/** @format */

(function() {
	'use strict';

	angular
		.module('emsApp', [
			'ngStorage',
			'tmh.dynamicLocale',
			'pascalprecht.translate',
			'ngResource',
			'ngCookies',
			'ngAria',
			'ngCacheBuster',
			'ngFileUpload',
			'angularFileUpload',
			'ui.bootstrap',
			'ui.bootstrap.datetimepicker',
			'ui.router',
			'infinite-scroll',
			// jhipster-needle-angularjs-add-module JHipster will add new module here
			'angular-loading-bar',
			'ngSanitize',
			'nzToggle',
			'ui.select',
			'LocalStorageModule',
			// Additional modules defined by custom/jhipster/app/additionalModules.ftl
			'dialogs.main',
		])
		.run(run);

	run.$inject = [
		'$rootScope',
		'$translate',
		'$window',
		'$location',
		'stateHandler',
		'translationHandler',
		'Auth',
		'HistoryService',
		'JhiLanguageService',
		'Principal',
		'$anchorScroll',
	];

	function run(
		$rootScope,
		$translate,
		$window,
		$location,
		stateHandler,
		translationHandler,
		Auth,
		HistoryService,
		JhiLanguageService,
		Principal,
		$anchorScroll
	) {
		stateHandler.initialize();
		translationHandler.initialize();

		/* Marco: Kijk naar de xx.initialize() hierboven. Je ziet dat jhipster allerlei code van de oude app.js
		 * ook weer naar losse bestanden heeft verplaatst. In die translationHandler zit nu ook bijv. de updateTitle.
		 * Ofwel, kijken of de rest ook ieder naar een los bestandje kan!
		 * */

		var debugEnabled = true;

		/* helper function to determine whether an object is defined AND not null */
		$rootScope.isDefinedAndNotNull = function(object) {
			return angular.isDefined(object) && object !== null;
		};

		$rootScope.$on('$stateChangeStart', function(event, toState, toStateParams) {
			$rootScope.toState = toState;
			$rootScope.toStateParams = toStateParams;

			if (Principal.isIdentityResolved()) {
				Auth.authorize();
			}

			// Use the cookie stored language, unless it is not available then use language from authorized account (if any)
			JhiLanguageService.getCurrent().then(function(lang) {
				if (!lang) {
					// if no language is available from cookie storage, check for an authorized account and use that lang
					Principal.identity().then(function(account) {
						if (account) {
							console.info('No stored language, use from authorized account', account.langKey);
							$translate.use(account.langKey);
						}
					});
				}
			});
		});

		// monitor all successful state changes
		$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
			var titleKey = 'global.title';

			$rootScope.previousState = fromState;
			$rootScope.previousStateName = fromState.name;
			$rootScope.previousStateParams = fromParams;

			// add the state to the history stack
			HistoryService.addHistory(toState, toParams);

			if (debugEnabled) {
				console.log('State change from', fromState.name, 'to', toState.name, 'with params:', toParams);
			}

			// Set the page title key to the one configured in state or use default one
			if (toState.data.pageTitle) {
				titleKey = toState.data.pageTitle;
			}

			$window.document.title = $translate.instant(titleKey);
		});

		$rootScope.back = function() {
			// pop the state to return to from the history stack
			HistoryService.back();
		};

		$rootScope.pageSizeList = [20, 50, 100, 200, 500];

		// function to show booleans
		$rootScope.getActiveClassForBoolean = function(isActive) {
			return isActive ? 'label label-success' : 'label label-danger';
		};

		// ModelOptions for autocomplete
		$rootScope.modelOptions = {
			debounce: {
				default: 500,
				blur: 250,
			},
			getterSetter: true,
		};

		$rootScope.displayFields = function(fieldArray) {
			var result = '';

			for (var t = 0; t < fieldArray.length; t++) {
				var value = fieldArray[t];
				if (value !== undefined && value !== null) {
					if (result != '') {
						result += ', ';
					}
					result += value;
				}
			}
			return result;
		};

		// Helper function. Used at , for instance, the Dates at tab search
		$rootScope.convertDateWithoutZone = function(modelDate) {
			var year = modelDate.getFullYear();

			var month = modelDate.getMonth() + 1;
			month = month < 10 ? '0' + month : month;

			var day = modelDate.getDate();
			day = day < 10 ? '0' + day : day;

			// this is a java 8 DateTimeFormatter.ISO_LOCAL_DATE) e.g. 2017-05-21
			var date = year + '-' + month + '-' + day;

			return date;
		};

		// Helper function. Gets the propery from each list item, using _.map
		$rootScope.getListValues = function(list, property) {
			if (this.isDefinedAndNotNull(list)) {
				return _.map(list, property);
			} else {
				return undefined;
			}
		};

		// authorization helper
		$rootScope.userHasAnyAuthority = function(authorities) {
			return Principal.hasAnyAuthority(authorities);
		};

		// scroll to top helper
		$anchorScroll.yOffset = 90; // scrollto always adds 90 pixels to ensure the scrollTo element is not behind the navigation
		$rootScope.scrollTo = function(elementId) {
			$location.hash(elementId);
			$anchorScroll();
		};
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('User', User);

	User.$inject = ['$resource'];

	function User($resource) {
		var service = $resource(
			'api/users/:login',
			{},
			{
				query: { method: 'GET', isArray: true },
				get: {
					method: 'GET',
					transformResponse: function(data) {
						data = angular.fromJson(data);
						return data;
					},
				},
				save: { method: 'POST' },
				update: { method: 'PUT' },
				delete: { method: 'DELETE' },
			}
		);

		return service;
	}
})();

/** @format */

(function() {
	'use strict';

	// -----------------------------------------------------------------------------------------------------------------

	angular.module('emsApp').directive('mfdTaskProgress', TaskProgressDirective);

	function TaskProgressDirective() {
		return {
			restrict: 'E',
			templateUrl: 'app/services/mfd-task-progress-service.html',
			// terminal : true,
			// priority : 1000,
			controller: TaskProgressDirectiveController,
			scope: {
				taskName: '=',
				title: '=',
				customClass: '=',
			},
		};
	}

	TaskProgressDirectiveController.$inject = ['$scope', '$interval', 'TaskProgressService'];

	function TaskProgressDirectiveController($scope, $interval, TaskProgressService) {
		var taskPollRunning,
			interval = 500;

		$scope.taskProgressDto;
		$scope.type = '';

		$scope.$on('task-progress-registered', function() {
			$scope.startInterval();
		});

		$scope.startInterval = function() {
			if (angular.isDefined(taskPollRunning)) return;

			$scope.type = 'info';

			taskPollRunning = $interval(function() {
				TaskProgressService.pollTask($scope.taskName).then(function(result) {
					$scope.taskProgressDto = result;

					if (!angular.isDefined($scope.taskProgressDto)) {
						console.error('Failed to retrieve the task with name ' + $scope.taskName + ' to poll', $scope.taskProgressDto);
						stopInterval();
						return;
					}

					if ($scope.taskProgressDto.taskProgressStatus !== 'IN_PROGRESS') {
						switch ($scope.taskProgressDto.taskProgressStatus) {
							case 'SUCCESS':
								$scope.type = 'success';
								break;
							case 'ERROR':
								$scope.type = 'danger';
								break;
							default:
						}

						stopInterval();
						return;
					}
				});
			}, interval);
		};

		function stopInterval() {
			if (angular.isDefined(taskPollRunning)) {
				$interval.cancel(taskPollRunning);
				taskPollRunning = undefined;
			}
		}
	}

	// -----------------------------------------------------------------------------------------------------------------

	angular.module('emsApp').factory('TaskProgressService', TaskProgressService);

	TaskProgressService.$inject = ['localStorageService', '$resource', '$q'];

	/**
	 *
	 * NOTE tasks are persisted in localStorage by their name, however the dto stored with it contains the unique ID
	 * NOTE tasks are retrieved from backend by their ID, which is unique
	 * NOTE the localStorageService is set to sessionStorage
	 *
	 * @returns {{registerTask: registerTask, pollTask: pollTask}}
	 * @constructor
	 */
	function TaskProgressService(localStorageService, $resource, $q) {
		var taskNameKeyPrefix = 'taskProgressName-';

		/**
		 *
		 */
		function registerTask(taskName, scope) {
			return $resource('/api/progress/register')
				.get()
				.$promise.then(function(result) {
					// result is an instance of TaskProgressDto
					var dto = result;

					// add to the local storage
					updateTaskToStorage(taskName, dto);

					scope.$broadcast('task-progress-registered', taskName);

					// return the dto
					return dto;
				});
		}

		/**
		 *
		 */
		function pollTask(taskName) {
			var currentTaskDto = getTaskFromStorage(taskName);

			return $resource('/api/progress/poll/:taskId', {
				taskId: currentTaskDto.taskId,
			})
				.get()
				.$promise.then(function(result) {
					// result is an instance of TaskProgressDto
					var newTaskDto = result;

					// handle the task status
					switch (newTaskDto.taskProgressStatus) {
						case 'IN_PROGRESS':
							// update the local storage
							updateTaskToStorage(taskName, newTaskDto);
							break;
						case 'SUCCESS':
							// as we're finished, we will remove the task from the storage
							removeTaskFromStorage(taskName);
							break;
						case 'ERROR':
							// handle error and remove task from storage
							handleTaskError(newTaskDto);
							removeTaskFromStorage(taskName);
							break;
						default:
					}

					// return the dto
					return newTaskDto;
				});
		}

		function updateTaskToStorage(name, dto) {
			var taskNameKey = taskNameKeyPrefix + name;

			// remove the task from the storage (no harm if it does not yet exist)
			localStorageService.remove(taskNameKey);

			// update the task by (re) adding it to the local storage
			localStorageService.set(taskNameKey, dto);
		}

		function getTaskFromStorage(name) {
			var taskNameKey = taskNameKeyPrefix + name;

			// retrieve the task from the local storage
			return localStorageService.get(taskNameKey);
		}

		function removeTaskFromStorage(name) {
			var taskNameKey = taskNameKeyPrefix + name;

			// remove the task from the storage (no harm if it does not yet exist)
			localStorageService.remove(taskNameKey);
		}

		function handleTaskError(dto) {
			console.error('Task with id ' + dto.taskId + ' resulted in an error');
		}

		// the public API of this service
		return {
			registerTask: registerTask,
			pollTask: pollTask,
		};
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('ProfileService', ProfileService);

	ProfileService.$inject = ['$http'];

	function ProfileService($http) {
		var dataPromise;

		var service = {
			getProfileInfo: getProfileInfo,
		};

		return service;

		function getProfileInfo() {
			if (angular.isUndefined(dataPromise)) {
				dataPromise = $http.get('management/info').then(function(result) {
					if (result.data.activeProfiles) {
						var response = {};
						response.activeProfiles = result.data.activeProfiles;
						response.ribbonEnv = result.data.ribbonEnv;
						response.inProduction = result.data.activeProfiles.indexOf('prod') !== -1;
						response.swaggerEnabled = result.data.activeProfiles.indexOf('swagger') !== -1;
						return response;
					}
				});
			}
			return dataPromise;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('pageRibbon', pageRibbon);

	pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

	function pageRibbon(ProfileService, $rootScope, $translate) {
		var directive = {
			replace: true,
			restrict: 'AE',
			template: '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			ProfileService.getProfileInfo().then(function(response) {
				// [dmitro] adding condition as sometimes response is undefined
				if (response && response.ribbonEnv) {
					scope.ribbonEnv = response.ribbonEnv;
					element.addClass(response.ribbonEnv);
					element.removeClass('hidden');
				}
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('Register', Register);

	Register.$inject = ['$resource'];

	function Register($resource) {
		return $resource('api/register', {}, {});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('Principal', Principal);

	Principal.$inject = ['$q', 'Account'];

	function Principal($q, Account) {
		var _identity,
			_authenticated = false;

		var service = {
			authenticate: authenticate,
			hasAnyAuthority: hasAnyAuthority,
			hasAuthority: hasAuthority,
			identity: identity,
			isAuthenticated: isAuthenticated,
			isIdentityResolved: isIdentityResolved,
		};

		return service;

		function authenticate(identity) {
			_identity = identity;
			_authenticated = identity !== null;
		}

		function hasAnyAuthority(authorities) {
			if (!_authenticated || !_identity || !_identity.authorities) {
				return false;
			}

			for (var i = 0; i < authorities.length; i++) {
				if (_identity.authorities.indexOf(authorities[i]) !== -1) {
					return true;
				}
			}

			return false;
		}

		function hasAuthority(authority) {
			if (!_authenticated) {
				return $q.when(false);
			}

			return this.identity().then(
				function(_id) {
					return _id.authorities && _id.authorities.indexOf(authority) !== -1;
				},
				function() {
					return false;
				}
			);
		}

		function identity(force) {
			var deferred = $q.defer();

			if (force === true) {
				_identity = undefined;
			}

			// check and see if we have retrieved the identity data from the server.
			// if we have, reuse it by immediately resolving
			if (angular.isDefined(_identity)) {
				deferred.resolve(_identity);

				return deferred.promise;
			}

			// retrieve the identity data from the server, update the identity object, and then resolve.
			Account.get()
				.$promise.then(getAccountThen)
				.catch(getAccountCatch);

			return deferred.promise;

			function getAccountThen(account) {
				_identity = account.data;
				_authenticated = true;
				deferred.resolve(_identity);
			}

			function getAccountCatch() {
				_identity = null;
				_authenticated = false;
				deferred.resolve(_identity);
			}
		}

		function isAuthenticated() {
			return _authenticated;
		}

		function isIdentityResolved() {
			return angular.isDefined(_identity);
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('PasswordResetInit', PasswordResetInit);

	PasswordResetInit.$inject = ['$resource'];

	function PasswordResetInit($resource) {
		var service = $resource('api/account/reset-password/init', {}, {});

		return service;
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('PasswordResetFinish', PasswordResetFinish);

	PasswordResetFinish.$inject = ['$resource'];

	function PasswordResetFinish($resource) {
		var service = $resource('api/account/reset-password/finish', {}, {});

		return service;
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('Password', Password);

	Password.$inject = ['$resource'];

	function Password($resource) {
		var service = $resource('api/account/change-password', {}, {});

		return service;
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('hasAuthority', hasAuthority);

	hasAuthority.$inject = ['Principal'];

	function hasAuthority(Principal) {
		var directive = {
			restrict: 'A',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			var authority = attrs.hasAuthority.replace(/\s+/g, '');

			var setVisible = function() {
					element.removeClass('hidden');
				},
				setHidden = function() {
					element.addClass('hidden');
				},
				defineVisibility = function(reset) {
					if (reset) {
						setVisible();
					}

					Principal.hasAuthority(authority).then(function(result) {
						if (result) {
							setVisible();
						} else {
							setHidden();
						}
					});
				};

			if (authority.length > 0) {
				defineVisibility(true);

				scope.$watch(
					function() {
						return Principal.isAuthenticated();
					},
					function() {
						defineVisibility(true);
					}
				);
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('hasAnyAuthority', hasAnyAuthority);

	hasAnyAuthority.$inject = ['Principal'];

	function hasAnyAuthority(Principal) {
		var directive = {
			restrict: 'A',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

			var setVisible = function() {
					element.removeClass('hidden');
				},
				setHidden = function() {
					element.addClass('hidden');
				},
				defineVisibility = function(reset) {
					var result;
					if (reset) {
						setVisible();
					}

					result = Principal.hasAnyAuthority(authorities);
					if (result) {
						setVisible();
					} else {
						setHidden();
					}
				};

			if (authorities.length > 0) {
				defineVisibility(true);

				scope.$watch(
					function() {
						return Principal.isAuthenticated();
					},
					function() {
						defineVisibility(true);
					}
				);
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('Auth', Auth);

	Auth.$inject = [
		'$rootScope',
		'$state',
		'$sessionStorage',
		'$q',
		'$translate',
		'Principal',
		'AuthServerProvider',
		'Account',
		'LoginService',
		'Register',
		'Activate',
		'Password',
		'PasswordResetInit',
		'PasswordResetFinish',
	];

	function Auth(
		$rootScope,
		$state,
		$sessionStorage,
		$q,
		$translate,
		Principal,
		AuthServerProvider,
		Account,
		LoginService,
		Register,
		Activate,
		Password,
		PasswordResetInit,
		PasswordResetFinish
	) {
		var service = {
			activateAccount: activateAccount,
			authorize: authorize,
			changePassword: changePassword,
			createAccount: createAccount,
			getPreviousState: getPreviousState,
			login: login,
			logout: logout,
			resetPasswordFinish: resetPasswordFinish,
			resetPasswordInit: resetPasswordInit,
			resetPreviousState: resetPreviousState,
			storePreviousState: storePreviousState,
			updateAccount: updateAccount,
		};

		return service;

		function activateAccount(key, callback) {
			var cb = callback || angular.noop;

			return Activate.get(
				key,
				function(response) {
					return cb(response);
				},
				function(err) {
					return cb(err);
				}.bind(this)
			).$promise;
		}

		function authorize(force) {
			var authReturn = Principal.identity(force).then(authThen);

			return authReturn;

			function authThen() {
				var isAuthenticated = Principal.isAuthenticated();

				// an authenticated user can't access to login and register pages
				if (
					isAuthenticated &&
					$rootScope.toState.parent === 'account' &&
					($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')
				) {
					$state.go('home');
				}

				// recover and clear previousState after external login redirect (e.g. oauth2)
				if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
					var previousState = getPreviousState();
					resetPreviousState();
					$state.go(previousState.name, previousState.params);
				}

				if (
					$rootScope.toState.data.authorities &&
					$rootScope.toState.data.authorities.length > 0 &&
					!Principal.hasAnyAuthority($rootScope.toState.data.authorities)
				) {
					if (isAuthenticated) {
						// user is signed in but not authorized for desired state
						$state.go('accessdenied');
					} else {
						// user is not authenticated. stow the state they wanted before you
						// send them to the login service, so you can return them when you're done
						storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

						// now, send them to the signin state so they can log in
						$state.go('accessdenied').then(function() {
							LoginService.open();
						});
					}
				}
			}
		}

		function changePassword(newPassword, callback) {
			var cb = callback || angular.noop;

			return Password.save(
				newPassword,
				function() {
					return cb();
				},
				function(err) {
					return cb(err);
				}
			).$promise;
		}

		function createAccount(account, callback) {
			var cb = callback || angular.noop;

			return Register.save(
				account,
				function() {
					return cb(account);
				},
				function(err) {
					this.logout();
					return cb(err);
				}.bind(this)
			).$promise;
		}

		function login(credentials, callback) {
			var cb = callback || angular.noop;
			var deferred = $q.defer();

			AuthServerProvider.login(credentials)
				.then(loginThen)
				.catch(
					function(err) {
						this.logout();
						deferred.reject(err);
						return cb(err);
					}.bind(this)
				);

			function loginThen(data) {
				Principal.identity(true).then(function(account) {
					// After the login the language will be changed to
					// the language selected by the user during his registration
					if (account !== null) {
						$translate.use(account.langKey).then(function() {
							$translate.refresh();
						});
					}
					deferred.resolve(data);
				});
				return cb();
			}

			return deferred.promise;
		}

		function logout() {
			AuthServerProvider.logout();
			Principal.authenticate(null);
		}

		function resetPasswordFinish(keyAndPassword, callback) {
			var cb = callback || angular.noop;

			return PasswordResetFinish.save(
				keyAndPassword,
				function() {
					return cb();
				},
				function(err) {
					return cb(err);
				}
			).$promise;
		}

		function resetPasswordInit(mail, callback) {
			var cb = callback || angular.noop;

			return PasswordResetInit.save(
				mail,
				function() {
					return cb();
				},
				function(err) {
					return cb(err);
				}
			).$promise;
		}

		function updateAccount(account, callback) {
			var cb = callback || angular.noop;

			return Account.save(
				account,
				function() {
					return cb(account);
				},
				function(err) {
					return cb(err);
				}.bind(this)
			).$promise;
		}

		function getPreviousState() {
			var previousState = $sessionStorage.previousState;
			return previousState;
		}

		function resetPreviousState() {
			delete $sessionStorage.previousState;
		}

		function storePreviousState(previousStateName, previousStateParams) {
			var previousState = { name: previousStateName, params: previousStateParams };
			$sessionStorage.previousState = previousState;
		}
	}
})();

(function() {
	'use strict';

	angular.module('emsApp').factory('AuthServerProvider', AuthServerProvider);

	AuthServerProvider.$inject = [ '$http', '$localStorage', '$sessionStorage', '$q' ];

	function AuthServerProvider($http, $localStorage, $sessionStorage, $q) {
		var service = {
			getToken : getToken,
			login : login,
			loginWithToken : loginWithToken,
			storeAuthenticationToken : storeAuthenticationToken,
			logout : logout
		};

		return service;

		function getToken() {

			return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
		}

		function login(credentials) {

			var data = {
				username : credentials.username,
				password : credentials.password,
				rememberMe : credentials.rememberMe
			};
			return $http.post('api/authenticate', data).success(authenticateSuccess);

			function authenticateSuccess(data, status, headers) {
				var bearerToken = headers('Authorization');
				if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
					var jwt = bearerToken.slice(7, bearerToken.length);
					service.storeAuthenticationToken(jwt, credentials.rememberMe);
					return jwt;
				}
			}
		}

		function loginWithToken(jwt, rememberMe) {
			var deferred = $q.defer();

			if (angular.isDefined(jwt)) {
				this.storeAuthenticationToken(jwt, rememberMe);
				deferred.resolve(jwt);
			} else {
				deferred.reject();
			}

			return deferred.promise;
		}

		function storeAuthenticationToken(jwt, rememberMe) {
			if (rememberMe) {
				$localStorage.authenticationToken = jwt;
			} else {
				$sessionStorage.authenticationToken = jwt;
			}
		}

		function logout() {

			delete $localStorage.authenticationToken;
			delete $sessionStorage.authenticationToken;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('Activate', Activate);

	Activate.$inject = ['$resource'];

	function Activate($resource) {
		var service = $resource(
			'api/activate',
			{},
			{
				get: { method: 'GET', params: {}, isArray: false },
			}
		);

		return service;
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('Account', Account);

	Account.$inject = ['$resource'];

	function Account($resource) {
		var service = $resource(
			'api/account',
			{},
			{
				get: {
					method: 'GET',
					params: {},
					isArray: false,
					interceptor: {
						response: function(response) {
							// expose response
							return response;
						},
					},
				},
			}
		);

		return service;
	}
})();

'use strict';

angular.module('emsApp').directive("mfdEventRelationStatus", function() {
	return {
		restrict : 'E',
		replace : true,
		templateUrl : 'app/sales/relation-sales-status.html',
		controller : 'EventRelationStatusController',
		scope : {
			relation : "=", // the relation
			event : "=", // the event
			eventContacts : "=",// the list of eventRelationContacts (if available, can be null)
			salesStatus : "=", // the array of possible sales statusses
			statusCellStyle : "=" // style to apply to the status cell
		}
	};
});

'use strict';

angular.module('emsApp').controller("ModalStatusController", [
    "$scope", "$rootScope", "$state", "$uibModal", "$uibModalInstance", "$translate", "AlertService", "RelationSalesFactory",
    "AutocompleteRelationsByQueryParamsFactory", "AutocompleteCarsByQueryParamsFactory", "NoPagingTemplateEventFactory", "SubscriptionFindArticleFilteredByInsuranceFactory",
    function ($scope, $rootScope, $state, $uibModal, $uibModalInstance, $translate, AlertService, RelationSalesFactory,
              AutocompleteRelationsByQueryParamsFactory, AutocompleteCarsByQueryParamsFactory, NoPagingTemplateEventFactory, SubscriptionFindArticleFilteredByInsuranceFactory) {
        if ($rootScope.isDefinedAndNotNull($scope.subscriptionId)) {
            $scope.subtitle = $translate.instant("relation-sales.modal.subtitle-ok");
        } else {
            $scope.subtitle = $translate.instant("relation-sales.modal.subtitle-empty");
        }

        $scope.trainingTypeList = NoPagingTemplateEventFactory.query();
        $scope.insuranceList = SubscriptionFindArticleFilteredByInsuranceFactory.query();
        $scope.showSubscriptionDetails = false;
        $scope.subscriptionDetails = {};
        $scope.newSalesStatus = {};

        // Returns true if SalesStatus is eligible for subscription details
        var statusRequiresSubscriptionDetails = function(salesStatus) {
            return /^(PRESENT|WAIT_FOR_ANSWER_HOT)$/.test(salesStatus.value);
        };

        // add 'ok' checkmark to button of current status
        $scope.activeButtonClass = function(status) {
            if ($scope.currentStatus === status) {
                return "glyphicon glyphicon-ok";
            }
        };

        /**
         * Submits the new salesstatus. Results in showing subscription details, updating the salesstatus
         * on the event relation contact, or just closing the modal.
         */
        $scope.submitStatus = function(newSalesStatus) {
            if (statusRequiresSubscriptionDetails(newSalesStatus) && !statusRequiresSubscriptionDetails($scope.currentStatus)) {
                // either PRESENT or WAIT_FOR_ANSWER_HOT was chosen, an event relation status will be created during creation of booking
                $state.go('event.detail.booking', {
                    eventId: $scope.$parent.event.id,
                    bookingId: $scope.$parent.bookingId, // could be present, optional
                    driverId: $scope.$parent.subscriptionId,
                    relationId: $scope.$parent.relationId,
                    predefinedSubscriptionStatus: (newSalesStatus.value==="PRESENT") ? "CONFIRMED": "RESERVED"
                }, {reload: true});
            } else if ($scope.currentStatus !== newSalesStatus) {
                // just update status as no booking and subscription are required
                $scope.updateStatus($scope.currentStatus, newSalesStatus);
                $uibModalInstance.dismiss('status changed without subscription');
            } else {
                $uibModalInstance.dismiss('no status change');
            }
        };

        /**
         * Updates the status by creating or updating the EventRelationContact.
         * The payload dto may contain subscription details.
         * @param oldSalesStatus The existing sales status formatted as (e.g.) ASK
         * @param newSalesStatus The chosen sales status formatted as (e.g.) PRESENT
         */
        $scope.updateStatus = function (oldSalesStatus, newSalesStatus) {
            var dto = {};
            if ($scope.showSubscriptionDetails) {
                dto = {
                    secondDriverId: ($scope.subscriptionDetails.secondDriver || {}).id,
                    spectatorId: ($scope.subscriptionDetails.spectator || {}).id,
                    carId: ($scope.subscriptionDetails.car || {}).id,
                    insuranceId: ($scope.subscriptionDetails.insurance || {}).id,
                    trainingTypeId: ($scope.subscriptionDetails.trainingType || {}).id,
                    instructionHours: $scope.subscriptionDetails.instructionHours
                }
            }

            dto.driverEventRelationContact = {
                event: {id: $scope.event.id},
                relation: {id: $scope.relation.id},
                salesStatus: newSalesStatus.value
            };

            if ($rootScope.isDefinedAndNotNull(dto.secondDriverId)) {
                dto.secondDriverEventRelationContact = {
                    event: {id: $scope.event.id},
                    relation: {id: dto.secondDriverId},
                    salesStatus: newSalesStatus.value
                };
            }

            RelationSalesFactory.create(dto).$promise.then(function (result) {
                processSalesStatusResult(result, oldSalesStatus);
            }).catch(function (error) {
                AlertService.error("Creating or updating sales status failed", error);
            });

            $uibModalInstance.dismiss('save');
        };

        /**
         * Do things with result:
         *  - show message
         *  - update the stats of the affected event
         */
        var processSalesStatusResult = function (result, oldSalesStatus) {
            // update the sales status for this driver
            if (!$rootScope.isDefinedAndNotNull(oldSalesStatus.value)) {
                oldSalesStatus = "SalesStatus.ASK";
            }
            updateSalesStatus(result['driver'], oldSalesStatus);

            // emit the event relation contact for the second driver if the second driver exists
            if (result['secondDriver']) {
                $rootScope.$emit("updateSecondDriverSalesStatus", result['secondDriver']);
            }

            // update the event stats as subscriptions have been updated
            $rootScope.$emit("updateEventStats", result['driver']['eventPkId']);
        };

        /**
         * Returns only the name of the relationDisplayValue in the UserEventRelationContactListItemDto (defined by display.format in the model).
         * e.g. "(6546) Eric Cartman, Hallway Authorities"
         * becomes "Eric Cartman"
         */
        function formatRelationDisplayValue(dtoRelationDisplayValue) {
            return dtoRelationDisplayValue.split(/[),]\s*/)[1];
        }

        /**
         * Update the data on the page on update from UI
         * @param result EventRelationContact
         * @param oldSalesStatus Old SalesStatus to be used to inform the user
         */
        var updateSalesStatus = function (result, oldSalesStatus) {
            console.log('Updating sales status to ' + result.salesStatusDisplayValue + ' for ' + result.relationDisplayValue + ' on ' + result.eventDisplayValue);

            // loop over all available event relation contacts to see if there is a connection between the current event and relation
            angular.forEach($scope.eventContacts, function (value, key) {
                if (value['eventPkId'] === $scope.event.id) {
                    // if for this relation there is an entry in the array for this event, remove it as we will add the new UserEventRelationContactListItemDto
                    $scope.eventContacts.splice(key, 1);
                }
            });

            // add the new UserEventRelationContactListItemDto
            $scope.eventContacts.push(result);

            // render the new status
            $scope.renderStatus($scope.eventContacts, result.eventPkId);

            // inform the user on the new sales status of the driver
            var oldSalesStatusDisplayValue = oldSalesStatus.displayValue;
            var newSalesStatusDisplayValue = $scope.salesStatus[result['salesStatusDisplayValue']].displayValue;
            var relationDisplayValue = formatRelationDisplayValue(result['relationDisplayValue']);
            var msg = "Sales status updated from " + oldSalesStatusDisplayValue + " into " + newSalesStatusDisplayValue + " for " + relationDisplayValue + " on " + result['eventDisplayValue'];
            AlertService.success(msg);
        };

        $scope.autocompleteRelations = function(val) {
            var params = {
                'relationTypeAheadSearchString': val
            };

            return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
                return results;
            });
        };
        $scope.autocompleteCars = function(val) {
            var params = {
                'carTypeAheadSearchString': val
            };

            return AutocompleteCarsByQueryParamsFactory.query(params).$promise.then(function(results) {
                return results;
            });
        };
        // called from cancel button in dialog
        $scope.clear = function() {
            // dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
            $uibModalInstance.dismiss('cancel');
        };
    }]).controller('EventRelationStatusController',
    function ($scope, $rootScope, $translate, $uibModal, $document, _, AlertService, RelationSalesFactory, SalesRelationSubscriptionFactory) {

        // initial and default sales status value
        $scope.statusStyle = $scope.salesStatus["SalesStatus.ASK"]["style"];
        $scope.subscriptionId = null;
        $scope.bookingId = null;
        $scope.modalTitle = "";
        $scope.test = '';

        /**
         * Search all event contacts for the event, and if there is a match, show the sales status found
         * @param eventContacts
         * @param eventId
         * @returns {String} the sales status
         */
        $scope.renderStatus = function (eventContacts, eventId) {
            // initial / default status which is used in case no EventRelationContact is available
            var status = "SalesStatus.ASK";

            // loop over all available event relation contacts to see if there is a connection between the current event and relation
            angular.forEach(eventContacts, function (value, key) {
                if (value.eventPkId === eventId) {
                    status = value.salesStatusDisplayValue;
                }
            });

            $scope.currentStatus = $scope.salesStatus[status];
            $scope.statusCellStyle = _.merge($scope.statusCellStyle, $scope.salesStatus[status]["style"]);
            return $translate.instant(status);
        };

        /**
         * Listener to update formula for specific event
         */
        $rootScope.$on("updateSecondDriverSalesStatus", function($event, erc) { // NOTE: '$event' is a javascript event, NOT an EMS Event entity
            if ($rootScope.isDefinedAndNotNull(erc) && $scope.relation.id === erc.relationPkId && $scope.event.id === erc.eventPkId) {
                // stop event propagation once relevant sales status tile is found
                $event.stopPropagation();

                // slice the event contacts and push new event relation contact
                // loop over all available event relation contacts to see if there is a connection between the current event and relation
                angular.forEach($scope.eventContacts, function (value, key) {
                    if (value['eventPkId'] === $scope.event.id) {
                        // if for this relation there is an entry in the array for this event, remove it as we will add the new UserEventRelationContactListItemDto
                        $scope.eventContacts.splice(key, 1);
                    }
                });

                // add the new UserEventRelationContactListItemDto so that the status is updated automatically
                $scope.eventContacts.push(erc);
            }
        });

        $scope.openModal = function (size, parentSelector) {
            var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;

            SalesRelationSubscriptionFactory.get({
                relationId: $scope.relation.id,
                eventId: $scope.event.id
            }).$promise.then(function (result) {
                $scope.subscriptionId = result.subscriptionId; // can be null
                $scope.bookingId = result.bookingId; // can be null
                $scope.personName = result.personName;
                $scope.eventName = result.eventName;
                $scope.relationId = $scope.relation.id;

                $scope.modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'statusUpdateModal.html',
                    controller: 'ModalStatusController',
                    // controller: 'EventRelationStatusController',
                    scope: $scope,
                    resolve: {
                        subscriptionId: function () {
                            return $scope.subscriptionId;
                        },
                        bookingId: function () {
                            return $scope.bookingId;
                        },
                        relationId: function() {
                            return $scope.relation.id;
                        }
                    },
                    // size: size,
                    appendTo: parentElem
                });
            });
        };
    });

'use strict';

angular.module('emsApp').config(function($stateProvider) {

	/**
	 * Add all translations for the sales dashboard
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('relation-sales'); // main translation loaded for article
		$translatePartialLoader.addPart('relation');
		$translatePartialLoader.addPart('event');
		$translatePartialLoader.addPart('salesfilter');
		$translatePartialLoader.addPart('salesstatus');
		$translatePartialLoader.addPart('subscription');
		return $translate.refresh();
	};

	$stateProvider.state('sales', {
		/* abstract state for entity sales, which is not an existing entity */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract : true,
		parent : 'entity',
		url : '/sales',
		data : {
			authorities : [ 'ROLE_USER' ],
			pageTitle : 'Sales',
			isModal : false
		},
		resolve : {
			translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
				return getTranslations($translate, $translatePartialLoader);
			} ]
		}
	});

	// TODO we could reroute the events dashboard through this state, if we want to
	// $stateProvider.state('sales.dashboard', {
	//     /* list state for entity event */
	//     /* to access: ui-ref="sales.dashboard" */
	//     /* url: hostname/sales/dashboard */
	//     url: '/dashboard',
	//     views: {
	//         'content@': {
	//             templateUrl: '/app/sales/events-dashboard.html',
	//             controller: 'EventDashboardController'
	//         }
	//     }
	// });

	$stateProvider.state('sales.relation', {
		/* detail state for entity SalesDTO */
		/* to access: ui-sref="sales.relation" */
		/* url: hostname/sales/relation */
		url : '/relation',
		views : {
			'content@' : {
				templateUrl : 'app/sales/relation-sales.html',
				controller : 'RelationSalesController'
			}
		}
	});

});

'use strict';

angular.module('emsApp').controller('RelationSalesController',
    function ($scope, $rootScope, $q, $timeout, $interval, $translate, $window, $filter, _, AlertService, RelationSalesFactory, UserSalesFilterNewDtoFactory, UserSalesFilterEditDtoFactory,
              RelationFindUserFilteredByAccountManagerFactory, UserSalesFilterListDtoSearchFactory, SalesSyncFactory, EventFactory, EventSalesFactory) {
    $scope.pageLoadTime = "Loading data ...";
    $scope.dto = undefined;
    $scope.salesFilter = {};
    $scope.submitButtonIsActive = true;
    $scope.showSearchForm = false;
    $scope.pageSizeList = [20, 50, 100, 200, 500];
    $scope.salesStatusList = {};
    $scope.salesStatusList.selected = [];
    $scope.showRelationDetails = $window.localStorage.getItem('showRelationDetails')==="true"; // compare with "true" because the localStorage.getItem returns a string
    setStatusCellPadding();
    $scope.reloadEventStatsInterval = 300; // 5 minutes

    /**
     * sets the style of the statuscells to collapse
     */
    $scope.toggleRelationDetails = function() {
        $scope.showRelationDetails = !$scope.showRelationDetails;
        $window.localStorage.setItem('showRelationDetails', $scope.showRelationDetails);
        setStatusCellPadding();
    }
    function setStatusCellPadding() {
        var padding = $scope.showRelationDetails ? '15px' : '0px';
        $scope.statusCellStyle = {padding: padding};
    }

    $scope.toggleSearchForm = function() {
        $scope.showSearchForm = !$scope.showSearchForm;
    };

    var convertDateWithoutZone = function(inputDate) {
        if ($rootScope.isDefinedAndNotNull(inputDate)) {
            return $rootScope.convertDateWithoutZone(inputDate);
        } else {
            return undefined;
        }
    };

    // timer to record grid loading time
    $scope.search = function() {
        $("#search-header-button").addClass("glyphicon-refresh-animate");

        if (!$rootScope.isDefinedAndNotNull($scope.salesFilter)) {
            $scope.salesFilter = {};
        }

        // add the selected sales statuses to the rootscope object
        $scope.salesFilter.salesStatusList = {};
        $scope.salesFilter.salesStatusList.selected = $scope.salesStatusList.selected;
        $rootScope.RelationSalesFilterSearchOverview = angular.copy($scope.salesFilter);

        $scope.timerStart = Date.now();
        $scope.pageLoadTime = "Loading data ...";

        // prevent null pointers by checking the selected user prior to getting it's ID
        var selectedUserId = ($rootScope.isDefinedAndNotNull($scope.salesFilter) && $rootScope.isDefinedAndNotNull($scope.salesFilter.selectedUser)) ? $scope.salesFilter.selectedUser.id : null;

        RelationSalesFactory.query({
            accountManagerId: selectedUserId,
            firstName: $scope.salesFilter.firstName,
            lastName: $scope.salesFilter.lastName,
            personName: $scope.salesFilter.personName,
            potentialFrom: $scope.salesFilter.potentialFrom,
            potentialTo: $scope.salesFilter.potentialTo,
            startDateFrom: convertDateWithoutZone($scope.salesFilter.startDateFrom),
            startDateTo: convertDateWithoutZone($scope.salesFilter.startDateTo),
            templateEventIdList: $rootScope.getListValues($scope.salesFilter.selectedTemplateEventList, 'id'),
            salesStatus: $rootScope.getListValues($scope.salesStatusList.selected, 'value'),
            page: $scope.salesFilter.pagingPage - 1,
            size: $scope.salesFilter.pagingSize,
            sort: ['sortOrder,asc']
        }).$promise.then(function(data) {
            // TODO add headers as function argument so we can paginate the relations
            // $scope.totalItems = headers('X-Total-Count');
            $scope.dto = data;
            $("#search-header-button").removeClass("glyphicon-refresh-animate");
        });
    };

    /**
     * Creates a date from the json datestring
     * @param jsonDate datestring (yyyy-MM-dd)
     * @returns {Date}
     */
    $scope.createDateFromJson = function(jsonDate) {
        return new Date(jsonDate);
    };

    /**
     *
     */
    $scope.convertOffsetStartDates2StartDates = function() {
        if ($rootScope.isDefinedAndNotNull($scope.salesFilter.offsetStartDateFrom)) {
            $scope.salesFilter.startDateFrom = moment().add($scope.salesFilter.offsetStartDateFrom, 'days').toDate();
        }
        if ($rootScope.isDefinedAndNotNull($scope.salesFilter.offsetStartDateTo)) {
            $scope.salesFilter.startDateTo = moment().add($scope.salesFilter.offsetStartDateTo, 'days').toDate();
        }
    };

    /**
     *
     */
    $scope.convertStartDates2OffsetStartDates = function() {
        var today = moment();
        if ($rootScope.isDefinedAndNotNull($scope.salesFilter.startDateFrom)) {
            $scope.salesFilter.offsetStartDateFrom = moment($scope.salesFilter.startDateFrom).diff(today, 'days');
        }
        if ($rootScope.isDefinedAndNotNull($scope.salesFilter.startDateTo)) {
            $scope.salesFilter.offsetStartDateTo = moment($scope.salesFilter.startDateTo).diff(today, 'days');
        }
    };

    $scope.loadFilter = function() {
    		function doCopying() {
					$scope.salesFilter = angular.copy($rootScope.RelationSalesFilterSearchOverview);
					if ($rootScope.isDefinedAndNotNull($scope.salesFilter)) {
						$scope.salesStatusList.selected = $scope.salesFilter.salesStatusList.selected;
					}
				}

    		return new Promise(function (resolve, reject) {
					if (!$rootScope.isDefinedAndNotNull($rootScope.RelationSalesFilterSearchOverview)) {
						$scope.loadDefaultSearchParams().then(resolve, reject); // load defaults
						doCopying();
					} else {
						doCopying();
						resolve();
					}
				});
    };

    $scope.loadDefaultSearchParams = function() {
        return UserSalesFilterNewDtoFactory.get().$promise.then(function(data) {
            $scope.salesFilter = data;
            $scope.convertOffsetStartDates2StartDates();
            _.merge($scope.salesFilter, $rootScope.RelationSalesFilterSearchOverview);
            $scope.originalRelationSalesFilterSearchOverview = angular.copy($scope.salesFilter);
        });
    };

    $scope.isRelationSalesFilterSearchOverviewDirty = function () {
        // TODO marco: uitbreiden met originalSalesFilter OR savedSalesFilter
        return !angular.equals($scope.salesFilter, $scope.originalRelationSalesFilterSearchOverview);
    };

    $scope.reset = function() {
        $scope.loadDefaultSearchParams().then(function () {
					$scope.search();
				});
        if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
            // we check the availability of search form as it is still used in search forms that are not inlined in the table
            $scope.searchForm.$setPristine();
        }
    };

    /**
     * Functionality for saving the SalesFilter form.
     */
    var onSalesFilterSaveFinishedCallback = function(result) {
        // After successful save, update the salesfilter dropdown.
        $("#save-button").removeClass("glyphicon-refresh-animate");
        $scope.salesFilterReferenceFilterList = $scope.querySalesFilters();
        $scope.selectedSalesFilter=result;
    };

    var saveSalesFilterOrUpdateErrorCallback = function(error) {
        $("#save-button").removeClass("glyphicon-refresh-animate");
    };

    $scope.saveSalesFilter = function() {
        $("#save-button").addClass("glyphicon-refresh-animate");
        $scope.convertStartDates2OffsetStartDates();
        UserSalesFilterEditDtoFactory.update($scope.salesFilter, onSalesFilterSaveFinishedCallback, saveSalesFilterOrUpdateErrorCallback);
    };

    /**
     * Get all Users of type AccountManagers. Result will be put in accountManagerReferenceFilterList.
     */
    $scope.queryAccountManager = function() {
        return RelationFindUserFilteredByAccountManagerFactory.query(function(result) {
            return result;
        });
    };
    $scope.accountManagerReferenceFilterList = $scope.queryAccountManager();

    /**
     * Get all SalesFilters so we can put it in the dropdown.
     * When the selection has changed, get the data for the salesfilter with id of $scope.selectedSalesFilter.id.
     */
    $scope.querySalesFilters = function() {
        return UserSalesFilterListDtoSearchFactory.query(function(result) {
            return result;
        });
    };
    $scope.salesFilterReferenceFilterList = $scope.querySalesFilters();

    $scope.salesFilterChanged = function() {
        if ($rootScope.isDefinedAndNotNull($scope.selectedSalesFilter)) {
            UserSalesFilterEditDtoFactory.get({id: $scope.selectedSalesFilter.id}).$promise.then(function (data) {
                $scope.salesFilter = data;
                $scope.convertOffsetStartDates2StartDates();
            });
        }
    };

    // To prevent updating the current selected, a change in the description will reset the id. Saving will now be a 'create new'
    $scope.descriptionChanged = function() {
        $scope.salesFilter.id = null;
    };

    /**
     * Synchronizes all {@link Subscription}s with {@link EventRelationContact}s.
     * This functionality is meant to run once, as it needs to sync the subscriptions for which there are no
     */
    $scope.syncSubscriptions = function() {
        $("#sync-button").addClass("glyphicon-refresh-animate");

        SalesSyncFactory.sync().$promise.then(function(result){
            AlertService.success("Sync events and relations was successful. There should be no more subscriptions without a corresponding sales status.");
            AlertService.info(result.message);
            $scope.search();
        }).catch(function(error){
            AlertService.error("Sync events and relations based on subscriptions failed.", error);
        }).finally(function(){
            $("#sync-button").removeClass("glyphicon-refresh-animate");
        });
    };

    /**
     * Listener to update formula for specific event
     */
    $rootScope.$on("updateEventStats", function($event, eventPkId) { // NOTE: '$event' is a javascript event, NOT an EMS Event entity
        EventFactory.get({
            id : eventPkId
        }).$promise.then(function (result) {
            var eventDto  = _.pick(result, ['id','totalReserved','totalConfirmed','target','availableSpots']); // mimic UserEventListItemDto
            updateEventFormula(eventDto);
        }).catch(function (error) {
            AlertService.error("Updating event statistics failed", error);
        });
        $event.stopPropagation();
    });

    /**
     * Update the event stats by merging in the dto values
     */
    var updateEventFormula = function(eventDto) {
        var eventToUpdate = _.find($scope.dto.events, function(o) { return o.id === eventDto.id; });
        _.merge(eventToUpdate, eventDto);
    };

    /**
     * Get all events based on filter and update the formula
     */
    var reloadEventData = function() {
        EventSalesFactory.query({
            startDateFrom: convertDateWithoutZone($scope.salesFilter.startDateFrom),
            startDateTo: convertDateWithoutZone($scope.salesFilter.startDateTo),
            templateEventIdList: $rootScope.getListValues($scope.salesFilter.selectedTemplateEventList, 'id')
        }).$promise.then(function(data) {
            _.each(data.events, function(eventDto){
                updateEventFormula(eventDto);
            });
        });
    }

    // map with sales status display values as populated from backend, see enum class SalesStatus
    $scope.salesStatus = {
        "SalesStatus.ASK": {
            "key" : "SalesStatus.ASK",
            "value" : "ASK",
            "displayValue": $translate.instant("SalesStatus.ASK"),
            "style": {"background-color": "#FDD835", "color": "black"}
        },
        "SalesStatus.WAIT_FOR_ANSWER_COLD": {
            "key" : "SalesStatus.WAIT_FOR_ANSWER_COLD",
            "value" : "WAIT_FOR_ANSWER_COLD",
            "displayValue": $translate.instant("SalesStatus.WAIT_FOR_ANSWER_COLD"),
            "style": {"background-color": "#03A9F4", "color": "black"}
        }, // light orange #FFB300
        "SalesStatus.WAIT_FOR_ANSWER_HOT": {
            "key" : "SalesStatus.WAIT_FOR_ANSWER_HOT",
            "value" : "WAIT_FOR_ANSWER_HOT",
            "displayValue": $translate.instant("SalesStatus.WAIT_FOR_ANSWER_HOT"),
            "style": {"background-color": "#FF8F00", "color": "black"}
        },
        "SalesStatus.PRESENT": {
            "key" : "SalesStatus.PRESENT",
            "value" : "PRESENT",
            "displayValue": $translate.instant("SalesStatus.PRESENT"),
            "style": {"background-color": "#7CB342", "color": "black"}
        },
        "SalesStatus.NOT_PRESENT": {
            "key" : "SalesStatus.NOT_PRESENT",
            "value" : "NOT_PRESENT",
            "displayValue": $translate.instant("SalesStatus.NOT_PRESENT"),
            "style": {"background-color": "#FF5733", "color": "white"}
        },
        "SalesStatus.CANCELLED": {
            "key" : "SalesStatus.CANCELLED",
            "value" : "CANCELLED",
            "displayValue": $translate.instant("SalesStatus.CANCELLED"),
            "style": {"background-color": "#FF5733", "color": "white"}
        },
        "SalesStatus.NOT_PRESENT_UNFIT": {
            "key" : "SalesStatus.NOT_PRESENT_UNFIT",
            "value" : "NOT_PRESENT_UNFIT",
            "displayValue": $translate.instant("SalesStatus.NOT_PRESENT_UNFIT"),
            "style": {"background-color": "#212121", "color": "white"}
        } // light grey #E0E0E0
    };
    // now, convert the map (object) salesStatus into a list for the ui-select
    $scope.salesStatusList.items = _.values($scope.salesStatus);

    /**
     * listener that is triggered by the onFinishRenderGrid directive
     */
    $scope.$on('ngRenderGridFinished', function (ngRepeatFinished) {
        var loadSeconds = (Date.now() - $scope.timerStart) / 1000;
        $scope.pageLoadTime = "It took " +  loadSeconds + " seconds to load the data";
    });

    /**
     * This is the end, do the thing we came for.
     */
    $scope.loadFilter().then(function () {
			if (!$rootScope.isDefinedAndNotNull($scope.dto)) {
				$scope.search();
			}
		}, function (err) {
    	console.error(err);
		});

    $interval(function(){
        // reload the eventformulas after the amount of seconds based on the value of $scope.reloadEventStatsInterval
        reloadEventData();
    },$scope.reloadEventStatsInterval*1000);

    $scope.eventDetailTooltip = function(event) {
        var tooltip = "<h4>"+event.name+"</h4>";
        var date = $filter('customNullableDateTime')(new Date(event.startDate)/1000,'dd-MM-yy');
        tooltip += "<h5>" + date + "</h5>";
        tooltip += "<p>Workdays remaining: " + event.workdaysRemaining + "</p>";
        tooltip += "<p>Target: " + event.target + "<br>Positions confirmed: " + event.totalConfirmed + "<br>Positions reserved: " + event.totalReserved + "</p>";
        tooltip += "<h5>Positions available: " + event.availableSpots + "</h5>";

        return tooltip;
    };
})
/**
 * Directive that is used to detect the rendering of the last grid cell in the grid, as this can take quite a while we want to know in order to show the page load time
 */
.directive('onFinishRenderGrid', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            // in relation-sales.html we have a nested ng-repeat
            // foreach relation we do foreach event
            // we want to detect the last event for the last relation, which is the last cell of the grid being rendered
            if (scope.$parent.$last === true && scope.$last === true) {
                $timeout(function () {
                    // we reached the last grid cell, trigger listeners for ngRenderGridFinished
                    scope.$emit('ngRenderGridFinished');
                });
            }
        }
    }
});

'use strict';


angular.module('emsApp').controller('EventDashboardController', function ($scope, $rootScope, $state, $stateParams, $q, $interval, EventFactory, FindAllEventsByQueryParamsFactory, NoPagingEventFactory, NoPagingEventStatusFactory, UserEventListDtoSearchFactory, NoPagingLocationFactory) {
    $scope.eventList = [];
    $scope.pageSize = 100;
    $scope.showSearchForm = false;
    $scope.secondsCounter = 120;
    $scope._refreshIntervalId = null;

    var spotWidth = 20; // in pixels
    $scope.statusBarStyle = "";
    $scope.calculateStatusBarStyle = function(event) {
        if ($rootScope.isDefinedAndNotNull(event.target) && $rootScope.isDefinedAndNotNull(event.totalConfirmed) && $rootScope.isDefinedAndNotNull(event.totalReserved)) {
						var barWidth;
						// If totalConfirmed + totalReserved is bigger than target, then take sum of confirmed and reserved as base for total bar width
						if ((event.totalConfirmed + event.totalReserved) > event.target) {
								barWidth = spotWidth * (event.totalConfirmed + event.totalReserved);
						} else {
								barWidth = spotWidth * event.target;
						}
        		var style = {"width": barWidth + "px"};
          	return style;
        }
        return  {"visibility":"hidden"};
    };
    $scope.calculateSpotsConfirmed = function(event) {
        if ($rootScope.isDefinedAndNotNull(event.totalConfirmed)) {
						var confirmedWidth = spotWidth * event.totalConfirmed;
						var style = {"width": confirmedWidth + "px"};
						return style;
        }
    };
    $scope.calculateSpotsReserved = function(event) {
				if ($rootScope.isDefinedAndNotNull(event.totalReserved)) {
						var reservedWidth = spotWidth * event.totalReserved;
						var style = {"width": reservedWidth + "px"};
						return style;
        }
    };
    $scope.calculateSpotsOpen = function(event) {
				if ($rootScope.isDefinedAndNotNull(event.availableSpots)) {
						var openWidth;
						if (event.availableSpots < 0) {
								openWidth = 0;
						} else {
								openWidth = spotWidth * event.availableSpots;
						}
						var style = {"width": openWidth + "px"};
						return style;
        }
    };

    $scope.goToNewState = function () {
        // this overview is NOT mapped, it is the main overview
        $state.go('event.list.new');
    };

    $scope.goToEditState = function (event) {
        // this overview is NOT mapped, it is the main overview
        $state.go('user-event.edit', {eventId: event.id});
    };


    var getLocationId = function () {
        if ($rootScope.isDefinedAndNotNull($scope.EventSearchOverview.location)) {
            return $scope.EventSearchOverview.location.id;
        } else {
            return undefined;
        }
    };


    // handle attribute startDate of javaType java.time.LocalDate
    $scope.processStartDate = function () {
        var startDateFromDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchOverview.startDateFrom);
        var startDateToDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchOverview.startDateTo);

        if (startDateFromDefined) {
            $scope.EventSearchOverview.startDateFromString = $rootScope.convertDateWithoutZone($scope.EventSearchOverview.startDateFrom);
        } else {
            $scope.EventSearchOverview.startDateFromString = undefined;
        }

        if (startDateToDefined) {
            $scope.EventSearchOverview.startDateToString = $rootScope.convertDateWithoutZone($scope.EventSearchOverview.startDateTo);
        } else {
            $scope.EventSearchOverview.startDateToString = undefined;
        }
    };


    NoPagingEventStatusFactory.query(function (result) {
        $scope.eventStatusList = result;
    });

		UserEventListDtoSearchFactory.query(function(result) {
				$scope.templateEventReferenceFilterList = result.templateEventSearchOptions;
		});

    NoPagingLocationFactory.query(function (result) {
        $scope.locationReferenceFilterList = result;
    });
    $scope.search = function () {
        $("#search-button").addClass("glyphicon-refresh-animate");

        // Call the javascript functions to handle search parameters
        $scope.processStartDate();

        $rootScope.EventSearchOverview = angular.copy($scope.EventSearchOverview);

        FindAllEventsByQueryParamsFactory.query({
            page: $scope.EventSearchOverview.page - 1,
            size: $scope.pageSize,
            name: $scope.EventSearchOverview.name,
            startDateFrom: $scope.EventSearchOverview.startDateFromString,
            startDateTo: $scope.EventSearchOverview.startDateToString,
            statusId: $scope.EventSearchOverview.status,
            templateEventIdList: $rootScope.getListValues($scope.EventSearchOverview.selectedTemplateEventList, 'id'),
            locationId: getLocationId(),
            sort: [$scope.EventSearchOverview.predicate + ',' + ($scope.EventSearchOverview.ascending ? 'asc' : 'desc')]

        }, function (result, headers) {
            $scope.totalItems = headers('X-Total-Count');
            $scope.eventList = result;
            console.log("X-Total-Count", $scope.totalItems);
            console.log("eventList size", $scope.eventList.length);
            console.log("$scope.EventSearchOverview", $scope.EventSearchOverview);
            $("#search-button").removeClass("glyphicon-refresh-animate");
        });

    };


    $scope.isEventSearchOverviewDirty = function () {
        return !angular.equals($scope.EventSearchOverview, $scope.originalEventSearchOverview);
    };

    $scope.loadDefaultSearchParams = function () {

        $rootScope.EventSearchOverview = {};
        $rootScope.EventSearchOverview.page = 1;
        $rootScope.EventSearchOverview.predicate = 'startDate';
        $rootScope.EventSearchOverview.ascending = true;

        $rootScope.EventSearchOverview.startDateFrom = new Date();

        $scope.EventSearchOverview = angular.copy($rootScope.EventSearchOverview);

        $scope.originalEventSearchOverview = angular.copy($scope.EventSearchOverview);
    };

    $scope.reset = function () {
        $scope.loadDefaultSearchParams();
        $scope.searchForm.$setPristine();
        $scope.search();
    };

    $scope.loadPage = function () {
        if (angular.isUndefined($rootScope.EventSearchOverview) || $rootScope.EventSearchOverview === null) {
            $scope.loadDefaultSearchParams(); // load defaults
        }

        $scope.EventSearchOverview = angular.copy($rootScope.EventSearchOverview);
        $scope.search();
    };

    $scope.singleDelete = function (id) {
        $scope.selectedEventId = id;
        $('#deleteEventConfirmation').modal('show');
    };

    $scope.confirmSingleDelete = function () {
        EventFactory.delete({id: $scope.selectedEventId}, function () {
            $scope.search();
            $('#deleteEventConfirmation').modal('hide');
        });
    };

    // the dialog controller can emit an event to update the overview, here we react on it
    $rootScope.$on('emsApp:eventUpdate', function () {
        $scope.loadPage();
    });

    $scope.loadPage();


    $scope.getSortIcon = function (itemName) {
        if ($scope.EventSearchOverview.predicate === itemName) {
            if ($scope.EventSearchOverview.ascending) {
                return "glyphicon-sort-by-attributes";
            } else {
                return "glyphicon-sort-by-attributes-alt";
            }
        } else {
            return "glyphicon-sort";
        }
    };

		$scope.$on('$destroy', function () {
			$interval.cancel($scope._refreshIntervalId);
		});

		$scope._refreshIntervalId = $interval(function () {
			$scope.loadPage();
		}, $scope.secondsCounter * 1000);
});

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('NavbarController', NavbarController);

	NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

	function NavbarController($state, Auth, Principal, ProfileService, LoginService) {
		var vm = this;

		vm.isNavbarCollapsed = true;
		vm.isAuthenticated = Principal.isAuthenticated;

		ProfileService.getProfileInfo().then(function(response) {
			// [dmitro] I'm receiving runtime exceptions because of this code. Response sometimes is undefined
			if (response) {
				vm.inProduction = response.inProduction;
				vm.swaggerEnabled = response.swaggerEnabled;
			}
		});

		vm.login = login;
		vm.logout = logout;
		vm.toggleNavbar = toggleNavbar;
		vm.collapseNavbar = collapseNavbar;
		vm.$state = $state;

		function login() {
			collapseNavbar();
			LoginService.open();
		}

		function logout() {
			collapseNavbar();
			Auth.logout();
			$state.go('home');
		}

		function toggleNavbar() {
			vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
		}

		function collapseNavbar() {
			vm.isNavbarCollapsed = true;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('activeMenu', activeMenu);

	activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

	function activeMenu($translate, $locale, tmhDynamicLocale) {
		var directive = {
			restrict: 'A',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			var language = attrs.activeMenu;

			scope.$watch(
				function() {
					return $translate.use();
				},
				function(selectedLanguage) {
					if (language === selectedLanguage) {
						tmhDynamicLocale.set(language);
						element.addClass('active');
					} else {
						element.removeClass('active');
					}
				}
			);
		}
	}
})();

(function() {
	'use strict';

	angular.module('emsApp').directive('activeLink', activeLink);

	function activeLink() {
		var directive = {
			restrict : 'A',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			var clazz = attrs.activeLink;
			var path = attrs.href;
			path = path.substring(1); //hack because path does bot return including hashbang
			scope.location = location;
			scope.$watch('location.path()', function(newPath) {
				if (path === newPath) {
					element.addClass(clazz);
				} else {
					element.removeClass(clazz);
				}
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
			.state('error', {
				parent: 'app',
				url: '/error',
				data: {
					authorities: [],
					pageTitle: 'error.title',
				},
				views: {
					'content@': {
						templateUrl: 'app/layouts/error/error.html',
					},
				},
				resolve: {
					translatePartialLoader: [
						'$translate',
						'$translatePartialLoader',
						function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('error');
							return $translate.refresh();
						},
					],
				},
			})
			.state('accessdenied', {
				parent: 'app',
				url: '/accessdenied',
				data: {
					authorities: [],
				},
				views: {
					'content@': {
						templateUrl: 'app/layouts/error/accessdenied.html',
					},
				},
				resolve: {
					translatePartialLoader: [
						'$translate',
						'$translatePartialLoader',
						function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('error');
							return $translate.refresh();
						},
					],
				},
			});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('home', {
			parent: 'app',
			url: '/',
			data: {
				authorities: [],
			},
			views: {
				'content@': {
					templateUrl: 'app/home/home.html',
					controller: 'HomeController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('home');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('HomeController', HomeController);

	HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

	function HomeController($scope, Principal, LoginService, $state) {
		var vm = this;

		vm.account = null;
		vm.isAuthenticated = null;
		vm.login = LoginService.open;
		vm.register = register;
		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				vm.isAuthenticated = Principal.isAuthenticated;
			});
		}
		function register() {
			$state.go('register');
		}
	}
})();

/** @format */

angular.module('emsApp').service('GetHeaderFilename', function() {
	return function(headers) {
		var result = headers
			.split(';')[1]
			.trim()
			.split('=')[1];
		return result.replace(/"/g, '');
	};
});

angular.module('emsApp').service('FileDownloadError', function($q, AlertService) {
	var arrayBufferToString = function(buff) {
		var charCodeArray = Array.apply(null, new Uint8Array(buff));
		var result = '';
		for (var i = 0, len = charCodeArray.length; i < len; i++) {
			var code = charCodeArray[i];
			result += String.fromCharCode(code);
		}
		return result;
	};

	return function(error) {
		error.data = angular.fromJson(arrayBufferToString(error.data.data));
		AlertService.error('error.file.download', {});
		return $q.reject(error);
	};
});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserVatListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		VatFactory,
		UserVatListDtoSearchFactory
	) {
		$scope.vatList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeVat)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeVat);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeVat = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-vat.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getVatList = function() {
			UserVatListDtoSearchFactory.query(
				{
					vatTypeList: angular.isDefined($scope.vatTypeId) ? $scope.vatTypeId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.vatList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getVatList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};

		$scope.updateVatTypeUISelect = function(item, model) {
			$scope.search();
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserVatListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		VatFactory,
		UserVatListDtoSearchFactory
	) {
		$scope.vatList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeVat)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeVat);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeVat = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-vat.new');
		};

		$scope.getVatList = function() {
			UserVatListDtoSearchFactory.query(
				{
					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.vatList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getVatList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};

		$scope.updateVatTypeUISelect = function(item, model) {
			$scope.search();
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('VatDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		VatFactory,
		AlertService,
		NoPagingVatFactory,
		NoPagingVatTypeFactory
	) {
		$scope.vat = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.vat) && $rootScope.isDefinedAndNotNull($scope.vat.id);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('vat.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type VatType and checks if this Vat dialog is called in the context of VatType.
		 * If this is the case, we detect the parent entity Vat and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryVatType = function() {
			return NoPagingVatTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'vatType');
			});
		};
		$scope.vatTypeList = $scope.queryVatType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:vatUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Vat failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.vat.id != null) {
				VatFactory.update($scope.vat, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				VatFactory.save($scope.vat, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('VatDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.vat = entity;
	$scope.objectName = 'Vat';
	$scope.vatId = $stateParams.vatId;

	if (angular.isUndefined($rootScope.vatActiveTab)) {
		//set the default here
		$rootScope.vatActiveTab = 0;
	}

	$scope.goToEditState = function(vat) {
		$state.go('vat.detail.edit({vatId:vat.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:vatUpdate', function(event, result) {
		$scope.vat = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Vat'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('vat'); // main translation loaded for vat
		$translatePartialLoader.addPart('vattype'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/vat/vat-dialog.html';

		return {
			/* new state for entity vat */
			/* to access: ui-ref="vat.list.new" */
			/* url: hostname/vat/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'VatDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'VatFactory',
									'NewVatFactory',
									function(VatFactory, NewVatFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Vat
										// - resuming the creation of a new new Vat AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return VatFactory.get({ id: $stateParams.vatId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewVatFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for vat new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for vat edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('vat', {
		/* abstract state for entity vat */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/vat',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Vats',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('vat.list', {
		/* list state for entity vat */
		/* to access: ui-ref="vat.list" */
		/* url: hostname/vat/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/vat/vats.html',
				controller: 'VatController',
			},
		},
	});

	$stateProvider.state('vat.detail', {
		/* detail state for entity vat */
		/* to access: ui-sref="vat.detail" */
		/* url: hostname/vat/detail/:vatId */
		url: '/detail/:vatId',
		views: {
			'content@': {
				templateUrl: 'app/entities/vat/vat-detail.html',
				controller: 'VatDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'VatFactory',
				function($stateParams, VatFactory) {
					return VatFactory.get({ id: $stateParams.vatId });
				},
			],
		},
	});

	/* url: http://<hostname>/vat/list/new */
	$stateProvider.state('vat.list.new', getNewState());
	/* url: http://<hostname>/vat/list/:vatId/edit */
	$stateProvider.state('vat.list.edit', getEditState('/:vatId/edit'));
	/* url: http://<hostname>/vat/detail/:vatId/edit */
	$stateProvider.state('vat.detail.edit', getEditState('/edit'));

	$stateProvider.state('user-vat', {
		/* abstract state for DTO UserVatListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/vat',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'Vat',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserVatListDto */
		/* to access: ui-ref="user-vat.list" */
		/* url: http://<hostname>/user/vat/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/vat/vat-list-user.html',
				controller: 'UserVatListDtoController',
			},
		},
	};

	$stateProvider.state('user-vat.list', dtoListState);
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('VatTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		VatFactory,
		FindAllVatsByQueryParamsFactory,
		NoPagingVatFactory,
		NoPagingVatTypeFactory
	) {
		$scope.vatList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeVat)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeVat);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeVat = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newVat', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(vat) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editVat', { vatId: vat.id, mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getVatList = function() {
			FindAllVatsByQueryParamsFactory.query(
				{
					// Searching Vat by vatType supports multiple
					vatTypeList: angular.isDefined($scope.vatTypeId) ? [$scope.vatTypeId] : [],

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.vatList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getVatList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedVatId = id;
			$('#deleteVatConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			VatFactory.delete(
				{ id: $scope.selectedVatId },
				function() {
					$scope.loadAll();
					$('#deleteVatConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteVatConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('VatController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		VatFactory,
		FindAllVatsByQueryParamsFactory,
		NoPagingVatFactory,
		NoPagingVatTypeFactory
	) {
		$scope.vatList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeVat)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeVat);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeVat = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('vat.list.new');
		};

		$scope.goToEditState = function(vat) {
			// this overview is NOT mapped, it is the main overview
			$state.go('vat.list.edit', { vatId: vat.id });
		};

		$scope.getVatList = function() {
			FindAllVatsByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.vatList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getVatList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedVatId = id;
			$('#deleteVatConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			VatFactory.delete(
				{ id: $scope.selectedVatId },
				function() {
					$scope.loadAll();
					$('#deleteVatConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteVatConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		UserTypeFactory,
		AlertService,
		NoPagingUserTypeFactory,
		NoPagingPredefinedUserTypeFactory
	) {
		$scope.userType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.userType) && $rootScope.isDefinedAndNotNull($scope.userType.id);
		};

		$scope.createPredefinedUserType = function() {
			var referredBy = {
				refName: 'predefinedUserType',
				data: $scope.userType,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new predefinedUserType will add this new usertype state to the history stack
				$state.go('usertype.list.newPredefinedUserType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('userType.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type PredefinedUserType and checks if this UserType dialog is called in the context of PredefinedUserType.
		 * If this is the case, we detect the parent entity UserType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryPredefinedUserType = function() {
			return NoPagingPredefinedUserTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'predefinedUserType');
			});
		};
		$scope.predefinedUserTypeList = $scope.queryPredefinedUserType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:userTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving UserType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.userType.id != null) {
				UserTypeFactory.update($scope.userType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				UserTypeFactory.save($scope.userType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('UserTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.userType = entity;
	$scope.objectName = 'UserType';
	$scope.userTypeId = $stateParams.userTypeId;

	if (angular.isUndefined($rootScope.userTypeActiveTab)) {
		//set the default here
		$rootScope.userTypeActiveTab = 0;
	}

	$scope.goToEditState = function(userType) {
		$state.go('usertype.detail.edit({userTypeId:userType.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:userTypeUpdate', function(event, result) {
		$scope.userType = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'UserType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('usertype'); // main translation loaded for usertype
		$translatePartialLoader.addPart('predefinedusertype'); // one to many reference from main entity
		$translatePartialLoader.addPart('user'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/usertype/usertype-dialog.html';

		return {
			/* new state for entity userType */
			/* to access: ui-ref="usertype.list.new" */
			/* url: hostname/usertype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'UserTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'UserTypeFactory',
									'NewUserTypeFactory',
									function(UserTypeFactory, NewUserTypeFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new UserType
										// - resuming the creation of a new new UserType AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return UserTypeFactory.get({ id: $stateParams.userTypeId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewUserTypeFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for userType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for userType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('usertype', {
		/* abstract state for entity userType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/usertype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'UserTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('usertype.list', {
		/* list state for entity userType */
		/* to access: ui-ref="usertype.list" */
		/* url: hostname/usertype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/usertype/usertypes.html',
				controller: 'UserTypeController',
			},
		},
	});

	$stateProvider.state('usertype.detail', {
		/* detail state for entity userType */
		/* to access: ui-sref="usertype.detail" */
		/* url: hostname/usertype/detail/:userTypeId */
		url: '/detail/:userTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/usertype/usertype-detail.html',
				controller: 'UserTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'UserTypeFactory',
				function($stateParams, UserTypeFactory) {
					return UserTypeFactory.get({ id: $stateParams.userTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/usertype/list/new */
	$stateProvider.state('usertype.list.new', getNewState());
	/* url: http://<hostname>/usertype/list/:userTypeId/edit */
	$stateProvider.state('usertype.list.edit', getEditState('/:userTypeId/edit'));
	/* url: http://<hostname>/usertype/detail/:userTypeId/edit */
	$stateProvider.state('usertype.detail.edit', getEditState('/edit'));

	$stateProvider.state('user.list.newUserType', getNewState('/usertype/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('UserTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		UserTypeFactory,
		FindAllUserTypesByQueryParamsNonPageableFactory,
		NoPagingUserTypeFactory,
		NoPagingPredefinedUserTypeFactory
	) {
		$scope.userTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newUserType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(userType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editUserType', {
				userTypeId: userType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getUserTypeList = function() {
			FindAllUserTypesByQueryParamsNonPageableFactory.query(
				{
					predefinedUserTypeId: angular.isDefined($scope.predefinedUserTypeId) ? $scope.predefinedUserTypeId : null,

					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.userTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getUserTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedUserTypeId = id;
			$('#deleteUserTypeConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserTypeFactory.delete(
				{ id: $scope.selectedUserTypeId },
				function() {
					$scope.loadAll();
					$('#deleteUserTypeConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteUserTypeConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('UserTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		UserTypeFactory,
		FindAllUserTypesByQueryParamsNonPageableFactory,
		NoPagingUserTypeFactory,
		NoPagingPredefinedUserTypeFactory
	) {
		$scope.userTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('usertype.list.new');
		};

		$scope.goToEditState = function(userType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('usertype.list.edit', { userTypeId: userType.id });
		};

		$scope.getUserTypeList = function() {
			FindAllUserTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.userTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getUserTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedUserTypeId = id;
			$('#deleteUserTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserTypeFactory.delete(
				{ id: $scope.selectedUserTypeId },
				function() {
					$scope.loadAll();
					$('#deleteUserTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteUserTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

// Created by frontend/angular/entity/controller/dto-edit.ftl
angular
	.module('emsApp')
	.controller('UserTemplateEventEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserTemplateEventEditDtoFactory,
		AlertService,
		HistoryService
	) {
		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.submitButtonIsActive = true;
		};

		$scope.templateEvent = entity;
		$scope.submitButtonIsActive = true;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		//This function preselects and disables the parent reference when called from tab
		$scope.templateEvent['selected' + _.upperFirst($stateParams.mappedBy)] = {
			id: $stateParams.mappedById,
			displayValue: $stateParams.mappedByDisplayValue,
		};

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.templateEvent) && $rootScope.isDefinedAndNotNull($scope.templateEvent.id);
		};

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:templateEventUpdate', result);
			$scope.submitButtonIsActive = true;
			// process success result, if necessary
			if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
				console.log('as we came on this create new page from plus button we will update history');

				// set relation as reference in the referredBy data model
				$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;

				// update previous state
				HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
			}
			$rootScope.back();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;
			UserTemplateEventEditDtoFactory.update($scope.templateEvent, onSaveFinishedCallback, saveOrUpdateErrorCallback);
		};

		// triggered when click a plus button, navigates to creating a new defaultDriver of type Article
		// once Article is saved, history is updated and the user automatically navigates back to this edit page for TemplateEvent
		$scope.createDefaultDriver = function() {
			var referredBy = {
				refName: 'defaultDriver',
				data: $scope.templateEvent,
			};

			// navigating to new defaultDriver will add this new templateevent state to the history stack
			$state.go($state.current.name + '.newArticle', { referredBy: referredBy }, { notify: true });
		};

		// triggered when click a plus button, navigates to creating a new defaultSecondDriver of type Article
		// once Article is saved, history is updated and the user automatically navigates back to this edit page for TemplateEvent
		$scope.createDefaultSecondDriver = function() {
			var referredBy = {
				refName: 'defaultSecondDriver',
				data: $scope.templateEvent,
			};

			// navigating to new defaultSecondDriver will add this new templateevent state to the history stack
			$state.go($state.current.name + '.newArticle', { referredBy: referredBy }, { notify: true });
		};

		// triggered when click a plus button, navigates to creating a new defaultSpectator of type Article
		// once Article is saved, history is updated and the user automatically navigates back to this edit page for TemplateEvent
		$scope.createDefaultSpectator = function() {
			var referredBy = {
				refName: 'defaultSpectator',
				data: $scope.templateEvent,
			};

			// navigating to new defaultSpectator will add this new templateevent state to the history stack
			$state.go($state.current.name + '.newArticle', { referredBy: referredBy }, { notify: true });
		};

		// triggered when click a plus button, navigates to creating a new defaultInsurance of type Article
		// once Article is saved, history is updated and the user automatically navigates back to this edit page for TemplateEvent
		$scope.createDefaultInsurance = function() {
			var referredBy = {
				refName: 'defaultInsurance',
				data: $scope.templateEvent,
			};

			// navigating to new defaultInsurance will add this new templateevent state to the history stack
			$state.go($state.current.name + '.newArticle', { referredBy: referredBy }, { notify: true });
		};

		// triggered when click a plus button, navigates to creating a new defaultHotel of type Article
		// once Article is saved, history is updated and the user automatically navigates back to this edit page for TemplateEvent
		$scope.createDefaultHotel = function() {
			var referredBy = {
				refName: 'defaultHotel',
				data: $scope.templateEvent,
			};

			// navigating to new defaultHotel will add this new templateevent state to the history stack
			$state.go($state.current.name + '.newArticle', { referredBy: referredBy }, { notify: true });
		};

		// triggered when click a plus button, navigates to creating a new defaultFuel of type Article
		// once Article is saved, history is updated and the user automatically navigates back to this edit page for TemplateEvent
		$scope.createDefaultFuel = function() {
			var referredBy = {
				refName: 'defaultFuel',
				data: $scope.templateEvent,
			};

			// navigating to new defaultFuel will add this new templateevent state to the history stack
			$state.go($state.current.name + '.newArticle', { referredBy: referredBy }, { notify: true });
		};

		// triggered when click a plus button, navigates to creating a new defaultInstruction of type Article
		// once Article is saved, history is updated and the user automatically navigates back to this edit page for TemplateEvent
		$scope.createDefaultInstruction = function() {
			var referredBy = {
				refName: 'defaultInstruction',
				data: $scope.templateEvent,
			};

			// navigating to new defaultInstruction will add this new templateevent state to the history stack
			$state.go($state.current.name + '.newArticle', { referredBy: referredBy }, { notify: true });
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('TemplateEventDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		TemplateEventFactory,
		AlertService,
		NoPagingTemplateEventFactory,
		NoPagingEventTypeFactory,
		NoPagingArticleFactory,
		TemplateEventFindArticleFilteredByDefaultDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSecondDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSpectatorFactory,
		TemplateEventFindArticleFilteredByDefaultInsuranceFactory,
		TemplateEventFindArticleFilteredByDefaultHotelFactory,
		TemplateEventFindArticleFilteredByDefaultFuelFactory,
		TemplateEventFindArticleFilteredByDefaultInstructionFactory,
		SalesFilterFromSalesFilterTemplateEventPicklistUpdateFactory,
		NoPagingSalesFilterFactory
	) {
		$scope.templateEvent = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.templateEvent) && $rootScope.isDefinedAndNotNull($scope.templateEvent.id);
		};

		$scope.createEventType = function() {
			var referredBy = {
				refName: 'eventType',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new eventType will add this new templateevent state to the history stack
				$state.go('templateevent.list.newEventType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDefaultDriver = function() {
			var referredBy = {
				refName: 'defaultDriver',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new defaultDriver will add this new templateevent state to the history stack
				$state.go('templateevent.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDefaultSecondDriver = function() {
			var referredBy = {
				refName: 'defaultSecondDriver',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new defaultSecondDriver will add this new templateevent state to the history stack
				$state.go('templateevent.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDefaultSpectator = function() {
			var referredBy = {
				refName: 'defaultSpectator',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new defaultSpectator will add this new templateevent state to the history stack
				$state.go('templateevent.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDefaultInsurance = function() {
			var referredBy = {
				refName: 'defaultInsurance',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new defaultInsurance will add this new templateevent state to the history stack
				$state.go('templateevent.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDefaultHotel = function() {
			var referredBy = {
				refName: 'defaultHotel',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new defaultHotel will add this new templateevent state to the history stack
				$state.go('templateevent.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDefaultFuel = function() {
			var referredBy = {
				refName: 'defaultFuel',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new defaultFuel will add this new templateevent state to the history stack
				$state.go('templateevent.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDefaultInstruction = function() {
			var referredBy = {
				refName: 'defaultInstruction',
				data: $scope.templateEvent,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new defaultInstruction will add this new templateevent state to the history stack
				$state.go('templateevent.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('templateEvent.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type EventType and checks if this TemplateEvent dialog is called in the context of EventType.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryEventType = function() {
			return NoPagingEventTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'eventType');
			});
		};
		$scope.eventTypeList = $scope.queryEventType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type DefaultDriver and checks if this TemplateEvent dialog is called in the context of DefaultDriver.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDefaultDriver = function() {
			return TemplateEventFindArticleFilteredByDefaultDriverFactory.query(function(result) {
				$scope.findItemByParent(result, 'defaultDriver');
			});
		};
		$scope.defaultDriverList = $scope.queryDefaultDriver();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type DefaultSecondDriver and checks if this TemplateEvent dialog is called in the context of DefaultSecondDriver.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDefaultSecondDriver = function() {
			return TemplateEventFindArticleFilteredByDefaultSecondDriverFactory.query(function(result) {
				$scope.findItemByParent(result, 'defaultSecondDriver');
			});
		};
		$scope.defaultSecondDriverList = $scope.queryDefaultSecondDriver();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type DefaultSpectator and checks if this TemplateEvent dialog is called in the context of DefaultSpectator.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDefaultSpectator = function() {
			return TemplateEventFindArticleFilteredByDefaultSpectatorFactory.query(function(result) {
				$scope.findItemByParent(result, 'defaultSpectator');
			});
		};
		$scope.defaultSpectatorList = $scope.queryDefaultSpectator();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type DefaultInsurance and checks if this TemplateEvent dialog is called in the context of DefaultInsurance.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDefaultInsurance = function() {
			return TemplateEventFindArticleFilteredByDefaultInsuranceFactory.query(function(result) {
				$scope.findItemByParent(result, 'defaultInsurance');
			});
		};
		$scope.defaultInsuranceList = $scope.queryDefaultInsurance();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type DefaultHotel and checks if this TemplateEvent dialog is called in the context of DefaultHotel.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDefaultHotel = function() {
			return TemplateEventFindArticleFilteredByDefaultHotelFactory.query(function(result) {
				$scope.findItemByParent(result, 'defaultHotel');
			});
		};
		$scope.defaultHotelList = $scope.queryDefaultHotel();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type DefaultFuel and checks if this TemplateEvent dialog is called in the context of DefaultFuel.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDefaultFuel = function() {
			return TemplateEventFindArticleFilteredByDefaultFuelFactory.query(function(result) {
				$scope.findItemByParent(result, 'defaultFuel');
			});
		};
		$scope.defaultFuelList = $scope.queryDefaultFuel();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type DefaultInstruction and checks if this TemplateEvent dialog is called in the context of DefaultInstruction.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDefaultInstruction = function() {
			return TemplateEventFindArticleFilteredByDefaultInstructionFactory.query(function(result) {
				$scope.findItemByParent(result, 'defaultInstruction');
			});
		};
		$scope.defaultInstructionList = $scope.queryDefaultInstruction();
		// --- end default implementation

		var getSelectedListItems = function(allItems, selectedItemList) {
			var itemIDs = [];
			angular.forEach(selectedItemList, function(value, key) {
				itemIDs.push(value.id);
			});

			var selectedItems = [];
			angular.forEach(allItems, function(value, key) {
				angular.forEach(itemIDs, function(value2, key2) {
					if (value.id === value2) {
						selectedItems.push(value);
					}
				});
			});

			return selectedItems;
		};

		var tempSelectedSalesFilterList = [];
		$scope.selectedSalesFilterList = [];

		$scope.getSelectedSalesFilterList = function() {
			SalesFilterFromSalesFilterTemplateEventPicklistUpdateFactory.query({ id: $stateParams.templateEventId }, function(result) {
				//put all selected SalesFilter-items in a list
				angular.forEach(result, function(value, key) {
					tempSelectedSalesFilterList.push(value);
				});
				NoPagingSalesFilterFactory.query(function(result) {
					$scope.salesFilterPickListOptions = result;
					$scope.selectedSalesFilterList = getSelectedListItems(result, tempSelectedSalesFilterList);
				});
			});
		};

		$scope.getSalesFilterPickListOptions = function() {
			if ($stateParams.templateEventId != null) {
				$scope.getSelectedSalesFilterList();
			} else {
				NoPagingSalesFilterFactory.query(function(result) {
					$scope.salesFilterPickListOptions = result;
				});
			}
		};

		$scope.getSalesFilterPickListOptions();

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:templateEventUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving TemplateEvent failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.templateEvent.id != null) {
				TemplateEventFactory.update(
					$scope.templateEvent,
					function(result) {
						$scope.templateEvent = result;

						if (
							!angular.isUndefined($scope.selectedSalesFilterList) &&
							angular.isArray($scope.selectedSalesFilterList) &&
							$scope.selectedSalesFilterList.length > 0
						) {
							SalesFilterFromSalesFilterTemplateEventPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedSalesFilterList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			} else {
				TemplateEventFactory.save(
					$scope.templateEvent,
					function(result) {
						$scope.templateEvent = result;

						if (
							!angular.isUndefined($scope.selectedSalesFilterList) &&
							angular.isArray($scope.selectedSalesFilterList) &&
							$scope.selectedSalesFilterList.length > 0
						) {
							SalesFilterFromSalesFilterTemplateEventPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedSalesFilterList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('TemplateEventDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.templateEvent = entity;
	$scope.objectName = 'TemplateEvent';
	$scope.templateEventId = $stateParams.templateEventId;

	if (angular.isUndefined($rootScope.templateEventActiveTab)) {
		//set the default here
		$rootScope.templateEventActiveTab = 0;
	}

	$scope.goToEditState = function(templateEvent) {
		$state.go('templateevent.detail.edit({templateEventId:templateEvent.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:templateEventUpdate', function(event, result) {
		$scope.templateEvent = result;
	});
});

/** @format */

'use strict';

// TemplateEvent has edit layout enabled. Edit layout template url: templateevent-dialog.html
angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'TemplateEvent'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('templateevent'); // main translation loaded for templateevent
		$translatePartialLoader.addPart('eventtype'); // one to many reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfiltertemplateevent'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/templateevent/templateevent-dialog.html';

		return {
			/* new state for entity templateEvent */
			/* to access: ui-ref="templateevent.list.new" */
			/* url: hostname/templateevent/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'TemplateEventDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'TemplateEventFactory',
									'NewTemplateEventFactory',
									function(TemplateEventFactory, NewTemplateEventFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new TemplateEvent
										// - resuming the creation of a new new TemplateEvent AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return TemplateEventFactory.get({ id: $stateParams.templateEventId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewTemplateEventFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for templateEvent new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for templateEvent edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('templateevent', {
		/* abstract state for entity templateEvent */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/templateevent',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'TemplateEvents',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('templateevent.list', {
		/* list state for entity templateEvent */
		/* to access: ui-ref="templateevent.list" */
		/* url: hostname/templateevent/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/templateevent/templateevents.html',
				controller: 'TemplateEventController',
			},
		},
	});

	$stateProvider.state('templateevent.detail', {
		/* detail state for entity templateEvent */
		/* to access: ui-sref="templateevent.detail" */
		/* url: hostname/templateevent/detail/:templateEventId */
		url: '/detail/:templateEventId',
		views: {
			'content@': {
				templateUrl: 'app/entities/templateevent/templateevent-detail.html',
				controller: 'TemplateEventDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'TemplateEventFactory',
				function($stateParams, TemplateEventFactory) {
					return TemplateEventFactory.get({ id: $stateParams.templateEventId });
				},
			],
		},
	});

	/* url: http://<hostname>/templateevent/list/new */
	$stateProvider.state('templateevent.list.new', getNewState());
	/* url: http://<hostname>/templateevent/list/:templateEventId/edit */
	$stateProvider.state('templateevent.list.edit', getEditState('/:templateEventId/edit'));
	/* url: http://<hostname>/templateevent/detail/:templateEventId/edit */
	$stateProvider.state('templateevent.detail.edit', getEditState('/edit'));
	// EventType.templateEvent with multiplicity 0..n points to TemplateEvent
	/* url: http://<hostname>/eventtype/detail/:eventTypeId/templateevent/new */
	$stateProvider.state('eventtype.detail.newTemplateEvent', getNewState('/templateevent/new'));
	/* url: http://<hostname>/eventtype/detail/:eventTypeId/templateevent/:templateEventId/edit */
	$stateProvider.state('eventtype.detail.editTemplateEvent', getEditState('/templateevent/:templateEventId/edit'));

	$stateProvider.state('subscription.list.newTemplateEvent', getNewState('/templateevent/new'));
	$stateProvider.state('event.list.newTemplateEvent', getNewState('/templateevent/new'));

	$stateProvider.state('user-templateevent', {
		/* abstract state for DTO UserTemplateEventListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/templateevent',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'TemplateEvent',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* edit state for DTO user */
	var dtoEditState = {
		/* edit state for DTO UserTemplateEventEditDto */
		/* to access: ui-sref="user-templateevent.edit" */
		/* url: http://<hostname>/user/templateevent/edit/:templateEventId */
		url: '/edit/:templateEventId',
		views: {
			'content@': {
				templateUrl: 'app/entities/templateevent/templateevent-edit-user.html',
				controller: 'UserTemplateEventEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserTemplateEventEditDtoFactory',
				function($stateParams, $rootScope, UserTemplateEventEditDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						// as defaultDriver has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultDriver)) {
							// push the created defaultDriver to the list with selectable defaultDriver items
							$stateParams.dataModel.defaultDriverList.push($stateParams.dataModel.defaultDriver);

							// set the created defaultDriver as selected defaultDriver
							$stateParams.dataModel.selectedDefaultDriver = $stateParams.dataModel.defaultDriver;
						}
						// as defaultSecondDriver has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultSecondDriver)) {
							// push the created defaultSecondDriver to the list with selectable defaultSecondDriver items
							$stateParams.dataModel.defaultSecondDriverList.push($stateParams.dataModel.defaultSecondDriver);

							// set the created defaultSecondDriver as selected defaultSecondDriver
							$stateParams.dataModel.selectedDefaultSecondDriver = $stateParams.dataModel.defaultSecondDriver;
						}
						// as defaultSpectator has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultSpectator)) {
							// push the created defaultSpectator to the list with selectable defaultSpectator items
							$stateParams.dataModel.defaultSpectatorList.push($stateParams.dataModel.defaultSpectator);

							// set the created defaultSpectator as selected defaultSpectator
							$stateParams.dataModel.selectedDefaultSpectator = $stateParams.dataModel.defaultSpectator;
						}
						// as defaultInsurance has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultInsurance)) {
							// push the created defaultInsurance to the list with selectable defaultInsurance items
							$stateParams.dataModel.defaultInsuranceList.push($stateParams.dataModel.defaultInsurance);

							// set the created defaultInsurance as selected defaultInsurance
							$stateParams.dataModel.selectedDefaultInsurance = $stateParams.dataModel.defaultInsurance;
						}
						// as defaultHotel has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultHotel)) {
							// push the created defaultHotel to the list with selectable defaultHotel items
							$stateParams.dataModel.defaultHotelList.push($stateParams.dataModel.defaultHotel);

							// set the created defaultHotel as selected defaultHotel
							$stateParams.dataModel.selectedDefaultHotel = $stateParams.dataModel.defaultHotel;
						}
						// as defaultFuel has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultFuel)) {
							// push the created defaultFuel to the list with selectable defaultFuel items
							$stateParams.dataModel.defaultFuelList.push($stateParams.dataModel.defaultFuel);

							// set the created defaultFuel as selected defaultFuel
							$stateParams.dataModel.selectedDefaultFuel = $stateParams.dataModel.defaultFuel;
						}
						// as defaultInstruction has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultInstruction)) {
							// push the created defaultInstruction to the list with selectable defaultInstruction items
							$stateParams.dataModel.defaultInstructionList.push($stateParams.dataModel.defaultInstruction);

							// set the created defaultInstruction as selected defaultInstruction
							$stateParams.dataModel.selectedDefaultInstruction = $stateParams.dataModel.defaultInstruction;
						}

						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserTemplateEventEditDtoFactory.get({ id: $stateParams.templateEventId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-templateevent.edit', dtoEditState);

	/* new (create) state for DTO user */
	var dtoCreateState = {
		/* new state for DTO UserTemplateEventEditDto */
		/* to access: ui-sref="user-templateevent.new" */
		/* url: http://<hostname>/user/templateevent/new */
		url: '/new',
		views: {
			'content@': {
				templateUrl: 'app/entities/templateevent/templateevent-edit-user.html',
				controller: 'UserTemplateEventEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserTemplateEventNewDtoFactory',
				function($stateParams, $rootScope, UserTemplateEventNewDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						// as defaultDriver has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultDriver)) {
							// push the created defaultDriver to the list with selectable defaultDriver items
							$stateParams.dataModel.defaultDriverList.push($stateParams.dataModel.defaultDriver);

							// set the created defaultDriver as selected defaultDriver
							$stateParams.dataModel.selectedDefaultDriver = $stateParams.dataModel.defaultDriver;
						}
						// as defaultSecondDriver has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultSecondDriver)) {
							// push the created defaultSecondDriver to the list with selectable defaultSecondDriver items
							$stateParams.dataModel.defaultSecondDriverList.push($stateParams.dataModel.defaultSecondDriver);

							// set the created defaultSecondDriver as selected defaultSecondDriver
							$stateParams.dataModel.selectedDefaultSecondDriver = $stateParams.dataModel.defaultSecondDriver;
						}
						// as defaultSpectator has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultSpectator)) {
							// push the created defaultSpectator to the list with selectable defaultSpectator items
							$stateParams.dataModel.defaultSpectatorList.push($stateParams.dataModel.defaultSpectator);

							// set the created defaultSpectator as selected defaultSpectator
							$stateParams.dataModel.selectedDefaultSpectator = $stateParams.dataModel.defaultSpectator;
						}
						// as defaultInsurance has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultInsurance)) {
							// push the created defaultInsurance to the list with selectable defaultInsurance items
							$stateParams.dataModel.defaultInsuranceList.push($stateParams.dataModel.defaultInsurance);

							// set the created defaultInsurance as selected defaultInsurance
							$stateParams.dataModel.selectedDefaultInsurance = $stateParams.dataModel.defaultInsurance;
						}
						// as defaultHotel has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultHotel)) {
							// push the created defaultHotel to the list with selectable defaultHotel items
							$stateParams.dataModel.defaultHotelList.push($stateParams.dataModel.defaultHotel);

							// set the created defaultHotel as selected defaultHotel
							$stateParams.dataModel.selectedDefaultHotel = $stateParams.dataModel.defaultHotel;
						}
						// as defaultFuel has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultFuel)) {
							// push the created defaultFuel to the list with selectable defaultFuel items
							$stateParams.dataModel.defaultFuelList.push($stateParams.dataModel.defaultFuel);

							// set the created defaultFuel as selected defaultFuel
							$stateParams.dataModel.selectedDefaultFuel = $stateParams.dataModel.defaultFuel;
						}
						// as defaultInstruction has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.defaultInstruction)) {
							// push the created defaultInstruction to the list with selectable defaultInstruction items
							$stateParams.dataModel.defaultInstructionList.push($stateParams.dataModel.defaultInstruction);

							// set the created defaultInstruction as selected defaultInstruction
							$stateParams.dataModel.selectedDefaultInstruction = $stateParams.dataModel.defaultInstruction;
						}

						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserTemplateEventNewDtoFactory.get({ id: $stateParams.templateEventId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-templateevent.new', dtoCreateState);

	// create state for plus button on Subscription edit / new page for reference TemplateEvent and dto property value user
	$stateProvider.state('user-subscription.new.newTemplateEvent', getCreateState('/trainingtype/new'));
	$stateProvider.state('user-subscription.edit.newTemplateEvent', getCreateState('/trainingtype/new'));
	// create state for plus button on Event edit / new page for reference TemplateEvent and dto property value user
	$stateProvider.state('user-event.new.newTemplateEvent', getCreateState('/templateevent/new'));
	$stateProvider.state('user-event.edit.newTemplateEvent', getCreateState('/templateevent/new'));
	// retrieve the create state object, and update the url in the state object as the default create state only adds "/new" to the location url, while we want the url to contain "/templateevent/new"
	function getCreateState(url) {
		var clonedDtoCreateState = Object.assign({}, dtoCreateState);
		clonedDtoCreateState.url = url;
		return clonedDtoCreateState;
	}
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('TemplateEventTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		TemplateEventFactory,
		FindAllTemplateEventsByQueryParamsNonPageableFactory,
		NoPagingTemplateEventFactory,
		NoPagingEventTypeFactory,
		NoPagingArticleFactory,
		TemplateEventFindArticleFilteredByDefaultDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSecondDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSpectatorFactory,
		TemplateEventFindArticleFilteredByDefaultInsuranceFactory,
		TemplateEventFindArticleFilteredByDefaultHotelFactory,
		TemplateEventFindArticleFilteredByDefaultFuelFactory,
		TemplateEventFindArticleFilteredByDefaultInstructionFactory
	) {
		$scope.templateEventList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newTemplateEvent', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(templateEvent) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editTemplateEvent', {
				templateEventId: templateEvent.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getTemplateEventList = function() {
			FindAllTemplateEventsByQueryParamsNonPageableFactory.query(
				{
					eventTypeId: angular.isDefined($scope.eventTypeId) ? $scope.eventTypeId : null,
					defaultDriverId: angular.isDefined($scope.defaultDriverId) ? $scope.defaultDriverId : null,
					defaultSecondDriverId: angular.isDefined($scope.defaultSecondDriverId) ? $scope.defaultSecondDriverId : null,
					defaultSpectatorId: angular.isDefined($scope.defaultSpectatorId) ? $scope.defaultSpectatorId : null,
					defaultInsuranceId: angular.isDefined($scope.defaultInsuranceId) ? $scope.defaultInsuranceId : null,
					defaultHotelId: angular.isDefined($scope.defaultHotelId) ? $scope.defaultHotelId : null,
					defaultFuelId: angular.isDefined($scope.defaultFuelId) ? $scope.defaultFuelId : null,
					defaultInstructionId: angular.isDefined($scope.defaultInstructionId) ? $scope.defaultInstructionId : null,

					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.templateEventList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getTemplateEventList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedTemplateEventId = id;
			$('#deleteTemplateEventConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			TemplateEventFactory.delete(
				{ id: $scope.selectedTemplateEventId },
				function() {
					$scope.loadAll();
					$('#deleteTemplateEventConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteTemplateEventConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('TemplateEventController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		TemplateEventFactory,
		FindAllTemplateEventsByQueryParamsNonPageableFactory,
		NoPagingTemplateEventFactory,
		NoPagingEventTypeFactory,
		NoPagingArticleFactory,
		TemplateEventFindArticleFilteredByDefaultDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSecondDriverFactory,
		TemplateEventFindArticleFilteredByDefaultSpectatorFactory,
		TemplateEventFindArticleFilteredByDefaultInsuranceFactory,
		TemplateEventFindArticleFilteredByDefaultHotelFactory,
		TemplateEventFindArticleFilteredByDefaultFuelFactory,
		TemplateEventFindArticleFilteredByDefaultInstructionFactory
	) {
		$scope.templateEventList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('templateevent.list.new');
		};

		$scope.goToEditState = function(templateEvent) {
			// this overview is NOT mapped, it is the main overview
			$state.go('templateevent.list.edit', { templateEventId: templateEvent.id });
		};

		var getEventTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.eventType)) {
				return $scope.TemplateEventSearchOverview.eventType.id;
			} else {
				return undefined;
			}
		};

		var getDefaultDriverId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.defaultDriver)) {
				return $scope.TemplateEventSearchOverview.defaultDriver.id;
			} else {
				return undefined;
			}
		};

		var getDefaultSecondDriverId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.defaultSecondDriver)) {
				return $scope.TemplateEventSearchOverview.defaultSecondDriver.id;
			} else {
				return undefined;
			}
		};

		var getDefaultSpectatorId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.defaultSpectator)) {
				return $scope.TemplateEventSearchOverview.defaultSpectator.id;
			} else {
				return undefined;
			}
		};

		var getDefaultInsuranceId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.defaultInsurance)) {
				return $scope.TemplateEventSearchOverview.defaultInsurance.id;
			} else {
				return undefined;
			}
		};

		var getDefaultHotelId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.defaultHotel)) {
				return $scope.TemplateEventSearchOverview.defaultHotel.id;
			} else {
				return undefined;
			}
		};

		var getDefaultFuelId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.defaultFuel)) {
				return $scope.TemplateEventSearchOverview.defaultFuel.id;
			} else {
				return undefined;
			}
		};

		var getDefaultInstructionId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.TemplateEventSearchOverview.defaultInstruction)) {
				return $scope.TemplateEventSearchOverview.defaultInstruction.id;
			} else {
				return undefined;
			}
		};

		/**
		 * This function queries all entities of type EventType and checks if this TemplateEvent dialog is called in the context of EventType.
		 * If this is the case, we detect the parent entity TemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryEventType = function() {
			return NoPagingEventTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.eventTypeReferenceFilterList = $scope.queryEventType();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.TemplateEventSearchOverview = angular.copy($scope.TemplateEventSearchOverview);

			FindAllTemplateEventsByQueryParamsNonPageableFactory.query(
				{
					name: $scope.TemplateEventSearchOverview.name,
					eventTypeId: getEventTypeId(),
					defaultDriverId: getDefaultDriverId(),
					defaultSecondDriverId: getDefaultSecondDriverId(),
					defaultSpectatorId: getDefaultSpectatorId(),
					defaultInsuranceId: getDefaultInsuranceId(),
					defaultHotelId: getDefaultHotelId(),
					defaultFuelId: getDefaultFuelId(),
					defaultInstructionId: getDefaultInstructionId(),

					sort: [$scope.TemplateEventSearchOverview.predicate + ',' + ($scope.TemplateEventSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.templateEventList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isTemplateEventSearchOverviewDirty = function() {
			return !angular.equals($scope.TemplateEventSearchOverview, $scope.originalTemplateEventSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.TemplateEventSearchOverview = {};
			$rootScope.TemplateEventSearchOverview.predicate = 'id';
			$rootScope.TemplateEventSearchOverview.ascending = false;

			$scope.TemplateEventSearchOverview = angular.copy($rootScope.TemplateEventSearchOverview);

			$scope.originalTemplateEventSearchOverview = angular.copy($scope.TemplateEventSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.TemplateEventSearchOverview) || $rootScope.TemplateEventSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.TemplateEventSearchOverview = angular.copy($rootScope.TemplateEventSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedTemplateEventId = id;
			$('#deleteTemplateEventConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			TemplateEventFactory.delete(
				{ id: $scope.selectedTemplateEventId },
				function() {
					$scope.search();
					$('#deleteTemplateEventConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteTemplateEventConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.TemplateEventSearchOverview.predicate === itemName) {
				if ($scope.TemplateEventSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('SubscriptionDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		SubscriptionFactory,
		AlertService,
		NoPagingSubscriptionFactory,
		NoPagingSubscriptionTypeFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		BookingFactory,
		NoPagingBookingFactory,
		AutocompleteBookingsByQueryParamsFactory,
		CarFactory,
		NoPagingCarFactory,
		AutocompleteCarsByQueryParamsFactory,
		NoPagingSubscriptionStatusFactory,
		NoPagingArticleFactory,
		NoPagingInstructorFactory,
		NoPagingTemplateEventFactory,
		SubscriptionSaveAndCreateFactory,
		SubscriptionFindArticleFilteredByDriverFactory,
		SubscriptionFindArticleFilteredBySecondDriverFactory,
		SubscriptionFindArticleFilteredBySpectatorFactory,
		SubscriptionFindArticleFilteredByInsuranceFactory,
		SubscriptionFindArticleFilteredByHotelFactory,
		SubscriptionFindArticleFilteredByFuelFactory,
		SubscriptionFindArticleFilteredByRentalCarFactory,
		SubscriptionFindArticleFilteredByInstructionFactory,
		NoPagingSubscriptionByBookingAndSubscriptionTypeFactory,
		NoPagingInstructorByBookingFactory
	) {
		$scope.subscription = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.subscription) && $rootScope.isDefinedAndNotNull($scope.subscription.id);
		};

		$scope.createSubscriptionType = function() {
			var referredBy = {
				refName: 'subscriptionType',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new subscriptionType will add this new subscription state to the history stack
				$state.go('subscription.list.newSubscriptionType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createRelation = function() {
			var referredBy = {
				refName: 'relation',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new relation will add this new subscription state to the history stack
				$state.go('subscription.list.newRelation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createBooking = function() {
			var referredBy = {
				refName: 'booking',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new booking will add this new subscription state to the history stack
				$state.go('subscription.list.newBooking', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createCar = function() {
			var referredBy = {
				refName: 'car',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new car will add this new subscription state to the history stack
				$state.go('subscription.list.newCar', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createStatus = function() {
			var referredBy = {
				refName: 'status',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new status will add this new subscription state to the history stack
				$state.go('subscription.list.newSubscriptionStatus', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createDriver = function() {
			var referredBy = {
				refName: 'driver',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new driver will add this new subscription state to the history stack
				$state.go('subscription.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createSecondDriver = function() {
			var referredBy = {
				refName: 'secondDriver',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new secondDriver will add this new subscription state to the history stack
				$state.go('subscription.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createSpectator = function() {
			var referredBy = {
				refName: 'spectator',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new spectator will add this new subscription state to the history stack
				$state.go('subscription.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createInsurance = function() {
			var referredBy = {
				refName: 'insurance',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new insurance will add this new subscription state to the history stack
				$state.go('subscription.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createHotel = function() {
			var referredBy = {
				refName: 'hotel',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new hotel will add this new subscription state to the history stack
				$state.go('subscription.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createFuel = function() {
			var referredBy = {
				refName: 'fuel',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new fuel will add this new subscription state to the history stack
				$state.go('subscription.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createRelationOf = function() {
			var referredBy = {
				refName: 'relationOf',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new relationOf will add this new subscription state to the history stack
				$state.go('subscription.list.newSubscription', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createInstructor = function() {
			var referredBy = {
				refName: 'instructor',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new instructor will add this new subscription state to the history stack
				$state.go('subscription.list.newInstructor', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createTrainingType = function() {
			var referredBy = {
				refName: 'trainingType',
				data: $scope.subscription,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new trainingType will add this new subscription state to the history stack
				$state.go('subscription.list.newTemplateEvent', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};
		$scope.autocompleteBookings = function(val) {
			var params = {
				bookingTypeAheadSearchString: val,
			};

			return AutocompleteBookingsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};
		$scope.autocompleteCars = function(val) {
			var params = {
				carTypeAheadSearchString: val,
			};

			return AutocompleteCarsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('subscription.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type SubscriptionType and checks if this Subscription dialog is called in the context of SubscriptionType.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySubscriptionType = function() {
			return NoPagingSubscriptionTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'subscriptionType');
			});
		};
		$scope.subscriptionTypeList = $scope.querySubscriptionType();
		// --- end default implementation

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryRelation = function() {
			// If the id of a preselected relation is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'relation');
					}
				});
			}
		};
		$scope.relationList = $scope.queryRelation();

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryBooking = function() {
			// If the id of a preselected booking is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return BookingFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'booking');
					}
				});
			}
		};
		$scope.bookingList = $scope.queryBooking();

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryCar = function() {
			// If the id of a preselected car is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return CarFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'car');
					}
				});
			}
		};
		$scope.carList = $scope.queryCar();

		// --- start default implementation
		/**
		 * This function queries all entities of type Status and checks if this Subscription dialog is called in the context of Status.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryStatus = function() {
			return NoPagingSubscriptionStatusFactory.query(function(result) {
				$scope.findItemByParent(result, 'status');
			});
		};
		$scope.statusList = $scope.queryStatus();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Driver and checks if this Subscription dialog is called in the context of Driver.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDriver = function() {
			return SubscriptionFindArticleFilteredByDriverFactory.query(function(result) {
				$scope.findItemByParent(result, 'driver');
			});
		};
		$scope.driverList = $scope.queryDriver();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type SecondDriver and checks if this Subscription dialog is called in the context of SecondDriver.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySecondDriver = function() {
			return SubscriptionFindArticleFilteredBySecondDriverFactory.query(function(result) {
				$scope.findItemByParent(result, 'secondDriver');
			});
		};
		$scope.secondDriverList = $scope.querySecondDriver();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Spectator and checks if this Subscription dialog is called in the context of Spectator.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySpectator = function() {
			return SubscriptionFindArticleFilteredBySpectatorFactory.query(function(result) {
				$scope.findItemByParent(result, 'spectator');
			});
		};
		$scope.spectatorList = $scope.querySpectator();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Insurance and checks if this Subscription dialog is called in the context of Insurance.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryInsurance = function() {
			return SubscriptionFindArticleFilteredByInsuranceFactory.query(function(result) {
				$scope.findItemByParent(result, 'insurance');
			});
		};
		$scope.insuranceList = $scope.queryInsurance();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Hotel and checks if this Subscription dialog is called in the context of Hotel.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryHotel = function() {
			return SubscriptionFindArticleFilteredByHotelFactory.query(function(result) {
				$scope.findItemByParent(result, 'hotel');
			});
		};
		$scope.hotelList = $scope.queryHotel();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Fuel and checks if this Subscription dialog is called in the context of Fuel.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryFuel = function() {
			return SubscriptionFindArticleFilteredByFuelFactory.query(function(result) {
				$scope.findItemByParent(result, 'fuel');
			});
		};
		$scope.fuelList = $scope.queryFuel();
		// --- end default implementation

		// --- start custom implementation
		// custom method to load the list with all relationOf entries
		$scope.queryRelationOf = function() {
			var bookingId =
				$rootScope.isDefinedAndNotNull($scope.subscription) && $rootScope.isDefinedAndNotNull($scope.subscription.booking)
					? $scope.subscription.booking.id
					: -1;

			// check if creating / editing this subscription happens in the context of a booking (from a sub tab), if so we have to set the booking id from that perspective
			if ($stateParams.mappedBy == 'booking' && $rootScope.isDefinedAndNotNull($stateParams.mappedById)) {
				bookingId = $stateParams.mappedById;
			}

			return NoPagingSubscriptionByBookingAndSubscriptionTypeFactory.query(
				{
					bookingId: bookingId,
					subscriptionType: 'Driver',
				},
				function(result) {
					$scope.findItemByParent(result, 'relationOf');
				}
			);
		};

		// call the method to load all relationOf entries once the controller loads
		$scope.relationOfList = $scope.queryRelationOf();
		// --- end custom implementation

		// --- start custom implementation
		// custom method to load the list with all instructor entries
		$scope.queryInstructor = function() {
			var bookingId =
				$rootScope.isDefinedAndNotNull($scope.subscription) && $rootScope.isDefinedAndNotNull($scope.subscription.booking)
					? $scope.subscription.booking.id
					: -1;

			// check if creating / editing this subscription happens in the context of a booking (from a sub tab), if so we have to set the booking id from that perspective
			if ($stateParams.mappedBy == 'booking' && $rootScope.isDefinedAndNotNull($stateParams.mappedById)) {
				bookingId = $stateParams.mappedById;
			}

			return NoPagingInstructorByBookingFactory.query(
				{
					bookingId: bookingId,
				},
				function(result) {
					$scope.findItemByParent(result, 'instructor');
				}
			);
		};

		// call the method to load all instructor entries once the controller loads
		$scope.instructorList = $scope.queryInstructor();
		// --- end custom implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type TrainingType and checks if this Subscription dialog is called in the context of TrainingType.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTrainingType = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				$scope.findItemByParent(result, 'trainingType');
			});
		};
		$scope.trainingTypeList = $scope.queryTrainingType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type RentalCar and checks if this Subscription dialog is called in the context of RentalCar.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryRentalCar = function() {
			return SubscriptionFindArticleFilteredByRentalCarFactory.query(function(result) {
				$scope.findItemByParent(result, 'rentalCar');
			});
		};
		$scope.rentalCarList = $scope.queryRentalCar();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Instruction and checks if this Subscription dialog is called in the context of Instruction.
		 * If this is the case, we detect the parent entity Subscription and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryInstruction = function() {
			return SubscriptionFindArticleFilteredByInstructionFactory.query(function(result) {
				$scope.findItemByParent(result, 'instruction');
			});
		};
		$scope.instructionList = $scope.queryInstruction();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:subscriptionUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Subscription failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		var onSaveAndNewFinishedCallback = function(result) {
			$scope.$emit('emsApp:subscriptionUpdate', result);
			// the result contains a new entity, but with the copied values from the previous
			$scope.subscription = result;
			$scope.updateDropdownModels();
			$scope.submitButtonIsActive = true;
		};

		$scope.updateDropdownModels = function() {
			$scope.querySubscriptionType();
			$scope.queryRelation();
			$scope.queryBooking();
			$scope.queryCar();
			$scope.queryStatus();
			$scope.queryDriver();
			$scope.querySecondDriver();
			$scope.querySpectator();
			$scope.queryInsurance();
			$scope.queryHotel();
			$scope.queryFuel();
			$scope.queryRelationOf();
			$scope.queryInstructor();
			$scope.queryTrainingType();
			$scope.queryRentalCar();
			$scope.queryInstruction();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.subscription.relation === '') {
				$scope.subscription.relation = null;
			}
			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.subscription.booking === '') {
				$scope.subscription.booking = null;
			}
			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.subscription.car === '') {
				$scope.subscription.car = null;
			}

			if ($scope.subscription.id != null) {
				SubscriptionFactory.update($scope.subscription, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				SubscriptionFactory.save($scope.subscription, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.subscription.relation === '') {
				$scope.subscription.relation = null;
			}
			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.subscription.booking === '') {
				$scope.subscription.booking = null;
			}
			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.subscription.car === '') {
				$scope.subscription.car = null;
			}

			if ($scope.subscription.id != null) {
				SubscriptionSaveAndCreateFactory.updateAndCreate($scope.subscription, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				SubscriptionSaveAndCreateFactory.saveAndCreate($scope.subscription, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('SubscriptionDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.subscription = entity;
	$scope.objectName = 'Subscription';
	$scope.subscriptionId = $stateParams.subscriptionId;

	if (angular.isUndefined($rootScope.subscriptionActiveTab)) {
		//set the default here
		$rootScope.subscriptionActiveTab = 0;
	}

	$scope.goToEditState = function(subscription) {
		$state.go('subscription.detail.edit({subscriptionId:subscription.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:subscriptionUpdate', function(event, result) {
		$scope.subscription = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Subscription'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('subscription'); // main translation loaded for subscription
		$translatePartialLoader.addPart('subscriptiontype'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('booking'); // one to many reference from main entity
		$translatePartialLoader.addPart('bookingstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('confirmationemailstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('car'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity
		$translatePartialLoader.addPart('instructor'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('orderline'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/subscription/subscription-dialog.html';

		return {
			/* new state for entity subscription */
			/* to access: ui-ref="subscription.list.new" */
			/* url: hostname/subscription/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'SubscriptionDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'SubscriptionFactory',
									'NewSubscriptionFactory',
									function(SubscriptionFactory, NewSubscriptionFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Subscription
										// - resuming the creation of a new new Subscription AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return SubscriptionFactory.get({ id: $stateParams.subscriptionId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewSubscriptionFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for subscription new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for subscription edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('subscription', {
		/* abstract state for entity subscription */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/subscription',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Subscriptions',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('subscription.list', {
		/* list state for entity subscription */
		/* to access: ui-ref="subscription.list" */
		/* url: hostname/subscription/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/subscription/subscriptions.html',
				controller: 'SubscriptionController',
			},
		},
	});

	$stateProvider.state('subscription.detail', {
		/* detail state for entity subscription */
		/* to access: ui-sref="subscription.detail" */
		/* url: hostname/subscription/detail/:subscriptionId */
		url: '/detail/:subscriptionId',
		views: {
			'content@': {
				templateUrl: 'app/entities/subscription/subscription-detail.html',
				controller: 'SubscriptionDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'SubscriptionFactory',
				function($stateParams, SubscriptionFactory) {
					return SubscriptionFactory.get({ id: $stateParams.subscriptionId });
				},
			],
		},
	});

	/* url: http://<hostname>/subscription/list/new */
	$stateProvider.state('subscription.list.new', getNewState());
	/* url: http://<hostname>/subscription/list/:subscriptionId/edit */
	$stateProvider.state('subscription.list.edit', getEditState('/:subscriptionId/edit'));
	/* url: http://<hostname>/subscription/detail/:subscriptionId/edit */
	$stateProvider.state('subscription.detail.edit', getEditState('/edit'));
	// Relation.subscription with multiplicity 0..n points to Subscription
	/* url: http://<hostname>/relation/detail/:relationId/subscription/new */
	$stateProvider.state('relation.detail.newSubscription', getNewState('/subscription/new'));
	/* url: http://<hostname>/relation/detail/:relationId/subscription/:subscriptionId/edit */
	$stateProvider.state('relation.detail.editSubscription', getEditState('/subscription/:subscriptionId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/subscription/new */
	$stateProvider.state('user-relation.detail.newSubscription', getNewState('/subscription/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/subscription/:subscriptionId/edit */
	$stateProvider.state('user-relation.detail.editSubscription', getEditState('/subscription/:subscriptionId/edit'));
	// Car.subscription with multiplicity 0..n points to Subscription
	/* url: http://<hostname>/car/detail/:carId/subscription/new */
	$stateProvider.state('car.detail.newSubscription', getNewState('/subscription/new'));
	/* url: http://<hostname>/car/detail/:carId/subscription/:subscriptionId/edit */
	$stateProvider.state('car.detail.editSubscription', getEditState('/subscription/:subscriptionId/edit'));
	// Booking.subscription with multiplicity 0..n points to Subscription
	/* url: http://<hostname>/booking/detail/:bookingId/subscription/new */
	$stateProvider.state('booking.detail.newSubscription', getNewState('/subscription/new'));
	/* url: http://<hostname>/booking/detail/:bookingId/subscription/:subscriptionId/edit */
	$stateProvider.state('booking.detail.editSubscription', getEditState('/subscription/:subscriptionId/edit'));
	// Instructor.subscription with multiplicity 0..n points to Subscription
	/* url: http://<hostname>/instructor/detail/:instructorId/subscription/new */
	$stateProvider.state('instructor.detail.newSubscription', getNewState('/subscription/new'));
	/* url: http://<hostname>/instructor/detail/:instructorId/subscription/:subscriptionId/edit */
	$stateProvider.state('instructor.detail.editSubscription', getEditState('/subscription/:subscriptionId/edit'));

	$stateProvider.state('subscription.list.newSubscription', getNewState('/subscription/new'));
	$stateProvider.state('orderline.list.newSubscription', getNewState('/subscription/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SubscriptionTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SubscriptionFactory,
		FindAllSubscriptionsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		AutocompleteBookingsByQueryParamsFactory,
		AutocompleteCarsByQueryParamsFactory,
		NoPagingSubscriptionFactory,
		NoPagingSubscriptionTypeFactory,
		NoPagingRelationFactory,
		NoPagingBookingFactory,
		NoPagingCarFactory,
		NoPagingSubscriptionStatusFactory,
		NoPagingArticleFactory,
		NoPagingInstructorFactory,
		NoPagingTemplateEventFactory,
		SubscriptionFindArticleFilteredByDriverFactory,
		SubscriptionFindArticleFilteredBySecondDriverFactory,
		SubscriptionFindArticleFilteredBySpectatorFactory,
		SubscriptionFindArticleFilteredByInsuranceFactory,
		SubscriptionFindArticleFilteredByHotelFactory,
		SubscriptionFindArticleFilteredByFuelFactory,
		SubscriptionFindArticleFilteredByRentalCarFactory,
		SubscriptionFindArticleFilteredByInstructionFactory
	) {
		$scope.subscriptionList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSubscription)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSubscription);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSubscription = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newSubscription', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(subscription) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editSubscription', {
				subscriptionId: subscription.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.relationId)) {
				return $scope.relationId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.relation)) {
					return $scope.SubscriptionSearchTab.relation.id;
				} else {
					return undefined;
				}
			}
		};

		var getBookingId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.bookingId)) {
				return $scope.bookingId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.booking)) {
					return $scope.SubscriptionSearchTab.booking.id;
				} else {
					return undefined;
				}
			}
		};

		var getCarId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.carId)) {
				return $scope.carId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.car)) {
					return $scope.SubscriptionSearchTab.car.id;
				} else {
					return undefined;
				}
			}
		};

		var getDriverId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.driverId)) {
				return $scope.driverId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.driver)) {
					return $scope.SubscriptionSearchTab.driver.id;
				} else {
					return undefined;
				}
			}
		};

		var getSecondDriverId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.secondDriverId)) {
				return $scope.secondDriverId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.secondDriver)) {
					return $scope.SubscriptionSearchTab.secondDriver.id;
				} else {
					return undefined;
				}
			}
		};

		var getSpectatorId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.spectatorId)) {
				return $scope.spectatorId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.spectator)) {
					return $scope.SubscriptionSearchTab.spectator.id;
				} else {
					return undefined;
				}
			}
		};

		var getInsuranceId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.insuranceId)) {
				return $scope.insuranceId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.insurance)) {
					return $scope.SubscriptionSearchTab.insurance.id;
				} else {
					return undefined;
				}
			}
		};

		var getHotelId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.hotelId)) {
				return $scope.hotelId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.hotel)) {
					return $scope.SubscriptionSearchTab.hotel.id;
				} else {
					return undefined;
				}
			}
		};

		var getFuelId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.fuelId)) {
				return $scope.fuelId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.fuel)) {
					return $scope.SubscriptionSearchTab.fuel.id;
				} else {
					return undefined;
				}
			}
		};

		var getRelationOfId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.relationOfId)) {
				return $scope.relationOfId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.relationOf)) {
					return $scope.SubscriptionSearchTab.relationOf.id;
				} else {
					return undefined;
				}
			}
		};

		var getInstructorId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.instructorId)) {
				return $scope.instructorId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.instructor)) {
					return $scope.SubscriptionSearchTab.instructor.id;
				} else {
					return undefined;
				}
			}
		};

		var getTrainingTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.trainingTypeId)) {
				return $scope.trainingTypeId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.trainingType)) {
					return $scope.SubscriptionSearchTab.trainingType.id;
				} else {
					return undefined;
				}
			}
		};

		var getRentalCarId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.rentalCarId)) {
				return $scope.rentalCarId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.rentalCar)) {
					return $scope.SubscriptionSearchTab.rentalCar.id;
				} else {
					return undefined;
				}
			}
		};

		var getInstructionId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.instructionId)) {
				return $scope.instructionId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchTab.instruction)) {
					return $scope.SubscriptionSearchTab.instruction.id;
				} else {
					return undefined;
				}
			}
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteBookings = function(val) {
			var params = {
				bookingTypeAheadSearchString: val,
			};

			return AutocompleteBookingsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SubscriptionSearchTab = angular.copy($scope.SubscriptionSearchTab);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSubscription = angular.copy($scope.pageSize);

			FindAllSubscriptionsByQueryParamsFactory.query(
				{
					page: $scope.SubscriptionSearchTab.page - 1,
					size: $scope.pageSize,
					subscriptionType: $scope.SubscriptionSearchTab.subscriptionType,
					relationId: getRelationId(),
					bookingId: getBookingId(),
					carId: getCarId(),
					status: $scope.SubscriptionSearchTab.status,
					driverId: getDriverId(),
					secondDriverId: getSecondDriverId(),
					spectatorId: getSpectatorId(),
					insuranceId: getInsuranceId(),
					hotelId: getHotelId(),
					fuelId: getFuelId(),
					relationOfId: getRelationOfId(),
					instructorId: getInstructorId(),
					trainingTypeId: getTrainingTypeId(),
					rentalCarId: getRentalCarId(),
					instructionId: getInstructionId(),

					sort: [$scope.SubscriptionSearchTab.predicate + ',' + ($scope.SubscriptionSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.subscriptionList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSubscriptionSearchTabDirty = function() {
			return !angular.equals($scope.SubscriptionSearchTab, $scope.originalSubscriptionSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SubscriptionSearchTab = {};
			$rootScope.SubscriptionSearchTab.page = 1;
			$rootScope.SubscriptionSearchTab.predicate = 'description';
			$rootScope.SubscriptionSearchTab.ascending = true;

			$scope.SubscriptionSearchTab = angular.copy($rootScope.SubscriptionSearchTab);

			$scope.originalSubscriptionSearchTab = angular.copy($scope.SubscriptionSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SubscriptionSearchTab) || $rootScope.SubscriptionSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SubscriptionSearchTab = angular.copy($rootScope.SubscriptionSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSubscriptionId = id;
			$('#deleteSubscriptionConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			SubscriptionFactory.delete(
				{ id: $scope.selectedSubscriptionId },
				function() {
					$scope.search();
					$('#deleteSubscriptionConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteSubscriptionConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:subscriptionUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SubscriptionSearchTab.predicate === itemName) {
				if ($scope.SubscriptionSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SubscriptionController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SubscriptionFactory,
		FindAllSubscriptionsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		AutocompleteBookingsByQueryParamsFactory,
		AutocompleteCarsByQueryParamsFactory,
		NoPagingSubscriptionFactory,
		NoPagingSubscriptionTypeFactory,
		NoPagingRelationFactory,
		NoPagingBookingFactory,
		NoPagingCarFactory,
		NoPagingSubscriptionStatusFactory,
		NoPagingArticleFactory,
		NoPagingInstructorFactory,
		NoPagingTemplateEventFactory,
		SubscriptionFindArticleFilteredByDriverFactory,
		SubscriptionFindArticleFilteredBySecondDriverFactory,
		SubscriptionFindArticleFilteredBySpectatorFactory,
		SubscriptionFindArticleFilteredByInsuranceFactory,
		SubscriptionFindArticleFilteredByHotelFactory,
		SubscriptionFindArticleFilteredByFuelFactory,
		SubscriptionFindArticleFilteredByRentalCarFactory,
		SubscriptionFindArticleFilteredByInstructionFactory
	) {
		$scope.subscriptionList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSubscription)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSubscription);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSubscription = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('subscription.list.new');
		};

		$scope.goToEditState = function(subscription) {
			// this overview is NOT mapped, it is the main overview
			$state.go('subscription.list.edit', { subscriptionId: subscription.id });
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.relation)) {
				return $scope.SubscriptionSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		var getBookingId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.booking)) {
				return $scope.SubscriptionSearchOverview.booking.id;
			} else {
				return undefined;
			}
		};

		var getCarId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.car)) {
				return $scope.SubscriptionSearchOverview.car.id;
			} else {
				return undefined;
			}
		};

		var getDriverId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.driver)) {
				return $scope.SubscriptionSearchOverview.driver.id;
			} else {
				return undefined;
			}
		};

		var getSecondDriverId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.secondDriver)) {
				return $scope.SubscriptionSearchOverview.secondDriver.id;
			} else {
				return undefined;
			}
		};

		var getSpectatorId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.spectator)) {
				return $scope.SubscriptionSearchOverview.spectator.id;
			} else {
				return undefined;
			}
		};

		var getInsuranceId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.insurance)) {
				return $scope.SubscriptionSearchOverview.insurance.id;
			} else {
				return undefined;
			}
		};

		var getHotelId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.hotel)) {
				return $scope.SubscriptionSearchOverview.hotel.id;
			} else {
				return undefined;
			}
		};

		var getFuelId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.fuel)) {
				return $scope.SubscriptionSearchOverview.fuel.id;
			} else {
				return undefined;
			}
		};

		var getRelationOfId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.relationOf)) {
				return $scope.SubscriptionSearchOverview.relationOf.id;
			} else {
				return undefined;
			}
		};

		var getInstructorId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.instructor)) {
				return $scope.SubscriptionSearchOverview.instructor.id;
			} else {
				return undefined;
			}
		};

		var getTrainingTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.trainingType)) {
				return $scope.SubscriptionSearchOverview.trainingType.id;
			} else {
				return undefined;
			}
		};

		var getRentalCarId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.rentalCar)) {
				return $scope.SubscriptionSearchOverview.rentalCar.id;
			} else {
				return undefined;
			}
		};

		var getInstructionId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SubscriptionSearchOverview.instruction)) {
				return $scope.SubscriptionSearchOverview.instruction.id;
			} else {
				return undefined;
			}
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteBookings = function(val) {
			var params = {
				bookingTypeAheadSearchString: val,
			};

			return AutocompleteBookingsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SubscriptionSearchOverview = angular.copy($scope.SubscriptionSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSubscription = angular.copy($scope.pageSize);

			FindAllSubscriptionsByQueryParamsFactory.query(
				{
					page: $scope.SubscriptionSearchOverview.page - 1,
					size: $scope.pageSize,
					subscriptionType: $scope.SubscriptionSearchOverview.subscriptionType,
					relationId: getRelationId(),
					bookingId: getBookingId(),
					carId: getCarId(),
					status: $scope.SubscriptionSearchOverview.status,
					driverId: getDriverId(),
					secondDriverId: getSecondDriverId(),
					spectatorId: getSpectatorId(),
					insuranceId: getInsuranceId(),
					hotelId: getHotelId(),
					fuelId: getFuelId(),
					relationOfId: getRelationOfId(),
					instructorId: getInstructorId(),
					trainingTypeId: getTrainingTypeId(),
					rentalCarId: getRentalCarId(),
					instructionId: getInstructionId(),

					sort: [$scope.SubscriptionSearchOverview.predicate + ',' + ($scope.SubscriptionSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.subscriptionList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSubscriptionSearchOverviewDirty = function() {
			return !angular.equals($scope.SubscriptionSearchOverview, $scope.originalSubscriptionSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SubscriptionSearchOverview = {};
			$rootScope.SubscriptionSearchOverview.page = 1;
			$rootScope.SubscriptionSearchOverview.predicate = 'description';
			$rootScope.SubscriptionSearchOverview.ascending = true;

			$scope.SubscriptionSearchOverview = angular.copy($rootScope.SubscriptionSearchOverview);

			$scope.originalSubscriptionSearchOverview = angular.copy($scope.SubscriptionSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SubscriptionSearchOverview) || $rootScope.SubscriptionSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SubscriptionSearchOverview = angular.copy($rootScope.SubscriptionSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSubscriptionId = id;
			$('#deleteSubscriptionConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			SubscriptionFactory.delete(
				{ id: $scope.selectedSubscriptionId },
				function() {
					$scope.search();
					$('#deleteSubscriptionConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteSubscriptionConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:subscriptionUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SubscriptionSearchOverview.predicate === itemName) {
				if ($scope.SubscriptionSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterTemplateEventListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterTemplateEventFactory,
		UserSalesFilterTemplateEventListDtoSearchFactory,
		UserSalesFilterTemplateEventViewDtoFactory
	) {
		$scope.salesFilterTemplateEventList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterTemplateEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterTemplateEvent);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-salesfiltertemplateevent.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getSalesFilterTemplateEventList = function() {
			UserSalesFilterTemplateEventListDtoSearchFactory.query(
				{
					salesFilterId: angular.isDefined($scope.salesFilterId) ? $scope.salesFilterId : null,
					templateEventId: angular.isDefined($scope.templateEventId) ? $scope.templateEventId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterTemplateEventList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterTemplateEventList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterTemplateEventListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterTemplateEventFactory,
		UserSalesFilterTemplateEventListDtoSearchFactory,
		UserSalesFilterTemplateEventViewDtoFactory
	) {
		$scope.salesFilterTemplateEventList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterTemplateEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterTemplateEvent);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-salesfiltertemplateevent.new');
		};

		var getSalesFilterId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterTemplateEventSearchOverview.salesFilter)) {
				return $scope.SalesFilterTemplateEventSearchOverview.salesFilter.id;
			} else {
				return undefined;
			}
		};

		var getTemplateEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterTemplateEventSearchOverview.templateEvent)) {
				return $scope.SalesFilterTemplateEventSearchOverview.templateEvent.id;
			} else {
				return undefined;
			}
		};

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterTemplateEventSearchOverview = angular.copy($scope.SalesFilterTemplateEventSearchOverview);

			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);

			UserSalesFilterTemplateEventListDtoSearchFactory.query(
				{
					page: $scope.SalesFilterTemplateEventSearchOverview.page - 1,
					size: $scope.pageSize,
					salesFilterId: getSalesFilterId(),
					templateEventId: getTemplateEventId(),

					sort: [
						$scope.SalesFilterTemplateEventSearchOverview.predicate +
							',' +
							($scope.SalesFilterTemplateEventSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterTemplateEventList = result.items;

					$scope.salesFilterReferenceFilterList = result.salesFilterSearchOptions;

					$scope.templateEventReferenceFilterList = result.templateEventSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterTemplateEventSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterTemplateEventSearchOverview, $scope.originalSalesFilterTemplateEventSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterTemplateEventSearchOverview = {};
			$rootScope.SalesFilterTemplateEventSearchOverview.page = 1;
			$rootScope.SalesFilterTemplateEventSearchOverview.predicate = 'id';
			$rootScope.SalesFilterTemplateEventSearchOverview.ascending = false;

			$scope.SalesFilterTemplateEventSearchOverview = angular.copy($rootScope.SalesFilterTemplateEventSearchOverview);

			$scope.originalSalesFilterTemplateEventSearchOverview = angular.copy($scope.SalesFilterTemplateEventSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (
				angular.isUndefined($rootScope.SalesFilterTemplateEventSearchOverview) ||
				$rootScope.SalesFilterTemplateEventSearchOverview === null
			) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterTemplateEventSearchOverview = angular.copy($rootScope.SalesFilterTemplateEventSearchOverview);

			$scope.search();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterTemplateEventSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterTemplateEventSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('SalesFilterTemplateEventDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		SalesFilterTemplateEventFactory,
		AlertService,
		NoPagingSalesFilterTemplateEventFactory,
		NoPagingSalesFilterFactory,
		NoPagingTemplateEventFactory
	) {
		$scope.salesFilterTemplateEvent = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return (
				$rootScope.isDefinedAndNotNull($scope.salesFilterTemplateEvent) &&
				$rootScope.isDefinedAndNotNull($scope.salesFilterTemplateEvent.id)
			);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('salesFilterTemplateEvent.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type SalesFilter and checks if this SalesFilterTemplateEvent dialog is called in the context of SalesFilter.
		 * If this is the case, we detect the parent entity SalesFilterTemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySalesFilter = function() {
			return NoPagingSalesFilterFactory.query(function(result) {
				$scope.findItemByParent(result, 'salesFilter');
			});
		};
		$scope.salesFilterList = $scope.querySalesFilter();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type TemplateEvent and checks if this SalesFilterTemplateEvent dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity SalesFilterTemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				$scope.findItemByParent(result, 'templateEvent');
			});
		};
		$scope.templateEventList = $scope.queryTemplateEvent();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:salesFilterTemplateEventUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving SalesFilterTemplateEvent failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.salesFilterTemplateEvent.id != null) {
				SalesFilterTemplateEventFactory.update($scope.salesFilterTemplateEvent, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				SalesFilterTemplateEventFactory.save($scope.salesFilterTemplateEvent, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('SalesFilterTemplateEventDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.salesFilterTemplateEvent = entity;
	$scope.objectName = 'SalesFilterTemplateEvent';
	$scope.salesFilterTemplateEventId = $stateParams.salesFilterTemplateEventId;

	if (angular.isUndefined($rootScope.salesFilterTemplateEventActiveTab)) {
		//set the default here
		$rootScope.salesFilterTemplateEventActiveTab = 0;
	}

	$scope.goToEditState = function(salesFilterTemplateEvent) {
		$state.go(
			'salesfiltertemplateevent.detail.edit({salesFilterTemplateEventId:salesFilterTemplateEvent.id, mappedBy:mappedBy, mappedById:mappedById})'
		);
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:salesFilterTemplateEventUpdate', function(event, result) {
		$scope.salesFilterTemplateEvent = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'SalesFilterTemplateEvent'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('salesfiltertemplateevent'); // main translation loaded for salesfiltertemplateevent
		$translatePartialLoader.addPart('salesfilter'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfilter'); // coupling entity reference loaded for salesfilter
		$translatePartialLoader.addPart('templateevent'); // coupling entity reference loaded for templateevent

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-dialog.html';

		return {
			/* new state for entity salesFilterTemplateEvent */
			/* to access: ui-ref="salesfiltertemplateevent.list.new" */
			/* url: hostname/salesfiltertemplateevent/new */
			url: url,
			data: {
				authorities: [],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'SalesFilterTemplateEventDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'SalesFilterTemplateEventFactory',
									'NewSalesFilterTemplateEventFactory',
									function(SalesFilterTemplateEventFactory, NewSalesFilterTemplateEventFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new SalesFilterTemplateEvent
										// - resuming the creation of a new new SalesFilterTemplateEvent AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return SalesFilterTemplateEventFactory.get({ id: $stateParams.salesFilterTemplateEventId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewSalesFilterTemplateEventFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for salesFilterTemplateEvent new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for salesFilterTemplateEvent edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('salesfiltertemplateevent', {
		/* abstract state for entity salesFilterTemplateEvent */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/salesfiltertemplateevent',
		data: {
			authorities: [],
			pageTitle: 'SalesFilterTemplateEvents',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('salesfiltertemplateevent.list', {
		/* list state for entity salesFilterTemplateEvent */
		/* to access: ui-ref="salesfiltertemplateevent.list" */
		/* url: hostname/salesfiltertemplateevent/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevents.html',
				controller: 'SalesFilterTemplateEventController',
			},
		},
	});

	$stateProvider.state('salesfiltertemplateevent.detail', {
		/* detail state for entity salesFilterTemplateEvent */
		/* to access: ui-sref="salesfiltertemplateevent.detail" */
		/* url: hostname/salesfiltertemplateevent/detail/:salesFilterTemplateEventId */
		url: '/detail/:salesFilterTemplateEventId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-detail.html',
				controller: 'SalesFilterTemplateEventDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'SalesFilterTemplateEventFactory',
				function($stateParams, SalesFilterTemplateEventFactory) {
					return SalesFilterTemplateEventFactory.get({ id: $stateParams.salesFilterTemplateEventId });
				},
			],
		},
	});

	$stateProvider.state('user-salesfiltertemplateevent', {
		/* abstract state for DTO UserSalesFilterTemplateEventListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/salesfiltertemplateevent',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'SalesFilterTemplateEvent',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserSalesFilterTemplateEventListDto */
		/* to access: ui-ref="user-salesfiltertemplateevent.list" */
		/* url: http://<hostname>/user/salesfiltertemplateevent/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-list-user.html',
				controller: 'UserSalesFilterTemplateEventListDtoController',
			},
		},
	};

	$stateProvider.state('user-salesfiltertemplateevent.list', dtoListState);
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterTemplateEventTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterTemplateEventFactory,
		FindAllSalesFilterTemplateEventsByQueryParamsFactory,
		NoPagingSalesFilterTemplateEventFactory,
		NoPagingSalesFilterFactory,
		NoPagingTemplateEventFactory
	) {
		$scope.salesFilterTemplateEventList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterTemplateEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterTemplateEvent);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newSalesFilterTemplateEvent', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(salesFilterTemplateEvent) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editSalesFilterTemplateEvent', {
				salesFilterTemplateEventId: salesFilterTemplateEvent.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getSalesFilterTemplateEventList = function() {
			FindAllSalesFilterTemplateEventsByQueryParamsFactory.query(
				{
					salesFilterId: angular.isDefined($scope.salesFilterId) ? $scope.salesFilterId : null,
					templateEventId: angular.isDefined($scope.templateEventId) ? $scope.templateEventId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterTemplateEventList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterTemplateEventList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterTemplateEventController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterTemplateEventFactory,
		FindAllSalesFilterTemplateEventsByQueryParamsFactory,
		NoPagingSalesFilterTemplateEventFactory,
		NoPagingSalesFilterFactory,
		NoPagingTemplateEventFactory
	) {
		$scope.salesFilterTemplateEventList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterTemplateEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterTemplateEvent);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfiltertemplateevent.list.new');
		};

		$scope.goToEditState = function(salesFilterTemplateEvent) {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfiltertemplateevent.list.edit', { salesFilterTemplateEventId: salesFilterTemplateEvent.id });
		};

		var getSalesFilterId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterTemplateEventSearchOverview.salesFilter)) {
				return $scope.SalesFilterTemplateEventSearchOverview.salesFilter.id;
			} else {
				return undefined;
			}
		};

		var getTemplateEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterTemplateEventSearchOverview.templateEvent)) {
				return $scope.SalesFilterTemplateEventSearchOverview.templateEvent.id;
			} else {
				return undefined;
			}
		};

		/**
		 * This function queries all entities of type SalesFilter and checks if this SalesFilterTemplateEvent dialog is called in the context of SalesFilter.
		 * If this is the case, we detect the parent entity SalesFilterTemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySalesFilter = function() {
			return NoPagingSalesFilterFactory.query(function(result) {
				return result;
			});
		};
		$scope.salesFilterReferenceFilterList = $scope.querySalesFilter();

		/**
		 * This function queries all entities of type TemplateEvent and checks if this SalesFilterTemplateEvent dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity SalesFilterTemplateEvent and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				return result;
			});
		};
		$scope.templateEventReferenceFilterList = $scope.queryTemplateEvent();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterTemplateEventSearchOverview = angular.copy($scope.SalesFilterTemplateEventSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterTemplateEvent = angular.copy($scope.pageSize);

			FindAllSalesFilterTemplateEventsByQueryParamsFactory.query(
				{
					page: $scope.SalesFilterTemplateEventSearchOverview.page - 1,
					size: $scope.pageSize,
					salesFilterId: getSalesFilterId(),
					templateEventId: getTemplateEventId(),

					sort: [
						$scope.SalesFilterTemplateEventSearchOverview.predicate +
							',' +
							($scope.SalesFilterTemplateEventSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterTemplateEventList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterTemplateEventSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterTemplateEventSearchOverview, $scope.originalSalesFilterTemplateEventSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterTemplateEventSearchOverview = {};
			$rootScope.SalesFilterTemplateEventSearchOverview.page = 1;
			$rootScope.SalesFilterTemplateEventSearchOverview.predicate = 'id';
			$rootScope.SalesFilterTemplateEventSearchOverview.ascending = false;

			$scope.SalesFilterTemplateEventSearchOverview = angular.copy($rootScope.SalesFilterTemplateEventSearchOverview);

			$scope.originalSalesFilterTemplateEventSearchOverview = angular.copy($scope.SalesFilterTemplateEventSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (
				angular.isUndefined($rootScope.SalesFilterTemplateEventSearchOverview) ||
				$rootScope.SalesFilterTemplateEventSearchOverview === null
			) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterTemplateEventSearchOverview = angular.copy($rootScope.SalesFilterTemplateEventSearchOverview);
			$scope.search();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterTemplateEventSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterTemplateEventSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterEventTypeListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterEventTypeFactory,
		UserSalesFilterEventTypeListDtoSearchFactory,
		UserSalesFilterEventTypeViewDtoFactory
	) {
		$scope.salesFilterEventTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterEventType)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterEventType);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-salesfiltereventtype.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getSalesFilterEventTypeList = function() {
			UserSalesFilterEventTypeListDtoSearchFactory.query(
				{
					salesFilterId: angular.isDefined($scope.salesFilterId) ? $scope.salesFilterId : null,
					eventTypeId: angular.isDefined($scope.eventTypeId) ? $scope.eventTypeId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterEventTypeList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterEventTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterEventTypeListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterEventTypeFactory,
		UserSalesFilterEventTypeListDtoSearchFactory,
		UserSalesFilterEventTypeViewDtoFactory
	) {
		$scope.salesFilterEventTypeList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterEventType)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterEventType);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-salesfiltereventtype.new');
		};

		var getSalesFilterId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterEventTypeSearchOverview.salesFilter)) {
				return $scope.SalesFilterEventTypeSearchOverview.salesFilter.id;
			} else {
				return undefined;
			}
		};

		var getEventTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterEventTypeSearchOverview.eventType)) {
				return $scope.SalesFilterEventTypeSearchOverview.eventType.id;
			} else {
				return undefined;
			}
		};

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterEventTypeSearchOverview = angular.copy($scope.SalesFilterEventTypeSearchOverview);

			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);

			UserSalesFilterEventTypeListDtoSearchFactory.query(
				{
					page: $scope.SalesFilterEventTypeSearchOverview.page - 1,
					size: $scope.pageSize,
					salesFilterId: getSalesFilterId(),
					eventTypeId: getEventTypeId(),

					sort: [
						$scope.SalesFilterEventTypeSearchOverview.predicate +
							',' +
							($scope.SalesFilterEventTypeSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterEventTypeList = result.items;

					$scope.salesFilterReferenceFilterList = result.salesFilterSearchOptions;

					$scope.eventTypeReferenceFilterList = result.eventTypeSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterEventTypeSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterEventTypeSearchOverview, $scope.originalSalesFilterEventTypeSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterEventTypeSearchOverview = {};
			$rootScope.SalesFilterEventTypeSearchOverview.page = 1;
			$rootScope.SalesFilterEventTypeSearchOverview.predicate = 'id';
			$rootScope.SalesFilterEventTypeSearchOverview.ascending = false;

			$scope.SalesFilterEventTypeSearchOverview = angular.copy($rootScope.SalesFilterEventTypeSearchOverview);

			$scope.originalSalesFilterEventTypeSearchOverview = angular.copy($scope.SalesFilterEventTypeSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SalesFilterEventTypeSearchOverview) || $rootScope.SalesFilterEventTypeSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterEventTypeSearchOverview = angular.copy($rootScope.SalesFilterEventTypeSearchOverview);

			$scope.search();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterEventTypeSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterEventTypeSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('SalesFilterEventTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		SalesFilterEventTypeFactory,
		AlertService,
		NoPagingSalesFilterEventTypeFactory,
		NoPagingSalesFilterFactory,
		NoPagingEventTypeFactory
	) {
		$scope.salesFilterEventType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.salesFilterEventType) && $rootScope.isDefinedAndNotNull($scope.salesFilterEventType.id);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('salesFilterEventType.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type SalesFilter and checks if this SalesFilterEventType dialog is called in the context of SalesFilter.
		 * If this is the case, we detect the parent entity SalesFilterEventType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySalesFilter = function() {
			return NoPagingSalesFilterFactory.query(function(result) {
				$scope.findItemByParent(result, 'salesFilter');
			});
		};
		$scope.salesFilterList = $scope.querySalesFilter();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type EventType and checks if this SalesFilterEventType dialog is called in the context of EventType.
		 * If this is the case, we detect the parent entity SalesFilterEventType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryEventType = function() {
			return NoPagingEventTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'eventType');
			});
		};
		$scope.eventTypeList = $scope.queryEventType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:salesFilterEventTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving SalesFilterEventType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.salesFilterEventType.id != null) {
				SalesFilterEventTypeFactory.update($scope.salesFilterEventType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				SalesFilterEventTypeFactory.save($scope.salesFilterEventType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('SalesFilterEventTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.salesFilterEventType = entity;
	$scope.objectName = 'SalesFilterEventType';
	$scope.salesFilterEventTypeId = $stateParams.salesFilterEventTypeId;

	if (angular.isUndefined($rootScope.salesFilterEventTypeActiveTab)) {
		//set the default here
		$rootScope.salesFilterEventTypeActiveTab = 0;
	}

	$scope.goToEditState = function(salesFilterEventType) {
		$state.go(
			'salesfiltereventtype.detail.edit({salesFilterEventTypeId:salesFilterEventType.id, mappedBy:mappedBy, mappedById:mappedById})'
		);
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:salesFilterEventTypeUpdate', function(event, result) {
		$scope.salesFilterEventType = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'SalesFilterEventType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('salesfiltereventtype'); // main translation loaded for salesfiltereventtype
		$translatePartialLoader.addPart('salesfilter'); // one to many reference from main entity
		$translatePartialLoader.addPart('eventtype'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfilter'); // coupling entity reference loaded for salesfilter
		$translatePartialLoader.addPart('eventtype'); // coupling entity reference loaded for eventtype

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/salesfiltereventtype/salesfiltereventtype-dialog.html';

		return {
			/* new state for entity salesFilterEventType */
			/* to access: ui-ref="salesfiltereventtype.list.new" */
			/* url: hostname/salesfiltereventtype/new */
			url: url,
			data: {
				authorities: [],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'SalesFilterEventTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'SalesFilterEventTypeFactory',
									'NewSalesFilterEventTypeFactory',
									function(SalesFilterEventTypeFactory, NewSalesFilterEventTypeFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new SalesFilterEventType
										// - resuming the creation of a new new SalesFilterEventType AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return SalesFilterEventTypeFactory.get({ id: $stateParams.salesFilterEventTypeId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewSalesFilterEventTypeFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for salesFilterEventType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for salesFilterEventType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('salesfiltereventtype', {
		/* abstract state for entity salesFilterEventType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/salesfiltereventtype',
		data: {
			authorities: [],
			pageTitle: 'SalesFilterEventTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('salesfiltereventtype.list', {
		/* list state for entity salesFilterEventType */
		/* to access: ui-ref="salesfiltereventtype.list" */
		/* url: hostname/salesfiltereventtype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtypes.html',
				controller: 'SalesFilterEventTypeController',
			},
		},
	});

	$stateProvider.state('salesfiltereventtype.detail', {
		/* detail state for entity salesFilterEventType */
		/* to access: ui-sref="salesfiltereventtype.detail" */
		/* url: hostname/salesfiltereventtype/detail/:salesFilterEventTypeId */
		url: '/detail/:salesFilterEventTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-detail.html',
				controller: 'SalesFilterEventTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'SalesFilterEventTypeFactory',
				function($stateParams, SalesFilterEventTypeFactory) {
					return SalesFilterEventTypeFactory.get({ id: $stateParams.salesFilterEventTypeId });
				},
			],
		},
	});

	$stateProvider.state('user-salesfiltereventtype', {
		/* abstract state for DTO UserSalesFilterEventTypeListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/salesfiltereventtype',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'SalesFilterEventType',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserSalesFilterEventTypeListDto */
		/* to access: ui-ref="user-salesfiltereventtype.list" */
		/* url: http://<hostname>/user/salesfiltereventtype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-list-user.html',
				controller: 'UserSalesFilterEventTypeListDtoController',
			},
		},
	};

	$stateProvider.state('user-salesfiltereventtype.list', dtoListState);
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterEventTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterEventTypeFactory,
		FindAllSalesFilterEventTypesByQueryParamsFactory,
		NoPagingSalesFilterEventTypeFactory,
		NoPagingSalesFilterFactory,
		NoPagingEventTypeFactory
	) {
		$scope.salesFilterEventTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterEventType)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterEventType);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newSalesFilterEventType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(salesFilterEventType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editSalesFilterEventType', {
				salesFilterEventTypeId: salesFilterEventType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getSalesFilterEventTypeList = function() {
			FindAllSalesFilterEventTypesByQueryParamsFactory.query(
				{
					salesFilterId: angular.isDefined($scope.salesFilterId) ? $scope.salesFilterId : null,
					eventTypeId: angular.isDefined($scope.eventTypeId) ? $scope.eventTypeId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterEventTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterEventTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterEventTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterEventTypeFactory,
		FindAllSalesFilterEventTypesByQueryParamsFactory,
		NoPagingSalesFilterEventTypeFactory,
		NoPagingSalesFilterFactory,
		NoPagingEventTypeFactory
	) {
		$scope.salesFilterEventTypeList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterEventType)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterEventType);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfiltereventtype.list.new');
		};

		$scope.goToEditState = function(salesFilterEventType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfiltereventtype.list.edit', { salesFilterEventTypeId: salesFilterEventType.id });
		};

		var getSalesFilterId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterEventTypeSearchOverview.salesFilter)) {
				return $scope.SalesFilterEventTypeSearchOverview.salesFilter.id;
			} else {
				return undefined;
			}
		};

		var getEventTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterEventTypeSearchOverview.eventType)) {
				return $scope.SalesFilterEventTypeSearchOverview.eventType.id;
			} else {
				return undefined;
			}
		};

		/**
		 * This function queries all entities of type SalesFilter and checks if this SalesFilterEventType dialog is called in the context of SalesFilter.
		 * If this is the case, we detect the parent entity SalesFilterEventType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySalesFilter = function() {
			return NoPagingSalesFilterFactory.query(function(result) {
				return result;
			});
		};
		$scope.salesFilterReferenceFilterList = $scope.querySalesFilter();

		/**
		 * This function queries all entities of type EventType and checks if this SalesFilterEventType dialog is called in the context of EventType.
		 * If this is the case, we detect the parent entity SalesFilterEventType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryEventType = function() {
			return NoPagingEventTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.eventTypeReferenceFilterList = $scope.queryEventType();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterEventTypeSearchOverview = angular.copy($scope.SalesFilterEventTypeSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);

			FindAllSalesFilterEventTypesByQueryParamsFactory.query(
				{
					page: $scope.SalesFilterEventTypeSearchOverview.page - 1,
					size: $scope.pageSize,
					salesFilterId: getSalesFilterId(),
					eventTypeId: getEventTypeId(),

					sort: [
						$scope.SalesFilterEventTypeSearchOverview.predicate +
							',' +
							($scope.SalesFilterEventTypeSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterEventTypeList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterEventTypeSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterEventTypeSearchOverview, $scope.originalSalesFilterEventTypeSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterEventTypeSearchOverview = {};
			$rootScope.SalesFilterEventTypeSearchOverview.page = 1;
			$rootScope.SalesFilterEventTypeSearchOverview.predicate = 'id';
			$rootScope.SalesFilterEventTypeSearchOverview.ascending = false;

			$scope.SalesFilterEventTypeSearchOverview = angular.copy($rootScope.SalesFilterEventTypeSearchOverview);

			$scope.originalSalesFilterEventTypeSearchOverview = angular.copy($scope.SalesFilterEventTypeSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SalesFilterEventTypeSearchOverview) || $rootScope.SalesFilterEventTypeSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterEventTypeSearchOverview = angular.copy($rootScope.SalesFilterEventTypeSearchOverview);
			$scope.search();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterEventTypeSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterEventTypeSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterFactory,
		UserSalesFilterListDtoSearchFactory,
		UserSalesFilterViewDtoFactory
	) {
		$scope.salesFilterList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilter)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilter);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-salesfilter.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getSalesFilterList = function() {
			UserSalesFilterListDtoSearchFactory.query(
				{
					salesStatus: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,
					userId: angular.isDefined($scope.userId) ? $scope.userId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSalesFilterId = id;
			$('#deleteSalesFilterConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserSalesFilterViewDtoFactory.delete(
				{ id: $scope.selectedSalesFilterId },
				function() {
					$scope.loadAll();
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterFactory,
		UserSalesFilterListDtoSearchFactory,
		UserSalesFilterViewDtoFactory
	) {
		$scope.salesFilterList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilter)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilter);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-salesfilter.new');
		};

		var getUserId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterSearchOverview.user)) {
				return $scope.SalesFilterSearchOverview.user.id;
			} else {
				return undefined;
			}
		};

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterSearchOverview = angular.copy($scope.SalesFilterSearchOverview);

			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);

			UserSalesFilterListDtoSearchFactory.query(
				{
					page: $scope.SalesFilterSearchOverview.page - 1,
					size: $scope.pageSize,
					description: $scope.SalesFilterSearchOverview.description,
					firstName: $scope.SalesFilterSearchOverview.firstName,
					lastName: $scope.SalesFilterSearchOverview.lastName,
					potentialFromFrom: $scope.SalesFilterSearchOverview.potentialFromFrom,
					potentialFromTo: $scope.SalesFilterSearchOverview.potentialFromTo,
					potentialToFrom: $scope.SalesFilterSearchOverview.potentialToFrom,
					potentialToTo: $scope.SalesFilterSearchOverview.potentialToTo,
					offsetStartDateFromFrom: $scope.SalesFilterSearchOverview.offsetStartDateFromFrom,
					offsetStartDateFromTo: $scope.SalesFilterSearchOverview.offsetStartDateFromTo,
					offsetStartDateToFrom: $scope.SalesFilterSearchOverview.offsetStartDateToFrom,
					offsetStartDateToTo: $scope.SalesFilterSearchOverview.offsetStartDateToTo,
					salesStatus: $scope.SalesFilterSearchOverview.salesStatus,
					userId: getUserId(),

					sort: [$scope.SalesFilterSearchOverview.predicate + ',' + ($scope.SalesFilterSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterList = result.items;

					$scope.salesStatusList = result.salesStatusSearchOptions;

					$scope.userReferenceFilterList = result.userSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterSearchOverview, $scope.originalSalesFilterSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterSearchOverview = {};
			$rootScope.SalesFilterSearchOverview.page = 1;
			$rootScope.SalesFilterSearchOverview.predicate = 'id';
			$rootScope.SalesFilterSearchOverview.ascending = false;

			$scope.SalesFilterSearchOverview = angular.copy($rootScope.SalesFilterSearchOverview);

			$scope.originalSalesFilterSearchOverview = angular.copy($scope.SalesFilterSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SalesFilterSearchOverview) || $rootScope.SalesFilterSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterSearchOverview = angular.copy($rootScope.SalesFilterSearchOverview);

			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSalesFilterId = id;
			$('#deleteSalesFilterConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserSalesFilterViewDtoFactory.delete(
				{ id: $scope.selectedSalesFilterId },
				function() {
					$scope.search();
					$('#deleteSalesFilterConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteSalesFilterConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

// Created by frontend/angular/entity/controller/dto-edit.ftl
angular
	.module('emsApp')
	.controller('UserSalesFilterEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserSalesFilterEditDtoFactory,
		AlertService,
		HistoryService
	) {
		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.submitButtonIsActive = true;
		};

		$scope.salesFilter = entity;
		$scope.submitButtonIsActive = true;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		//This function preselects and disables the parent reference when called from tab
		$scope.salesFilter['selected' + _.upperFirst($stateParams.mappedBy)] = {
			id: $stateParams.mappedById,
			displayValue: $stateParams.mappedByDisplayValue,
		};

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.salesFilter) && $rootScope.isDefinedAndNotNull($scope.salesFilter.id);
		};

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:salesFilterUpdate', result);
			$scope.submitButtonIsActive = true;
			$rootScope.back();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;
			UserSalesFilterEditDtoFactory.update($scope.salesFilter, onSaveFinishedCallback, saveOrUpdateErrorCallback);
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('SalesFilterDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		SalesFilterFactory,
		AlertService,
		NoPagingSalesFilterFactory,
		NoPagingSalesStatusFactory,
		NoPagingUserFactory,
		EventTypeFromSalesFilterEventTypePicklistUpdateFactory,
		NoPagingEventTypeFactory,
		TemplateEventFromSalesFilterTemplateEventPicklistUpdateFactory,
		NoPagingTemplateEventFactory
	) {
		$scope.salesFilter = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.salesFilter) && $rootScope.isDefinedAndNotNull($scope.salesFilter.id);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('salesFilter.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type SalesStatus and checks if this SalesFilter dialog is called in the context of SalesStatus.
		 * If this is the case, we detect the parent entity SalesFilter and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySalesStatus = function() {
			return NoPagingSalesStatusFactory.query(function(result) {
				$scope.findItemByParent(result, 'salesStatus');
			});
		};
		$scope.salesStatusList = $scope.querySalesStatus();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type User and checks if this SalesFilter dialog is called in the context of User.
		 * If this is the case, we detect the parent entity SalesFilter and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryUser = function() {
			return NoPagingUserFactory.query(function(result) {
				$scope.findItemByParent(result, 'user');
			});
		};
		$scope.userList = $scope.queryUser();
		// --- end default implementation

		var getSelectedListItems = function(allItems, selectedItemList) {
			var itemIDs = [];
			angular.forEach(selectedItemList, function(value, key) {
				itemIDs.push(value.id);
			});

			var selectedItems = [];
			angular.forEach(allItems, function(value, key) {
				angular.forEach(itemIDs, function(value2, key2) {
					if (value.id === value2) {
						selectedItems.push(value);
					}
				});
			});

			return selectedItems;
		};

		var tempSelectedEventTypeList = [];
		$scope.selectedEventTypeList = [];

		$scope.getSelectedEventTypeList = function() {
			EventTypeFromSalesFilterEventTypePicklistUpdateFactory.query({ id: $stateParams.salesFilterId }, function(result) {
				//put all selected EventType-items in a list
				angular.forEach(result, function(value, key) {
					tempSelectedEventTypeList.push(value);
				});
				NoPagingEventTypeFactory.query(function(result) {
					$scope.eventTypePickListOptions = result;
					$scope.selectedEventTypeList = getSelectedListItems(result, tempSelectedEventTypeList);
				});
			});
		};

		$scope.getEventTypePickListOptions = function() {
			if ($stateParams.salesFilterId != null) {
				$scope.getSelectedEventTypeList();
			} else {
				NoPagingEventTypeFactory.query(function(result) {
					$scope.eventTypePickListOptions = result;
				});
			}
		};

		$scope.getEventTypePickListOptions();

		var tempSelectedTemplateEventList = [];
		$scope.selectedTemplateEventList = [];

		$scope.getSelectedTemplateEventList = function() {
			TemplateEventFromSalesFilterTemplateEventPicklistUpdateFactory.query({ id: $stateParams.salesFilterId }, function(result) {
				//put all selected TemplateEvent-items in a list
				angular.forEach(result, function(value, key) {
					tempSelectedTemplateEventList.push(value);
				});
				NoPagingTemplateEventFactory.query(function(result) {
					$scope.templateEventPickListOptions = result;
					$scope.selectedTemplateEventList = getSelectedListItems(result, tempSelectedTemplateEventList);
				});
			});
		};

		$scope.getTemplateEventPickListOptions = function() {
			if ($stateParams.salesFilterId != null) {
				$scope.getSelectedTemplateEventList();
			} else {
				NoPagingTemplateEventFactory.query(function(result) {
					$scope.templateEventPickListOptions = result;
				});
			}
		};

		$scope.getTemplateEventPickListOptions();

		var onUpdateTemplateEventListUpdateCallback = function(result) {
			TemplateEventFromSalesFilterTemplateEventPicklistUpdateFactory.update(
				{ id: $scope.salesFilter.id },
				$scope.selectedTemplateEventList,
				onSaveFinishedCallback
			);
		};

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:salesFilterUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving SalesFilter failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.salesFilter.id != null) {
				SalesFilterFactory.update(
					$scope.salesFilter,
					function(result) {
						$scope.salesFilter = result;
						EventTypeFromSalesFilterEventTypePicklistUpdateFactory.update(
							{ id: result.id },
							$scope.selectedEventTypeList,
							function(successResult) {
								onUpdateTemplateEventListUpdateCallback();
							},
							function(error) {
								AlertService.error(error.data.message, error.data.params);
							}
						);
					},
					saveOrUpdateErrorCallback
				);
			} else {
				SalesFilterFactory.save(
					$scope.salesFilter,
					function(result) {
						$scope.salesFilter = result;
						EventTypeFromSalesFilterEventTypePicklistUpdateFactory.update(
							{ id: result.id },
							$scope.selectedEventTypeList,
							function(successResult) {
								onUpdateTemplateEventListUpdateCallback();
							},
							function(error) {
								AlertService.error(error.data.message, error.data.params);
							}
						);
					},
					saveOrUpdateErrorCallback
				);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('SalesFilterDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.salesFilter = entity;
	$scope.objectName = 'SalesFilter';
	$scope.salesFilterId = $stateParams.salesFilterId;

	if (angular.isUndefined($rootScope.salesFilterActiveTab)) {
		//set the default here
		$rootScope.salesFilterActiveTab = 0;
	}

	$scope.goToEditState = function(salesFilter) {
		$state.go('salesfilter.detail.edit({salesFilterId:salesFilter.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:salesFilterUpdate', function(event, result) {
		$scope.salesFilter = result;
	});
});

/** @format */

'use strict';

// SalesFilter has edit layout enabled. Edit layout template url: salesfilter-dialog.html
// SalesFilter has detail layout enabled. Detail layout template url: salesfilter-detail.html
angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'SalesFilter'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('salesfilter'); // main translation loaded for salesfilter
		$translatePartialLoader.addPart('salesstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfiltereventtype'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfiltertemplateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // reference of coupling entity with coupling extra field metadata
		$translatePartialLoader.addPart('user'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/salesfilter/salesfilter-dialog.html';

		return {
			/* new state for entity salesFilter */
			/* to access: ui-ref="salesfilter.list.new" */
			/* url: hostname/salesfilter/new */
			url: url,
			data: {
				authorities: [],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'SalesFilterDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'SalesFilterFactory',
									'NewSalesFilterFactory',
									function(SalesFilterFactory, NewSalesFilterFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new SalesFilter
										// - resuming the creation of a new new SalesFilter AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return SalesFilterFactory.get({ id: $stateParams.salesFilterId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewSalesFilterFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for salesFilter new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for salesFilter edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('salesfilter', {
		/* abstract state for entity salesFilter */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/salesfilter',
		data: {
			authorities: [],
			pageTitle: 'SalesFilters',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('salesfilter.list', {
		/* list state for entity salesFilter */
		/* to access: ui-ref="salesfilter.list" */
		/* url: hostname/salesfilter/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilters.html',
				controller: 'SalesFilterController',
			},
		},
	});

	$stateProvider.state('salesfilter.detail', {
		/* detail state for entity salesFilter */
		/* to access: ui-sref="salesfilter.detail" */
		/* url: hostname/salesfilter/detail/:salesFilterId */
		url: '/detail/:salesFilterId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-detail.html',
				controller: 'SalesFilterDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'SalesFilterFactory',
				function($stateParams, SalesFilterFactory) {
					return SalesFilterFactory.get({ id: $stateParams.salesFilterId });
				},
			],
		},
	});

	/* url: http://<hostname>/salesfilter/list/new */
	$stateProvider.state('salesfilter.list.new', getNewState());
	/* url: http://<hostname>/salesfilter/list/:salesFilterId/edit */
	$stateProvider.state('salesfilter.list.edit', getEditState('/:salesFilterId/edit'));
	/* url: http://<hostname>/salesfilter/detail/:salesFilterId/edit */
	$stateProvider.state('salesfilter.detail.edit', getEditState('/edit'));

	$stateProvider.state('user-salesfilter', {
		/* abstract state for DTO UserSalesFilterListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/salesfilter',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'SalesFilter',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserSalesFilterListDto */
		/* to access: ui-ref="user-salesfilter.list" */
		/* url: http://<hostname>/user/salesfilter/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-list-user.html',
				controller: 'UserSalesFilterListDtoController',
			},
		},
	};

	$stateProvider.state('user-salesfilter.list', dtoListState);

	/* detail state for DTO user */
	var dtoDetailState = {
		/* detail state for DTO UserSalesFilterViewDto */
		/* to access: ui-sref="user-salesfilter.detail" */
		/* url: http://<hostname>/user/salesfilter/detail/:salesFilterId */
		url: '/detail/:salesFilterId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-view-user.html',
				controller: 'SalesFilterDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'UserSalesFilterViewDtoFactory',
				function($stateParams, UserSalesFilterViewDtoFactory) {
					return UserSalesFilterViewDtoFactory.get({ id: $stateParams.salesFilterId });
				},
			],
		},
	};

	$stateProvider.state('user-salesfilter.detail', dtoDetailState);

	/* edit state for DTO user */
	var dtoEditState = {
		/* edit state for DTO UserSalesFilterEditDto */
		/* to access: ui-sref="user-salesfilter.edit" */
		/* url: http://<hostname>/user/salesfilter/edit/:salesFilterId */
		url: '/edit/:salesFilterId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-edit-user.html',
				controller: 'UserSalesFilterEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserSalesFilterEditDtoFactory',
				function($stateParams, $rootScope, UserSalesFilterEditDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserSalesFilterEditDtoFactory.get({ id: $stateParams.salesFilterId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-salesfilter.edit', dtoEditState);

	/* new (create) state for DTO user */
	var dtoCreateState = {
		/* new state for DTO UserSalesFilterEditDto */
		/* to access: ui-sref="user-salesfilter.new" */
		/* url: http://<hostname>/user/salesfilter/new */
		url: '/new',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-edit-user.html',
				controller: 'UserSalesFilterEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserSalesFilterNewDtoFactory',
				function($stateParams, $rootScope, UserSalesFilterNewDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserSalesFilterNewDtoFactory.get({ id: $stateParams.salesFilterId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-salesfilter.new', dtoCreateState);
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterFactory,
		FindAllSalesFiltersByQueryParamsFactory,
		NoPagingSalesFilterFactory,
		NoPagingSalesStatusFactory,
		NoPagingUserFactory
	) {
		$scope.salesFilterList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilter)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilter);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newSalesFilter', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(salesFilter) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editSalesFilter', {
				salesFilterId: salesFilter.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getSalesFilterList = function() {
			FindAllSalesFiltersByQueryParamsFactory.query(
				{
					salesStatusId: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,
					userId: angular.isDefined($scope.userId) ? $scope.userId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSalesFilterId = id;
			$('#deleteSalesFilterConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			SalesFilterFactory.delete(
				{ id: $scope.selectedSalesFilterId },
				function() {
					$scope.loadAll();
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterFactory,
		FindAllSalesFiltersByQueryParamsFactory,
		NoPagingSalesFilterFactory,
		NoPagingSalesStatusFactory,
		NoPagingUserFactory
	) {
		$scope.salesFilterList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilter)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilter);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfilter.list.new');
		};

		$scope.goToEditState = function(salesFilter) {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfilter.list.edit', { salesFilterId: salesFilter.id });
		};

		var getUserId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterSearchOverview.user)) {
				return $scope.SalesFilterSearchOverview.user.id;
			} else {
				return undefined;
			}
		};

		NoPagingSalesStatusFactory.query(function(result) {
			$scope.salesStatusList = result;
		});

		/**
		 * This function queries all entities of type User and checks if this SalesFilter dialog is called in the context of User.
		 * If this is the case, we detect the parent entity SalesFilter and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryUser = function() {
			return NoPagingUserFactory.query(function(result) {
				return result;
			});
		};
		$scope.userReferenceFilterList = $scope.queryUser();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterSearchOverview = angular.copy($scope.SalesFilterSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);

			FindAllSalesFiltersByQueryParamsFactory.query(
				{
					page: $scope.SalesFilterSearchOverview.page - 1,
					size: $scope.pageSize,
					description: $scope.SalesFilterSearchOverview.description,
					firstName: $scope.SalesFilterSearchOverview.firstName,
					lastName: $scope.SalesFilterSearchOverview.lastName,
					potentialFromFrom: $scope.SalesFilterSearchOverview.potentialFromFrom,
					potentialFromTo: $scope.SalesFilterSearchOverview.potentialFromTo,
					potentialToFrom: $scope.SalesFilterSearchOverview.potentialToFrom,
					potentialToTo: $scope.SalesFilterSearchOverview.potentialToTo,
					offsetStartDateFromFrom: $scope.SalesFilterSearchOverview.offsetStartDateFromFrom,
					offsetStartDateFromTo: $scope.SalesFilterSearchOverview.offsetStartDateFromTo,
					offsetStartDateToFrom: $scope.SalesFilterSearchOverview.offsetStartDateToFrom,
					offsetStartDateToTo: $scope.SalesFilterSearchOverview.offsetStartDateToTo,
					salesStatus: $scope.SalesFilterSearchOverview.salesStatus,
					userId: getUserId(),

					sort: [$scope.SalesFilterSearchOverview.predicate + ',' + ($scope.SalesFilterSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterSearchOverview, $scope.originalSalesFilterSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterSearchOverview = {};
			$rootScope.SalesFilterSearchOverview.page = 1;
			$rootScope.SalesFilterSearchOverview.predicate = 'id';
			$rootScope.SalesFilterSearchOverview.ascending = false;

			$scope.SalesFilterSearchOverview = angular.copy($rootScope.SalesFilterSearchOverview);

			$scope.originalSalesFilterSearchOverview = angular.copy($scope.SalesFilterSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SalesFilterSearchOverview) || $rootScope.SalesFilterSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterSearchOverview = angular.copy($rootScope.SalesFilterSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSalesFilterId = id;
			$('#deleteSalesFilterConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			SalesFilterFactory.delete(
				{ id: $scope.selectedSalesFilterId },
				function() {
					$scope.search();
					$('#deleteSalesFilterConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteSalesFilterConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('RelationMailGroupDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		RelationMailGroupFactory,
		AlertService,
		NoPagingRelationMailGroupFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingMailGroupFactory
	) {
		$scope.relationMailGroup = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.relationMailGroup) && $rootScope.isDefinedAndNotNull($scope.relationMailGroup.id);
		};

		$scope.createRelation = function() {
			var referredBy = {
				refName: 'relation',
				data: $scope.relationMailGroup,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new relation will add this new relationmailgroup state to the history stack
				$state.go('relationmailgroup.list.newRelation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createMailGroup = function() {
			var referredBy = {
				refName: 'mailGroup',
				data: $scope.relationMailGroup,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new mailGroup will add this new relationmailgroup state to the history stack
				$state.go('relationmailgroup.list.newMailGroup', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('relationMailGroup.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryRelation = function() {
			// If the id of a preselected relation is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'relation');
					}
				});
			}
		};
		$scope.relationList = $scope.queryRelation();

		// --- start default implementation
		/**
		 * This function queries all entities of type MailGroup and checks if this RelationMailGroup dialog is called in the context of MailGroup.
		 * If this is the case, we detect the parent entity RelationMailGroup and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryMailGroup = function() {
			return NoPagingMailGroupFactory.query(function(result) {
				$scope.findItemByParent(result, 'mailGroup');
			});
		};
		$scope.mailGroupList = $scope.queryMailGroup();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:relationMailGroupUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving RelationMailGroup failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.relationMailGroup.relation === '') {
				$scope.relationMailGroup.relation = null;
			}

			if ($scope.relationMailGroup.id != null) {
				RelationMailGroupFactory.update($scope.relationMailGroup, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				RelationMailGroupFactory.save($scope.relationMailGroup, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('RelationMailGroupDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.relationMailGroup = entity;
	$scope.objectName = 'RelationMailGroup';
	$scope.relationMailGroupId = $stateParams.relationMailGroupId;

	if (angular.isUndefined($rootScope.relationMailGroupActiveTab)) {
		//set the default here
		$rootScope.relationMailGroupActiveTab = 0;
	}

	$scope.goToEditState = function(relationMailGroup) {
		$state.go('relationmailgroup.detail.edit({relationMailGroupId:relationMailGroup.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:relationMailGroupUpdate', function(event, result) {
		$scope.relationMailGroup = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'RelationMailGroup'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('relationmailgroup'); // main translation loaded for relationmailgroup
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('mailgroup'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // coupling entity reference loaded for relation
		$translatePartialLoader.addPart('mailgroup'); // coupling entity reference loaded for mailgroup

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/relationmailgroup/relationmailgroup-dialog.html';

		return {
			/* new state for entity relationMailGroup */
			/* to access: ui-ref="relationmailgroup.list.new" */
			/* url: hostname/relationmailgroup/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'RelationMailGroupDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'RelationMailGroupFactory',
									'NewRelationMailGroupFactory',
									function(RelationMailGroupFactory, NewRelationMailGroupFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new RelationMailGroup
										// - resuming the creation of a new new RelationMailGroup AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return RelationMailGroupFactory.get({ id: $stateParams.relationMailGroupId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewRelationMailGroupFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for relationMailGroup new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for relationMailGroup edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('relationmailgroup', {
		/* abstract state for entity relationMailGroup */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/relationmailgroup',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'RelationMailGroups',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('relationmailgroup.list', {
		/* list state for entity relationMailGroup */
		/* to access: ui-ref="relationmailgroup.list" */
		/* url: hostname/relationmailgroup/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/relationmailgroup/relationmailgroups.html',
				controller: 'RelationMailGroupController',
			},
		},
	});

	$stateProvider.state('relationmailgroup.detail', {
		/* detail state for entity relationMailGroup */
		/* to access: ui-sref="relationmailgroup.detail" */
		/* url: hostname/relationmailgroup/detail/:relationMailGroupId */
		url: '/detail/:relationMailGroupId',
		views: {
			'content@': {
				templateUrl: 'app/entities/relationmailgroup/relationmailgroup-detail.html',
				controller: 'RelationMailGroupDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'RelationMailGroupFactory',
				function($stateParams, RelationMailGroupFactory) {
					return RelationMailGroupFactory.get({ id: $stateParams.relationMailGroupId });
				},
			],
		},
	});

	/* url: http://<hostname>/relationmailgroup/list/new */
	$stateProvider.state('relationmailgroup.list.new', getNewState());
	/* url: http://<hostname>/relationmailgroup/list/:relationMailGroupId/edit */
	$stateProvider.state('relationmailgroup.list.edit', getEditState('/:relationMailGroupId/edit'));
	/* url: http://<hostname>/relationmailgroup/detail/:relationMailGroupId/edit */
	$stateProvider.state('relationmailgroup.detail.edit', getEditState('/edit'));
	// Relation.relationMailGroup with multiplicity 0..n points to RelationMailGroup
	/* url: http://<hostname>/relation/detail/:relationId/relationmailgroup/new */
	$stateProvider.state('relation.detail.newRelationMailGroup', getNewState('/relationmailgroup/new'));
	/* url: http://<hostname>/relation/detail/:relationId/relationmailgroup/:relationMailGroupId/edit */
	$stateProvider.state('relation.detail.editRelationMailGroup', getEditState('/relationmailgroup/:relationMailGroupId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/relationmailgroup/new */
	$stateProvider.state('user-relation.detail.newRelationMailGroup', getNewState('/relationmailgroup/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/relationmailgroup/:relationMailGroupId/edit */
	$stateProvider.state('user-relation.detail.editRelationMailGroup', getEditState('/relationmailgroup/:relationMailGroupId/edit'));
	// MailGroup.relationMailGroup with multiplicity 0..n points to RelationMailGroup
	/* url: http://<hostname>/mailgroup/detail/:mailGroupId/relationmailgroup/new */
	$stateProvider.state('mailgroup.detail.newRelationMailGroup', getNewState('/relationmailgroup/new'));
	/* url: http://<hostname>/mailgroup/detail/:mailGroupId/relationmailgroup/:relationMailGroupId/edit */
	$stateProvider.state('mailgroup.detail.editRelationMailGroup', getEditState('/relationmailgroup/:relationMailGroupId/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('RelationMailGroupTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationMailGroupFactory,
		FindAllRelationMailGroupsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingRelationMailGroupFactory,
		NoPagingRelationFactory,
		NoPagingMailGroupFactory
	) {
		$scope.relationMailGroupList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelationMailGroup)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelationMailGroup);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeRelationMailGroup = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newRelationMailGroup', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(relationMailGroup) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editRelationMailGroup', {
				relationMailGroupId: relationMailGroup.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getRelationMailGroupList = function() {
			FindAllRelationMailGroupsByQueryParamsFactory.query(
				{
					relationId: angular.isDefined($scope.relationId) ? $scope.relationId : null,
					mailGroupId: angular.isDefined($scope.mailGroupId) ? $scope.mailGroupId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationMailGroupList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getRelationMailGroupList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationMailGroupId = id;
			$('#deleteRelationMailGroupConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			RelationMailGroupFactory.delete(
				{ id: $scope.selectedRelationMailGroupId },
				function() {
					$scope.loadAll();
					$('#deleteRelationMailGroupConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteRelationMailGroupConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('RelationMailGroupController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationMailGroupFactory,
		FindAllRelationMailGroupsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingRelationMailGroupFactory,
		NoPagingRelationFactory,
		NoPagingMailGroupFactory
	) {
		$scope.relationMailGroupList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelationMailGroup)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelationMailGroup);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeRelationMailGroup = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('relationmailgroup.list.new');
		};

		$scope.goToEditState = function(relationMailGroup) {
			// this overview is NOT mapped, it is the main overview
			$state.go('relationmailgroup.list.edit', { relationMailGroupId: relationMailGroup.id });
		};

		$scope.getRelationMailGroupList = function() {
			FindAllRelationMailGroupsByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationMailGroupList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getRelationMailGroupList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationMailGroupId = id;
			$('#deleteRelationMailGroupConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			RelationMailGroupFactory.delete(
				{ id: $scope.selectedRelationMailGroupId },
				function() {
					$scope.loadAll();
					$('#deleteRelationMailGroupConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteRelationMailGroupConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserRelationListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationFactory,
		UserRelationListDtoSearchFactory,
		UserRelationViewDtoFactory
	) {
		$scope.relationList = [];
		$scope.selectedRelationList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelation)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelation);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-relation.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		var getCompanyTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.companyTypeId)) {
				return $scope.companyTypeId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.companyType)) {
				return $scope.RelationSearchTab.companyType.id;
			} else {
				return undefined;
			}
		};

		var getAccountManagerId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.accountManagerId)) {
				return $scope.accountManagerId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.accountManager)) {
				return $scope.RelationSearchTab.accountManager.id;
			} else {
				return undefined;
			}
		};

		var getBusinessCountryId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.businessCountryId)) {
				return $scope.businessCountryId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.businessCountry)) {
				return $scope.RelationSearchTab.businessCountry.id;
			} else {
				return undefined;
			}
		};

		var getPrivateCountryId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.privateCountryId)) {
				return $scope.privateCountryId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.privateCountry)) {
				return $scope.RelationSearchTab.privateCountry.id;
			} else {
				return undefined;
			}
		};

		// handle attribute carRentalAgreementSigned of javaType Boolean
		// handle attribute indemnificationSigned of javaType Boolean

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.RelationSearchTab = angular.copy($scope.RelationSearchTab);

			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);

			UserRelationListDtoSearchFactory.query(
				{
					page: $scope.RelationSearchTab.page - 1,
					size: $scope.pageSize,
					externalId: $scope.RelationSearchTab.externalId,
					companyName: $scope.RelationSearchTab.companyName,
					firstName: $scope.RelationSearchTab.firstName,
					lastName: $scope.RelationSearchTab.lastName,
					email: $scope.RelationSearchTab.email,
					telephone: $scope.RelationSearchTab.telephone,
					mobile: $scope.RelationSearchTab.mobile,
					potentialFrom: $scope.RelationSearchTab.potentialFrom,
					potentialTo: $scope.RelationSearchTab.potentialTo,
					carRentalAgreementSigned: $scope.RelationSearchTab.carRentalAgreementSignedGroup,
					indemnificationSigned: $scope.RelationSearchTab.indemnificationSignedGroup,
					type: $scope.RelationSearchTab.type,
					companyTypeId: getCompanyTypeId(),
					relationSource: $scope.RelationSearchTab.relationSource,
					gender: $scope.RelationSearchTab.gender,
					clientOf: $scope.RelationSearchTab.clientOf,
					accountManagerId: getAccountManagerId(),
					businessCountryId: getBusinessCountryId(),
					privateCountryId: getPrivateCountryId(),
					langKey: $scope.RelationSearchTab.langKey,

					sort: [$scope.RelationSearchTab.predicate + ',' + ($scope.RelationSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationList = result.items;

					$scope.accountManagerReferenceFilterList = result.accountManagerSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isRelationSearchTabDirty = function() {
			return !angular.equals($scope.RelationSearchTab, $scope.originalRelationSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.RelationSearchTab = {};
			$rootScope.RelationSearchTab.page = 1;
			$rootScope.RelationSearchTab.predicate = 'id';
			$rootScope.RelationSearchTab.ascending = false;

			$scope.RelationSearchTab = angular.copy($rootScope.RelationSearchTab);

			$scope.originalRelationSearchTab = angular.copy($scope.RelationSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.RelationSearchTab) || $rootScope.RelationSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.RelationSearchTab = angular.copy($rootScope.RelationSearchTab);

			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationId = id;
			$('#deleteRelationConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserRelationViewDtoFactory.delete(
				{ id: $scope.selectedRelationId },
				function() {
					$scope.search();
					$('#deleteRelationConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteRelationConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.multipleUpdate = function() {
			$state.go('user-relation.bulkedit', { selectedRelationList: $scope.selectedRelationList });
		};

		$scope.deselectAll = function() {
			angular.forEach($scope.relationList, function(value, key) {
				// update the list with selected items
				value.isSelected = false;
				$scope.selectionChanged(value);
			});
			$scope.selectedRelationList = [];
		};

		$scope.selectionChanged = function(item) {
			$scope.$broadcast('childClick', item);
			$scope.updateSelection();
		};

		$scope.toggleSelection = function() {
			$scope.updateSelection();
		};

		$scope.updateSelection = function() {
			// clean selection (if any)
			$scope.selectedRelationList = [];

			angular.forEach($scope.relationList, function(value, key) {
				// update the list with selected items
				if (value.isSelected) {
					$scope.selectedRelationList.push(value);
				}
			});
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:relationUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.RelationSearchTab.predicate === itemName) {
				if ($scope.RelationSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserRelationListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationFactory,
		UserRelationListDtoSearchFactory,
		UserRelationViewDtoFactory
	) {
		$scope.relationList = [];
		$scope.selectedRelationList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelation)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelation);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-relation.new');
		};

		var getCompanyTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.RelationSearchOverview.companyType)) {
				return $scope.RelationSearchOverview.companyType.id;
			} else {
				return undefined;
			}
		};

		var getAccountManagerId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.RelationSearchOverview.accountManager)) {
				return $scope.RelationSearchOverview.accountManager.id;
			} else {
				return undefined;
			}
		};

		var getBusinessCountryId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.RelationSearchOverview.businessCountry)) {
				return $scope.RelationSearchOverview.businessCountry.id;
			} else {
				return undefined;
			}
		};

		var getPrivateCountryId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.RelationSearchOverview.privateCountry)) {
				return $scope.RelationSearchOverview.privateCountry.id;
			} else {
				return undefined;
			}
		};

		// handle attribute carRentalAgreementSigned of javaType Boolean
		// handle attribute indemnificationSigned of javaType Boolean

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.RelationSearchOverview = angular.copy($scope.RelationSearchOverview);

			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);

			UserRelationListDtoSearchFactory.query(
				{
					page: $scope.RelationSearchOverview.page - 1,
					size: $scope.pageSize,
					externalId: $scope.RelationSearchOverview.externalId,
					companyName: $scope.RelationSearchOverview.companyName,
					firstName: $scope.RelationSearchOverview.firstName,
					lastName: $scope.RelationSearchOverview.lastName,
					email: $scope.RelationSearchOverview.email,
					telephone: $scope.RelationSearchOverview.telephone,
					mobile: $scope.RelationSearchOverview.mobile,
					potentialFrom: $scope.RelationSearchOverview.potentialFrom,
					potentialTo: $scope.RelationSearchOverview.potentialTo,
					carRentalAgreementSigned: $scope.RelationSearchOverview.carRentalAgreementSignedGroup,
					indemnificationSigned: $scope.RelationSearchOverview.indemnificationSignedGroup,
					type: $scope.RelationSearchOverview.type,
					companyTypeId: getCompanyTypeId(),
					relationSource: $scope.RelationSearchOverview.relationSource,
					gender: $scope.RelationSearchOverview.gender,
					clientOf: $scope.RelationSearchOverview.clientOf,
					accountManagerId: getAccountManagerId(),
					businessCountryId: getBusinessCountryId(),
					privateCountryId: getPrivateCountryId(),
					langKey: $scope.RelationSearchOverview.langKey,

					sort: [$scope.RelationSearchOverview.predicate + ',' + ($scope.RelationSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationList = result.items;

					$scope.accountManagerReferenceFilterList = result.accountManagerSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isRelationSearchOverviewDirty = function() {
			return !angular.equals($scope.RelationSearchOverview, $scope.originalRelationSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.RelationSearchOverview = {};
			$rootScope.RelationSearchOverview.page = 1;
			$rootScope.RelationSearchOverview.predicate = 'id';
			$rootScope.RelationSearchOverview.ascending = false;

			$scope.RelationSearchOverview = angular.copy($rootScope.RelationSearchOverview);

			$scope.originalRelationSearchOverview = angular.copy($scope.RelationSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.RelationSearchOverview) || $rootScope.RelationSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.RelationSearchOverview = angular.copy($rootScope.RelationSearchOverview);

			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationId = id;
			$('#deleteRelationConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserRelationViewDtoFactory.delete(
				{ id: $scope.selectedRelationId },
				function() {
					$scope.search();
					$('#deleteRelationConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteRelationConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.multipleUpdate = function() {
			$state.go('user-relation.bulkedit', { selectedRelationList: $scope.selectedRelationList });
		};

		$scope.deselectAll = function() {
			angular.forEach($scope.relationList, function(value, key) {
				// update the list with selected items
				value.isSelected = false;
				$scope.selectionChanged(value);
			});
			$scope.selectedRelationList = [];
		};

		$scope.selectionChanged = function(item) {
			$scope.$broadcast('childClick', item);
			$scope.updateSelection();
		};

		$scope.toggleSelection = function() {
			$scope.updateSelection();
		};

		$scope.updateSelection = function() {
			// clean selection (if any)
			$scope.selectedRelationList = [];

			angular.forEach($scope.relationList, function(value, key) {
				// update the list with selected items
				if (value.isSelected) {
					$scope.selectedRelationList.push(value);
				}
			});
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:relationUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.RelationSearchOverview.predicate === itemName) {
				if ($scope.RelationSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

// CodeComposer:preserve:file => Don't override manual changes
/** @format */

'use strict';

// Created by frontend/angular/entity/controller/dto-edit.ftl
angular
	.module('emsApp')
	.controller('UserRelationEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserRelationEditDtoFactory,
		AlertService,
		HistoryService,
		UserRelationEditDtoSaveAndCreateFactory
	) {
		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.submitButtonIsActive = true;
		};

		$scope.relation = entity;
		$scope.submitButtonIsActive = true;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		//This function preselects and disables the parent reference when called from tab
		$scope.relation['selected' + _.upperFirst($stateParams.mappedBy)] = {
			id: $stateParams.mappedById,
			displayValue: $stateParams.mappedByDisplayValue,
		};

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.relation) && $rootScope.isDefinedAndNotNull($scope.relation.id);
		};

		var onSaveAndNewFinishedCallback = function(result) {
			// navigate to new state with result (a new entity, but with the copied values from the previous)
			$state.go('user-relation.new', {
				dataModel: result,
				mappedBy: $stateParams.mappedBy,
				mappedById: $stateParams.mappedById,
			});
		};

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:relationUpdate', result);
			$scope.submitButtonIsActive = true;
			// process success result, if necessary
			if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
				console.log('as we came on this create new page from plus button we will update history');

				// set relation as reference in the referredBy data model
				$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;

				// update previous state
				HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
			}
			$rootScope.back();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;
			UserRelationEditDtoFactory.update($scope.relation, onSaveFinishedCallback, saveOrUpdateErrorCallback);
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			// To prevent navigating back to this current view, remove it from history.
			HistoryService.removeHistory();

			if ($scope.relation.id != null) {
				UserRelationEditDtoSaveAndCreateFactory.updateAndNew($scope.relation, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				UserRelationEditDtoSaveAndCreateFactory.createAndNew($scope.relation, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};

		// Custom validation of the summarize length of the first-last name fields
		$scope.$watchGroup(['relation.firstName', 'relation.lastName'], function (firstName, lastName) {
			var summOfLengths = ($scope.relation.firstName || '').length + ($scope.relation.lastName || '').length;
			$scope._validationSumOfLengths = summOfLengths
			var isLengthValid = summOfLengths <= 49;
			$scope.editForm.firstName.$setValidity('firstAndLastNameLengthSumm', isLengthValid);
			$scope.editForm.lastName.$setValidity('firstAndLastNameLengthSumm', isLengthValid);
		});
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('RelationDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		RelationFactory,
		AlertService,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingRelationTypeFactory,
		NoPagingCompanyTypeFactory,
		NoPagingRelationSourceFactory,
		NoPagingGenderFactory,
		NoPagingClientOfFactory,
		NoPagingUserFactory,
		NoPagingCountryFactory,
		NoPagingLangKeyFactory,
		RelationSaveAndCreateFactory,
		RelationFindUserFilteredByAccountManagerFactory,
		MailGroupFromRelationMailGroupPicklistUpdateFactory,
		NoPagingMailGroupFactory
	) {
		$scope.relation = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.relation) && $rootScope.isDefinedAndNotNull($scope.relation.id);
		};

		$scope.createType = function() {
			var referredBy = {
				refName: 'type',
				data: $scope.relation,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new type will add this new relation state to the history stack
				$state.go('relation.list.newRelationType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createCompanyType = function() {
			var referredBy = {
				refName: 'companyType',
				data: $scope.relation,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new companyType will add this new relation state to the history stack
				$state.go('relation.list.newCompanyType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createRelationSource = function() {
			var referredBy = {
				refName: 'relationSource',
				data: $scope.relation,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new relationSource will add this new relation state to the history stack
				$state.go('relation.list.newRelationSource', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createGender = function() {
			var referredBy = {
				refName: 'gender',
				data: $scope.relation,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new gender will add this new relation state to the history stack
				$state.go('relation.list.newGender', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createClientOf = function() {
			var referredBy = {
				refName: 'clientOf',
				data: $scope.relation,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new clientOf will add this new relation state to the history stack
				$state.go('relation.list.newClientOf', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createLangKey = function() {
			var referredBy = {
				refName: 'langKey',
				data: $scope.relation,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new langKey will add this new relation state to the history stack
				$state.go('relation.list.newLangKey', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('relation.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type Type and checks if this Relation dialog is called in the context of Type.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryType = function() {
			return NoPagingRelationTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'type');
			});
		};
		$scope.typeList = $scope.queryType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type CompanyType and checks if this Relation dialog is called in the context of CompanyType.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryCompanyType = function() {
			return NoPagingCompanyTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'companyType');
			});
		};
		$scope.companyTypeList = $scope.queryCompanyType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type RelationSource and checks if this Relation dialog is called in the context of RelationSource.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryRelationSource = function() {
			return NoPagingRelationSourceFactory.query(function(result) {
				$scope.findItemByParent(result, 'relationSource');
			});
		};
		$scope.relationSourceList = $scope.queryRelationSource();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Gender and checks if this Relation dialog is called in the context of Gender.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryGender = function() {
			return NoPagingGenderFactory.query(function(result) {
				$scope.findItemByParent(result, 'gender');
			});
		};
		$scope.genderList = $scope.queryGender();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type ClientOf and checks if this Relation dialog is called in the context of ClientOf.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryClientOf = function() {
			return NoPagingClientOfFactory.query(function(result) {
				$scope.findItemByParent(result, 'clientOf');
			});
		};
		$scope.clientOfList = $scope.queryClientOf();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type AccountManager and checks if this Relation dialog is called in the context of AccountManager.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryAccountManager = function() {
			return RelationFindUserFilteredByAccountManagerFactory.query(function(result) {
				$scope.findItemByParent(result, 'accountManager');
			});
		};
		$scope.accountManagerList = $scope.queryAccountManager();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type BusinessCountry and checks if this Relation dialog is called in the context of BusinessCountry.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryBusinessCountry = function() {
			return NoPagingCountryFactory.query(function(result) {
				$scope.findItemByParent(result, 'businessCountry');
			});
		};
		$scope.businessCountryList = $scope.queryBusinessCountry();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type PrivateCountry and checks if this Relation dialog is called in the context of PrivateCountry.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryPrivateCountry = function() {
			return NoPagingCountryFactory.query(function(result) {
				$scope.findItemByParent(result, 'privateCountry');
			});
		};
		$scope.privateCountryList = $scope.queryPrivateCountry();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type LangKey and checks if this Relation dialog is called in the context of LangKey.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLangKey = function() {
			return NoPagingLangKeyFactory.query(function(result) {
				$scope.findItemByParent(result, 'langKey');
			});
		};
		$scope.langKeyList = $scope.queryLangKey();
		// --- end default implementation

		var getSelectedListItems = function(allItems, selectedItemList) {
			var itemIDs = [];
			angular.forEach(selectedItemList, function(value, key) {
				itemIDs.push(value.id);
			});

			var selectedItems = [];
			angular.forEach(allItems, function(value, key) {
				angular.forEach(itemIDs, function(value2, key2) {
					if (value.id === value2) {
						selectedItems.push(value);
					}
				});
			});

			return selectedItems;
		};

		var tempSelectedMailGroupList = [];
		$scope.selectedMailGroupList = [];

		$scope.getSelectedMailGroupList = function() {
			MailGroupFromRelationMailGroupPicklistUpdateFactory.query({ id: $stateParams.relationId }, function(result) {
				//put all selected MailGroup-items in a list
				angular.forEach(result, function(value, key) {
					tempSelectedMailGroupList.push(value);
				});
				NoPagingMailGroupFactory.query(function(result) {
					$scope.mailGroupPickListOptions = result;
					$scope.selectedMailGroupList = getSelectedListItems(result, tempSelectedMailGroupList);
				});
			});
		};

		$scope.getMailGroupPickListOptions = function() {
			if ($stateParams.relationId != null) {
				$scope.getSelectedMailGroupList();
			} else {
				NoPagingMailGroupFactory.query(function(result) {
					$scope.mailGroupPickListOptions = result;
				});
			}
		};

		$scope.getMailGroupPickListOptions();

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:relationUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Relation failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		var onSaveAndNewFinishedCallback = function(result) {
			$scope.$emit('emsApp:relationUpdate', result);
			// the result contains a new entity, but with the copied values from the previous
			$scope.relation = result;
			$scope.updateDropdownModels();
			$scope.submitButtonIsActive = true;
		};

		$scope.updateDropdownModels = function() {
			$scope.queryType();
			$scope.queryCompanyType();
			$scope.queryRelationSource();
			$scope.queryGender();
			$scope.queryClientOf();
			$scope.queryAccountManager();
			$scope.queryBusinessCountry();
			$scope.queryPrivateCountry();
			$scope.queryLangKey();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.relation.id != null) {
				RelationFactory.update(
					$scope.relation,
					function(result) {
						$scope.relation = result;

						if (
							!angular.isUndefined($scope.selectedMailGroupList) &&
							angular.isArray($scope.selectedMailGroupList) &&
							$scope.selectedMailGroupList.length > 0
						) {
							MailGroupFromRelationMailGroupPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedMailGroupList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			} else {
				RelationFactory.save(
					$scope.relation,
					function(result) {
						$scope.relation = result;

						if (
							!angular.isUndefined($scope.selectedMailGroupList) &&
							angular.isArray($scope.selectedMailGroupList) &&
							$scope.selectedMailGroupList.length > 0
						) {
							MailGroupFromRelationMailGroupPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedMailGroupList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			}
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.relation.id != null) {
				RelationSaveAndCreateFactory.updateAndCreate(
					$scope.relation,
					function(result) {
						$scope.relation = result;
						$scope.$emit('emsApp:relationUpdate', result);

						if (
							!angular.isUndefined($scope.selectedMailGroupList) &&
							angular.isArray($scope.selectedMailGroupList) &&
							$scope.selectedMailGroupList.length > 0
						) {
							MailGroupFromRelationMailGroupPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedMailGroupList,
								function(successResult) {
									onSaveAndNewFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveAndNewFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			} else {
				RelationSaveAndCreateFactory.saveAndCreate(
					$scope.relation,
					function(result) {
						$scope.relation = result;
						$scope.$emit('emsApp:relationUpdate', result);

						if (
							!angular.isUndefined($scope.selectedMailGroupList) &&
							angular.isArray($scope.selectedMailGroupList) &&
							$scope.selectedMailGroupList.length > 0
						) {
							MailGroupFromRelationMailGroupPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedMailGroupList,
								function(successResult) {
									onSaveAndNewFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveAndNewFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('RelationDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.relation = entity;
	$scope.objectName = 'Relation';
	$scope.relationId = $stateParams.relationId;

	if (angular.isUndefined($rootScope.relationActiveTab)) {
		//set the default here
		$rootScope.relationActiveTab = 0;
	}

	$scope.goToEditState = function(relation) {
		$state.go('relation.detail.edit({relationId:relation.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:relationUpdate', function(event, result) {
		$scope.relation = result;
	});
});

/** @format */
// CodeComposer:preserve:file => Don't override manual changes

'use strict';

angular
	.module('emsApp')
	.controller('UserRelationBulkEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserRelationBulkEditDtoFactory,
		AlertService
	) {
		$scope.selectedRelationIds = _.map($stateParams.selectedRelationList, 'id');
		$scope.selectedItemsAmount = $scope.selectedRelationIds.length;
		$scope.relation = entity;
		$scope.submitButtonIsActive = true;

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:relationUpdate', result);
			$scope.submitButtonIsActive = true;
			// process success result, if necessary
			if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
				console.log('as we came on this create new page from plus button we will update history');

				// set relation as reference in the referredBy data model
				$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;

				// update previous state
				HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
			}
			$rootScope.back();
		};

		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.updatingItemsInProgress = false;
		};

		$scope.save = function() {
			$scope.updatingItemsInProgress = true;
			UserRelationBulkEditDtoFactory.update(
				{ relationIds: $scope.selectedRelationIds },
				$scope.relation,
				onSaveFinishedCallback,
				saveOrUpdateErrorCallback
			);
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};

		// Custom validation of the summarize length of the first-last name fields
		$scope.$watchGroup(['relation.firstName', 'relation.lastName'], function (firstName, lastName) {
			var summOfLengths = ($scope.relation.firstName || '').length + ($scope.relation.lastName || '').length;
			$scope._validationSumOfLengths = summOfLengths
			var isLengthValid = summOfLengths <= 49;
			$scope.editForm.firstName.$setValidity('firstAndLastNameLengthSumm', isLengthValid);
			$scope.editForm.lastName.$setValidity('firstAndLastNameLengthSumm', isLengthValid);
		});
	});

/** @format */

'use strict';

// Relation has edit layout enabled. Edit layout template url: relation-dialoglayout.html
// Relation has detail layout enabled. Detail layout template url: relation-detaillayout.html
angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Relation'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('relation'); // main translation loaded for relation
		$translatePartialLoader.addPart('relationtype'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to many reference from main entity
		$translatePartialLoader.addPart('gender'); // one to many reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to many reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to many reference from main entity
		$translatePartialLoader.addPart('companytype'); // one to many reference from main entity
		$translatePartialLoader.addPart('user'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationmailgroup'); // one to many reference from main entity
		$translatePartialLoader.addPart('booking'); // one to many reference from main entity
		$translatePartialLoader.addPart('bookingstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('confirmationemailstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('car'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('document'); // one to many reference from main entity
		$translatePartialLoader.addPart('instructor'); // one to many reference from main entity
		$translatePartialLoader.addPart('eventrelationcontact'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('country'); // one to many reference from main entity
		$translatePartialLoader.addPart('articlerelationprice'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/relation/relation-dialoglayout.html';

		return {
			/* new state for entity relation */
			/* to access: ui-ref="relation.list.new" */
			/* url: hostname/relation/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'RelationDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'RelationFactory',
									'NewRelationFactory',
									function(RelationFactory, NewRelationFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Relation
										// - resuming the creation of a new new Relation AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return RelationFactory.get({ id: $stateParams.relationId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewRelationFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for relation new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for relation edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('relation', {
		/* abstract state for entity relation */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/relation',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Relations',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('relation.list', {
		/* list state for entity relation */
		/* to access: ui-ref="relation.list" */
		/* url: hostname/relation/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/relation/relations.html',
				controller: 'RelationController',
			},
		},
	});

	$stateProvider.state('relation.detail', {
		/* detail state for entity relation */
		/* to access: ui-sref="relation.detail" */
		/* url: hostname/relation/detail/:relationId */
		url: '/detail/:relationId',
		views: {
			'content@': {
				templateUrl: 'app/entities/relation/relation-detaillayout.html',
				controller: 'RelationDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'RelationFactory',
				function($stateParams, RelationFactory) {
					return RelationFactory.get({ id: $stateParams.relationId });
				},
			],
		},
	});

	/* url: http://<hostname>/relation/list/new */
	$stateProvider.state('relation.list.new', getNewState());
	/* url: http://<hostname>/relation/list/:relationId/edit */
	$stateProvider.state('relation.list.edit', getEditState('/:relationId/edit'));
	/* url: http://<hostname>/relation/detail/:relationId/edit */
	$stateProvider.state('relation.detail.edit', getEditState('/edit'));

	$stateProvider.state('subscription.list.newRelation', getNewState('/relation/new'));
	$stateProvider.state('relationmailgroup.list.newRelation', getNewState('/relation/new'));
	$stateProvider.state('car.list.newRelation', getNewState('/relation/new'));
	$stateProvider.state('booking.list.newRelation', getNewState('/relation/new'));
	$stateProvider.state('document.list.newRelation', getNewState('/relation/new'));
	$stateProvider.state('instructor.list.newRelation', getNewState('/relation/new'));

	$stateProvider.state('event.detail.booking.newRelation', getNewState('/relation/new'));

	$stateProvider.state('user-relation', {
		/* abstract state for DTO UserRelationListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/relation',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'Relation',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserRelationListDto */
		/* to access: ui-ref="user-relation.list" */
		/* url: http://<hostname>/user/relation/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/relation/relation-list-user.html',
				controller: 'UserRelationListDtoController',
			},
		},
	};

	$stateProvider.state('user-relation.list', dtoListState);

	/* detail state for DTO user */
	var dtoDetailState = {
		/* detail state for DTO UserRelationViewDto */
		/* to access: ui-sref="user-relation.detail" */
		/* url: http://<hostname>/user/relation/detail/:relationId */
		url: '/detail/:relationId',
		views: {
			'content@': {
				templateUrl: 'app/entities/relation/relation-view-user.html',
				controller: 'RelationDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'UserRelationViewDtoFactory',
				function($stateParams, UserRelationViewDtoFactory) {
					return UserRelationViewDtoFactory.get({ id: $stateParams.relationId });
				},
			],
		},
	};

	$stateProvider.state('user-relation.detail', dtoDetailState);

	/* edit state for DTO user */
	var dtoEditState = {
		/* edit state for DTO UserRelationEditDto */
		/* to access: ui-sref="user-relation.edit" */
		/* url: http://<hostname>/user/relation/edit/:relationId */
		url: '/edit/:relationId',
		views: {
			'content@': {
				templateUrl: 'app/entities/relation/relation-edit-user.html',
				controller: 'UserRelationEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserRelationEditDtoFactory',
				function($stateParams, $rootScope, UserRelationEditDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserRelationEditDtoFactory.get({ id: $stateParams.relationId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-relation.edit', dtoEditState);

	/* new (create) state for DTO user */
	var dtoCreateState = {
		/* new state for DTO UserRelationEditDto */
		/* to access: ui-sref="user-relation.new" */
		/* url: http://<hostname>/user/relation/new */
		url: '/new',
		views: {
			'content@': {
				templateUrl: 'app/entities/relation/relation-edit-user.html',
				controller: 'UserRelationEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserRelationNewDtoFactory',
				function($stateParams, $rootScope, UserRelationNewDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserRelationNewDtoFactory.get({ id: $stateParams.relationId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-relation.new', dtoCreateState);

	/* Bulk edit state for DTO user */
	var dtoBulkEditState = {
		/* Bulk edit state for DTO UserRelationEditDto */
		/* to access: ui-sref="user-relation.bulkedit" */
		/* url: http://<hostname>/user/relation/bulkedit */
		url: '/bulkedit',
		views: {
			'content@': {
				templateUrl: 'app/entities/relation/relation-bulkedit-user.html',
				controller: 'UserRelationBulkEditDtoController',
			},
		},
		params: {
			selectedRelationList: [''],
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserRelationNewBulkEditDtoFactory',
				function($stateParams, $rootScope, UserRelationNewBulkEditDtoFactory) {
					return UserRelationNewBulkEditDtoFactory.get().$promise.then(function(result) {
						return _.merge(result, { type: 'UserRelationBulkEditDto' });
					});
				},
			],
		},
	};

	$stateProvider.state('user-relation.bulkedit', dtoBulkEditState);

	// create state for plus button on Subscription edit / new page for reference Relation and dto property value user
	$stateProvider.state('user-subscription.new.newRelation', getCreateState('/relation/new'));
	$stateProvider.state('user-subscription.edit.newRelation', getCreateState('/relation/new'));
	// create state for plus button on RelationMailGroup edit / new page for reference Relation and dto property value user
	$stateProvider.state('user-relationmailgroup.new.newRelation', getCreateState('/relation/new'));
	$stateProvider.state('user-relationmailgroup.edit.newRelation', getCreateState('/relation/new'));
	// create state for plus button on Car edit / new page for reference Relation and dto property value user
	$stateProvider.state('user-car.new.newRelation', getCreateState('/owner/new'));
	$stateProvider.state('user-car.edit.newRelation', getCreateState('/owner/new'));
	// create state for plus button on Booking edit / new page for reference Relation and dto property value user
	$stateProvider.state('user-booking.new.newRelation', getCreateState('/client/new'));
	$stateProvider.state('user-booking.edit.newRelation', getCreateState('/client/new'));
	// create state for plus button on Document edit / new page for reference Relation and dto property value user
	$stateProvider.state('user-document.new.newRelation', getCreateState('/relation/new'));
	$stateProvider.state('user-document.edit.newRelation', getCreateState('/relation/new'));
	// create state for plus button on Instructor edit / new page for reference Relation and dto property value user
	$stateProvider.state('user-instructor.new.newRelation', getCreateState('/relation/new'));
	$stateProvider.state('user-instructor.edit.newRelation', getCreateState('/relation/new'));
	// retrieve the create state object, and update the url in the state object as the default create state only adds "/new" to the location url, while we want the url to contain "/relation/new"
	function getCreateState(url) {
		var clonedDtoCreateState = Object.assign({}, dtoCreateState);
		clonedDtoCreateState.url = url;
		return clonedDtoCreateState;
	}
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('RelationTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationFactory,
		FindAllRelationsByQueryParamsFactory,
		NoPagingRelationFactory,
		NoPagingRelationTypeFactory,
		NoPagingCompanyTypeFactory,
		NoPagingRelationSourceFactory,
		NoPagingGenderFactory,
		NoPagingClientOfFactory,
		NoPagingUserFactory,
		NoPagingCountryFactory,
		NoPagingLangKeyFactory,
		RelationFindUserFilteredByAccountManagerFactory
	) {
		$scope.relationList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelation)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelation);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newRelation', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(relation) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editRelation', {
				relationId: relation.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		var getCompanyTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.companyTypeId)) {
				return $scope.companyTypeId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.companyType)) {
					return $scope.RelationSearchTab.companyType.id;
				} else {
					return undefined;
				}
			}
		};

		var getAccountManagerId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.accountManagerId)) {
				return $scope.accountManagerId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.accountManager)) {
					return $scope.RelationSearchTab.accountManager.id;
				} else {
					return undefined;
				}
			}
		};

		var getBusinessCountryIdList = function() {
			if ($rootScope.isDefinedAndNotNull($scope.businessCountryId)) {
				return $scope.businessCountryId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.businessCountryIdList)) {
					return $rootScope.getListValues($scope.RelationSearchTab.businessCountryIdList, 'id');
				} else {
					return undefined;
				}
			}
		};

		var getPrivateCountryIdList = function() {
			if ($rootScope.isDefinedAndNotNull($scope.privateCountryId)) {
				return $scope.privateCountryId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.privateCountryIdList)) {
					return $rootScope.getListValues($scope.RelationSearchTab.privateCountryIdList, 'id');
				} else {
					return undefined;
				}
			}
		};

		// handle attribute carRentalAgreementSigned of javaType Boolean
		// handle attribute indemnificationSigned of javaType Boolean

		/**
		 * This function queries all entities of type AccountManager and checks if this Relation dialog is called in the context of AccountManager.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryAccountManager = function() {
			return RelationFindUserFilteredByAccountManagerFactory.query(function(result) {
				return result;
			});
		};
		$scope.accountManagerReferenceFilterList = $scope.queryAccountManager();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.RelationSearchTab = angular.copy($scope.RelationSearchTab);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);

			FindAllRelationsByQueryParamsFactory.query(
				{
					page: $scope.RelationSearchTab.page - 1,
					size: $scope.pageSize,
					externalId: $scope.RelationSearchTab.externalId,
					companyName: $scope.RelationSearchTab.companyName,
					firstName: $scope.RelationSearchTab.firstName,
					lastName: $scope.RelationSearchTab.lastName,
					email: $scope.RelationSearchTab.email,
					telephone: $scope.RelationSearchTab.telephone,
					mobile: $scope.RelationSearchTab.mobile,
					potentialFrom: $scope.RelationSearchTab.potentialFrom,
					potentialTo: $scope.RelationSearchTab.potentialTo,
					carRentalAgreementSigned: $scope.RelationSearchTab.carRentalAgreementSignedGroup,
					indemnificationSigned: $scope.RelationSearchTab.indemnificationSignedGroup,
					type: $scope.RelationSearchTab.type,
					companyTypeId: getCompanyTypeId(),
					relationSource: $scope.RelationSearchTab.relationSource,
					gender: $scope.RelationSearchTab.gender,
					clientOfList: $scope.RelationSearchTab.clientOfList,
					accountManagerId: getAccountManagerId(),
					businessCountryIdList: getBusinessCountryIdList(),
					privateCountryIdList: getPrivateCountryIdList(),
					langKeyList: $scope.RelationSearchTab.langKeyList,

					sort: [$scope.RelationSearchTab.predicate + ',' + ($scope.RelationSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.updateClientOfUISelect = function(item, model) {
			$scope.search();
		};
		$scope.updateBusinessCountryUISelect = function(item, model) {
			$scope.search();
		};
		$scope.updatePrivateCountryUISelect = function(item, model) {
			$scope.search();
		};
		$scope.updateLangKeyUISelect = function(item, model) {
			$scope.search();
		};
		$scope.isRelationSearchTabDirty = function() {
			return !angular.equals($scope.RelationSearchTab, $scope.originalRelationSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.RelationSearchTab = {};
			$rootScope.RelationSearchTab.page = 1;
			$rootScope.RelationSearchTab.predicate = 'id';
			$rootScope.RelationSearchTab.ascending = false;

			$scope.RelationSearchTab = angular.copy($rootScope.RelationSearchTab);

			$scope.originalRelationSearchTab = angular.copy($scope.RelationSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.RelationSearchTab) || $rootScope.RelationSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.RelationSearchTab = angular.copy($rootScope.RelationSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationId = id;
			$('#deleteRelationConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			RelationFactory.delete(
				{ id: $scope.selectedRelationId },
				function() {
					$scope.search();
					$('#deleteRelationConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteRelationConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:relationUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.RelationSearchTab.predicate === itemName) {
				if ($scope.RelationSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('RelationController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationFactory,
		FindAllRelationsByQueryParamsFactory,
		NoPagingRelationFactory,
		NoPagingRelationTypeFactory,
		NoPagingCompanyTypeFactory,
		NoPagingRelationSourceFactory,
		NoPagingGenderFactory,
		NoPagingClientOfFactory,
		NoPagingUserFactory,
		NoPagingCountryFactory,
		NoPagingLangKeyFactory,
		RelationFindUserFilteredByAccountManagerFactory
	) {
		$scope.relationList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelation)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelation);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('relation.list.new');
		};

		$scope.goToEditState = function(relation) {
			// this overview is NOT mapped, it is the main overview
			$state.go('relation.list.edit', { relationId: relation.id });
		};

		var getCompanyTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.RelationSearchOverview.companyType)) {
				return $scope.RelationSearchOverview.companyType.id;
			} else {
				return undefined;
			}
		};

		var getAccountManagerId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.RelationSearchOverview.accountManager)) {
				return $scope.RelationSearchOverview.accountManager.id;
			} else {
				return undefined;
			}
		};

		var getBusinessCountryIdList = function() {
			return $rootScope.getListValues($scope.RelationSearchOverview.businessCountryIdList, 'id');
		};

		var getPrivateCountryIdList = function() {
			return $rootScope.getListValues($scope.RelationSearchOverview.privateCountryIdList, 'id');
		};

		// handle attribute carRentalAgreementSigned of javaType Boolean
		// handle attribute indemnificationSigned of javaType Boolean

		/**
		 * This function queries all entities of type AccountManager and checks if this Relation dialog is called in the context of AccountManager.
		 * If this is the case, we detect the parent entity Relation and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryAccountManager = function() {
			return RelationFindUserFilteredByAccountManagerFactory.query(function(result) {
				return result;
			});
		};
		$scope.accountManagerReferenceFilterList = $scope.queryAccountManager();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.RelationSearchOverview = angular.copy($scope.RelationSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);

			FindAllRelationsByQueryParamsFactory.query(
				{
					page: $scope.RelationSearchOverview.page - 1,
					size: $scope.pageSize,
					externalId: $scope.RelationSearchOverview.externalId,
					companyName: $scope.RelationSearchOverview.companyName,
					firstName: $scope.RelationSearchOverview.firstName,
					lastName: $scope.RelationSearchOverview.lastName,
					email: $scope.RelationSearchOverview.email,
					telephone: $scope.RelationSearchOverview.telephone,
					mobile: $scope.RelationSearchOverview.mobile,
					potentialFrom: $scope.RelationSearchOverview.potentialFrom,
					potentialTo: $scope.RelationSearchOverview.potentialTo,
					carRentalAgreementSigned: $scope.RelationSearchOverview.carRentalAgreementSignedGroup,
					indemnificationSigned: $scope.RelationSearchOverview.indemnificationSignedGroup,
					type: $scope.RelationSearchOverview.type,
					companyTypeId: getCompanyTypeId(),
					relationSource: $scope.RelationSearchOverview.relationSource,
					gender: $scope.RelationSearchOverview.gender,
					clientOfList: $scope.RelationSearchOverview.clientOfList,
					accountManagerId: getAccountManagerId(),
					businessCountryIdList: getBusinessCountryIdList(),
					privateCountryIdList: getPrivateCountryIdList(),
					langKeyList: $scope.RelationSearchOverview.langKeyList,

					sort: [$scope.RelationSearchOverview.predicate + ',' + ($scope.RelationSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.updateClientOfUISelect = function(item, model) {
			$scope.search();
		};
		$scope.updateBusinessCountryUISelect = function(item, model) {
			$scope.search();
		};
		$scope.updatePrivateCountryUISelect = function(item, model) {
			$scope.search();
		};
		$scope.updateLangKeyUISelect = function(item, model) {
			$scope.search();
		};
		$scope.isRelationSearchOverviewDirty = function() {
			return !angular.equals($scope.RelationSearchOverview, $scope.originalRelationSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.RelationSearchOverview = {};
			$rootScope.RelationSearchOverview.page = 1;
			$rootScope.RelationSearchOverview.predicate = 'id';
			$rootScope.RelationSearchOverview.ascending = false;

			$scope.RelationSearchOverview = angular.copy($rootScope.RelationSearchOverview);

			$scope.originalRelationSearchOverview = angular.copy($scope.RelationSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.RelationSearchOverview) || $rootScope.RelationSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.RelationSearchOverview = angular.copy($rootScope.RelationSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationId = id;
			$('#deleteRelationConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			RelationFactory.delete(
				{ id: $scope.selectedRelationId },
				function() {
					$scope.search();
					$('#deleteRelationConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteRelationConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:relationUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.RelationSearchOverview.predicate === itemName) {
				if ($scope.RelationSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('OrderLineDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		OrderLineFactory,
		AlertService,
		NoPagingOrderLineFactory,
		BookingFactory,
		NoPagingBookingFactory,
		AutocompleteBookingsByQueryParamsFactory,
		NoPagingSubscriptionFactory,
		NoPagingArticleFactory,
		NoPagingOrderLineOriginFactory,
		NoPagingSubscriptionByBookingFactory,
		NoPagingArticleWithBookingFactory
	) {
		$scope.orderLine = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.orderLine) && $rootScope.isDefinedAndNotNull($scope.orderLine.id);
		};

		$scope.createBooking = function() {
			var referredBy = {
				refName: 'booking',
				data: $scope.orderLine,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new booking will add this new orderline state to the history stack
				$state.go('orderline.list.newBooking', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createSubscription = function() {
			var referredBy = {
				refName: 'subscription',
				data: $scope.orderLine,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new subscription will add this new orderline state to the history stack
				$state.go('orderline.list.newSubscription', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createArticle = function() {
			var referredBy = {
				refName: 'article',
				data: $scope.orderLine,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new article will add this new orderline state to the history stack
				$state.go('orderline.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteBookings = function(val) {
			var params = {
				bookingTypeAheadSearchString: val,
			};

			return AutocompleteBookingsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('orderLine.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryBooking = function() {
			// If the id of a preselected booking is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return BookingFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'booking');
					}
				});
			}
		};
		$scope.bookingList = $scope.queryBooking();

		// --- start custom implementation
		// custom method to load the list with subscription entries for related booking only
		$scope.querySubscription = function() {
			var bookingId =
				$rootScope.isDefinedAndNotNull($scope.orderLine) && $rootScope.isDefinedAndNotNull($scope.orderLine.booking)
					? $scope.orderLine.booking.id
					: -1;

			// check if creating / editing this orderline happens in the context of a booking (from a sub tab), if so we have to set the booking id from that perspective
			if ($stateParams.mappedBy === 'booking' && $rootScope.isDefinedAndNotNull($stateParams.mappedById)) {
				bookingId = $stateParams.mappedById;
			}

			return NoPagingSubscriptionByBookingFactory.query(
				{
					bookingId: bookingId,
				},
				function(result) {
					$scope.findItemByParent(result, 'subscription');
				}
			);
		};

		// call the method to load all subscription entries once the controller loads
		$scope.subscriptionList = $scope.querySubscription();
		// --- end custom implementation

		// --- start custom implementation
		// custom method to load the list with relationprices for related booking only

		$scope.queryArticle = function() {
			var bookingId =
				$rootScope.isDefinedAndNotNull($scope.orderLine) && $rootScope.isDefinedAndNotNull($scope.orderLine.booking)
					? $scope.orderLine.booking.id
					: -1;

			// check if creating / editing this orderline happens in the context of a booking (from a sub tab), if so we have to set the booking id from that perspective
			if ($stateParams.mappedBy === 'booking' && $rootScope.isDefinedAndNotNull($stateParams.mappedById)) {
				bookingId = $stateParams.mappedById;
			}

			return NoPagingArticleWithBookingFactory.query(
				{
					bookingId: bookingId,
				},
				function(result) {
					$scope.findItemByParent(result, 'article');
				}
			);
		};
		$scope.articleList = $scope.queryArticle();
		// --- end custom implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Origin and checks if this OrderLine dialog is called in the context of Origin.
		 * If this is the case, we detect the parent entity OrderLine and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryOrigin = function() {
			return NoPagingOrderLineOriginFactory.query(function(result) {
				$scope.findItemByParent(result, 'origin');
			});
		};
		$scope.originList = $scope.queryOrigin();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:orderLineUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving OrderLine failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.orderLine.booking === '') {
				$scope.orderLine.booking = null;
			}

			if ($scope.orderLine.id != null) {
				OrderLineFactory.update($scope.orderLine, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				OrderLineFactory.save($scope.orderLine, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};

		// executes when onchange is triggered for the OrderLine.Article reference listbox
		// goal is to set OrderLine.description based on chosen Article.description
		$scope.changeArticle = function(article) {
			if (article !== undefined) {
				$scope.orderLine.description = article.description;
				if ($scope.orderLine.numberOfArticles == undefined) {
					$scope.orderLine.numberOfArticles = 1;
				}
				$scope.orderLine.pricePerPiece = article.price;
				$scope.orderLine.price = article.price;
				$scope.changePrice();
			}
		};
		// executes when onchange is triggered for the OrderLine.numberOfArticles attribute
		// goal is to set OrderLine.price based on chosen OrderLine.pricePerPiece
		$scope.changePrice = function() {
			if ($scope.orderLine.pricePerPiece !== undefined) {
				$scope.orderLine.price = $scope.orderLine.numberOfArticles * $scope.orderLine.pricePerPiece;
			}
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('OrderLineDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.orderLine = entity;
	$scope.objectName = 'OrderLine';
	$scope.orderLineId = $stateParams.orderLineId;

	if (angular.isUndefined($rootScope.orderLineActiveTab)) {
		//set the default here
		$rootScope.orderLineActiveTab = 0;
	}

	$scope.goToEditState = function(orderLine) {
		$state.go('orderline.detail.edit({orderLineId:orderLine.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:orderLineUpdate', function(event, result) {
		$scope.orderLine = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'OrderLine'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('orderline'); // main translation loaded for orderline
		$translatePartialLoader.addPart('orderlineorigin'); // one to many reference from main entity
		$translatePartialLoader.addPart('booking'); // one to many reference from main entity
		$translatePartialLoader.addPart('bookingstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('confirmationemailstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/orderline/orderline-dialog.html';

		return {
			/* new state for entity orderLine */
			/* to access: ui-ref="orderline.list.new" */
			/* url: hostname/orderline/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'OrderLineDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'OrderLineFactory',
									'NewOrderLineFactory',
									function(OrderLineFactory, NewOrderLineFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new OrderLine
										// - resuming the creation of a new new OrderLine AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return OrderLineFactory.get({ id: $stateParams.orderLineId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewOrderLineFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for orderLine new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for orderLine edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('orderline', {
		/* abstract state for entity orderLine */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/orderline',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'OrderLines',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('orderline.list', {
		/* list state for entity orderLine */
		/* to access: ui-ref="orderline.list" */
		/* url: hostname/orderline/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/orderline/orderlines.html',
				controller: 'OrderLineController',
			},
		},
	});

	$stateProvider.state('orderline.detail', {
		/* detail state for entity orderLine */
		/* to access: ui-sref="orderline.detail" */
		/* url: hostname/orderline/detail/:orderLineId */
		url: '/detail/:orderLineId',
		views: {
			'content@': {
				templateUrl: 'app/entities/orderline/orderline-detail.html',
				controller: 'OrderLineDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'OrderLineFactory',
				function($stateParams, OrderLineFactory) {
					return OrderLineFactory.get({ id: $stateParams.orderLineId });
				},
			],
		},
	});

	/* url: http://<hostname>/orderline/list/new */
	$stateProvider.state('orderline.list.new', getNewState());
	/* url: http://<hostname>/orderline/list/:orderLineId/edit */
	$stateProvider.state('orderline.list.edit', getEditState('/:orderLineId/edit'));
	/* url: http://<hostname>/orderline/detail/:orderLineId/edit */
	$stateProvider.state('orderline.detail.edit', getEditState('/edit'));
	// Article.orderLine with multiplicity 0..n points to OrderLine
	/* url: http://<hostname>/article/detail/:articleId/orderline/new */
	$stateProvider.state('article.detail.newOrderLine', getNewState('/orderline/new'));
	/* url: http://<hostname>/article/detail/:articleId/orderline/:orderLineId/edit */
	$stateProvider.state('article.detail.editOrderLine', getEditState('/orderline/:orderLineId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-article/detail/:articleId/orderline/new */
	$stateProvider.state('user-article.detail.newOrderLine', getNewState('/orderline/new'));
	/* url: http://<hostname>/user-article/detail/:articleId/orderline/:orderLineId/edit */
	$stateProvider.state('user-article.detail.editOrderLine', getEditState('/orderline/:orderLineId/edit'));
	// Subscription.orderLine with multiplicity 0..n points to OrderLine
	/* url: http://<hostname>/subscription/detail/:subscriptionId/orderline/new */
	$stateProvider.state('subscription.detail.newOrderLine', getNewState('/orderline/new'));
	/* url: http://<hostname>/subscription/detail/:subscriptionId/orderline/:orderLineId/edit */
	$stateProvider.state('subscription.detail.editOrderLine', getEditState('/orderline/:orderLineId/edit'));
	// Booking.orderLine with multiplicity 0..n points to OrderLine
	/* url: http://<hostname>/booking/detail/:bookingId/orderline/new */
	$stateProvider.state('booking.detail.newOrderLine', getNewState('/orderline/new'));
	/* url: http://<hostname>/booking/detail/:bookingId/orderline/:orderLineId/edit */
	$stateProvider.state('booking.detail.editOrderLine', getEditState('/orderline/:orderLineId/edit'));
});

// CodeComposer:preserve:file => Don't override manual changes
/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('OrderLineTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		OrderLineFactory,
		FindAllOrderLinesByQueryParamsFactory,
		AutocompleteBookingsByQueryParamsFactory,
		NoPagingOrderLineFactory,
		NoPagingBookingFactory,
		NoPagingSubscriptionFactory,
		NoPagingArticleFactory
	) {
		$scope.orderLineList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeOrderLine)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeOrderLine);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeOrderLine = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newOrderLine', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(orderLine) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editOrderLine', {
				orderLineId: orderLine.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getOrderLineList = function() {
			$rootScope.$emit('emsApp:bookingDetailsRefreshTrigger');
			FindAllOrderLinesByQueryParamsFactory.query(
				{
					bookingId: angular.isDefined($scope.bookingId) ? $scope.bookingId : null,
					// Searching OrderLine by subscription supports multiple
					subscriptionIdList: angular.isDefined($scope.subscriptionId) ? [$scope.subscriptionId] : [],
					articleId: angular.isDefined($scope.articleId) ? $scope.articleId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.orderLineList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getOrderLineList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedOrderLineId = id;
			$('#deleteOrderLineConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			OrderLineFactory.delete(
				{ id: $scope.selectedOrderLineId },
				function() {
					$scope.loadAll();
					$('#deleteOrderLineConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteOrderLineConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('OrderLineController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		OrderLineFactory,
		FindAllOrderLinesByQueryParamsFactory,
		AutocompleteBookingsByQueryParamsFactory,
		NoPagingOrderLineFactory,
		NoPagingBookingFactory,
		NoPagingSubscriptionFactory,
		NoPagingArticleFactory,
		NoPagingOrderLineOriginFactory
	) {
		$scope.orderLineList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeOrderLine)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeOrderLine);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeOrderLine = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('orderline.list.new');
		};

		$scope.goToEditState = function(orderLine) {
			// this overview is NOT mapped, it is the main overview
			$state.go('orderline.list.edit', { orderLineId: orderLine.id });
		};

		var getBookingId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.OrderLineSearchOverview.booking)) {
				return $scope.OrderLineSearchOverview.booking.id;
			} else {
				return undefined;
			}
		};

		var getSubscriptionIdList = function() {
			return $rootScope.getListValues($scope.OrderLineSearchOverview.subscriptionIdList, 'id');
		};

		var getArticleId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.OrderLineSearchOverview.article)) {
				return $scope.OrderLineSearchOverview.article.id;
			} else {
				return undefined;
			}
		};

		$scope.autocompleteBookings = function(val) {
			var params = {
				bookingTypeAheadSearchString: val,
			};

			return AutocompleteBookingsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type Subscription and checks if this OrderLine dialog is called in the context of Subscription.
		 * If this is the case, we detect the parent entity OrderLine and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySubscription = function() {
			return NoPagingSubscriptionFactory.query(function(result) {
				return result;
			});
		};
		$scope.subscriptionReferenceFilterList = $scope.querySubscription();

		/**
		 * This function queries all entities of type Article and checks if this OrderLine dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity OrderLine and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return NoPagingArticleFactory.query(function(result) {
				return result;
			});
		};
		$scope.articleReferenceFilterList = $scope.queryArticle();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.OrderLineSearchOverview = angular.copy($scope.OrderLineSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeOrderLine = angular.copy($scope.pageSize);

			FindAllOrderLinesByQueryParamsFactory.query(
				{
					page: $scope.OrderLineSearchOverview.page - 1,
					size: $scope.pageSize,
					bookingId: getBookingId(),
					subscriptionIdList: getSubscriptionIdList(),
					articleId: getArticleId(),
					origin: $scope.OrderLineSearchOverview.origin,

					sort: [$scope.OrderLineSearchOverview.predicate + ',' + ($scope.OrderLineSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.orderLineList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.updateSubscriptionUISelect = function(item, model) {
			$scope.search();
		};
		$scope.isOrderLineSearchOverviewDirty = function() {
			return !angular.equals($scope.OrderLineSearchOverview, $scope.originalOrderLineSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.OrderLineSearchOverview = {};
			$rootScope.OrderLineSearchOverview.page = 1;
			$rootScope.OrderLineSearchOverview.predicate = 'id';
			$rootScope.OrderLineSearchOverview.ascending = false;

			$scope.OrderLineSearchOverview = angular.copy($rootScope.OrderLineSearchOverview);

			$scope.originalOrderLineSearchOverview = angular.copy($scope.OrderLineSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.OrderLineSearchOverview) || $rootScope.OrderLineSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.OrderLineSearchOverview = angular.copy($rootScope.OrderLineSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedOrderLineId = id;
			$('#deleteOrderLineConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			OrderLineFactory.delete(
				{ id: $scope.selectedOrderLineId },
				function() {
					$scope.search();
					$('#deleteOrderLineConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteOrderLineConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.OrderLineSearchOverview.predicate === itemName) {
				if ($scope.OrderLineSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('MailGroupDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		MailGroupFactory,
		AlertService,
		NoPagingMailGroupFactory,
		RelationFromRelationMailGroupPicklistUpdateFactory,
		NoPagingRelationFactory
	) {
		$scope.mailGroup = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.mailGroup) && $rootScope.isDefinedAndNotNull($scope.mailGroup.id);
		};

		$scope.submitButtonIsActive = true;

		var getSelectedListItems = function(allItems, selectedItemList) {
			var itemIDs = [];
			angular.forEach(selectedItemList, function(value, key) {
				itemIDs.push(value.id);
			});

			var selectedItems = [];
			angular.forEach(allItems, function(value, key) {
				angular.forEach(itemIDs, function(value2, key2) {
					if (value.id === value2) {
						selectedItems.push(value);
					}
				});
			});

			return selectedItems;
		};

		var tempSelectedRelationList = [];
		$scope.selectedRelationList = [];

		$scope.getSelectedRelationList = function() {
			RelationFromRelationMailGroupPicklistUpdateFactory.query({ id: $stateParams.mailGroupId }, function(result) {
				//put all selected Relation-items in a list
				angular.forEach(result, function(value, key) {
					tempSelectedRelationList.push(value);
				});
				NoPagingRelationFactory.query(function(result) {
					$scope.relationPickListOptions = result;
					$scope.selectedRelationList = getSelectedListItems(result, tempSelectedRelationList);
				});
			});
		};

		$scope.getRelationPickListOptions = function() {
			if ($stateParams.mailGroupId != null) {
				$scope.getSelectedRelationList();
			} else {
				NoPagingRelationFactory.query(function(result) {
					$scope.relationPickListOptions = result;
				});
			}
		};

		$scope.getRelationPickListOptions();

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:mailGroupUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving MailGroup failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.mailGroup.id != null) {
				MailGroupFactory.update(
					$scope.mailGroup,
					function(result) {
						$scope.mailGroup = result;

						if (
							!angular.isUndefined($scope.selectedRelationList) &&
							angular.isArray($scope.selectedRelationList) &&
							$scope.selectedRelationList.length > 0
						) {
							RelationFromRelationMailGroupPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedRelationList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			} else {
				MailGroupFactory.save(
					$scope.mailGroup,
					function(result) {
						$scope.mailGroup = result;

						if (
							!angular.isUndefined($scope.selectedRelationList) &&
							angular.isArray($scope.selectedRelationList) &&
							$scope.selectedRelationList.length > 0
						) {
							RelationFromRelationMailGroupPicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedRelationList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('MailGroupDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.mailGroup = entity;
	$scope.objectName = 'MailGroup';
	$scope.mailGroupId = $stateParams.mailGroupId;

	if (angular.isUndefined($rootScope.mailGroupActiveTab)) {
		//set the default here
		$rootScope.mailGroupActiveTab = 0;
	}

	$scope.goToEditState = function(mailGroup) {
		$state.go('mailgroup.detail.edit({mailGroupId:mailGroup.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:mailGroupUpdate', function(event, result) {
		$scope.mailGroup = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'MailGroup'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('mailgroup'); // main translation loaded for mailgroup
		$translatePartialLoader.addPart('relationmailgroup'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/mailgroup/mailgroup-dialog.html';

		return {
			/* new state for entity mailGroup */
			/* to access: ui-ref="mailgroup.list.new" */
			/* url: hostname/mailgroup/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'MailGroupDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'MailGroupFactory',
									'NewMailGroupFactory',
									function(MailGroupFactory, NewMailGroupFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return MailGroupFactory.get({ id: $stateParams.mailGroupId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewMailGroupFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for mailGroup new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for mailGroup edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('mailgroup', {
		/* abstract state for entity mailGroup */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/mailgroup',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'MailGroups',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('mailgroup.list', {
		/* list state for entity mailGroup */
		/* to access: ui-ref="mailgroup.list" */
		/* url: hostname/mailgroup/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/mailgroup/mailgroups.html',
				controller: 'MailGroupController',
			},
		},
	});

	$stateProvider.state('mailgroup.detail', {
		/* detail state for entity mailGroup */
		/* to access: ui-sref="mailgroup.detail" */
		/* url: hostname/mailgroup/detail/:mailGroupId */
		url: '/detail/:mailGroupId',
		views: {
			'content@': {
				templateUrl: 'app/entities/mailgroup/mailgroup-detail.html',
				controller: 'MailGroupDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'MailGroupFactory',
				function($stateParams, MailGroupFactory) {
					return MailGroupFactory.get({ id: $stateParams.mailGroupId });
				},
			],
		},
	});

	/* url: http://<hostname>/mailgroup/list/new */
	$stateProvider.state('mailgroup.list.new', getNewState());
	/* url: http://<hostname>/mailgroup/list/:mailGroupId/edit */
	$stateProvider.state('mailgroup.list.edit', getEditState('/:mailGroupId/edit'));
	/* url: http://<hostname>/mailgroup/detail/:mailGroupId/edit */
	$stateProvider.state('mailgroup.detail.edit', getEditState('/edit'));

	$stateProvider.state('relationmailgroup.list.newMailGroup', getNewState('/mailgroup/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('MailGroupTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		MailGroupFactory,
		FindAllMailGroupsByQueryParamsNonPageableFactory,
		NoPagingMailGroupFactory
	) {
		$scope.mailGroupList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newMailGroup', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(mailGroup) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editMailGroup', {
				mailGroupId: mailGroup.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.MailGroupSearchTab = angular.copy($scope.MailGroupSearchTab);

			FindAllMailGroupsByQueryParamsNonPageableFactory.query(
				{
					name: $scope.MailGroupSearchTab.name,

					sort: [$scope.MailGroupSearchTab.predicate + ',' + ($scope.MailGroupSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.mailGroupList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isMailGroupSearchTabDirty = function() {
			return !angular.equals($scope.MailGroupSearchTab, $scope.originalMailGroupSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.MailGroupSearchTab = {};
			$rootScope.MailGroupSearchTab.predicate = 'id';
			$rootScope.MailGroupSearchTab.ascending = false;

			$scope.MailGroupSearchTab = angular.copy($rootScope.MailGroupSearchTab);

			$scope.originalMailGroupSearchTab = angular.copy($scope.MailGroupSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.MailGroupSearchTab) || $rootScope.MailGroupSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.MailGroupSearchTab = angular.copy($rootScope.MailGroupSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedMailGroupId = id;
			$('#deleteMailGroupConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			MailGroupFactory.delete(
				{ id: $scope.selectedMailGroupId },
				function() {
					$scope.search();
					$('#deleteMailGroupConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteMailGroupConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.MailGroupSearchTab.predicate === itemName) {
				if ($scope.MailGroupSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('MailGroupController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		MailGroupFactory,
		FindAllMailGroupsByQueryParamsNonPageableFactory,
		NoPagingMailGroupFactory
	) {
		$scope.mailGroupList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('mailgroup.list.new');
		};

		$scope.goToEditState = function(mailGroup) {
			// this overview is NOT mapped, it is the main overview
			$state.go('mailgroup.list.edit', { mailGroupId: mailGroup.id });
		};

		$scope.getMailGroupList = function() {
			FindAllMailGroupsByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.mailGroupList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getMailGroupList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedMailGroupId = id;
			$('#deleteMailGroupConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			MailGroupFactory.delete(
				{ id: $scope.selectedMailGroupId },
				function() {
					$scope.loadAll();
					$('#deleteMailGroupConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteMailGroupConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('LocationTemplateEventArticleDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		LocationTemplateEventArticleFactory,
		AlertService,
		NoPagingLocationTemplateEventArticleFactory,
		NoPagingLocationFactory,
		NoPagingTemplateEventFactory,
		NoPagingPredefinedArticleTypeFactory,
		NoPagingArticleFactory,
		LocationTemplateEventArticleFindArticleFilteredByArticleFactory
	) {
		$scope.locationTemplateEventArticle = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return (
				$rootScope.isDefinedAndNotNull($scope.locationTemplateEventArticle) &&
				$rootScope.isDefinedAndNotNull($scope.locationTemplateEventArticle.id)
			);
		};

		$scope.createArticle = function() {
			var referredBy = {
				refName: 'article',
				data: $scope.locationTemplateEventArticle,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new article will add this new locationtemplateeventarticle state to the history stack
				$state.go('locationtemplateeventarticle.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('locationTemplateEventArticle.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type Location and checks if this LocationTemplateEventArticle dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				$scope.findItemByParent(result, 'location');
			});
		};
		$scope.locationList = $scope.queryLocation();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type TemplateEvent and checks if this LocationTemplateEventArticle dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				$scope.findItemByParent(result, 'templateEvent');
			});
		};
		$scope.templateEventList = $scope.queryTemplateEvent();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type PredefinedArticleType and checks if this LocationTemplateEventArticle dialog is called in the context of PredefinedArticleType.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryPredefinedArticleType = function() {
			return NoPagingPredefinedArticleTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'predefinedArticleType');
			});
		};
		$scope.predefinedArticleTypeList = $scope.queryPredefinedArticleType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Article and checks if this LocationTemplateEventArticle dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return LocationTemplateEventArticleFindArticleFilteredByArticleFactory.query(function(result) {
				$scope.findItemByParent(result, 'article');
			});
		};
		$scope.articleList = $scope.queryArticle();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:locationTemplateEventArticleUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving LocationTemplateEventArticle failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.locationTemplateEventArticle.id != null) {
				LocationTemplateEventArticleFactory.update($scope.locationTemplateEventArticle, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				LocationTemplateEventArticleFactory.save($scope.locationTemplateEventArticle, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('LocationTemplateEventArticleDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
		$scope.locationTemplateEventArticle = entity;
		$scope.objectName = 'LocationTemplateEventArticle';
		$scope.locationTemplateEventArticleId = $stateParams.locationTemplateEventArticleId;

		if (angular.isUndefined($rootScope.locationTemplateEventArticleActiveTab)) {
			//set the default here
			$rootScope.locationTemplateEventArticleActiveTab = 0;
		}

		$scope.goToEditState = function(locationTemplateEventArticle) {
			$state.go(
				'locationtemplateeventarticle.detail.edit({locationTemplateEventArticleId:locationTemplateEventArticle.id, mappedBy:mappedBy, mappedById:mappedById})'
			);
		};

		// by broadcasting this event from an edit dialog the model is refreshed
		$rootScope.$on('emsApp:locationTemplateEventArticleUpdate', function(event, result) {
			$scope.locationTemplateEventArticle = result;
		});
	});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'LocationTemplateEventArticle'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('locationtemplateeventarticle'); // main translation loaded for locationtemplateeventarticle
		$translatePartialLoader.addPart('predefinedarticletype'); // one to many reference from main entity
		$translatePartialLoader.addPart('location'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/locationtemplateeventarticle/locationtemplateeventarticle-dialog.html';

		return {
			/* new state for entity locationTemplateEventArticle */
			/* to access: ui-ref="locationtemplateeventarticle.list.new" */
			/* url: hostname/locationtemplateeventarticle/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'LocationTemplateEventArticleDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'LocationTemplateEventArticleFactory',
									'NewLocationTemplateEventArticleFactory',
									function(LocationTemplateEventArticleFactory, NewLocationTemplateEventArticleFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new LocationTemplateEventArticle
										// - resuming the creation of a new new LocationTemplateEventArticle AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return LocationTemplateEventArticleFactory.get({ id: $stateParams.locationTemplateEventArticleId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewLocationTemplateEventArticleFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for locationTemplateEventArticle new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for locationTemplateEventArticle edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('locationtemplateeventarticle', {
		/* abstract state for entity locationTemplateEventArticle */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/locationtemplateeventarticle',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'LocationTemplateEventArticles',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('locationtemplateeventarticle.list', {
		/* list state for entity locationTemplateEventArticle */
		/* to access: ui-ref="locationtemplateeventarticle.list" */
		/* url: hostname/locationtemplateeventarticle/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/locationtemplateeventarticle/locationtemplateeventarticles.html',
				controller: 'LocationTemplateEventArticleController',
			},
		},
	});

	$stateProvider.state('locationtemplateeventarticle.detail', {
		/* detail state for entity locationTemplateEventArticle */
		/* to access: ui-sref="locationtemplateeventarticle.detail" */
		/* url: hostname/locationtemplateeventarticle/detail/:locationTemplateEventArticleId */
		url: '/detail/:locationTemplateEventArticleId',
		views: {
			'content@': {
				templateUrl: 'app/entities/locationtemplateeventarticle/locationtemplateeventarticle-detail.html',
				controller: 'LocationTemplateEventArticleDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'LocationTemplateEventArticleFactory',
				function($stateParams, LocationTemplateEventArticleFactory) {
					return LocationTemplateEventArticleFactory.get({ id: $stateParams.locationTemplateEventArticleId });
				},
			],
		},
	});

	/* url: http://<hostname>/locationtemplateeventarticle/list/new */
	$stateProvider.state('locationtemplateeventarticle.list.new', getNewState());
	/* url: http://<hostname>/locationtemplateeventarticle/list/:locationTemplateEventArticleId/edit */
	$stateProvider.state('locationtemplateeventarticle.list.edit', getEditState('/:locationTemplateEventArticleId/edit'));
	/* url: http://<hostname>/locationtemplateeventarticle/detail/:locationTemplateEventArticleId/edit */
	$stateProvider.state('locationtemplateeventarticle.detail.edit', getEditState('/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('LocationTemplateEventArticleTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		LocationTemplateEventArticleFactory,
		FindAllLocationTemplateEventArticlesByQueryParamsFactory,
		NoPagingLocationTemplateEventArticleFactory,
		NoPagingLocationFactory,
		NoPagingTemplateEventFactory,
		NoPagingPredefinedArticleTypeFactory,
		NoPagingArticleFactory,
		LocationTemplateEventArticleFindArticleFilteredByArticleFactory
	) {
		$scope.locationTemplateEventArticleList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeLocationTemplateEventArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeLocationTemplateEventArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeLocationTemplateEventArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newLocationTemplateEventArticle', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(locationTemplateEventArticle) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editLocationTemplateEventArticle', {
				locationTemplateEventArticleId: locationTemplateEventArticle.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getLocationTemplateEventArticleList = function() {
			FindAllLocationTemplateEventArticlesByQueryParamsFactory.query(
				{
					locationId: angular.isDefined($scope.locationId) ? $scope.locationId : null,
					templateEventId: angular.isDefined($scope.templateEventId) ? $scope.templateEventId : null,
					predefinedArticleTypeId: angular.isDefined($scope.predefinedArticleTypeId) ? $scope.predefinedArticleTypeId : null,
					articleId: angular.isDefined($scope.articleId) ? $scope.articleId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.locationTemplateEventArticleList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getLocationTemplateEventArticleList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedLocationTemplateEventArticleId = id;
			$('#deleteLocationTemplateEventArticleConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			LocationTemplateEventArticleFactory.delete(
				{ id: $scope.selectedLocationTemplateEventArticleId },
				function() {
					$scope.loadAll();
					$('#deleteLocationTemplateEventArticleConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteLocationTemplateEventArticleConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('LocationTemplateEventArticleController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		LocationTemplateEventArticleFactory,
		FindAllLocationTemplateEventArticlesByQueryParamsFactory,
		NoPagingLocationTemplateEventArticleFactory,
		NoPagingLocationFactory,
		NoPagingTemplateEventFactory,
		NoPagingPredefinedArticleTypeFactory,
		NoPagingArticleFactory,
		LocationTemplateEventArticleFindArticleFilteredByArticleFactory
	) {
		$scope.locationTemplateEventArticleList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeLocationTemplateEventArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeLocationTemplateEventArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeLocationTemplateEventArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('locationtemplateeventarticle.list.new');
		};

		$scope.goToEditState = function(locationTemplateEventArticle) {
			// this overview is NOT mapped, it is the main overview
			$state.go('locationtemplateeventarticle.list.edit', { locationTemplateEventArticleId: locationTemplateEventArticle.id });
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.LocationTemplateEventArticleSearchOverview.location)) {
				return $scope.LocationTemplateEventArticleSearchOverview.location.id;
			} else {
				return undefined;
			}
		};

		var getTemplateEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.LocationTemplateEventArticleSearchOverview.templateEvent)) {
				return $scope.LocationTemplateEventArticleSearchOverview.templateEvent.id;
			} else {
				return undefined;
			}
		};

		var getArticleId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.LocationTemplateEventArticleSearchOverview.article)) {
				return $scope.LocationTemplateEventArticleSearchOverview.article.id;
			} else {
				return undefined;
			}
		};

		/**
		 * This function queries all entities of type Location and checks if this LocationTemplateEventArticle dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				return result;
			});
		};
		$scope.locationReferenceFilterList = $scope.queryLocation();

		/**
		 * This function queries all entities of type TemplateEvent and checks if this LocationTemplateEventArticle dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				return result;
			});
		};
		$scope.templateEventReferenceFilterList = $scope.queryTemplateEvent();

		/**
		 * This function queries all entities of type Article and checks if this LocationTemplateEventArticle dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return LocationTemplateEventArticleFindArticleFilteredByArticleFactory.query(function(result) {
				return result;
			});
		};
		$scope.articleReferenceFilterList = $scope.queryArticle();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.LocationTemplateEventArticleSearchOverview = angular.copy($scope.LocationTemplateEventArticleSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeLocationTemplateEventArticle = angular.copy($scope.pageSize);

			FindAllLocationTemplateEventArticlesByQueryParamsFactory.query(
				{
					page: $scope.LocationTemplateEventArticleSearchOverview.page - 1,
					size: $scope.pageSize,
					locationId: getLocationId(),
					templateEventId: getTemplateEventId(),
					predefinedArticleType: $scope.LocationTemplateEventArticleSearchOverview.predefinedArticleType,
					articleId: getArticleId(),

					sort: [
						$scope.LocationTemplateEventArticleSearchOverview.predicate +
							',' +
							($scope.LocationTemplateEventArticleSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.locationTemplateEventArticleList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isLocationTemplateEventArticleSearchOverviewDirty = function() {
			return !angular.equals($scope.LocationTemplateEventArticleSearchOverview, $scope.originalLocationTemplateEventArticleSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.LocationTemplateEventArticleSearchOverview = {};
			$rootScope.LocationTemplateEventArticleSearchOverview.page = 1;
			$rootScope.LocationTemplateEventArticleSearchOverview.predicate = 'id';
			$rootScope.LocationTemplateEventArticleSearchOverview.ascending = false;

			$scope.LocationTemplateEventArticleSearchOverview = angular.copy($rootScope.LocationTemplateEventArticleSearchOverview);

			$scope.originalLocationTemplateEventArticleSearchOverview = angular.copy($scope.LocationTemplateEventArticleSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (
				angular.isUndefined($rootScope.LocationTemplateEventArticleSearchOverview) ||
				$rootScope.LocationTemplateEventArticleSearchOverview === null
			) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.LocationTemplateEventArticleSearchOverview = angular.copy($rootScope.LocationTemplateEventArticleSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedLocationTemplateEventArticleId = id;
			$('#deleteLocationTemplateEventArticleConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			LocationTemplateEventArticleFactory.delete(
				{ id: $scope.selectedLocationTemplateEventArticleId },
				function() {
					$scope.search();
					$('#deleteLocationTemplateEventArticleConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteLocationTemplateEventArticleConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.LocationTemplateEventArticleSearchOverview.predicate === itemName) {
				if ($scope.LocationTemplateEventArticleSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

// Created by frontend/angular/entity/controller/dto-edit.ftl
angular
	.module('emsApp')
	.controller('UserLocationEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserLocationEditDtoFactory,
		AlertService,
		HistoryService
	) {
		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.submitButtonIsActive = true;
		};

		$scope.location = entity;
		$scope.submitButtonIsActive = true;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		//This function preselects and disables the parent reference when called from tab
		$scope.location['selected' + _.upperFirst($stateParams.mappedBy)] = {
			id: $stateParams.mappedById,
			displayValue: $stateParams.mappedByDisplayValue,
		};

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.location) && $rootScope.isDefinedAndNotNull($scope.location.id);
		};

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:locationUpdate', result);
			$scope.submitButtonIsActive = true;
			// process success result, if necessary
			if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
				console.log('as we came on this create new page from plus button we will update history');

				// set relation as reference in the referredBy data model
				$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;

				// update previous state
				HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
			}
			$rootScope.back();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;
			UserLocationEditDtoFactory.update($scope.location, onSaveFinishedCallback, saveOrUpdateErrorCallback);
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('LocationDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		LocationFactory,
		AlertService,
		NoPagingLocationFactory,
		NoPagingCountryFactory
	) {
		$scope.location = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.location) && $rootScope.isDefinedAndNotNull($scope.location.id);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('location.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type DeliveryAddressCountry and checks if this Location dialog is called in the context of DeliveryAddressCountry.
		 * If this is the case, we detect the parent entity Location and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryDeliveryAddressCountry = function() {
			return NoPagingCountryFactory.query(function(result) {
				$scope.findItemByParent(result, 'deliveryAddressCountry');
			});
		};
		$scope.deliveryAddressCountryList = $scope.queryDeliveryAddressCountry();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:locationUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Location failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.location.id != null) {
				LocationFactory.update($scope.location, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				LocationFactory.save($scope.location, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('LocationDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.location = entity;
	$scope.objectName = 'Location';
	$scope.locationId = $stateParams.locationId;

	if (angular.isUndefined($rootScope.locationActiveTab)) {
		//set the default here
		$rootScope.locationActiveTab = 0;
	}

	$scope.goToEditState = function(location) {
		$state.go('location.detail.edit({locationId:location.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:locationUpdate', function(event, result) {
		$scope.location = result;
	});
});

/** @format */

'use strict';

// Location has edit layout enabled. Edit layout template url: location-dialog.html
angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Location'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('location'); // main translation loaded for location
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('document'); // one to many reference from main entity
		$translatePartialLoader.addPart('country'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/location/location-dialog.html';

		return {
			/* new state for entity location */
			/* to access: ui-ref="location.list.new" */
			/* url: hostname/location/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'LocationDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'LocationFactory',
									'NewLocationFactory',
									function(LocationFactory, NewLocationFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Location
										// - resuming the creation of a new new Location AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return LocationFactory.get({ id: $stateParams.locationId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewLocationFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for location new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for location edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('location', {
		/* abstract state for entity location */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/location',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Locations',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('location.list', {
		/* list state for entity location */
		/* to access: ui-ref="location.list" */
		/* url: hostname/location/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/location/locations.html',
				controller: 'LocationController',
			},
		},
	});

	$stateProvider.state('location.detail', {
		/* detail state for entity location */
		/* to access: ui-sref="location.detail" */
		/* url: hostname/location/detail/:locationId */
		url: '/detail/:locationId',
		views: {
			'content@': {
				templateUrl: 'app/entities/location/location-detail.html',
				controller: 'LocationDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'LocationFactory',
				function($stateParams, LocationFactory) {
					return LocationFactory.get({ id: $stateParams.locationId });
				},
			],
		},
	});

	/* url: http://<hostname>/location/list/new */
	$stateProvider.state('location.list.new', getNewState());
	/* url: http://<hostname>/location/list/:locationId/edit */
	$stateProvider.state('location.list.edit', getEditState('/:locationId/edit'));
	/* url: http://<hostname>/location/detail/:locationId/edit */
	$stateProvider.state('location.detail.edit', getEditState('/edit'));

	$stateProvider.state('event.list.newLocation', getNewState('/location/new'));
	$stateProvider.state('document.list.newLocation', getNewState('/location/new'));

	$stateProvider.state('user-location', {
		/* abstract state for DTO UserLocationListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/location',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'Location',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* edit state for DTO user */
	var dtoEditState = {
		/* edit state for DTO UserLocationEditDto */
		/* to access: ui-sref="user-location.edit" */
		/* url: http://<hostname>/user/location/edit/:locationId */
		url: '/edit/:locationId',
		views: {
			'content@': {
				templateUrl: 'app/entities/location/location-edit-user.html',
				controller: 'UserLocationEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserLocationEditDtoFactory',
				function($stateParams, $rootScope, UserLocationEditDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserLocationEditDtoFactory.get({ id: $stateParams.locationId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-location.edit', dtoEditState);

	/* new (create) state for DTO user */
	var dtoCreateState = {
		/* new state for DTO UserLocationEditDto */
		/* to access: ui-sref="user-location.new" */
		/* url: http://<hostname>/user/location/new */
		url: '/new',
		views: {
			'content@': {
				templateUrl: 'app/entities/location/location-edit-user.html',
				controller: 'UserLocationEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserLocationNewDtoFactory',
				function($stateParams, $rootScope, UserLocationNewDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserLocationNewDtoFactory.get({ id: $stateParams.locationId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-location.new', dtoCreateState);

	// create state for plus button on Event edit / new page for reference Location and dto property value user
	$stateProvider.state('user-event.new.newLocation', getCreateState('/location/new'));
	$stateProvider.state('user-event.edit.newLocation', getCreateState('/location/new'));
	// create state for plus button on Document edit / new page for reference Location and dto property value user
	$stateProvider.state('user-document.new.newLocation', getCreateState('/location/new'));
	$stateProvider.state('user-document.edit.newLocation', getCreateState('/location/new'));
	// retrieve the create state object, and update the url in the state object as the default create state only adds "/new" to the location url, while we want the url to contain "/location/new"
	function getCreateState(url) {
		var clonedDtoCreateState = Object.assign({}, dtoCreateState);
		clonedDtoCreateState.url = url;
		return clonedDtoCreateState;
	}
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('LocationTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		LocationFactory,
		FindAllLocationsByQueryParamsFactory,
		NoPagingLocationFactory,
		NoPagingCountryFactory
	) {
		$scope.locationList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeLocation)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeLocation);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeLocation = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newLocation', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(location) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editLocation', {
				locationId: location.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		var getDeliveryAddressCountryIdList = function() {
			if ($rootScope.isDefinedAndNotNull($scope.deliveryAddressCountryId)) {
				return $scope.deliveryAddressCountryId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.LocationSearchTab.deliveryAddressCountryIdList)) {
					return $rootScope.getListValues($scope.LocationSearchTab.deliveryAddressCountryIdList, 'id');
				} else {
					return undefined;
				}
			}
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.LocationSearchTab = angular.copy($scope.LocationSearchTab);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeLocation = angular.copy($scope.pageSize);

			FindAllLocationsByQueryParamsFactory.query(
				{
					page: $scope.LocationSearchTab.page - 1,
					size: $scope.pageSize,
					name: $scope.LocationSearchTab.name,
					description: $scope.LocationSearchTab.description,
					deliveryContactPerson: $scope.LocationSearchTab.deliveryContactPerson,
					deliveryAddressStreet: $scope.LocationSearchTab.deliveryAddressStreet,
					deliveryAddressZip: $scope.LocationSearchTab.deliveryAddressZip,
					deliveryAddressCity: $scope.LocationSearchTab.deliveryAddressCity,
					deliveryAddressCountryIdList: getDeliveryAddressCountryIdList(),

					sort: [$scope.LocationSearchTab.predicate + ',' + ($scope.LocationSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.locationList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.updateDeliveryAddressCountryUISelect = function(item, model) {
			$scope.search();
		};
		$scope.isLocationSearchTabDirty = function() {
			return !angular.equals($scope.LocationSearchTab, $scope.originalLocationSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.LocationSearchTab = {};
			$rootScope.LocationSearchTab.page = 1;
			$rootScope.LocationSearchTab.predicate = 'id';
			$rootScope.LocationSearchTab.ascending = false;

			$scope.LocationSearchTab = angular.copy($rootScope.LocationSearchTab);

			$scope.originalLocationSearchTab = angular.copy($scope.LocationSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.LocationSearchTab) || $rootScope.LocationSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.LocationSearchTab = angular.copy($rootScope.LocationSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedLocationId = id;
			$('#deleteLocationConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			LocationFactory.delete(
				{ id: $scope.selectedLocationId },
				function() {
					$scope.search();
					$('#deleteLocationConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteLocationConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.LocationSearchTab.predicate === itemName) {
				if ($scope.LocationSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('LocationController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		LocationFactory,
		FindAllLocationsByQueryParamsFactory,
		NoPagingLocationFactory,
		NoPagingCountryFactory
	) {
		$scope.locationList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeLocation)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeLocation);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeLocation = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('location.list.new');
		};

		$scope.goToEditState = function(location) {
			// this overview is NOT mapped, it is the main overview
			$state.go('location.list.edit', { locationId: location.id });
		};

		$scope.getLocationList = function() {
			FindAllLocationsByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.locationList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getLocationList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedLocationId = id;
			$('#deleteLocationConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			LocationFactory.delete(
				{ id: $scope.selectedLocationId },
				function() {
					$scope.loadAll();
					$('#deleteLocationConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteLocationConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('InstructorDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		InstructorFactory,
		AlertService,
		NoPagingInstructorFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		EventFactory,
		NoPagingEventFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingArticleFactory,
		NoPagingSubscriptionStatusFactory,
		InstructorFindArticleFilteredByHotelFactory
	) {
		$scope.instructor = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.instructor) && $rootScope.isDefinedAndNotNull($scope.instructor.id);
		};

		$scope.createRelation = function() {
			var referredBy = {
				refName: 'relation',
				data: $scope.instructor,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new relation will add this new instructor state to the history stack
				$state.go('instructor.list.newRelation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createStatus = function() {
			var referredBy = {
				refName: 'status',
				data: $scope.instructor,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new status will add this new instructor state to the history stack
				$state.go('instructor.list.newSubscriptionStatus', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};
		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('instructor.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryRelation = function() {
			// If the id of a preselected relation is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'relation');
					}
				});
			}
		};
		$scope.relationList = $scope.queryRelation();

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryEvent = function() {
			// If the id of a preselected event is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return EventFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'event');
					}
				});
			}
		};
		$scope.eventList = $scope.queryEvent();

		// --- start default implementation
		/**
		 * This function queries all entities of type Hotel and checks if this Instructor dialog is called in the context of Hotel.
		 * If this is the case, we detect the parent entity Instructor and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryHotel = function() {
			return InstructorFindArticleFilteredByHotelFactory.query(function(result) {
				$scope.findItemByParent(result, 'hotel');
			});
		};
		$scope.hotelList = $scope.queryHotel();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Status and checks if this Instructor dialog is called in the context of Status.
		 * If this is the case, we detect the parent entity Instructor and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryStatus = function() {
			return NoPagingSubscriptionStatusFactory.query(function(result) {
				$scope.findItemByParent(result, 'status');
			});
		};
		$scope.statusList = $scope.queryStatus();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:instructorUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Instructor failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.instructor.relation === '') {
				$scope.instructor.relation = null;
			}
			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.instructor.event === '') {
				$scope.instructor.event = null;
			}

			if ($scope.instructor.id != null) {
				InstructorFactory.update($scope.instructor, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				InstructorFactory.save($scope.instructor, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('InstructorDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.instructor = entity;
	$scope.objectName = 'Instructor';
	$scope.instructorId = $stateParams.instructorId;

	if (angular.isUndefined($rootScope.instructorActiveTab)) {
		//set the default here
		$rootScope.instructorActiveTab = 0;
	}

	$scope.goToEditState = function(instructor) {
		$state.go('instructor.detail.edit({instructorId:instructor.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:instructorUpdate', function(event, result) {
		$scope.instructor = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Instructor'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('instructor'); // main translation loaded for instructor
		$translatePartialLoader.addPart('subscriptionstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/instructor/instructor-dialog.html';

		return {
			/* new state for entity instructor */
			/* to access: ui-ref="instructor.list.new" */
			/* url: hostname/instructor/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'InstructorDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'InstructorFactory',
									'NewInstructorFactory',
									function(InstructorFactory, NewInstructorFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Instructor
										// - resuming the creation of a new new Instructor AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return InstructorFactory.get({ id: $stateParams.instructorId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewInstructorFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for instructor new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for instructor edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('instructor', {
		/* abstract state for entity instructor */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/instructor',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Instructors',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('instructor.list', {
		/* list state for entity instructor */
		/* to access: ui-ref="instructor.list" */
		/* url: hostname/instructor/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/instructor/instructors.html',
				controller: 'InstructorController',
			},
		},
	});

	$stateProvider.state('instructor.detail', {
		/* detail state for entity instructor */
		/* to access: ui-sref="instructor.detail" */
		/* url: hostname/instructor/detail/:instructorId */
		url: '/detail/:instructorId',
		views: {
			'content@': {
				templateUrl: 'app/entities/instructor/instructor-detail.html',
				controller: 'InstructorDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'InstructorFactory',
				function($stateParams, InstructorFactory) {
					return InstructorFactory.get({ id: $stateParams.instructorId });
				},
			],
		},
	});

	/* url: http://<hostname>/instructor/list/new */
	$stateProvider.state('instructor.list.new', getNewState());
	/* url: http://<hostname>/instructor/list/:instructorId/edit */
	$stateProvider.state('instructor.list.edit', getEditState('/:instructorId/edit'));
	/* url: http://<hostname>/instructor/detail/:instructorId/edit */
	$stateProvider.state('instructor.detail.edit', getEditState('/edit'));
	// Relation.instructor with multiplicity 0..n points to Instructor
	/* url: http://<hostname>/relation/detail/:relationId/instructor/new */
	$stateProvider.state('relation.detail.newInstructor', getNewState('/instructor/new'));
	/* url: http://<hostname>/relation/detail/:relationId/instructor/:instructorId/edit */
	$stateProvider.state('relation.detail.editInstructor', getEditState('/instructor/:instructorId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/instructor/new */
	$stateProvider.state('user-relation.detail.newInstructor', getNewState('/instructor/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/instructor/:instructorId/edit */
	$stateProvider.state('user-relation.detail.editInstructor', getEditState('/instructor/:instructorId/edit'));
	// Event.instructor with multiplicity 0..n points to Instructor
	/* url: http://<hostname>/event/detail/:eventId/instructor/new */
	$stateProvider.state('event.detail.newInstructor', getNewState('/instructor/new'));
	/* url: http://<hostname>/event/detail/:eventId/instructor/:instructorId/edit */
	$stateProvider.state('event.detail.editInstructor', getEditState('/instructor/:instructorId/edit'));

	$stateProvider.state('subscription.list.newInstructor', getNewState('/instructor/new'));

	$stateProvider.state('event.detail.booking.newInstructor', getNewState('/instructor/new'));
	$stateProvider.state('event.detail.subscriptions.newInstructor', getNewState('/instructor/new'));
	$stateProvider.state('event.detail.subscriptions.editInstructor', getEditState('/instructor/:instructorId/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('InstructorTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		InstructorFactory,
		FindAllInstructorsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingInstructorFactory,
		NoPagingRelationFactory,
		NoPagingEventFactory,
		NoPagingArticleFactory,
		NoPagingSubscriptionStatusFactory,
		InstructorFindArticleFilteredByHotelFactory
	) {
		$scope.instructorList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeInstructor)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeInstructor);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeInstructor = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newInstructor', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(instructor) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editInstructor', {
				instructorId: instructor.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getInstructorList = function() {
			FindAllInstructorsByQueryParamsFactory.query(
				{
					relationId: angular.isDefined($scope.relationId) ? $scope.relationId : null,
					eventId: angular.isDefined($scope.eventId) ? $scope.eventId : null,
					hotelId: angular.isDefined($scope.hotelId) ? $scope.hotelId : null,
					statusId: angular.isDefined($scope.statusId) ? $scope.statusId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.instructorList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getInstructorList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedInstructorId = id;
			$('#deleteInstructorConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			InstructorFactory.delete(
				{ id: $scope.selectedInstructorId },
				function() {
					$scope.loadAll();
					$('#deleteInstructorConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteInstructorConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('InstructorController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		InstructorFactory,
		FindAllInstructorsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingInstructorFactory,
		NoPagingRelationFactory,
		NoPagingEventFactory,
		NoPagingArticleFactory,
		NoPagingSubscriptionStatusFactory,
		InstructorFindArticleFilteredByHotelFactory
	) {
		$scope.instructorList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeInstructor)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeInstructor);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeInstructor = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('instructor.list.new');
		};

		$scope.goToEditState = function(instructor) {
			// this overview is NOT mapped, it is the main overview
			$state.go('instructor.list.edit', { instructorId: instructor.id });
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.InstructorSearchOverview.relation)) {
				return $scope.InstructorSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.InstructorSearchOverview.event)) {
				return $scope.InstructorSearchOverview.event.id;
			} else {
				return undefined;
			}
		};

		var getHotelId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.InstructorSearchOverview.hotel)) {
				return $scope.InstructorSearchOverview.hotel.id;
			} else {
				return undefined;
			}
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.InstructorSearchOverview = angular.copy($scope.InstructorSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeInstructor = angular.copy($scope.pageSize);

			FindAllInstructorsByQueryParamsFactory.query(
				{
					page: $scope.InstructorSearchOverview.page - 1,
					size: $scope.pageSize,
					description: $scope.InstructorSearchOverview.description,
					relationId: getRelationId(),
					eventId: getEventId(),
					hotelId: getHotelId(),
					status: $scope.InstructorSearchOverview.status,

					sort: [$scope.InstructorSearchOverview.predicate + ',' + ($scope.InstructorSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.instructorList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isInstructorSearchOverviewDirty = function() {
			return !angular.equals($scope.InstructorSearchOverview, $scope.originalInstructorSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.InstructorSearchOverview = {};
			$rootScope.InstructorSearchOverview.page = 1;
			$rootScope.InstructorSearchOverview.predicate = 'id';
			$rootScope.InstructorSearchOverview.ascending = false;

			$scope.InstructorSearchOverview = angular.copy($rootScope.InstructorSearchOverview);

			$scope.originalInstructorSearchOverview = angular.copy($scope.InstructorSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.InstructorSearchOverview) || $rootScope.InstructorSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.InstructorSearchOverview = angular.copy($rootScope.InstructorSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedInstructorId = id;
			$('#deleteInstructorConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			InstructorFactory.delete(
				{ id: $scope.selectedInstructorId },
				function() {
					$scope.search();
					$('#deleteInstructorConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteInstructorConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.InstructorSearchOverview.predicate === itemName) {
				if ($scope.InstructorSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('EventTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		EventTypeFactory,
		AlertService,
		NoPagingEventTypeFactory,
		SalesFilterFromSalesFilterEventTypePicklistUpdateFactory,
		NoPagingSalesFilterFactory
	) {
		$scope.eventType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.eventType) && $rootScope.isDefinedAndNotNull($scope.eventType.id);
		};

		$scope.submitButtonIsActive = true;

		var getSelectedListItems = function(allItems, selectedItemList) {
			var itemIDs = [];
			angular.forEach(selectedItemList, function(value, key) {
				itemIDs.push(value.id);
			});

			var selectedItems = [];
			angular.forEach(allItems, function(value, key) {
				angular.forEach(itemIDs, function(value2, key2) {
					if (value.id === value2) {
						selectedItems.push(value);
					}
				});
			});

			return selectedItems;
		};

		var tempSelectedSalesFilterList = [];
		$scope.selectedSalesFilterList = [];

		$scope.getSelectedSalesFilterList = function() {
			SalesFilterFromSalesFilterEventTypePicklistUpdateFactory.query({ id: $stateParams.eventTypeId }, function(result) {
				//put all selected SalesFilter-items in a list
				angular.forEach(result, function(value, key) {
					tempSelectedSalesFilterList.push(value);
				});
				NoPagingSalesFilterFactory.query(function(result) {
					$scope.salesFilterPickListOptions = result;
					$scope.selectedSalesFilterList = getSelectedListItems(result, tempSelectedSalesFilterList);
				});
			});
		};

		$scope.getSalesFilterPickListOptions = function() {
			if ($stateParams.eventTypeId != null) {
				$scope.getSelectedSalesFilterList();
			} else {
				NoPagingSalesFilterFactory.query(function(result) {
					$scope.salesFilterPickListOptions = result;
				});
			}
		};

		$scope.getSalesFilterPickListOptions();

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:eventTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving EventType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.eventType.id != null) {
				EventTypeFactory.update(
					$scope.eventType,
					function(result) {
						$scope.eventType = result;

						if (
							!angular.isUndefined($scope.selectedSalesFilterList) &&
							angular.isArray($scope.selectedSalesFilterList) &&
							$scope.selectedSalesFilterList.length > 0
						) {
							SalesFilterFromSalesFilterEventTypePicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedSalesFilterList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			} else {
				EventTypeFactory.save(
					$scope.eventType,
					function(result) {
						$scope.eventType = result;

						if (
							!angular.isUndefined($scope.selectedSalesFilterList) &&
							angular.isArray($scope.selectedSalesFilterList) &&
							$scope.selectedSalesFilterList.length > 0
						) {
							SalesFilterFromSalesFilterEventTypePicklistUpdateFactory.update(
								{ id: result.id },
								$scope.selectedSalesFilterList,
								function(successResult) {
									onSaveFinishedCallback(successResult);
								},
								function(error) {}
							);
						} else {
							onSaveFinishedCallback(result);
						} // if
					},
					saveOrUpdateErrorCallback
				);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('EventTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.eventType = entity;
	$scope.objectName = 'EventType';
	$scope.eventTypeId = $stateParams.eventTypeId;

	if (angular.isUndefined($rootScope.eventTypeActiveTab)) {
		//set the default here
		$rootScope.eventTypeActiveTab = 0;
	}

	$scope.goToEditState = function(eventType) {
		$state.go('eventtype.detail.edit({eventTypeId:eventType.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:eventTypeUpdate', function(event, result) {
		$scope.eventType = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'EventType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('eventtype'); // main translation loaded for eventtype
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfiltereventtype'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/eventtype/eventtype-dialog.html';

		return {
			/* new state for entity eventType */
			/* to access: ui-ref="eventtype.list.new" */
			/* url: hostname/eventtype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'EventTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'EventTypeFactory',
									'NewEventTypeFactory',
									function(EventTypeFactory, NewEventTypeFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return EventTypeFactory.get({ id: $stateParams.eventTypeId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewEventTypeFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for eventType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for eventType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('eventtype', {
		/* abstract state for entity eventType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/eventtype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'EventTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('eventtype.list', {
		/* list state for entity eventType */
		/* to access: ui-ref="eventtype.list" */
		/* url: hostname/eventtype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventtype/eventtypes.html',
				controller: 'EventTypeController',
			},
		},
	});

	$stateProvider.state('eventtype.detail', {
		/* detail state for entity eventType */
		/* to access: ui-sref="eventtype.detail" */
		/* url: hostname/eventtype/detail/:eventTypeId */
		url: '/detail/:eventTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventtype/eventtype-detail.html',
				controller: 'EventTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'EventTypeFactory',
				function($stateParams, EventTypeFactory) {
					return EventTypeFactory.get({ id: $stateParams.eventTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/eventtype/list/new */
	$stateProvider.state('eventtype.list.new', getNewState());
	/* url: http://<hostname>/eventtype/list/:eventTypeId/edit */
	$stateProvider.state('eventtype.list.edit', getEditState('/:eventTypeId/edit'));
	/* url: http://<hostname>/eventtype/detail/:eventTypeId/edit */
	$stateProvider.state('eventtype.detail.edit', getEditState('/edit'));

	$stateProvider.state('templateevent.list.newEventType', getNewState('/eventtype/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventTypeFactory,
		FindAllEventTypesByQueryParamsNonPageableFactory,
		NoPagingEventTypeFactory
	) {
		$scope.eventTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newEventType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(eventType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editEventType', {
				eventTypeId: eventType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getEventTypeList = function() {
			FindAllEventTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getEventTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventTypeId = id;
			$('#deleteEventTypeConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventTypeFactory.delete(
				{ id: $scope.selectedEventTypeId },
				function() {
					$scope.loadAll();
					$('#deleteEventTypeConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteEventTypeConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventTypeFactory,
		FindAllEventTypesByQueryParamsNonPageableFactory,
		NoPagingEventTypeFactory
	) {
		$scope.eventTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('eventtype.list.new');
		};

		$scope.goToEditState = function(eventType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('eventtype.list.edit', { eventTypeId: eventType.id });
		};

		$scope.getEventTypeList = function() {
			FindAllEventTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getEventTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventTypeId = id;
			$('#deleteEventTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventTypeFactory.delete(
				{ id: $scope.selectedEventTypeId },
				function() {
					$scope.loadAll();
					$('#deleteEventTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteEventTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserEventRelationContactListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventRelationContactFactory,
		UserEventRelationContactListDtoSearchFactory
	) {
		$scope.eventRelationContactList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEventRelationContact)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEventRelationContact);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-eventrelationcontact.new', {
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
				mappedByDisplayValue: $scope.mappedByDisplayValue,
			});
		};

		$scope.getEventRelationContactList = function() {
			UserEventRelationContactListDtoSearchFactory.query(
				{
					eventId: angular.isDefined($scope.eventId) ? $scope.eventId : null,
					relationId: angular.isDefined($scope.relationId) ? $scope.relationId : null,
					salesStatus: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventRelationContactList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getEventRelationContactList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserEventRelationContactListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventRelationContactFactory,
		UserEventRelationContactListDtoSearchFactory,
		AutocompleteUserEventsByQueryParamsFactory,
		AutocompleteUserRelationsByQueryParamsFactory
	) {
		$scope.eventRelationContactList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEventRelationContact)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEventRelationContact);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-eventrelationcontact.new');
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.EventRelationContactSearchOverview.event)) {
				return $scope.EventRelationContactSearchOverview.event.id;
			} else {
				return undefined;
			}
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.EventRelationContactSearchOverview.relation)) {
				return $scope.EventRelationContactSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.EventRelationContactSearchOverview = angular.copy($scope.EventRelationContactSearchOverview);

			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);

			UserEventRelationContactListDtoSearchFactory.query(
				{
					page: $scope.EventRelationContactSearchOverview.page - 1,
					size: $scope.pageSize,
					eventId: getEventId(),
					relationId: getRelationId(),
					salesStatus: $scope.EventRelationContactSearchOverview.salesStatus,

					sort: [
						$scope.EventRelationContactSearchOverview.predicate +
							',' +
							($scope.EventRelationContactSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventRelationContactList = result.items;

					$scope.autocompleteEvents = function(val) {
						var params = {
							eventTypeAheadSearchString: val,
						};

						return AutocompleteUserEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
							return results;
						});
					};

					$scope.autocompleteRelations = function(val) {
						var params = {
							relationTypeAheadSearchString: val,
						};

						return AutocompleteUserRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
							return results;
						});
					};

					$scope.salesStatusList = result.salesStatusSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isEventRelationContactSearchOverviewDirty = function() {
			return !angular.equals($scope.EventRelationContactSearchOverview, $scope.originalEventRelationContactSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.EventRelationContactSearchOverview = {};
			$rootScope.EventRelationContactSearchOverview.page = 1;
			$rootScope.EventRelationContactSearchOverview.predicate = 'id';
			$rootScope.EventRelationContactSearchOverview.ascending = false;

			$scope.EventRelationContactSearchOverview = angular.copy($rootScope.EventRelationContactSearchOverview);

			$scope.originalEventRelationContactSearchOverview = angular.copy($scope.EventRelationContactSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.EventRelationContactSearchOverview) || $rootScope.EventRelationContactSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.EventRelationContactSearchOverview = angular.copy($rootScope.EventRelationContactSearchOverview);

			$scope.search();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.EventRelationContactSearchOverview.predicate === itemName) {
				if ($scope.EventRelationContactSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('EventRelationContactDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		EventRelationContactFactory,
		AlertService,
		NoPagingEventRelationContactFactory,
		EventFactory,
		NoPagingEventFactory,
		AutocompleteEventsByQueryParamsFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingSalesStatusFactory
	) {
		$scope.eventRelationContact = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.eventRelationContact) && $rootScope.isDefinedAndNotNull($scope.eventRelationContact.id);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};
		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('eventRelationContact.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryEvent = function() {
			// If the id of a preselected event is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return EventFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'event');
					}
				});
			}
		};
		$scope.eventList = $scope.queryEvent();

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryRelation = function() {
			// If the id of a preselected relation is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'relation');
					}
				});
			}
		};
		$scope.relationList = $scope.queryRelation();

		// --- start default implementation
		/**
		 * This function queries all entities of type SalesStatus and checks if this EventRelationContact dialog is called in the context of SalesStatus.
		 * If this is the case, we detect the parent entity EventRelationContact and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySalesStatus = function() {
			return NoPagingSalesStatusFactory.query(function(result) {
				$scope.findItemByParent(result, 'salesStatus');
			});
		};
		$scope.salesStatusList = $scope.querySalesStatus();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:eventRelationContactUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving EventRelationContact failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.eventRelationContact.event === '') {
				$scope.eventRelationContact.event = null;
			}
			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.eventRelationContact.relation === '') {
				$scope.eventRelationContact.relation = null;
			}

			if ($scope.eventRelationContact.id != null) {
				EventRelationContactFactory.update($scope.eventRelationContact, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				EventRelationContactFactory.save($scope.eventRelationContact, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('EventRelationContactDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.eventRelationContact = entity;
	$scope.objectName = 'EventRelationContact';
	$scope.eventRelationContactId = $stateParams.eventRelationContactId;

	if (angular.isUndefined($rootScope.eventRelationContactActiveTab)) {
		//set the default here
		$rootScope.eventRelationContactActiveTab = 0;
	}

	$scope.goToEditState = function(eventRelationContact) {
		$state.go(
			'eventrelationcontact.detail.edit({eventRelationContactId:eventRelationContact.id, mappedBy:mappedBy, mappedById:mappedById})'
		);
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:eventRelationContactUpdate', function(event, result) {
		$scope.eventRelationContact = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'EventRelationContact'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('eventrelationcontact'); // main translation loaded for eventrelationcontact
		$translatePartialLoader.addPart('salesstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/eventrelationcontact/eventrelationcontact-dialog.html';

		return {
			/* new state for entity eventRelationContact */
			/* to access: ui-ref="eventrelationcontact.list.new" */
			/* url: hostname/eventrelationcontact/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'EventRelationContactDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'EventRelationContactFactory',
									'NewEventRelationContactFactory',
									function(EventRelationContactFactory, NewEventRelationContactFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new EventRelationContact
										// - resuming the creation of a new new EventRelationContact AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return EventRelationContactFactory.get({ id: $stateParams.eventRelationContactId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewEventRelationContactFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for eventRelationContact new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for eventRelationContact edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('eventrelationcontact', {
		/* abstract state for entity eventRelationContact */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/eventrelationcontact',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'EventRelationContacts',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('eventrelationcontact.list', {
		/* list state for entity eventRelationContact */
		/* to access: ui-ref="eventrelationcontact.list" */
		/* url: hostname/eventrelationcontact/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventrelationcontact/eventrelationcontacts.html',
				controller: 'EventRelationContactController',
			},
		},
	});

	$stateProvider.state('eventrelationcontact.detail', {
		/* detail state for entity eventRelationContact */
		/* to access: ui-sref="eventrelationcontact.detail" */
		/* url: hostname/eventrelationcontact/detail/:eventRelationContactId */
		url: '/detail/:eventRelationContactId',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-detail.html',
				controller: 'EventRelationContactDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'EventRelationContactFactory',
				function($stateParams, EventRelationContactFactory) {
					return EventRelationContactFactory.get({ id: $stateParams.eventRelationContactId });
				},
			],
		},
	});

	/* url: http://<hostname>/eventrelationcontact/list/new */
	$stateProvider.state('eventrelationcontact.list.new', getNewState());
	/* url: http://<hostname>/eventrelationcontact/list/:eventRelationContactId/edit */
	$stateProvider.state('eventrelationcontact.list.edit', getEditState('/:eventRelationContactId/edit'));
	/* url: http://<hostname>/eventrelationcontact/detail/:eventRelationContactId/edit */
	$stateProvider.state('eventrelationcontact.detail.edit', getEditState('/edit'));
	// Relation.eventRelationContact with multiplicity 0..n points to EventRelationContact
	/* url: http://<hostname>/relation/detail/:relationId/eventrelationcontact/new */
	$stateProvider.state('relation.detail.newEventRelationContact', getNewState('/eventrelationcontact/new'));
	/* url: http://<hostname>/relation/detail/:relationId/eventrelationcontact/:eventRelationContactId/edit */
	$stateProvider.state('relation.detail.editEventRelationContact', getEditState('/eventrelationcontact/:eventRelationContactId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/eventrelationcontact/new */
	$stateProvider.state('user-relation.detail.newEventRelationContact', getNewState('/eventrelationcontact/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/eventrelationcontact/:eventRelationContactId/edit */
	$stateProvider.state('user-relation.detail.editEventRelationContact', getEditState('/eventrelationcontact/:eventRelationContactId/edit'));
	// Event.eventRelationContact with multiplicity 0..n points to EventRelationContact
	/* url: http://<hostname>/event/detail/:eventId/eventrelationcontact/new */
	$stateProvider.state('event.detail.newEventRelationContact', getNewState('/eventrelationcontact/new'));
	/* url: http://<hostname>/event/detail/:eventId/eventrelationcontact/:eventRelationContactId/edit */
	$stateProvider.state('event.detail.editEventRelationContact', getEditState('/eventrelationcontact/:eventRelationContactId/edit'));

	$stateProvider.state('user-eventrelationcontact', {
		/* abstract state for DTO UserEventRelationContactListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/eventrelationcontact',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'EventRelationContact',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserEventRelationContactListDto */
		/* to access: ui-ref="user-eventrelationcontact.list" */
		/* url: http://<hostname>/user/eventrelationcontact/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-list-user.html',
				controller: 'UserEventRelationContactListDtoController',
			},
		},
	};

	$stateProvider.state('user-eventrelationcontact.list', dtoListState);
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventRelationContactTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventRelationContactFactory,
		FindAllEventRelationContactsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingEventRelationContactFactory,
		NoPagingEventFactory,
		NoPagingRelationFactory,
		NoPagingSalesStatusFactory
	) {
		$scope.eventRelationContactList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEventRelationContact)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEventRelationContact);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newEventRelationContact', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(eventRelationContact) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editEventRelationContact', {
				eventRelationContactId: eventRelationContact.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getEventRelationContactList = function() {
			FindAllEventRelationContactsByQueryParamsFactory.query(
				{
					eventId: angular.isDefined($scope.eventId) ? $scope.eventId : null,
					relationId: angular.isDefined($scope.relationId) ? $scope.relationId : null,
					salesStatusId: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventRelationContactList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getEventRelationContactList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventRelationContactId = id;
			$('#deleteEventRelationContactConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventRelationContactFactory.delete(
				{ id: $scope.selectedEventRelationContactId },
				function() {
					$scope.loadAll();
					$('#deleteEventRelationContactConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteEventRelationContactConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventRelationContactController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventRelationContactFactory,
		FindAllEventRelationContactsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingEventRelationContactFactory,
		NoPagingEventFactory,
		NoPagingRelationFactory,
		NoPagingSalesStatusFactory
	) {
		$scope.eventRelationContactList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEventRelationContact)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEventRelationContact);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('eventrelationcontact.list.new');
		};

		$scope.goToEditState = function(eventRelationContact) {
			// this overview is NOT mapped, it is the main overview
			$state.go('eventrelationcontact.list.edit', { eventRelationContactId: eventRelationContact.id });
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.EventRelationContactSearchOverview.event)) {
				return $scope.EventRelationContactSearchOverview.event.id;
			} else {
				return undefined;
			}
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.EventRelationContactSearchOverview.relation)) {
				return $scope.EventRelationContactSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		NoPagingSalesStatusFactory.query(function(result) {
			$scope.salesStatusList = result;
		});
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.EventRelationContactSearchOverview = angular.copy($scope.EventRelationContactSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);

			FindAllEventRelationContactsByQueryParamsFactory.query(
				{
					page: $scope.EventRelationContactSearchOverview.page - 1,
					size: $scope.pageSize,
					eventId: getEventId(),
					relationId: getRelationId(),
					salesStatus: $scope.EventRelationContactSearchOverview.salesStatus,

					sort: [
						$scope.EventRelationContactSearchOverview.predicate +
							',' +
							($scope.EventRelationContactSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventRelationContactList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isEventRelationContactSearchOverviewDirty = function() {
			return !angular.equals($scope.EventRelationContactSearchOverview, $scope.originalEventRelationContactSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.EventRelationContactSearchOverview = {};
			$rootScope.EventRelationContactSearchOverview.page = 1;
			$rootScope.EventRelationContactSearchOverview.predicate = 'id';
			$rootScope.EventRelationContactSearchOverview.ascending = false;

			$scope.EventRelationContactSearchOverview = angular.copy($rootScope.EventRelationContactSearchOverview);

			$scope.originalEventRelationContactSearchOverview = angular.copy($scope.EventRelationContactSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.EventRelationContactSearchOverview) || $rootScope.EventRelationContactSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.EventRelationContactSearchOverview = angular.copy($rootScope.EventRelationContactSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventRelationContactId = id;
			$('#deleteEventRelationContactConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventRelationContactFactory.delete(
				{ id: $scope.selectedEventRelationContactId },
				function() {
					$scope.search();
					$('#deleteEventRelationContactConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteEventRelationContactConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.EventRelationContactSearchOverview.predicate === itemName) {
				if ($scope.EventRelationContactSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserEventListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventFactory,
		UserEventListDtoSearchFactory,
		UserEventViewDtoFactory
	) {
		$scope.eventList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEvent);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-event.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		var getTemplateEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.templateEventId)) {
				return $scope.templateEventId;
			} else if ($rootScope.isDefinedAndNotNull($scope.EventSearchTab.templateEventIdList)) {
				return $scope.EventSearchTab.templateEventIdList;
			} else {
				return undefined;
			}
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.locationId)) {
				return $scope.locationId;
			} else if ($rootScope.isDefinedAndNotNull($scope.EventSearchTab.location)) {
				return $scope.EventSearchTab.location.id;
			} else {
				return undefined;
			}
		};

		// handle attribute startDate of javaType java.time.LocalDate
		$scope.processStartDate = function() {
			var startDateFromDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchTab.startDateFrom);
			var startDateToDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchTab.startDateTo);

			if (startDateFromDefined) {
				$scope.EventSearchTab.startDateFromString = $rootScope.convertDateWithoutZone($scope.EventSearchTab.startDateFrom);
			} else {
				$scope.EventSearchTab.startDateFromString = undefined;
			}

			if (startDateToDefined) {
				$scope.EventSearchTab.startDateToString = $rootScope.convertDateWithoutZone($scope.EventSearchTab.startDateTo);
			} else {
				$scope.EventSearchTab.startDateToString = undefined;
			}
		};

		// handle attribute exclusive of javaType boolean

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processStartDate();

			$rootScope.EventSearchTab = angular.copy($scope.EventSearchTab);

			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);

			UserEventListDtoSearchFactory.query(
				{
					page: $scope.EventSearchTab.page - 1,
					size: $scope.pageSize,
					name: $scope.EventSearchTab.name,
					startDateFrom: $scope.EventSearchTab.startDateFromString,
					startDateTo: $scope.EventSearchTab.startDateToString,
					exclusive: $scope.EventSearchTab.exclusiveGroup,
					templateEventIdList: getTemplateEventId(),
					locationId: getLocationId(),
					status: $scope.EventSearchTab.status,

					sort: [$scope.EventSearchTab.predicate + ',' + ($scope.EventSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventList = result.items;

					$scope.templateEventReferenceFilterList = result.templateEventSearchOptions;

					$scope.locationReferenceFilterList = result.locationSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isEventSearchTabDirty = function() {
			return !angular.equals($scope.EventSearchTab, $scope.originalEventSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.EventSearchTab = {};
			$rootScope.EventSearchTab.page = 1;
			$rootScope.EventSearchTab.predicate = 'startDate';
			$rootScope.EventSearchTab.ascending = true;

			$rootScope.EventSearchTab.startDateFrom = new Date();

			$scope.EventSearchTab = angular.copy($rootScope.EventSearchTab);

			$scope.originalEventSearchTab = angular.copy($scope.EventSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.EventSearchTab) || $rootScope.EventSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.EventSearchTab = angular.copy($rootScope.EventSearchTab);

			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventId = id;
			$('#deleteEventConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserEventViewDtoFactory.delete(
				{ id: $scope.selectedEventId },
				function() {
					$scope.search();
					$('#deleteEventConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteEventConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:eventUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.EventSearchTab.predicate === itemName) {
				if ($scope.EventSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};

		$scope.updateTemplateEventUISelect = function(item, model) {
			$scope.search();
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserEventListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventFactory,
		UserEventListDtoSearchFactory,
		UserEventViewDtoFactory
	) {
		$scope.eventList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEvent);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-event.new');
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.EventSearchOverview.location)) {
				return $scope.EventSearchOverview.location.id;
			} else {
				return undefined;
			}
		};

		// handle attribute startDate of javaType java.time.LocalDate
		$scope.processStartDate = function() {
			var startDateFromDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchOverview.startDateFrom);
			var startDateToDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchOverview.startDateTo);

			if (startDateFromDefined) {
				$scope.EventSearchOverview.startDateFromString = $rootScope.convertDateWithoutZone($scope.EventSearchOverview.startDateFrom);
			} else {
				$scope.EventSearchOverview.startDateFromString = undefined;
			}

			if (startDateToDefined) {
				$scope.EventSearchOverview.startDateToString = $rootScope.convertDateWithoutZone($scope.EventSearchOverview.startDateTo);
			} else {
				$scope.EventSearchOverview.startDateToString = undefined;
			}
		};

		// handle attribute exclusive of javaType boolean

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processStartDate();

			$rootScope.EventSearchOverview = angular.copy($scope.EventSearchOverview);

			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);

			UserEventListDtoSearchFactory.query(
				{
					page: $scope.EventSearchOverview.page - 1,
					size: $scope.pageSize,
					name: $scope.EventSearchOverview.name,
					startDateFrom: $scope.EventSearchOverview.startDateFromString,
					startDateTo: $scope.EventSearchOverview.startDateToString,
					exclusive: $scope.EventSearchOverview.exclusiveGroup,
					templateEventIdList: $scope.EventSearchOverview.templateEventIdList,
					locationId: getLocationId(),
					status: $scope.EventSearchOverview.status,

					sort: [$scope.EventSearchOverview.predicate + ',' + ($scope.EventSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventList = result.items;

					$scope.templateEventReferenceFilterList = result.templateEventSearchOptions;

					$scope.locationReferenceFilterList = result.locationSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isEventSearchOverviewDirty = function() {
			return !angular.equals($scope.EventSearchOverview, $scope.originalEventSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.EventSearchOverview = {};
			$rootScope.EventSearchOverview.page = 1;
			$rootScope.EventSearchOverview.predicate = 'startDate';
			$rootScope.EventSearchOverview.ascending = true;

			$rootScope.EventSearchOverview.startDateFrom = new Date();

			$scope.EventSearchOverview = angular.copy($rootScope.EventSearchOverview);

			$scope.originalEventSearchOverview = angular.copy($scope.EventSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.EventSearchOverview) || $rootScope.EventSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.EventSearchOverview = angular.copy($rootScope.EventSearchOverview);

			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventId = id;
			$('#deleteEventConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserEventViewDtoFactory.delete(
				{ id: $scope.selectedEventId },
				function() {
					$scope.search();
					$('#deleteEventConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteEventConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:eventUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.EventSearchOverview.predicate === itemName) {
				if ($scope.EventSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};

		$scope.updateTemplateEventUISelect = function(item, model) {
			$scope.search();
		};
	});

/** @format */

'use strict';

// Created by frontend/angular/entity/controller/dto-edit.ftl
angular
	.module('emsApp')
	.controller('UserEventEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserEventEditDtoFactory,
		AlertService,
		HistoryService,
		UserEventEditDtoSaveAndCreateFactory
	) {
		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.submitButtonIsActive = true;
		};

		$scope.event = entity;
		$scope.submitButtonIsActive = true;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		//This function preselects and disables the parent reference when called from tab
		$scope.event['selected' + _.upperFirst($stateParams.mappedBy)] = {
			id: $stateParams.mappedById,
			displayValue: $stateParams.mappedByDisplayValue,
		};

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.event) && $rootScope.isDefinedAndNotNull($scope.event.id);
		};

		var onSaveAndNewFinishedCallback = function(result) {
			// navigate to new state with result (a new entity, but with the copied values from the previous)
			$state.go('user-event.new', {
				dataModel: result,
				mappedBy: $stateParams.mappedBy,
				mappedById: $stateParams.mappedById,
			});
		};

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:eventUpdate', result);
			$scope.submitButtonIsActive = true;
			// process success result, if necessary
			if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
				console.log('as we came on this create new page from plus button we will update history');

				// set relation as reference in the referredBy data model
				$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;

				// update previous state
				HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
			}
			$rootScope.back();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;
			UserEventEditDtoFactory.update($scope.event, onSaveFinishedCallback, saveOrUpdateErrorCallback);
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			// To prevent navigating back to this current view, remove it from history.
			HistoryService.removeHistory();

			if ($scope.event.id != null) {
				UserEventEditDtoSaveAndCreateFactory.updateAndNew($scope.event, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				UserEventEditDtoSaveAndCreateFactory.createAndNew($scope.event, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// triggered when click a plus button, navigates to creating a new templateEvent of type TemplateEvent
		// once TemplateEvent is saved, history is updated and the user automatically navigates back to this edit page for Event
		$scope.createTemplateEvent = function() {
			var referredBy = {
				refName: 'templateEvent',
				data: $scope.event,
			};

			// navigating to new templateEvent will add this new event state to the history stack
			$state.go($state.current.name + '.newTemplateEvent', { referredBy: referredBy }, { notify: true });
		};

		// triggered when click a plus button, navigates to creating a new location of type Location
		// once Location is saved, history is updated and the user automatically navigates back to this edit page for Event
		$scope.createLocation = function() {
			var referredBy = {
				refName: 'location',
				data: $scope.event,
			};

			// navigating to new location will add this new event state to the history stack
			$state.go($state.current.name + '.newLocation', { referredBy: referredBy }, { notify: true });
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};

		/**
		 * Tells caller whether the current shown screen (and state) is in edit mode, hence a dialog is shown
		 */
		$scope.isInEditState = function() {
			// check on stateName: *.edit  or  *.detail.edit
			return $state.current.name.toUpperCase().endsWith('EDIT');
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('EventDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		EventFactory,
		AlertService,
		NoPagingEventFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingTemplateEventFactory,
		NoPagingLocationFactory,
		NoPagingEventStatusFactory,
		EventSaveAndCreateFactory
	) {
		$scope.event = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.event) && $rootScope.isDefinedAndNotNull($scope.event.id);
		};

		$scope.createTemplateEvent = function() {
			var referredBy = {
				refName: 'templateEvent',
				data: $scope.event,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new templateEvent will add this new event state to the history stack
				$state.go('event.list.newTemplateEvent', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createLocation = function() {
			var referredBy = {
				refName: 'location',
				data: $scope.event,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new location will add this new event state to the history stack
				$state.go('event.list.newLocation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createStatus = function() {
			var referredBy = {
				refName: 'status',
				data: $scope.event,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new status will add this new event state to the history stack
				$state.go('event.list.newEventStatus', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		/**
		 * Tells caller whether the current shown screen (and state) is in edit mode, hence a dialog is shown
		 */
		$scope.isInEditState = function() {
			// check on stateName: *.edit  or  *.detail.edit
			return $state.current.name.toUpperCase().endsWith('EDIT');
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('event.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type TemplateEvent and checks if this Event dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity Event and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				$scope.findItemByParent(result, 'templateEvent');
			});
		};
		$scope.templateEventList = $scope.queryTemplateEvent();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Location and checks if this Event dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity Event and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				$scope.findItemByParent(result, 'location');
			});
		};
		$scope.locationList = $scope.queryLocation();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Status and checks if this Event dialog is called in the context of Status.
		 * If this is the case, we detect the parent entity Event and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryStatus = function() {
			return NoPagingEventStatusFactory.query(function(result) {
				$scope.findItemByParent(result, 'status');
			});
		};
		$scope.statusList = $scope.queryStatus();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:eventUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Event failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		var onSaveAndNewFinishedCallback = function(result) {
			$scope.$emit('emsApp:eventUpdate', result);
			// the result contains a new entity, but with the copied values from the previous
			$scope.event = result;
			$scope.updateDropdownModels();
			$scope.submitButtonIsActive = true;
		};

		$scope.updateDropdownModels = function() {
			$scope.queryTemplateEvent();
			$scope.queryLocation();
			$scope.queryStatus();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.event.id != null) {
				EventFactory.update($scope.event, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				EventFactory.save($scope.event, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.event.id != null) {
				EventSaveAndCreateFactory.updateAndCreate($scope.event, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				EventSaveAndCreateFactory.saveAndCreate($scope.event, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};

		// executes when onchange is triggered for the Event.TemplateEvent reference listbox
		// goal is to set Event.description based on chosen TemplateEvent.description
		$scope.changeTemplateEvent = function(templateEvent) {
			if (templateEvent !== undefined) {
				$scope.event.description = templateEvent.description;
			}
		};
	});

'use strict';

angular.module('emsApp').controller(
		'EventDetailWithSubscriptionsController',
		function($scope, $rootScope, $stateParams, $state, $translate, dialogs, entity, AlertService, EventSubscriptionsFactory,
				EventSubscriptionsMailUpdateFactory, DriverFactory, EventFactory, EventSnelstartFactory, EventMailChimpFactory) {
			$scope.event = entity;
			$scope.objectName = "Event";
			$scope.eventId = $stateParams.eventId;
			$scope.subscriptionList = [];
			$scope.syncingAudience = false;

			var addObjectToDisplayString = function(object, displayString) {
				if ($rootScope.isDefinedAndNotNull(object)) {
					if (displayString.trim() !== "") {
						displayString += ", ";
					}
					displayString += object;
				}
				return displayString;
			};

			$scope.getHotels = function(subscription) {
				var hotel = "";

				if (!$rootScope.isDefinedAndNotNull(subscription.driverDto)) {
					return hotel;
				}

				// get driver hotel (if any)
				if ($rootScope.isDefinedAndNotNull(subscription.driverDto.hotel)) {
					hotel = addObjectToDisplayString(subscription.driverDto.hotel, hotel);
				}
				// get second driver hotel (if any)
				if ($rootScope.isDefinedAndNotNull(subscription.secondDriverDtoList)) {
					angular.forEach(subscription.secondDriverDtoList, function(secondDriver, index) {
						hotel = addObjectToDisplayString(secondDriver.hotel, hotel);
					})
				}
				// get spectator hotel (if any)
				if ($rootScope.isDefinedAndNotNull(subscription.spectatorDtoList)) {
					angular.forEach(subscription.spectatorDtoList, function(spectator, index) {
						hotel = addObjectToDisplayString(spectator.hotel, hotel);
					})
				}

				return hotel;
			};

			$scope.getInstructionTypes = function(subscription) {
				var instructionTypes = "";

				if (!$rootScope.isDefinedAndNotNull(subscription.driverDto)) {
					return instructionTypes;
				}

				// get driver instructionType (if any)
				if ($rootScope.isDefinedAndNotNull(subscription.driverDto.instructionType)) {
					instructionTypes = addObjectToDisplayString(subscription.driverDto.instructionType, instructionTypes);
				}
				// get second driver instructionType (if any)
				if ($rootScope.isDefinedAndNotNull(subscription.secondDriverDtoList)) {
					angular.forEach(subscription.secondDriverDtoList, function(secondDriver, index) {
						instructionTypes = addObjectToDisplayString(secondDriver.instructionType, instructionTypes);
					});
				}
				return instructionTypes;
			};

			/**
			 * [dmitro] In summary of hours should go only subscriptions with listed statuses
			 */
			var subscriptionStatusToIncludeInHoursTotalSum = ['RESERVED', 'CONFIRMED'];
			$scope.getInstructionHours = function(subscription) {

				var hours = 0;

				if (!$rootScope.isDefinedAndNotNull(subscription.driverDto)) {
					return hours;
				}

				if ($rootScope.isDefinedAndNotNull(subscription.driverDto.instructionHours)) {
					if (subscriptionStatusToIncludeInHoursTotalSum.indexOf(subscription.driverDto.status) !== -1) {
						hours = subscription.driverDto.instructionHours;
					}
				}
				// get second driver instructionHours
				if ($rootScope.isDefinedAndNotNull(subscription.secondDriverDtoList)) {
					angular.forEach(subscription.secondDriverDtoList, function(secondDriver, index) {
						if (subscriptionStatusToIncludeInHoursTotalSum.indexOf(secondDriver.status) !== -1) {
							hours += secondDriver.instructionHours;
						}
					});
				}
				// get spectator instructionHours
				if ($rootScope.isDefinedAndNotNull(subscription.spectatorDtoList)) {
					angular.forEach(subscription.spectatorDtoList, function(spectator, index) {
						if (subscriptionStatusToIncludeInHoursTotalSum.indexOf(spectator.status) !== -1) {
							hours += spectator.instructionHours;
						}
					});
				}
				return hours;
			};

			$scope.getInstructors = function(subscription) {
				var instructors = "";

				if (!$rootScope.isDefinedAndNotNull(subscription.driverDto)) {
					return instructors;
				}

				// get driver instructionType (if any)
				if ($rootScope.isDefinedAndNotNull(subscription.driverDto.instructor)) {
					instructors = addObjectToDisplayString(subscription.driverDto.instructor, instructors);
				}
				// get second driver instructionType (if any)
				if ($rootScope.isDefinedAndNotNull(subscription.secondDriverDtoList)) {
					angular.forEach(subscription.secondDriverDtoList, function(secondDriver, index) {
						instructors = addObjectToDisplayString(secondDriver.instructor, instructors);
					});
				}
				return instructors;
			};

			$scope.updateInfoMail = function() {
				EventSubscriptionsMailUpdateFactory.updateInfoMail($scope.eventId).update().$promise.then(function(data) {
					$scope.subscriptionList = data;
				});
			};

			$scope.updateAfterMail = function() {
				EventSubscriptionsMailUpdateFactory.updateAfterMail($scope.eventId).update().$promise.then(function(data) {
					$scope.subscriptionList = data;
				});
			};

			$scope.syncAudiences = function () {
				$scope.syncingAudience = true;
				EventMailChimpFactory.syncAudience($scope.event.id).sync().$promise.then(function (updatedEvent) {
					$scope.syncingAudience = false;
					$scope.event = updatedEvent;
					AlertService.add({
						type: 'success',
						msg: "Audience synced",
						timeout: 3000
					})
				}, function (error) {
					$scope.syncingAudience = false;
					AlertService.add({
						type: 'danger',
						msg: "Failed to sync the audience",
						timeout: 3000
					});
				})
			};

			$scope.deleteDriver = function(subscription) {
				var driverId = subscription.driverDto.subscriptionIdPk;
				var bookingId = subscription.bookingIdPk;

				if (!$rootScope.isDefinedAndNotNull(driverId)) {
					AlertService.error("Unknown driver");
					return;
				}

				if (!$rootScope.isDefinedAndNotNull(bookingId)) {
					AlertService.error("Unknown booking");
					return;
				}

				var driverName = subscription.driverDto.subscriptionPersonName;
				var bookingName = subscription.bookingPersonName;
				var dlgTitle = $translate.instant("event.detail.subscriptions.delete.confirm.title", {
					driverName : driverName
				});
				var dlgMessage = $translate.instant("event.detail.subscriptions.delete.confirm.message", {
					driverName : driverName,
					bookingName : bookingName
				});

				var dlg = dialogs.confirm(dlgTitle, dlgMessage);

				dlg.result.then(function() {
					// user confirmed delete action
					DriverFactory.deleteDriver({
						id : driverId,
						bookingId : bookingId
					}).$promise.then(function() {
						AlertService.info("Successfully deleted driver {{driverName}}", {
							driverName : driverName
						});
						$scope.loadData();
						$scope.reloadEvent();
					}, function(error) {
						AlertService.error("Failed to delete driver {{driverName}}", {
							driverName : driverName
						}, error);
					});
				}, function() {
					// user cancelled delete action
				});
			};

			$scope.translateStatus = function(status) {
				return $rootScope.isDefinedAndNotNull(status) ? $translate.instant('SubscriptionStatus.' + status) : "";
			};

			$scope.loadData = function() {
				EventSubscriptionsFactory.query({
					id : $scope.eventId
				}, function(result) {
					$scope.subscriptionList = result;
				}, function(error) {
					AlertService.error(error);
				});
			};

			$scope.reloadEvent = function() {
				EventFactory.get({
					id : $scope.eventId
				}).$promise.then(function(result) {
					$scope.event = result;
				});
			};

			$scope.loadData();
		});

/** @format */

'use strict';

angular.module('emsApp').controller('EventDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.event = entity;
	$scope.objectName = 'Event';
	$scope.eventId = $stateParams.eventId;

	if (angular.isUndefined($rootScope.eventActiveTab)) {
		//set the default here
		$rootScope.eventActiveTab = 0;
	}

	$scope.goToEditState = function(event) {
		$state.go('event.detail.edit({eventId:event.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:eventUpdate', function(event, result) {
		$scope.event = result;
	});
});

/** @format */

'use strict';

// Event has edit layout enabled. Edit layout template url: event-dialog.html
// Event has detail layout enabled. Detail layout template url: event-eventdetail.html
angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Event'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('event'); // main translation loaded for event
		$translatePartialLoader.addPart('eventstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('location'); // one to many reference from main entity
		$translatePartialLoader.addPart('booking'); // one to many reference from main entity
		$translatePartialLoader.addPart('bookingstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('confirmationemailstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('document'); // one to many reference from main entity
		$translatePartialLoader.addPart('instructor'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('eventrelationcontact'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesstatus'); // one to one or many to one reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/event/event-dialog.html';

		return {
			/* new state for entity event */
			/* to access: ui-ref="event.list.new" */
			/* url: hostname/event/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'EventDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'EventFactory',
									'NewEventFactory',
									function(EventFactory, NewEventFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Event
										// - resuming the creation of a new new Event AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return EventFactory.get({ id: $stateParams.eventId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewEventFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for event new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for event edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('event', {
		/* abstract state for entity event */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/event',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Events',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('event.list', {
		/* list state for entity event */
		/* to access: ui-ref="event.list" */
		/* url: hostname/event/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/event/events.html',
				controller: 'EventController',
			},
		},
	});

	$stateProvider.state('event.detail', {
		/* detail state for entity event */
		/* to access: ui-sref="event.detail" */
		/* url: hostname/event/detail/:eventId */
		url: '/detail/:eventId',
		views: {
			'content@': {
				templateUrl: 'app/entities/event/event-eventdetail.html',
				controller: 'EventDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'EventFactory',
				function($stateParams, EventFactory) {
					return EventFactory.get({ id: $stateParams.eventId });
				},
			],
		},
	});

	/* url: http://<hostname>/event/list/new */
	$stateProvider.state('event.list.new', getNewState());
	/* url: http://<hostname>/event/list/:eventId/edit */
	$stateProvider.state('event.list.edit', getEditState('/:eventId/edit'));
	/* url: http://<hostname>/event/detail/:eventId/edit */
	$stateProvider.state('event.detail.edit', getEditState('/edit'));
	// TemplateEvent.event with multiplicity 0..n points to Event
	/* url: http://<hostname>/templateevent/detail/:templateEventId/event/new */
	$stateProvider.state('templateevent.detail.newEvent', getNewState('/event/new'));
	/* url: http://<hostname>/templateevent/detail/:templateEventId/event/:eventId/edit */
	$stateProvider.state('templateevent.detail.editEvent', getEditState('/event/:eventId/edit'));
	// Location.event with multiplicity 0..n points to Event
	/* url: http://<hostname>/location/detail/:locationId/event/new */
	$stateProvider.state('location.detail.newEvent', getNewState('/event/new'));
	/* url: http://<hostname>/location/detail/:locationId/event/:eventId/edit */
	$stateProvider.state('location.detail.editEvent', getEditState('/event/:eventId/edit'));

	$stateProvider.state('booking.list.newEvent', getNewState('/event/new'));
	$stateProvider.state('document.list.newEvent', getNewState('/event/new'));

	$stateProvider.state('event.detail.subscriptions.edit', getEditState('/edit'));

	$stateProvider.state('event.detail.subscriptions', {
		/* detail state for entity event with custom subscriptions overview*/
		url: '/subscriptions',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Event',
		},
		views: {
			'content@': {
				templateUrl: 'app/entities/event/event-detail-with-subscriptions.html',
				controller: 'EventDetailWithSubscriptionsController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'EventFactory',
				function($stateParams, EventFactory) {
					return EventFactory.get({
						id: $stateParams.eventId,
					});
				},
			],
		},
	});

	$stateProvider.state('event.detail.booking', {
		/* detail state for entity event with custom subscriptions overview*/
		url: '/booking/:bookingId',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Event',
		},
		views: {
			'content@': {
				templateUrl: 'app/entities/event/booking-subscription-details.html',
				controller: 'BookingSubscriptionDetailsController',
			},
		},
		params: {
			predefinedSubscriptionStatus: 'CONFIRMED', // can be set to reserved or confirmed
			relationId: null,
			driverId: null,
			dataModel: null, // the datamodel that is filled with the created entity from a modal dialog
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('car'); // main translation loaded for event
					$translatePartialLoader.addPart('subscription'); // main translation loaded for event
					$translatePartialLoader.addPart('subscriptiontype'); // main translation loaded for subscriptiontype
					return $translate.refresh();
				},
			],
			entity: [
				'$stateParams',
				'$rootScope',
				'$q',
				'BookingFactory',
				'NewBookingFactory',
				'EventFactory',
				'RelationFactory',
				function($stateParams, $rootScope, $q, BookingFactory, NewBookingFactory, EventFactory, RelationFactory) {
					if ($rootScope.isDefinedAndNotNull($stateParams.bookingId) && $stateParams.bookingId !== '') {
						return BookingFactory.get({
							id: $stateParams.bookingId,
						});
					} else {
						// get the event by it's id, plus get a new booking
						var eventPromise = EventFactory.get({ id: $stateParams.eventId }).$promise.then(function(result) {
							return result;
						});
						var newBookingPromise = NewBookingFactory.get().$promise.then(function(result) {
							return result;
						});
						var relationPromise = $stateParams.relationId
							? RelationFactory.get({ id: $stateParams.relationId }).$promise.then(function(result) {
									return result;
							  })
							: $q.resolve(null);

						// once both event and booking are retrieved we update the booking with the event and return the booking as entity
						return $q.all({ event: eventPromise, booking: newBookingPromise, client: relationPromise }).then(function(results) {
							var booking = results.booking;
							booking.event = results.event;
							if (results.client) {
								// this part is only relevant when the page is opened from the sales relation dashboard
								booking.client = results.client;
							}
							return booking;
						});
					}
				},
			],
		},
	});

	$stateProvider.state('event.dashboard', {
		/* dashboardstate for entity event */
		/* to access: ui-ref="event.dashboard" */
		/* url: hostname/event/dashboard */
		url: '/dashboard',
		views: {
			'content@': {
				templateUrl: 'app/sales/events-dashboard.html',
				controller: 'EventDashboardController',
			},
		},
	});
	/* url: http://<hostname>/event/dashboard/new */
	$stateProvider.state('event.dashboard.new', getNewState());
	/* url: http://<hostname>/event/dashboard/:eventId/edit */
	$stateProvider.state('event.dashboard.edit', getEditState('/:eventId/edit'));

	$stateProvider.state('user-event', {
		/* abstract state for DTO UserEventListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/event',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'Event',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserEventListDto */
		/* to access: ui-ref="user-event.list" */
		/* url: http://<hostname>/user/event/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/event/event-list-user.html',
				controller: 'UserEventListDtoController',
			},
		},
	};

	$stateProvider.state('user-event.list', dtoListState);

	/* edit state for DTO user */
	var dtoEditState = {
		/* edit state for DTO UserEventEditDto */
		/* to access: ui-sref="user-event.edit" */
		/* url: http://<hostname>/user/event/edit/:eventId */
		url: '/edit/:eventId',
		views: {
			'content@': {
				templateUrl: 'app/entities/event/event-edit-user.html',
				controller: 'UserEventEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserEventEditDtoFactory',
				function($stateParams, $rootScope, UserEventEditDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						// as templateEvent has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.templateEvent)) {
							// push the created templateEvent to the list with selectable templateEvent items
							$stateParams.dataModel.templateEventList.push($stateParams.dataModel.templateEvent);

							// set the created templateEvent as selected templateEvent
							$stateParams.dataModel.selectedTemplateEvent = $stateParams.dataModel.templateEvent;
						}
						// as location has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.location)) {
							// push the created location to the list with selectable location items
							$stateParams.dataModel.locationList.push($stateParams.dataModel.location);

							// set the created location as selected location
							$stateParams.dataModel.selectedLocation = $stateParams.dataModel.location;
						}

						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserEventEditDtoFactory.get({ id: $stateParams.eventId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-event.edit', dtoEditState);

	/* new (create) state for DTO user */
	var dtoCreateState = {
		/* new state for DTO UserEventEditDto */
		/* to access: ui-sref="user-event.new" */
		/* url: http://<hostname>/user/event/new */
		url: '/new',
		views: {
			'content@': {
				templateUrl: 'app/entities/event/event-edit-user.html',
				controller: 'UserEventEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserEventNewDtoFactory',
				function($stateParams, $rootScope, UserEventNewDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						// as templateEvent has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.templateEvent)) {
							// push the created templateEvent to the list with selectable templateEvent items
							$stateParams.dataModel.templateEventList.push($stateParams.dataModel.templateEvent);

							// set the created templateEvent as selected templateEvent
							$stateParams.dataModel.selectedTemplateEvent = $stateParams.dataModel.templateEvent;
						}
						// as location has a plus button we need to process the result of creating a new instance
						if ($rootScope.isDefinedAndNotNull($stateParams.dataModel.location)) {
							// push the created location to the list with selectable location items
							$stateParams.dataModel.locationList.push($stateParams.dataModel.location);

							// set the created location as selected location
							$stateParams.dataModel.selectedLocation = $stateParams.dataModel.location;
						}

						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserEventNewDtoFactory.get({ id: $stateParams.eventId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-event.new', dtoCreateState);

	// create state for plus button on Booking edit / new page for reference Event and dto property value user
	$stateProvider.state('user-booking.new.newEvent', getCreateState('/event/new'));
	$stateProvider.state('user-booking.edit.newEvent', getCreateState('/event/new'));
	// create state for plus button on Document edit / new page for reference Event and dto property value user
	$stateProvider.state('user-document.new.newEvent', getCreateState('/event/new'));
	$stateProvider.state('user-document.edit.newEvent', getCreateState('/event/new'));
	// retrieve the create state object, and update the url in the state object as the default create state only adds "/new" to the location url, while we want the url to contain "/event/new"
	function getCreateState(url) {
		var clonedDtoCreateState = Object.assign({}, dtoCreateState);
		clonedDtoCreateState.url = url;
		return clonedDtoCreateState;
	}
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventFactory,
		FindAllEventsByQueryParamsFactory,
		NoPagingEventFactory,
		NoPagingTemplateEventFactory,
		NoPagingLocationFactory,
		NoPagingEventStatusFactory
	) {
		$scope.eventList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEvent);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newEvent', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(event) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editEvent', { eventId: event.id, mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		var getTemplateEventIdList = function() {
			if ($rootScope.isDefinedAndNotNull($scope.templateEventId)) {
				return $scope.templateEventId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.EventSearchTab.templateEventIdList)) {
					return $rootScope.getListValues($scope.EventSearchTab.templateEventIdList, 'id');
				} else {
					return undefined;
				}
			}
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.locationId)) {
				return $scope.locationId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.EventSearchTab.location)) {
					return $scope.EventSearchTab.location.id;
				} else {
					return undefined;
				}
			}
		};

		// handle attribute startDate of javaType java.time.LocalDate
		$scope.processStartDate = function() {
			var startDateFromDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchTab.startDateFrom);
			var startDateToDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchTab.startDateTo);

			if (startDateFromDefined) {
				$scope.EventSearchTab.startDateFromString = $rootScope.convertDateWithoutZone($scope.EventSearchTab.startDateFrom);
			} else {
				$scope.EventSearchTab.startDateFromString = undefined;
			}

			if (startDateToDefined) {
				$scope.EventSearchTab.startDateToString = $rootScope.convertDateWithoutZone($scope.EventSearchTab.startDateTo);
			} else {
				$scope.EventSearchTab.startDateToString = undefined;
			}
		};

		// handle attribute exclusive of javaType boolean

		/**
		 * This function queries all entities of type TemplateEvent and checks if this Event dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity Event and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				return result;
			});
		};
		$scope.templateEventReferenceFilterList = $scope.queryTemplateEvent();

		/**
		 * This function queries all entities of type Location and checks if this Event dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity Event and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				return result;
			});
		};
		$scope.locationReferenceFilterList = $scope.queryLocation();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processStartDate();

			$rootScope.EventSearchTab = angular.copy($scope.EventSearchTab);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);

			FindAllEventsByQueryParamsFactory.query(
				{
					page: $scope.EventSearchTab.page - 1,
					size: $scope.pageSize,
					name: $scope.EventSearchTab.name,
					startDateFrom: $scope.EventSearchTab.startDateFromString,
					startDateTo: $scope.EventSearchTab.startDateToString,
					exclusive: $scope.EventSearchTab.exclusiveGroup,
					templateEventIdList: getTemplateEventIdList(),
					locationId: getLocationId(),
					status: $scope.EventSearchTab.status,

					sort: [$scope.EventSearchTab.predicate + ',' + ($scope.EventSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.updateTemplateEventUISelect = function(item, model) {
			$scope.search();
		};
		$scope.isEventSearchTabDirty = function() {
			return !angular.equals($scope.EventSearchTab, $scope.originalEventSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.EventSearchTab = {};
			$rootScope.EventSearchTab.page = 1;
			$rootScope.EventSearchTab.predicate = 'startDate';
			$rootScope.EventSearchTab.ascending = true;

			$rootScope.EventSearchTab.startDateFrom = new Date();

			$scope.EventSearchTab = angular.copy($rootScope.EventSearchTab);

			$scope.originalEventSearchTab = angular.copy($scope.EventSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.EventSearchTab) || $rootScope.EventSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.EventSearchTab = angular.copy($rootScope.EventSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventId = id;
			$('#deleteEventConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventFactory.delete(
				{ id: $scope.selectedEventId },
				function() {
					$scope.search();
					$('#deleteEventConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteEventConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:eventUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.EventSearchTab.predicate === itemName) {
				if ($scope.EventSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventFactory,
		FindAllEventsByQueryParamsFactory,
		NoPagingEventFactory,
		NoPagingTemplateEventFactory,
		NoPagingLocationFactory,
		NoPagingEventStatusFactory
	) {
		$scope.eventList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEvent)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEvent);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('event.list.new');
		};

		$scope.goToEditState = function(event) {
			// this overview is NOT mapped, it is the main overview
			$state.go('event.list.edit', { eventId: event.id });
		};

		var getTemplateEventIdList = function() {
			return $rootScope.getListValues($scope.EventSearchOverview.templateEventIdList, 'id');
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.EventSearchOverview.location)) {
				return $scope.EventSearchOverview.location.id;
			} else {
				return undefined;
			}
		};

		// handle attribute startDate of javaType java.time.LocalDate
		$scope.processStartDate = function() {
			var startDateFromDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchOverview.startDateFrom);
			var startDateToDefined = $rootScope.isDefinedAndNotNull($scope.EventSearchOverview.startDateTo);

			if (startDateFromDefined) {
				$scope.EventSearchOverview.startDateFromString = $rootScope.convertDateWithoutZone($scope.EventSearchOverview.startDateFrom);
			} else {
				$scope.EventSearchOverview.startDateFromString = undefined;
			}

			if (startDateToDefined) {
				$scope.EventSearchOverview.startDateToString = $rootScope.convertDateWithoutZone($scope.EventSearchOverview.startDateTo);
			} else {
				$scope.EventSearchOverview.startDateToString = undefined;
			}
		};

		// handle attribute exclusive of javaType boolean

		/**
		 * This function queries all entities of type TemplateEvent and checks if this Event dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity Event and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				return result;
			});
		};
		$scope.templateEventReferenceFilterList = $scope.queryTemplateEvent();

		/**
		 * This function queries all entities of type Location and checks if this Event dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity Event and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				return result;
			});
		};
		$scope.locationReferenceFilterList = $scope.queryLocation();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processStartDate();

			$rootScope.EventSearchOverview = angular.copy($scope.EventSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEvent = angular.copy($scope.pageSize);

			FindAllEventsByQueryParamsFactory.query(
				{
					page: $scope.EventSearchOverview.page - 1,
					size: $scope.pageSize,
					name: $scope.EventSearchOverview.name,
					startDateFrom: $scope.EventSearchOverview.startDateFromString,
					startDateTo: $scope.EventSearchOverview.startDateToString,
					exclusive: $scope.EventSearchOverview.exclusiveGroup,
					templateEventIdList: getTemplateEventIdList(),
					locationId: getLocationId(),
					status: $scope.EventSearchOverview.status,

					sort: [$scope.EventSearchOverview.predicate + ',' + ($scope.EventSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.updateTemplateEventUISelect = function(item, model) {
			$scope.search();
		};
		$scope.isEventSearchOverviewDirty = function() {
			return !angular.equals($scope.EventSearchOverview, $scope.originalEventSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.EventSearchOverview = {};
			$rootScope.EventSearchOverview.page = 1;
			$rootScope.EventSearchOverview.predicate = 'startDate';
			$rootScope.EventSearchOverview.ascending = true;

			$rootScope.EventSearchOverview.startDateFrom = new Date();

			$scope.EventSearchOverview = angular.copy($rootScope.EventSearchOverview);

			$scope.originalEventSearchOverview = angular.copy($scope.EventSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.EventSearchOverview) || $rootScope.EventSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.EventSearchOverview = angular.copy($rootScope.EventSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventId = id;
			$('#deleteEventConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventFactory.delete(
				{ id: $scope.selectedEventId },
				function() {
					$scope.search();
					$('#deleteEventConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteEventConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:eventUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.EventSearchOverview.predicate === itemName) {
				if ($scope.EventSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

'use strict';

angular.module('emsApp').controller(
    'BookingSubscriptionDetailsController',
    function ($scope, $rootScope, $stateParams, $state, $translate, $timeout, $q, entity, dialogs,
              AlertService, BookingFactory, BookingSubscriptionsFactory, AutocompleteRelationsByQueryParamsFactory, SubscriptionFactory,
              NoPagingSubscriptionTypeFactory, NoPagingSubscriptionStatusFactory, SubscriptionFindArticleFilteredByHotelFactory,
              InstructorsByEventFactory, NoPagingTemplateEventFactory, SubscriptionFindArticleFilteredByDriverFactory,
              SubscriptionFindArticleFilteredBySpectatorFactory, SubscriptionFindArticleFilteredBySecondDriverFactory, NewSubscriptionFactory,
              SubscriptionFindArticleFilteredByInsuranceFactory, SubscriptionFindArticleFilteredByFuelFactory,
              AutocompleteCarsByQueryParamsFactory, HistoryService, NoPagingBookingStatusFactory, BookingSnelstartFactory, ConfirmationEmailManager) {
        $scope.booking = entity;
        $scope.objectName = "Booking";
        $scope.bookingId = $stateParams.bookingId;
        $scope.eventId = $stateParams.eventId;
        $scope.driverId = $stateParams.driverId;
        $scope.relationId = $stateParams.relationId;
        // list of drivers for this booking, per driver there could be second drivers and spectators (all dtos)
        $scope.subscriptionList = [];
        $scope.currentSubscription = null;
        $scope.currentSubscriptionIndex = 0;
        // entities to edit
        $scope.subscriptionToEdit = null;
        $scope.subscriptionToDelete = null;
        // properties to indicate certain parts of DOM should be shown, or not
        $scope.showBookingData = true;
        $scope.showInstructionData = false;
        $scope.showEditInstructionData = false;
        $scope.showBookingForm = false;
        $scope.showEditSubscriptionForm = false;
        $scope.showCarForm = false;
        $scope.hideAddingNewDriver = false;

        $scope.modelOptions = {
            debounce: {
                default: 500,
                blur: 100
            },
            getterSetter: true
        };

        $scope.title = function() {
            var title = "";

            if ($rootScope.isDefinedAndNotNull($scope.booking)) {
                if ($rootScope.isDefinedAndNotNull($scope.booking.description)) {
                    title = $scope.booking.description + " - ";
                }
                if ($rootScope.isDefinedAndNotNull($scope.booking.event)) {
                    title += $scope.booking.event.name + " - ";
                }
                if ($rootScope.isDefinedAndNotNull($scope.booking.client)) {
                    if ($rootScope.isDefinedAndNotNull($scope.booking.client.externalId)) {
                        title += $scope.booking.client.externalId + ", ";
                    }
                    if ($rootScope.isDefinedAndNotNull($scope.booking.client.personName)) {
                        title += $scope.booking.client.personName + ", ";
                    }
                    if ($rootScope.isDefinedAndNotNull($scope.booking.client.companyName)) {
                        title += $scope.booking.client.companyName;
                    }
                }
            }

            return title;
        };

        $scope.backToSalesDashboard = function() {
            // override for the rootscope back function to navigate to sales relation dashboard
            $state.go('sales.relation', {}, {reload: true});
        };

        $scope.backToEvent = function() {
            // override for the rootscope back function to navigate to event details
            $state.go('event.detail.subscriptions', {eventId: $scope.eventId}, {reload: true});
        };

        $scope.createCar = function() {
            console.log("creating new car for driver", $scope.subscriptionToEdit);

            // $scope.subscriptionToEdit is populated with a driver subscription by editCar()
            var referredBy = {
                refName: 'car',
                data: $scope.subscriptionToEdit
            };

            $timeout(function(){
                // we add a little timeout to prevent the modal dismiss not to be ready
                $state.go('event.detail.booking.newCar', {referredBy: referredBy, dataModel: null}, {reload: false});
            },10);
        };

        $scope.createBookingClient = function() {
            console.log("creating new client for booking", $scope.booking);

            // $scope.booking will be assigned by the result of creating the new booking
            var referredBy = {
                refName: 'client',
                data: $scope.booking
            };

            $timeout(function() {
                // we add a little timeout to prevent the modal dismiss not to be ready
                $state.go('event.detail.booking.newRelation', {referredBy: referredBy, dataModel: null}, {reload: false});
            },10);
        };

        $scope.createInstructor = function() {
            console.log("creating new instructor for driver", $scope.subscriptionToEdit);

            // $scope.subscriptionToEdit is populated with an instructor
            var referredBy = {
                refName: 'instructor',
                data: $scope.subscriptionToEdit
            };

            $timeout(function() {
                // we add a little timeout to prevent the modal dismiss not to be ready
                $state.go('event.detail.booking.newInstructor', {referredBy: referredBy, dataModel: null, driverId:$scope.driverId, mappedBy:'event', mappedById:$scope.subscriptionToEdit.booking.event.id}, {reload: false});
            },10);
        };

        $scope.createRelation = function() {
            console.log("creating new relation for subscriptopn", $scope.subscriptionToEdit);

            // $scope.subscriptionToEdit is populated with a relation
            var referredBy = {
                refName: 'relation',
                data: $scope.subscriptionToEdit
            };

            $timeout(function() {
                // we add a little timeout to prevent the modal dismiss not to be ready
                $state.go('event.detail.booking.newRelation', {referredBy: referredBy, dataModel: null, driverId:$scope.driverId}, {reload: false});
            },10);
        };



        $scope.getBookingArticle = function (subscription) {
            if (!$rootScope.isDefinedAndNotNull(subscription)) {
                return "";
            }

            if (subscription.subscriptionType == 'Driver') {
                return subscription.driver;
            }

            if (subscription.subscriptionType == 'Second_driver') {
                return subscription.secondDriver;
            }

            if (subscription.subscriptionType == 'Spectator') {
                return subscription.spectator;
            }
        };

// BOOKING functions

        $scope.toggleBookingForm = function() {
            $scope.showBookingForm = !$scope.showBookingForm;

            if ($scope.showBookingForm) {
                $scope.showEditBookingForm();
            } else {
                $scope.hideEditBookingForm();
            }
        };

        $scope.showEditBookingForm = function() {
            $scope.showBookingForm = true;
            angular.element("#field_client").focus();
        };

        $scope.hideEditBookingForm = function() {
            $scope.showBookingForm = false;
        };

        var getBooking = function() {
            BookingFactory.get({id : $scope.bookingId}).$promise.then(function(data) {
                $scope.booking = data;
            });
        };

        $scope.saveBooking = function () {
            $scope.submitButtonIsActive = false;

            //check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
            if($scope.booking.event === "") {
                $scope.booking.event = null;
            }
            //check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
            if($scope.booking.client === "") {
                $scope.booking.client = null;
                AlertService.warning("Please choose a client for a booking");
                return;
            }

            if(!$rootScope.isDefinedAndNotNull($scope.booking.client)) {
                AlertService.warning("Please choose a client for a booking");
                return;
            }

            if ($scope.booking.id != null) {
                return BookingFactory.update($scope.booking, onSaveBookingFinishedCallback, saveOrUpdateBookingErrorCallback);
            } else {
                return BookingFactory.save($scope.booking, function(booking) {
                    $scope.booking = booking;
                    $scope.bookingId = booking.id;
                    // HACK to update the browser url, we need to add the bookingId otherwise reloading the page breaks functionality
                    $state.go('event.detail.booking', {eventId:booking.event.id, bookingId:booking.id}, {notify:false, reload:false});
                    $scope.hideEditBookingForm();
                    $scope.addDriver();
                    return booking;
                }, saveOrUpdateBookingErrorCallback);
            }
        };

        var onSaveBookingFinishedCallback = function (result) {
            $scope.booking = result;
            $scope.bookingId = result.id;
            $scope.hideEditBookingForm();
            AlertService.success("Booking has been updated");
        };

        var saveOrUpdateBookingErrorCallback = function(error){
            AlertService.error(error.data.message, error.data.params);
        };

// CAR functions

        $scope.showEditCarForm = function() {
            if ($scope.showCarForm) {
                // if edit button is clicked while the form already was opened, we close it

                $scope.hideEditCarForm();
                return;
            }
            $scope.showCarForm = true;
            angular.element("input#field_car").focus();
        };

        $scope.hideEditCarForm = function() {
            $scope.showCarForm = false;
        };

        $scope.hasCarData = function() {
            return $rootScope.isDefinedAndNotNull($scope.currentSubscription)
                && $rootScope.isDefinedAndNotNull($scope.currentSubscription.driverDto)
                && $rootScope.isDefinedAndNotNull($scope.currentSubscription.driverDto.car);
        };

        $scope.saveCar = function() {
            if ($scope.subscriptionToEdit.car == "") {
                $scope.subscriptionToEdit.car = null;
            }

            // NOTE this resets the $scope.subscriptionToEdit
            $scope.saveSubscription();
        };

        $scope.editCar = function() {
            $scope.showEditCarForm();

            // get the subscription (driver) pojo and the car pojo and set it to $scope.subscriptionToEdit
            getDriver().then(function(result){
                $scope.subscriptionToEdit = result;

                // try to set insurance and fuel from the defaults
                if ($rootScope.isDefinedAndNotNull($scope.booking.event.templateEvent)) {
                    if (!$rootScope.isDefinedAndNotNull($scope.subscriptionToEdit.insurance)) {
                        $scope.subscriptionToEdit.insurance = $scope.booking.event.templateEvent.defaultInsurance;
                    }
                    if (!$rootScope.isDefinedAndNotNull($scope.subscriptionToEdit.fuel)) {
                        $scope.subscriptionToEdit.fuel = $scope.booking.event.templateEvent.defaultFuel;
                    }
                }
            });
        };

        $scope.onCarSelect = function($item, $model, $label, $event) {
            if ($scope.subscriptionToEdit.car == null || $scope.subscriptionToEdit.car.rental !== true) {
                $scope.subscriptionToEdit.fuel = null;
            }
        }

// SUBSCRIPTION functions
				var subscriptionUpdatingIsInProgress = false;
		    $scope.saveSubscription = function() {
					// Another callback did not complete yet
					if (subscriptionUpdatingIsInProgress) {
						return;
					}
					subscriptionUpdatingIsInProgress = true;
					// console.log($scope.subscriptionToEdit);
					if ($scope.subscriptionToEdit.id != null) {
						SubscriptionFactory.update($scope.subscriptionToEdit, onSaveSubscriptionFinishedCallback, saveOrUpdateSubscriptionErrorCallback);
					} else {
						SubscriptionFactory.save($scope.subscriptionToEdit, onSaveSubscriptionFinishedCallback, saveOrUpdateSubscriptionErrorCallback);
					}
				};

        var onSaveSubscriptionFinishedCallback = function (result) {
						subscriptionUpdatingIsInProgress = false;
            $scope.hideEditCarForm();
            hideSubscriptionForm();
            AlertService.info(result.relation.personName + " has been saved");
            $timeout(function(){
                $scope.loadData(result.id);
            }, 10);
        };

        var saveOrUpdateSubscriptionErrorCallback = function(error){
						subscriptionUpdatingIsInProgress = false;
            console.log(error);
            AlertService.error(error.data.message, error.data.params);
            $scope.hideEditCarForm();
            hideSubscriptionForm();
        };

        $scope.addDriver = function() {
            $scope.hideEditCarForm();

            if ($scope.hasCarData()) {
                $scope.currentSubscription.driverDto.car = null;
            }

            var driver = getNewSubscription('Driver'); // returns a Promise

            // once the driver (promise) is ready, then proceed
            driver.then(function(data) {
                $scope.subscriptionToEdit = data;
                if ($rootScope.isDefinedAndNotNull($scope.booking.client)) {
                    // preset the chosen booking relation as subscription relation
                    $scope.subscriptionToEdit.relation = $scope.booking.client;
                }
                if ($rootScope.isDefinedAndNotNull($stateParams.predefinedSubscriptionStatus)) {
                    // preset the chosen subscription status IF available
                    $scope.subscriptionToEdit.status = $stateParams.predefinedSubscriptionStatus;
                }

                showSubscriptionForm();

                $scope.hideAddingNewDriver = true;
            });

        };

        var getDriver = function() {
            var driverPkId = $scope.currentSubscription.driverDto.subscriptionIdPk;

            return SubscriptionFactory.get({
                id : driverPkId
            }).$promise.then(function(data) {
                return data;
            }, function(error) {
                AlertService.error("Failed to retrieve driver subscription",error);
            }); // the driver subscription
        };

        $scope.addSubscription = function(subscriptionType) {
            var subscription = getNewSubscription(subscriptionType);
            var driver = getDriver();

            $q.all({subscription: subscription, driver: driver}).then(function(results) {
                results.subscription.relationOf = results.driver;
                $scope.subscriptionToEdit = results.subscription;
                if ($scope.subscriptionToEdit.subscriptionType == 'Spectator') {
                    $scope.showInstructionData = false;
                }
                showSubscriptionForm();
            });
        };

        /**
         * Pops up delete driver subscription confirmation dialog
         * @param subscription
         */
        $scope.deleteDriverSubscription = function (subscription) {
            SubscriptionFactory.get({id: subscription.subscriptionIdPk}, function(result) {
                $scope.subscriptionToDelete = result;
                $('#deleteSubscriptionConfirmation').modal('show');
            });
        };

        /**
         * Deletes a driver subscription
         * @param id
         */
        $scope.confirmDeleteDriverSubscription = function (id) {
            SubscriptionFactory.delete({id: id}, function () {
                AlertService.success("Deleted driver " + $scope.subscriptionToDelete.relation.personName);
                $scope.subscriptionToDelete = null;
                $('#deleteSubscriptionConfirmation').modal('hide');

                // attempt to load previous subscription
                $scope.loadData(null);

            }, function (error) {
                AlertService.warning("Failed to delete ");
            });
        };

        /**
         * Deletes second driver / spectator subscriptions
         * @param subscription
         */
        $scope.deleteSubscription = function(subscription) {
            SubscriptionFactory.delete({id: subscription.subscriptionIdPk}, function () {
                $scope.loadData(-1);
                AlertService.success("Deleted subscription " + subscription.subscriptionIdPk);
            }, function (error) {
                AlertService.warning("Failed to delete ");
            });
        };

        var getNewSubscription = function(subscriptionType) {
            return NewSubscriptionFactory.get().$promise.then(function(data) {
                var subscription = data;

                subscription.subscriptionType = subscriptionType;
                subscription.booking = $scope.booking;
                if ($rootScope.isDefinedAndNotNull($scope.booking.event.templateEvent)) {
                    subscription.driver = $scope.booking.event.templateEvent.defaultDriver;
                    subscription.secondDriver = $scope.booking.event.templateEvent.defaultSecondDriver;
                    subscription.spectator = $scope.booking.event.templateEvent.defaultSpectator;
                    subscription.hotel = $scope.booking.event.templateEvent.defaultHotel;
                    subscription.trainingType = $scope.booking.event.templateEvent;
                }
                subscription.status = 'CONFIRMED';
                switch (subscriptionType) {
                    case 'Driver':
                        if (subscription.driver) {
                            subscription.instructionHours = subscription.driver.includedInstructionHours;
                        } else {
                            subscription.instructionHours = $scope.driverList[0].includedInstructionHours;
                        }
                        break;
                    case 'Second_driver':
                        if (subscription.secondDriver) {
                            subscription.instructionHours = subscription.secondDriver.includedInstructionHours;
                        } else {
                            subscription.instructionHours = $scope.secondDriverList[0].includedInstructionHours;
                        }
                        break;
                    case 'Spectator':
                        if (subscription.spectator) {
                            subscription.instructionHours = subscription.spectator.includedInstructionHours;
                        } else {
                            subscription.instructionHours = $scope.spectatorList[0].includedInstructionHours;
                        }
                        break;
                }

                return subscription;
            }, function(error) {
                return error;
            });
        };

        $scope.cancelSubscription = function() {
            hideSubscriptionForm();
            $scope.loadData()
        };

        $scope.editSubscription = function(subscription) {
            // retrieve the subscription from backend
            SubscriptionFactory.get({
                id : subscription.subscriptionIdPk
            }).$promise.then(function(data) {
                $scope.subscriptionToEdit = data;
                $scope.showEditInstructionData = ($scope.subscriptionToEdit.subscriptionType!='Spectator');
                $scope.showEditSubscriptionForm = true;
            }, function(error) {
                AlertService.error("Failed to retrieve subscription",error);
            });
        };

				$scope.showEmailDialog = function (bookingId, subscriptionId) {
					ConfirmationEmailManager.confirmationEmailDialog(bookingId, subscriptionId, function () {
						// noop
					});
				};

        $scope.updateInstructionHours = function() {
            switch ($scope.subscriptionToEdit.subscriptionType) {
                case 'Driver':
                    $scope.subscriptionToEdit.instructionHours = $scope.subscriptionToEdit.driver.includedInstructionHours;
                    break;
                case 'Second_driver':
                    $scope.subscriptionToEdit.instructionHours = $scope.subscriptionToEdit.secondDriver.includedInstructionHours;
                    break;
                case 'Spectator':
                    $scope.subscriptionToEdit.instructionHours = $scope.subscriptionToEdit.spectator.includedInstructionHours;
                    break;
            }
        };

        var showSubscriptionForm = function() {
            // TODO remove this once it works well, the idea is that $scope.hideAddingNewDriver is set to false when hiding the form, but only set to true when adding a driver not other subscriptions
            // $scope.hideAddingNewDriver = true;

            $scope.showEditSubscriptionForm = true;
            $scope.showEditInstructionData = ($scope.subscriptionToEdit.subscriptionType!='Spectator');
            $timeout(function(){
                // simply setting focus does not set focus, probably as this relation input is a typeahead autocomplete that also needs to be initialized, by setting a timeout it executes this focus later in the js chain
                angular.element("input#field_relation").focus();
            },0)
        };

        var hideSubscriptionForm = function() {
            $scope.hideAddingNewDriver = false;
            $scope.showEditSubscriptionForm = false;
            $scope.subscriptionToEdit = null;
        };

        $scope.isValidDriverSubscription = function() {
            return $rootScope.isDefinedAndNotNull($scope.currentSubscription)
                && $rootScope.isDefinedAndNotNull($scope.currentSubscription.driverDto)
                && $rootScope.isDefinedAndNotNull($scope.currentSubscription.driverDto.subscriptionIdPk);
        };

        $scope.previousSubscription = function() {
            hideSubscriptionForm();
            if (!$rootScope.isDefinedAndNotNull($scope.currentSubscriptionIndex)) {
                $scope.currentSubscriptionIndex = 0;
            }
            if ($scope.currentSubscriptionIndex > 0) {
                $scope.currentSubscriptionIndex--;
            } else {
                console.warn("Unable to decrease the $scope.currentSubscriptionIndex as it is already 0");
            }

            updateCurrentSubscription();
        };

        $scope.nextSubscription = function() {
            hideSubscriptionForm();
            if (!$rootScope.isDefinedAndNotNull($scope.currentSubscriptionIndex)) {
                $scope.currentSubscriptionIndex = 0;
            }
            if ($scope.currentSubscriptionIndex < $scope.subscriptionList.length - 1) {
                $scope.currentSubscriptionIndex++;
            } else {
                console.warn("Unable to increase the $scope.currentSubscriptionIndex as it is already the max index");
            }

            updateCurrentSubscription();
        };

        function updateCurrentSubscription() {
            $scope.currentSubscription = $scope.subscriptionList[$scope.currentSubscriptionIndex];
            $scope.driverId = $scope.currentSubscription.driverDto.subscriptionIdPk;
            // we have to update the state params driver ID so it is contained for the situation where we come back from a new relation dialog
            $stateParams.driverId = $scope.driverId;
        }

        $scope.hasPreviousSubscription = function() {
            if ($scope.currentSubscriptionIndex > 0) {
                return true;
            }
            return false;
        };

        $scope.hasNextSubscription = function() {
            if ($scope.currentSubscriptionIndex < $scope.subscriptionList.length - 1) {
                return true;
            }
            return false;
        };

// additional helper functions

        $scope.toggleBookingData = function() {
            $scope.showBookingData = !$scope.showBookingData;
            if ($scope.showBookingData) {
                angular.element("#showBookingDataIcon").removeClass("glyphicon-remove-circle");
                angular.element("#showBookingDataIcon").addClass("glyphicon-ok-circle");
            } else {
                angular.element("#showBookingDataIcon").removeClass("glyphicon-ok-circle");
                angular.element("#showBookingDataIcon").addClass("glyphicon-remove-circle");
            }
        };

        $scope.toggleInstructionData = function() {
            $scope.showInstructionData = !$scope.showInstructionData;
            if ($scope.showInstructionData) {
                angular.element("#showInstructionDataIcon").removeClass("glyphicon-remove-circle");
                angular.element("#showInstructionDataIcon").addClass("glyphicon-ok-circle");
            } else {
                angular.element("#showInstructionDataIcon").removeClass("glyphicon-ok-circle");
                angular.element("#showInstructionDataIcon").addClass("glyphicon-remove-circle");
            }
        };

        /**
         * This function queries all entities of type SubscriptionType
         */
        $scope.instructorList = null;
        $scope.subscriptionTypeList = NoPagingSubscriptionTypeFactory.query();
        $scope.statusList = NoPagingSubscriptionStatusFactory.query();
        $scope.hotelList = SubscriptionFindArticleFilteredByHotelFactory.query();
        $scope.trainingTypeList = NoPagingTemplateEventFactory.query();
        $scope.driverList = SubscriptionFindArticleFilteredByDriverFactory.query();
        $scope.secondDriverList = SubscriptionFindArticleFilteredBySecondDriverFactory.query();
        $scope.spectatorList = SubscriptionFindArticleFilteredBySpectatorFactory.query();
        $scope.fuelList = SubscriptionFindArticleFilteredByFuelFactory.query();
        $scope.insuranceList = SubscriptionFindArticleFilteredByInsuranceFactory.query();
        $scope.instructorList = InstructorsByEventFactory.query({id: $scope.eventId});
        $scope.bookingStatusList = NoPagingBookingStatusFactory.query();
        $scope.autocompleteRelations = function(val) {
            var params = {
                'relationTypeAheadSearchString': val
            };

            return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
                return results;
            });
        };
        $scope.autocompleteCars = function(val) {
            var params = {
                'carTypeAheadSearchString': val
            };

            return AutocompleteCarsByQueryParamsFactory.query(params).$promise.then(function(results) {
                return results;
            });
        };

        $scope.selectSubscriptionRelation = function() {
            console.log($scope.subscriptionToEdit.relation);

        };

        var resetParams = function() {
            // reset the dataModel attribute in the current state params
            HistoryService.resetCurrentHistoryParamsData();

            // reset 'remembered' values to prevent future misbehaviour
            $rootScope.previousStateParams.dataModel = null;
            $stateParams.dataModel = null;
        };

        /**
         * Function to load the page data. This involves a booking, but if applicable also a driver subscription plus its dependants (2nd drivers and spectators, car)
         *
         * @param driverPkId The driver ID is provided by the caller, and can be the driverId from the scope (populated from stateParams), or by request none or something else
         */
        $scope.loadData = function(driverPkId) {
            console.log("Loading data for driver",driverPkId);

            // this IF handles the situation where a new booking.client, car, subscription.instructor or subscription.relation has been created
            if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
                console.log("dataModel detected in stateParams:",$stateParams.dataModel,"dataModelType:",$stateParams.dataModelType);

                // either a booking, car, subscription relation or subscription instructor has been updated, hence we save the dataModel as subscription to edit!
                switch ($stateParams.dataModelType) {
                    case "client":
                        console.log("a client (relation) was detected when loading the page, we will update the booking and show the form");

                        $scope.booking = $stateParams.dataModel;
                        $scope.bookingId = $scope.booking.id;

                        // HACK to update the browser url, we need to add the bookingId otherwise reloading the page breaks functionality
                        $state.go('event.detail.booking', {eventId:$scope.booking.event.id, bookingId:$scope.bookingId}, {notify:false, reload:false});

                        resetParams();

                        $scope.showEditBookingForm();

                        break;
                    case "car":
                        console.log("a car was detected when loading the page");

                        // in case of a car we have the new car set as property of the dataModel which is subscriptionToEdit
                        $scope.subscriptionToEdit = $stateParams.dataModel;
                        $scope.booking = $scope.subscriptionToEdit.booking;
                        $scope.bookingId = $scope.booking.id;

                        resetParams();

                        // we execute saveSubscription after 50ms as we want to return first
                        // after 50ms saveSubscription will run and eventually after doing what it needs to do call this loadData function again
                        $timeout(function(){
                            $scope.saveSubscription();
                        },50);

                        // right after
                        return;
                    case "instructor":
                        console.log("an instructor was detected when loading the page");

                        // in case of a car we have the new car set as property of the dataModel which is subscriptionToEdit
                        $scope.subscriptionToEdit = $stateParams.dataModel;
                        $scope.booking = $scope.subscriptionToEdit.booking;
                        $scope.bookingId = $scope.booking.id;

                        // HACK to update the browser url, we need to add the bookingId otherwise reloading the page breaks functionality
                        $state.go('event.detail.booking', {eventId:$scope.booking.event.id, bookingId:$scope.bookingId}, {notify:false, reload:false});

                        resetParams();

                        showSubscriptionForm();

                        // we execute a trick to show the instruction data by initially setting the show boolean to false, then we toggle it thus it becomes true causing to show the data
                        $scope.showInstructionData = false;
                        $scope.toggleInstructionData();
                        // TODO we should update the visual state of the button too

                        break;
                    case "relation":
                        console.log("a relation was detected when loading the page");

                        // in case of a car we have the new car set as property of the dataModel which is subscriptionToEdit
                        $scope.subscriptionToEdit = $stateParams.dataModel;
                        $scope.booking = $scope.subscriptionToEdit.booking;
                        $scope.bookingId = $scope.booking.id;

                        // HACK to update the browser url, we need to add the bookingId otherwise reloading the page breaks functionality
                        $state.go('event.detail.booking', {eventId:$scope.booking.event.id, bookingId:$scope.bookingId}, {notify:false, reload:false});

                        // $scope.subscriptionToEdit.relationOf.id - driver id

                        resetParams();

                        showSubscriptionForm();

                        // we execute a trick to show the instruction data by initially setting the show boolean to false, then we toggle it thus it becomes true causing to show the data
                        $scope.showBookingData = false;
                        $scope.toggleBookingData();

                        break;
                    default:
                        console.log("$stateParams.dataModelType unknown:",$stateParams.dataModelType);
                }

                // as saveSubscription reloads the data (by executing this loadData method) we can now savely return from this method
            }

            $scope.currentSubscription = null;

            if (!$rootScope.isDefinedAndNotNull(driverPkId)) {
                $scope.currentSubscriptionIndex = 0;
            }

            if (!$rootScope.isDefinedAndNotNull($scope.currentSubscriptionIndex)) {
                $scope.currentSubscriptionIndex = 0;
            }

            if ($rootScope.isDefinedAndNotNull($scope.bookingId) && $scope.bookingId !== "") {
                console.log("Loading data for existing booking", $scope.bookingId);

                $scope.hideEditBookingForm();

                BookingSubscriptionsFactory.query({
                    bookingId: $scope.bookingId
                }, function (result) {
                    $scope.subscriptionList = result;

                    angular.forEach($scope.subscriptionList, function(value, key) {
                        if ($rootScope.isDefinedAndNotNull(value.driverDto) && value.driverDto.subscriptionIdPk === driverPkId) {
                            $scope.currentSubscriptionIndex = key;
                        }
                    });

                    // get the first subscription as current
                    if ($scope.subscriptionList.length > 0) {
                        $scope.currentSubscription = $scope.subscriptionList[$scope.currentSubscriptionIndex];
                        getBooking();
                    }
                }, function (error) {
                    AlertService.error(error.data.detail);
                });
            } else {
                // the page was loaded without a booking id meaning we're dealing with a new booking, prepare this!
                console.log("Loading data for new booking and driver subscription");
                $scope.showEditBookingForm();
            }

        };

        $scope.hasDriver = function() {
            return $rootScope.isDefinedAndNotNull($scope.currentSubscription) && $rootScope.isDefinedAndNotNull($scope.currentSubscription.driverDto);
        };

        $scope.translateStatus = function(status) {
            return $rootScope.isDefinedAndNotNull(status) ? $translate.instant('SubscriptionStatus.' + status) : "";
        };

        $scope.billBooking = function(booking, omitNotification) {
            $("#billButtonIcon").addClass("glyphicon-euro-animate");

            var preSnelstartId = booking.snelstartVerkoopOrderId;

            BookingSnelstartFactory.billBooking(booking, function(result) {
                $scope.booking = result;

                if (preSnelstartId != result.snelstartVerkoopOrderId) {
                    var dlgMsg = $translate.instant("global.messages.info.bookingBilledSuccesfully", {"status": result.status});
                } else {
                    var dlgMsg = $translate.instant("global.messages.info.bookingAcceptedSuccesfully", {"status": result.status});
                }
								if (!omitNotification) {
									dialogs.notify($translate.instant("booking.dialog.bill.title.success"), dlgMsg).result.then(function() {
										$("#billButtonIcon").removeClass("glyphicon-euro-animate");
									});
								}
            }, function(error) {
                console.error(error);
                var dlgMsg = $translate.instant(error.data.message, error.data.params);
                dialogs.error($translate.instant("booking.dialog.bill.title.failed"), dlgMsg).result.then(function() {
                    $("#billButtonIcon").removeClass("glyphicon-euro-animate");
                });
            });
        };

        $scope.loadData($scope.driverId);
    });

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('entity', {
			abstract: true,
			parent: 'app',
		});
	}
})();

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	$stateProvider.state('entity', {
		abstract: true,
		parent: 'site',
	});
});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('DocumentTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		DocumentTypeFactory,
		AlertService,
		NoPagingDocumentTypeFactory
	) {
		$scope.documentType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.documentType) && $rootScope.isDefinedAndNotNull($scope.documentType.id);
		};

		$scope.submitButtonIsActive = true;

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:documentTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving DocumentType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.documentType.id != null) {
				DocumentTypeFactory.update($scope.documentType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				DocumentTypeFactory.save($scope.documentType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('DocumentTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.documentType = entity;
	$scope.objectName = 'DocumentType';
	$scope.documentTypeId = $stateParams.documentTypeId;

	if (angular.isUndefined($rootScope.documentTypeActiveTab)) {
		//set the default here
		$rootScope.documentTypeActiveTab = 0;
	}

	$scope.goToEditState = function(documentType) {
		$state.go('documenttype.detail.edit({documentTypeId:documentType.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:documentTypeUpdate', function(event, result) {
		$scope.documentType = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'DocumentType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('documenttype'); // main translation loaded for documenttype

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/documenttype/documenttype-dialog.html';

		return {
			/* new state for entity documentType */
			/* to access: ui-ref="documenttype.list.new" */
			/* url: hostname/documenttype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'DocumentTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'DocumentTypeFactory',
									'NewDocumentTypeFactory',
									function(DocumentTypeFactory, NewDocumentTypeFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return DocumentTypeFactory.get({ id: $stateParams.documentTypeId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewDocumentTypeFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for documentType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for documentType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('documenttype', {
		/* abstract state for entity documentType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/documenttype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'DocumentTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('documenttype.list', {
		/* list state for entity documentType */
		/* to access: ui-ref="documenttype.list" */
		/* url: hostname/documenttype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/documenttype/documenttypes.html',
				controller: 'DocumentTypeController',
			},
		},
	});

	$stateProvider.state('documenttype.detail', {
		/* detail state for entity documentType */
		/* to access: ui-sref="documenttype.detail" */
		/* url: hostname/documenttype/detail/:documentTypeId */
		url: '/detail/:documentTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/documenttype/documenttype-detail.html',
				controller: 'DocumentTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'DocumentTypeFactory',
				function($stateParams, DocumentTypeFactory) {
					return DocumentTypeFactory.get({ id: $stateParams.documentTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/documenttype/list/new */
	$stateProvider.state('documenttype.list.new', getNewState());
	/* url: http://<hostname>/documenttype/list/:documentTypeId/edit */
	$stateProvider.state('documenttype.list.edit', getEditState('/:documentTypeId/edit'));
	/* url: http://<hostname>/documenttype/detail/:documentTypeId/edit */
	$stateProvider.state('documenttype.detail.edit', getEditState('/edit'));

	$stateProvider.state('document.list.newDocumentType', getNewState('/documenttype/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('DocumentTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		DocumentTypeFactory,
		FindAllDocumentTypesByQueryParamsFactory,
		NoPagingDocumentTypeFactory
	) {
		$scope.documentTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeDocumentType)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeDocumentType);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocumentType = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newDocumentType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(documentType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editDocumentType', {
				documentTypeId: documentType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getDocumentTypeList = function() {
			FindAllDocumentTypesByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.documentTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getDocumentTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedDocumentTypeId = id;
			$('#deleteDocumentTypeConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			DocumentTypeFactory.delete(
				{ id: $scope.selectedDocumentTypeId },
				function() {
					$scope.loadAll();
					$('#deleteDocumentTypeConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteDocumentTypeConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('DocumentTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		DocumentTypeFactory,
		FindAllDocumentTypesByQueryParamsFactory,
		NoPagingDocumentTypeFactory
	) {
		$scope.documentTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeDocumentType)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeDocumentType);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocumentType = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('documenttype.list.new');
		};

		$scope.goToEditState = function(documentType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('documenttype.list.edit', { documentTypeId: documentType.id });
		};

		$scope.getDocumentTypeList = function() {
			FindAllDocumentTypesByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.documentTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getDocumentTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedDocumentTypeId = id;
			$('#deleteDocumentTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			DocumentTypeFactory.delete(
				{ id: $scope.selectedDocumentTypeId },
				function() {
					$scope.loadAll();
					$('#deleteDocumentTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteDocumentTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('DocumentDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		DocumentFactory,
		AlertService,
		FileUploader,
		NoPagingDocumentFactory,
		NoPagingDocumentTypeFactory,
		CarFactory,
		NoPagingCarFactory,
		AutocompleteCarsByQueryParamsFactory,
		NoPagingLocationFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		EventFactory,
		NoPagingEventFactory,
		AutocompleteEventsByQueryParamsFactory,
		$cookies
	) {
		$scope.document = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.document) && $rootScope.isDefinedAndNotNull($scope.document.id);
		};

		$scope.createType = function() {
			var referredBy = {
				refName: 'type',
				data: $scope.document,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new type will add this new document state to the history stack
				$state.go('document.list.newDocumentType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createCar = function() {
			var referredBy = {
				refName: 'car',
				data: $scope.document,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new car will add this new document state to the history stack
				$state.go('document.list.newCar', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createLocation = function() {
			var referredBy = {
				refName: 'location',
				data: $scope.document,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new location will add this new document state to the history stack
				$state.go('document.list.newLocation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createRelation = function() {
			var referredBy = {
				refName: 'relation',
				data: $scope.document,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new relation will add this new document state to the history stack
				$state.go('document.list.newRelation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createEvent = function() {
			var referredBy = {
				refName: 'event',
				data: $scope.document,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new event will add this new document state to the history stack
				$state.go('document.list.newEvent', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		var isUploadReady = true;
		var isUploadDisabled = false; // this variable is used in the statement to determine whether the file input should be enabled
		var errorMessage = '';

		var uploader = ($scope.file = new FileUploader({
			url: 'api/documents/',
			autoUpload: false,
			headers: {
				Accept: 'application/json, text/plain, */*',
				'X-CSRF-TOKEN': $cookies.get('CSRF-TOKEN'), // cookie with name CSRF-TOKEN is used by Angular
			},
		}));

		$scope.isDisableFileInput = function() {
			return uploader.queueLimit == uploader.queue.length || isUploadDisabled;
		};

		uploader.onErrorItem = function(fileItem, response, status, headers) {
			// console.log("uploader.onErrorItem");
			isUploadReady = false;
		};

		uploader.onAfterAddingFile = function(fileItem) {
			// console.log("uploader.onAfterAddingFile");
			if (uploader.queue.length == 2) {
				//delete one item on the left side of the array (Jquery function)
				uploader.queue.shift();
			}
			$scope.submitButtonIsActive = true;
		};

		var clearFileInputAndQueue = function() {
			uploader.clearQueue();
			//Clear the file input. Since there is no ng-model binding we can only do this by directly calling the DOM element(s) and set it to null
			angular.element("input[type='file']").val(null);
		};

		uploader.onWhenAddingFileFailed = function(item, filter, options) {
			$scope.submitButtonIsActive = false;
			AlertService.error('error.file.upload.onWhenAddingFileFailed');
			clearFileInputAndQueue();
		};

		uploader.onCompleteItem = function(fileItem, result, status) {
			if (status == 201) {
				onSaveFinishedCallback(result);
			} else {
				// something went wrong, cancel all items in uploader and clear the queue
				uploader.cancelAll();
				uploader.clearQueue();

				// default error message in case none of below statusses match
				errorMessage = 'error.file.upload.general';

				switch (status) {
					case 500: {
						if (result.indexOf('SizeLimitExceededException') != -1) {
							errorMessage = 'error.file.upload.size.exceeded';
						}
					}
					// more cases to come
				}

				AlertService.error(errorMessage);
				$scope.submitButtonIsActive = false;
			}
		};

		$scope.submitButtonIsActive = false;

		$scope.autocompleteCars = function(val) {
			var params = {
				carTypeAheadSearchString: val,
			};

			return AutocompleteCarsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};
		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};
		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('document.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type Type and checks if this Document dialog is called in the context of Type.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryType = function() {
			return NoPagingDocumentTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'type');
			});
		};
		$scope.typeList = $scope.queryType();
		// --- end default implementation

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryCar = function() {
			// If the id of a preselected car is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return CarFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'car');
					}
				});
			}
		};
		$scope.carList = $scope.queryCar();

		// --- start default implementation
		/**
		 * This function queries all entities of type Location and checks if this Document dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				$scope.findItemByParent(result, 'location');
			});
		};
		$scope.locationList = $scope.queryLocation();
		// --- end default implementation

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryRelation = function() {
			// If the id of a preselected relation is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'relation');
					}
				});
			}
		};
		$scope.relationList = $scope.queryRelation();

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryEvent = function() {
			// If the id of a preselected event is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return EventFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'event');
					}
				});
			}
		};
		$scope.eventList = $scope.queryEvent();

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:documentUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Document failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			var formData = [];
			$scope.submitButtonIsActive = false;
			if (!angular.isUndefined($scope.document.createdOn) && $scope.document.createdOn != null) {
				formData.push({ createdOn: $scope.document.createdOn });
			}
			if (!angular.isUndefined($scope.document.description) && $scope.document.description != null) {
				formData.push({ description: $scope.document.description });
			}
			if (!angular.isUndefined($scope.document.name) && $scope.document.name != null) {
				formData.push({ name: $scope.document.name });
			}
			if (!angular.isUndefined($scope.document.fileName) && $scope.document.fileName != null) {
				formData.push({ fileName: $scope.document.fileName });
			}
			if (!angular.isUndefined($scope.document.file) && $scope.document.file != null) {
				formData.push({ file: $scope.document.file });
			}
			if (!angular.isUndefined($scope.document.fileType) && $scope.document.fileType != null) {
				formData.push({ fileType: $scope.document.fileType });
			}
			if (!angular.isUndefined($scope.document.type) && $scope.document.type != null) {
				formData.push({ typeId: $scope.document.type.id });
			}
			if (!angular.isUndefined($scope.document.car) && $scope.document.car != null) {
				formData.push({ carId: $scope.document.car.id });
			}
			if (!angular.isUndefined($scope.document.location) && $scope.document.location != null) {
				formData.push({ locationId: $scope.document.location.id });
			}
			if (!angular.isUndefined($scope.document.relation) && $scope.document.relation != null) {
				formData.push({ relationId: $scope.document.relation.id });
			}
			if (!angular.isUndefined($scope.document.event) && $scope.document.event != null) {
				formData.push({ eventId: $scope.document.event.id });
			}
			if (!angular.isUndefined($scope.file.queue[0]) && isUploadReady) {
				$scope.file.queue[0].formData = formData;
				$scope.submitButtonIsActive = false;
				$scope.file.uploadAll(); // triggers the multipart form POST
			} else {
				if (isUploadReady) {
					AlertService.error('error.file.upload.not.selected', {});
				} else {
					AlertService.error(errorMessage, {});
				}
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};

		// this statement disables the file input
		isUploadDisabled = true;

		// executes when onchange is triggered for Document.DocumentType reference listbox
		// goal is to push the new filters to the uploader based on the chosen DocumentType
		// after this the file upload will be enabled
		$scope.changeDocumentType = function(documentType) {
			if (angular.isDefined(documentType)) {
				// reset the filters as well as the file upload queue and push a new file extention filter to it to ensure only one is active
				uploader.filters = [];
				clearFileInputAndQueue();
				uploader.filters.push({
					name: documentType.functionalType + 'Filter',
					fn: function(item /*{File|FileLikeObject}*/, options) {
						// TODO note the complex file type values for example for docx
						// |vnd.openxmlformats-officedocument.wordprocessingml.document|

						var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
						var hasType = documentType.technicalTypes.indexOf(type) !== -1;

						// console.log("has type by item.type: " + hasType);

						if (!hasType) {
							// if no item type has been dound
							var nameExt = '|' + item.name.slice(item.name.lastIndexOf('.') + 1) + '|';
							hasType = documentType.technicalTypes.indexOf(nameExt) !== -1;

							// console.log("has type by file name extention: " + hasType);
						}

						return hasType;
					},
				});
				isUploadDisabled = false; // enables the file input IF queue conditions are met in $scope.isDisableFileInput function
			} else {
				// no document type was chosen, disable file input
				isUploadDisabled = true;
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('DocumentDetailController', function($scope, $rootScope, $stateParams, $state, entity, DocumentDownloadService) {
		$scope.document = entity;
		$scope.objectName = 'Document';
		$scope.documentId = $stateParams.documentId;

		if (angular.isUndefined($rootScope.documentActiveTab)) {
			//set the default here
			$rootScope.documentActiveTab = 0;
		}

		$scope.goToEditState = function(document) {
			$state.go('document.detail.edit({documentId:document.id, mappedBy:mappedBy, mappedById:mappedById})');
		};

		// by broadcasting this event from an edit dialog the model is refreshed
		$rootScope.$on('emsApp:documentUpdate', function(event, result) {
			$scope.document = result;
		});

		$scope.download = function(id) {
			DocumentDownloadService(id);
		};
	});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Document'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('document'); // main translation loaded for document
		$translatePartialLoader.addPart('documenttype'); // one to many reference from main entity
		$translatePartialLoader.addPart('car'); // one to many reference from main entity
		$translatePartialLoader.addPart('location'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/document/document-dialog.html';

		return {
			/* new state for entity document */
			/* to access: ui-ref="document.list.new" */
			/* url: hostname/document/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'DocumentDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'DocumentFactory',
									'NewDocumentFactory',
									function(DocumentFactory, NewDocumentFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Document
										// - resuming the creation of a new new Document AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return DocumentFactory.get({ id: $stateParams.documentId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewDocumentFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for document new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for document edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('document', {
		/* abstract state for entity document */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/document',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Documents',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('document.list', {
		/* list state for entity document */
		/* to access: ui-ref="document.list" */
		/* url: hostname/document/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/document/documents.html',
				controller: 'DocumentController',
			},
		},
	});

	$stateProvider.state('document.detail', {
		/* detail state for entity document */
		/* to access: ui-sref="document.detail" */
		/* url: hostname/document/detail/:documentId */
		url: '/detail/:documentId',
		views: {
			'content@': {
				templateUrl: 'app/entities/document/document-detail.html',
				controller: 'DocumentDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'DocumentFactory',
				function($stateParams, DocumentFactory) {
					return DocumentFactory.get({ id: $stateParams.documentId });
				},
			],
		},
	});

	/* url: http://<hostname>/document/list/new */
	$stateProvider.state('document.list.new', getNewState());
	/* url: http://<hostname>/document/list/:documentId/edit */
	$stateProvider.state('document.list.edit', getEditState('/:documentId/edit'));
	/* url: http://<hostname>/document/detail/:documentId/edit */
	$stateProvider.state('document.detail.edit', getEditState('/edit'));
	// Relation.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/relation/detail/:relationId/document/new */
	$stateProvider.state('relation.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/relation/detail/:relationId/document/:documentId/edit */
	$stateProvider.state('relation.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/document/new */
	$stateProvider.state('user-relation.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/document/:documentId/edit */
	$stateProvider.state('user-relation.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Car.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/car/detail/:carId/document/new */
	$stateProvider.state('car.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/car/detail/:carId/document/:documentId/edit */
	$stateProvider.state('car.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Location.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/location/detail/:locationId/document/new */
	$stateProvider.state('location.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/location/detail/:locationId/document/:documentId/edit */
	$stateProvider.state('location.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Event.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/event/detail/:eventId/document/new */
	$stateProvider.state('event.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/event/detail/:eventId/document/:documentId/edit */
	$stateProvider.state('event.detail.editDocument', getEditState('/document/:documentId/edit'));

	$stateProvider.state('event.detail.subscriptions.newDocument', getNewState('/document/new'));
	$stateProvider.state('event.detail.subscriptions.editDocument', getEditState('/document/:documentId/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('DocumentTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		DocumentFactory,
		FindAllDocumentsByQueryParamsFactory,
		AutocompleteCarsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingDocumentFactory,
		NoPagingDocumentTypeFactory,
		NoPagingCarFactory,
		NoPagingLocationFactory,
		NoPagingRelationFactory,
		NoPagingEventFactory,
		DocumentDownloadService
	) {
		$scope.documentList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeDocument)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeDocument);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocument = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newDocument', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(document) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editDocument', {
				documentId: document.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		var getTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.typeId)) {
				return $scope.typeId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchTab.type)) {
					return $scope.DocumentSearchTab.type.id;
				} else {
					return undefined;
				}
			}
		};

		var getCarId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.carId)) {
				return $scope.carId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchTab.car)) {
					return $scope.DocumentSearchTab.car.id;
				} else {
					return undefined;
				}
			}
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.locationId)) {
				return $scope.locationId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchTab.location)) {
					return $scope.DocumentSearchTab.location.id;
				} else {
					return undefined;
				}
			}
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.relationId)) {
				return $scope.relationId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchTab.relation)) {
					return $scope.DocumentSearchTab.relation.id;
				} else {
					return undefined;
				}
			}
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.eventId)) {
				return $scope.eventId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchTab.event)) {
					return $scope.DocumentSearchTab.event.id;
				} else {
					return undefined;
				}
			}
		};

		// handle attribute createdOn of javaType java.time.ZonedDateTime
		$scope.processCreatedOn = function() {
			var createdOnFromDefined = $rootScope.isDefinedAndNotNull($scope.DocumentSearchTab.createdOnFrom);
			var createdOnToDefined = $rootScope.isDefinedAndNotNull($scope.DocumentSearchTab.createdOnTo);

			// TODO either we assign a value, or undefined, plus we check for undefined, hence we could assign the variable, period

			if (createdOnFromDefined) {
				$scope.DocumentSearchTab.createdOnFromString = $rootScope.convertDateWithoutZone($scope.DocumentSearchTab.createdOnFrom);
			} else {
				$scope.DocumentSearchTab.createdOnFromString = undefined;
			}

			if (createdOnToDefined) {
				$scope.DocumentSearchTab.createdOnToString = $rootScope.convertDateWithoutZone($scope.DocumentSearchTab.createdOnTo);
			} else {
				$scope.DocumentSearchTab.createdOnToString = undefined;
			}
		};

		/**
		 * This function queries all entities of type Type and checks if this Document dialog is called in the context of Type.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryType = function() {
			return NoPagingDocumentTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.typeReferenceFilterList = $scope.queryType();

		$scope.autocompleteCars = function(val) {
			var params = {
				carTypeAheadSearchString: val,
			};

			return AutocompleteCarsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type Location and checks if this Document dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				return result;
			});
		};
		$scope.locationReferenceFilterList = $scope.queryLocation();

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processCreatedOn();

			$rootScope.DocumentSearchTab = angular.copy($scope.DocumentSearchTab);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocument = angular.copy($scope.pageSize);

			FindAllDocumentsByQueryParamsFactory.query(
				{
					page: $scope.DocumentSearchTab.page - 1,
					size: $scope.pageSize,
					createdOnFrom: $scope.DocumentSearchTab.createdOnFromString,
					createdOnTo: $scope.DocumentSearchTab.createdOnToString,
					name: $scope.DocumentSearchTab.name,
					typeId: getTypeId(),
					carId: getCarId(),
					locationId: getLocationId(),
					relationId: getRelationId(),
					eventId: getEventId(),

					sort: [$scope.DocumentSearchTab.predicate + ',' + ($scope.DocumentSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.documentList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isDocumentSearchTabDirty = function() {
			return !angular.equals($scope.DocumentSearchTab, $scope.originalDocumentSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.DocumentSearchTab = {};
			$rootScope.DocumentSearchTab.page = 1;
			$rootScope.DocumentSearchTab.predicate = 'id';
			$rootScope.DocumentSearchTab.ascending = false;

			$scope.DocumentSearchTab = angular.copy($rootScope.DocumentSearchTab);

			$scope.originalDocumentSearchTab = angular.copy($scope.DocumentSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.DocumentSearchTab) || $rootScope.DocumentSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.DocumentSearchTab = angular.copy($rootScope.DocumentSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedDocumentId = id;
			$('#deleteDocumentConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			DocumentFactory.delete(
				{ id: $scope.selectedDocumentId },
				function() {
					$scope.search();
					$('#deleteDocumentConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteDocumentConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.downloadDocument = function(id) {
			DocumentDownloadService(id);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.DocumentSearchTab.predicate === itemName) {
				if ($scope.DocumentSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('DocumentController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		DocumentFactory,
		FindAllDocumentsByQueryParamsFactory,
		AutocompleteCarsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingDocumentFactory,
		NoPagingDocumentTypeFactory,
		NoPagingCarFactory,
		NoPagingLocationFactory,
		NoPagingRelationFactory,
		NoPagingEventFactory,
		DocumentDownloadService
	) {
		$scope.documentList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeDocument)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeDocument);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocument = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('document.list.new');
		};

		$scope.goToEditState = function(document) {
			// this overview is NOT mapped, it is the main overview
			$state.go('document.list.edit', { documentId: document.id });
		};

		var getTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.type)) {
				return $scope.DocumentSearchOverview.type.id;
			} else {
				return undefined;
			}
		};

		var getCarId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.car)) {
				return $scope.DocumentSearchOverview.car.id;
			} else {
				return undefined;
			}
		};

		var getLocationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.location)) {
				return $scope.DocumentSearchOverview.location.id;
			} else {
				return undefined;
			}
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.relation)) {
				return $scope.DocumentSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.event)) {
				return $scope.DocumentSearchOverview.event.id;
			} else {
				return undefined;
			}
		};

		// handle attribute createdOn of javaType java.time.ZonedDateTime
		$scope.processCreatedOn = function() {
			var createdOnFromDefined = $rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.createdOnFrom);
			var createdOnToDefined = $rootScope.isDefinedAndNotNull($scope.DocumentSearchOverview.createdOnTo);

			// TODO either we assign a value, or undefined, plus we check for undefined, hence we could assign the variable, period

			if (createdOnFromDefined) {
				$scope.DocumentSearchOverview.createdOnFromString = $rootScope.convertDateWithoutZone($scope.DocumentSearchOverview.createdOnFrom);
			} else {
				$scope.DocumentSearchOverview.createdOnFromString = undefined;
			}

			if (createdOnToDefined) {
				$scope.DocumentSearchOverview.createdOnToString = $rootScope.convertDateWithoutZone($scope.DocumentSearchOverview.createdOnTo);
			} else {
				$scope.DocumentSearchOverview.createdOnToString = undefined;
			}
		};

		/**
		 * This function queries all entities of type Type and checks if this Document dialog is called in the context of Type.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryType = function() {
			return NoPagingDocumentTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.typeReferenceFilterList = $scope.queryType();

		$scope.autocompleteCars = function(val) {
			var params = {
				carTypeAheadSearchString: val,
			};

			return AutocompleteCarsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type Location and checks if this Document dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity Document and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				return result;
			});
		};
		$scope.locationReferenceFilterList = $scope.queryLocation();

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processCreatedOn();

			$rootScope.DocumentSearchOverview = angular.copy($scope.DocumentSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeDocument = angular.copy($scope.pageSize);

			FindAllDocumentsByQueryParamsFactory.query(
				{
					page: $scope.DocumentSearchOverview.page - 1,
					size: $scope.pageSize,
					createdOnFrom: $scope.DocumentSearchOverview.createdOnFromString,
					createdOnTo: $scope.DocumentSearchOverview.createdOnToString,
					name: $scope.DocumentSearchOverview.name,
					typeId: getTypeId(),
					carId: getCarId(),
					locationId: getLocationId(),
					relationId: getRelationId(),
					eventId: getEventId(),

					sort: [$scope.DocumentSearchOverview.predicate + ',' + ($scope.DocumentSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.documentList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isDocumentSearchOverviewDirty = function() {
			return !angular.equals($scope.DocumentSearchOverview, $scope.originalDocumentSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.DocumentSearchOverview = {};
			$rootScope.DocumentSearchOverview.page = 1;
			$rootScope.DocumentSearchOverview.predicate = 'id';
			$rootScope.DocumentSearchOverview.ascending = false;

			$scope.DocumentSearchOverview = angular.copy($rootScope.DocumentSearchOverview);

			$scope.originalDocumentSearchOverview = angular.copy($scope.DocumentSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.DocumentSearchOverview) || $rootScope.DocumentSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.DocumentSearchOverview = angular.copy($rootScope.DocumentSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedDocumentId = id;
			$('#deleteDocumentConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			DocumentFactory.delete(
				{ id: $scope.selectedDocumentId },
				function() {
					$scope.search();
					$('#deleteDocumentConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteDocumentConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.downloadDocument = function(id) {
			DocumentDownloadService(id);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.DocumentSearchOverview.predicate === itemName) {
				if ($scope.DocumentSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserCountryListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CountryFactory,
		UserCountryListDtoSearchFactory
	) {
		$scope.countryList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCountry)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCountry);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeCountry = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-country.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getCountryList = function() {
			UserCountryListDtoSearchFactory.query(
				{
					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.countryList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCountryList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserCountryListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CountryFactory,
		UserCountryListDtoSearchFactory
	) {
		$scope.countryList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCountry)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCountry);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeCountry = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-country.new');
		};

		$scope.getCountryList = function() {
			UserCountryListDtoSearchFactory.query(
				{
					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.countryList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCountryList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('CountryDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		CountryFactory,
		AlertService,
		NoPagingCountryFactory
	) {
		$scope.country = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.country) && $rootScope.isDefinedAndNotNull($scope.country.id);
		};

		$scope.submitButtonIsActive = true;

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:countryUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Country failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.country.id != null) {
				CountryFactory.update($scope.country, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				CountryFactory.save($scope.country, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('CountryDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.country = entity;
	$scope.objectName = 'Country';
	$scope.countryId = $stateParams.countryId;

	if (angular.isUndefined($rootScope.countryActiveTab)) {
		//set the default here
		$rootScope.countryActiveTab = 0;
	}

	$scope.goToEditState = function(country) {
		$state.go('country.detail.edit({countryId:country.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:countryUpdate', function(event, result) {
		$scope.country = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Country'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('country'); // main translation loaded for country

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/country/country-dialog.html';

		return {
			/* new state for entity country */
			/* to access: ui-ref="country.list.new" */
			/* url: hostname/country/new */
			url: url,
			data: {
				authorities: [],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CountryDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CountryFactory',
									'NewCountryFactory',
									function(CountryFactory, NewCountryFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return CountryFactory.get({ id: $stateParams.countryId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewCountryFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for country new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for country edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('country', {
		/* abstract state for entity country */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/country',
		data: {
			authorities: [],
			pageTitle: 'Countries',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('country.list', {
		/* list state for entity country */
		/* to access: ui-ref="country.list" */
		/* url: hostname/country/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/country/countries.html',
				controller: 'CountryController',
			},
		},
	});

	$stateProvider.state('country.detail', {
		/* detail state for entity country */
		/* to access: ui-sref="country.detail" */
		/* url: hostname/country/detail/:countryId */
		url: '/detail/:countryId',
		views: {
			'content@': {
				templateUrl: 'app/entities/country/country-detail.html',
				controller: 'CountryDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CountryFactory',
				function($stateParams, CountryFactory) {
					return CountryFactory.get({ id: $stateParams.countryId });
				},
			],
		},
	});

	$stateProvider.state('user-country', {
		/* abstract state for DTO UserCountryListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/country',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'Country',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserCountryListDto */
		/* to access: ui-ref="user-country.list" */
		/* url: http://<hostname>/user/country/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/country/country-list-user.html',
				controller: 'UserCountryListDtoController',
			},
		},
	};

	$stateProvider.state('user-country.list', dtoListState);
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CountryTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CountryFactory,
		FindAllCountriesByQueryParamsFactory,
		NoPagingCountryFactory
	) {
		$scope.countryList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCountry)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCountry);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCountry = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newCountry', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(country) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editCountry', { countryId: country.id, mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getCountryList = function() {
			FindAllCountriesByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.countryList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCountryList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CountryController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CountryFactory,
		FindAllCountriesByQueryParamsFactory,
		NoPagingCountryFactory
	) {
		$scope.countryList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCountry)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCountry);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCountry = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('country.list.new');
		};

		$scope.goToEditState = function(country) {
			// this overview is NOT mapped, it is the main overview
			$state.go('country.list.edit', { countryId: country.id });
		};

		$scope.getCountryList = function() {
			FindAllCountriesByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.countryList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCountryList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

'use strict';

angular.module('emsApp').factory('ConfirmationEmailManager', function ($uibModal, AlertService, BookingConfirmationEmailSender, SubscriptionConfirmationEmailSender) {
  var instance = {};

  instance.confirmationStatuses = {
    NOT_SENT: 'Not sent',
    SENT: 'Sent',
    CONFIRMED: 'Confirmed',
    REJECTED: 'Rejected',
		ERROR: 'Error',
		QUEUED: 'Queued',
		INVALID: 'Invalid'
  };

  instance.confirmationEmailDialog = function (bookingId, optionalSubscriptionId, successCallback) {
    $uibModal
      .open({
					templateUrl: 'app/entities/confirmation_email/confirmation-email-dialog.html',
        controller: 'ConfirmationEmailDialogController',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          translatePartialLoader: [
            '$translate',
            '$translatePartialLoader',
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('emails');
              $translate.refresh();
            },
          ],
        },
      })
      .result.then(function (result) {
				var requestObj;
				if (optionalSubscriptionId) {
					requestObj = SubscriptionConfirmationEmailSender.post({
						subscriptionId: optionalSubscriptionId ? optionalSubscriptionId : null,
						emailTemplateId: result.emailTemplateId,
						emailLabels: result.emailLabels,
						sendToTestAddress: result.sendToTestAddress,
					});
				} else {
					requestObj = BookingConfirmationEmailSender.post({
						bookingId: bookingId,
						emailTemplateId: result.emailTemplateId,
						emailLabels: result.emailLabels,
						sendToTestAddress: result.sendToTestAddress,
					})
				}
				requestObj
        .$promise.then(function () {
					AlertService.add({
						type: 'success',
						msg: 'Email was sent',
						timeout: 5000,
					});
					if (successCallback) {
						successCallback();
					}
      	})
        .catch(function (error) {
					var failureMessageHeader = (typeof error.headers === 'function') ? error.headers('Failure') : '';
					var failureMessageData = error.data.message;
					var failureMessageDefault = 'failure';
					var messageForUser = failureMessageHeader || failureMessageData || failureMessageDefault;
          AlertService.add({
            type: 'danger',
            msg: 'Email was not sent. Server responded: ' + messageForUser,
            timeout: 5000,
          });
        });
			});
  };

  return instance;
});

'use strict';

angular
  .module('emsApp')
  .controller('ConfirmationEmailDialogController', function (
    $scope,
    $rootScope,
    $uibModalInstance,
    ProfileService,
    ConfirmationEmailTemplateList
  ) {
    $scope.isProduction = false;
    $scope.waitingForData = true;
    $scope.waitingForEnvironment = true;

    $scope.selectedEmailTemplate = null;
    $scope.sendToTestAddress = true;

    $scope.emailTemplateListOptions = [];

    ConfirmationEmailTemplateList.get()
      .$promise.then(function (response) {
        $scope.emailTemplateListOptions = response;
      })
      .finally(function () {
        $scope.waitingForData = false;
      });

    ProfileService.getProfileInfo()
      .then(function (response) {
        $scope.isProduction = response.inProduction;
        if (response.inProduction) {
          $scope.sendToTestAddress = false;
        }
      })
      .finally(function () {
        $scope.waitingForEnvironment = false;
      });

    $scope.formShouldBeEnabled = function () {
      return !$scope.waitingForData && !$scope.waitingForEnvironment && !$scope.form.$invalid;
    };

    $scope.save = function () {
			var slug = $scope.selectedEmailTemplate.slug;
			var emailLabels = $scope.emailTemplateListOptions.filter(function (option) {
				return option.slug === slug;
			})[0].labels;
      $uibModalInstance.close({
        emailTemplateId: $scope.selectedEmailTemplate.slug,
				emailLabels: emailLabels,
        sendToTestAddress: $scope.sendToTestAddress,
      });
    };

    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };
  });

'use strict';

angular.module('emsApp').factory('ConfirmationEmailTemplateList', function ($resource) {
  return $resource(
    'api/booking/emailtemplatelist',
    {},
    {
      get: {
        method: 'POST',
        isArray: true,
      },
    }
  );
});

angular.module('emsApp').factory('BookingConfirmationEmailSender', function ($resource) {
  return $resource(
    'api/booking/sendconfirmationemail',
    {},
    {
      post: {
        method: 'POST',
				cache: true
      },
    }
  );
});



angular.module('emsApp').factory('SubscriptionConfirmationEmailSender', function ($resource) {
  return $resource(
    'api/subscription/sendconfirmationemail',
    {},
    {
      post: {
        method: 'POST',
				cache: true
      },
    }
  );
});



/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('CompanyTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		CompanyTypeFactory,
		AlertService,
		NoPagingCompanyTypeFactory
	) {
		$scope.companyType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.companyType) && $rootScope.isDefinedAndNotNull($scope.companyType.id);
		};

		$scope.submitButtonIsActive = true;

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:companyTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving CompanyType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.companyType.id != null) {
				CompanyTypeFactory.update($scope.companyType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				CompanyTypeFactory.save($scope.companyType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('CompanyTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.companyType = entity;
	$scope.objectName = 'CompanyType';
	$scope.companyTypeId = $stateParams.companyTypeId;

	if (angular.isUndefined($rootScope.companyTypeActiveTab)) {
		//set the default here
		$rootScope.companyTypeActiveTab = 0;
	}

	$scope.goToEditState = function(companyType) {
		$state.go('companytype.detail.edit({companyTypeId:companyType.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:companyTypeUpdate', function(event, result) {
		$scope.companyType = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'CompanyType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('companytype'); // main translation loaded for companytype

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/companytype/companytype-dialog.html';

		return {
			/* new state for entity companyType */
			/* to access: ui-ref="companytype.list.new" */
			/* url: hostname/companytype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CompanyTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CompanyTypeFactory',
									'NewCompanyTypeFactory',
									function(CompanyTypeFactory, NewCompanyTypeFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return CompanyTypeFactory.get({ id: $stateParams.companyTypeId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewCompanyTypeFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for companyType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for companyType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('companytype', {
		/* abstract state for entity companyType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/companytype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'CompanyTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('companytype.list', {
		/* list state for entity companyType */
		/* to access: ui-ref="companytype.list" */
		/* url: hostname/companytype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/companytype/companytypes.html',
				controller: 'CompanyTypeController',
			},
		},
	});

	$stateProvider.state('companytype.detail', {
		/* detail state for entity companyType */
		/* to access: ui-sref="companytype.detail" */
		/* url: hostname/companytype/detail/:companyTypeId */
		url: '/detail/:companyTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/companytype/companytype-detail.html',
				controller: 'CompanyTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CompanyTypeFactory',
				function($stateParams, CompanyTypeFactory) {
					return CompanyTypeFactory.get({ id: $stateParams.companyTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/companytype/list/new */
	$stateProvider.state('companytype.list.new', getNewState());
	/* url: http://<hostname>/companytype/list/:companyTypeId/edit */
	$stateProvider.state('companytype.list.edit', getEditState('/:companyTypeId/edit'));
	/* url: http://<hostname>/companytype/detail/:companyTypeId/edit */
	$stateProvider.state('companytype.detail.edit', getEditState('/edit'));

	$stateProvider.state('relation.list.newCompanyType', getNewState('/companytype/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CompanyTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CompanyTypeFactory,
		FindAllCompanyTypesByQueryParamsNonPageableFactory,
		NoPagingCompanyTypeFactory
	) {
		$scope.companyTypeList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newCompanyType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(companyType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editCompanyType', {
				companyTypeId: companyType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.CompanyTypeSearchTab = angular.copy($scope.CompanyTypeSearchTab);

			FindAllCompanyTypesByQueryParamsNonPageableFactory.query(
				{
					name: $scope.CompanyTypeSearchTab.name,
					description: $scope.CompanyTypeSearchTab.description,

					sort: [$scope.CompanyTypeSearchTab.predicate + ',' + ($scope.CompanyTypeSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.companyTypeList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isCompanyTypeSearchTabDirty = function() {
			return !angular.equals($scope.CompanyTypeSearchTab, $scope.originalCompanyTypeSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.CompanyTypeSearchTab = {};
			$rootScope.CompanyTypeSearchTab.predicate = 'id';
			$rootScope.CompanyTypeSearchTab.ascending = false;

			$scope.CompanyTypeSearchTab = angular.copy($rootScope.CompanyTypeSearchTab);

			$scope.originalCompanyTypeSearchTab = angular.copy($scope.CompanyTypeSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.CompanyTypeSearchTab) || $rootScope.CompanyTypeSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.CompanyTypeSearchTab = angular.copy($rootScope.CompanyTypeSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCompanyTypeId = id;
			$('#deleteCompanyTypeConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CompanyTypeFactory.delete(
				{ id: $scope.selectedCompanyTypeId },
				function() {
					$scope.search();
					$('#deleteCompanyTypeConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteCompanyTypeConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.CompanyTypeSearchTab.predicate === itemName) {
				if ($scope.CompanyTypeSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CompanyTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CompanyTypeFactory,
		FindAllCompanyTypesByQueryParamsNonPageableFactory,
		NoPagingCompanyTypeFactory
	) {
		$scope.companyTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('companytype.list.new');
		};

		$scope.goToEditState = function(companyType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('companytype.list.edit', { companyTypeId: companyType.id });
		};

		$scope.getCompanyTypeList = function() {
			FindAllCompanyTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.companyTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCompanyTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCompanyTypeId = id;
			$('#deleteCompanyTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CompanyTypeFactory.delete(
				{ id: $scope.selectedCompanyTypeId },
				function() {
					$scope.loadAll();
					$('#deleteCompanyTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteCompanyTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('CarRentalTypeTemplateEventArticleDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		CarRentalTypeTemplateEventArticleFactory,
		AlertService,
		NoPagingCarRentalTypeTemplateEventArticleFactory,
		NoPagingCarRentalTypeFactory,
		NoPagingTemplateEventFactory,
		NoPagingArticleFactory,
		CarRentalTypeTemplateEventArticleFindArticleFilteredByArticleForRentalFactory
	) {
		$scope.carRentalTypeTemplateEventArticle = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return (
				$rootScope.isDefinedAndNotNull($scope.carRentalTypeTemplateEventArticle) &&
				$rootScope.isDefinedAndNotNull($scope.carRentalTypeTemplateEventArticle.id)
			);
		};

		$scope.createArticleForRental = function() {
			var referredBy = {
				refName: 'articleForRental',
				data: $scope.carRentalTypeTemplateEventArticle,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new articleForRental will add this new carrentaltypetemplateeventarticle state to the history stack
				$state.go('carrentaltypetemplateeventarticle.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('carRentalTypeTemplateEventArticle.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type CarRentalType and checks if this CarRentalTypeTemplateEventArticle dialog is called in the context of CarRentalType.
		 * If this is the case, we detect the parent entity CarRentalTypeTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryCarRentalType = function() {
			return NoPagingCarRentalTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'carRentalType');
			});
		};
		$scope.carRentalTypeList = $scope.queryCarRentalType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type TemplateEvent and checks if this CarRentalTypeTemplateEventArticle dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity CarRentalTypeTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				$scope.findItemByParent(result, 'templateEvent');
			});
		};
		$scope.templateEventList = $scope.queryTemplateEvent();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type ArticleForRental and checks if this CarRentalTypeTemplateEventArticle dialog is called in the context of ArticleForRental.
		 * If this is the case, we detect the parent entity CarRentalTypeTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticleForRental = function() {
			return CarRentalTypeTemplateEventArticleFindArticleFilteredByArticleForRentalFactory.query(function(result) {
				$scope.findItemByParent(result, 'articleForRental');
			});
		};
		$scope.articleForRentalList = $scope.queryArticleForRental();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:carRentalTypeTemplateEventArticleUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving CarRentalTypeTemplateEventArticle failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.carRentalTypeTemplateEventArticle.id != null) {
				CarRentalTypeTemplateEventArticleFactory.update(
					$scope.carRentalTypeTemplateEventArticle,
					onSaveFinishedCallback,
					saveOrUpdateErrorCallback
				);
			} else {
				CarRentalTypeTemplateEventArticleFactory.save(
					$scope.carRentalTypeTemplateEventArticle,
					onSaveFinishedCallback,
					saveOrUpdateErrorCallback
				);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('CarRentalTypeTemplateEventArticleDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
		$scope.carRentalTypeTemplateEventArticle = entity;
		$scope.objectName = 'CarRentalTypeTemplateEventArticle';
		$scope.carRentalTypeTemplateEventArticleId = $stateParams.carRentalTypeTemplateEventArticleId;

		if (angular.isUndefined($rootScope.carRentalTypeTemplateEventArticleActiveTab)) {
			//set the default here
			$rootScope.carRentalTypeTemplateEventArticleActiveTab = 0;
		}

		$scope.goToEditState = function(carRentalTypeTemplateEventArticle) {
			$state.go(
				'carrentaltypetemplateeventarticle.detail.edit({carRentalTypeTemplateEventArticleId:carRentalTypeTemplateEventArticle.id, mappedBy:mappedBy, mappedById:mappedById})'
			);
		};

		// by broadcasting this event from an edit dialog the model is refreshed
		$rootScope.$on('emsApp:carRentalTypeTemplateEventArticleUpdate', function(event, result) {
			$scope.carRentalTypeTemplateEventArticle = result;
		});
	});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'CarRentalTypeTemplateEventArticle'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('carrentaltypetemplateeventarticle'); // main translation loaded for carrentaltypetemplateeventarticle
		$translatePartialLoader.addPart('carrentaltype'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticle-dialog.html';

		return {
			/* new state for entity carRentalTypeTemplateEventArticle */
			/* to access: ui-ref="carrentaltypetemplateeventarticle.list.new" */
			/* url: hostname/carrentaltypetemplateeventarticle/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CarRentalTypeTemplateEventArticleDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CarRentalTypeTemplateEventArticleFactory',
									'NewCarRentalTypeTemplateEventArticleFactory',
									function(CarRentalTypeTemplateEventArticleFactory, NewCarRentalTypeTemplateEventArticleFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new CarRentalTypeTemplateEventArticle
										// - resuming the creation of a new new CarRentalTypeTemplateEventArticle AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return CarRentalTypeTemplateEventArticleFactory.get({
													id: $stateParams.carRentalTypeTemplateEventArticleId,
												}).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewCarRentalTypeTemplateEventArticleFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for carRentalTypeTemplateEventArticle new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for carRentalTypeTemplateEventArticle edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('carrentaltypetemplateeventarticle', {
		/* abstract state for entity carRentalTypeTemplateEventArticle */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/carrentaltypetemplateeventarticle',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'CarRentalTypeTemplateEventArticles',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('carrentaltypetemplateeventarticle.list', {
		/* list state for entity carRentalTypeTemplateEventArticle */
		/* to access: ui-ref="carrentaltypetemplateeventarticle.list" */
		/* url: hostname/carrentaltypetemplateeventarticle/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticles.html',
				controller: 'CarRentalTypeTemplateEventArticleController',
			},
		},
	});

	$stateProvider.state('carrentaltypetemplateeventarticle.detail', {
		/* detail state for entity carRentalTypeTemplateEventArticle */
		/* to access: ui-sref="carrentaltypetemplateeventarticle.detail" */
		/* url: hostname/carrentaltypetemplateeventarticle/detail/:carRentalTypeTemplateEventArticleId */
		url: '/detail/:carRentalTypeTemplateEventArticleId',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticle-detail.html',
				controller: 'CarRentalTypeTemplateEventArticleDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CarRentalTypeTemplateEventArticleFactory',
				function($stateParams, CarRentalTypeTemplateEventArticleFactory) {
					return CarRentalTypeTemplateEventArticleFactory.get({ id: $stateParams.carRentalTypeTemplateEventArticleId });
				},
			],
		},
	});

	/* url: http://<hostname>/carrentaltypetemplateeventarticle/list/new */
	$stateProvider.state('carrentaltypetemplateeventarticle.list.new', getNewState());
	/* url: http://<hostname>/carrentaltypetemplateeventarticle/list/:carRentalTypeTemplateEventArticleId/edit */
	$stateProvider.state('carrentaltypetemplateeventarticle.list.edit', getEditState('/:carRentalTypeTemplateEventArticleId/edit'));
	/* url: http://<hostname>/carrentaltypetemplateeventarticle/detail/:carRentalTypeTemplateEventArticleId/edit */
	$stateProvider.state('carrentaltypetemplateeventarticle.detail.edit', getEditState('/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarRentalTypeTemplateEventArticleTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarRentalTypeTemplateEventArticleFactory,
		FindAllCarRentalTypeTemplateEventArticlesByQueryParamsFactory,
		NoPagingCarRentalTypeTemplateEventArticleFactory,
		NoPagingCarRentalTypeFactory,
		NoPagingTemplateEventFactory,
		NoPagingArticleFactory,
		CarRentalTypeTemplateEventArticleFindArticleFilteredByArticleForRentalFactory
	) {
		$scope.carRentalTypeTemplateEventArticleList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCarRentalTypeTemplateEventArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCarRentalTypeTemplateEventArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCarRentalTypeTemplateEventArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newCarRentalTypeTemplateEventArticle', {
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.goToEditState = function(carRentalTypeTemplateEventArticle) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editCarRentalTypeTemplateEventArticle', {
				carRentalTypeTemplateEventArticleId: carRentalTypeTemplateEventArticle.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getCarRentalTypeTemplateEventArticleList = function() {
			FindAllCarRentalTypeTemplateEventArticlesByQueryParamsFactory.query(
				{
					carRentalTypeId: angular.isDefined($scope.carRentalTypeId) ? $scope.carRentalTypeId : null,
					templateEventId: angular.isDefined($scope.templateEventId) ? $scope.templateEventId : null,
					articleForRentalId: angular.isDefined($scope.articleForRentalId) ? $scope.articleForRentalId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carRentalTypeTemplateEventArticleList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCarRentalTypeTemplateEventArticleList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarRentalTypeTemplateEventArticleId = id;
			$('#deleteCarRentalTypeTemplateEventArticleConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarRentalTypeTemplateEventArticleFactory.delete(
				{ id: $scope.selectedCarRentalTypeTemplateEventArticleId },
				function() {
					$scope.loadAll();
					$('#deleteCarRentalTypeTemplateEventArticleConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteCarRentalTypeTemplateEventArticleConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarRentalTypeTemplateEventArticleController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarRentalTypeTemplateEventArticleFactory,
		FindAllCarRentalTypeTemplateEventArticlesByQueryParamsFactory,
		NoPagingCarRentalTypeTemplateEventArticleFactory,
		NoPagingCarRentalTypeFactory,
		NoPagingTemplateEventFactory,
		NoPagingArticleFactory,
		CarRentalTypeTemplateEventArticleFindArticleFilteredByArticleForRentalFactory
	) {
		$scope.carRentalTypeTemplateEventArticleList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCarRentalTypeTemplateEventArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCarRentalTypeTemplateEventArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCarRentalTypeTemplateEventArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltypetemplateeventarticle.list.new');
		};

		$scope.goToEditState = function(carRentalTypeTemplateEventArticle) {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltypetemplateeventarticle.list.edit', {
				carRentalTypeTemplateEventArticleId: carRentalTypeTemplateEventArticle.id,
			});
		};

		$scope.getCarRentalTypeTemplateEventArticleList = function() {
			FindAllCarRentalTypeTemplateEventArticlesByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carRentalTypeTemplateEventArticleList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCarRentalTypeTemplateEventArticleList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarRentalTypeTemplateEventArticleId = id;
			$('#deleteCarRentalTypeTemplateEventArticleConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarRentalTypeTemplateEventArticleFactory.delete(
				{ id: $scope.selectedCarRentalTypeTemplateEventArticleId },
				function() {
					$scope.loadAll();
					$('#deleteCarRentalTypeTemplateEventArticleConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteCarRentalTypeTemplateEventArticleConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('CarRentalTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		CarRentalTypeFactory,
		AlertService,
		NoPagingCarRentalTypeFactory
	) {
		$scope.carRentalType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.carRentalType) && $rootScope.isDefinedAndNotNull($scope.carRentalType.id);
		};

		$scope.submitButtonIsActive = true;

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:carRentalTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving CarRentalType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.carRentalType.id != null) {
				CarRentalTypeFactory.update($scope.carRentalType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				CarRentalTypeFactory.save($scope.carRentalType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('CarRentalTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.carRentalType = entity;
	$scope.objectName = 'CarRentalType';
	$scope.carRentalTypeId = $stateParams.carRentalTypeId;

	if (angular.isUndefined($rootScope.carRentalTypeActiveTab)) {
		//set the default here
		$rootScope.carRentalTypeActiveTab = 0;
	}

	$scope.goToEditState = function(carRentalType) {
		$state.go('carrentaltype.detail.edit({carRentalTypeId:carRentalType.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:carRentalTypeUpdate', function(event, result) {
		$scope.carRentalType = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'CarRentalType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('carrentaltype'); // main translation loaded for carrentaltype
		$translatePartialLoader.addPart('car'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/carrentaltype/carrentaltype-dialog.html';

		return {
			/* new state for entity carRentalType */
			/* to access: ui-ref="carrentaltype.list.new" */
			/* url: hostname/carrentaltype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CarRentalTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CarRentalTypeFactory',
									'NewCarRentalTypeFactory',
									function(CarRentalTypeFactory, NewCarRentalTypeFactory) {
										if (isEditMode) {
											// get the entity by its ID
											return CarRentalTypeFactory.get({ id: $stateParams.carRentalTypeId }).$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										} else {
											// get a new empty entity
											return NewCarRentalTypeFactory.get().$promise.then(
												function(data) {
													return data;
												},
												function(error) {
													return error;
												}
											);
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for carRentalType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for carRentalType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('carrentaltype', {
		/* abstract state for entity carRentalType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/carrentaltype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'CarRentalTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('carrentaltype.list', {
		/* list state for entity carRentalType */
		/* to access: ui-ref="carrentaltype.list" */
		/* url: hostname/carrentaltype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltype/carrentaltypes.html',
				controller: 'CarRentalTypeController',
			},
		},
	});

	$stateProvider.state('carrentaltype.detail', {
		/* detail state for entity carRentalType */
		/* to access: ui-sref="carrentaltype.detail" */
		/* url: hostname/carrentaltype/detail/:carRentalTypeId */
		url: '/detail/:carRentalTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/carrentaltype/carrentaltype-detail.html',
				controller: 'CarRentalTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CarRentalTypeFactory',
				function($stateParams, CarRentalTypeFactory) {
					return CarRentalTypeFactory.get({ id: $stateParams.carRentalTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/carrentaltype/list/new */
	$stateProvider.state('carrentaltype.list.new', getNewState());
	/* url: http://<hostname>/carrentaltype/list/:carRentalTypeId/edit */
	$stateProvider.state('carrentaltype.list.edit', getEditState('/:carRentalTypeId/edit'));
	/* url: http://<hostname>/carrentaltype/detail/:carRentalTypeId/edit */
	$stateProvider.state('carrentaltype.detail.edit', getEditState('/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarRentalTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarRentalTypeFactory,
		FindAllCarRentalTypesByQueryParamsNonPageableFactory,
		NoPagingCarRentalTypeFactory
	) {
		$scope.carRentalTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newCarRentalType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(carRentalType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editCarRentalType', {
				carRentalTypeId: carRentalType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getCarRentalTypeList = function() {
			FindAllCarRentalTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carRentalTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCarRentalTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarRentalTypeId = id;
			$('#deleteCarRentalTypeConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarRentalTypeFactory.delete(
				{ id: $scope.selectedCarRentalTypeId },
				function() {
					$scope.loadAll();
					$('#deleteCarRentalTypeConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteCarRentalTypeConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarRentalTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarRentalTypeFactory,
		FindAllCarRentalTypesByQueryParamsNonPageableFactory,
		NoPagingCarRentalTypeFactory
	) {
		$scope.carRentalTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltype.list.new');
		};

		$scope.goToEditState = function(carRentalType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltype.list.edit', { carRentalTypeId: carRentalType.id });
		};

		$scope.getCarRentalTypeList = function() {
			FindAllCarRentalTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carRentalTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCarRentalTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarRentalTypeId = id;
			$('#deleteCarRentalTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarRentalTypeFactory.delete(
				{ id: $scope.selectedCarRentalTypeId },
				function() {
					$scope.loadAll();
					$('#deleteCarRentalTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteCarRentalTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('CarDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		CarFactory,
		AlertService,
		NoPagingCarFactory,
		AutocompleteCarsByQueryParamsFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingArticleFactory,
		NoPagingCarRentalTypeFactory,
		CarSaveAndCreateFactory,
		CarFindArticleFilteredByArticleForRentalFactory
	) {
		$scope.car = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.car) && $rootScope.isDefinedAndNotNull($scope.car.id);
		};

		$scope.createOwner = function() {
			var referredBy = {
				refName: 'owner',
				data: $scope.car,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new owner will add this new car state to the history stack
				$state.go('car.list.newRelation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('car.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryOwner = function() {
			// If the id of a preselected owner is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'owner');
					}
				});
			}
		};
		$scope.ownerList = $scope.queryOwner();

		// --- start default implementation
		/**
		 * This function queries all entities of type ArticleForRental and checks if this Car dialog is called in the context of ArticleForRental.
		 * If this is the case, we detect the parent entity Car and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticleForRental = function() {
			return CarFindArticleFilteredByArticleForRentalFactory.query(function(result) {
				$scope.findItemByParent(result, 'articleForRental');
			});
		};
		$scope.articleForRentalList = $scope.queryArticleForRental();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type CarRentalType and checks if this Car dialog is called in the context of CarRentalType.
		 * If this is the case, we detect the parent entity Car and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryCarRentalType = function() {
			return NoPagingCarRentalTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'carRentalType');
			});
		};
		$scope.carRentalTypeList = $scope.queryCarRentalType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:carUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Car failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		var onSaveAndNewFinishedCallback = function(result) {
			$scope.$emit('emsApp:carUpdate', result);
			// the result contains a new entity, but with the copied values from the previous
			$scope.car = result;
			$scope.updateDropdownModels();
			$scope.submitButtonIsActive = true;
		};

		$scope.updateDropdownModels = function() {
			$scope.queryOwner();
			$scope.queryArticleForRental();
			$scope.queryCarRentalType();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.car.owner === '') {
				$scope.car.owner = null;
			}

			if ($scope.car.id != null) {
				CarFactory.update($scope.car, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				CarFactory.save($scope.car, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.car.owner === '') {
				$scope.car.owner = null;
			}

			if ($scope.car.id != null) {
				CarSaveAndCreateFactory.updateAndCreate($scope.car, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				CarSaveAndCreateFactory.saveAndCreate($scope.car, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('CarDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.car = entity;
	$scope.objectName = 'Car';
	$scope.carId = $stateParams.carId;

	if (angular.isUndefined($rootScope.carActiveTab)) {
		//set the default here
		$rootScope.carActiveTab = 0;
	}

	$scope.goToEditState = function(car) {
		$state.go('car.detail.edit({carId:car.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:carUpdate', function(event, result) {
		$scope.car = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Car'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('car'); // main translation loaded for car
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('document'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity
		$translatePartialLoader.addPart('carrentaltype'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/car/car-dialog.html';

		return {
			/* new state for entity car */
			/* to access: ui-ref="car.list.new" */
			/* url: hostname/car/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'CarDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'CarFactory',
									'NewCarFactory',
									function(CarFactory, NewCarFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Car
										// - resuming the creation of a new new Car AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return CarFactory.get({ id: $stateParams.carId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewCarFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for car new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for car edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('car', {
		/* abstract state for entity car */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/car',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Cars',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('car.list', {
		/* list state for entity car */
		/* to access: ui-ref="car.list" */
		/* url: hostname/car/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/car/cars.html',
				controller: 'CarController',
			},
		},
	});

	$stateProvider.state('car.detail', {
		/* detail state for entity car */
		/* to access: ui-sref="car.detail" */
		/* url: hostname/car/detail/:carId */
		url: '/detail/:carId',
		views: {
			'content@': {
				templateUrl: 'app/entities/car/car-detail.html',
				controller: 'CarDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'CarFactory',
				function($stateParams, CarFactory) {
					return CarFactory.get({ id: $stateParams.carId });
				},
			],
		},
	});

	/* url: http://<hostname>/car/list/new */
	$stateProvider.state('car.list.new', getNewState());
	/* url: http://<hostname>/car/list/:carId/edit */
	$stateProvider.state('car.list.edit', getEditState('/:carId/edit'));
	/* url: http://<hostname>/car/detail/:carId/edit */
	$stateProvider.state('car.detail.edit', getEditState('/edit'));
	// Relation.car with multiplicity 0..n points to Car
	/* url: http://<hostname>/relation/detail/:relationId/car/new */
	$stateProvider.state('relation.detail.newCar', getNewState('/car/new'));
	/* url: http://<hostname>/relation/detail/:relationId/car/:carId/edit */
	$stateProvider.state('relation.detail.editCar', getEditState('/car/:carId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/car/new */
	$stateProvider.state('user-relation.detail.newCar', getNewState('/car/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/car/:carId/edit */
	$stateProvider.state('user-relation.detail.editCar', getEditState('/car/:carId/edit'));
	// CarRentalType.cars with multiplicity 0..n points to Car
	/* url: http://<hostname>/carrentaltype/detail/:carRentalTypeId/car/new */
	$stateProvider.state('carrentaltype.detail.newCar', getNewState('/car/new'));
	/* url: http://<hostname>/carrentaltype/detail/:carRentalTypeId/car/:carId/edit */
	$stateProvider.state('carrentaltype.detail.editCar', getEditState('/car/:carId/edit'));

	$stateProvider.state('subscription.list.newCar', getNewState('/car/new'));
	$stateProvider.state('document.list.newCar', getNewState('/car/new'));

	$stateProvider.state('event.detail.booking.newCar', getNewState('/car/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarFactory,
		FindAllCarsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingCarFactory,
		NoPagingRelationFactory,
		NoPagingArticleFactory,
		NoPagingCarRentalTypeFactory,
		CarFindArticleFilteredByArticleForRentalFactory
	) {
		$scope.carList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCar)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCar);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCar = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newCar', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(car) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editCar', { carId: car.id, mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getCarList = function() {
			FindAllCarsByQueryParamsFactory.query(
				{
					ownerId: angular.isDefined($scope.ownerId) ? $scope.ownerId : null,
					articleForRentalId: angular.isDefined($scope.articleForRentalId) ? $scope.articleForRentalId : null,
					carRentalTypeId: angular.isDefined($scope.carRentalTypeId) ? $scope.carRentalTypeId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCarList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarId = id;
			$('#deleteCarConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarFactory.delete(
				{ id: $scope.selectedCarId },
				function() {
					$scope.loadAll();
					$('#deleteCarConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteCarConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:carUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarFactory,
		FindAllCarsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingCarFactory,
		NoPagingRelationFactory,
		NoPagingArticleFactory,
		NoPagingCarRentalTypeFactory,
		CarFindArticleFilteredByArticleForRentalFactory
	) {
		$scope.carList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCar)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCar);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCar = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('car.list.new');
		};

		$scope.goToEditState = function(car) {
			// this overview is NOT mapped, it is the main overview
			$state.go('car.list.edit', { carId: car.id });
		};

		var getOwnerId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.CarSearchOverview.owner)) {
				return $scope.CarSearchOverview.owner.id;
			} else {
				return undefined;
			}
		};

		var getArticleForRentalId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.CarSearchOverview.articleForRental)) {
				return $scope.CarSearchOverview.articleForRental.id;
			} else {
				return undefined;
			}
		};

		var getCarRentalTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.CarSearchOverview.carRentalType)) {
				return $scope.CarSearchOverview.carRentalType.id;
			} else {
				return undefined;
			}
		};

		// handle attribute readyForUse of javaType Boolean
		// handle attribute rental of javaType Boolean
		// handle attribute service of javaType Boolean

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type ArticleForRental and checks if this Car dialog is called in the context of ArticleForRental.
		 * If this is the case, we detect the parent entity Car and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticleForRental = function() {
			return CarFindArticleFilteredByArticleForRentalFactory.query(function(result) {
				return result;
			});
		};
		$scope.articleForRentalReferenceFilterList = $scope.queryArticleForRental();

		/**
		 * This function queries all entities of type CarRentalType and checks if this Car dialog is called in the context of CarRentalType.
		 * If this is the case, we detect the parent entity Car and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryCarRentalType = function() {
			return NoPagingCarRentalTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.carRentalTypeReferenceFilterList = $scope.queryCarRentalType();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.CarSearchOverview = angular.copy($scope.CarSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCar = angular.copy($scope.pageSize);

			FindAllCarsByQueryParamsFactory.query(
				{
					page: $scope.CarSearchOverview.page - 1,
					size: $scope.pageSize,
					name: $scope.CarSearchOverview.name,
					licensePlate: $scope.CarSearchOverview.licensePlate,
					readyForUse: $scope.CarSearchOverview.readyForUseGroup,
					rental: $scope.CarSearchOverview.rentalGroup,
					service: $scope.CarSearchOverview.serviceGroup,
					ownerId: getOwnerId(),
					articleForRentalId: getArticleForRentalId(),
					carRentalTypeId: getCarRentalTypeId(),

					sort: [$scope.CarSearchOverview.predicate + ',' + ($scope.CarSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isCarSearchOverviewDirty = function() {
			return !angular.equals($scope.CarSearchOverview, $scope.originalCarSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.CarSearchOverview = {};
			$rootScope.CarSearchOverview.page = 1;
			$rootScope.CarSearchOverview.predicate = 'id';
			$rootScope.CarSearchOverview.ascending = false;

			$scope.CarSearchOverview = angular.copy($rootScope.CarSearchOverview);

			$scope.originalCarSearchOverview = angular.copy($scope.CarSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.CarSearchOverview) || $rootScope.CarSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.CarSearchOverview = angular.copy($rootScope.CarSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarId = id;
			$('#deleteCarConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarFactory.delete(
				{ id: $scope.selectedCarId },
				function() {
					$scope.search();
					$('#deleteCarConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteCarConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:carUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.CarSearchOverview.predicate === itemName) {
				if ($scope.CarSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

'use strict';

angular.module('emsApp').controller(
		'BookingDialogController',
		function($scope, $rootScope, $timeout, $state, $stateParams, $uibModalInstance, $parse, entity, BookingFactory, AlertService,
				NoPagingBookingFactory, AutocompleteBookingsByQueryParamsFactory, NoPagingEventFactory,
				AutocompleteEventsByQueryParamsFactory, NoPagingRelationFactory, AutocompleteRelationsByQueryParamsFactory,
				NoPagingBookingStatusFactory) {

			$scope.booking = entity;

			if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
				$scope.mappedBy = $stateParams.mappedBy;
			}

			/**
			 * Checks if the page is in create or edit state based on the scope model and it's id value
			 */
			$scope.isEdit = function() {
				return ($rootScope.isDefinedAndNotNull($scope.booking) && $rootScope.isDefinedAndNotNull($scope.booking.id));
			};

			$scope.createEvent = function() {
				var referredBy = {
					refName : 'event',
					data : $scope.booking
				};

				// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
				$uibModalInstance.dismiss('createNew');

				$timeout(function() {
					// we add a little timeout to prevent the modal dismiss not to be ready
					// navigating to new event will add this new booking state to the history stack
					$state.go('booking.list.newEvent', {
						referredBy : referredBy
					}, {
						reload : false
					});
				}, 100);
			};
			$scope.createClient = function() {
				var referredBy = {
					refName : 'client',
					data : $scope.booking
				};

				// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
				$uibModalInstance.dismiss('createNew');

				$timeout(function() {
					// we add a little timeout to prevent the modal dismiss not to be ready
					// navigating to new client will add this new booking state to the history stack
					$state.go('booking.list.newRelation', {
						referredBy : referredBy
					}, {
						reload : false
					});
				}, 100);
			};
			$scope.createStatus = function() {
				var referredBy = {
					refName : 'status',
					data : $scope.booking
				};

				// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
				$uibModalInstance.dismiss('createNew');

				$timeout(function() {
					// we add a little timeout to prevent the modal dismiss not to be ready
					// navigating to new status will add this new booking state to the history stack
					$state.go('booking.list.newBookingStatus', {
						referredBy : referredBy
					}, {
						reload : false
					});
				}, 100);
			};

			$scope.submitButtonIsActive = true;

			$scope.autocompleteEvents = function(val) {
				var params = {
					'eventTypeAheadSearchString' : val

				};

				return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
					return results;
				});
			};
			$scope.autocompleteRelations = function(val) {
				var params = {
					'relationTypeAheadSearchString' : val

				};

				return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
					return results;
				});
			};

			/**
			 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
			 */
			$scope.findItemByParent = function(items, property) {
				//This function preselects and disables the parent reference when called from tab
				if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
					angular.forEach(items, function(value) {
						// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
						if (value.id === _.toNumber($stateParams.mappedById)) {
							var model = $parse("booking." + property);
							model.assign($scope, value);
						}
					});
				}
			};

			/**
			 * This function preselects and disables the parent reference in autocomplete field when called from tab
			 */
			$scope.queryEvent = function() {
				// FIXME this call to retrieve all Events seems unnecessary for autocomplete references!
				return NoPagingEventFactory.query(function(result) {
					$scope.findItemByParent(result, "event");
				});
			};
			$scope.eventList = $scope.queryEvent();

			/**
			 * This function preselects and disables the parent reference in autocomplete field when called from tab
			 */
			$scope.queryClient = function() {
				// FIXME this call to retrieve all Relations seems unnecessary for autocomplete references!
				return NoPagingRelationFactory.query(function(result) {
					$scope.findItemByParent(result, "client");
				});
			};
			$scope.clientList = $scope.queryClient();

			// --- start default implementation
			/**
			 * This function queries all entities of type Status and checks if this Booking dialog is called in the context of Status.
			 * If this is the case, we detect the parent entity Booking and select it as model value so it is shown in the dropdown select.
			 */
			$scope.queryStatus = function() {
				return NoPagingBookingStatusFactory.query(function(result) {
					$scope.findItemByParent(result, "status");
				});
			};
			$scope.statusList = $scope.queryStatus();
			// --- end default implementation

			var onSaveFinishedCallback = function(result) {
				$scope.$emit('emsApp:bookingUpdate', result);
				$uibModalInstance.close(result);
				$scope.submitButtonIsActive = true;
			};

			var saveOrUpdateErrorCallback = function(error) {
				console.error("Saving Booking failed", error);
				AlertService.error("error." + error.data.message, error.data.params);
				$scope.submitButtonIsActive = true;
			};

			$scope.save = function() {
				$scope.submitButtonIsActive = false;

				//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
				if ($scope.booking.event === "") {
					$scope.booking.event = null;
				}
				//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
				if ($scope.booking.client === "") {
					$scope.booking.client = null;
				}

				if ($scope.booking.id != null) {
					BookingFactory.update($scope.booking, onSaveFinishedCallback, saveOrUpdateErrorCallback);
				} else {
					BookingFactory.save($scope.booking, onSaveFinishedCallback, saveOrUpdateErrorCallback);
				}
			};

			// called from cancel button in dialog
			$scope.clear = function() {
				// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
				$uibModalInstance.dismiss('cancel');
			};

		});

// CodeComposer:preserve:file => Don't override manual changes
/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('BookingDetailController', function(
		$scope,
		$rootScope,
		$stateParams,
		$state,
		entity,
		$translate,
		dialogs,
		BookingSnelstartFactory,
		BookingFactory
	) {
		$scope.booking = entity;
		$scope.objectName = 'Booking';
		$scope.bookingId = $stateParams.bookingId;

		if (angular.isUndefined($rootScope.bookingActiveTab)) {
			//set the default here
			$rootScope.bookingActiveTab = 0;
		}

		$scope.goToEditState = function(booking) {
			$state.go('booking.detail.edit({bookingId:booking.id, mappedBy:mappedBy, mappedById:mappedById})');
		};

		var unsubscribeRefreshTriggerHandler = $rootScope.$on('emsApp:bookingDetailsRefreshTrigger', function () {
			BookingFactory.get({ id: $stateParams.bookingId }).$promise.then(function (result) {
				$scope.booking = result;
			});
		});

		// [dmitro] Without this callbacks will keep piling causing more and more resources wasted
		$scope.$on('$destroy', function () {
			if (angular.isFunction(unsubscribeRefreshTriggerHandler)) {
				unsubscribeRefreshTriggerHandler();
			}
		});

		// by broadcasting this event from an edit dialog the model is refreshed
		$rootScope.$on('emsApp:bookingUpdate', function(event, result) {
			$scope.booking = result;
		});

		// additional actions added by custom/jhipster/controller/detail/additional-actions.ftl

		// billBooking copied from booking-subscription-details.controller.js
		$scope.billBooking = function(booking) {
			$('#billButtonIcon').addClass('glyphicon-euro-animate');

			var preSnelstartId = booking.snelstartVerkoopOrderId;

			BookingSnelstartFactory.billBooking(
				booking,
				function(result) {
					$scope.booking = result;

					var dlgMsg;
					if (preSnelstartId !== result.snelstartVerkoopOrderId) {
						dlgMsg = $translate.instant('global.messages.info.bookingBilledSuccesfully', { status: result.status });
					} else {
						dlgMsg = $translate.instant('global.messages.info.bookingAcceptedSuccesfully', { status: result.status });
					}
					dialogs.notify($translate.instant('booking.dialog.bill.title.success'), dlgMsg).result.then(function() {
						$('#billButtonIcon').removeClass('glyphicon-euro-animate');
					});
				},
				function(error) {
					console.error(error);
					var dlgMsg = $translate.instant(error.data.message, error.data.params);
					dialogs.error($translate.instant('booking.dialog.bill.title.failed'), dlgMsg).result.then(function() {
						$('#billButtonIcon').removeClass('glyphicon-euro-animate');
					});
				}
			);
		};
		// end additional actions
	});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Booking'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('booking'); // main translation loaded for booking
		$translatePartialLoader.addPart('bookingstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('confirmationemailstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('orderline'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to one or many to one reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/booking/booking-dialog.html';

		return {
			/* new state for entity booking */
			/* to access: ui-ref="booking.list.new" */
			/* url: hostname/booking/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'BookingDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'BookingFactory',
									'NewBookingFactory',
									function(BookingFactory, NewBookingFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Booking
										// - resuming the creation of a new new Booking AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return BookingFactory.get({ id: $stateParams.bookingId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewBookingFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for booking new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for booking edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('booking', {
		/* abstract state for entity booking */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/booking',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Bookings',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('booking.list', {
		/* list state for entity booking */
		/* to access: ui-ref="booking.list" */
		/* url: hostname/booking/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/booking/bookings.html',
				controller: 'BookingController',
			},
		},
	});

	$stateProvider.state('booking.detail', {
		/* detail state for entity booking */
		/* to access: ui-sref="booking.detail" */
		/* url: hostname/booking/detail/:bookingId */
		url: '/detail/:bookingId',
		views: {
			'content@': {
				templateUrl: 'app/entities/booking/booking-detail.html',
				controller: 'BookingDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'BookingFactory',
				function($stateParams, BookingFactory) {
					return BookingFactory.get({ id: $stateParams.bookingId });
				},
			],
		},
	});

	/* url: http://<hostname>/booking/list/new */
	$stateProvider.state('booking.list.new', getNewState());
	/* url: http://<hostname>/booking/list/:bookingId/edit */
	$stateProvider.state('booking.list.edit', getEditState('/:bookingId/edit'));
	/* url: http://<hostname>/booking/detail/:bookingId/edit */
	$stateProvider.state('booking.detail.edit', getEditState('/edit'));
	// Relation.booking with multiplicity 0..n points to Booking
	/* url: http://<hostname>/relation/detail/:relationId/booking/new */
	$stateProvider.state('relation.detail.newBooking', getNewState('/booking/new'));
	/* url: http://<hostname>/relation/detail/:relationId/booking/:bookingId/edit */
	$stateProvider.state('relation.detail.editBooking', getEditState('/booking/:bookingId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/booking/new */
	$stateProvider.state('user-relation.detail.newBooking', getNewState('/booking/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/booking/:bookingId/edit */
	$stateProvider.state('user-relation.detail.editBooking', getEditState('/booking/:bookingId/edit'));
	// Event.booking with multiplicity 0..n points to Booking
	/* url: http://<hostname>/event/detail/:eventId/booking/new */
	$stateProvider.state('event.detail.newBooking', getNewState('/booking/new'));
	/* url: http://<hostname>/event/detail/:eventId/booking/:bookingId/edit */
	$stateProvider.state('event.detail.editBooking', getEditState('/booking/:bookingId/edit'));

	$stateProvider.state('subscription.list.newBooking', getNewState('/booking/new'));
	$stateProvider.state('orderline.list.newBooking', getNewState('/booking/new'));

	$stateProvider.state('event.detail.subscriptions.newBooking', getNewState('/booking/new'));
	$stateProvider.state('event.detail.subscriptions.editBooking', getEditState('/booking/:bookingId/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('BookingTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		BookingFactory,
		FindAllBookingsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		$translate,
		dialogs,
		EventSnelstartFactory,
		NoPagingBookingFactory,
		NoPagingEventFactory,
		NoPagingRelationFactory,
		NoPagingBookingStatusFactory,
		NoPagingConfirmationEmailStatusFactory,
		ConfirmationEmailManager
	) {
		$scope.confirmationStatuses = ConfirmationEmailManager.confirmationStatuses;
		$scope.bookingList = [];
		$scope.showSearchForm = true;
		// additional field defined in custom/jhipster/controller/overview/additional-fields.ftl
		$scope.selectedBookingList = [];

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeBooking)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeBooking);
		} else {
			$scope.pageSize = 20;
			// Custom hook for setting page size is implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			if ($scope.mappedBy !== 'event') {
				$rootScope.pageSizeBooking = angular.copy($scope.pageSize);
			}
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newBooking', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(booking) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editBooking', { bookingId: booking.id, mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.eventId)) {
				return $scope.eventId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.BookingSearchTab.event)) {
					return $scope.BookingSearchTab.event.id;
				} else {
					return undefined;
				}
			}
		};

		var getClientId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.clientId)) {
				return $scope.clientId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.BookingSearchTab.client)) {
					return $scope.BookingSearchTab.client.id;
				} else {
					return undefined;
				}
			}
		};

		// handle attribute bookingDate of javaType java.time.LocalDate
		$scope.processBookingDate = function() {
			var bookingDateFromDefined = $rootScope.isDefinedAndNotNull($scope.BookingSearchTab.bookingDateFrom);
			var bookingDateToDefined = $rootScope.isDefinedAndNotNull($scope.BookingSearchTab.bookingDateTo);

			if (bookingDateFromDefined) {
				$scope.BookingSearchTab.bookingDateFromString = $rootScope.convertDateWithoutZone($scope.BookingSearchTab.bookingDateFrom);
			} else {
				$scope.BookingSearchTab.bookingDateFromString = undefined;
			}

			if (bookingDateToDefined) {
				$scope.BookingSearchTab.bookingDateToString = $rootScope.convertDateWithoutZone($scope.BookingSearchTab.bookingDateTo);
			} else {
				$scope.BookingSearchTab.bookingDateToString = undefined;
			}
		};

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		NoPagingBookingStatusFactory.query(function(result) {
			$scope.bookingStatusList = result;
		});

		NoPagingConfirmationEmailStatusFactory.query(function(result) {
			$scope.confirmationEmailStatusList = result;
		});
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processBookingDate();

			$rootScope.BookingSearchTab = angular.copy($scope.BookingSearchTab);

			// Custom hook for setting page size is implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			if ($scope.mappedBy !== 'event') {
				$rootScope.pageSizeBooking = angular.copy($scope.pageSize);
			}

			FindAllBookingsByQueryParamsFactory.query(
				{
					page: $scope.BookingSearchTab.page - 1,
					size: $scope.pageSize,
					bookingDateFrom: $scope.BookingSearchTab.bookingDateFromString,
					bookingDateTo: $scope.BookingSearchTab.bookingDateToString,
					eventId: getEventId(),
					clientId: getClientId(),
					status: $scope.BookingSearchTab.status,
					confirmationEmailStatus: $scope.BookingSearchTab.confirmationEmailStatus,

					sort: [$scope.BookingSearchTab.predicate + ',' + ($scope.BookingSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.bookingList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isBookingSearchTabDirty = function() {
			return !angular.equals($scope.BookingSearchTab, $scope.originalBookingSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.BookingSearchTab = {};
			$rootScope.BookingSearchTab.page = 1;
			$rootScope.BookingSearchTab.predicate = 'id';
			$rootScope.BookingSearchTab.ascending = false;

			$scope.BookingSearchTab = angular.copy($rootScope.BookingSearchTab);

			$scope.originalBookingSearchTab = angular.copy($scope.BookingSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.BookingSearchTab) || $rootScope.BookingSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.BookingSearchTab = angular.copy($rootScope.BookingSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedBookingId = id;
			$('#deleteBookingConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			BookingFactory.delete(
				{ id: $scope.selectedBookingId },
				function() {
					$scope.search();
					$('#deleteBookingConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteBookingConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.deselectAll = function() {
			angular.forEach($scope.bookingList, function(value, key) {
				// update the list with selected items
				value.isSelected = false;
				$scope.selectionChanged(value);
			});
			$scope.selectedBookingList = [];
		};

		$scope.selectionChanged = function(item) {
			$scope.$broadcast('childClick', item);
			$scope.updateSelection();
		};

		$scope.toggleSelection = function() {
			$scope.updateSelection();
		};

		$scope.updateSelection = function() {
			// clean selection (if any)
			$scope.selectedBookingList = [];

			angular.forEach($scope.bookingList, function(value, key) {
				// update the list with selected items
				if (value.isSelected) {
					$scope.selectedBookingList.push(value);
				}
			});
		};

		// additional actions added by custom/jhipster/controller/overview/additional-actions.ftl
		$scope.billEventBookings = function() {
			// get event from first booking
			console.log('number of selected bookings: ' + $scope.selectedBookingList.length);
			if ($scope.selectedBookingList.length > 0) {
				var event = $scope.selectedBookingList[0].event;
				var body = {
					eventId: event.id,
					bookingIdList: _.map($scope.selectedBookingList, 'id'),
				};
				EventSnelstartFactory.billEvent(
					body,
					function(result) {
						var dlgTitle = $translate.instant('event.detail.bill.title', {
							costCenter: event.costCenter,
						});
						var dlgMsg =
							'<div class="alert alert-info" role="alert">' +
							$translate.instant('event.detail.bill.ignore', {
								numberOfBookings: result.countIgnoredBookings,
							}) +
							'</div>';
						dlgMsg +=
							'<div class="alert alert-success" role="alert">' +
							$translate.instant('event.detail.bill.success', {
								numberOfBookings: result.countValidResults,
							}) +
							'</div>';
						if (result.hasErrors) {
							dlgMsg +=
								'<div class="alert alert-danger" role="alert">' +
								$translate.instant('event.detail.bill.warning', {
									numberOfBookings: result.countInvalidResults,
								}) +
								'</div>';
							angular.forEach(result.invalidBookingResults, function(invalidResult) {
								dlgMsg +=
									'<div class="alert alert-warning" role="alert">' +
									$translate.instant(invalidResult.errorKey) +
									' (' +
									invalidResult.bookingDisplayValue +
									')</div>';
							});
						}

						dialogs.notify(dlgTitle, dlgMsg).result.then(function() {
							$scope.loadPage();
						});
					},
					function(error) {
						console.error('A problem occurred when billing event ' + event.id, error);
						AlertService.error('event.detail.bill.error', {
							error: error,
						});
						$scope.loadPage();
					}
				);
			}
		};
		// EMS-1456 set pagesize to 500 if the tab is shown on the event page
		if ($scope.mappedBy === 'event') {
			$scope.pageSize = 500;
		}

		// end additional actions

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.BookingSearchTab.predicate === itemName) {
				if ($scope.BookingSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};

		$scope.confirmationEmailDialog = function(bookingId) {
			ConfirmationEmailManager.confirmationEmailDialog(bookingId, null, function() {
				$scope.search();
			});
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('BookingController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		BookingFactory,
		FindAllBookingsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingBookingFactory,
		NoPagingEventFactory,
		NoPagingRelationFactory,
		NoPagingBookingStatusFactory,
		NoPagingConfirmationEmailStatusFactory,
		ConfirmationEmailManager
	) {
		$scope.confirmationStatuses = ConfirmationEmailManager.confirmationStatuses;
		$scope.bookingList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeBooking)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeBooking);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeBooking = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('booking.list.new');
		};

		$scope.goToEditState = function(booking) {
			// this overview is NOT mapped, it is the main overview
			$state.go('booking.list.edit', { bookingId: booking.id });
		};

		var getEventId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.BookingSearchOverview.event)) {
				return $scope.BookingSearchOverview.event.id;
			} else {
				return undefined;
			}
		};

		var getClientId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.BookingSearchOverview.client)) {
				return $scope.BookingSearchOverview.client.id;
			} else {
				return undefined;
			}
		};

		// handle attribute bookingDate of javaType java.time.LocalDate
		$scope.processBookingDate = function() {
			var bookingDateFromDefined = $rootScope.isDefinedAndNotNull($scope.BookingSearchOverview.bookingDateFrom);
			var bookingDateToDefined = $rootScope.isDefinedAndNotNull($scope.BookingSearchOverview.bookingDateTo);

			if (bookingDateFromDefined) {
				$scope.BookingSearchOverview.bookingDateFromString = $rootScope.convertDateWithoutZone(
					$scope.BookingSearchOverview.bookingDateFrom
				);
			} else {
				$scope.BookingSearchOverview.bookingDateFromString = undefined;
			}

			if (bookingDateToDefined) {
				$scope.BookingSearchOverview.bookingDateToString = $rootScope.convertDateWithoutZone($scope.BookingSearchOverview.bookingDateTo);
			} else {
				$scope.BookingSearchOverview.bookingDateToString = undefined;
			}
		};

		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		NoPagingBookingStatusFactory.query(function(result) {
			$scope.bookingStatusList = result;
		});

		NoPagingConfirmationEmailStatusFactory.query(function(result) {
			$scope.confirmationEmailStatusList = result;
		});
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			// Call the javascript functions to handle search parameters
			$scope.processBookingDate();

			$rootScope.BookingSearchOverview = angular.copy($scope.BookingSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeBooking = angular.copy($scope.pageSize);

			FindAllBookingsByQueryParamsFactory.query(
				{
					page: $scope.BookingSearchOverview.page - 1,
					size: $scope.pageSize,
					bookingDateFrom: $scope.BookingSearchOverview.bookingDateFromString,
					bookingDateTo: $scope.BookingSearchOverview.bookingDateToString,
					eventId: getEventId(),
					clientId: getClientId(),
					status: $scope.BookingSearchOverview.status,
					confirmationEmailStatus: $scope.BookingSearchOverview.confirmationEmailStatus,

					sort: [$scope.BookingSearchOverview.predicate + ',' + ($scope.BookingSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.bookingList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isBookingSearchOverviewDirty = function() {
			return !angular.equals($scope.BookingSearchOverview, $scope.originalBookingSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.BookingSearchOverview = {};
			$rootScope.BookingSearchOverview.page = 1;
			$rootScope.BookingSearchOverview.predicate = 'id';
			$rootScope.BookingSearchOverview.ascending = false;

			$scope.BookingSearchOverview = angular.copy($rootScope.BookingSearchOverview);

			$scope.originalBookingSearchOverview = angular.copy($scope.BookingSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.BookingSearchOverview) || $rootScope.BookingSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.BookingSearchOverview = angular.copy($rootScope.BookingSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedBookingId = id;
			$('#deleteBookingConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			BookingFactory.delete(
				{ id: $scope.selectedBookingId },
				function() {
					$scope.search();
					$('#deleteBookingConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteBookingConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.BookingSearchOverview.predicate === itemName) {
				if ($scope.BookingSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};

		$scope.confirmationEmailDialog = function(bookingId) {
			ConfirmationEmailManager.confirmationEmailDialog(bookingId, null, function() {
				$scope.search();
			});
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('BaseModelDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		BaseModelFactory,
		AlertService,
		NoPagingBaseModelFactory
	) {
		$scope.baseModel = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.baseModel) && $rootScope.isDefinedAndNotNull($scope.baseModel.id);
		};

		/**
		 * Tells caller whether the current shown screen (and state) is in edit mode, hence a dialog is shown
		 */
		$scope.isInEditState = function() {
			// check on stateName: *.edit  or  *.detail.edit
			return $state.current.name.toUpperCase().endsWith('EDIT');
		};

		$scope.submitButtonIsActive = true;

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:baseModelUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving BaseModel failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.baseModel.id != null) {
				BaseModelFactory.update($scope.baseModel, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				BaseModelFactory.save($scope.baseModel, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('BaseModelDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.baseModel = entity;
	$scope.objectName = 'BaseModel';
	$scope.baseModelId = $stateParams.baseModelId;

	if (angular.isUndefined($rootScope.baseModelActiveTab)) {
		//set the default here
		$rootScope.baseModelActiveTab = 0;
	}

	$scope.goToEditState = function(baseModel) {
		$state.go('basemodel.detail.edit({baseModelId:baseModel.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:baseModelUpdate', function(event, result) {
		$scope.baseModel = result;
	});
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('BaseModelTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		BaseModelFactory,
		FindAllBaseModelsByQueryParamsFactory,
		NoPagingBaseModelFactory
	) {
		$scope.baseModelList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeBaseModel)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeBaseModel);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeBaseModel = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newBaseModel', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(baseModel) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editBaseModel', {
				baseModelId: baseModel.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getBaseModelList = function() {
			FindAllBaseModelsByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.baseModelList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getBaseModelList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('BaseModelController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		BaseModelFactory,
		FindAllBaseModelsByQueryParamsFactory,
		NoPagingBaseModelFactory
	) {
		$scope.baseModelList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeBaseModel)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeBaseModel);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeBaseModel = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('basemodel.list.new');
		};

		$scope.goToEditState = function(baseModel) {
			// this overview is NOT mapped, it is the main overview
			$state.go('basemodel.list.edit', { baseModelId: baseModel.id });
		};

		$scope.getBaseModelList = function() {
			FindAllBaseModelsByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.baseModelList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getBaseModelList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('ArticleTypeDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		ArticleTypeFactory,
		AlertService,
		NoPagingArticleTypeFactory,
		NoPagingPredefinedArticleTypeFactory
	) {
		$scope.articleType = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.articleType) && $rootScope.isDefinedAndNotNull($scope.articleType.id);
		};

		$scope.createPredefinedArticleType = function() {
			var referredBy = {
				refName: 'predefinedArticleType',
				data: $scope.articleType,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new predefinedArticleType will add this new articletype state to the history stack
				$state.go('articletype.list.newPredefinedArticleType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('articleType.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type PredefinedArticleType and checks if this ArticleType dialog is called in the context of PredefinedArticleType.
		 * If this is the case, we detect the parent entity ArticleType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryPredefinedArticleType = function() {
			return NoPagingPredefinedArticleTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'predefinedArticleType');
			});
		};
		$scope.predefinedArticleTypeList = $scope.queryPredefinedArticleType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleTypeUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving ArticleType failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.articleType.id != null) {
				ArticleTypeFactory.update($scope.articleType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				ArticleTypeFactory.save($scope.articleType, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('ArticleTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.articleType = entity;
	$scope.objectName = 'ArticleType';
	$scope.articleTypeId = $stateParams.articleTypeId;

	if (angular.isUndefined($rootScope.articleTypeActiveTab)) {
		//set the default here
		$rootScope.articleTypeActiveTab = 0;
	}

	$scope.goToEditState = function(articleType) {
		$state.go('articletype.detail.edit({articleTypeId:articleType.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:articleTypeUpdate', function(event, result) {
		$scope.articleType = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'ArticleType'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('articletype'); // main translation loaded for articletype
		$translatePartialLoader.addPart('predefinedarticletype'); // one to many reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/articletype/articletype-dialog.html';

		return {
			/* new state for entity articleType */
			/* to access: ui-ref="articletype.list.new" */
			/* url: hostname/articletype/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'ArticleTypeDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'ArticleTypeFactory',
									'NewArticleTypeFactory',
									function(ArticleTypeFactory, NewArticleTypeFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new ArticleType
										// - resuming the creation of a new new ArticleType AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return ArticleTypeFactory.get({ id: $stateParams.articleTypeId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewArticleTypeFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for articleType new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for articleType edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('articletype', {
		/* abstract state for entity articleType */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/articletype',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'ArticleTypes',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('articletype.list', {
		/* list state for entity articleType */
		/* to access: ui-ref="articletype.list" */
		/* url: hostname/articletype/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/articletype/articletypes.html',
				controller: 'ArticleTypeController',
			},
		},
	});

	$stateProvider.state('articletype.detail', {
		/* detail state for entity articleType */
		/* to access: ui-sref="articletype.detail" */
		/* url: hostname/articletype/detail/:articleTypeId */
		url: '/detail/:articleTypeId',
		views: {
			'content@': {
				templateUrl: 'app/entities/articletype/articletype-detail.html',
				controller: 'ArticleTypeDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'ArticleTypeFactory',
				function($stateParams, ArticleTypeFactory) {
					return ArticleTypeFactory.get({ id: $stateParams.articleTypeId });
				},
			],
		},
	});

	/* url: http://<hostname>/articletype/list/new */
	$stateProvider.state('articletype.list.new', getNewState());
	/* url: http://<hostname>/articletype/list/:articleTypeId/edit */
	$stateProvider.state('articletype.list.edit', getEditState('/:articleTypeId/edit'));
	/* url: http://<hostname>/articletype/detail/:articleTypeId/edit */
	$stateProvider.state('articletype.detail.edit', getEditState('/edit'));

	$stateProvider.state('article.list.newArticleType', getNewState('/articletype/new'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleTypeFactory,
		FindAllArticleTypesByQueryParamsNonPageableFactory,
		NoPagingArticleTypeFactory,
		NoPagingPredefinedArticleTypeFactory
	) {
		$scope.articleTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newArticleType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(articleType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editArticleType', {
				articleTypeId: articleType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getArticleTypeList = function() {
			FindAllArticleTypesByQueryParamsNonPageableFactory.query(
				{
					predefinedArticleTypeId: angular.isDefined($scope.predefinedArticleTypeId) ? $scope.predefinedArticleTypeId : null,

					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getArticleTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleTypeId = id;
			$('#deleteArticleTypeConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleTypeFactory.delete(
				{ id: $scope.selectedArticleTypeId },
				function() {
					$scope.loadAll();
					$('#deleteArticleTypeConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteArticleTypeConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleTypeFactory,
		FindAllArticleTypesByQueryParamsNonPageableFactory,
		NoPagingArticleTypeFactory,
		NoPagingPredefinedArticleTypeFactory
	) {
		$scope.articleTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('articletype.list.new');
		};

		$scope.goToEditState = function(articleType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('articletype.list.edit', { articleTypeId: articleType.id });
		};

		$scope.getArticleTypeList = function() {
			FindAllArticleTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getArticleTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleTypeId = id;
			$('#deleteArticleTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleTypeFactory.delete(
				{ id: $scope.selectedArticleTypeId },
				function() {
					$scope.loadAll();
					$('#deleteArticleTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteArticleTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('ArticleRelationPriceDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		ArticleRelationPriceFactory,
		AlertService,
		NoPagingArticleRelationPriceFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingArticleFactory
	) {
		$scope.articleRelationPrice = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.articleRelationPrice) && $rootScope.isDefinedAndNotNull($scope.articleRelationPrice.id);
		};

		$scope.createArticle = function() {
			var referredBy = {
				refName: 'article',
				data: $scope.articleRelationPrice,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new article will add this new articlerelationprice state to the history stack
				$state.go('articlerelationprice.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('articleRelationPrice.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryRelation = function() {
			// If the id of a preselected relation is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'relation');
					}
				});
			}
		};
		$scope.relationList = $scope.queryRelation();

		// --- start default implementation
		/**
		 * This function queries all entities of type Article and checks if this ArticleRelationPrice dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity ArticleRelationPrice and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return NoPagingArticleFactory.query(function(result) {
				$scope.findItemByParent(result, 'article');
			});
		};
		$scope.articleList = $scope.queryArticle();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleRelationPriceUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving ArticleRelationPrice failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.articleRelationPrice.relation === '') {
				$scope.articleRelationPrice.relation = null;
			}

			if ($scope.articleRelationPrice.id != null) {
				ArticleRelationPriceFactory.update($scope.articleRelationPrice, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				ArticleRelationPriceFactory.save($scope.articleRelationPrice, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('ArticleRelationPriceDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.articleRelationPrice = entity;
	$scope.objectName = 'ArticleRelationPrice';
	$scope.articleRelationPriceId = $stateParams.articleRelationPriceId;

	if (angular.isUndefined($rootScope.articleRelationPriceActiveTab)) {
		//set the default here
		$rootScope.articleRelationPriceActiveTab = 0;
	}

	$scope.goToEditState = function(articleRelationPrice) {
		$state.go(
			'articlerelationprice.detail.edit({articleRelationPriceId:articleRelationPrice.id, mappedBy:mappedBy, mappedById:mappedById})'
		);
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:articleRelationPriceUpdate', function(event, result) {
		$scope.articleRelationPrice = result;
	});
});

/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'ArticleRelationPrice'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('articlerelationprice'); // main translation loaded for articlerelationprice
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('article'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/articlerelationprice/articlerelationprice-dialog.html';

		return {
			/* new state for entity articleRelationPrice */
			/* to access: ui-ref="articlerelationprice.list.new" */
			/* url: hostname/articlerelationprice/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'ArticleRelationPriceDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'ArticleRelationPriceFactory',
									'NewArticleRelationPriceFactory',
									function(ArticleRelationPriceFactory, NewArticleRelationPriceFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new ArticleRelationPrice
										// - resuming the creation of a new new ArticleRelationPrice AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return ArticleRelationPriceFactory.get({ id: $stateParams.articleRelationPriceId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewArticleRelationPriceFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for articleRelationPrice new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for articleRelationPrice edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('articlerelationprice', {
		/* abstract state for entity articleRelationPrice */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/articlerelationprice',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'ArticleRelationPrices',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('articlerelationprice.list', {
		/* list state for entity articleRelationPrice */
		/* to access: ui-ref="articlerelationprice.list" */
		/* url: hostname/articlerelationprice/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/articlerelationprice/articlerelationprices.html',
				controller: 'ArticleRelationPriceController',
			},
		},
	});

	$stateProvider.state('articlerelationprice.detail', {
		/* detail state for entity articleRelationPrice */
		/* to access: ui-sref="articlerelationprice.detail" */
		/* url: hostname/articlerelationprice/detail/:articleRelationPriceId */
		url: '/detail/:articleRelationPriceId',
		views: {
			'content@': {
				templateUrl: 'app/entities/articlerelationprice/articlerelationprice-detail.html',
				controller: 'ArticleRelationPriceDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'ArticleRelationPriceFactory',
				function($stateParams, ArticleRelationPriceFactory) {
					return ArticleRelationPriceFactory.get({ id: $stateParams.articleRelationPriceId });
				},
			],
		},
	});

	/* url: http://<hostname>/articlerelationprice/list/new */
	$stateProvider.state('articlerelationprice.list.new', getNewState());
	/* url: http://<hostname>/articlerelationprice/list/:articleRelationPriceId/edit */
	$stateProvider.state('articlerelationprice.list.edit', getEditState('/:articleRelationPriceId/edit'));
	/* url: http://<hostname>/articlerelationprice/detail/:articleRelationPriceId/edit */
	$stateProvider.state('articlerelationprice.detail.edit', getEditState('/edit'));
	// Article.articleRelationPrice with multiplicity 0..n points to ArticleRelationPrice
	/* url: http://<hostname>/article/detail/:articleId/articlerelationprice/new */
	$stateProvider.state('article.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/article/detail/:articleId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('article.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-article/detail/:articleId/articlerelationprice/new */
	$stateProvider.state('user-article.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/user-article/detail/:articleId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('user-article.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
	// Relation.articleRelationPrice with multiplicity 0..n points to ArticleRelationPrice
	/* url: http://<hostname>/relation/detail/:relationId/articlerelationprice/new */
	$stateProvider.state('relation.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/relation/detail/:relationId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('relation.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/articlerelationprice/new */
	$stateProvider.state('user-relation.detail.newArticleRelationPrice', getNewState('/articlerelationprice/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/articlerelationprice/:articleRelationPriceId/edit */
	$stateProvider.state('user-relation.detail.editArticleRelationPrice', getEditState('/articlerelationprice/:articleRelationPriceId/edit'));
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleRelationPriceTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleRelationPriceFactory,
		FindAllArticleRelationPricesByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingArticleRelationPriceFactory,
		NoPagingRelationFactory,
		NoPagingArticleFactory
	) {
		$scope.articleRelationPriceList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeArticleRelationPrice)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeArticleRelationPrice);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticleRelationPrice = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newArticleRelationPrice', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(articleRelationPrice) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editArticleRelationPrice', {
				articleRelationPriceId: articleRelationPrice.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.relationId)) {
				return $scope.relationId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.ArticleRelationPriceSearchTab.relation)) {
					return $scope.ArticleRelationPriceSearchTab.relation.id;
				} else {
					return undefined;
				}
			}
		};

		var getArticleId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.articleId)) {
				return $scope.articleId;
			} else {
				if ($rootScope.isDefinedAndNotNull($scope.ArticleRelationPriceSearchTab.article)) {
					return $scope.ArticleRelationPriceSearchTab.article.id;
				} else {
					return undefined;
				}
			}
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type Article and checks if this ArticleRelationPrice dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity ArticleRelationPrice and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return NoPagingArticleFactory.query(function(result) {
				return result;
			});
		};
		$scope.articleReferenceFilterList = $scope.queryArticle();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.ArticleRelationPriceSearchTab = angular.copy($scope.ArticleRelationPriceSearchTab);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticleRelationPrice = angular.copy($scope.pageSize);

			FindAllArticleRelationPricesByQueryParamsFactory.query(
				{
					page: $scope.ArticleRelationPriceSearchTab.page - 1,
					size: $scope.pageSize,
					relationId: getRelationId(),
					articleId: getArticleId(),

					sort: [$scope.ArticleRelationPriceSearchTab.predicate + ',' + ($scope.ArticleRelationPriceSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleRelationPriceList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isArticleRelationPriceSearchTabDirty = function() {
			return !angular.equals($scope.ArticleRelationPriceSearchTab, $scope.originalArticleRelationPriceSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.ArticleRelationPriceSearchTab = {};
			$rootScope.ArticleRelationPriceSearchTab.page = 1;
			$rootScope.ArticleRelationPriceSearchTab.predicate = 'id';
			$rootScope.ArticleRelationPriceSearchTab.ascending = false;

			$scope.ArticleRelationPriceSearchTab = angular.copy($rootScope.ArticleRelationPriceSearchTab);

			$scope.originalArticleRelationPriceSearchTab = angular.copy($scope.ArticleRelationPriceSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.ArticleRelationPriceSearchTab) || $rootScope.ArticleRelationPriceSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.ArticleRelationPriceSearchTab = angular.copy($rootScope.ArticleRelationPriceSearchTab);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleRelationPriceId = id;
			$('#deleteArticleRelationPriceConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleRelationPriceFactory.delete(
				{ id: $scope.selectedArticleRelationPriceId },
				function() {
					$scope.search();
					$('#deleteArticleRelationPriceConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteArticleRelationPriceConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.ArticleRelationPriceSearchTab.predicate === itemName) {
				if ($scope.ArticleRelationPriceSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleRelationPriceController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleRelationPriceFactory,
		FindAllArticleRelationPricesByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingArticleRelationPriceFactory,
		NoPagingRelationFactory,
		NoPagingArticleFactory
	) {
		$scope.articleRelationPriceList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeArticleRelationPrice)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeArticleRelationPrice);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticleRelationPrice = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('articlerelationprice.list.new');
		};

		$scope.goToEditState = function(articleRelationPrice) {
			// this overview is NOT mapped, it is the main overview
			$state.go('articlerelationprice.list.edit', { articleRelationPriceId: articleRelationPrice.id });
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.ArticleRelationPriceSearchOverview.relation)) {
				return $scope.ArticleRelationPriceSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		var getArticleId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.ArticleRelationPriceSearchOverview.article)) {
				return $scope.ArticleRelationPriceSearchOverview.article.id;
			} else {
				return undefined;
			}
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type Article and checks if this ArticleRelationPrice dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity ArticleRelationPrice and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return NoPagingArticleFactory.query(function(result) {
				return result;
			});
		};
		$scope.articleReferenceFilterList = $scope.queryArticle();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.ArticleRelationPriceSearchOverview = angular.copy($scope.ArticleRelationPriceSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticleRelationPrice = angular.copy($scope.pageSize);

			FindAllArticleRelationPricesByQueryParamsFactory.query(
				{
					page: $scope.ArticleRelationPriceSearchOverview.page - 1,
					size: $scope.pageSize,
					relationId: getRelationId(),
					articleId: getArticleId(),

					sort: [
						$scope.ArticleRelationPriceSearchOverview.predicate +
							',' +
							($scope.ArticleRelationPriceSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleRelationPriceList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isArticleRelationPriceSearchOverviewDirty = function() {
			return !angular.equals($scope.ArticleRelationPriceSearchOverview, $scope.originalArticleRelationPriceSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.ArticleRelationPriceSearchOverview = {};
			$rootScope.ArticleRelationPriceSearchOverview.page = 1;
			$rootScope.ArticleRelationPriceSearchOverview.predicate = 'id';
			$rootScope.ArticleRelationPriceSearchOverview.ascending = false;

			$scope.ArticleRelationPriceSearchOverview = angular.copy($rootScope.ArticleRelationPriceSearchOverview);

			$scope.originalArticleRelationPriceSearchOverview = angular.copy($scope.ArticleRelationPriceSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.ArticleRelationPriceSearchOverview) || $rootScope.ArticleRelationPriceSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.ArticleRelationPriceSearchOverview = angular.copy($rootScope.ArticleRelationPriceSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleRelationPriceId = id;
			$('#deleteArticleRelationPriceConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleRelationPriceFactory.delete(
				{ id: $scope.selectedArticleRelationPriceId },
				function() {
					$scope.search();
					$('#deleteArticleRelationPriceConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteArticleRelationPriceConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.ArticleRelationPriceSearchOverview.predicate === itemName) {
				if ($scope.ArticleRelationPriceSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserArticleListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleFactory,
		UserArticleListDtoSearchFactory,
		UserArticleViewDtoFactory
	) {
		$scope.articleList = [];
		$scope.selectedArticleList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeArticle);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-article.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getArticleList = function() {
			UserArticleListDtoSearchFactory.query(
				{
					articleTypeId: angular.isDefined($scope.articleTypeId) ? $scope.articleTypeId : null,
					vatType: angular.isDefined($scope.vatTypeId) ? $scope.vatTypeId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getArticleList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleId = id;
			$('#deleteArticleConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserArticleViewDtoFactory.delete(
				{ id: $scope.selectedArticleId },
				function() {
					$scope.loadAll();
					$('#deleteArticleConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteArticleConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.multipleUpdate = function() {
			$state.go('user-article.bulkedit', { selectedArticleList: $scope.selectedArticleList });
		};

		$scope.deselectAll = function() {
			angular.forEach($scope.articleList, function(value, key) {
				// update the list with selected items
				value.isSelected = false;
				$scope.selectionChanged(value);
			});
			$scope.selectedArticleList = [];
		};

		$scope.selectionChanged = function(item) {
			$scope.$broadcast('childClick', item);
			$scope.updateSelection();
		};

		$scope.toggleSelection = function() {
			$scope.updateSelection();
		};

		$scope.updateSelection = function() {
			// clean selection (if any)
			$scope.selectedArticleList = [];

			angular.forEach($scope.articleList, function(value, key) {
				// update the list with selected items
				if (value.isSelected) {
					$scope.selectedArticleList.push(value);
				}
			});
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:articleUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserArticleListDtoController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleFactory,
		UserArticleListDtoSearchFactory,
		UserArticleViewDtoFactory
	) {
		$scope.articleList = [];
		$scope.selectedArticleList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeArticle);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('user-article.new');
		};

		var getArticleTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.ArticleSearchOverview.articleType)) {
				return $scope.ArticleSearchOverview.articleType.id;
			} else {
				return undefined;
			}
		};

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.ArticleSearchOverview = angular.copy($scope.ArticleSearchOverview);

			$rootScope.pageSizeArticle = angular.copy($scope.pageSize);

			UserArticleListDtoSearchFactory.query(
				{
					page: $scope.ArticleSearchOverview.page - 1,
					size: $scope.pageSize,
					name: $scope.ArticleSearchOverview.name,
					articleTypeId: getArticleTypeId(),
					vatType: $scope.ArticleSearchOverview.vatType,

					sort: [$scope.ArticleSearchOverview.predicate + ',' + ($scope.ArticleSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleList = result.items;

					$scope.articleTypeReferenceFilterList = result.articleTypeSearchOptions;

					$scope.vatTypeList = result.vatTypeSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isArticleSearchOverviewDirty = function() {
			return !angular.equals($scope.ArticleSearchOverview, $scope.originalArticleSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.ArticleSearchOverview = {};
			$rootScope.ArticleSearchOverview.page = 1;
			$rootScope.ArticleSearchOverview.predicate = 'id';
			$rootScope.ArticleSearchOverview.ascending = false;

			$scope.ArticleSearchOverview = angular.copy($rootScope.ArticleSearchOverview);

			$scope.originalArticleSearchOverview = angular.copy($scope.ArticleSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.ArticleSearchOverview) || $rootScope.ArticleSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.ArticleSearchOverview = angular.copy($rootScope.ArticleSearchOverview);

			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleId = id;
			$('#deleteArticleConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserArticleViewDtoFactory.delete(
				{ id: $scope.selectedArticleId },
				function() {
					$scope.search();
					$('#deleteArticleConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteArticleConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.multipleUpdate = function() {
			$state.go('user-article.bulkedit', { selectedArticleList: $scope.selectedArticleList });
		};

		$scope.deselectAll = function() {
			angular.forEach($scope.articleList, function(value, key) {
				// update the list with selected items
				value.isSelected = false;
				$scope.selectionChanged(value);
			});
			$scope.selectedArticleList = [];
		};

		$scope.selectionChanged = function(item) {
			$scope.$broadcast('childClick', item);
			$scope.updateSelection();
		};

		$scope.toggleSelection = function() {
			$scope.updateSelection();
		};

		$scope.updateSelection = function() {
			// clean selection (if any)
			$scope.selectedArticleList = [];

			angular.forEach($scope.articleList, function(value, key) {
				// update the list with selected items
				if (value.isSelected) {
					$scope.selectedArticleList.push(value);
				}
			});
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:articleUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.ArticleSearchOverview.predicate === itemName) {
				if ($scope.ArticleSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';

// Created by frontend/angular/entity/controller/dto-edit.ftl
angular
	.module('emsApp')
	.controller('UserArticleEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserArticleEditDtoFactory,
		AlertService,
		HistoryService,
		UserArticleEditDtoSaveAndCreateFactory
	) {
		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.submitButtonIsActive = true;
		};

		$scope.article = entity;
		$scope.submitButtonIsActive = true;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		//This function preselects and disables the parent reference when called from tab
		$scope.article['selected' + _.upperFirst($stateParams.mappedBy)] = {
			id: $stateParams.mappedById,
			displayValue: $stateParams.mappedByDisplayValue,
		};

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.article) && $rootScope.isDefinedAndNotNull($scope.article.id);
		};

		var onSaveAndNewFinishedCallback = function(result) {
			// navigate to new state with result (a new entity, but with the copied values from the previous)
			$state.go('user-article.new', {
				dataModel: result,
				mappedBy: $stateParams.mappedBy,
				mappedById: $stateParams.mappedById,
			});
		};

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleUpdate', result);
			$scope.submitButtonIsActive = true;
			// process success result, if necessary
			if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
				console.log('as we came on this create new page from plus button we will update history');

				// set relation as reference in the referredBy data model
				$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;

				// update previous state
				HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
			}
			$rootScope.back();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;
			UserArticleEditDtoFactory.update($scope.article, onSaveFinishedCallback, saveOrUpdateErrorCallback);
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			// To prevent navigating back to this current view, remove it from history.
			HistoryService.removeHistory();

			if ($scope.article.id != null) {
				UserArticleEditDtoSaveAndCreateFactory.updateAndNew($scope.article, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				UserArticleEditDtoSaveAndCreateFactory.createAndNew($scope.article, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};
	});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('ArticleDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		ArticleFactory,
		AlertService,
		NoPagingArticleFactory,
		NoPagingArticleTypeFactory,
		NoPagingVatTypeFactory,
		ArticleSaveAndCreateFactory
	) {
		$scope.article = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.article) && $rootScope.isDefinedAndNotNull($scope.article.id);
		};

		$scope.createArticleType = function() {
			var referredBy = {
				refName: 'articleType',
				data: $scope.article,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new articleType will add this new article state to the history stack
				$state.go('article.list.newArticleType', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('article.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type ArticleType and checks if this Article dialog is called in the context of ArticleType.
		 * If this is the case, we detect the parent entity Article and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticleType = function() {
			return NoPagingArticleTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'articleType');
			});
		};
		$scope.articleTypeList = $scope.queryArticleType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type VatType and checks if this Article dialog is called in the context of VatType.
		 * If this is the case, we detect the parent entity Article and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryVatType = function() {
			return NoPagingVatTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'vatType');
			});
		};
		$scope.vatTypeList = $scope.queryVatType();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Article failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		var onSaveAndNewFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleUpdate', result);
			// the result contains a new entity, but with the copied values from the previous
			$scope.article = result;
			$scope.updateDropdownModels();
			$scope.submitButtonIsActive = true;
		};

		$scope.updateDropdownModels = function() {
			$scope.queryArticleType();
			$scope.queryVatType();
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.article.id != null) {
				ArticleFactory.update($scope.article, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				ArticleFactory.save($scope.article, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		$scope.saveAndNew = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.article.id != null) {
				ArticleSaveAndCreateFactory.updateAndCreate($scope.article, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				ArticleSaveAndCreateFactory.saveAndCreate($scope.article, onSaveAndNewFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});

/** @format */

'use strict';

angular.module('emsApp').controller('ArticleDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.article = entity;
	$scope.objectName = 'Article';
	$scope.articleId = $stateParams.articleId;

	if (angular.isUndefined($rootScope.articleActiveTab)) {
		//set the default here
		$rootScope.articleActiveTab = 0;
	}

	$scope.goToEditState = function(article) {
		$state.go('article.detail.edit({articleId:article.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:articleUpdate', function(event, result) {
		$scope.article = result;
	});
});

/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserArticleBulkEditDtoController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$parse,
		_,
		entity,
		UserArticleBulkEditDtoFactory,
		AlertService
	) {
		$scope.selectedArticleIds = _.map($stateParams.selectedArticleList, 'id');
		$scope.selectedItemsAmount = $scope.selectedArticleIds.length;
		$scope.article = entity;
		$scope.submitButtonIsActive = true;

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:articleUpdate', result);
			$scope.submitButtonIsActive = true;
			// process success result, if necessary
			if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
				console.log('as we came on this create new page from plus button we will update history');

				// set relation as reference in the referredBy data model
				$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;

				// update previous state
				HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
			}
			$rootScope.back();
		};

		var saveOrUpdateErrorCallback = function(error) {
			AlertService.error(error.data);
			$scope.updatingItemsInProgress = false;
		};

		$scope.save = function() {
			$scope.updatingItemsInProgress = true;
			UserArticleBulkEditDtoFactory.update(
				{ articleIds: $scope.selectedArticleIds },
				$scope.article,
				onSaveFinishedCallback,
				saveOrUpdateErrorCallback
			);
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			$rootScope.back();
		};
	});

/** @format */

'use strict';

// Article has edit layout enabled. Edit layout template url: article-dialog.html
// Article has detail layout enabled. Detail layout template url: article-detail.html
angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Article'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('article'); // main translation loaded for article
		$translatePartialLoader.addPart('vattype'); // one to many reference from main entity
		$translatePartialLoader.addPart('articletype'); // one to many reference from main entity
		$translatePartialLoader.addPart('orderline'); // one to many reference from main entity
		$translatePartialLoader.addPart('articlerelationprice'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/article/article-dialog.html';

		return {
			/* new state for entity article */
			/* to access: ui-ref="article.list.new" */
			/* url: hostname/article/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'ArticleDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'ArticleFactory',
									'NewArticleFactory',
									function(ArticleFactory, NewArticleFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Article
										// - resuming the creation of a new new Article AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return ArticleFactory.get({ id: $stateParams.articleId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewArticleFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for article new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for article edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('article', {
		/* abstract state for entity article */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/article',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Articles',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('article.list', {
		/* list state for entity article */
		/* to access: ui-ref="article.list" */
		/* url: hostname/article/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/article/articles.html',
				controller: 'ArticleController',
			},
		},
	});

	$stateProvider.state('article.detail', {
		/* detail state for entity article */
		/* to access: ui-sref="article.detail" */
		/* url: hostname/article/detail/:articleId */
		url: '/detail/:articleId',
		views: {
			'content@': {
				templateUrl: 'app/entities/article/article-detail.html',
				controller: 'ArticleDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'ArticleFactory',
				function($stateParams, ArticleFactory) {
					return ArticleFactory.get({ id: $stateParams.articleId });
				},
			],
		},
	});

	/* url: http://<hostname>/article/list/new */
	$stateProvider.state('article.list.new', getNewState());
	/* url: http://<hostname>/article/list/:articleId/edit */
	$stateProvider.state('article.list.edit', getEditState('/:articleId/edit'));
	/* url: http://<hostname>/article/detail/:articleId/edit */
	$stateProvider.state('article.detail.edit', getEditState('/edit'));
	// ArticleType.article with multiplicity 0..n points to Article
	/* url: http://<hostname>/articletype/detail/:articleTypeId/article/new */
	$stateProvider.state('articletype.detail.newArticle', getNewState('/article/new'));
	/* url: http://<hostname>/articletype/detail/:articleTypeId/article/:articleId/edit */
	$stateProvider.state('articletype.detail.editArticle', getEditState('/article/:articleId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/-articletype/detail/:articleTypeId/article/new */
	$stateProvider.state('-articletype.detail.newArticle', getNewState('/article/new'));
	/* url: http://<hostname>/-articletype/detail/:articleTypeId/article/:articleId/edit */
	$stateProvider.state('-articletype.detail.editArticle', getEditState('/article/:articleId/edit'));

	$stateProvider.state('templateevent.list.newArticle', getNewState('/article/new'));
	$stateProvider.state('subscription.list.newArticle', getNewState('/article/new'));
	$stateProvider.state('orderline.list.newArticle', getNewState('/article/new'));
	$stateProvider.state('locationtemplateeventarticle.list.newArticle', getNewState('/article/new'));
	$stateProvider.state('carrentaltypetemplateeventarticle.list.newArticle', getNewState('/article/new'));
	$stateProvider.state('articlerelationprice.list.newArticle', getNewState('/article/new'));

	$stateProvider.state('user-article', {
		/* abstract state for DTO UserArticleListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/article',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'Article',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserArticleListDto */
		/* to access: ui-ref="user-article.list" */
		/* url: http://<hostname>/user/article/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/article/article-list-user.html',
				controller: 'UserArticleListDtoController',
			},
		},
	};

	$stateProvider.state('user-article.list', dtoListState);

	/* detail state for DTO user */
	var dtoDetailState = {
		/* detail state for DTO UserArticleViewDto */
		/* to access: ui-sref="user-article.detail" */
		/* url: http://<hostname>/user/article/detail/:articleId */
		url: '/detail/:articleId',
		views: {
			'content@': {
				templateUrl: 'app/entities/article/article-view-user.html',
				controller: 'ArticleDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'UserArticleViewDtoFactory',
				function($stateParams, UserArticleViewDtoFactory) {
					return UserArticleViewDtoFactory.get({ id: $stateParams.articleId });
				},
			],
		},
	};

	$stateProvider.state('user-article.detail', dtoDetailState);

	/* edit state for DTO user */
	var dtoEditState = {
		/* edit state for DTO UserArticleEditDto */
		/* to access: ui-sref="user-article.edit" */
		/* url: http://<hostname>/user/article/edit/:articleId */
		url: '/edit/:articleId',
		views: {
			'content@': {
				templateUrl: 'app/entities/article/article-edit-user.html',
				controller: 'UserArticleEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserArticleEditDtoFactory',
				function($stateParams, $rootScope, UserArticleEditDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserArticleEditDtoFactory.get({ id: $stateParams.articleId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-article.edit', dtoEditState);

	/* new (create) state for DTO user */
	var dtoCreateState = {
		/* new state for DTO UserArticleEditDto */
		/* to access: ui-sref="user-article.new" */
		/* url: http://<hostname>/user/article/new */
		url: '/new',
		views: {
			'content@': {
				templateUrl: 'app/entities/article/article-edit-user.html',
				controller: 'UserArticleEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserArticleNewDtoFactory',
				function($stateParams, $rootScope, UserArticleNewDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserArticleNewDtoFactory.get({ id: $stateParams.articleId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-article.new', dtoCreateState);

	/* Bulk edit state for DTO user */
	var dtoBulkEditState = {
		/* Bulk edit state for DTO UserArticleEditDto */
		/* to access: ui-sref="user-article.bulkedit" */
		/* url: http://<hostname>/user/article/bulkedit */
		url: '/bulkedit',
		views: {
			'content@': {
				templateUrl: 'app/entities/article/article-bulkedit-user.html',
				controller: 'UserArticleBulkEditDtoController',
			},
		},
		params: {
			selectedArticleList: [''],
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserArticleNewBulkEditDtoFactory',
				function($stateParams, $rootScope, UserArticleNewBulkEditDtoFactory) {
					return UserArticleNewBulkEditDtoFactory.get().$promise.then(function(result) {
						return result;
					});
				},
			],
		},
	};

	$stateProvider.state('user-article.bulkedit', dtoBulkEditState);

	// create state for plus button on TemplateEvent edit / new page for reference Article and dto property value user
	$stateProvider.state('user-templateevent.new.newArticle', getCreateState('/defaultdriver/new'));
	$stateProvider.state('user-templateevent.edit.newArticle', getCreateState('/defaultdriver/new'));
	// create state for plus button on Subscription edit / new page for reference Article and dto property value user
	$stateProvider.state('user-subscription.new.newArticle', getCreateState('/driver/new'));
	$stateProvider.state('user-subscription.edit.newArticle', getCreateState('/driver/new'));
	// create state for plus button on OrderLine edit / new page for reference Article and dto property value user
	$stateProvider.state('user-orderline.new.newArticle', getCreateState('/article/new'));
	$stateProvider.state('user-orderline.edit.newArticle', getCreateState('/article/new'));
	// create state for plus button on LocationTemplateEventArticle edit / new page for reference Article and dto property value user
	$stateProvider.state('user-locationtemplateeventarticle.new.newArticle', getCreateState('/article/new'));
	$stateProvider.state('user-locationtemplateeventarticle.edit.newArticle', getCreateState('/article/new'));
	// create state for plus button on CarRentalTypeTemplateEventArticle edit / new page for reference Article and dto property value user
	$stateProvider.state('user-carrentaltypetemplateeventarticle.new.newArticle', getCreateState('/articleforrental/new'));
	$stateProvider.state('user-carrentaltypetemplateeventarticle.edit.newArticle', getCreateState('/articleforrental/new'));
	// create state for plus button on ArticleRelationPrice edit / new page for reference Article and dto property value user
	$stateProvider.state('user-articlerelationprice.new.newArticle', getCreateState('/article/new'));
	$stateProvider.state('user-articlerelationprice.edit.newArticle', getCreateState('/article/new'));
	// retrieve the create state object, and update the url in the state object as the default create state only adds "/new" to the location url, while we want the url to contain "/article/new"
	function getCreateState(url) {
		var clonedDtoCreateState = Object.assign({}, dtoCreateState);
		clonedDtoCreateState.url = url;
		return clonedDtoCreateState;
	}
});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleFactory,
		FindAllArticlesByQueryParamsFactory,
		NoPagingArticleFactory,
		NoPagingArticleTypeFactory,
		NoPagingVatTypeFactory
	) {
		$scope.articleList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newArticle', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(article) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editArticle', { articleId: article.id, mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getArticleList = function() {
			FindAllArticlesByQueryParamsFactory.query(
				{
					articleTypeId: angular.isDefined($scope.articleTypeId) ? $scope.articleTypeId : null,
					vatTypeId: angular.isDefined($scope.vatTypeId) ? $scope.vatTypeId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getArticleList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleId = id;
			$('#deleteArticleConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleFactory.delete(
				{ id: $scope.selectedArticleId },
				function() {
					$scope.loadAll();
					$('#deleteArticleConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteArticleConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:articleUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleFactory,
		FindAllArticlesByQueryParamsFactory,
		NoPagingArticleFactory,
		NoPagingArticleTypeFactory,
		NoPagingVatTypeFactory
	) {
		$scope.articleList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('article.list.new');
		};

		$scope.goToEditState = function(article) {
			// this overview is NOT mapped, it is the main overview
			$state.go('article.list.edit', { articleId: article.id });
		};

		var getArticleTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.ArticleSearchOverview.articleType)) {
				return $scope.ArticleSearchOverview.articleType.id;
			} else {
				return undefined;
			}
		};

		/**
		 * This function queries all entities of type ArticleType and checks if this Article dialog is called in the context of ArticleType.
		 * If this is the case, we detect the parent entity Article and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticleType = function() {
			return NoPagingArticleTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.articleTypeReferenceFilterList = $scope.queryArticleType();

		NoPagingVatTypeFactory.query(function(result) {
			$scope.vatTypeList = result;
		});
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.ArticleSearchOverview = angular.copy($scope.ArticleSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticle = angular.copy($scope.pageSize);

			FindAllArticlesByQueryParamsFactory.query(
				{
					page: $scope.ArticleSearchOverview.page - 1,
					size: $scope.pageSize,
					name: $scope.ArticleSearchOverview.name,
					articleTypeId: getArticleTypeId(),
					vatType: $scope.ArticleSearchOverview.vatType,

					sort: [$scope.ArticleSearchOverview.predicate + ',' + ($scope.ArticleSearchOverview.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isArticleSearchOverviewDirty = function() {
			return !angular.equals($scope.ArticleSearchOverview, $scope.originalArticleSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.ArticleSearchOverview = {};
			$rootScope.ArticleSearchOverview.page = 1;
			$rootScope.ArticleSearchOverview.predicate = 'id';
			$rootScope.ArticleSearchOverview.ascending = false;

			$scope.ArticleSearchOverview = angular.copy($rootScope.ArticleSearchOverview);

			$scope.originalArticleSearchOverview = angular.copy($scope.ArticleSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.ArticleSearchOverview) || $rootScope.ArticleSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.ArticleSearchOverview = angular.copy($rootScope.ArticleSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleId = id;
			$('#deleteArticleConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleFactory.delete(
				{ id: $scope.selectedArticleId },
				function() {
					$scope.search();
					$('#deleteArticleConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteArticleConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:articleUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.ArticleSearchOverview.predicate === itemName) {
				if ($scope.ArticleSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').filter('words', words);

	function words() {
		return wordsFilter;

		function wordsFilter(input, words) {
			if (isNaN(words)) {
				return input;
			}
			if (words <= 0) {
				return '';
			}
			if (input) {
				var inputWords = input.split(/\s+/);
				if (inputWords.length > words) {
					input = inputWords.slice(0, words).join(' ') + '...';
				}
			}
			return input;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').filter('characters', characters);

	function characters() {
		return charactersFilter;

		function charactersFilter(input, chars, breakOnWord) {
			if (isNaN(chars)) {
				return input;
			}
			if (chars <= 0) {
				return '';
			}
			if (input && input.length > chars) {
				input = input.substring(0, chars);

				if (!breakOnWord) {
					var lastspace = input.lastIndexOf(' ');
					// Get last space
					if (lastspace !== -1) {
						input = input.substr(0, lastspace);
					}
				} else {
					while (input.charAt(input.length - 1) === ' ') {
						input = input.substr(0, input.length - 1);
					}
				}
				return input + '...';
			}
			return input;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('jhSortBy', jhSortBy);

	function jhSortBy() {
		var directive = {
			restrict: 'A',
			scope: false,
			require: '^jhSort',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs, parentCtrl) {
			element.bind('click', function() {
				parentCtrl.sort(attrs.jhSortBy);
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('jhSort', jhSort);

	function jhSort() {
		var directive = {
			restrict: 'A',
			scope: {
				predicate: '=jhSort',
				ascending: '=',
				callback: '&',
			},
			controller: SortController,
			controllerAs: 'vm',
			bindToController: true,
		};

		return directive;
	}

	SortController.$inject = ['$scope', '$element'];

	function SortController($scope, $element) {
		var vm = this;

		vm.applyClass = applyClass;
		vm.resetClasses = resetClasses;
		vm.sort = sort;
		vm.triggerApply = triggerApply;

		$scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
		vm.triggerApply();

		function applyClass(element) {
			var thisIcon = element.find('span.glyphicon'),
				sortIcon = 'glyphicon-sort',
				sortAsc = 'glyphicon-sort-by-attributes',
				sortDesc = 'glyphicon-sort-by-attributes-alt',
				remove = sortIcon + ' ' + sortDesc,
				add = sortAsc;
			if (!vm.ascending) {
				remove = sortIcon + ' ' + sortAsc;
				add = sortDesc;
			}
			vm.resetClasses();
			thisIcon.removeClass(remove);
			thisIcon.addClass(add);
		}

		function resetClasses() {
			var allThIcons = $element.find('span.glyphicon'),
				sortIcon = 'glyphicon-sort',
				sortAsc = 'glyphicon-sort-by-attributes',
				sortDesc = 'glyphicon-sort-by-attributes-alt';
			allThIcons.removeClass(sortAsc + ' ' + sortDesc);
			allThIcons.addClass(sortIcon);
		}

		function sort(field) {
			if (field !== vm.predicate) {
				vm.ascending = true;
			} else {
				vm.ascending = !vm.ascending;
			}
			vm.predicate = field;
			$scope.$apply();
			vm.callback();
		}

		function triggerApply(values) {
			vm.resetClasses();
			if (values && values[0] !== '_score') {
				vm.applyClass($element.find("th[jh-sort-by='" + values[0] + "']"));
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('ParseLinks', ParseLinks);

	function ParseLinks() {
		var service = {
			parse: parse,
		};

		return service;

		function parse(header) {
			if (header.length === 0) {
				throw new Error('input must not be of zero length');
			}

			// Split parts by comma
			var parts = header.split(',');
			var links = {};
			// Parse each part into a named link
			angular.forEach(parts, function(p) {
				var section = p.split('>;');
				if (section.length !== 2) {
					throw new Error('section could not be split on ">;"');
				}
				var url = section[0].replace(/<(.*)/, '$1').trim();
				var queryString = {};
				url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function($0, $1, $2, $3) {
					queryString[$1] = $3;
				});
				var page = queryString.page;
				if (angular.isString(page)) {
					page = parseInt(page);
				}
				var name = section[1].replace(/rel="(.*)"/, '$1').trim();
				links[name] = page;
			});
			return links;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('PaginationUtil', PaginationUtil);

	function PaginationUtil() {
		var service = {
			parseAscending: parseAscending,
			parsePage: parsePage,
			parsePredicate: parsePredicate,
		};

		return service;

		function parseAscending(sort) {
			var sortArray = sort.split(',');
			if (sortArray.length > 1) {
				return sort.split(',').slice(-1)[0] === 'asc';
			} else {
				// default to true if no sort defined
				return true;
			}
		}

		// query params are strings, and need to be parsed
		function parsePage(page) {
			return parseInt(page);
		}

		// sort can be in the format `id,asc` or `id`
		function parsePredicate(sort) {
			var sortArray = sort.split(',');
			if (sortArray.length > 1) {
				sortArray.pop();
			}
			return sortArray.join(',');
		}
	}
})();

/** @format */

'use strict';

angular.module('emsApp').directive('triStateCheckbox', function() {
	return {
		replace: true,
		restrict: 'E',
		scope: {
			items: '=',
			topLevelClick: '=',
			childClick: '@childClick',
		},
		template: '<input type="checkbox" ng-model="topLevel" ng-change="topLevelChange()">',
		controller: [
			'$scope',
			'$element',
			function($scope, $element) {
				$scope.setState = function() {
					var count = 0;
					for (var i = 0; i < $scope.items.length; i++) count += $scope.items[i].isSelected ? 1 : 0;
					$element.prop('indeterminate', false);
					$scope.topLevel = count === 0 ? false : true;
					if (count > 0 && count < i) {
						$scope.topLevel = false;
						$element.prop('indeterminate', true);
					}
				};

				$scope.topLevelChange = function() {
					for (var i = 0; i < $scope.items.length; i++) {
						$scope.items[i].isSelected = $scope.topLevel;
					}
					if ($scope.topLevelClick) {
						$scope.topLevelClick();
					}
				};

				if (!$scope.childClick) {
					$scope.$watch(
						'items',
						function() {
							$scope.setState();
						},
						true
					);
				} else {
					$scope.$on($scope.childClick, function() {
						$scope.setState();
					});
					$scope.setState();
				}
			},
		],
	};
});

/** @format */

(function() {
	'use strict';

	var jhiItemCount = {
		template:
			'<div class="info" data-translate="global.item-count" ' +
			'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
			'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
			'translate-value-total="{{$ctrl.queryCount}}">' +
			'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
			'{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
			'of {{$ctrl.queryCount}} items.' +
			'</div>',
		bindings: {
			page: '<',
			queryCount: '<total',
			itemsPerPage: '<',
		},
	};

	angular.module('emsApp').component('jhiItemCount', jhiItemCount);
})();

/** @format */

'use strict';

/**
 * Renders all historyState items from the history stack seperated by "/".
 * This might help the developer to debug state history problems.
 */
angular.module('emsApp').directive('historyBreadcrumb', function() {
	return {
		template:
			'<div class="row history-breadcrumb">' +
			'   <div class="col-xs-12">' +
			'       <span ng-repeat="historyState in history">{{historyState.stateName}}&nbsp;/&nbsp;</span>' +
			'   </div>' +
			'</div>',
		controller: function($scope, HistoryService) {
			$scope.history = HistoryService.breadcrumb();
		},
	};
});

/**
 * This HistoryService provides functionality to maintain a history stack.
 * It also provides a way to navigate back to the previous state.
 */
angular.module('emsApp').factory('HistoryService', function($window, $state) {
	/**
	 * The history stack. The last item always reflects the current state we are in. The 2nd last item is the previous history state.
	 * @type {Array} An array of historyState items.
	 */
	var history = [];

	/**
	 * A history state object. It contains the state that was transitioned to and the state params that were passed.
	 * @param toStateName
	 * @param toStateParams
	 * @returns {{stateName: *, stateParams: *}}
	 */
	var historyState = function(toStateName, toStateParams) {
		return {
			stateName: toStateName,
			stateParams: toStateParams,
		};
	};

	return {
		/**
		 * Navigates back to the 2nd last history state. The last history state is the current state, as all states that
		 * we transition to are pushed onto the stack after a successful state change (see app.js).
		 */
		back: function() {
			// the current state is the last on the stack, the previous state in history is the one prior to the last, hence we check for a stack size of 2 or more
			if (history.length >= 2) {
				// the first pop gets the state from the stack we were already in
				history.pop();

				// the next pop will retrieve the state we were in prior to the current state, which is the state we want to go to
				// NOTE it will be pushed onto the stack again by the state change listener
				var toState = history.pop();

				console.log('navigate back to history state', toState.stateName, 'with params:', toState.stateParams);

				// the popped state is used to navigate to, and so it reappears on the stack as the state change success event handling catches and pushes it
				$state.go(toState.stateName, toState.stateParams, { reload: true });
			} else {
				// there is not enough history in the stack to navigate to, hence we fall back to the window history back
				// $window.history.back();
				// TODO I uncommented the window history back as it causes weird behaviour in use with dialogs
				$state.go('home', {}, {});
			}
		},
		/**
		 * Adds the state with params as a new history item to the stack by pushing it onto it.
		 * @param toState The state that was transitioned to
		 * @param toStateParams The state params that were passed
		 */
		addHistory: function(toState, toStateParams) {
			history.push(new historyState(toState.name, toStateParams));
		},
		/**
		 * Removes the last state from the stack. Can be used to prevent the state from being navigated to via history.
		 */
		removeHistory: function() {
			var thisState = history.pop();

			console.log('Navigated to state ' + thisState.stateName + '. Removed from history stack.');
		},
		/**
		 * Updates the 2nd last history item state params dataModel with a data model. This data model is a model as a result of a modal dialog action.
		 * @param data the ng model as a result of a modal dialog
		 */
		updateHistoryParamsData: function(data, type) {
			var historyToUpdate = history[history.length - 2];
			historyToUpdate.stateParams.dataModel = data;
			historyToUpdate.stateParams.dataModelType = type;

			console.log('updated history state', historyToUpdate.stateName, 'with new params:', historyToUpdate.stateParams);
		},
		/**
		 * Resets the current history item state params dataModel with an empty data model.
		 */
		resetCurrentHistoryParamsData: function() {
			var historyToUpdate = history[history.length - 1];
			historyToUpdate.stateParams.dataModel = null;
			historyToUpdate.stateParams.dataModelType = null;

			console.log('updated current history state', historyToUpdate.stateName, 'with new params:', historyToUpdate.stateParams);
		},
		/**
		 * Returns the complete history stack. Could be used for breadcrumb like purposes.
		 * @returns {Array}
		 */
		breadcrumb: function() {
			return history;
		},
	};
});

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').constant(
		'errorConstants',
		(function() {
			var problemBaseUrl = 'http://www.jhipster.tech/problem';
			return {
				EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
				LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
				EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found',
			};
		})()
	);
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('DateUtils', DateUtils);

	DateUtils.$inject = ['$filter'];

	function DateUtils($filter) {
		var service = {
			convertDateTimeFromServer: convertDateTimeFromServer,
			convertLocalDateFromServer: convertLocalDateFromServer,
			convertLocalDateToServer: convertLocalDateToServer,
			dateformat: dateformat,
		};

		return service;

		function convertDateTimeFromServer(date) {
			if (date) {
				return new Date(date);
			} else {
				return null;
			}
		}

		function convertLocalDateFromServer(date) {
			if (date) {
				var dateString = date.split('-');
				return new Date(dateString[0], dateString[1] - 1, dateString[2]);
			}
			return null;
		}

		function convertLocalDateToServer(date) {
			if (date) {
				return $filter('date')(date, 'yyyy-MM-dd');
			} else {
				return null;
			}
		}

		function dateformat() {
			return 'yyyy-MM-dd';
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('DataUtils', DataUtils);

	DataUtils.$inject = ['$window'];

	function DataUtils($window) {
		var service = {
			abbreviate: abbreviate,
			byteSize: byteSize,
			openFile: openFile,
			toBase64: toBase64,
		};

		return service;

		function abbreviate(text) {
			if (!angular.isString(text)) {
				return '';
			}
			if (text.length < 30) {
				return text;
			}
			return text ? text.substring(0, 15) + '...' + text.slice(-10) : '';
		}

		function byteSize(base64String) {
			if (!angular.isString(base64String)) {
				return '';
			}

			function endsWith(suffix, str) {
				return str.indexOf(suffix, str.length - suffix.length) !== -1;
			}

			function paddingSize(base64String) {
				if (endsWith('==', base64String)) {
					return 2;
				}
				if (endsWith('=', base64String)) {
					return 1;
				}
				return 0;
			}

			function size(base64String) {
				return (base64String.length / 4) * 3 - paddingSize(base64String);
			}

			function formatAsBytes(size) {
				return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
			}

			return formatAsBytes(size(base64String));
		}

		function openFile(type, data) {
			var fileURL = 'data:' + type + ';base64,' + data;
			var win = $window.open('', '_blank');
			win.document.write(
				'<iframe src="' +
					fileURL +
					'" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
			);
		}

		function toBase64(file, cb) {
			var fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.onload = function(e) {
				var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
				cb(base64Data);
			};
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').filter('capitalize', capitalize);

	function capitalize() {
		return capitalizeFilter;

		function capitalizeFilter(input) {
			if (input !== null) {
				input = input.toLowerCase();
				input = input.substring(0, 1).toUpperCase() + input.substring(1);
			}
			return input;
		}
	}
})();

/** @format */

(function() {
	/*jshint bitwise: false*/
	'use strict';

	angular.module('emsApp').factory('Base64', Base64);

	function Base64() {
		var keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '=';

		var service = {
			decode: decode,
			encode: encode,
		};

		return service;

		function encode(input) {
			var output = '',
				chr1,
				chr2,
				chr3,
				enc1,
				enc2,
				enc3,
				enc4,
				i = 0;

			while (i < input.length) {
				chr1 = input.charCodeAt(i++);
				chr2 = input.charCodeAt(i++);
				chr3 = input.charCodeAt(i++);

				enc1 = chr1 >> 2;
				enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
				enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
				enc4 = chr3 & 63;

				if (isNaN(chr2)) {
					enc3 = enc4 = 64;
				} else if (isNaN(chr3)) {
					enc4 = 64;
				}

				output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
			}

			return output;
		}

		function decode(input) {
			var output = '',
				chr1,
				chr2,
				chr3,
				enc1,
				enc2,
				enc3,
				enc4,
				i = 0;

			// remove all characters that are not A-Z, a-z, 0-9, +, /, or =
			input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

			while (i < input.length) {
				enc1 = keyStr.indexOf(input.charAt(i++));
				enc2 = keyStr.indexOf(input.charAt(i++));
				enc3 = keyStr.indexOf(input.charAt(i++));
				enc4 = keyStr.indexOf(input.charAt(i++));

				chr1 = (enc1 << 2) | (enc2 >> 4);
				chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
				chr3 = ((enc3 & 3) << 6) | enc4;

				output = output + String.fromCharCode(chr1);

				if (enc3 !== 64) {
					output = output + String.fromCharCode(chr2);
				}
				if (enc4 !== 64) {
					output = output + String.fromCharCode(chr3);
				}
			}

			return output;
		}
	}
})();

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('RelationSalesFactory', function($resource) {
	return $resource('api/sales/relations', {}, {
		'query' : {
			method : 'GET',
			isArray : false
		},
		'create' : {
			method : 'POST'
		}
	});
});

angular.module('emsApp').factory('EventSalesFactory', function($resource) {
	return $resource('api/sales/events', {}, {
		'query' : {
			method : 'GET',
			isArray : false
		}
	});
});

angular.module('emsApp').factory('SalesSyncFactory', function($resource) {
	return $resource('api/sales/sync', {}, {
		'sync' : {
			method : 'GET',
			isArray : false
		}
	});
});

angular.module('emsApp').factory('SalesRelationSubscriptionFactory', function($resource) {
	return $resource('api/sales/relation/subscription', {}, {
		'get' : {
			method : 'GET',
			isArray : false
		}
	});
});

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('LoginService', LoginService);

	LoginService.$inject = ['$uibModal'];

	function LoginService($uibModal) {
		var service = {
			open: open,
		};

		var modalInstance = null;
		var resetModal = function() {
			modalInstance = null;
		};

		return service;

		function open() {
			if (modalInstance !== null) return;
			modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/components/login/login.html',
				controller: 'LoginController',
				controllerAs: 'vm',
				resolve: {
					translatePartialLoader: [
						'$translate',
						'$translatePartialLoader',
						function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('login');
							return $translate.refresh();
						},
					],
				},
			});
			modalInstance.result.then(resetModal, resetModal);
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('LoginController', LoginController);

	LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

	function LoginController($rootScope, $state, $timeout, Auth, $uibModalInstance) {
		var vm = this;

		vm.authenticationError = false;
		vm.cancel = cancel;
		vm.credentials = {};
		vm.login = login;
		vm.password = null;
		vm.register = register;
		vm.rememberMe = true;
		vm.requestResetPassword = requestResetPassword;
		vm.username = null;

		$timeout(function() {
			angular.element('#username').focus();
		});

		function cancel() {
			vm.credentials = {
				username: null,
				password: null,
				rememberMe: true,
			};
			vm.authenticationError = false;
			$uibModalInstance.dismiss('cancel');
		}

		function login(event) {
			event.preventDefault();
			Auth.login({
				username: vm.username,
				password: vm.password,
				rememberMe: vm.rememberMe,
			})
				.then(function() {
					vm.authenticationError = false;
					$uibModalInstance.close();
					if (
						$state.current.name === 'register' ||
						$state.current.name === 'activate' ||
						$state.current.name === 'finishReset' ||
						$state.current.name === 'requestReset'
					) {
						$state.go('home');
					}

					$rootScope.$broadcast('authenticationSuccess');

					// previousState was set in the authExpiredInterceptor before being redirected to login modal.
					// since login is successful, go to stored previousState and clear previousState
					if (Auth.getPreviousState()) {
						var previousState = Auth.getPreviousState();
						Auth.resetPreviousState();
						$state.go(previousState.name, previousState.params);
					}
				})
				.catch(function() {
					vm.authenticationError = true;
				});
		}

		function register() {
			$uibModalInstance.dismiss('cancel');
			$state.go('register');
		}

		function requestResetPassword() {
			$uibModalInstance.dismiss('cancel');
			$state.go('requestReset');
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('JhiLanguageService', JhiLanguageService);

	JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

	function JhiLanguageService($q, $http, $translate, LANGUAGES) {
		var service = {
			getAll: getAll,
			getCurrent: getCurrent,
		};

		return service;

		function getAll() {
			var deferred = $q.defer();
			deferred.resolve(LANGUAGES);
			return deferred.promise;
		}

		function getCurrent() {
			var deferred = $q.defer();
			var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

			deferred.resolve(language);

			return deferred.promise;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular
		.module('emsApp')
		.filter('findLanguageFromKey', findLanguageFromKey)
		.filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

	var languages = {
		en: { name: 'English' },
		nl: { name: 'Dutch' },
		// jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
	};

	function findLanguageFromKey() {
		return findLanguageFromKeyFilter;

		function findLanguageFromKeyFilter(lang) {
			return languages[lang].name;
		}
	}

	function findLanguageRtlFromKey() {
		return findLanguageRtlFromKeyFilter;

		function findLanguageRtlFromKeyFilter(lang) {
			return languages[lang].rtl;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('JhiLanguageController', JhiLanguageController);

	JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

	function JhiLanguageController($translate, JhiLanguageService, tmhDynamicLocale) {
		var vm = this;

		vm.changeLanguage = changeLanguage;
		vm.languages = null;

		JhiLanguageService.getAll().then(function(languages) {
			vm.languages = languages;
		});

		function changeLanguage(languageKey) {
			$translate.use(languageKey);
			tmhDynamicLocale.set(languageKey);
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular
		.module('emsApp')

		/*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
		.constant('LANGUAGES', [
			'en',
			'nl',
			// jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
		]);
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('showValidation', showValidation);

	function showValidation() {
		var directive = {
			restrict: 'A',
			require: 'form',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs, formCtrl) {
			element.find('.form-group').each(function() {
				var $formGroup = angular.element(this);
				var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

				if ($inputs.length > 0) {
					$inputs.each(function() {
						var $input = angular.element(this);
						var inputName = $input.attr('name');
						scope.$watch(
							function() {
								// NOTE uncomment the following line to check possible "Cannot read property '$invalid' of undefined
								// console.log("Check form control [" + inputName + "] for $invalid.", $input, $inputs);
								return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
							},
							function(isInvalid) {
								$formGroup.toggleClass('has-error', isInvalid);
							}
						);
					});
				}
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').constant('paginationConstants', {
		itemsPerPage: 20,
	});
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('minbytes', minbytes);

	function minbytes() {
		var directive = {
			restrict: 'A',
			require: '?ngModel',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return;
			}

			ngModel.$validators.minbytes = function(modelValue) {
				return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
			};
		}

		function endsWith(suffix, str) {
			return str.indexOf(suffix, str.length - suffix.length) !== -1;
		}

		function paddingSize(base64String) {
			if (endsWith('==', base64String)) {
				return 2;
			}
			if (endsWith('=', base64String)) {
				return 1;
			}
			return 0;
		}

		function numberOfBytes(base64String) {
			return (base64String.length / 4) * 3 - paddingSize(base64String);
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').directive('maxbytes', maxbytes);

	function maxbytes() {
		var directive = {
			restrict: 'A',
			require: '?ngModel',
			link: linkFunc,
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return;
			}

			ngModel.$validators.maxbytes = function(modelValue) {
				return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
			};
		}

		function endsWith(suffix, str) {
			return str.indexOf(suffix, str.length - suffix.length) !== -1;
		}

		function paddingSize(base64String) {
			if (endsWith('==', base64String)) {
				return 2;
			}
			if (endsWith('=', base64String)) {
				return 1;
			}
			return 0;
		}

		function numberOfBytes(base64String) {
			return (base64String.length / 4) * 3 - paddingSize(base64String);
		}
	}
})();

/** @format */

'use strict';

angular.module('emsApp').directive('datepickerLocaldate', [
	'$parse',
	function($parse) {
		var directive = {
			restrict: 'A, E',
			require: ['ngModel'],
			link: link,
		};
		return directive;

		function link(scope, element, attr, ctrls) {
			var ngModelController = ctrls[0];

			// called with a JavaScript Date object when picked from the datepicker
			ngModelController.$parsers.push(function(viewValue) {
				// 2018-03-12 Marco: jhipster4 did not check at all if the viewValue was undefined or null.
				if (viewValue === null || viewValue === undefined) {
					return null;
				}
				// undo the timezone adjustment we did during the formatting
				viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
				// we just want a local date in ISO format
				return viewValue.toISOString().substring(0, 10);
			});

			// called with a 'yyyy-mm-dd' string to format
			ngModelController.$formatters.push(function(modelValue) {
				if (!modelValue) {
					return undefined;
				}
				// date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
				var dt = new Date(modelValue);
				// 'undo' the timezone offset again (so we end up on the original date again)
				dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
				return dt;
			});
		}
	},
]);

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('VatFactory', function($resource) {
	return $resource(
		'api/vats/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/**
 * Factory to search / retrieve an array of UserVatListDto's
 */
angular.module('emsApp').factory('UserVatListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/vat',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewVatFactory', function($resource) {
	return $resource(
		'api/vats/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Vats without the use of paging
angular.module('emsApp').factory('NoPagingVatFactory', function($resource) {
	return $resource(
		'api/vats/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible VatTypes Enum values without the use of paging
angular.module('emsApp').factory('NoPagingVatTypeFactory', function($resource) {
	return $resource(
		'api/vat/vatTypes',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllVatsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/vats/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('usersOverviewMappedByUsertype', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/user/user-tab.html',
		controller: 'UserTabController',
		scope: {
			userTypeId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('UserTypeFactory', function($resource) {
	return $resource(
		'api/userTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewUserTypeFactory', function($resource) {
	return $resource(
		'api/userTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all UserTypes without the use of paging
angular.module('emsApp').factory('NoPagingUserTypeFactory', function($resource) {
	return $resource(
		'api/userTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible PredefinedUserTypes Enum values without the use of paging
angular.module('emsApp').factory('NoPagingPredefinedUserTypeFactory', function($resource) {
	return $resource(
		'api/userType/predefinedUserTypes',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('UsersByUserTypeFactory', function($resource) {
	return $resource(
		'api/users/userType/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllUserTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/userTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllUserTypesByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/userTypesNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

'use strict';

// This factory was generated by MetaFactory pattern, but modified later. Generation is disabled and unused factories
// were removed. The NoPagingUserFactory is in the Relation functionality where you can search by account manager
// which is a user.userType
//Get all Users without the use of paging
angular.module('emsApp').factory('NoPagingUserFactory', function($resource) {
	return $resource('api/users/nopaging', {}, {
		'query' : {
			method : 'GET',
			isArray : true
		}
	});
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('eventsOverviewMappedByTemplateevent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/event/event-tab.html',
		controller: 'EventTabController',
		scope: {
			templateEventId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userEventMappedByTemplateEvent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/event/event-list-user.tab.html',
		controller: 'UserEventListDtoTabController',
		scope: {
			templateEventId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('salesfiltertemplateeventsOverviewMappedByTemplateevent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-tab.html',
		controller: 'SalesFilterTemplateEventTabController',
		scope: {
			templateEventId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userSalesFilterTemplateEventMappedByTemplateEvent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-list-user.tab.html',
		controller: 'UserSalesFilterTemplateEventListDtoTabController',
		scope: {
			templateEventId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('TemplateEventFactory', function($resource) {
	return $resource(
		'api/templateEvents/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/* A custom hook can be implemented here custom/jhipster/factory/create_custom_edit_factory.ftl */
/**
 * Factory to get / update an instance of UserTemplateEventEditDto
 */
angular.module('emsApp').factory('UserTemplateEventEditDtoFactory', function($resource) {
	return $resource(
		'api/user/templateevent/edit/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/*
 * Factory to fetch a new object of UserTemplateEventEditDto
 * with defaults from server
 */
angular.module('emsApp').factory('UserTemplateEventNewDtoFactory', function($resource) {
	return $resource(
		'api/user/templateevent/edit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewTemplateEventFactory', function($resource) {
	return $resource(
		'api/templateEvents/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all TemplateEvents without the use of paging
angular.module('emsApp').factory('NoPagingTemplateEventFactory', function($resource) {
	return $resource(
		'api/templateEvents/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by defaultdriver
angular.module('emsApp').factory('TemplateEventFindArticleFilteredByDefaultDriverFactory', function($resource) {
	return $resource(
		'api/templateevents/article/filteredby/defaultdriver',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by defaultseconddriver
angular.module('emsApp').factory('TemplateEventFindArticleFilteredByDefaultSecondDriverFactory', function($resource) {
	return $resource(
		'api/templateevents/article/filteredby/defaultseconddriver',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by defaultspectator
angular.module('emsApp').factory('TemplateEventFindArticleFilteredByDefaultSpectatorFactory', function($resource) {
	return $resource(
		'api/templateevents/article/filteredby/defaultspectator',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by defaultinsurance
angular.module('emsApp').factory('TemplateEventFindArticleFilteredByDefaultInsuranceFactory', function($resource) {
	return $resource(
		'api/templateevents/article/filteredby/defaultinsurance',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by defaulthotel
angular.module('emsApp').factory('TemplateEventFindArticleFilteredByDefaultHotelFactory', function($resource) {
	return $resource(
		'api/templateevents/article/filteredby/defaulthotel',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by defaultfuel
angular.module('emsApp').factory('TemplateEventFindArticleFilteredByDefaultFuelFactory', function($resource) {
	return $resource(
		'api/templateevents/article/filteredby/defaultfuel',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by defaultinstruction
angular.module('emsApp').factory('TemplateEventFindArticleFilteredByDefaultInstructionFactory', function($resource) {
	return $resource(
		'api/templateevents/article/filteredby/defaultinstruction',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('EventsByTemplateEventFactory', function($resource) {
	return $resource(
		'api/events/templateEvent/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SalesFilterTemplateEventsByTemplateEventFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/templateEvent/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//The factory for getting the picklist options
angular.module('emsApp').factory('SalesFilterFromSalesFilterTemplateEventPicklistUpdateFactory', function($resource) {
	return $resource(
		'/api/salesFilterTemplateEventList/AsSalesFilterList/templateEvent/:id',
		{},
		{
			update: { method: 'PUT', isArray: false },
		}
	);
});

angular.module('emsApp').factory('FindAllTemplateEventsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/templateEvents/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllTemplateEventsByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/templateEventsNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('orderlinesOverviewMappedBySubscription', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/orderline/orderline-tab.html',
		controller: 'OrderLineTabController',
		scope: {
			subscriptionId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('SubscriptionFactory', function($resource) {
	return $resource(
		'api/subscriptions/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewSubscriptionFactory', function($resource) {
	return $resource(
		'api/subscriptions/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Subscriptions without the use of paging
angular.module('emsApp').factory('NoPagingSubscriptionFactory', function($resource) {
	return $resource(
		'api/subscriptions/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible SubscriptionTypes Enum values without the use of paging
angular.module('emsApp').factory('NoPagingSubscriptionTypeFactory', function($resource) {
	return $resource(
		'api/subscription/subscriptionTypes',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible SubscriptionStatuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingSubscriptionStatusFactory', function($resource) {
	return $resource(
		'api/subscription/subscriptionStatuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by driver
angular.module('emsApp').factory('SubscriptionFindArticleFilteredByDriverFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/driver',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by seconddriver
angular.module('emsApp').factory('SubscriptionFindArticleFilteredBySecondDriverFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/seconddriver',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by spectator
angular.module('emsApp').factory('SubscriptionFindArticleFilteredBySpectatorFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/spectator',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by insurance
angular.module('emsApp').factory('SubscriptionFindArticleFilteredByInsuranceFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/insurance',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by hotel
angular.module('emsApp').factory('SubscriptionFindArticleFilteredByHotelFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/hotel',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by fuel
angular.module('emsApp').factory('SubscriptionFindArticleFilteredByFuelFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/fuel',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by rentalcar
angular.module('emsApp').factory('SubscriptionFindArticleFilteredByRentalCarFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/rentalcar',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by instruction
angular.module('emsApp').factory('SubscriptionFindArticleFilteredByInstructionFactory', function($resource) {
	return $resource(
		'api/subscriptions/article/filteredby/instruction',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('OrderLinesBySubscriptionFactory', function($resource) {
	return $resource(
		'api/orderLines/subscription/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllSubscriptionsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/subscriptions/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all Subscriptions by booking ID and subscription type without the use of paging
angular.module('emsApp').factory('NoPagingSubscriptionByBookingAndSubscriptionTypeFactory', function($resource) {
	return $resource(
		'api/subscriptions/booking/:bookingId/subscriptiontype/:subscriptionType',
		{},
		{
			query: {
				method: 'GET',
				isArray: true,
			},
		}
	);
});

//Get all subscriptions by booking ID without paging
angular.module('emsApp').factory('NoPagingSubscriptionByBookingFactory', function($resource) {
	return $resource(
		'api/subscriptions/booking/:bookingId',
		{},
		{
			query: {
				method: 'GET',
				isArray: true,
			},
		}
	);
});

// Delete a driver plus all related second drivers and spectators (via relationOf), and the booking (if it has no more subscriptions)
angular.module('emsApp').factory('DriverFactory', function($resource) {
	return $resource(
		'api/subscriptions/:id/booking/:bookingId',
		{},
		{
			deleteDriver: {
				method: 'DELETE',
			},
		}
	);
});

angular.module('emsApp').factory('SubscriptionSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/subscriptions/createandnew/:id',
		{},
		{
			saveAndCreate: { method: 'POST' },
			updateAndCreate: { method: 'PUT' },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('SalesFilterTemplateEventFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/**
 * Factory to get or delete an instance of UserSalesFilterTemplateEventViewDto
 */
angular.module('emsApp').factory('UserSalesFilterTemplateEventViewDtoFactory', function($resource) {
	return $resource(
		'api/user/salesfiltertemplateevent/:id',
		{},
		{
			// Factory is only used to delete a UserSalesFilterTemplateEventViewDto
		}
	);
});
/**
 * Factory to search / retrieve an array of UserSalesFilterTemplateEventListDto's
 */
angular.module('emsApp').factory('UserSalesFilterTemplateEventListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/salesfiltertemplateevent',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewSalesFilterTemplateEventFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all SalesFilterTemplateEvents without the use of paging
angular.module('emsApp').factory('NoPagingSalesFilterTemplateEventFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllSalesFilterTemplateEventsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/salesFilterTemplateEvents/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('SalesFilterEventTypeFactory', function($resource) {
	return $resource(
		'api/salesFilterEventTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/**
 * Factory to get or delete an instance of UserSalesFilterEventTypeViewDto
 */
angular.module('emsApp').factory('UserSalesFilterEventTypeViewDtoFactory', function($resource) {
	return $resource(
		'api/user/salesfiltereventtype/:id',
		{},
		{
			// Factory is only used to delete a UserSalesFilterEventTypeViewDto
		}
	);
});
/**
 * Factory to search / retrieve an array of UserSalesFilterEventTypeListDto's
 */
angular.module('emsApp').factory('UserSalesFilterEventTypeListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/salesfiltereventtype',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewSalesFilterEventTypeFactory', function($resource) {
	return $resource(
		'api/salesFilterEventTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all SalesFilterEventTypes without the use of paging
angular.module('emsApp').factory('NoPagingSalesFilterEventTypeFactory', function($resource) {
	return $resource(
		'api/salesFilterEventTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllSalesFilterEventTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/salesFilterEventTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('salesfiltereventtypesOverviewMappedBySalesfilter', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-tab.html',
		controller: 'SalesFilterEventTypeTabController',
		scope: {
			salesFilterId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userSalesFilterEventTypeMappedBySalesFilter', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-list-user.tab.html',
		controller: 'UserSalesFilterEventTypeListDtoTabController',
		scope: {
			salesFilterId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('salesfiltertemplateeventsOverviewMappedBySalesfilter', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-tab.html',
		controller: 'SalesFilterTemplateEventTabController',
		scope: {
			salesFilterId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userSalesFilterTemplateEventMappedBySalesFilter', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltertemplateevent/salesfiltertemplateevent-list-user.tab.html',
		controller: 'UserSalesFilterTemplateEventListDtoTabController',
		scope: {
			salesFilterId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('SalesFilterFactory', function($resource) {
	return $resource(
		'api/salesFilters/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/**
 * Factory to get or delete an instance of UserSalesFilterViewDto
 */
angular.module('emsApp').factory('UserSalesFilterViewDtoFactory', function($resource) {
	return $resource(
		'api/user/salesfilter/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});
/**
 * Factory to search / retrieve an array of UserSalesFilterListDto's
 */
angular.module('emsApp').factory('UserSalesFilterListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/salesfilter',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

/* A custom hook can be implemented here custom/jhipster/factory/create_custom_edit_factory.ftl */
/**
 * Factory to get / update an instance of UserSalesFilterEditDto
 */
angular.module('emsApp').factory('UserSalesFilterEditDtoFactory', function($resource) {
	return $resource(
		'api/user/salesfilter/edit/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/*
 * Factory to fetch a new object of UserSalesFilterEditDto
 * with defaults from server
 */
angular.module('emsApp').factory('UserSalesFilterNewDtoFactory', function($resource) {
	return $resource(
		'api/user/salesfilter/edit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewSalesFilterFactory', function($resource) {
	return $resource(
		'api/salesFilters/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all SalesFilters without the use of paging
angular.module('emsApp').factory('NoPagingSalesFilterFactory', function($resource) {
	return $resource(
		'api/salesFilters/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible SalesStatuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingSalesStatusFactory', function($resource) {
	return $resource(
		'api/salesFilter/salesStatuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SalesFilterEventTypesBySalesFilterFactory', function($resource) {
	return $resource(
		'api/salesFilterEventTypes/salesFilter/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//The factory for getting the picklist options
angular.module('emsApp').factory('EventTypeFromSalesFilterEventTypePicklistUpdateFactory', function($resource) {
	return $resource(
		'/api/salesFilterEventTypeList/AsEventTypeList/salesFilter/:id',
		{},
		{
			update: { method: 'PUT', isArray: false },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SalesFilterTemplateEventsBySalesFilterFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/salesFilter/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//The factory for getting the picklist options
angular.module('emsApp').factory('TemplateEventFromSalesFilterTemplateEventPicklistUpdateFactory', function($resource) {
	return $resource(
		'/api/salesFilterTemplateEventList/AsTemplateEventList/salesFilter/:id',
		{},
		{
			update: { method: 'PUT', isArray: false },
		}
	);
});

angular.module('emsApp').factory('FindAllSalesFiltersByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/salesFilters/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('RelationMailGroupFactory', function($resource) {
	return $resource(
		'api/relationMailGroups/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewRelationMailGroupFactory', function($resource) {
	return $resource(
		'api/relationMailGroups/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all RelationMailGroups without the use of paging
angular.module('emsApp').factory('NoPagingRelationMailGroupFactory', function($resource) {
	return $resource(
		'api/relationMailGroups/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllRelationMailGroupsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/relationMailGroups/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('relationmailgroupsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/relationmailgroup/relationmailgroup-tab.html',
		controller: 'RelationMailGroupTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('bookingsOverviewMappedByClient', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/booking/booking-tab.html',
		controller: 'BookingTabController',
		scope: {
			clientId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('carsOverviewMappedByOwner', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/car/car-tab.html',
		controller: 'CarTabController',
		scope: {
			ownerId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('subscriptionsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/subscription/subscription-tab.html',
		controller: 'SubscriptionTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('documentsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/document/document-tab.html',
		controller: 'DocumentTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('instructorsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/instructor/instructor-tab.html',
		controller: 'InstructorTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('eventrelationcontactsOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-tab.html',
		controller: 'EventRelationContactTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userEventRelationContactMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-list-user.tab.html',
		controller: 'UserEventRelationContactListDtoTabController',
		scope: {
			relationId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('articlerelationpricesOverviewMappedByRelation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/articlerelationprice/articlerelationprice-tab.html',
		controller: 'ArticleRelationPriceTabController',
		scope: {
			relationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('RelationFactory', function($resource) {
	return $resource(
		'api/relations/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/**
 * Factory to get or delete an instance of UserRelationViewDto
 */
angular.module('emsApp').factory('UserRelationViewDtoFactory', function($resource) {
	return $resource(
		'api/user/relation/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});
/**
 * Factory to search / retrieve an array of UserRelationListDto's
 */
angular.module('emsApp').factory('UserRelationListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/relation',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

/* A custom hook can be implemented here custom/jhipster/factory/create_custom_edit_factory.ftl */
/**
 * Factory to get / update an instance of UserRelationEditDto
 */
angular.module('emsApp').factory('UserRelationEditDtoFactory', function($resource) {
	return $resource(
		'api/user/relation/edit/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/*
 * Factory to fetch a new object of UserRelationEditDto
 * with defaults from server
 */
angular.module('emsApp').factory('UserRelationNewDtoFactory', function($resource) {
	return $resource(
		'api/user/relation/edit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/*
 * Factory to fetch a new object of UserRelationEditDto
 * without defaults from server, to use in bulkedit
 */
angular.module('emsApp').factory('UserRelationNewBulkEditDtoFactory', function($resource) {
	return $resource(
		'api/user/relation/bulkedit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/**
 * Factory to bulkupdate an instance of UserRelationEditDto
 */
angular.module('emsApp').factory('UserRelationBulkEditDtoFactory', function($resource) {
	return $resource(
		'api/user/relation/bulkedit',
		{},
		{
			update: {
				method: 'PUT',
			},
		}
	);
});

/**
 * Factory to save a new object of UserRelationEditDto
 * and returns a copy to create another one.
 */
angular.module('emsApp').factory('UserRelationEditDtoSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/user/relation/saveandnew',
		{},
		{
			createAndNew: {
				method: 'POST',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			updateAndNew: {
				method: 'PUT',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewRelationFactory', function($resource) {
	return $resource(
		'api/relations/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Relations without the use of paging
angular.module('emsApp').factory('NoPagingRelationFactory', function($resource) {
	return $resource(
		'api/relations/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible RelationTypes Enum values without the use of paging
angular.module('emsApp').factory('NoPagingRelationTypeFactory', function($resource) {
	return $resource(
		'api/relation/relationTypes',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible RelationSources Enum values without the use of paging
angular.module('emsApp').factory('NoPagingRelationSourceFactory', function($resource) {
	return $resource(
		'api/relation/relationSources',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible Genders Enum values without the use of paging
angular.module('emsApp').factory('NoPagingGenderFactory', function($resource) {
	return $resource(
		'api/relation/genders',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible ClientsOf Enum values without the use of paging
angular.module('emsApp').factory('NoPagingClientOfFactory', function($resource) {
	return $resource(
		'api/relation/clientsOf',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all users filtered by accountmanager
angular.module('emsApp').factory('RelationFindUserFilteredByAccountManagerFactory', function($resource) {
	return $resource(
		'api/relations/user/filteredby/accountmanager',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible LangKeys Enum values without the use of paging
angular.module('emsApp').factory('NoPagingLangKeyFactory', function($resource) {
	return $resource(
		'api/relation/langKeys',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('RelationMailGroupsByRelationFactory', function($resource) {
	return $resource(
		'api/relationMailGroups/relation/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//The factory for getting the picklist options
angular.module('emsApp').factory('MailGroupFromRelationMailGroupPicklistUpdateFactory', function($resource) {
	return $resource(
		'/api/relationMailGroupList/AsMailGroupList/relation/:id',
		{},
		{
			update: { method: 'PUT', isArray: false },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('BookingsByClientFactory', function($resource) {
	return $resource(
		'api/bookings/client/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('CarsByOwnerFactory', function($resource) {
	return $resource(
		'api/cars/owner/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SubscriptionsByRelationFactory', function($resource) {
	return $resource(
		'api/subscriptions/relation/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('DocumentsByRelationFactory', function($resource) {
	return $resource(
		'api/documents/relation/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('InstructorsByRelationFactory', function($resource) {
	return $resource(
		'api/instructors/relation/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('EventRelationContactsByRelationFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/relation/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('ArticleRelationPricesByRelationFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/relation/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllRelationsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/relations/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('AutocompleteRelationsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/autocomplete/relations/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('AutocompleteUserRelationsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/user/autocomplete/relations',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('RelationSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/relations/createandnew/:id',
		{},
		{
			saveAndCreate: { method: 'POST' },
			updateAndCreate: { method: 'PUT' },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('OrderLineFactory', function($resource) {
	return $resource(
		'api/orderLines/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewOrderLineFactory', function($resource) {
	return $resource(
		'api/orderLines/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all OrderLines without the use of paging
angular.module('emsApp').factory('NoPagingOrderLineFactory', function($resource) {
	return $resource(
		'api/orderLines/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible OrderLineOrigins Enum values without the use of paging
angular.module('emsApp').factory('NoPagingOrderLineOriginFactory', function($resource) {
	return $resource(
		'api/orderLine/orderLineOrigins',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllOrderLinesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/orderLines/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('relationmailgroupsOverviewMappedByMailgroup', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/relationmailgroup/relationmailgroup-tab.html',
		controller: 'RelationMailGroupTabController',
		scope: {
			mailGroupId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('MailGroupFactory', function($resource) {
	return $resource(
		'api/mailGroups/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewMailGroupFactory', function($resource) {
	return $resource(
		'api/mailGroups/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all MailGroups without the use of paging
angular.module('emsApp').factory('NoPagingMailGroupFactory', function($resource) {
	return $resource(
		'api/mailGroups/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('RelationMailGroupsByMailGroupFactory', function($resource) {
	return $resource(
		'api/relationMailGroups/mailGroup/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//The factory for getting the picklist options
angular.module('emsApp').factory('RelationFromRelationMailGroupPicklistUpdateFactory', function($resource) {
	return $resource(
		'/api/relationMailGroupList/AsRelationList/mailGroup/:id',
		{},
		{
			update: { method: 'PUT', isArray: false },
		}
	);
});

angular.module('emsApp').factory('FindAllMailGroupsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/mailGroups/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllMailGroupsByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/mailGroupsNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('LocationTemplateEventArticleFactory', function($resource) {
	return $resource(
		'api/locationTemplateEventArticles/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewLocationTemplateEventArticleFactory', function($resource) {
	return $resource(
		'api/locationTemplateEventArticles/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all LocationTemplateEventArticles without the use of paging
angular.module('emsApp').factory('NoPagingLocationTemplateEventArticleFactory', function($resource) {
	return $resource(
		'api/locationTemplateEventArticles/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible PredefinedArticleTypes Enum values without the use of paging
angular.module('emsApp').factory('NoPagingPredefinedArticleTypeFactory', function($resource) {
	return $resource(
		'api/locationTemplateEventArticle/predefinedArticleTypes',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by article
angular.module('emsApp').factory('LocationTemplateEventArticleFindArticleFilteredByArticleFactory', function($resource) {
	return $resource(
		'api/locationtemplateeventarticles/article/filteredby/article',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllLocationTemplateEventArticlesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/locationTemplateEventArticles/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('eventsOverviewMappedByLocation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/event/event-tab.html',
		controller: 'EventTabController',
		scope: {
			locationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userEventMappedByLocation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/event/event-list-user.tab.html',
		controller: 'UserEventListDtoTabController',
		scope: {
			locationId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('documentsOverviewMappedByLocation', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/document/document-tab.html',
		controller: 'DocumentTabController',
		scope: {
			locationId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('LocationFactory', function($resource) {
	return $resource(
		'api/locations/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/* A custom hook can be implemented here custom/jhipster/factory/create_custom_edit_factory.ftl */
/**
 * Factory to get / update an instance of UserLocationEditDto
 */
angular.module('emsApp').factory('UserLocationEditDtoFactory', function($resource) {
	return $resource(
		'api/user/location/edit/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/*
 * Factory to fetch a new object of UserLocationEditDto
 * with defaults from server
 */
angular.module('emsApp').factory('UserLocationNewDtoFactory', function($resource) {
	return $resource(
		'api/user/location/edit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewLocationFactory', function($resource) {
	return $resource(
		'api/locations/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Locations without the use of paging
angular.module('emsApp').factory('NoPagingLocationFactory', function($resource) {
	return $resource(
		'api/locations/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('EventsByLocationFactory', function($resource) {
	return $resource(
		'api/events/location/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('DocumentsByLocationFactory', function($resource) {
	return $resource(
		'api/documents/location/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllLocationsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/locations/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('subscriptionsOverviewMappedByInstructor', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/subscription/subscription-tab.html',
		controller: 'SubscriptionTabController',
		scope: {
			instructorId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('InstructorFactory', function($resource) {
	return $resource(
		'api/instructors/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewInstructorFactory', function($resource) {
	return $resource(
		'api/instructors/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Instructors without the use of paging
angular.module('emsApp').factory('NoPagingInstructorFactory', function($resource) {
	return $resource(
		'api/instructors/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by hotel
angular.module('emsApp').factory('InstructorFindArticleFilteredByHotelFactory', function($resource) {
	return $resource(
		'api/instructors/article/filteredby/hotel',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible SubscriptionStatuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingSubscriptionStatusFactory', function($resource) {
	return $resource(
		'api/instructor/subscriptionStatuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SubscriptionsByInstructorFactory', function($resource) {
	return $resource(
		'api/subscriptions/instructor/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllInstructorsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/instructors/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all instructors for an event by booking ID without paging
angular.module('emsApp').factory('NoPagingInstructorByBookingFactory', function($resource) {
	return $resource(
		'api/instructors/booking/:bookingId',
		{},
		{
			query: {
				method: 'GET',
				isArray: true,
			},
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('templateeventsOverviewMappedByEventtype', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/templateevent/templateevent-tab.html',
		controller: 'TemplateEventTabController',
		scope: {
			eventTypeId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('salesfiltereventtypesOverviewMappedByEventtype', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-tab.html',
		controller: 'SalesFilterEventTypeTabController',
		scope: {
			eventTypeId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userSalesFilterEventTypeMappedByEventType', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/salesfiltereventtype/salesfiltereventtype-list-user.tab.html',
		controller: 'UserSalesFilterEventTypeListDtoTabController',
		scope: {
			eventTypeId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('EventTypeFactory', function($resource) {
	return $resource(
		'api/eventTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewEventTypeFactory', function($resource) {
	return $resource(
		'api/eventTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all EventTypes without the use of paging
angular.module('emsApp').factory('NoPagingEventTypeFactory', function($resource) {
	return $resource(
		'api/eventTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('TemplateEventsByEventTypeFactory', function($resource) {
	return $resource(
		'api/templateEvents/eventType/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SalesFilterEventTypesByEventTypeFactory', function($resource) {
	return $resource(
		'api/salesFilterEventTypes/eventType/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//The factory for getting the picklist options
angular.module('emsApp').factory('SalesFilterFromSalesFilterEventTypePicklistUpdateFactory', function($resource) {
	return $resource(
		'/api/salesFilterEventTypeList/AsSalesFilterList/eventType/:id',
		{},
		{
			update: { method: 'PUT', isArray: false },
		}
	);
});

angular.module('emsApp').factory('FindAllEventTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/eventTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllEventTypesByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/eventTypesNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('EventRelationContactFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/**
 * Factory to search / retrieve an array of UserEventRelationContactListDto's
 */
angular.module('emsApp').factory('UserEventRelationContactListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/eventrelationcontact',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewEventRelationContactFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all EventRelationContacts without the use of paging
angular.module('emsApp').factory('NoPagingEventRelationContactFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible SalesStatuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingSalesStatusFactory', function($resource) {
	return $resource(
		'api/eventRelationContact/salesStatuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllEventRelationContactsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/eventRelationContacts/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('bookingsOverviewMappedByEvent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/booking/booking-tab.html',
		controller: 'BookingTabController',
		scope: {
			eventId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('documentsOverviewMappedByEvent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/document/document-tab.html',
		controller: 'DocumentTabController',
		scope: {
			eventId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('instructorsOverviewMappedByEvent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/instructor/instructor-tab.html',
		controller: 'InstructorTabController',
		scope: {
			eventId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('eventrelationcontactsOverviewMappedByEvent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-tab.html',
		controller: 'EventRelationContactTabController',
		scope: {
			eventId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userEventRelationContactMappedByEvent', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-list-user.tab.html',
		controller: 'UserEventRelationContactListDtoTabController',
		scope: {
			eventId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('EventFactory', function($resource) {
	return $resource(
		'api/events/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/**
 * Factory to get or delete an instance of UserEventViewDto
 */
angular.module('emsApp').factory('UserEventViewDtoFactory', function($resource) {
	return $resource(
		'api/user/event/:id',
		{},
		{
			// Factory is only used to delete a UserEventViewDto
		}
	);
});
/**
 * Factory to search / retrieve an array of UserEventListDto's
 */
angular.module('emsApp').factory('UserEventListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/event',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

/* A custom hook can be implemented here custom/jhipster/factory/create_custom_edit_factory.ftl */
/**
 * Factory to get / update an instance of UserEventEditDto
 */
angular.module('emsApp').factory('UserEventEditDtoFactory', function($resource) {
	return $resource(
		'api/user/event/edit/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/*
 * Factory to fetch a new object of UserEventEditDto
 * with defaults from server
 */
angular.module('emsApp').factory('UserEventNewDtoFactory', function($resource) {
	return $resource(
		'api/user/event/edit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/**
 * Factory to save a new object of UserEventEditDto
 * and returns a copy to create another one.
 */
angular.module('emsApp').factory('UserEventEditDtoSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/user/event/saveandnew',
		{},
		{
			createAndNew: {
				method: 'POST',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			updateAndNew: {
				method: 'PUT',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewEventFactory', function($resource) {
	return $resource(
		'api/events/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Events without the use of paging
angular.module('emsApp').factory('NoPagingEventFactory', function($resource) {
	return $resource(
		'api/events/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible Statuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingEventStatusFactory', function($resource) {
	return $resource(
		'api/event/statuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('BookingsByEventFactory', function($resource) {
	return $resource(
		'api/bookings/event/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('DocumentsByEventFactory', function($resource) {
	return $resource(
		'api/documents/event/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('InstructorsByEventFactory', function($resource) {
	return $resource(
		'api/instructors/event/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('EventRelationContactsByEventFactory', function($resource) {
	return $resource(
		'api/eventRelationContacts/event/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllEventsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/events/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('AutocompleteEventsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/autocomplete/events/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('AutocompleteUserEventsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/user/autocomplete/events',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// Get all Subscriptions per Booking for an Event
angular.module('emsApp').factory('EventSubscriptionsFactory', function($resource) {
	return $resource(
		'api/events/:id/subscriptions',
		{},
		{
			query: {
				method: 'GET',
				isArray: true,
			},
		}
	);
});

// update info / after mail for all subscriptions of an event
angular.module('emsApp').factory('EventSubscriptionsMailUpdateFactory', function($resource) {
	return {
		updateInfoMail: function(currentEventId) {
			return $resource(
				'api/events/:eventId/subscriptions/infoMail',
				{ eventId: currentEventId },
				{
					update: {
						method: 'GET',
						isArray: true,
					},
				}
			);
		},
		updateAfterMail: function(currentEventId) {
			return $resource(
				'api/events/:eventId/subscriptions/afterMail',
				{ eventId: currentEventId },
				{
					update: {
						method: 'GET',
						isArray: true,
					},
				}
			);
		},
	};
});

// Get all Subscriptions for a Booking of an Event
angular.module('emsApp').factory('BookingSubscriptionsFactory', function($resource) {
	return $resource(
		'api/booking/:bookingId/subscriptions',
		{},
		{
			query: {
				method: 'GET',
				isArray: true,
			},
		}
	);
});

angular.module('emsApp').factory('EventSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/events/createandnew/:id',
		{},
		{
			saveAndCreate: { method: 'POST' },
			updateAndCreate: { method: 'PUT' },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('DocumentTypeFactory', function($resource) {
	return $resource(
		'api/documentTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewDocumentTypeFactory', function($resource) {
	return $resource(
		'api/documentTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all DocumentTypes without the use of paging
angular.module('emsApp').factory('NoPagingDocumentTypeFactory', function($resource) {
	return $resource(
		'api/documentTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllDocumentTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/documentTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';
angular.module('emsApp').service('DocumentDownloadService', function(DocumentDownloadFactory, GetHeaderFilename, FileDownloadError) {
	return function(id) {
		console.log('downloading requested file...');
		DocumentDownloadFactory.download({ id: id })
			.$promise.then(function(result) {
				var url = URL.createObjectURL(new Blob([result.data]));
				var a = document.createElement('a');
				console.log(result.headerData);
				a.href = url;
				a.download = GetHeaderFilename(result.headerData);
				a.target = '_blank';
				a.click();
			})
			.catch(FileDownloadError)
			.catch(function(error) {
				console.log(error.data); // in JSON
			});
	};
});

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('DocumentFactory', function($resource) {
	return $resource(
		'api/documents/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewDocumentFactory', function($resource) {
	return $resource(
		'api/documents/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Documents without the use of paging
angular.module('emsApp').factory('NoPagingDocumentFactory', function($resource) {
	return $resource(
		'api/documents/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllDocumentsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/documents/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('DocumentDownloadFactory', function($resource) {
	return $resource(
		'api/documents/download/:id',
		{},
		{
			download: {
				method: 'GET',
				responseType: 'arraybuffer',
				transformResponse: function(data, headers) {
					console.log(headers);
					return {
						data: data,
						headerData: headers('content-disposition'),
					};
				},
			},
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('CountryFactory', function($resource) {
	return $resource(
		'api/countries/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/**
 * Factory to search / retrieve an array of UserCountryListDto's
 */
angular.module('emsApp').factory('UserCountryListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/country',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewCountryFactory', function($resource) {
	return $resource(
		'api/countries/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Countries without the use of paging
angular.module('emsApp').factory('NoPagingCountryFactory', function($resource) {
	return $resource(
		'api/countries/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCountriesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/countries/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('CompanyTypeFactory', function($resource) {
	return $resource(
		'api/companyTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewCompanyTypeFactory', function($resource) {
	return $resource(
		'api/companyTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all CompanyTypes without the use of paging
angular.module('emsApp').factory('NoPagingCompanyTypeFactory', function($resource) {
	return $resource(
		'api/companyTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCompanyTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/companyTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCompanyTypesByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/companyTypesNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('CarRentalTypeTemplateEventArticleFactory', function($resource) {
	return $resource(
		'api/carRentalTypeTemplateEventArticles/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewCarRentalTypeTemplateEventArticleFactory', function($resource) {
	return $resource(
		'api/carRentalTypeTemplateEventArticles/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all CarRentalTypeTemplateEventArticles without the use of paging
angular.module('emsApp').factory('NoPagingCarRentalTypeTemplateEventArticleFactory', function($resource) {
	return $resource(
		'api/carRentalTypeTemplateEventArticles/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by articleforrental
angular.module('emsApp').factory('CarRentalTypeTemplateEventArticleFindArticleFilteredByArticleForRentalFactory', function($resource) {
	return $resource(
		'api/carrentaltypetemplateeventarticles/article/filteredby/articleforrental',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCarRentalTypeTemplateEventArticlesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/carRentalTypeTemplateEventArticles/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('carsOverviewMappedByCarrentaltype', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/car/car-tab.html',
		controller: 'CarTabController',
		scope: {
			carRentalTypeId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('CarRentalTypeFactory', function($resource) {
	return $resource(
		'api/carRentalTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewCarRentalTypeFactory', function($resource) {
	return $resource(
		'api/carRentalTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all CarRentalTypes without the use of paging
angular.module('emsApp').factory('NoPagingCarRentalTypeFactory', function($resource) {
	return $resource(
		'api/carRentalTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('CarsByCarRentalTypeFactory', function($resource) {
	return $resource(
		'api/cars/carRentalType/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCarRentalTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/carRentalTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCarRentalTypesByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/carRentalTypesNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('subscriptionsOverviewMappedByCar', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/subscription/subscription-tab.html',
		controller: 'SubscriptionTabController',
		scope: {
			carId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('documentsOverviewMappedByCar', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/document/document-tab.html',
		controller: 'DocumentTabController',
		scope: {
			carId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('CarFactory', function($resource) {
	return $resource(
		'api/cars/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewCarFactory', function($resource) {
	return $resource(
		'api/cars/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Cars without the use of paging
angular.module('emsApp').factory('NoPagingCarFactory', function($resource) {
	return $resource(
		'api/cars/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by articleforrental
angular.module('emsApp').factory('CarFindArticleFilteredByArticleForRentalFactory', function($resource) {
	return $resource(
		'api/cars/article/filteredby/articleforrental',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SubscriptionsByCarFactory', function($resource) {
	return $resource(
		'api/subscriptions/car/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('DocumentsByCarFactory', function($resource) {
	return $resource(
		'api/documents/car/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCarsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/cars/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('AutocompleteCarsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/autocomplete/cars/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('CarSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/cars/createandnew/:id',
		{},
		{
			saveAndCreate: { method: 'POST' },
			updateAndCreate: { method: 'PUT' },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('orderlinesOverviewMappedByBooking', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/orderline/orderline-tab.html',
		controller: 'OrderLineTabController',
		scope: {
			bookingId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('subscriptionsOverviewMappedByBooking', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/subscription/subscription-tab.html',
		controller: 'SubscriptionTabController',
		scope: {
			bookingId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
			mappedByDisplayValue: '=mappedByDisplayValue',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('BookingFactory', function($resource) {
	return $resource(
		'api/bookings/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewBookingFactory', function($resource) {
	return $resource(
		'api/bookings/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Bookings without the use of paging
angular.module('emsApp').factory('NoPagingBookingFactory', function($resource) {
	return $resource(
		'api/bookings/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible BookingStatuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingBookingStatusFactory', function($resource) {
	return $resource(
		'api/booking/bookingStatuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible ConfirmationEmailStatuses Enum values without the use of paging
angular.module('emsApp').factory('NoPagingConfirmationEmailStatusFactory', function($resource) {
	return $resource(
		'api/booking/confirmationEmailStatuses',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('OrderLinesByBookingFactory', function($resource) {
	return $resource(
		'api/orderLines/booking/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SubscriptionsByBookingFactory', function($resource) {
	return $resource(
		'api/subscriptions/booking/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllBookingsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/bookings/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('AutocompleteBookingsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/autocomplete/bookings/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// Bill a booking
angular.module('emsApp').factory('BookingSnelstartFactory', function($resource) {
	return $resource(
		'api/booking/bill',
		{},
		{
			billBooking: {
				method: 'PUT',
			},
		}
	);
});

// bill all bookings for an event
angular.module('emsApp').factory('EventSnelstartFactory', function($resource) {
	return $resource(
		'api/event/bill',
		{},
		{
			billEvent: {
				method: 'PUT',
			},
		}
	);
});

angular.module('emsApp').factory('EventMailChimpFactory', function($resource) {
	return {
		syncAudience: function(id) {
			return $resource(
				'api/event/syncaudience/:id',
				{ id: id },
				{
					sync: {
						method: 'PUT',
					},
				}
			);
		},
	};
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('articlesOverviewMappedByArticletype', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/article/article-tab.html',
		controller: 'ArticleTabController',
		scope: {
			articleTypeId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});
//DTO version of directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('userArticleMappedByArticleType', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/article/article-list-user.tab.html',
		controller: 'UserArticleListDtoTabController',
		scope: {
			articleTypeId: '=mappedById',
			showCreateButtonTab: '=showCreateButtonTab',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('ArticleTypeFactory', function($resource) {
	return $resource(
		'api/articleTypes/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewArticleTypeFactory', function($resource) {
	return $resource(
		'api/articleTypes/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all ArticleTypes without the use of paging
angular.module('emsApp').factory('NoPagingArticleTypeFactory', function($resource) {
	return $resource(
		'api/articleTypes/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible PredefinedArticleTypes Enum values without the use of paging
angular.module('emsApp').factory('NoPagingPredefinedArticleTypeFactory', function($resource) {
	return $resource(
		'api/articleType/predefinedArticleTypes',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('ArticlesByArticleTypeFactory', function($resource) {
	return $resource(
		'api/articles/articleType/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllArticleTypesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/articleTypes/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllArticleTypesByQueryParamsNonPageableFactory', function($resource) {
	return $resource(
		'api/query/articleTypesNonPageable/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('ArticleRelationPriceFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewArticleRelationPriceFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all ArticleRelationPrices without the use of paging
angular.module('emsApp').factory('NoPagingArticleRelationPriceFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllArticleRelationPricesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/articleRelationPrices/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

/** @format */

'use strict';

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('orderlinesOverviewMappedByArticle', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/orderline/orderline-tab.html',
		controller: 'OrderLineTabController',
		scope: {
			articleId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

//Directive for each tabbed pane for n-relations, using 1 tab for each referenceName that is used on the other side (0..1 and 1..1 multiplicity) of the n-relation
//For example: Relation might have a reference to car, but from the other side car has a relation to Relation in two ways: as owner and as reseller. Both need a tab.
angular.module('emsApp').directive('articlerelationpricesOverviewMappedByArticle', function() {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'app/entities/articlerelationprice/articlerelationprice-tab.html',
		controller: 'ArticleRelationPriceTabController',
		scope: {
			articleId: '=mappedById',
			mappedBy: '=mappedBy',
			mappedByType: '=mappedByType',
			mappedById: '=mappedById',
		},
	};
});

/** @format */

'use strict';

/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('ArticleFactory', function($resource) {
	return $resource(
		'api/articles/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/**
 * Factory to get or delete an instance of UserArticleViewDto
 */
angular.module('emsApp').factory('UserArticleViewDtoFactory', function($resource) {
	return $resource(
		'api/user/article/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});
/**
 * Factory to search / retrieve an array of UserArticleListDto's
 */
angular.module('emsApp').factory('UserArticleListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/article',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

/* A custom hook can be implemented here custom/jhipster/factory/create_custom_edit_factory.ftl */
/**
 * Factory to get / update an instance of UserArticleEditDto
 */
angular.module('emsApp').factory('UserArticleEditDtoFactory', function($resource) {
	return $resource(
		'api/user/article/edit/:id',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

/*
 * Factory to fetch a new object of UserArticleEditDto
 * with defaults from server
 */
angular.module('emsApp').factory('UserArticleNewDtoFactory', function($resource) {
	return $resource(
		'api/user/article/edit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/*
 * Factory to fetch a new object of UserArticleEditDto
 * without defaults from server, to use in bulkedit
 */
angular.module('emsApp').factory('UserArticleNewBulkEditDtoFactory', function($resource) {
	return $resource(
		'api/user/article/bulkedit/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/**
 * Factory to bulkupdate an instance of UserArticleEditDto
 */
angular.module('emsApp').factory('UserArticleBulkEditDtoFactory', function($resource) {
	return $resource(
		'api/user/article/bulkedit',
		{},
		{
			update: {
				method: 'PUT',
			},
		}
	);
});

/**
 * Factory to save a new object of UserArticleEditDto
 * and returns a copy to create another one.
 */
angular.module('emsApp').factory('UserArticleEditDtoSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/user/article/saveandnew',
		{},
		{
			createAndNew: {
				method: 'POST',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			updateAndNew: {
				method: 'PUT',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewArticleFactory', function($resource) {
	return $resource(
		'api/articles/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Articles without the use of paging
angular.module('emsApp').factory('NoPagingArticleFactory', function($resource) {
	return $resource(
		'api/articles/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all possible VatTypes Enum values without the use of paging
angular.module('emsApp').factory('NoPagingVatTypeFactory', function($resource) {
	return $resource(
		'api/article/vatTypes',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('OrderLinesByArticleFactory', function($resource) {
	return $resource(
		'api/orderLines/article/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('ArticleRelationPricesByArticleFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/article/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllArticlesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/articles/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//Get all articles with booking ID without paging
angular.module('emsApp').factory('NoPagingArticleWithBookingFactory', function($resource) {
	return $resource(
		'api/articles/nopaging/booking/:bookingId',
		{},
		{
			query: {
				method: 'GET',
				isArray: true,
			},
		}
	);
});

angular.module('emsApp').factory('ArticleSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/articles/createandnew/:id',
		{},
		{
			saveAndCreate: { method: 'POST' },
			updateAndCreate: { method: 'PUT' },
		}
	);
});

/** @format */

(function() {
	'use strict';

	var jhiAlertError = {
		template:
			'<div class="alerts" ng-cloak="" role="alert">' +
			'<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
			'<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
			'</div>' +
			'</div>',
		controller: jhiAlertErrorController,
	};

	angular.module('emsApp').component('jhiAlertError', jhiAlertError);

	jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

	function jhiAlertErrorController($scope, AlertService, $rootScope, $translate) {
		var vm = this;

		vm.alerts = [];

		function addErrorAlert(message, key, data) {
			key = key ? key : message;
			vm.alerts.push(
				AlertService.add(
					{
						type: 'danger',
						msg: key,
						params: data,
						timeout: 5000,
						toast: AlertService.isToast(),
						scoped: true,
					},
					vm.alerts
				)
			);
		}

		var cleanHttpErrorListener = $rootScope.$on('emsApp.httpError', function(event, httpResponse) {
			var i;
			event.stopPropagation();
			switch (httpResponse.status) {
				// connection refused, server not reachable
				case 0:
					addErrorAlert('Server not reachable', 'error.server.not.reachable');
					break;

				case 400:
					var headers = Object.keys(httpResponse.headers())
						.filter(function(header) {
							return (
								header.indexOf('app-error', header.length - 'app-error'.length) !== -1 ||
								header.indexOf('app-params', header.length - 'app-params'.length) !== -1
							);
						})
						.sort();
					var errorHeader = httpResponse.headers(headers[0]);
					var entityKey = httpResponse.headers(headers[1]);
					if (angular.isString(errorHeader)) {
						var entityName = $translate.instant('global.menu.entities.' + entityKey);
						addErrorAlert(errorHeader, errorHeader, { entityName: entityName });
					} else if (httpResponse.data && httpResponse.data.fieldErrors) {
						for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
							var fieldError = httpResponse.data.fieldErrors[i];
							// convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
							var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
							var fieldName = $translate.instant('emsApp.' + fieldError.objectName + '.' + convertedField);
							addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, { fieldName: fieldName });
						}
					} else if (httpResponse.data && httpResponse.data.message) {
						addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
					} else {
						addErrorAlert(httpResponse.data);
					}
					break;

				case 404:
					addErrorAlert('Not found', 'error.url.not.found');
					break;

				default:
					if (httpResponse.data && httpResponse.data.message) {
						addErrorAlert(httpResponse.data.message);
					} else {
						addErrorAlert(angular.toJson(httpResponse));
					}
			}
		});

		$scope.$on('$destroy', function() {
			if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
				cleanHttpErrorListener();
				vm.alerts = [];
			}
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').provider('AlertService', AlertService);

	function AlertService() {
		this.toast = false;
		/*jshint validthis: true */
		this.$get = getService;

		this.showAsToast = function(isToast) {
			this.toast = isToast;
		};

		getService.$inject = ['$timeout', '$sce', '$translate'];

		function getService($timeout, $sce, $translate) {
			var toast = this.toast,
				alertId = 0, // unique id for each alert. Starts from 0.
				alerts = [],
				timeout = 5000; // default timeout

			return {
				factory: factory,
				isToast: isToast,
				add: addAlert,
				closeAlert: closeAlert,
				closeAlertByIndex: closeAlertByIndex,
				clear: clear,
				get: get,
				success: success,
				error: error,
				info: info,
				warning: warning,
			};

			function isToast() {
				return toast;
			}

			function clear() {
				alerts = [];
			}

			function get() {
				return alerts;
			}

			function success(msg, params, position) {
				return this.add({
					type: 'success',
					msg: msg,
					params: params,
					timeout: timeout,
					toast: toast,
					position: position,
				});
			}

			function error(msg, params, position) {
				if (typeof msg === 'object') {
					msg = msg.title || msg.message;
				}
				return this.add({
					type: 'danger',
					msg: msg,
					params: params,
					timeout: timeout,
					toast: toast,
					position: position,
				});
			}

			function warning(msg, params, position) {
				return this.add({
					type: 'warning',
					msg: msg,
					params: params,
					timeout: timeout,
					toast: toast,
					position: position,
				});
			}

			function info(msg, params, position) {
				return this.add({
					type: 'info',
					msg: msg,
					params: params,
					timeout: timeout,
					toast: toast,
					position: position,
				});
			}

			function factory(alertOptions) {
				var alert = {
					type: alertOptions.type,
					msg: $sce.trustAsHtml(alertOptions.msg),
					id: alertOptions.alertId,
					timeout: alertOptions.timeout,
					toast: alertOptions.toast,
					position: alertOptions.position ? alertOptions.position : 'top right',
					scoped: alertOptions.scoped,
					close: function(alerts) {
						return closeAlert(this.id, alerts);
					},
				};
				if (!alert.scoped) {
					alerts.push(alert);
				}
				return alert;
			}

			function addAlert(alertOptions, extAlerts) {
				alertOptions.alertId = alertId++;
				alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
				var that = this;
				var alert = this.factory(alertOptions);
				if (alertOptions.timeout && alertOptions.timeout > 0) {
					$timeout(function() {
						that.closeAlert(alertOptions.alertId, extAlerts);
					}, alertOptions.timeout);
				}
				return alert;
			}

			function closeAlert(id, extAlerts) {
				var thisAlerts = extAlerts ? extAlerts : alerts;
				return closeAlertByIndex(
					thisAlerts
						.map(function(e) {
							return e.id;
						})
						.indexOf(id),
					thisAlerts
				);
			}

			function closeAlertByIndex(index, thisAlerts) {
				return thisAlerts.splice(index, 1);
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	var jhiAlert = {
		template:
			'<div class="alerts" ng-cloak="" role="alert">' +
			'<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
			'<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
			'</div>' +
			'</div>',
		controller: jhiAlertController,
	};

	angular.module('emsApp').component('jhiAlert', jhiAlert);

	jhiAlertController.$inject = ['$scope', 'AlertService'];

	function jhiAlertController($scope, AlertService) {
		var vm = this;

		vm.alerts = AlertService.get();
		$scope.$on('$destroy', function() {
			vm.alerts = [];
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('notificationInterceptor', notificationInterceptor);

	notificationInterceptor.$inject = ['$q', 'AlertService'];

	function notificationInterceptor($q, AlertService) {
		var service = {
			response: response,
		};

		return service;

		function response(response) {
			var headers = Object.keys(response.headers())
				.filter(function(header) {
					return (
						header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 ||
						header.indexOf('app-params', header.length - 'app-params'.length) !== -1
					);
				})
				.sort();
			var alertKey = response.headers(headers[0]);
			if (angular.isString(alertKey)) {
				AlertService.success(alertKey, { param: response.headers(headers[1]) });
			}
			return response;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('errorHandlerInterceptor', errorHandlerInterceptor);

	errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

	function errorHandlerInterceptor($q, $rootScope) {
		var service = {
			responseError: responseError,
		};

		return service;

		function responseError(response) {
			if (
				!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0)))
			) {
				$rootScope.$emit('emsApp.httpError', response);
			}
			return $q.reject(response);
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('authExpiredInterceptor', authExpiredInterceptor);

	authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

	function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
		var service = {
			responseError: responseError,
		};

		return service;

		function responseError(response) {
			if (response.status === 401) {
				delete $localStorage.authenticationToken;
				delete $sessionStorage.authenticationToken;
				var Principal = $injector.get('Principal');
				if (Principal.isAuthenticated()) {
					var Auth = $injector.get('Auth');
					Auth.authorize(true);
				}
			}
			return $q.reject(response);
		}
	}
})();

(function() {
	'use strict';

	angular.module('emsApp').factory('authInterceptor', authInterceptor);

	authInterceptor.$inject = [ '$rootScope', '$q', '$location', '$localStorage', '$sessionStorage' ];

	function authInterceptor($rootScope, $q, $location, $localStorage, $sessionStorage) {
		var service = {
			request : request
		};

		return service;

		function request(config) {
			if (!config || !config.url || /^http/.test(config.url))
				return config;

			/*jshint camelcase: false */
			config.headers = config.headers || {};
			var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
			if (token) {
				config.headers.Authorization = 'Bearer ' + token;
			}
			return config;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('translationHandler', translationHandler);

	translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

	function translationHandler($rootScope, $window, $state, $translate) {
		return {
			initialize: initialize,
			updateTitle: updateTitle,
		};

		function initialize() {
			// if the current translation changes, update the window title
			var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
				updateTitle();
			});

			$rootScope.$on('$destroy', function() {
				if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
					translateChangeSuccess();
				}
			});
		}

		// update the window title using params in the following
		// precedence
		// 1. titleKey parameter
		// 2. $state.$current.data.pageTitle (current state page title)
		// 3. 'global.title'
		function updateTitle(titleKey) {
			if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
				titleKey = $state.$current.data.pageTitle;
			}
			$translate(titleKey || 'global.title').then(function(title) {
				$window.document.title = title;
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('stateHandler', stateHandler);

	stateHandler.$inject = [
		'$rootScope',
		'$state',
		'$sessionStorage',
		'$translate',
		'JhiLanguageService',
		'translationHandler',
		'$window',
		'Auth',
		'Principal',
		'VERSION',
	];

	function stateHandler(
		$rootScope,
		$state,
		$sessionStorage,
		$translate,
		JhiLanguageService,
		translationHandler,
		$window,
		Auth,
		Principal,
		VERSION
	) {
		return {
			initialize: initialize,
		};

		function initialize() {
			$rootScope.VERSION = VERSION;

			var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState) {
				$rootScope.toState = toState;
				$rootScope.toStateParams = toStateParams;
				$rootScope.fromState = fromState;

				// Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
				if (toState.external) {
					event.preventDefault();
					$window.open(toState.url, '_self');
				}

				if (Principal.isIdentityResolved()) {
					Auth.authorize();
				}

				// Update the language
				JhiLanguageService.getCurrent().then(function(language) {
					$translate.use(language);
				});
			});

			var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
				var titleKey = 'global.title';

				// Set the page title key to the one configured in state or use default one
				if (toState.data.pageTitle) {
					titleKey = toState.data.pageTitle;
				}
				translationHandler.updateTitle(titleKey);
			});

			$rootScope.$on('$destroy', function() {
				if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
					stateChangeStart();
				}
				if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
					stateChangeSuccess();
				}
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(paginationConfig);

	paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

	function paginationConfig(uibPaginationConfig, paginationConstants) {
		uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
		uibPaginationConfig.maxSize = 5;
		uibPaginationConfig.boundaryLinks = true;
		uibPaginationConfig.firstText = '«';
		uibPaginationConfig.previousText = '‹';
		uibPaginationConfig.nextText = '›';
		uibPaginationConfig.lastText = '»';
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(pagerConfig);

	pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

	function pagerConfig(uibPagerConfig, paginationConstants) {
		uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
		uibPagerConfig.previousText = '«';
		uibPagerConfig.nextText = '»';
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('translationStorageProvider', translationStorageProvider);

	translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

	function translationStorageProvider($cookies, $log, LANGUAGES) {
		return {
			get: get,
			put: put,
		};

		function get(name) {
			if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
				$log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
				$cookies.putObject(name, 'en');
			}
			return $cookies.getObject(name);
		}

		function put(name, value) {
			$cookies.putObject(name, value);
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(translationConfig);

	translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

	function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
		// Initialize angular-translate
		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : ''),
		});

		$translateProvider.preferredLanguage('en');
		$translateProvider.useStorage('translationStorageProvider');
		$translateProvider.useSanitizeValueStrategy('escaped');
		$translateProvider.addInterpolation('$translateMessageFormatInterpolation');

		tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
		tmhDynamicLocaleProvider.useCookieStorage();
		tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(localStorageConfig);

	localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

	function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
		$localStorageProvider.setKeyPrefix('jhi-');
		$sessionStorageProvider.setKeyPrefix('jhi-');
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(httpConfig);

	httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

	function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
		//Cache everything except rest api requests
		httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

		$urlRouterProvider.otherwise('/');

		$httpProvider.interceptors.push('errorHandlerInterceptor');
		$httpProvider.interceptors.push('authExpiredInterceptor');
		$httpProvider.interceptors.push('authInterceptor');
		$httpProvider.interceptors.push('notificationInterceptor');
		// jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

		$urlMatcherFactoryProvider.type('boolean', {
			name: 'boolean',
			decode: function(val) {
				return val === true || val === 'true';
			},
			encode: function(val) {
				return val ? 1 : 0;
			},
			equals: function(a, b) {
				return this.is(a) && a === b;
			},
			is: function(val) {
				return [true, false, 0, 1].indexOf(val) >= 0;
			},
			pattern: /bool|true|0|1/,
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(compileServiceConfig);

	compileServiceConfig.$inject = ['$compileProvider', 'DEBUG_INFO_ENABLED'];

	function compileServiceConfig($compileProvider, DEBUG_INFO_ENABLED) {
		// disable debug data on prod profile to improve performance
		$compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

		/*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(alertServiceConfig);

	alertServiceConfig.$inject = ['AlertServiceProvider'];

	function alertServiceConfig(AlertServiceProvider) {
		// set below to true to make alerts look like toast
		AlertServiceProvider.showAsToast(false);
	}
})();

/** @format */

(function() {
	'use strict';

	angular
		.module('emsApp')
		.config(stateConfig)
		.config(uiSelectConfig)
		.config(localStorageConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('app', {
			abstract: true,
			views: {
				'navbar@': {
					templateUrl: 'app/layouts/navbar/navbar.html',
					controller: 'NavbarController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				authorize: [
					'Auth',
					function(Auth) {
						return Auth.authorize();
					},
				],
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('global');
					},
				],
			},
		});
	}

	uiSelectConfig.$inject = ['uiSelectConfig'];

	function uiSelectConfig(uiSelectConfig) {
		// AngularJS UI select (https://github.com/angular-ui/ui-select) global settings
		uiSelectConfig.theme = 'bootstrap';
		uiSelectConfig.resetSearchInput = true;
		uiSelectConfig.appendToBody = true;
	}

	localStorageConfig.$inject = ['localStorageServiceProvider'];

	function localStorageConfig(localStorageServiceProvider) {
		localStorageServiceProvider.setPrefix('emsApp').setStorageType('sessionStorage');
	}
})();

/**
 * /*
 *     Define filters.
 *     Template: jhipster4_ajs/app_filters.ftl
 *
 * @format
 */

(function() {
	'use strict';

	angular
		.module('emsApp')

		.filter('percentage', function() {
			// console.log('filter percentage');
			return function(input) {
				if (angular.isDefined(input) && input !== null) {
					return input + '%';
				} else {
					return '';
				}
			};
		})

		.filter('nullableDateTimeZone', function($filter) {
			//input is in ms in ami, so multiply by 1000 is wrong
			console.log('filter nullableDateTimeZone');
			var defaultDateFilterFn = $filter('date');

			return function(input) {
				if (angular.isDefined(input) && input !== null) {
					return defaultDateFilterFn(input, 'yyyy-MM-dd HH:mm:ss Z');
				} else {
					return '-';
				}
			};
		})

		.filter('nullableDateTimeNoZone', function($filter) {
			//input is in ms in ami, so multiply by 1000 is wrong
			// used for displaying commissioning date times
			var defaultDateFilterFn = $filter('date');

			return function(input) {
				if (angular.isDefined(input) && input !== null) {
					return defaultDateFilterFn(input, 'dd-MM-yyyy HH:mm:ss');
				} else {
					return '';
				}
			};
		})

		.filter('nullableDate', function($filter) {
			// {{input | date:'yyyy-MM-dd'}}
			var defaultDateFilterFn = $filter('date');

			return function(input) {
				if (angular.isDefined(input) && input !== null) {
					return defaultDateFilterFn(input, 'yyyy-MM-dd');
				} else {
					return '';
				}
			};
		})

		.filter('customNullableDateTime', function($filter) {
			// used for displaying commissioning date times
			// {{input * 1000 | date:'dd-MM HH:mm'}}
			var defaultDateFilterFn = $filter('date');

			return function(input, format) {
				var defaultFormat = 'yyyy-dd-MM HH:mm';
				if (angular.isDefined(format) && format !== null && format !== '') {
					defaultFormat = format;
				}
				if (angular.isDefined(input) && input !== null) {
					return defaultDateFilterFn(input * 1000, defaultFormat);
				} else {
					return '';
				}
			};
		})

		.filter('visibleLimitTo', function($filter) {
			// {{input | visibleLimitTo:100}}
			var defaultLimitToFilterFn = $filter('limitTo');

			return function(input, limit, begin) {
				if (angular.isDefined(input) && input !== null) {
					var result = defaultLimitToFilterFn(input, limit, begin);
					if (result.length < input.length) {
						result += ' ...';
					}
					return result;
				} else {
					return '';
				}
			};
		})

		.filter('suffix', function() {
			// {{input | suffix:'whatever'}}
			return function(input, suffix) {
				if (angular.isDefined(input) && input !== null) {
					if (angular.isDefined(suffix) && suffix !== null && suffix !== '') {
						return input + suffix;
					} else {
						return input;
					}
				} else {
					return '';
				}
			};
		})

		.filter('propsFilter', function() {
			return function(items, props) {
				var out = [];

				if (angular.isArray(items)) {
					items.forEach(function(item) {
						var itemMatches = false;

						var keys = Object.keys(props);
						for (var i = 0; i < keys.length; i++) {
							var prop = keys[i];
							var text = props[prop].toLowerCase();
							if (
								item[prop]
									.toString()
									.toLowerCase()
									.indexOf(text) !== -1
							) {
								itemMatches = true;
								break;
							}
						}

						if (itemMatches) {
							out.push(item);
						}
					});
				} else {
					// Let the output be the input untouched
					out = items;
				}

				return out;
			};
		});
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('emsApp') //
        .constant('_', window._) // lodash support
        .constant('jQuery', $) // jQuery support
        .constant('VERSION', "Built at 22 Jul 2025 08:32:04") //
        .constant('DEBUG_INFO_ENABLED', false) //
        .constant('BUILD_TIMESTAMP', 1753166852806) //
;
})();

(function() {
	'use strict';

	angular.module('emsApp').controller('UserManagementDialogController', UserManagementDialogController);

	UserManagementDialogController.$inject = [ '$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService',
			'NoPagingUserTypeFactory' ];

	function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService, NoPagingUserTypeFactory) {
		var vm = this;

		vm.authorities = [ 'ROLE_USER', 'ROLE_ADMIN' ];
		vm.clear = clear;
		vm.languages = null;
		vm.userTypes = null;
		vm.save = save;
		vm.user = entity;

		JhiLanguageService.getAll().then(function(languages) {
			vm.languages = languages;
		});

		NoPagingUserTypeFactory.query(function(result) {
			vm.userTypes = result;
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function onSaveSuccess(result) {
			vm.isSaving = false;
			$uibModalInstance.close(result);
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		function save() {
			vm.isSaving = true;
			if (vm.user.id !== null) {
				User.update(vm.user, onSaveSuccess, onSaveError);
			} else {
				User.save(vm.user, onSaveSuccess, onSaveError);
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('UserManagementDetailController', UserManagementDetailController);

	UserManagementDetailController.$inject = ['$stateParams', 'User'];

	function UserManagementDetailController($stateParams, User) {
		var vm = this;

		vm.load = load;
		vm.user = {};

		vm.load($stateParams.login);

		function load(login) {
			User.get({ login: login }, function(result) {
				vm.user = result;
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('UserManagementDeleteController', UserManagementDeleteController);

	UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

	function UserManagementDeleteController($uibModalInstance, entity, User) {
		var vm = this;

		vm.user = entity;
		vm.clear = clear;
		vm.confirmDelete = confirmDelete;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmDelete(login) {
			User.delete({ login: login }, function() {
				$uibModalInstance.close(true);
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
			.state('user-management', {
				parent: 'admin',
				url: '/user-management?page&sort',
				data: {
					authorities: ['ROLE_ADMIN'],
					pageTitle: 'userManagement.home.title',
				},
				views: {
					'content@': {
						templateUrl: 'app/admin/user-management/user-management.html',
						controller: 'UserManagementController',
						controllerAs: 'vm',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					sort: {
						value: 'id,asc',
						squash: true,
					},
				},
				resolve: {
					pagingParams: [
						'$stateParams',
						'PaginationUtil',
						function($stateParams, PaginationUtil) {
							return {
								page: PaginationUtil.parsePage($stateParams.page),
								sort: $stateParams.sort,
								predicate: PaginationUtil.parsePredicate($stateParams.sort),
								ascending: PaginationUtil.parseAscending($stateParams.sort),
							};
						},
					],
					translatePartialLoader: [
						'$translate',
						'$translatePartialLoader',
						function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('user-management');
							return $translate.refresh();
						},
					],
				},
			})
			.state('user-management.new', {
				url: '/new',
				data: {
					authorities: ['ROLE_ADMIN'],
				},
				onEnter: [
					'$stateParams',
					'$state',
					'$uibModal',
					function($stateParams, $state, $uibModal) {
						$uibModal
							.open({
								templateUrl: 'app/admin/user-management/user-management-dialog.html',
								controller: 'UserManagementDialogController',
								controllerAs: 'vm',
								backdrop: 'static',
								size: 'lg',
								resolve: {
									entity: function() {
										return {
											id: null,
											login: null,
											firstName: null,
											lastName: null,
											email: null,
											activated: true,
											langKey: null,
											createdBy: null,
											createdDate: null,
											lastModifiedBy: null,
											lastModifiedDate: null,
											resetDate: null,
											resetKey: null,
											authorities: null,
										};
									},
								},
							})
							.result.then(
								function() {
									$state.go('user-management', null, { reload: true });
								},
								function() {
									$state.go('user-management');
								}
							);
					},
				],
			})
			.state('user-management.edit', {
				url: '/{login}/edit',
				data: {
					authorities: ['ROLE_ADMIN'],
				},
				onEnter: [
					'$stateParams',
					'$state',
					'$uibModal',
					function($stateParams, $state, $uibModal) {
						$uibModal
							.open({
								templateUrl: 'app/admin/user-management/user-management-dialog.html',
								controller: 'UserManagementDialogController',
								controllerAs: 'vm',
								backdrop: 'static',
								size: 'lg',
								resolve: {
									entity: [
										'User',
										function(User) {
											return User.get({ login: $stateParams.login }).$promise;
										},
									],
								},
							})
							.result.then(
								function() {
									$state.go('user-management', null, { reload: true });
								},
								function() {
									$state.go('^');
								}
							);
					},
				],
			})
			.state('user-management-detail', {
				parent: 'user-management',
				url: '/{login}',
				data: {
					authorities: ['ROLE_ADMIN'],
					pageTitle: 'user-management.detail.title',
				},
				views: {
					'content@': {
						templateUrl: 'app/admin/user-management/user-management-detail.html',
						controller: 'UserManagementDetailController',
						controllerAs: 'vm',
					},
				},
				resolve: {
					translatePartialLoader: [
						'$translate',
						'$translatePartialLoader',
						function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('user-management');
							return $translate.refresh();
						},
					],
				},
			})
			.state('user-management.delete', {
				url: '/{login}/delete',
				data: {
					authorities: ['ROLE_ADMIN'],
				},
				onEnter: [
					'$stateParams',
					'$state',
					'$uibModal',
					function($stateParams, $state, $uibModal) {
						$uibModal
							.open({
								templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
								controller: 'UserManagementDeleteController',
								controllerAs: 'vm',
								size: 'md',
								resolve: {
									entity: [
										'User',
										function(User) {
											return User.get({ login: $stateParams.login }).$promise;
										},
									],
								},
							})
							.result.then(
								function() {
									$state.go('user-management', null, { reload: true });
								},
								function() {
									$state.go('^');
								}
							);
					},
				],
			});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('UserManagementController', UserManagementController);

	UserManagementController.$inject = [
		'Principal',
		'User',
		'ParseLinks',
		'AlertService',
		'$state',
		'pagingParams',
		'paginationConstants',
		'JhiLanguageService',
	];

	function UserManagementController(
		Principal,
		User,
		ParseLinks,
		AlertService,
		$state,
		pagingParams,
		paginationConstants,
		JhiLanguageService
	) {
		var vm = this;

		vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
		vm.currentAccount = null;
		vm.languages = null;
		vm.loadAll = loadAll;
		vm.setActive = setActive;
		vm.users = [];
		vm.page = 1;
		vm.totalItems = null;
		vm.clear = clear;
		vm.links = null;
		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.transition = transition;

		vm.loadAll();
		JhiLanguageService.getAll().then(function(languages) {
			vm.languages = languages;
		});
		Principal.identity().then(function(account) {
			vm.currentAccount = account;
		});

		function setActive(user, isActivated) {
			user.activated = isActivated;
			User.update(user, function() {
				vm.loadAll();
				vm.clear();
			});
		}

		function loadAll() {
			User.query(
				{
					page: pagingParams.page - 1,
					size: vm.itemsPerPage,
					sort: sort(),
				},
				onSuccess,
				onError
			);
		}

		function onSuccess(data, headers) {
			vm.links = ParseLinks.parse(headers('link'));
			vm.totalItems = headers('X-Total-Count');
			vm.queryCount = vm.totalItems;
			vm.page = pagingParams.page;
			vm.users = data;
		}

		function onError(error) {
			AlertService.error(error.data.message);
		}

		function clear() {
			vm.user = {
				id: null,
				login: null,
				firstName: null,
				lastName: null,
				email: null,
				activated: null,
				langKey: null,
				createdBy: null,
				createdDate: null,
				lastModifiedBy: null,
				lastModifiedDate: null,
				resetDate: null,
				resetKey: null,
				authorities: null,
			};
		}

		function sort() {
			var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
			if (vm.predicate !== 'id') {
				result.push('id');
			}
			return result;
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page: vm.page,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search: vm.currentSearch,
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('jhi-metrics', {
			parent: 'admin',
			url: '/metrics',
			data: {
				authorities: ['ROLE_ADMIN'],
				pageTitle: 'metrics.title',
			},
			views: {
				'content@': {
					templateUrl: 'app/admin/metrics/metrics.html',
					controller: 'JhiMetricsMonitoringController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('metrics');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('JhiMetricsService', JhiMetricsService);

	JhiMetricsService.$inject = ['$rootScope', '$http'];

	function JhiMetricsService($rootScope, $http) {
		var service = {
			getMetrics: getMetrics,
			threadDump: threadDump,
		};

		return service;

		function getMetrics() {
			return $http.get('management/jhimetrics').then(function(response) {
				return response.data;
			});
		}

		function threadDump() {
			return $http.get('management/dump').then(function(response) {
				return response.data;
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

	JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

	function JhiMetricsMonitoringModalController($uibModalInstance, threadDump) {
		var vm = this;

		vm.cancel = cancel;
		vm.getLabelClass = getLabelClass;
		vm.threadDump = threadDump;
		vm.threadDumpAll = 0;
		vm.threadDumpBlocked = 0;
		vm.threadDumpRunnable = 0;
		vm.threadDumpTimedWaiting = 0;
		vm.threadDumpWaiting = 0;

		angular.forEach(threadDump, function(value) {
			if (value.threadState === 'RUNNABLE') {
				vm.threadDumpRunnable += 1;
			} else if (value.threadState === 'WAITING') {
				vm.threadDumpWaiting += 1;
			} else if (value.threadState === 'TIMED_WAITING') {
				vm.threadDumpTimedWaiting += 1;
			} else if (value.threadState === 'BLOCKED') {
				vm.threadDumpBlocked += 1;
			}
		});

		vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting + vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}

		function getLabelClass(threadState) {
			if (threadState === 'RUNNABLE') {
				return 'label-success';
			} else if (threadState === 'WAITING') {
				return 'label-info';
			} else if (threadState === 'TIMED_WAITING') {
				return 'label-warning';
			} else if (threadState === 'BLOCKED') {
				return 'label-danger';
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

	JhiMetricsMonitoringController.$inject = ['$scope', 'JhiMetricsService', '$uibModal'];

	function JhiMetricsMonitoringController($scope, JhiMetricsService, $uibModal) {
		var vm = this;

		vm.metrics = {};
		vm.refresh = refresh;
		vm.refreshThreadDumpData = refreshThreadDumpData;
		vm.servicesStats = {};
		vm.updatingMetrics = true;

		vm.refresh();

		$scope.$watch('vm.metrics', function(newValue) {
			vm.servicesStats = {};
			angular.forEach(newValue.timers, function(value, key) {
				if (key.includes('web.rest') || key.includes('service')) {
					vm.servicesStats[key] = value;
				}
			});
		});

		function refresh() {
			vm.updatingMetrics = true;
			JhiMetricsService.getMetrics().then(
				function(promise) {
					vm.metrics = promise;
					vm.updatingMetrics = false;
				},
				function(promise) {
					vm.metrics = promise.data;
					vm.updatingMetrics = false;
				}
			);
		}

		function refreshThreadDumpData() {
			JhiMetricsService.threadDump().then(function(data) {
				$uibModal.open({
					templateUrl: 'app/admin/metrics/metrics.modal.html',
					controller: 'JhiMetricsMonitoringModalController',
					controllerAs: 'vm',
					size: 'lg',
					resolve: {
						threadDump: function() {
							return data;
						},
					},
				});
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('logs', {
			parent: 'admin',
			url: '/logs',
			data: {
				authorities: ['ROLE_ADMIN'],
				pageTitle: 'logs.title',
			},
			views: {
				'content@': {
					templateUrl: 'app/admin/logs/logs.html',
					controller: 'LogsController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('logs');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('LogsService', LogsService);

	LogsService.$inject = ['$resource'];

	function LogsService($resource) {
		var service = $resource(
			'management/logs',
			{},
			{
				findAll: { method: 'GET', isArray: true },
				changeLevel: { method: 'PUT' },
			}
		);

		return service;
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('LogsController', LogsController);

	LogsController.$inject = ['LogsService'];

	function LogsController(LogsService) {
		var vm = this;

		vm.changeLevel = changeLevel;
		vm.loggers = LogsService.findAll();

		function changeLevel(name, level) {
			LogsService.changeLevel({ name: name, level: level }, function() {
				vm.loggers = LogsService.findAll();
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('jhi-health', {
			parent: 'admin',
			url: '/health',
			data: {
				authorities: ['ROLE_ADMIN'],
				pageTitle: 'health.title',
			},
			views: {
				'content@': {
					templateUrl: 'app/admin/health/health.html',
					controller: 'JhiHealthCheckController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('health');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('JhiHealthService', JhiHealthService);

	JhiHealthService.$inject = ['$rootScope', '$http'];

	function JhiHealthService($rootScope, $http) {
		var separator = '.';
		var service = {
			checkHealth: checkHealth,
			transformHealthData: transformHealthData,
			getBaseName: getBaseName,
			getSubSystemName: getSubSystemName,
		};

		return service;

		function checkHealth() {
			return $http.get('management/health').then(function(response) {
				return response.data;
			});
		}

		function transformHealthData(data) {
			var response = [];
			flattenHealthData(response, null, data);
			return response;
		}

		function getBaseName(name) {
			if (name) {
				var split = name.split('.');
				return split[0];
			}
		}

		function getSubSystemName(name) {
			if (name) {
				var split = name.split('.');
				split.splice(0, 1);
				var remainder = split.join('.');
				return remainder ? ' - ' + remainder : '';
			}
		}

		/* private methods */
		function flattenHealthData(result, path, data) {
			angular.forEach(data, function(value, key) {
				if (isHealthObject(value)) {
					if (hasSubSystem(value)) {
						addHealthObject(result, false, value, getModuleName(path, key));
						flattenHealthData(result, getModuleName(path, key), value);
					} else {
						addHealthObject(result, true, value, getModuleName(path, key));
					}
				}
			});
			return result;
		}

		function addHealthObject(result, isLeaf, healthObject, name) {
			var healthData = {
				name: name,
			};
			var details = {};
			var hasDetails = false;

			angular.forEach(healthObject, function(value, key) {
				if (key === 'status' || key === 'error') {
					healthData[key] = value;
				} else {
					if (!isHealthObject(value)) {
						details[key] = value;
						hasDetails = true;
					}
				}
			});

			// Add the of the details
			if (hasDetails) {
				angular.extend(healthData, { details: details });
			}

			// Only add nodes if they provide additional information
			if (isLeaf || hasDetails || healthData.error) {
				result.push(healthData);
			}
			return healthData;
		}

		function getModuleName(path, name) {
			var result;
			if (path && name) {
				result = path + separator + name;
			} else if (path) {
				result = path;
			} else if (name) {
				result = name;
			} else {
				result = '';
			}
			return result;
		}

		function hasSubSystem(healthObject) {
			var result = false;
			angular.forEach(healthObject, function(value) {
				if (value && value.status) {
					result = true;
				}
			});
			return result;
		}

		function isHealthObject(healthObject) {
			var result = false;
			angular.forEach(healthObject, function(value, key) {
				if (key === 'status') {
					result = true;
				}
			});
			return result;
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('HealthModalController', HealthModalController);

	HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

	function HealthModalController($uibModalInstance, currentHealth, baseName, subSystemName) {
		var vm = this;

		vm.cancel = cancel;
		vm.currentHealth = currentHealth;
		vm.baseName = baseName;
		vm.subSystemName = subSystemName;

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('JhiHealthCheckController', JhiHealthCheckController);

	JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

	function JhiHealthCheckController(JhiHealthService, $uibModal) {
		var vm = this;

		vm.updatingHealth = true;
		vm.getLabelClass = getLabelClass;
		vm.refresh = refresh;
		vm.showHealth = showHealth;
		vm.baseName = JhiHealthService.getBaseName;
		vm.subSystemName = JhiHealthService.getSubSystemName;

		vm.refresh();

		function getLabelClass(statusState) {
			if (statusState === 'UP') {
				return 'label-success';
			} else {
				return 'label-danger';
			}
		}

		function refresh() {
			vm.updatingHealth = true;
			JhiHealthService.checkHealth().then(
				function(response) {
					vm.healthData = JhiHealthService.transformHealthData(response);
					vm.updatingHealth = false;
				},
				function(response) {
					vm.healthData = JhiHealthService.transformHealthData(response.data);
					vm.updatingHealth = false;
				}
			);
		}

		function showHealth(health) {
			$uibModal.open({
				templateUrl: 'app/admin/health/health.modal.html',
				controller: 'HealthModalController',
				controllerAs: 'vm',
				size: 'lg',
				resolve: {
					currentHealth: function() {
						return health;
					},
					baseName: function() {
						return vm.baseName;
					},
					subSystemName: function() {
						return vm.subSystemName;
					},
				},
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('docs', {
			parent: 'admin',
			url: '/docs',
			data: {
				authorities: ['ROLE_ADMIN'],
				pageTitle: 'global.menu.admin.apidocs',
			},
			views: {
				'content@': {
					templateUrl: 'app/admin/docs/docs.html',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					function($translate) {
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('jhi-configuration', {
			parent: 'admin',
			url: '/configuration',
			data: {
				authorities: ['ROLE_ADMIN'],
				pageTitle: 'configuration.title',
			},
			views: {
				'content@': {
					templateUrl: 'app/admin/configuration/configuration.html',
					controller: 'JhiConfigurationController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('configuration');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('JhiConfigurationService', JhiConfigurationService);

	JhiConfigurationService.$inject = ['$filter', '$http'];

	function JhiConfigurationService($filter, $http) {
		var service = {
			get: get,
			getEnv: getEnv,
		};

		return service;

		function get() {
			return $http.get('management/configprops').then(getConfigPropsComplete);

			function getConfigPropsComplete(response) {
				var properties = [];
				angular.forEach(response.data, function(data) {
					properties.push(data);
				});
				var orderBy = $filter('orderBy');
				return orderBy(properties, 'prefix');
			}
		}

		function getEnv() {
			return $http.get('management/env').then(getEnvComplete);

			function getEnvComplete(response) {
				var properties = {};
				angular.forEach(response.data, function(val, key) {
					var vals = [];
					angular.forEach(val, function(v, k) {
						vals.push({ key: k, val: v });
					});
					properties[key] = vals;
				});
				return properties;
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('JhiConfigurationController', JhiConfigurationController);

	JhiConfigurationController.$inject = ['$filter', 'JhiConfigurationService'];

	function JhiConfigurationController(filter, JhiConfigurationService) {
		var vm = this;

		vm.allConfiguration = null;
		vm.configuration = null;

		JhiConfigurationService.get().then(function(configuration) {
			vm.configuration = configuration;
		});
		JhiConfigurationService.getEnv().then(function(configuration) {
			vm.allConfiguration = configuration;
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('audits', {
			parent: 'admin',
			url: '/audits',
			data: {
				authorities: ['ROLE_ADMIN'],
				pageTitle: 'audits.title',
			},
			views: {
				'content@': {
					templateUrl: 'app/admin/audits/audits.html',
					controller: 'AuditsController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('audits');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').factory('AuditsService', AuditsService);

	AuditsService.$inject = ['$resource'];

	function AuditsService($resource) {
		var service = $resource(
			'management/audits/:id',
			{},
			{
				get: {
					method: 'GET',
					isArray: true,
				},
				query: {
					method: 'GET',
					isArray: true,
					params: { fromDate: null, toDate: null },
				},
			}
		);

		return service;
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('AuditsController', AuditsController);

	AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

	function AuditsController($filter, AuditsService, ParseLinks) {
		var vm = this;

		vm.audits = null;
		vm.fromDate = null;
		vm.links = null;
		vm.loadPage = loadPage;
		vm.onChangeDate = onChangeDate;
		vm.page = 1;
		vm.previousMonth = previousMonth;
		vm.toDate = null;
		vm.today = today;
		vm.totalItems = null;

		vm.today();
		vm.previousMonth();
		vm.onChangeDate();

		function onChangeDate() {
			var dateFormat = 'yyyy-MM-dd';
			var fromDate = $filter('date')(vm.fromDate, dateFormat);
			var toDate = $filter('date')(vm.toDate, dateFormat);

			AuditsService.query({ page: vm.page - 1, size: 20, fromDate: fromDate, toDate: toDate }, function(result, headers) {
				vm.audits = result;
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
			});
		}

		// Date picker configuration
		function today() {
			// Today + 1 day - needed if the current day must be included
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
		}

		function previousMonth() {
			var fromDate = new Date();
			if (fromDate.getMonth() === 0) {
				fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
			} else {
				fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
			}

			vm.fromDate = fromDate;
		}

		function loadPage(page) {
			vm.page = page;
			vm.onChangeDate();
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('admin', {
			abstract: true,
			parent: 'app',
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('settings', {
			parent: 'account',
			url: '/settings',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.menu.account.settings',
			},
			views: {
				'content@': {
					templateUrl: 'app/account/settings/settings.html',
					controller: 'SettingsController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('settings');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('SettingsController', SettingsController);

	SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

	function SettingsController(Principal, Auth, JhiLanguageService, $translate) {
		var vm = this;

		vm.error = null;
		vm.save = save;
		vm.settingsAccount = null;
		vm.success = null;

		/**
		 * Store the "settings account" in a separate variable, and not in the shared "account" variable.
		 */
		var copyAccount = function(account) {
			return {
				activated: account.activated,
				email: account.email,
				firstName: account.firstName,
				langKey: account.langKey,
				lastName: account.lastName,
				login: account.login,
			};
		};

		Principal.identity().then(function(account) {
			vm.settingsAccount = copyAccount(account);
		});

		function save() {
			Auth.updateAccount(vm.settingsAccount)
				.then(function() {
					vm.error = null;
					vm.success = 'OK';
					Principal.identity(true).then(function(account) {
						vm.settingsAccount = copyAccount(account);
					});
					JhiLanguageService.getCurrent().then(function(current) {
						if (vm.settingsAccount.langKey !== current) {
							$translate.use(vm.settingsAccount.langKey);
						}
					});
				})
				.catch(function() {
					vm.success = null;
					vm.error = 'ERROR';
				});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('requestReset', {
			parent: 'account',
			url: '/reset/request',
			data: {
				authorities: [],
			},
			views: {
				'content@': {
					templateUrl: 'app/account/reset/request/reset.request.html',
					controller: 'RequestResetController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('reset');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('RequestResetController', RequestResetController);

	RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

	function RequestResetController($timeout, Auth, errorConstants) {
		var vm = this;

		vm.error = null;
		vm.errorEmailNotExists = null;
		vm.requestReset = requestReset;
		vm.resetAccount = {};
		vm.success = null;

		$timeout(function() {
			angular.element('#email').focus();
		});

		function requestReset() {
			vm.error = null;
			vm.errorEmailNotExists = null;

			Auth.resetPasswordInit(vm.resetAccount.email)
				.then(function() {
					vm.success = 'OK';
				})
				.catch(function(response) {
					vm.success = null;
					if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
						vm.errorEmailNotExists = 'ERROR';
					} else {
						vm.error = 'ERROR';
					}
				});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('finishReset', {
			parent: 'account',
			url: '/reset/finish?key',
			data: {
				authorities: [],
			},
			views: {
				'content@': {
					templateUrl: 'app/account/reset/finish/reset.finish.html',
					controller: 'ResetFinishController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('reset');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('ResetFinishController', ResetFinishController);

	ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

	function ResetFinishController($stateParams, $timeout, Auth, LoginService) {
		var vm = this;

		vm.keyMissing = angular.isUndefined($stateParams.key);
		vm.confirmPassword = null;
		vm.doNotMatch = null;
		vm.error = null;
		vm.finishReset = finishReset;
		vm.login = LoginService.open;
		vm.resetAccount = {};
		vm.success = null;

		$timeout(function() {
			angular.element('#password').focus();
		});

		function finishReset() {
			vm.doNotMatch = null;
			vm.error = null;
			if (vm.resetAccount.password !== vm.confirmPassword) {
				vm.doNotMatch = 'ERROR';
			} else {
				Auth.resetPasswordFinish({ key: $stateParams.key, newPassword: vm.resetAccount.password })
					.then(function() {
						vm.success = 'OK';
					})
					.catch(function() {
						vm.success = null;
						vm.error = 'ERROR';
					});
			}
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('register', {
			parent: 'account',
			url: '/register',
			data: {
				authorities: [],
				pageTitle: 'register.title',
			},
			views: {
				'content@': {
					templateUrl: 'app/account/register/register.html',
					controller: 'RegisterController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('register');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('RegisterController', RegisterController);

	RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

	function RegisterController($translate, $timeout, Auth, LoginService, errorConstants) {
		var vm = this;

		vm.doNotMatch = null;
		vm.error = null;
		vm.errorUserExists = null;
		vm.login = LoginService.open;
		vm.register = register;
		vm.registerAccount = {};
		vm.success = null;

		$timeout(function() {
			angular.element('#login').focus();
		});

		function register() {
			if (vm.registerAccount.password !== vm.confirmPassword) {
				vm.doNotMatch = 'ERROR';
			} else {
				vm.registerAccount.langKey = $translate.use();
				vm.doNotMatch = null;
				vm.error = null;
				vm.errorUserExists = null;
				vm.errorEmailExists = null;

				Auth.createAccount(vm.registerAccount)
					.then(function() {
						vm.success = 'OK';
					})
					.catch(function(response) {
						vm.success = null;
						if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
							vm.errorUserExists = 'ERROR';
						} else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
							vm.errorEmailExists = 'ERROR';
						} else {
							vm.error = 'ERROR';
						}
					});
			}
		}
	}
})();

/**
 * /* globals $
 *
 * @format
 */

(function() {
	'use strict';

	angular.module('emsApp').directive('passwordStrengthBar', passwordStrengthBar);

	function passwordStrengthBar() {
		var directive = {
			replace: true,
			restrict: 'E',
			template:
				'<div id="strength">' +
				'<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
				'<ul id="strengthBar">' +
				'<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
				'</ul>' +
				'</div>',
			scope: {
				passwordToCheck: '=',
			},
			link: linkFunc,
		};

		return directive;

		/* private helper methods*/

		function linkFunc(scope, iElement) {
			var strength = {
				colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
				mesureStrength: function(p) {
					var _force = 0;
					var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

					var _lowerLetters = /[a-z]+/.test(p);
					var _upperLetters = /[A-Z]+/.test(p);
					var _numbers = /[0-9]+/.test(p);
					var _symbols = _regex.test(p);

					var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
					var _passedMatches = $.grep(_flags, function(el) {
						return el === true;
					}).length;

					_force += 2 * p.length + (p.length >= 10 ? 1 : 0);
					_force += _passedMatches * 10;

					// penalty (short password)
					_force = p.length <= 6 ? Math.min(_force, 10) : _force;

					// penalty (poor variety of characters)
					_force = _passedMatches === 1 ? Math.min(_force, 10) : _force;
					_force = _passedMatches === 2 ? Math.min(_force, 20) : _force;
					_force = _passedMatches === 3 ? Math.min(_force, 40) : _force;

					return _force;
				},
				getColor: function(s) {
					var idx;
					if (s <= 10) {
						idx = 0;
					} else if (s <= 20) {
						idx = 1;
					} else if (s <= 30) {
						idx = 2;
					} else if (s <= 40) {
						idx = 3;
					} else {
						idx = 4;
					}

					return { idx: idx + 1, col: this.colors[idx] };
				},
			};
			scope.$watch('passwordToCheck', function(password) {
				if (password) {
					var c = strength.getColor(strength.mesureStrength(password));
					iElement.removeClass('ng-hide');
					iElement
						.find('ul')
						.children('li')
						.css({ 'background-color': '#DDD' })
						.slice(0, c.idx)
						.css({ 'background-color': c.col });
				}
			});
		}
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('password', {
			parent: 'account',
			url: '/password',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.menu.account.password',
			},
			views: {
				'content@': {
					templateUrl: 'app/account/password/password.html',
					controller: 'PasswordController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('password');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('emsApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.currentPassword = '';

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword({
									currentPassword: vm.currentPassword,
									newPassword: vm.password
								}).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('activate', {
			parent: 'account',
			url: '/activate?key',
			data: {
				authorities: [],
				pageTitle: 'activate.title',
			},
			views: {
				'content@': {
					templateUrl: 'app/account/activate/activate.html',
					controller: 'ActivationController',
					controllerAs: 'vm',
				},
			},
			resolve: {
				translatePartialLoader: [
					'$translate',
					'$translatePartialLoader',
					function($translate, $translatePartialLoader) {
						$translatePartialLoader.addPart('activate');
						return $translate.refresh();
					},
				],
			},
		});
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').controller('ActivationController', ActivationController);

	ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

	function ActivationController($stateParams, Auth, LoginService) {
		var vm = this;

		Auth.activateAccount({ key: $stateParams.key })
			.then(function() {
				vm.error = null;
				vm.success = 'OK';
			})
			.catch(function() {
				vm.success = null;
				vm.error = 'ERROR';
			});

		vm.login = LoginService.open;
	}
})();

/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('account', {
			abstract: true,
			parent: 'app',
		});
	}
})();
(function(){angular.module('emsApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-10 col-md-offset-1 text-center gpelite-main-logo img-rounded"><span class="hipster img-responsive img-rounded"></span><p class="lead" translate="home.subtitle">- Event Management System -</p></div></div><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{account.login}}".</div></div></div></div></div>');
$templateCache.put('app/sales/events-dashboard.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="event.dashboard.title">Events</h3></div><div class="panel-buttons"><button type="button" ng-click="showSearchForm=!showSearchForm" class="btn"><span class="glyphicon glyphicon-search" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.search"></span></button> <button id="createEventButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="event.overview.button.new">Create a new Event</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="modal fade" id="deleteEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="event.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="event.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Event?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEvent" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="event.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm" ng-show="showSearchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="event.overview.search.startDate.label">startDate</label><div class="col-md-6"><p class="input-group"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="fromstartDate" ng-model="EventSearchOverview.startDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="tostartDate" ng-model="EventSearchOverview.startDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></p></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="event.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'event.overview.search.name.placeholder\' | translate}}" name="name" ng-model="EventSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="event.overview.search.templateEvent.label">templateEvent</label><div class="col-md-6"><ui-select multiple="multiple" ng-model="EventSearchOverview.selectedTemplateEventList" title="Choose an event sub category" on-select="search()" on-remove="search()"><ui-select-match placeholder="{{ \'event.overview.search.templateEvent.defaultOption\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent in templateEventReferenceFilterList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="event.overview.search.location.label">location</label><div class="col-md-6"><select id="location_select" class="form-control input-sm" ng-options="location as location.name for location in locationReferenceFilterList track by location.id" ng-model="EventSearchOverview.location" tabindex="0" ng-change="search()"><option value="" translate="event.overview.search.location.defaultOption">All Locations</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="event.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isEventSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="event.overview.search.reset.button">Reset</span></button></div></div></form><div class="table-responsive"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="EventSearchOverview.predicate" ascending="EventSearchOverview.ascending" callback="search()"><th jh-sort-by="startDate" class="sortable hidden-xs"><span class="pull-left" translate="event.overview.results.header.startDate.label">startDate</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'startDate\')}}" aria-hidden="true"></span></span></th><th><span class="pull-left" translate="event.overview.results.header.workdaysRemaining.label">workdaysRemaining</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="event.overview.results.header.name.label">name</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span class="pull-left" translate="event.dashboard.status">status</span> <span class="pull-right" translate="event.overview.results.header.target.label">target</span></th><th ng-show="{{!readOnly}}" class="actionButtons hidden-xs"></th></tr></thead><tbody><tr ng-repeat="event in eventList" ng-class="{\r\n                        \'success\':event.workdaysRemaining >= 14,\r\n                        \'warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14,\r\n                        \'danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7\r\n                    }" class=""><td id="event.startDateId{{$index}}" class="hidden-xs"><span ng-hide="event.startDate == null">{{event.startDate | date:\'dd-MM-yy\'}}</span></td><td ng-class="{\'text-success\': event.workdaysRemaining >= 14, \'text-warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14, \'text-danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}" id="event.workdaysRemainingId{{$index}}"><span><strong>{{event.workdaysRemaining}}</strong></span></td><td id="event.nameId{{$index}}"><a ui-sref="event.detail.subscriptions({eventId:event.id})"><span><strong>{{event.name}}</strong></span> <span class="text-muted small pull-right">({{event.location.name}})</span></a></td><td><span class="pull-left"><div class="progress" ng-style="calculateStatusBarStyle(event)" style="margin-bottom:0"><div class="progress-bar progress-bar-success progress-bar-striped" ng-style="calculateSpotsConfirmed(event)"><strong>{{event.totalConfirmed}}</strong></div><div class="progress-bar progress-bar-warning progress-bar-striped" ng-style="calculateSpotsReserved(event)"><strong>{{event.totalReserved}}</strong></div><div class="progress-bar progress-bar-danger progress-bar-striped" ng-style="calculateSpotsOpen(event)"><strong>{{event.target - (event.totalConfirmed + event.totalReserved)}}</strong></div></div></span><span class="pull-right text-muted" ng-show="event.totalConfirmed + event.totalReserved > event.target"><span class="label label-danger label-additional" tooltip-placement="bottom" uib-tooltip="The sum of confirmed plus reserved spots is more than event target">{{event.target}}</span> </span><span class="pull-right text-muted" ng-show="event.totalConfirmed + event.totalReserved <= event.target">{{event.target}}</span></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons hidden-xs"><span class="pull-right"><button id="customDetailEvent{{$index}}" type="button" ui-sref="event.detail.subscriptions({eventId:event.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Event{{$index}}" type="button" ng-click="goToEditState(event)" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEvent{{$index}}" type="button" ng-click="singleDelete(event.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="EventSearchOverview.page" ng-change="search()"></ul></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/sales/relation-sales-status.html','<div class="panel sales-status" ng-attr-id="{{ \'panel-\' + event.id + \'-\' + relation.id }}"><div class="panel-body text-center sales-status-cell" ng-style="statusCellStyle" ng-click="openModal(\'sm\', \'#panel-\' + event.id + \'-\' + relation.id)" ng-attr-data-target="{{ \'#actions-\' + event.id + \'-\' + relation.id }}"><span>{{renderStatus(eventContacts, event.id)}}</span></div><!-- Modal --><script type="text/ng-template" id="statusUpdateModal.html"><div class="modal-header">\r\n            <h4 class="modal-title" id="modal-title">\r\n                {{relation.personName}} - {{event.name}}&nbsp;<span class="pull-right"><a ui-sref="event.detail.booking({eventId:event.id,bookingId:bookingId,driverId:subscriptionId})" ng-if="$root.isDefinedAndNotNull(subscriptionId)"><span class="glyphicon glyphicon-link" aria-hidden="true"></span></a></span>\r\n                <br><small>{{subtitle}}</small>\r\n            </h4>\r\n        </div>\r\n        <div class="modal-body" id="modal-body">\r\n            <div class="row" ng-hide="showSubscriptionDetails">\r\n                <div class="col-xs-12">\r\n                    <div id="salesstatus-buttons">\r\n                        <button type="button" class="btn btn-block" ng-repeat="status in salesStatus" ng-click="submitStatus(status)" ng-style="status.style">\r\n                            <span ng-class="activeButtonClass(status)"></span>\r\n                            <span>{{status.displayValue}}</span>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div></script></div>');
$templateCache.put('app/sales/relation-sales.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="relation-sales.overview.title"></h3></div><div class="panel-buttons"><div class="btn-group" role="group"><button type="button" class="btn btn-default" ng-click="toggleSearchForm()"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button type="button" class="btn btn-primary" ng-click="search()"><span id="search-header-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="">Filter</span></button> <button type="button" class="btn btn-warning" ng-click="syncSubscriptions()" id="syncButton" has-authority="ROLE_ADMIN"><span id="sync-button" class="glyphicon glyphicon-refresh" aria-hidden="true"></span>&nbsp;<span>Sync</span></button></div></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="row" ng-show="showSearchForm"><div class="row"><div class="col-xs-10 col-xs-offset-1"><form name="searchForm" class="voffset3" novalidate id="searchForm"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title" ng-show="isDefinedAndNotNull(selectedSalesFilter)"><span translate="salesFilter.overview.search.title-existing"></span> <span>{{selectedSalesFilter.description}}</span></h5><h5 class="panel-title" ng-hide="isDefinedAndNotNull(selectedSalesFilter)"><span translate="salesFilter.overview.search.title-new"></span></h5></div><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-4"><!--<div class="panel panel-default">--><!--<div class="panel-body">--><div class="row"><div class="col-xs-12"><h5><span translate="salesFilter.overview.search.relation.filter.title"></span></h5></div></div><div class="row"><div class="col-xs-12"><!--account managers--><select id="accountManager_select" class="form-control input-sm" ng-options="accountManager as $root.displayFields([accountManager.lastName, accountManager.firstName]) for accountManager in accountManagerReferenceFilterList track by accountManager.id" ng-model="salesFilter.selectedUser" tabindex="0"><option value="" translate="salesFilter.overview.search.user.defaultOption">All Users</option></select></div></div><div class="row"><div class="col-xs-12"><span class="input-group input-group-sm"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialFrom.placeholder.from\' | translate}}" class="form-control" name="potentialFrom" ng-model="salesFilter.potentialFrom" type="number" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialTo.placeholder.to\' | translate}}" class="form-control" name="topotential" ng-model="salesFilter.potentialTo" type="number" ng-model-options="{ debounce: 500 }"></span></div></div><div class="row"><div class="col-xs-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'salesFilter.overview.search.firstName.placeholder\' | translate}}" name="firstName" ng-model="salesFilter.firstName" type="String" ng-model-options="{ debounce: 250 }"></div><div class="col-xs-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'salesFilter.overview.search.lastName.placeholder\' | translate}}" name="lastName" ng-model="salesFilter.lastName" type="String" ng-model-options="{ debounce: 250 }"></div></div><!--</div>--><!--</div>--></div><div class="col-xs-12 col-sm-8"><!--<div class="panel panel-default">--><!--<div class="panel-body">--><div class="row"><div class="col-xs-12"><h5><span translate="salesFilter.overview.search.event.filter.title"></span></h5></div></div><div class="row"><div class="col-xs-12"><span class="input-group"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="fromstartDate" ng-model="salesFilter.startDateFrom" type="date" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="tostartDate" ng-model="salesFilter.startDateTo" type="date" ng-model-options="{ debounce: 500 }"></span></div></div><div class="row"><div class="col-xs-6"><ui-select multiple="multiple" ng-model="salesFilter.selectedTemplateEventList" title="Choose an event sub category"><ui-select-match placeholder="{{ \'salesFilter.dialog.salesFilterTemplateEvent.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent in salesFilter.templateEventList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></div><div class="col-xs-6"><ui-select multiple="multiple" ng-model="salesStatusList.selected"><ui-select-match placeholder="Select status">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="status in salesStatusList.items | propsFilter: {displayValue: $select.search}"><small>{{status.displayValue}}</small></ui-select-choices></ui-select></div></div><!--</div>--><!--</div>--></div></div><div class="row"><div class="col-xs-2"><div class="form-group form-group-sm"><label class="control-label col-xs-6" translate="salesFilter.overview.search.pagingPage.label"></label><div class="col-xs-6"><input type="number" class="form-control input-sm" name="pagingPage" id="field_pagingPage" ng-model="salesFilter.pagingPage" placeholder="{{\'salesFilter.overview.search.pagingPage.placeholder\'|translate}}"></div></div></div><div class="col-xs-2"><div class="form-group form-group-sm"><label class="control-label col-xs-6" translate="salesFilter.overview.search.pagingSize.label"></label><div class="col-xs-6"><input type="number" class="form-control input-sm" name="pagingSize" id="field_pagingSize" ng-model="salesFilter.pagingSize" placeholder="{{\'salesFilter.overview.search.pagingSize.placeholder\'|translate}}"><!--<select id="pageSize_select" class="form-control input-sm" ng-options="pageSize as pageSize for pageSize in pageSizeList" ng-model="salesFilter.pagingSize" tabindex="0"></select>--></div></div></div><div class="col-xs-8"><button type="reset" class="btn" ng-click="reset()" ng-disabled="!isRelationSalesFilterSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="salesFilter.overview.search.reset.button">Reset</span></button></div></div></div></div></form></div></div></div><div class="row" ng-if="dto.events.length == 0"><div class="col-xs-12 text-center"><em translate="salesFilter.overview.search.events.not.found"></em></div></div><div class="row" ng-if="dto.events.length > 0"><div class="col-xs-12"><div class="scrolling outer"><div class="inner"><table class="table table-hover table-striped table-condensed"><thead><tr><th>&nbsp;</th><th ng-repeat="event in dto.events"><span tooltip-placement="bottom" uib-tooltip-html="eventDetailTooltip(event)"><a ui-sref="event.detail.subscriptions({eventId:event.id})"><span>{{event.name}}</span></a></span></th></tr><tr><th><span class="text-nowrap right" style="vertical-align: inherit" translate="relation-sales.overview.toggle-relation-details"></span><nz-toggle on-toggle="toggleRelationDetails()" ng-model="showRelationDetails" class="square" tip-false="\'Hide\'" tip-true="\'Show\'"></nz-toggle></th><td ng-repeat="event in dto.events" class="text-center"><span tooltip-placement="bottom" uib-tooltip-html="eventDetailTooltip(event)">{{createDateFromJson(event.startDate)/1000 | customNullableDateTime:\'dd-MM-yy\'}} <strong>({{event.workdaysRemaining}})</strong></span></td></tr><tr><th>&nbsp;</th><th ng-repeat="event in dto.events" class="text-center"><span class="text-nowrap right" tooltip-placement="bottom" uib-tooltip-html="eventDetailTooltip(event)"><span class="badge"><small>{{event.target}} - ({{event.totalConfirmed}} + {{event.totalReserved}}) = {{event.availableSpots}}</small></span></span></th></tr></thead><tbody><tr ng-repeat="relation in dto.relations"><td><span class="pull-left sales-status-relation"><a ui-sref="user-relation.detail({relationId:relation.relation.id})"><span>{{relation.relation.personName}}</span> </a></span><span class="pull-right"><span class="label label-info label-additional" tooltip-placement="bottom" uib-tooltip="Season booking">{{(relation.relation.season) ? \'S\' : \'\'}}</span> <span class="badge">{{relation.relation.potential}}</span></span><br><div uib-collapse="!showRelationDetails"><span class="pull-left sales-status-relation text-nowrap" ng-if="relation.relation.email"><span class="glyphicon glyphicon-envelope" aria-hidden="true"></span> <a href="mailto:{{relation.relation.email}}">{{relation.relation.email}}</a></span><br><span class="pull-left sales-status-relation text-nowrap" ng-if="relation.relation.telephone || relation.relation.mobile"><span class="glyphicon glyphicon-earphone" aria-hidden="true"></span> <span ng-if="relation.relation.telephone">{{relation.relation.telephone}}</span> <span ng-if="relation.relation.mobile"><span ng-if="relation.relation.telephone">&nbsp;/&nbsp;</span>{{relation.relation.mobile}}</span></span></div></td><td ng-repeat="event in dto.events" class="text-left" on-finish-render-grid><mfd-event-relation-status relation="relation.relation" event="event" event-contacts="relation.eventContacts" sales-status="salesStatus" status-cell-style="statusCellStyle"></mfd-event-relation-status></td></tr></tbody></table></div></div></div></div><div class="row" ng-if="dto.events.length > 0"><div class="col-xs-12 text-center"><ul uib-pagination class="pagination-sm" total-items="dto.totalItems" items-per-page="salesFilter.pagingSize" ng-model="salesFilter.pagingPage" ng-change="search()"></ul></div></div><div class="row" ng-show="isDefinedAndNotNull(dto)"><div class="col-xs-12 text-center"><em>{{pageLoadTime}}</em></div></div></div></div>');
$templateCache.put('app/services/mfd-task-progress-service.html','<div class="row" ng-class="customClass"><div class="col-xs-12 col-sm-2"><label>{{title}}</label></div><div class="col-xs-12 col-sm-10"><div uib-progressbar value="taskProgressDto.taskProgress" max="taskProgressDto.taskTotal" ng-show="taskProgressDto !== undefined && taskProgressDto !== null" type="{{type}}">{{taskProgressDto.taskProgressPercentage}}%</div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="register.title">Registration</h3></div></div><div class="panel-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your administrator to activate your account.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="activate.title">Activation</h3></div></div><div class="panel-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h3></div></div><div class="panel-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.currentpassword">New password</label><input type="password" class="form-control" id="currentPassword" name="currentPassword" placeholder="{{\'global.form.currentpassword.placeholder\' | translate}}" ng-model="vm.currentPassword" ng-maxlength="50" required><div ng-show="form.currentPassword.$dirty && form.currentPassword.$invalid"><p class="help-block" ng-show="form.currentPassword.$error.required" data-translate="global.messages.validate.currentpassword.required">Your current password is required.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="10" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 10 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="10" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 10 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h3></div></div><div class="panel-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="configuration.title">Configuration</h3></div></div><div class="panel-body"><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="audits.title">Audits</h3></div></div><div class="panel-body"><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div></div>');
$templateCache.put('app/admin/health/health.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="health.title">Health Checks</h3></div></div><div class="panel-body"><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/metrics/metrics.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="metrics.title">Application Metrics</h3></div><div class="panel-buttons"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></div></div><div class="panel-body"><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="logs.title">Logs</h3></div></div><div class="panel-body"><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h3></div></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.userTypeSelectableDto">Type</span></dt><dd>{{vm.user.userTypeSelectableDto.displayValue}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.user.newPassword" ng-minlength="10" ng-maxlength="50" ng-required="vm.user.id==null"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 10 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.user.newPassword"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="10" ng-maxlength="50" ng-required="vm.user.id==null"><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 10 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.userTypeSelectableDto">TYPE</label><select class="form-control" name="userType" ng-model="vm.user.userTypeSelectableDto" ng-options="userType as userType.name for userType in vm.userTypes track by userType.id"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="userManagement.home.title">Users</h3></div><div class="panel-buttons"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userTypeSelectableDto"><span data-translate="userManagement.userTypeSelectableDto">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td>{{user.userTypeSelectableDto.displayValue}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" id="loginButton" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/article/article-bulkedit-user.html','<div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" id="ArticleDialogTitleCreate" translate="article.dialog.title.bulkedit" translate-value-amount="{{selectedItemsAmount}}">Bulk update 7 Articles</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" ng-disabled="updatingItemsInProgress" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.name.label" for="field_name">Name</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="name" id="field_name" ng-model="article.name" ng-maxlength="100" ng-minlength="2" placeholder="{{\'article.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="100">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.description.label" for="field_description">Description</label><div class="col-xs-12 col-sm-8"><textarea ng-disabled="true" rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="article.description" placeholder="{{\'article.dialog.description.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t</textarea></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.confirmationDescription.$invalid, \'has-success\' : editForm.confirmationDescription.$valid && editForm.confirmationDescription.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.confirmationDescription.label" for="field_confirmationDescription">ConfirmationDescription</label><div class="col-xs-12 col-sm-8"><textarea ng-disabled="true" rows="3" class="form-control input-sm" name="confirmationDescription" id="field_confirmationDescription" ng-model="article.confirmationDescription" placeholder="{{\'article.dialog.confirmationDescription.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t</textarea></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.price.$invalid, \'has-success\' : editForm.price.$valid && editForm.price.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.price.label" for="field_price">Price</label><div class="col-xs-12 col-sm-8"><input type="number" ng-disabled="true" step="0.1" class="form-control input-sm" name="price" id="field_price" ng-model="article.price" placeholder="{{\'article.dialog.price.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #5--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.costPrice.$invalid, \'has-success\' : editForm.costPrice.$valid && editForm.costPrice.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.costPrice.label" for="field_costPrice">CostPrice</label><div class="col-xs-12 col-sm-8"><input type="number" ng-disabled="true" step="0.1" class="form-control input-sm" name="costPrice" id="field_costPrice" ng-model="article.costPrice" placeholder="{{\'article.dialog.costPrice.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.costPrice.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.articleType.$invalid, \'has-success\' : editForm.articleType.$valid && editForm.articleType.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.articleType.label" for="field_articleType">ArticleType</label><div class="col-xs-12 col-sm-8"><select class="form-control input-sm" id="field_articleType" name="articleType" ng-model="article.selectedArticleType" ng-options="articleType as articleType.displayValue for articleType in article.articleTypeList track by articleType.id"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #7--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.includedInstructionHours.$invalid, \'has-success\' : editForm.includedInstructionHours.$valid && editForm.includedInstructionHours.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.includedInstructionHours.label" for="field_includedInstructionHours">IncludedInstructionHours</label><div class="col-xs-12 col-sm-8"><input type="number" ng-disabled="true" step="0.5" class="form-control input-sm" name="includedInstructionHours" id="field_includedInstructionHours" ng-model="article.includedInstructionHours" placeholder="{{\'article.dialog.includedInstructionHours.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #9--></div><div class="row voffset2"><!--row #10--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.vatType.$invalid, \'has-success\' : editForm.vatType.$valid && editForm.vatType.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.vatType.label" for="field_vatType">VatType</label><div class="col-xs-12 col-sm-8"><select ng-disabled="true" class="form-control input-sm" id="field_vatType" name="vatType" ng-model="article.vatType" ng-options="\'VatType.\' + vatType | translate for vatType in article.vatTypeList"><option value=""></option></select></div></div></div><!-- close column--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><i ng-show="updatingItemsInProgress" class="glyphicon glyphicon-refresh">&nbsp;</i> <button type="button" class="btn btn-default" ng-click="clear()" ng-disabled="updatingItemsInProgress"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || updatingItemsInProgress" class="btn btn-primary" title="{{\'article.dialog.bulkupdate.button.hint\'|translate}}"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="article.dialog.bulkupdate.button">Bulk update</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/article/article-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="ArticleDetailTitle" translate="article.detail.title">Article</span> {{article.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="article.detail.creator.label">Creator:</span>&nbsp; <span>{{article.creator}} {{article.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="article.updater">,&nbsp; <span translate="article.detail.updater.label">Updater: </span>&nbsp; <span>{{article.updater}} {{article.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="article.detail.edit({articleId:article.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(article.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="article.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="article.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Article?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="article.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="article.detail.name.label">name</span></td><td><span class="form-control-static">{{article.name}}</span></td></tr><tr><td><span translate="article.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{article.description}}</span></td></tr><tr><td><span translate="article.detail.confirmationDescription.label">confirmationDescription</span></td><td><span class="form-control-static white-space-pre">{{article.confirmationDescription}}</span></td></tr><tr><td><span translate="article.detail.price.label">price</span></td><td><span class="form-control-static">{{article.price | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="article.detail.vatType.label">vatType</span></td><td><span class="form-control-static">{{article.vatType === null ? "" : \'VatType.\' + article.vatType | translate}}</span></td></tr><tr><td><span translate="article.detail.costPrice.label">costPrice</span></td><td><span class="form-control-static">{{article.costPrice | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="article.detail.articleType.label">articleType</span></td><td><span>{{article.articleType.name}}</span></td></tr><tr><td><span translate="article.detail.includedInstructionHours.label">includedInstructionHours</span></td><td><span class="form-control-static">{{article.includedInstructionHours | number: 0}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.articleActiveTab"><uib-tab id="tab-orderlines-overview-mapped-by-article" heading="{{\'article.detail.tab.orderLine.by.article\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><orderlines-overview-mapped-by-article read-only="true" mapped-by-id="articleId" mapped-by="\'article\'" mapped-by-type="\'article\'"></orderlines-overview-mapped-by-article></uib-tab><uib-tab id="tab-articlerelationprices-overview-mapped-by-article" heading="{{\'article.detail.tab.articleRelationPrice.by.article\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><articlerelationprices-overview-mapped-by-article read-only="true" mapped-by-id="articleId" mapped-by="\'article\'" mapped-by-type="\'article\'"></articlerelationprices-overview-mapped-by-article></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/article/article-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="ArticleDialogTitleCreate" translate="article.dialog.title.create">Create a Article</h4><h4 class="modal-title" ng-show="isEdit()" id="ArticleDialogTitleEdit" translate="article.dialog.title.edit" translate-value-id="{{article.id}}">Edit a Article</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="article.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="article.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="article.name" required ng-maxlength="100" placeholder="{{\'article.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="100">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="article.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="article.description" required ng-maxlength="-1" placeholder="{{\'article.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.confirmationDescription.$invalid, \'has-success\' : editForm.confirmationDescription.$valid && editForm.confirmationDescription.$dirty }"><label for="field_confirmationDescription" id="label_confirmationDescription" class="col-sm-2 control-label" translate="article.dialog.confirmationDescription.label">ConfirmationDescription</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="confirmationDescription" id="field_confirmationDescription" ng-model="article.confirmationDescription" ng-maxlength="-1" placeholder="{{\'article.dialog.confirmationDescription.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.price.$invalid, \'has-success\' : editForm.price.$valid && editForm.price.$dirty }"><label for="field_price" id="label_price" class="col-sm-2 control-label" translate="article.dialog.price.label">Price</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="price" id="field_price" ng-model="article.price" ng-currency currency-symbol="\u20AC" 2 fraction="2" required placeholder="{{\'article.dialog.price.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.price.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.price.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.price.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.vatType.$invalid, \'has-success\' : editForm.vatType.$valid && editForm.vatType.$dirty }"><label for="field_vatType" class="col-sm-2 control-label" translate="article.dialog.vatType.label">vatType</label><div class="col-sm-9"><select ng-disabled="\'vatType\' == mappedBy" class="form-control input-sm" id="field_vatType" name="vatType" ng-model="article.vatType" required ng-options="\'VatType.\' + vatType | translate for vatType in vatTypeList"><option value=""></option></select><div ng-show="editForm.vatType.$invalid"><p class="help-block" ng-show="editForm.vatType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.costPrice.$invalid, \'has-success\' : editForm.costPrice.$valid && editForm.costPrice.$dirty }"><label for="field_costPrice" id="label_costPrice" class="col-sm-2 control-label" translate="article.dialog.costPrice.label">CostPrice</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="costPrice" id="field_costPrice" ng-model="article.costPrice" ng-currency currency-symbol="\u20AC" 2 fraction="2" required min="0" placeholder="{{\'article.dialog.costPrice.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.costPrice.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.costPrice.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.costPrice.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.articleType.$invalid, \'has-success\' : editForm.articleType.$valid && editForm.articleType.$dirty }"><label for="field_articleType" class="col-sm-2 control-label" translate="article.dialog.articleType.label">articleType</label><div class="col-sm-9"><select ng-disabled="\'articleType\' == mappedBy" class="form-control input-sm" id="field_articleType" name="articleType" ng-model="article.articleType" required ng-options="articleType as articleType.name for articleType in articleTypeList track by articleType.id"><option value=""></option></select><div ng-show="editForm.articleType.$invalid"><p class="help-block" ng-show="editForm.articleType.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new articletype" ng-disabled="\'articleType\' == mappedBy" ng-click="createArticleType()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.includedInstructionHours.$invalid, \'has-success\' : editForm.includedInstructionHours.$valid && editForm.includedInstructionHours.$dirty }"><label for="field_includedInstructionHours" id="label_includedInstructionHours" class="col-sm-2 control-label" translate="article.dialog.includedInstructionHours.label">IncludedInstructionHours</label><div class="col-sm-9"><input type="number" step="0.01" class="form-control input-sm" name="includedInstructionHours" id="field_includedInstructionHours" ng-model="article.includedInstructionHours" ng-maxlength="-1" placeholder="{{\'article.dialog.includedInstructionHours.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.includedInstructionHours.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.includedInstructionHours.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="article.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="article.dialog.saveAndNew.button">Save</span></button></div></form>');
$templateCache.put('app/entities/article/article-edit-user.html','<!--// Created by html/angular/entity/dto-edit.ftl--><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="!isEdit()" id="ArticleDialogTitleCreate" translate="article.dialog.title.create">Create a Article</h3><h3 class="voffset" ng-show="isEdit()" id="ArticleDialogTitleEdit" translate="article.dialog.title.edit" translate-value-id="{{article.id}}">Edit a Article</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.name.label" for="field_name">Name</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="article.name" required ng-maxlength="100" ng-minlength="2" placeholder="{{\'article.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="100">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.description.label" for="field_description">Description</label><div class="col-xs-12 col-sm-8"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="article.description" required placeholder="{{\'article.dialog.description.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t</textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.confirmationDescription.$invalid, \'has-success\' : editForm.confirmationDescription.$valid && editForm.confirmationDescription.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.confirmationDescription.label" for="field_confirmationDescription">ConfirmationDescription</label><div class="col-xs-12 col-sm-8"><textarea rows="3" class="form-control input-sm" name="confirmationDescription" id="field_confirmationDescription" ng-model="article.confirmationDescription" placeholder="{{\'article.dialog.confirmationDescription.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t</textarea></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.price.$invalid, \'has-success\' : editForm.price.$valid && editForm.price.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.price.label" for="field_price">Price</label><div class="col-xs-12 col-sm-8"><input type="number" step="0.1" class="form-control input-sm" name="price" id="field_price" ng-model="article.price" required placeholder="{{\'article.dialog.price.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.price.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #5--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.costPrice.$invalid, \'has-success\' : editForm.costPrice.$valid && editForm.costPrice.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.costPrice.label" for="field_costPrice">CostPrice</label><div class="col-xs-12 col-sm-8"><input type="number" step="0.1" class="form-control input-sm" name="costPrice" id="field_costPrice" ng-model="article.costPrice" required placeholder="{{\'article.dialog.costPrice.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.costPrice.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.costPrice.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.articleType.$invalid, \'has-success\' : editForm.articleType.$valid && editForm.articleType.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.articleType.label" for="field_articleType">ArticleType</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'articleType\' == mappedBy" class="form-control input-sm" id="field_articleType" name="articleType" ng-model="article.selectedArticleType" required ng-options="articleType as articleType.displayValue for articleType in article.articleTypeList track by articleType.id"><option value=""></option></select><p class="help-block" ng-show="editForm.articleType.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #7--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.includedInstructionHours.$invalid, \'has-success\' : editForm.includedInstructionHours.$valid && editForm.includedInstructionHours.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.includedInstructionHours.label" for="field_includedInstructionHours">IncludedInstructionHours</label><div class="col-xs-12 col-sm-8"><input type="number" step="0.5" class="form-control input-sm" name="includedInstructionHours" id="field_includedInstructionHours" ng-model="article.includedInstructionHours" placeholder="{{\'article.dialog.includedInstructionHours.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #9--></div><div class="row voffset2"><!--row #10--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.vatType.$invalid, \'has-success\' : editForm.vatType.$valid && editForm.vatType.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="article.dialog.vatType.label" for="field_vatType">VatType</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'vatType\' == mappedBy" class="form-control input-sm" id="field_vatType" name="vatType" ng-model="article.vatType" required ng-options="\'VatType.\' + vatType | translate for vatType in article.vatTypeList"><option value=""></option></select><p class="help-block" ng-show="editForm.vatType.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><!-- close column--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="article.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="article.dialog.saveAndNew.button">Save</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/article/article-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="article.overview.title">Articles</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createArticleButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="article.overview.button.new">Create a new Article</span></button> <button type="button" id="updateSelectedArticleButton" class="btn btn-success" ng-disabled="selectedArticleList.length == 0" ng-click="multipleUpdate()"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="article.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="article.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Article</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="article.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="ArticleSearchOverview.predicate" ascending="ArticleSearchOverview.ascending" callback="search()"><th style="width:20px"><tri-state-checkbox class="toggle-all" items="articleList" top-level-click="toggleSelection" child-click="childClick"></tri-state-checkbox></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="article.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="article.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="article.overview.results.header.price.label">price</span></th><th jh-sort-by="vatType" class="sortable hidden-xs"><span class="pull-left" translate="article.overview.results.header.vatType.label">vatType</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'vatType\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="article.overview.results.header.costPrice.label">costPrice</span></th><th jh-sort-by="articleType.name" class="sortable"><span class="pull-left" translate="article.overview.results.header.articleType.label">articleType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td></td><td><!-- column #0--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'article.overview.search.name.placeholder\' | translate}}" name="name" ng-model="ArticleSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #1--></td><td><!-- column #2--></td><td class="hidden-xs"><!-- column #3--><select id="vatType_select" class="form-control input-sm" ng-model="ArticleSearchOverview.vatType" tabindex="0" ng-change="search()" ng-options="\'VatType.\' + vatType | translate for vatType in vatTypeList"><option value="" translate="article.overview.search.vatType.defaultOption">All VatTypes</option></select></td><td><!-- column #4--></td><td><!-- column #5--><select id="articleType_select" class="form-control input-sm" ng-options="articleType as articleType.displayValue for articleType in articleTypeReferenceFilterList track by articleType.id" ng-model="ArticleSearchOverview.articleType" tabindex="0" ng-change="search()"><option value="" translate="article.overview.search.articleType.defaultOption">All ArticleTypes</option></select></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isArticleSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="article in articleList"><td class="td-checkbox"><input type="checkbox" ng-model="article.isSelected" ng-click="selectionChanged(article)"></td><td id="article.nameId{{$index}}"><strong>{{article.name}}</strong></td><td id="article.descriptionId{{$index}}">{{article.description | visibleLimitTo:250 }}</td><td id="article.priceId{{$index}}"><strong>{{article.price | currency:"\u20AC":2}}</strong></td><td class="hidden-xs">{{article.vatTypeDisplayValue === null ? "" : article.vatTypeDisplayValue | translate}}</td><td id="article.costPriceId{{$index}}">{{article.costPrice | currency:"\u20AC":2}}</td><td><span>{{article.articleTypeDisplayValue}}</span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Article{{$index}}" type="submit" ui-sref="user-article.detail({articleId:article.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Article{{$index}}" type="submit" ui-sref="user-article.edit({articleId:article.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticle{{$index}}" type="submit" ng-click="singleDelete(article.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="ArticleSearchOverview.page" ng-change="search()"></ul></div><div class="col-xs-12 col-md-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/article/article-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"><button id="createArticleButton" class="btn btn-primary" ng-click="goToNewState()" ng-if="showCreateButtonTab"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="article.overview.button.new">Create a new Article</span></button> <button type="button" id="updateSelectedArticleButton" class="btn btn-success" ng-disabled="selectedArticleList.length == 0" ng-click="multipleUpdate()"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteArticleConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="article.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="article.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Article</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="article.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th style="width:20px" ng-if="showCreateButtonTab"><tri-state-checkbox class="toggle-all" items="articleList" top-level-click="toggleSelection" child-click="childClick"></tri-state-checkbox></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="article.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="article.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="article.overview.results.header.price.label">price</span></th><th jh-sort-by="vatType" class="sortable hidden-xs"><span class="pull-left" translate="article.overview.results.header.vatType.label">vatType</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'vatType\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="article.overview.results.header.costPrice.label">costPrice</span></th><th ng-hide="mappedBy == \'articleType\'" jh-sort-by="articleType.name" class="sortable"><span class="pull-left" translate="article.overview.results.header.articleType.label">articleType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="article in articleList"><td class="td-checkbox" ng-if="showCreateButtonTab"><input type="checkbox" ng-model="article.isSelected" ng-click="selectionChanged(article)"></td><td id="article.nameId{{$index}}"><strong>{{article.name}}</strong></td><td id="article.descriptionId{{$index}}">{{article.description | visibleLimitTo:250 }}</td><td id="article.priceId{{$index}}"><strong>{{article.price | currency:"\u20AC":2}}</strong></td><td class="hidden-xs">{{article.vatTypeDisplayValue === null ? "" : article.vatTypeDisplayValue | translate}}</td><td id="article.costPriceId{{$index}}">{{article.costPrice | currency:"\u20AC":2}}</td><td ng-hide="mappedBy == \'articleType\'"><span>{{article.articleTypeDisplayValue}}</span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Article{{$index}}" type="submit" ui-sref="user-article.detail({articleId:article.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Article{{$index}}" type="submit" ui-sref="user-article.edit({articleId:article.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticle{{$index}}" type="submit" ng-click="singleDelete(article.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div><div class="col-xs-12 col-md-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="loadAll()"></div></div></div></div></div>');
$templateCache.put('app/entities/article/article-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createArticleButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="article.overview.button.new">Create a new Article</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteArticleConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="article.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="article.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Article</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="article.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="article.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="article.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="confirmationDescription" class="sortable"><span class="pull-left" translate="article.overview.results.header.confirmationDescription.label">confirmationDescription</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'confirmationDescription\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="article.overview.results.header.price.label">price</span></th><th><span translate="article.overview.results.header.costPrice.label">costPrice</span></th><th jh-sort-by="includedInstructionHours" class="sortable hidden-xs"><span class="pull-left" translate="article.overview.results.header.includedInstructionHours.label">includedInstructionHours</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'includedInstructionHours\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'articleType\'" jh-sort-by="articleType.name" class="sortable"><span class="pull-left" translate="article.overview.results.header.articleType.label">articleType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="article in articleList"><td id="article.nameId{{$index}}"><strong>{{article.name}}</strong></td><td id="article.descriptionId{{$index}}">{{article.description | visibleLimitTo:250 }}</td><td id="article.confirmationDescriptionId{{$index}}">{{article.confirmationDescription | visibleLimitTo:250 }}</td><td id="article.priceId{{$index}}"><strong>{{article.price | currency:"\u20AC":2}}</strong></td><td id="article.costPriceId{{$index}}">{{article.costPrice | currency:"\u20AC":2}}</td><td class="hidden-xs" id="article.includedInstructionHoursId{{$index}}">{{article.includedInstructionHours | number: 3}}</td><td ng-hide="mappedBy == \'articleType\'"><span>{{article.articleType.name}}</span></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Article{{$index}}" type="submit" ui-sref="article.detail({articleId:article.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Article{{$index}}" type="submit" ng-click="goToEditState(article)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticle{{$index}}" type="submit" ng-click="singleDelete(article.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="loadAll()"></select></div></div></div></div></div>');
$templateCache.put('app/entities/article/article-view-user.html','<!-- Created by html/angular/entity/dto-view.ftl --><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="ArticleDetailTitle" translate="article.detail.title">Article</span> {{article.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="article.detail.creator.label">Creator:</span>&nbsp; <span>{{article.creator}} {{article.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="article.updater">,&nbsp; <span translate="article.detail.updater.label">Updater: </span>&nbsp; <span>{{article.updater}} {{article.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button id="btn_edit_Article{{$index}}" type="submit" ui-sref="user-article.edit({articleId:article.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button><p>&nbsp;</p></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(article.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="article.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="article.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Article?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="article.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="row"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed layout-container"><tbody><tr><!--row #1--><td style="width: 50%"><!--column #1--><label translate="article.detail.name.label">Name</label></td><td style="width: 50%"><!--column #2--> <span>{{article.name}}</span></td></tr><tr><!--row #2--><td style="width: 50%"><!--column #1--><label translate="article.detail.description.label">Description</label></td><td style="width: 50%"><!--column #2--><textarea ng-model="article.description" disabled="disabled" class="form-control" rows="5"></textarea></td></tr><tr><!--row #3--><td style="width: 50%"><!--column #1--><label translate="article.detail.confirmationDescription.label">ConfirmationDescription</label></td><td style="width: 50%"><!--column #2--><textarea ng-model="article.confirmationDescription" disabled="disabled" class="form-control" rows="5"></textarea></td></tr><tr><!--row #4--><td style="width: 50%"><!--column #1--><label translate="article.detail.price.label">Price</label></td><td style="width: 50%"><!--column #2--> <span>{{article.price | currency:"":0}}</span></td></tr><tr><!--row #5--><td style="width: 50%"><!--column #1--><label translate="article.detail.costPrice.label">CostPrice</label></td><td style="width: 50%"><!--column #2--> <span>{{article.costPrice | currency:"":2}}</span></td></tr><tr><!--row #6--><td style="width: 50%"><!--column #1--><label translate="article.detail.articleType.label">ArticleType</label></td><td style="width: 50%"><!--column #2--> <span>{{article.articleTypeDisplayValue}}</span></td></tr><tr><!--row #7--><td style="width: 50%"></td><td style="width: 50%"></td></tr><tr><!--row #8--><td style="width: 50%"><!--column #1--><label translate="article.detail.includedInstructionHours.label">IncludedInstructionHours</label></td><td style="width: 50%"><!--column #2--> <span>{{article.includedInstructionHours | number: 0}}</span></td></tr><tr><!--row #9--><td style="width: 50%"><!--column #1--><label translate="article.detail.vatType.label">VatType</label></td><td style="width: 50%"><!--column #2--> <span class="form-control-static">{{article.vatTypeDisplayValue === null ? "" : article.vatTypeDisplayValue | translate}}</span></td></tr><!-- END row in rows --></tbody></table></div></div></div><div class="row"><div class="col-xs-12"><div><uib-tabset active="$root.relationActiveTab"><uib-tab id="tab-articlerelationprices-overview-mapped-by-article" heading="{{\'article.detail.tab.articleRelationPrice.by.article\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><articlerelationprices-overview-mapped-by-article read-only="true" mapped-by-id="articleId" mapped-by="\'article\'" mapped-by-type="\'article\'"></articlerelationprices-overview-mapped-by-article></uib-tab></uib-tabset></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/article/articles.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="article.overview.title">Articles</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createArticleButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="article.overview.button.new">Create a new Article</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="article.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="article.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Article</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="article.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="article.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="ArticleSearchOverview.predicate" ascending="ArticleSearchOverview.ascending" callback="search()"><th jh-sort-by="articleType.name" class="sortable"><span class="pull-left" translate="article.overview.results.header.articleType.label">articleType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="article.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="article.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="confirmationDescription" class="sortable"><span class="pull-left" translate="article.overview.results.header.confirmationDescription.label">confirmationDescription</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'confirmationDescription\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="article.overview.results.header.price.label">price</span></th><th jh-sort-by="vatType" class="sortable hidden-xs"><span translate="article.overview.results.header.vatType.label">vatType</span> <span class="glyphicon {{getSortIcon(\'vatType\')}}"></span></th><th><span translate="article.overview.results.header.costPrice.label">costPrice</span></th><th jh-sort-by="includedInstructionHours" class="sortable hidden-xs"><span class="pull-left" translate="article.overview.results.header.includedInstructionHours.label">includedInstructionHours</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'includedInstructionHours\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td><!-- column #0--><select id="articleType_select" class="form-control input-sm" ng-options="articleType as articleType.name for articleType in articleTypeReferenceFilterList track by articleType.id" ng-model="ArticleSearchOverview.articleType" tabindex="0" ng-change="search()"><option value="" translate="article.overview.search.articleType.defaultOption">All ArticleTypes</option></select></td><td><!-- column #1--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'article.overview.search.name.placeholder\' | translate}}" name="name" ng-model="ArticleSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #2--></td><td><!-- column #3--></td><td><!-- column #4--></td><td class="hidden-xs"><!-- column #5--><select id="vatType_select" class="form-control input-sm" ng-model="ArticleSearchOverview.vatType" tabindex="0" ng-change="search()" ng-options="\'VatType.\' + vatType | translate for vatType in vatTypeList"><option value="" translate="article.overview.search.vatType.defaultOption">All VatTypes</option></select></td><td><!-- column #6--></td><td class="hidden-xs"><!-- column #7--></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isArticleSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="article in articleList"><td><span>{{article.articleType.name}}</span></td><td id="article.nameId{{$index}}"><strong>{{article.name}}</strong></td><td id="article.descriptionId{{$index}}">{{article.description | visibleLimitTo:250 }}</td><td id="article.confirmationDescriptionId{{$index}}">{{article.confirmationDescription | visibleLimitTo:250 }}</td><td id="article.priceId{{$index}}"><strong>{{article.price | currency:"\u20AC":2}}</strong></td><td class="hidden-xs">{{article.vatType === null ? "" : \'VatType.\' + article.vatType | translate}}</td><td id="article.costPriceId{{$index}}">{{article.costPrice | currency:"\u20AC":2}}</td><td class="hidden-xs" id="article.includedInstructionHoursId{{$index}}">{{article.includedInstructionHours | number: 3}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Article{{$index}}" type="submit" ui-sref="article.detail({articleId:article.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Article{{$index}}" type="submit" ng-click="goToEditState(article)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticle{{$index}}" type="submit" ng-click="singleDelete(article.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="ArticleSearchOverview.page" ng-change="search()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></select></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/articletype/articletype-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="ArticleTypeDetailTitle" translate="articleType.detail.title">ArticleType</span> {{articleType.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="articleType.detail.creator.label">Creator:</span>&nbsp; <span>{{articleType.creator}} {{articleType.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="articleType.updater">,&nbsp; <span translate="articleType.detail.updater.label">Updater: </span>&nbsp; <span>{{articleType.updater}} {{articleType.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="articletype.detail.edit({articleTypeId:articleType.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteArticleTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(articleType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="articleType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="articleType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this ArticleType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="articleType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="articleType.detail.name.label">name</span></td><td><span class="form-control-static">{{articleType.name}}</span></td></tr><tr><td><span translate="articleType.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{articleType.description}}</span></td></tr><tr><td><span translate="articleType.detail.predefinedArticleType.label">predefinedArticleType</span></td><td><span class="form-control-static">{{articleType.predefinedArticleType === null ? "" : \'PredefinedArticleType.\' + articleType.predefinedArticleType | translate}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.articleTypeActiveTab"><uib-tab id="tab-articles-overview-mapped-by-articleType" heading="{{\'articleType.detail.tab.article.by.articleType\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><articles-overview-mapped-by-articletype read-only="true" mapped-by-id="articleTypeId" mapped-by="\'articleType\'" mapped-by-type="\'articletype\'"></articles-overview-mapped-by-articletype></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/articletype/articletype-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="ArticleTypeDialogTitleCreate" translate="articleType.dialog.title.create">Create a ArticleType</h4><h4 class="modal-title" ng-show="isEdit()" id="ArticleTypeDialogTitleEdit" translate="articleType.dialog.title.edit" translate-value-id="{{articleType.id}}">Edit a ArticleType</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="articleType.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="articleType.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="articleType.name" required ng-maxlength="50" placeholder="{{\'articleType.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="articleType.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="articleType.description" required ng-maxlength="-1" placeholder="{{\'articleType.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.predefinedArticleType.$invalid, \'has-success\' : editForm.predefinedArticleType.$valid && editForm.predefinedArticleType.$dirty }"><label for="field_predefinedArticleType" class="col-sm-2 control-label" translate="articleType.dialog.predefinedArticleType.label">predefinedArticleType</label><div class="col-sm-9"><select ng-disabled="\'predefinedArticleType\' == mappedBy" class="form-control input-sm" id="field_predefinedArticleType" name="predefinedArticleType" ng-model="articleType.predefinedArticleType" ng-options="\'PredefinedArticleType.\' + predefinedArticleType | translate for predefinedArticleType in predefinedArticleTypeList"><option value=""></option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleType.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="articleType.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/articletype/articletype-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createArticleTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="articleType.overview.button.new">Create a new ArticleType</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteArticleTypeConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="articleType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="articleType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this ArticleType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticleType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="articleType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="articleType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="articleType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="articleType in articleTypeList"><td id="articleType.nameId{{$index}}">{{articleType.name}}</td><td id="articleType.descriptionId{{$index}}">{{articleType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_ArticleType{{$index}}" type="submit" ui-sref="articletype.detail({articleTypeId:articleType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_ArticleType{{$index}}" type="submit" ng-click="goToEditState(articleType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticleType{{$index}}" type="submit" ng-click="singleDelete(articleType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/articletype/articletypes.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="articleType.overview.title">ArticleTypes</h3></div><div class="panel-buttons"><button id="createArticleTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="articleType.overview.button.new">Create a new ArticleType</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteArticleTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="articleType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="articleType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this ArticleType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticleType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="articleType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="articleType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="articleType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="predefinedArticleType" class="sortable"><span translate="articleType.overview.results.header.predefinedArticleType.label">predefinedArticleType</span> <span class="glyphicon {{getSortIcon(\'predefinedArticleType\')}}"></span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="articleType in articleTypeList"><td id="articleType.nameId{{$index}}">{{articleType.name}}</td><td id="articleType.descriptionId{{$index}}">{{articleType.description | visibleLimitTo:250 }}</td><td>{{articleType.predefinedArticleType === null ? "" : \'PredefinedArticleType.\' + articleType.predefinedArticleType | translate}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_ArticleType{{$index}}" type="submit" ui-sref="articletype.detail({articleTypeId:articleType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_ArticleType{{$index}}" type="submit" ng-click="goToEditState(articleType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticleType{{$index}}" type="submit" ng-click="singleDelete(articleType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/basemodel/basemodel-detail.html','<div has-any-authority=""><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="BaseModelDetailTitle" translate="baseModel.detail.title">BaseModel</span> {{baseModel.name}}</h3></div><div class="panel-buttons"><button ui-sref="basemodel.detail.edit({baseModelId:baseModel.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteBaseModelConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(baseModel.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="baseModel.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="baseModel.overview.results.buttons.delete.confirmation">Are you sure you want to delete this BaseModel?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="baseModel.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="baseModel.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/basemodel/basemodel-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="baseModel in baseModelList"><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_BaseModel{{$index}}" type="submit" ui-sref="basemodel.detail({baseModelId:baseModel.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/basemodel/basemodels.html','<div id="content"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="baseModel.overview.title">BaseModels</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="baseModel in baseModelList"><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_BaseModel{{$index}}" type="submit" ui-sref="basemodel.detail({baseModelId:baseModel.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/articlerelationprice/articlerelationprice-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="ArticleRelationPriceDetailTitle" translate="articleRelationPrice.detail.title">ArticleRelationPrice</span> {{articleRelationPrice.price}}</h3></div><div class="panel-buttons"><button ui-sref="articlerelationprice.detail.edit({articleRelationPriceId:articleRelationPrice.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteArticleRelationPriceConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(articleRelationPrice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="articleRelationPrice.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="articleRelationPrice.overview.results.buttons.delete.confirmation">Are you sure you want to delete this ArticleRelationPrice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleRelationPrice.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="articleRelationPrice.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="articleRelationPrice.detail.relation.label">relation</span></td><td><a ui-sref="user-relation.detail({relationId:articleRelationPrice.relation.id})"><span>{{$root.displayFields([articleRelationPrice.relation.externalId, articleRelationPrice.relation.firstName, articleRelationPrice.relation.lastName, articleRelationPrice.relation.companyName])}}</span></a></td></tr><tr><td><span translate="articleRelationPrice.detail.article.label">article</span></td><td><a ui-sref="user-article.detail({articleId:articleRelationPrice.article.id})"><span>{{$root.displayFields([articleRelationPrice.article.name, articleRelationPrice.article.price])}}</span></a></td></tr><tr><td><span translate="articleRelationPrice.detail.price.label">price</span></td><td><span class="form-control-static">{{articleRelationPrice.price | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="articleRelationPrice.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{articleRelationPrice.description}}</span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/articlerelationprice/articlerelationprice-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="ArticleRelationPriceDialogTitleCreate" translate="articleRelationPrice.dialog.title.create">Create a ArticleRelationPrice</h4><h4 class="modal-title" ng-show="isEdit()" id="ArticleRelationPriceDialogTitleEdit" translate="articleRelationPrice.dialog.title.edit" translate-value-id="{{articleRelationPrice.id}}">Edit a ArticleRelationPrice</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="articleRelationPrice.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relation.$invalid, \'has-success\' : editForm.relation.$valid && editForm.relation.$dirty }"><label for="field_relation" class="col-sm-2 control-label" translate="articleRelationPrice.dialog.relation.label">relation</label><div class="col-sm-9"><input ng-disabled="\'relation\' == mappedBy" type="text" id="field_relation" name="relation" ng-model="articleRelationPrice.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsForRelation" placeholder="{{\'articleRelationPrice.dialog.relation.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.relation.$invalid"><p class="help-block" ng-show="editForm.relation.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.article.$invalid, \'has-success\' : editForm.article.$valid && editForm.article.$dirty }"><label for="field_article" class="col-sm-2 control-label" translate="articleRelationPrice.dialog.article.label">article</label><div class="col-sm-9"><select ng-disabled="\'article\' == mappedBy" class="form-control input-sm" id="field_article" name="article" ng-model="articleRelationPrice.article" required ng-options="article as $root.displayFields([article.name, article.price]) for article in articleList track by article.id"><option value=""></option></select><div ng-show="editForm.article.$invalid"><p class="help-block" ng-show="editForm.article.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new article" ng-disabled="\'article\' == mappedBy" ng-click="createArticle()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.price.$invalid, \'has-success\' : editForm.price.$valid && editForm.price.$dirty }"><label for="field_price" id="label_price" class="col-sm-2 control-label" translate="articleRelationPrice.dialog.price.label">Price</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="price" id="field_price" ng-model="articleRelationPrice.price" ng-currency currency-symbol="\u20AC" 2 fraction="2" required placeholder="{{\'articleRelationPrice.dialog.price.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.price.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.price.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.price.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="articleRelationPrice.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="articleRelationPrice.description" ng-maxlength="-1" placeholder="{{\'articleRelationPrice.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.description.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleRelationPrice.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="articleRelationPrice.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/articlerelationprice/articlerelationprice-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createArticleRelationPriceButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="articleRelationPrice.overview.button.new">Create a new ArticleRelationPrice</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm" ng-hide="mappedBy == \'article\'"><label class="col-md-2 col-md-offset-2 control-label" translate="articleRelationPrice.overview.search.article.label">article</label><div class="col-md-6"><select id="article_select" class="form-control input-sm" ng-options="article as $root.displayFields([article.name, article.price]) for article in articleReferenceFilterList track by article.id" ng-model="ArticleRelationPriceSearchTab.article" tabindex="0" ng-change="search()"><option value="" translate="articleRelationPrice.overview.search.article.defaultOption">All Articles</option></select></div></div><div class="form-group form-group-sm" ng-hide="mappedBy == \'relation\'"><label class="col-md-2 col-md-offset-2 control-label" translate="articleRelationPrice.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="ArticleRelationPriceSearchTab.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'articleRelationPrice.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="articleRelationPrice.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isArticleRelationPriceSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="articleRelationPrice.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteArticleRelationPriceConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="articleRelationPrice.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="articleRelationPrice.overview.results.buttons.delete.confirmation">Are you sure you want to delete this ArticleRelationPrice</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleRelationPrice.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticleRelationPrice" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="articleRelationPrice.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="ArticleRelationPriceSearchTab.predicate" ascending="ArticleRelationPriceSearchTab.ascending" callback="search()"><th ng-hide="mappedBy == \'relation\'" jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="articleRelationPrice.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'article\'" jh-sort-by="article.name" class="sortable hidden-xs"><span class="pull-left" translate="articleRelationPrice.overview.results.header.article.label">article</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'article.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="articleRelationPrice.overview.results.header.price.label">price</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="articleRelationPrice.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="articleRelationPrice in articleRelationPriceList"><td ng-hide="mappedBy == \'relation\'"><a ui-sref="user-relation.detail({relationId:articleRelationPrice.relation.id})"><span>{{$root.displayFields([articleRelationPrice.relation.externalId, articleRelationPrice.relation.firstName, articleRelationPrice.relation.lastName, articleRelationPrice.relation.companyName])}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'article\'"><a ui-sref="user-article.detail({articleId:articleRelationPrice.article.id})"><span>{{$root.displayFields([articleRelationPrice.article.name, articleRelationPrice.article.price])}}</span></a></td><td id="articleRelationPrice.priceId{{$index}}"><strong>{{articleRelationPrice.price | currency:"\u20AC":2}}</strong></td><td id="articleRelationPrice.descriptionId{{$index}}">{{articleRelationPrice.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_ArticleRelationPrice{{$index}}" type="submit" ui-sref="articlerelationprice.detail({articleRelationPriceId:articleRelationPrice.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_ArticleRelationPrice{{$index}}" type="submit" ng-click="goToEditState(articleRelationPrice)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticleRelationPrice{{$index}}" type="submit" ng-click="singleDelete(articleRelationPrice.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="ArticleRelationPriceSearchTab.page" ng-change="search()"></ul></div></div></div></div>');
$templateCache.put('app/entities/articlerelationprice/articlerelationprices.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="articleRelationPrice.overview.title">ArticleRelationPrices</h3></div><div class="panel-buttons"><button id="createArticleRelationPriceButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="articleRelationPrice.overview.button.new">Create a new ArticleRelationPrice</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="articleRelationPrice.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="ArticleRelationPriceSearchOverview.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'articleRelationPrice.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="articleRelationPrice.overview.search.article.label">article</label><div class="col-md-6"><select id="article_select" class="form-control input-sm" ng-options="article as $root.displayFields([article.name, article.price]) for article in articleReferenceFilterList track by article.id" ng-model="ArticleRelationPriceSearchOverview.article" tabindex="0" ng-change="search()"><option value="" translate="articleRelationPrice.overview.search.article.defaultOption">All Articles</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="articleRelationPrice.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isArticleRelationPriceSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="articleRelationPrice.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteArticleRelationPriceConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="articleRelationPrice.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="articleRelationPrice.overview.results.buttons.delete.confirmation">Are you sure you want to delete this ArticleRelationPrice</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="articleRelationPrice.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteArticleRelationPrice" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="articleRelationPrice.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="ArticleRelationPriceSearchOverview.predicate" ascending="ArticleRelationPriceSearchOverview.ascending" callback="search()"><th jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="articleRelationPrice.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="article.name" class="sortable hidden-xs"><span class="pull-left" translate="articleRelationPrice.overview.results.header.article.label">article</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'article.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="articleRelationPrice.overview.results.header.price.label">price</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="articleRelationPrice.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="articleRelationPrice in articleRelationPriceList"><td><a ui-sref="user-relation.detail({relationId:articleRelationPrice.relation.id})"><span>{{$root.displayFields([articleRelationPrice.relation.externalId, articleRelationPrice.relation.firstName, articleRelationPrice.relation.lastName, articleRelationPrice.relation.companyName])}}</span></a></td><td class="hidden-xs"><a ui-sref="user-article.detail({articleId:articleRelationPrice.article.id})"><span>{{$root.displayFields([articleRelationPrice.article.name, articleRelationPrice.article.price])}}</span></a></td><td id="articleRelationPrice.priceId{{$index}}"><strong>{{articleRelationPrice.price | currency:"\u20AC":2}}</strong></td><td id="articleRelationPrice.descriptionId{{$index}}">{{articleRelationPrice.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_ArticleRelationPrice{{$index}}" type="submit" ui-sref="articlerelationprice.detail({articleRelationPriceId:articleRelationPrice.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_ArticleRelationPrice{{$index}}" type="submit" ng-click="goToEditState(articleRelationPrice)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteArticleRelationPrice{{$index}}" type="submit" ng-click="singleDelete(articleRelationPrice.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="ArticleRelationPriceSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/car/car-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="CarDetailTitle" translate="car.detail.title">Car</span> {{car.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="car.detail.creator.label">Creator:</span>&nbsp; <span>{{car.creator}} {{car.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="car.updater">,&nbsp; <span translate="car.detail.updater.label">Updater: </span>&nbsp; <span>{{car.updater}} {{car.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="car.detail.edit({carId:car.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(car.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="car.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="car.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Car?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="car.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="car.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="car.detail.name.label">name</span></td><td><span class="form-control-static">{{car.name}}</span></td></tr><tr><td><span translate="car.detail.description.label">description</span></td><td><span class="form-control-static">{{car.description}}</span></td></tr><tr><td><span translate="car.detail.licensePlate.label">licensePlate</span></td><td><span class="form-control-static">{{car.licensePlate}}</span></td></tr><tr><td><span translate="car.detail.readyForUse.label">readyForUse</span></td><td><span class="form-control-static">{{car.readyForUse}}</span></td></tr><tr><td><span translate="car.detail.rental.label">rental</span></td><td><span class="form-control-static">{{car.rental}}</span></td></tr><tr><td><span translate="car.detail.service.label">service</span></td><td><span class="form-control-static">{{car.service}}</span></td></tr><tr><td><span translate="car.detail.owner.label">owner</span></td><td><a ui-sref="user-relation.detail({relationId:car.owner.id})"><span>{{$root.displayFields([car.owner.externalId, car.owner.firstName, car.owner.lastName, car.owner.companyName])}}</span></a></td></tr><tr><td><span translate="car.detail.articleForRental.label">articleForRental</span></td><td><a ui-sref="article.detail({articleId:car.articleForRental.id})"><span>{{$root.displayFields([car.articleForRental.name, car.articleForRental.price])}}</span></a></td></tr><tr><td><span translate="car.detail.carRentalType.label">carRentalType</span></td><td><a ui-sref="carrentaltype.detail({carRentalTypeId:car.carRentalType.id})"><span>{{car.carRentalType.name}}</span></a></td></tr></tbody></table></div><div><uib-tabset active="$root.carActiveTab"><uib-tab id="tab-subscriptions-overview-mapped-by-car" heading="{{\'car.detail.tab.subscription.by.car\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><subscriptions-overview-mapped-by-car read-only="true" mapped-by-id="carId" mapped-by="\'car\'" mapped-by-type="\'car\'"></subscriptions-overview-mapped-by-car></uib-tab><uib-tab id="tab-documents-overview-mapped-by-car" heading="{{\'car.detail.tab.document.by.car\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-car read-only="true" mapped-by-id="carId" mapped-by="\'car\'" mapped-by-type="\'car\'"></documents-overview-mapped-by-car></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/car/car-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="CarDialogTitleCreate" translate="car.dialog.title.create">Create a Car</h4><h4 class="modal-title" ng-show="isEdit()" id="CarDialogTitleEdit" translate="car.dialog.title.edit" translate-value-id="{{car.id}}">Edit a Car</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="car.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="car.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="car.name" required ng-maxlength="-1" placeholder="{{\'car.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="car.dialog.description.label">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="car.description" required ng-maxlength="-1" placeholder="{{\'car.dialog.description.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.licensePlate.$invalid, \'has-success\' : editForm.licensePlate.$valid && editForm.licensePlate.$dirty }"><label for="field_licensePlate" id="label_licensePlate" class="col-sm-2 control-label" translate="car.dialog.licensePlate.label">LicensePlate</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="licensePlate" id="field_licensePlate" ng-model="car.licensePlate" ng-maxlength="-1" placeholder="{{\'car.dialog.licensePlate.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.readyForUse.$invalid, \'has-success\' : editForm.readyForUse.$valid && editForm.readyForUse.$dirty }"><label for="field_readyForUse" id="label_readyForUse" class="col-sm-2 control-label" translate="car.dialog.readyForUse.label">ReadyForUse</label><div class="col-sm-9"><nz-toggle id="field_readyForUse" name="readyForUse" ng-model="car.readyForUse" val-true="true" val-false="false" val-null="null" val-default="true" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.rental.$invalid, \'has-success\' : editForm.rental.$valid && editForm.rental.$dirty }"><label for="field_rental" id="label_rental" class="col-sm-2 control-label" translate="car.dialog.rental.label">Rental</label><div class="col-sm-9"><nz-toggle id="field_rental" name="rental" ng-model="car.rental" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.service.$invalid, \'has-success\' : editForm.service.$valid && editForm.service.$dirty }"><label for="field_service" id="label_service" class="col-sm-2 control-label" translate="car.dialog.service.label">Service</label><div class="col-sm-9"><nz-toggle id="field_service" name="service" ng-model="car.service" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.owner.$invalid, \'has-success\' : editForm.owner.$valid && editForm.owner.$dirty }"><label for="field_owner" class="col-sm-2 control-label" translate="car.dialog.owner.label">owner</label><div class="col-sm-9"><input ng-disabled="\'owner\' == mappedBy" type="text" id="field_owner" name="owner" ng-model="car.owner" ng-model-options="$root.modelOptions" uib-typeahead="owner as owner.displayValue for owner in autocompleteRelations($viewValue)" typeahead-loading="loadingOwner" typeahead-no-results="noResultsForOwner" placeholder="{{\'car.dialog.owner.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingOwner" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForOwner"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.owner.$invalid"><p class="help-block" ng-show="editForm.owner.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new owner" ng-disabled="\'owner\' == mappedBy" ng-click="createOwner()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.articleForRental.$invalid, \'has-success\' : editForm.articleForRental.$valid && editForm.articleForRental.$dirty }"><label for="field_articleForRental" class="col-sm-2 control-label" translate="car.dialog.articleForRental.label">articleForRental</label><div class="col-sm-9"><select ng-disabled="\'articleForRental\' == mappedBy" class="form-control input-sm" id="field_articleForRental" name="articleForRental" ng-model="car.articleForRental" ng-options="articleForRental as $root.displayFields([articleForRental.name, articleForRental.price]) for articleForRental in articleForRentalList track by articleForRental.id"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.carRentalType.$invalid, \'has-success\' : editForm.carRentalType.$valid && editForm.carRentalType.$dirty }"><label for="field_carRentalType" class="col-sm-2 control-label" translate="car.dialog.carRentalType.label">carRentalType</label><div class="col-sm-9"><select ng-disabled="\'carRentalType\' == mappedBy" class="form-control input-sm" id="field_carRentalType" name="carRentalType" ng-model="car.carRentalType" ng-options="carRentalType as carRentalType.name for carRentalType in carRentalTypeList track by carRentalType.id"><option value=""></option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="car.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="car.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="car.dialog.saveAndNew.button">Save</span></button></div></form>');
$templateCache.put('app/entities/car/car-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createCarButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="car.overview.button.new">Create a new Car</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="car.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="car.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Car</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="car.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCar" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="car.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="car.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="car.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="licensePlate" class="sortable"><span class="pull-left" translate="car.overview.results.header.licensePlate.label">licensePlate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'licensePlate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="readyForUse" class="sortable"><span class="pull-left" translate="car.overview.results.header.readyForUse.label">readyForUse</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'readyForUse\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="rental" class="sortable"><span class="pull-left" translate="car.overview.results.header.rental.label">rental</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'rental\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="service" class="sortable"><span class="pull-left" translate="car.overview.results.header.service.label">service</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'service\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'owner\'" jh-sort-by="owner.externalId" class="sortable"><span class="pull-left" translate="car.overview.results.header.owner.label">owner</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'owner.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'articleForRental\'" jh-sort-by="articleForRental.name" class="sortable hidden-xs"><span class="pull-left" translate="car.overview.results.header.articleForRental.label">articleForRental</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleForRental.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'carRentalType\'" jh-sort-by="carRentalType.name" class="sortable hidden-xs"><span class="pull-left" translate="car.overview.results.header.carRentalType.label">carRentalType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'carRentalType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="car in carList"><td id="car.nameId{{$index}}">{{car.name}}</td><td id="car.descriptionId{{$index}}">{{car.description}}</td><td id="car.licensePlateId{{$index}}">{{car.licensePlate}}</td><td id="car.readyForUseId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(car.readyForUse)"><span ng-show="car.readyForUse" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!car.readyForUse" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="car.rentalId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(car.rental)"><span ng-show="car.rental" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!car.rental" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="car.serviceId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(car.service)"><span ng-show="car.service" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!car.service" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td ng-hide="mappedBy == \'owner\'"><a ui-sref="user-relation.detail({relationId:car.owner.id})"><span>{{$root.displayFields([car.owner.externalId, car.owner.firstName, car.owner.lastName, car.owner.companyName])}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'articleForRental\'"><a ui-sref="article.detail({articleId:car.articleForRental.id})"><span>{{$root.displayFields([car.articleForRental.name, car.articleForRental.price])}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'carRentalType\'"><a ui-sref="carrentaltype.detail({carRentalTypeId:car.carRentalType.id})"><span>{{car.carRentalType.name}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Car{{$index}}" type="submit" ui-sref="car.detail({carId:car.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Car{{$index}}" type="submit" ng-click="goToEditState(car)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCar{{$index}}" type="submit" ng-click="singleDelete(car.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/car/cars.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="car.overview.title">Cars</h3></div><div class="panel-buttons"><button id="createCarButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="car.overview.button.new">Create a new Car</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'car.overview.search.name.placeholder\' | translate}}" name="name" ng-model="CarSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.licensePlate.label">licensePlate</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'car.overview.search.licensePlate.placeholder\' | translate}}" name="licensePlate" ng-model="CarSearchOverview.licensePlate" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.readyForUse.label">readyForUse</label><div class="col-md-6"><nz-toggle tri-toggle on-toggle="search()" ng-model="CarSearchOverview.readyForUseGroup" class="square"></nz-toggle></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.rental.label">rental</label><div class="col-md-6"><nz-toggle tri-toggle on-toggle="search()" ng-model="CarSearchOverview.rentalGroup" class="square"></nz-toggle></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.service.label">service</label><div class="col-md-6"><nz-toggle tri-toggle on-toggle="search()" ng-model="CarSearchOverview.serviceGroup" class="square"></nz-toggle></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.owner.label">owner</label><div class="col-md-6"><input type="text" id="field_owner" name="owner" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="CarSearchOverview.owner" ng-model-options="$root.modelOptions" uib-typeahead="owner as owner.displayValue for owner in autocompleteRelations($viewValue)" typeahead-loading="loadingOwner" typeahead-no-results="noResultsOwner" placeholder="{{\'car.overview.search.owner.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingOwner" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsOwner"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.articleForRental.label">articleForRental</label><div class="col-md-6"><select id="articleForRental_select" class="form-control input-sm" ng-options="articleForRental as $root.displayFields([articleForRental.name, articleForRental.price]) for articleForRental in articleForRentalReferenceFilterList track by articleForRental.id" ng-model="CarSearchOverview.articleForRental" tabindex="0" ng-change="search()"><option value="" translate="car.overview.search.articleForRental.defaultOption">All Articles</option></select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="car.overview.search.carRentalType.label">carRentalType</label><div class="col-md-6"><select id="carRentalType_select" class="form-control input-sm" ng-options="carRentalType as carRentalType.name for carRentalType in carRentalTypeReferenceFilterList track by carRentalType.id" ng-model="CarSearchOverview.carRentalType" tabindex="0" ng-change="search()"><option value="" translate="car.overview.search.carRentalType.defaultOption">All CarRentalTypes</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="car.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isCarSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="car.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteCarConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="car.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="car.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Car</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="car.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCar" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="car.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="CarSearchOverview.predicate" ascending="CarSearchOverview.ascending" callback="search()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="car.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="car.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="licensePlate" class="sortable"><span class="pull-left" translate="car.overview.results.header.licensePlate.label">licensePlate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'licensePlate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="readyForUse" class="sortable"><span class="pull-left" translate="car.overview.results.header.readyForUse.label">readyForUse</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'readyForUse\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="rental" class="sortable"><span class="pull-left" translate="car.overview.results.header.rental.label">rental</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'rental\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="service" class="sortable"><span class="pull-left" translate="car.overview.results.header.service.label">service</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'service\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="owner.externalId" class="sortable"><span class="pull-left" translate="car.overview.results.header.owner.label">owner</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'owner.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="articleForRental.name" class="sortable hidden-xs"><span class="pull-left" translate="car.overview.results.header.articleForRental.label">articleForRental</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleForRental.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="carRentalType.name" class="sortable hidden-xs"><span class="pull-left" translate="car.overview.results.header.carRentalType.label">carRentalType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'carRentalType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="car in carList"><td id="car.nameId{{$index}}">{{car.name}}</td><td id="car.descriptionId{{$index}}">{{car.description}}</td><td id="car.licensePlateId{{$index}}">{{car.licensePlate}}</td><td id="car.readyForUseId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(car.readyForUse)"><span ng-show="car.readyForUse" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!car.readyForUse" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="car.rentalId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(car.rental)"><span ng-show="car.rental" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!car.rental" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="car.serviceId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(car.service)"><span ng-show="car.service" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!car.service" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td><a ui-sref="user-relation.detail({relationId:car.owner.id})"><span>{{$root.displayFields([car.owner.externalId, car.owner.firstName, car.owner.lastName, car.owner.companyName])}}</span></a></td><td class="hidden-xs"><a ui-sref="article.detail({articleId:car.articleForRental.id})"><span>{{$root.displayFields([car.articleForRental.name, car.articleForRental.price])}}</span></a></td><td class="hidden-xs"><a ui-sref="carrentaltype.detail({carRentalTypeId:car.carRentalType.id})"><span>{{car.carRentalType.name}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Car{{$index}}" type="submit" ui-sref="car.detail({carId:car.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Car{{$index}}" type="submit" ng-click="goToEditState(car)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCar{{$index}}" type="submit" ng-click="singleDelete(car.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="CarSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/carrentaltype/carrentaltype-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="CarRentalTypeDetailTitle" translate="carRentalType.detail.title">CarRentalType</span> {{carRentalType.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="carRentalType.detail.creator.label">Creator:</span>&nbsp; <span>{{carRentalType.creator}} {{carRentalType.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="carRentalType.updater">,&nbsp; <span translate="carRentalType.detail.updater.label">Updater: </span>&nbsp; <span>{{carRentalType.updater}} {{carRentalType.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="carrentaltype.detail.edit({carRentalTypeId:carRentalType.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarRentalTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(carRentalType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="carRentalType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="carRentalType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CarRentalType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="carRentalType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="carRentalType.detail.name.label">name</span></td><td><span class="form-control-static">{{carRentalType.name}}</span></td></tr><tr><td><span translate="carRentalType.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{carRentalType.description}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.carRentalTypeActiveTab"><uib-tab id="tab-cars-overview-mapped-by-carRentalType" heading="{{\'carRentalType.detail.tab.cars.by.carRentalType\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><cars-overview-mapped-by-carrentaltype read-only="true" mapped-by-id="carRentalTypeId" mapped-by="\'carRentalType\'" mapped-by-type="\'carrentaltype\'"></cars-overview-mapped-by-carrentaltype></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/carrentaltype/carrentaltype-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="CarRentalTypeDialogTitleCreate" translate="carRentalType.dialog.title.create">Create a CarRentalType</h4><h4 class="modal-title" ng-show="isEdit()" id="CarRentalTypeDialogTitleEdit" translate="carRentalType.dialog.title.edit" translate-value-id="{{carRentalType.id}}">Edit a CarRentalType</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="carRentalType.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="carRentalType.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="carRentalType.name" required ng-maxlength="50" placeholder="{{\'carRentalType.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="carRentalType.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="carRentalType.description" required ng-maxlength="-1" placeholder="{{\'carRentalType.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalType.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="carRentalType.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/carrentaltype/carrentaltype-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createCarRentalTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="carRentalType.overview.button.new">Create a new CarRentalType</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarRentalTypeConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="carRentalType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="carRentalType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CarRentalType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCarRentalType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="carRentalType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="carRentalType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="carRentalType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="carRentalType in carRentalTypeList"><td id="carRentalType.nameId{{$index}}">{{carRentalType.name}}</td><td id="carRentalType.descriptionId{{$index}}">{{carRentalType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_CarRentalType{{$index}}" type="submit" ui-sref="carrentaltype.detail({carRentalTypeId:carRentalType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_CarRentalType{{$index}}" type="submit" ng-click="goToEditState(carRentalType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCarRentalType{{$index}}" type="submit" ng-click="singleDelete(carRentalType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/carrentaltype/carrentaltypes.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="carRentalType.overview.title">CarRentalTypes</h3></div><div class="panel-buttons"><button id="createCarRentalTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="carRentalType.overview.button.new">Create a new CarRentalType</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarRentalTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="carRentalType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="carRentalType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CarRentalType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCarRentalType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="carRentalType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="carRentalType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="carRentalType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="carRentalType in carRentalTypeList"><td id="carRentalType.nameId{{$index}}">{{carRentalType.name}}</td><td id="carRentalType.descriptionId{{$index}}">{{carRentalType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_CarRentalType{{$index}}" type="submit" ui-sref="carrentaltype.detail({carRentalTypeId:carRentalType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_CarRentalType{{$index}}" type="submit" ng-click="goToEditState(carRentalType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCarRentalType{{$index}}" type="submit" ng-click="singleDelete(carRentalType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/booking/booking-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="BookingDetailTitle" translate="booking.detail.title">Booking</span> {{booking.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="booking.detail.creator.label">Creator:</span>&nbsp; <span>{{booking.creator}} {{booking.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="booking.updater">,&nbsp; <span translate="booking.detail.updater.label">Updater: </span>&nbsp; <span>{{booking.updater}} {{booking.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="booking.detail.edit({bookingId:booking.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button id="billBookingButton" type="button" ng-click="billBooking(booking)" ng-disabled="!booking.id || !booking.status || (booking.status != \'NEW\' && booking.status != \'CHANGED_AFTER_BILLING\')" class="btn btn-info"><span id="billButtonIcon" class="glyphicon glyphicon-euro"></span>&nbsp;<span translate="booking.dialog.bill.button">Bill</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteBookingConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(booking.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="booking.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="booking.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Booking?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="booking.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="booking.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="booking.detail.description.label">description</span></td><td><span class="form-control-static">{{booking.description}}</span></td></tr><tr><td><span translate="booking.detail.confirmationEmailDescription.label">confirmationEmailDescription</span></td><td><span class="form-control-static">{{booking.confirmationEmailDescription}}</span></td></tr><tr><td><span translate="booking.detail.bookingDate.label">bookingDate</span></td><td><span class="form-control-static">{{booking.bookingDate | nullableDate}}</span></td></tr><tr><td><span translate="booking.detail.event.label">event</span></td><td><a ui-sref="event.detail.subscriptions({eventId:booking.event.id})"><span>{{booking.event.name}}</span></a></td></tr><tr><td><span translate="booking.detail.client.label">client</span></td><td><a ui-sref="user-relation.detail({relationId:booking.client.id})"><span>{{$root.displayFields([booking.client.externalId, booking.client.firstName, booking.client.lastName, booking.client.companyName])}}</span></a></td></tr><tr><td><span translate="booking.detail.totalCostConfirmed.label">totalCostConfirmed</span></td><td><span class="form-control-static">{{booking.totalCostConfirmed | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="booking.detail.totalCostNoSubscription.label">totalCostNoSubscription</span></td><td><span class="form-control-static">{{booking.totalCostNoSubscription | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="booking.detail.totalCostReserved.label">totalCostReserved</span></td><td><span class="form-control-static">{{booking.totalCostReserved | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="booking.detail.totalCost.label">totalCost</span></td><td><span class="form-control-static">{{booking.totalCost | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="booking.detail.totalCostCancelled.label">totalCostCancelled</span></td><td><span class="form-control-static">{{booking.totalCostCancelled | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="booking.detail.confirmationEmailStatus.label">confirmationEmailStatus</span></td><td><span class="form-control-static">{{booking.confirmationEmailStatus === null ? "" : \'ConfirmationEmailStatus.\' + booking.confirmationEmailStatus | translate}}</span></td></tr><tr><td><span translate="booking.detail.status.label">status</span></td><td><span class="form-control-static">{{booking.status === null ? "" : \'BookingStatus.\' + booking.status | translate}}</span></td></tr><tr><td><span translate="booking.detail.snelstartVerkoopOrderId.label">snelstartVerkoopOrderId</span></td><td><span class="form-control-static">{{booking.snelstartVerkoopOrderId}}</span></td></tr><tr><td><span translate="booking.detail.termOfPayment.label">termOfPayment</span></td><td><span class="form-control-static">{{booking.termOfPayment}}</span></td></tr><tr><td><span translate="booking.detail.snelstartMemoriaalBoekingId.label">snelstartMemoriaalBoekingId</span></td><td><span class="form-control-static">{{booking.snelstartMemoriaalBoekingId}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.bookingActiveTab"><uib-tab id="tab-orderlines-overview-mapped-by-booking" heading="{{\'booking.detail.tab.orderLine.by.booking\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><orderlines-overview-mapped-by-booking read-only="true" mapped-by-id="bookingId" mapped-by="\'booking\'" mapped-by-type="\'booking\'"></orderlines-overview-mapped-by-booking></uib-tab><uib-tab id="tab-subscriptions-overview-mapped-by-booking" heading="{{\'booking.detail.tab.subscription.by.booking\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><subscriptions-overview-mapped-by-booking read-only="true" mapped-by-id="bookingId" mapped-by="\'booking\'" mapped-by-type="\'booking\'"></subscriptions-overview-mapped-by-booking></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/booking/booking-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="BookingDialogTitleCreate" translate="booking.dialog.title.create">Create a Booking</h4><h4 class="modal-title" ng-show="isEdit()" id="BookingDialogTitleEdit" translate="booking.dialog.title.edit" translate-value-id="{{booking.id}}">Edit a Booking</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="booking.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="booking.dialog.description.label">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="booking.description" ng-maxlength="-1" placeholder="{{\'booking.dialog.description.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.bookingDate.$invalid, \'has-success\' : editForm.bookingDate.$valid && editForm.bookingDate.$dirty }"><label for="field_bookingDate" id="label_bookingDate" class="col-sm-2 control-label" translate="booking.dialog.bookingDate.label">BookingDate</label><div class="col-sm-9"><input datepicker-localdate type="date" class="form-control input-sm" name="bookingDate" id="field_bookingDate" ng-model="booking.bookingDate" required ng-readonly="booking.status!=\'NEW\'"><p class="help-block" ng-show="editForm.bookingDate.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.event.$invalid, \'has-success\' : editForm.event.$valid && editForm.event.$dirty }"><label for="field_event" class="col-sm-2 control-label" translate="booking.dialog.event.label">event</label><div class="col-sm-9"><input ng-disabled="\'event\' == mappedBy || booking.status!=\'NEW\'" type="text" id="field_event" name="event" ng-model="booking.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsForEvent" placeholder="{{\'booking.dialog.event.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForEvent"><i class="glyphicon glyphicon-remove"></i> No Results Found</div><div ng-show="editForm.event.$invalid"><p class="help-block" ng-show="editForm.event.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new event" ng-disabled="\'event\' == mappedBy || booking.status!=\'NEW\'" ng-click="createEvent()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.client.$invalid, \'has-success\' : editForm.client.$valid && editForm.client.$dirty }"><label for="field_client" class="col-sm-2 control-label" translate="booking.dialog.client.label">client</label><div class="col-sm-9"><input ng-disabled="\'client\' == mappedBy || booking.status!=\'NEW\'" type="text" id="field_client" name="client" ng-model="booking.client" ng-model-options="$root.modelOptions" uib-typeahead="client as client.displayValue for client in autocompleteRelations($viewValue)" typeahead-loading="loadingClient" typeahead-no-results="noResultsForClient" placeholder="{{\'booking.dialog.client.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingClient" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForClient"><i class="glyphicon glyphicon-remove"></i> No Results Found</div><div ng-show="editForm.client.$invalid"><p class="help-block" ng-show="editForm.client.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new client" ng-disabled="\'client\' == mappedBy || booking.status!=\'NEW\'" ng-click="createClient()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.totalCost.$invalid, \'has-success\' : editForm.totalCost.$valid && editForm.totalCost.$dirty }"><label for="field_totalCost" id="label_totalCost" class="col-sm-2 control-label" translate="booking.dialog.totalCost.label">TotalCost</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="totalCost" id="field_totalCost" readonly="true" ng-model="booking.totalCost" ng-currency currency-symbol="\u20AC" 2 fraction="2" placeholder="{{\'booking.dialog.totalCost.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.totalCost.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.totalCost.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.status.$invalid, \'has-success\' : editForm.status.$valid && editForm.status.$dirty }"><label for="field_status" class="col-sm-2 control-label" translate="booking.dialog.status.label">status</label><div class="col-sm-9"><select disabled="disabled" class="form-control input-sm" id="field_status" name="status" ng-model="booking.status" required ng-options="\'BookingStatus.\' + status | translate for status in statusList"><option value=""></option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.status.$invalid, \'has-success\' : editForm.status.$valid && editForm.status.$dirty }"><label for="field_ConfirmationEmailStatus" id="label_ConfirmationEmailStatus" translate="booking.dialog.confirmationEmailStatus.label" class="col-sm-2 control-label"></label><div class="col-sm-9"><select class="form-control input-sm" id="field_ConfirmationEmailStatus" name="confirmationEmailStatus" ng-model="booking.confirmationEmailStatus"><option selected="selected" value="NOT_SENT" translate="ConfirmationEmailStatus.NOT_SENT"></option><option value="SENT" translate="ConfirmationEmailStatus.SENT"></option><option value="ERROR" translate="ConfirmationEmailStatus.ERROR"></option><option value="CONFIRMED" translate="ConfirmationEmailStatus.CONFIRMED"></option><option value="REJECTED" translate="ConfirmationEmailStatus.REJECTED"></option><option value="QUEUED" translate="ConfirmationEmailStatus.QUEUED"></option><option value="INVALID" translate="ConfirmationEmailStatus.INVALID"></option></select></div></div><div class="form-group form-group-sm"><label for="field_confirmationEmailDescription" id="label_confirmationEmailDescription" translate="booking.dialog.confirmationEmailDescription.label" class="col-sm-2 control-label"></label><div class="col-sm-9"><input id="field_confirmationEmailDescription" type="text" class="form-control input-sm" name="confirmationEmailDescription" id="field_snelstartVerkoopOrderId" ng-model="booking.confirmationEmailDescription" ng-maxlength="-1" placeholder="{{\'booking.dialog.confirmationEmailDescription.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.snelstartVerkoopOrderId.$invalid, \'has-success\' : editForm.snelstartVerkoopOrderId.$valid && editForm.snelstartVerkoopOrderId.$dirty }"><label for="field_snelstartVerkoopOrderId" id="label_snelstartVerkoopOrderId" class="col-sm-2 control-label" translate="booking.dialog.snelstartVerkoopOrderId.label">SnelstartVerkoopOrderId</label><div class="col-sm-9"><input type="text" disabled="disabled" class="form-control input-sm" name="snelstartVerkoopOrderId" id="field_snelstartVerkoopOrderId" ng-model="booking.snelstartVerkoopOrderId" ng-maxlength="-1" placeholder="{{\'booking.dialog.snelstartVerkoopOrderId.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.snelstartVerkoopOrderId.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.snelstartVerkoopOrderId.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.termOfPayment.$invalid, \'has-success\' : editForm.termOfPayment.$valid && editForm.termOfPayment.$dirty }"><label for="field_termOfPayment" id="label_termOfPayment" class="col-sm-2 control-label" translate="booking.dialog.termOfPayment.label">TermOfPayment</label><div class="col-sm-9"><input readonly="true" type="number" class="form-control input-sm" name="termOfPayment" id="field_termOfPayment" ng-model="booking.termOfPayment" ng-maxlength="-1" placeholder="{{\'booking.dialog.termOfPayment.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.termOfPayment.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.termOfPayment.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span> &nbsp; <span translate="booking.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> &nbsp; <span translate="booking.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/booking/booking-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createBookingButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="booking.overview.button.new">Create a new Booking</span></button> <button ng-click="billEventBookings()" class="btn btn-info" ng-if="mappedBy == \'event\'" ng-disabled="selectedBookingList.length < 1"><span class="glyphicon glyphicon-euro" aria-hidden="true"></span> <span>Bill bookings of event</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.bookingDate.label">bookingDate</label><div class="col-md-6"><p class="input-group"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="frombookingDate" ng-model="BookingSearchTab.bookingDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="tobookingDate" ng-model="BookingSearchTab.bookingDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></p></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.confirmationEmailStatus.label">confirmationEmailStatus</label><div class="col-md-6"><select id="confirmationEmailStatus_select" class="form-control input-sm" ng-model="BookingSearchTab.confirmationEmailStatus" tabindex="0" ng-change="search()" ng-options="\'ConfirmationEmailStatus.\' + confirmationEmailStatus | translate for confirmationEmailStatus in confirmationEmailStatusList"><option value="" translate="booking.overview.search.confirmationEmailStatus.defaultOption">All ConfirmationEmailStatuses</option></select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.status.label">status</label><div class="col-md-6"><select id="status_select" class="form-control input-sm" ng-model="BookingSearchTab.status" tabindex="0" ng-change="search()" ng-options="\'BookingStatus.\' + status | translate for status in bookingStatusList"><option value="" translate="booking.overview.search.status.defaultOption">All BookingStatuses</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="booking.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isBookingSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="booking.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteBookingConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="booking.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="booking.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Booking</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="booking.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteBooking" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="booking.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="BookingSearchTab.predicate" ascending="BookingSearchTab.ascending" callback="search()"><th style="width:20px" ng-if="mappedBy == \'event\'"><tri-state-checkbox class="toggle-all" items="bookingList" top-level-click="toggleSelection" child-click="childClick"></tri-state-checkbox></th><th jh-sort-by="bookingDate" class="sortable"><span class="pull-left" translate="booking.overview.results.header.bookingDate.label">bookingDate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'bookingDate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'event\'" jh-sort-by="event.name" class="sortable"><span class="pull-left" translate="booking.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'client\'" jh-sort-by="client.externalId" class="sortable"><span class="pull-left" translate="booking.overview.results.header.client.label">client</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'client.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable hidden-xs"><span class="pull-left" translate="booking.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="confirmationEmailDescription" class="sortable hidden-xs"><span class="pull-left" translate="booking.overview.results.header.confirmationEmailDescription.label">confirmationEmailDescription</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'confirmationEmailDescription\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="confirmationEmailStatus" class="sortable hidden-xs"><span translate="booking.overview.results.header.confirmationEmailStatus.label">confirmationEmailStatus</span> <span class="glyphicon {{getSortIcon(\'confirmationEmailStatus\')}}"></span></th><th jh-sort-by="status" class="sortable hidden-xs"><span translate="booking.overview.results.header.status.label">status</span> <span class="glyphicon {{getSortIcon(\'status\')}}"></span></th><th><span translate="booking.overview.results.header.totalCostConfirmed.label">totalCostConfirmed</span></th><th><span translate="booking.overview.results.header.totalCostNoSubscription.label">totalCostNoSubscription</span></th><th><span translate="booking.overview.results.header.totalCostReserved.label">totalCostReserved</span></th><th><span translate="booking.overview.results.header.totalCost.label">totalCost</span></th><th><span translate="booking.overview.results.header.totalCostCancelled.label">totalCostCancelled</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="booking in bookingList"><td class="td-checkbox" ng-if="mappedBy == \'event\'"><input type="checkbox" ng-model="booking.isSelected" ng-click="selectionChanged(booking)"></td><td id="booking.bookingDateId{{$index}}"><span ng-hide="booking.bookingDate == null">{{booking.bookingDate | date:\'mediumDate\'}}</span></td><td ng-hide="mappedBy == \'event\'"><a ui-sref="event.detail.subscriptions({eventId:booking.event.id})"><span>{{booking.event.name}}</span></a></td><td ng-hide="mappedBy == \'client\'"><a ui-sref="user-relation.detail({relationId:booking.client.id})"><span>{{$root.displayFields([booking.client.externalId, booking.client.firstName, booking.client.lastName, booking.client.companyName])}}</span> </a><span class="label label-info label-additional pull-right" tooltip-placement="bottom" uib-tooltip="Season booking">{{(booking.client.season) ? \'S\' : \'\'}}</span></td><td class="hidden-xs" id="booking.descriptionId{{$index}}">{{booking.description}}</td><td class="hidden-xs" id="booking.confirmationEmailDescriptionId{{$index}}">{{booking.confirmationEmailDescription}}</td><td class="hidden-xs">{{booking.confirmationEmailStatus === null ? "" : \'ConfirmationEmailStatus.\' + booking.confirmationEmailStatus | translate}}</td><td class="hidden-xs">{{booking.status === null ? "" : \'BookingStatus.\' + booking.status | translate}}</td><td id="booking.totalCostConfirmedId{{$index}}">{{booking.totalCostConfirmed | currency:"\u20AC":2}}</td><td id="booking.totalCostNoSubscriptionId{{$index}}">{{booking.totalCostNoSubscription | currency:"\u20AC":2}}</td><td id="booking.totalCostReservedId{{$index}}">{{booking.totalCostReserved | currency:"\u20AC":2}}</td><td id="booking.totalCostId{{$index}}">{{booking.totalCost | currency:"\u20AC":2}}</td><td id="booking.totalCostCancelledId{{$index}}">{{booking.totalCostCancelled | currency:"\u20AC":2}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="" type="submit" ng-click="confirmationEmailDialog(booking.id)" class="btn btn-xs" uib-tooltip="{{confirmationStatuses[booking.confirmationEmailStatus]}}" ng-class="{\r\n\'btn-secondary\': booking.confirmationEmailStatus === \'NOT_SENT\',\r\n\'btn-info\': [\'SENT\', \'QUEUED\'].indexOf(booking.confirmationEmailStatus) !== -1,\r\n\'btn-success\': booking.confirmationEmailStatus === \'CONFIRMED\',\r\n\'btn-danger\': [\'REJECTED\', \'ERROR\', \'INVALID\'].indexOf(booking.confirmationEmailStatus) !== -1 }"><span class="glyphicon glyphicon-envelope"></span></button> <button id="btn_detail_Booking{{$index}}" type="submit" ui-sref="booking.detail({bookingId:booking.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Booking{{$index}}" type="submit" ng-click="goToEditState(booking)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteBooking{{$index}}" type="submit" ng-click="singleDelete(booking.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="BookingSearchTab.page" ng-change="search()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></select></div></div></div></div></div>');
$templateCache.put('app/entities/booking/bookings.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="booking.overview.title">Bookings</h3></div><div class="panel-buttons"><button id="createBookingButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="booking.overview.button.new">Create a new Booking</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.bookingDate.label">bookingDate</label><div class="col-md-6"><p class="input-group"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="frombookingDate" ng-model="BookingSearchOverview.bookingDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="tobookingDate" ng-model="BookingSearchOverview.bookingDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></p></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.event.label">event</label><div class="col-md-6"><input type="text" id="field_event" name="event" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="BookingSearchOverview.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsEvent" placeholder="{{\'booking.overview.search.event.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.client.label">client</label><div class="col-md-6"><input type="text" id="field_client" name="client" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="BookingSearchOverview.client" ng-model-options="$root.modelOptions" uib-typeahead="client as client.displayValue for client in autocompleteRelations($viewValue)" typeahead-loading="loadingClient" typeahead-no-results="noResultsClient" placeholder="{{\'booking.overview.search.client.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingClient" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsClient"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.status.label">status</label><div class="col-md-6"><select id="status_select" class="form-control input-sm" ng-model="BookingSearchOverview.status" tabindex="0" ng-change="search()" ng-options="\'BookingStatus.\' + status | translate for status in bookingStatusList"><option value="" translate="booking.overview.search.status.defaultOption">All BookingStatuses</option></select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="booking.overview.search.confirmationEmailStatus.label">confirmationEmailStatus</label><div class="col-md-6"><select id="confirmationEmailStatus_select" class="form-control input-sm" ng-model="BookingSearchOverview.confirmationEmailStatus" tabindex="0" ng-change="search()" ng-options="\'ConfirmationEmailStatus.\' + confirmationEmailStatus | translate for confirmationEmailStatus in confirmationEmailStatusList"><option value="" translate="booking.overview.search.confirmationEmailStatus.defaultOption">All ConfirmationEmailStatuses</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="booking.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isBookingSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="booking.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteBookingConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="booking.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="booking.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Booking</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="booking.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteBooking" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="booking.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="BookingSearchOverview.predicate" ascending="BookingSearchOverview.ascending" callback="search()"><th jh-sort-by="bookingDate" class="sortable"><span class="pull-left" translate="booking.overview.results.header.bookingDate.label">bookingDate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'bookingDate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="event.name" class="sortable"><span class="pull-left" translate="booking.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="client.externalId" class="sortable"><span class="pull-left" translate="booking.overview.results.header.client.label">client</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'client.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="confirmationEmailStatus" class="sortable hidden-xs"><span translate="booking.overview.results.header.confirmationEmailStatus.label">confirmationEmailStatus</span> <span class="glyphicon {{getSortIcon(\'confirmationEmailStatus\')}}"></span></th><th jh-sort-by="status" class="sortable hidden-xs"><span translate="booking.overview.results.header.status.label">status</span> <span class="glyphicon {{getSortIcon(\'status\')}}"></span></th><th><span translate="booking.overview.results.header.totalCostConfirmed.label">totalCostConfirmed</span></th><th><span translate="booking.overview.results.header.totalCostNoSubscription.label">totalCostNoSubscription</span></th><th><span translate="booking.overview.results.header.totalCostReserved.label">totalCostReserved</span></th><th><span translate="booking.overview.results.header.totalCost.label">totalCost</span></th><th><span translate="booking.overview.results.header.totalCostCancelled.label">totalCostCancelled</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="booking in bookingList"><td id="booking.bookingDateId{{$index}}"><span ng-hide="booking.bookingDate == null">{{booking.bookingDate | date:\'mediumDate\'}}</span></td><td><a ui-sref="event.detail.subscriptions({eventId:booking.event.id})"><span>{{booking.event.name}}</span></a></td><td><a ui-sref="user-relation.detail({relationId:booking.client.id})"><span>{{$root.displayFields([booking.client.externalId, booking.client.firstName, booking.client.lastName, booking.client.companyName])}}</span> </a><span class="label label-info label-additional pull-right" tooltip-placement="bottom" uib-tooltip="Season booking">{{(booking.client.season) ? \'S\' : \'\'}}</span></td><td class="hidden-xs">{{booking.confirmationEmailStatus === null ? "" : \'ConfirmationEmailStatus.\' + booking.confirmationEmailStatus | translate}}</td><td class="hidden-xs">{{booking.status === null ? "" : \'BookingStatus.\' + booking.status | translate}}</td><td id="booking.totalCostConfirmedId{{$index}}">{{booking.totalCostConfirmed | currency:"\u20AC":2}}</td><td id="booking.totalCostNoSubscriptionId{{$index}}">{{booking.totalCostNoSubscription | currency:"\u20AC":2}}</td><td id="booking.totalCostReservedId{{$index}}">{{booking.totalCostReserved | currency:"\u20AC":2}}</td><td id="booking.totalCostId{{$index}}">{{booking.totalCost | currency:"\u20AC":2}}</td><td id="booking.totalCostCancelledId{{$index}}">{{booking.totalCostCancelled | currency:"\u20AC":2}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="" type="submit" ng-click="confirmationEmailDialog(booking.id)" class="btn btn-xs" uib-tooltip="{{confirmationStatuses[booking.confirmationEmailStatus]}}" ng-class="{\r\n\'btn-secondary\': booking.confirmationEmailStatus === \'NOT_SENT\',\r\n\'btn-info\': [\'SENT\', \'QUEUED\'].indexOf(booking.confirmationEmailStatus) !== -1,\r\n\'btn-success\': booking.confirmationEmailStatus === \'CONFIRMED\',\r\n\'btn-danger\': [\'REJECTED\', \'ERROR\', \'INVALID\'].indexOf(booking.confirmationEmailStatus) !== -1 }"><span class="glyphicon glyphicon-envelope"></span></button> <button id="btn_detail_Booking{{$index}}" type="submit" ui-sref="booking.detail({bookingId:booking.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Booking{{$index}}" type="submit" ng-click="goToEditState(booking)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteBooking{{$index}}" type="submit" ng-click="singleDelete(booking.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="BookingSearchOverview.page" ng-change="search()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></select></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticle-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="CarRentalTypeTemplateEventArticleDetailTitle" translate="carRentalTypeTemplateEventArticle.detail.title">CarRentalTypeTemplateEventArticle</span> {{carRentalTypeTemplateEventArticle.name}}</h3></div><div class="panel-buttons"><button ui-sref="carrentaltypetemplateeventarticle.detail.edit({carRentalTypeTemplateEventArticleId:carRentalTypeTemplateEventArticle.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarRentalTypeTemplateEventArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(carRentalTypeTemplateEventArticle.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CarRentalTypeTemplateEventArticle?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="carRentalTypeTemplateEventArticle.detail.carRentalType.label">carRentalType</span></td><td><a ui-sref="carrentaltype.detail({carRentalTypeId:carRentalTypeTemplateEventArticle.carRentalType.id})"><span>{{carRentalTypeTemplateEventArticle.carRentalType.name}}</span></a></td></tr><tr><td><span translate="carRentalTypeTemplateEventArticle.detail.templateEvent.label">templateEvent</span></td><td><a ui-sref="templateevent.detail({templateEventId:carRentalTypeTemplateEventArticle.templateEvent.id})"><span>{{carRentalTypeTemplateEventArticle.templateEvent.name}}</span></a></td></tr><tr><td><span translate="carRentalTypeTemplateEventArticle.detail.articleForRental.label">articleForRental</span></td><td><a ui-sref="article.detail({articleId:carRentalTypeTemplateEventArticle.articleForRental.id})"><span>{{$root.displayFields([carRentalTypeTemplateEventArticle.articleForRental.name, carRentalTypeTemplateEventArticle.articleForRental.price])}}</span></a></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticle-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="CarRentalTypeTemplateEventArticleDialogTitleCreate" translate="carRentalTypeTemplateEventArticle.dialog.title.create">Create a CarRentalTypeTemplateEventArticle</h4><h4 class="modal-title" ng-show="isEdit()" id="CarRentalTypeTemplateEventArticleDialogTitleEdit" translate="carRentalTypeTemplateEventArticle.dialog.title.edit" translate-value-id="{{carRentalTypeTemplateEventArticle.id}}">Edit a CarRentalTypeTemplateEventArticle</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="carRentalTypeTemplateEventArticle.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.carRentalType.$invalid, \'has-success\' : editForm.carRentalType.$valid && editForm.carRentalType.$dirty }"><label for="field_carRentalType" class="col-sm-2 control-label" translate="carRentalTypeTemplateEventArticle.dialog.carRentalType.label">carRentalType</label><div class="col-sm-9"><select ng-disabled="\'carRentalType\' == mappedBy" class="form-control input-sm" id="field_carRentalType" name="carRentalType" ng-model="carRentalTypeTemplateEventArticle.carRentalType" required ng-options="carRentalType as carRentalType.name for carRentalType in carRentalTypeList track by carRentalType.id"><option value=""></option></select><div ng-show="editForm.carRentalType.$invalid"><p class="help-block" ng-show="editForm.carRentalType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.templateEvent.$invalid, \'has-success\' : editForm.templateEvent.$valid && editForm.templateEvent.$dirty }"><label for="field_templateEvent" class="col-sm-2 control-label" translate="carRentalTypeTemplateEventArticle.dialog.templateEvent.label">templateEvent</label><div class="col-sm-9"><select ng-disabled="\'templateEvent\' == mappedBy" class="form-control input-sm" id="field_templateEvent" name="templateEvent" ng-model="carRentalTypeTemplateEventArticle.templateEvent" required ng-options="templateEvent as templateEvent.name for templateEvent in templateEventList track by templateEvent.id"><option value=""></option></select><div ng-show="editForm.templateEvent.$invalid"><p class="help-block" ng-show="editForm.templateEvent.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.articleForRental.$invalid, \'has-success\' : editForm.articleForRental.$valid && editForm.articleForRental.$dirty }"><label for="field_articleForRental" class="col-sm-2 control-label" translate="carRentalTypeTemplateEventArticle.dialog.articleForRental.label">articleForRental</label><div class="col-sm-9"><select ng-disabled="\'articleForRental\' == mappedBy" class="form-control input-sm" id="field_articleForRental" name="articleForRental" ng-model="carRentalTypeTemplateEventArticle.articleForRental" required ng-options="articleForRental as $root.displayFields([articleForRental.name, articleForRental.price]) for articleForRental in articleForRentalList track by articleForRental.id"><option value=""></option></select><div ng-show="editForm.articleForRental.$invalid"><p class="help-block" ng-show="editForm.articleForRental.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new articleforrental" ng-disabled="\'articleForRental\' == mappedBy" ng-click="createArticleForRental()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticle-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createCarRentalTypeTemplateEventArticleButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="carRentalTypeTemplateEventArticle.overview.button.new">Create a new CarRentalTypeTemplateEventArticle</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarRentalTypeTemplateEventArticleConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CarRentalTypeTemplateEventArticle</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCarRentalTypeTemplateEventArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'carRentalType\'" jh-sort-by="carRentalType.name" class="sortable hidden-xs"><span class="pull-left" translate="carRentalTypeTemplateEventArticle.overview.results.header.carRentalType.label">carRentalType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'carRentalType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'templateEvent\'" jh-sort-by="templateEvent.name" class="sortable hidden-xs"><span class="pull-left" translate="carRentalTypeTemplateEventArticle.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'articleForRental\'" jh-sort-by="articleForRental.name" class="sortable hidden-xs"><span class="pull-left" translate="carRentalTypeTemplateEventArticle.overview.results.header.articleForRental.label">articleForRental</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleForRental.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="carRentalTypeTemplateEventArticle in carRentalTypeTemplateEventArticleList"><td class="hidden-xs" ng-hide="mappedBy == \'carRentalType\'"><a ui-sref="carrentaltype.detail({carRentalTypeId:carRentalTypeTemplateEventArticle.carRentalType.id})"><span>{{carRentalTypeTemplateEventArticle.carRentalType.name}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'templateEvent\'"><a ui-sref="templateevent.detail({templateEventId:carRentalTypeTemplateEventArticle.templateEvent.id})"><span>{{carRentalTypeTemplateEventArticle.templateEvent.name}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'articleForRental\'"><a ui-sref="article.detail({articleId:carRentalTypeTemplateEventArticle.articleForRental.id})"><span>{{$root.displayFields([carRentalTypeTemplateEventArticle.articleForRental.name, carRentalTypeTemplateEventArticle.articleForRental.price])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_CarRentalTypeTemplateEventArticle{{$index}}" type="submit" ui-sref="carrentaltypetemplateeventarticle.detail({carRentalTypeTemplateEventArticleId:carRentalTypeTemplateEventArticle.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_CarRentalTypeTemplateEventArticle{{$index}}" type="submit" ng-click="goToEditState(carRentalTypeTemplateEventArticle)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCarRentalTypeTemplateEventArticle{{$index}}" type="submit" ng-click="singleDelete(carRentalTypeTemplateEventArticle.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/carrentaltypetemplateeventarticle/carrentaltypetemplateeventarticles.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="carRentalTypeTemplateEventArticle.overview.title">CarRentalTypeTemplateEventArticles</h3></div><div class="panel-buttons"><button id="createCarRentalTypeTemplateEventArticleButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="carRentalTypeTemplateEventArticle.overview.button.new">Create a new CarRentalTypeTemplateEventArticle</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCarRentalTypeTemplateEventArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CarRentalTypeTemplateEventArticle</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCarRentalTypeTemplateEventArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="carRentalTypeTemplateEventArticle.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="carRentalType.name" class="sortable hidden-xs"><span class="pull-left" translate="carRentalTypeTemplateEventArticle.overview.results.header.carRentalType.label">carRentalType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'carRentalType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="templateEvent.name" class="sortable hidden-xs"><span class="pull-left" translate="carRentalTypeTemplateEventArticle.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="articleForRental.name" class="sortable hidden-xs"><span class="pull-left" translate="carRentalTypeTemplateEventArticle.overview.results.header.articleForRental.label">articleForRental</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'articleForRental.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="carRentalTypeTemplateEventArticle in carRentalTypeTemplateEventArticleList"><td class="hidden-xs"><a ui-sref="carrentaltype.detail({carRentalTypeId:carRentalTypeTemplateEventArticle.carRentalType.id})"><span>{{carRentalTypeTemplateEventArticle.carRentalType.name}}</span></a></td><td class="hidden-xs"><a ui-sref="templateevent.detail({templateEventId:carRentalTypeTemplateEventArticle.templateEvent.id})"><span>{{carRentalTypeTemplateEventArticle.templateEvent.name}}</span></a></td><td class="hidden-xs"><a ui-sref="article.detail({articleId:carRentalTypeTemplateEventArticle.articleForRental.id})"><span>{{$root.displayFields([carRentalTypeTemplateEventArticle.articleForRental.name, carRentalTypeTemplateEventArticle.articleForRental.price])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_CarRentalTypeTemplateEventArticle{{$index}}" type="submit" ui-sref="carrentaltypetemplateeventarticle.detail({carRentalTypeTemplateEventArticleId:carRentalTypeTemplateEventArticle.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_CarRentalTypeTemplateEventArticle{{$index}}" type="submit" ng-click="goToEditState(carRentalTypeTemplateEventArticle)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCarRentalTypeTemplateEventArticle{{$index}}" type="submit" ng-click="singleDelete(carRentalTypeTemplateEventArticle.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/companytype/companytype-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="CompanyTypeDetailTitle" translate="companyType.detail.title">CompanyType</span> {{companyType.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="companyType.detail.creator.label">Creator:</span>&nbsp; <span>{{companyType.creator}} {{companyType.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="companyType.updater">,&nbsp; <span translate="companyType.detail.updater.label">Updater: </span>&nbsp; <span>{{companyType.updater}} {{companyType.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="companytype.detail.edit({companyTypeId:companyType.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCompanyTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(companyType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="companyType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="companyType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CompanyType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="companyType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="companyType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="companyType.detail.name.label">name</span></td><td><span class="form-control-static">{{companyType.name}}</span></td></tr><tr><td><span translate="companyType.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{companyType.description}}</span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/companytype/companytype-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="CompanyTypeDialogTitleCreate" translate="companyType.dialog.title.create">Create a CompanyType</h4><h4 class="modal-title" ng-show="isEdit()" id="CompanyTypeDialogTitleEdit" translate="companyType.dialog.title.edit" translate-value-id="{{companyType.id}}">Edit a CompanyType</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="companyType.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="companyType.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="companyType.name" required ng-maxlength="-1" placeholder="{{\'companyType.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="companyType.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="companyType.description" ng-maxlength="-1" placeholder="{{\'companyType.dialog.description.placeholder\'|translate}}"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="companyType.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="companyType.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/companytype/companytype-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createCompanyTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="companyType.overview.button.new">Create a new CompanyType</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="companyType.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'companyType.overview.search.name.placeholder\' | translate}}" name="name" ng-model="CompanyTypeSearchTab.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="companyType.overview.search.description.label">description</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'companyType.overview.search.description.placeholder\' | translate}}" name="description" ng-model="CompanyTypeSearchTab.description" type="text" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="companyType.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isCompanyTypeSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="companyType.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteCompanyTypeConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="companyType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="companyType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CompanyType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="companyType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCompanyType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="companyType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="companyType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="companyType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="companyType in companyTypeList"><td id="companyType.nameId{{$index}}">{{companyType.name}}</td><td id="companyType.descriptionId{{$index}}">{{companyType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_CompanyType{{$index}}" type="submit" ui-sref="companytype.detail({companyTypeId:companyType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_CompanyType{{$index}}" type="submit" ng-click="goToEditState(companyType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCompanyType{{$index}}" type="submit" ng-click="singleDelete(companyType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/companytype/companytypes.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="companyType.overview.title">CompanyTypes</h3></div><div class="panel-buttons"><button id="createCompanyTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="companyType.overview.button.new">Create a new CompanyType</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCompanyTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="companyType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="companyType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this CompanyType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="companyType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteCompanyType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="companyType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="companyType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="companyType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="companyType in companyTypeList"><td id="companyType.nameId{{$index}}">{{companyType.name}}</td><td id="companyType.descriptionId{{$index}}">{{companyType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_CompanyType{{$index}}" type="submit" ui-sref="companytype.detail({companyTypeId:companyType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_CompanyType{{$index}}" type="submit" ng-click="goToEditState(companyType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteCompanyType{{$index}}" type="submit" ng-click="singleDelete(companyType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/confirmation_email/confirmation-email-dialog.html','<form class="form-horizontal" name="form" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="close()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" translate="emails.confirmation.dialog.title"></h4></div><div class="modal-body"><div class="form-group form-group-sm" ng-class="{ \'has-error\': form.status.$invalid, \'has-success\' : form.status.$valid && form.status.$dirty }"><label for="emailTemplate" class="col-sm-2 control-label" translate="emails.confirmation.dialog.selection.label"></label><div class="col-sm-9"><select required class="form-control input-sm" id="emailTemplate" name="emailTemplate" ng-model="selectedEmailTemplate" ng-options="emailTemplate as emailTemplate.name for emailTemplate in emailTemplateListOptions track by emailTemplate.slug"></select><p class="help-block" ng-show="form.emailTemplate.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm"><label for="sendToTestAddress" class="col-sm-2 control-label" translate="emails.confirmation.dialog.test_email.label"></label><div class="col-sm-9"><input type="checkbox" class="input-sm" id="sendToTestAddress" name="sendToTestAddress" ng-model="sendToTestAddress" ng-disabled="!isProduction" uib-tooltip="{{!isProduction ? \'Test email address is always used\' : \'\'}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="emails.confirmation.dialog.controls.cancel"></span></button> <button id="saveButton" type="submit" ng-disabled="!formShouldBeEnabled()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="emails.confirmation.dialog.controls.confirm"></span></button></div></form>');
$templateCache.put('app/entities/country/countries.html','<div id="content"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="country.overview.title">Countries</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="country.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcode" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcode.label">landcode</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcode\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcodeIso" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcodeIso.label">landcodeIso</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcodeIso\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartId" class="sortable"><span class="pull-left" translate="country.overview.results.header.snelstartId.label">snelstartId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="country in countryList"><td id="country.nameId{{$index}}">{{country.name}}</td><td id="country.landcodeId{{$index}}">{{country.landcode}}</td><td id="country.landcodeIsoId{{$index}}">{{country.landcodeIso}}</td><td id="country.snelstartIdId{{$index}}">{{country.snelstartId}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Country{{$index}}" type="submit" ui-sref="country.detail({countryId:country.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/country/country-detail.html','<div has-any-authority=""><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="CountryDetailTitle" translate="country.detail.title">Country</span> {{country.name}}</h3></div><div class="panel-buttons"><button ui-sref="country.detail.edit({countryId:country.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteCountryConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(country.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="country.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="country.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="country.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="country.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="country.detail.name.label">name</span></td><td><span class="form-control-static">{{country.name}}</span></td></tr><tr><td><span translate="country.detail.landcode.label">landcode</span></td><td><span class="form-control-static">{{country.landcode}}</span></td></tr><tr><td><span translate="country.detail.landcodeIso.label">landcodeIso</span></td><td><span class="form-control-static">{{country.landcodeIso}}</span></td></tr><tr><td><span translate="country.detail.snelstartId.label">snelstartId</span></td><td><span class="form-control-static">{{country.snelstartId}}</span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/country/country-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="country.overview.title">Countries</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="country.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcode" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcode.label">landcode</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcode\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcodeIso" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcodeIso.label">landcodeIso</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcodeIso\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartId" class="sortable"><span class="pull-left" translate="country.overview.results.header.snelstartId.label">snelstartId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="country in countryList"><td id="country.nameId{{$index}}">{{country.name}}</td><td id="country.landcodeId{{$index}}">{{country.landcode}}</td><td id="country.landcodeIsoId{{$index}}">{{country.landcodeIso}}</td><td id="country.snelstartIdId{{$index}}">{{country.snelstartId}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/country/country-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="country.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcode" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcode.label">landcode</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcode\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcodeIso" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcodeIso.label">landcodeIso</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcodeIso\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartId" class="sortable"><span class="pull-left" translate="country.overview.results.header.snelstartId.label">snelstartId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="country in countryList"><td id="country.nameId{{$index}}">{{country.name}}</td><td id="country.landcodeId{{$index}}">{{country.landcode}}</td><td id="country.landcodeIsoId{{$index}}">{{country.landcodeIso}}</td><td id="country.snelstartIdId{{$index}}">{{country.snelstartId}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/country/country-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="country.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcode" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcode.label">landcode</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcode\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="landcodeIso" class="sortable"><span class="pull-left" translate="country.overview.results.header.landcodeIso.label">landcodeIso</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'landcodeIso\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartId" class="sortable"><span class="pull-left" translate="country.overview.results.header.snelstartId.label">snelstartId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="country in countryList"><td id="country.nameId{{$index}}">{{country.name}}</td><td id="country.landcodeId{{$index}}">{{country.landcode}}</td><td id="country.landcodeIsoId{{$index}}">{{country.landcodeIso}}</td><td id="country.snelstartIdId{{$index}}">{{country.snelstartId}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Country{{$index}}" type="submit" ui-sref="country.detail({countryId:country.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/documenttype/documenttype-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="DocumentTypeDetailTitle" translate="documentType.detail.title">DocumentType</span> {{documentType.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="documentType.detail.creator.label">Creator:</span>&nbsp; <span>{{documentType.creator}} {{documentType.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="documentType.updater">,&nbsp; <span translate="documentType.detail.updater.label">Updater: </span>&nbsp; <span>{{documentType.updater}} {{documentType.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="documenttype.detail.edit({documentTypeId:documentType.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteDocumentTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(documentType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="documentType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="documentType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this DocumentType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="documentType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="documentType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="documentType.detail.functionalType.label">functionalType</span></td><td><span class="form-control-static">{{documentType.functionalType}}</span></td></tr><tr><td><span translate="documentType.detail.technicalTypes.label">technicalTypes</span></td><td><span class="form-control-static">{{documentType.technicalTypes}}</span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/documenttype/documenttype-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="DocumentTypeDialogTitleCreate" translate="documentType.dialog.title.create">Create a DocumentType</h4><h4 class="modal-title" ng-show="isEdit()" id="DocumentTypeDialogTitleEdit" translate="documentType.dialog.title.edit" translate-value-id="{{documentType.id}}">Edit a DocumentType</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="documentType.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.functionalType.$invalid, \'has-success\' : editForm.functionalType.$valid && editForm.functionalType.$dirty }"><label for="field_functionalType" id="label_functionalType" class="col-sm-2 control-label" translate="documentType.dialog.functionalType.label">FunctionalType</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="functionalType" id="field_functionalType" ng-model="documentType.functionalType" ng-maxlength="-1" placeholder="{{\'documentType.dialog.functionalType.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.technicalTypes.$invalid, \'has-success\' : editForm.technicalTypes.$valid && editForm.technicalTypes.$dirty }"><label for="field_technicalTypes" id="label_technicalTypes" class="col-sm-2 control-label" translate="documentType.dialog.technicalTypes.label">TechnicalTypes</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="technicalTypes" id="field_technicalTypes" ng-model="documentType.technicalTypes" ng-maxlength="-1" placeholder="{{\'documentType.dialog.technicalTypes.placeholder\'|translate}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="documentType.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="documentType.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/documenttype/documenttype-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createDocumentTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="documentType.overview.button.new">Create a new DocumentType</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteDocumentTypeConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="documentType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="documentType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this DocumentType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="documentType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteDocumentType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="documentType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="documentType in documentTypeList"><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_DocumentType{{$index}}" type="submit" ui-sref="documenttype.detail({documentTypeId:documentType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_DocumentType{{$index}}" type="submit" ng-click="goToEditState(documentType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteDocumentType{{$index}}" type="submit" ng-click="singleDelete(documentType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/documenttype/documenttypes.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="documentType.overview.title">DocumentTypes</h3></div><div class="panel-buttons"><button id="createDocumentTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="documentType.overview.button.new">Create a new DocumentType</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteDocumentTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="documentType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="documentType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this DocumentType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="documentType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteDocumentType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="documentType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="functionalType" class="sortable"><span class="pull-left" translate="documentType.overview.results.header.functionalType.label">functionalType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'functionalType\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="technicalTypes" class="sortable"><span class="pull-left" translate="documentType.overview.results.header.technicalTypes.label">technicalTypes</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'technicalTypes\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="documentType in documentTypeList"><td id="documentType.functionalTypeId{{$index}}">{{documentType.functionalType}}</td><td id="documentType.technicalTypesId{{$index}}">{{documentType.technicalTypes}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_DocumentType{{$index}}" type="submit" ui-sref="documenttype.detail({documentTypeId:documentType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_DocumentType{{$index}}" type="submit" ng-click="goToEditState(documentType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteDocumentType{{$index}}" type="submit" ng-click="singleDelete(documentType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/document/document-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="DocumentDetailTitle" translate="document.detail.title">Document</span> {{document.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="document.detail.creator.label">Creator:</span>&nbsp; <span>{{document.creator}} {{document.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="document.updater">,&nbsp; <span translate="document.detail.updater.label">Updater: </span>&nbsp; <span>{{document.updater}} {{document.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="document.detail.edit({documentId:document.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteDocumentConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(document.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="document.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="document.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Document?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="document.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="document.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="document.detail.description.label">description</span></td><td><span class="form-control-static">{{document.description}}</span></td></tr><tr><td><span translate="document.detail.name.label">name</span></td><td><span class="form-control-static">{{document.name}}</span></td></tr><tr><td><span translate="document.detail.type.label">type</span></td><td><a ui-sref="documenttype.detail({documentTypeId:document.type.id})"><span>{{document.type.functionalType}}</span></a></td></tr><tr><td><span translate="document.detail.file.label">file</span></td><td><span class="form-control-static"><a ng-click="download(document.id)" target="_blank" style="cursor: hand;cursor: pointer"><span class="glyphicon glyphicon-download-alt"></span></a></span></td></tr><tr><td><span translate="document.detail.car.label">car</span></td><td><a ui-sref="car.detail({carId:document.car.id})"><span>{{$root.displayFields([document.car.name, document.car.rental])}}</span></a></td></tr><tr><td><span translate="document.detail.location.label">location</span></td><td><a ui-sref="location.detail({locationId:document.location.id})"><span>{{document.location.name}}</span></a></td></tr><tr><td><span translate="document.detail.relation.label">relation</span></td><td><a ui-sref="user-relation.detail({relationId:document.relation.id})"><span>{{$root.displayFields([document.relation.externalId, document.relation.firstName, document.relation.lastName, document.relation.companyName])}}</span></a></td></tr><tr><td><span translate="document.detail.event.label">event</span></td><td><a ui-sref="event.detail.subscriptions({eventId:document.event.id})"><span>{{document.event.name}}</span></a></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/document/document-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="DocumentDialogTitleCreate" translate="document.dialog.title.create">Create a Document</h4><h4 class="modal-title" ng-show="isEdit()" id="DocumentDialogTitleEdit" translate="document.dialog.title.edit" translate-value-id="{{document.id}}">Edit a Document</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="document.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="document.dialog.description.label">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="document.description" ng-maxlength="-1" placeholder="{{\'document.dialog.description.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="document.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="document.name" required ng-maxlength="-1" placeholder="{{\'document.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.type.$invalid, \'has-success\' : editForm.type.$valid && editForm.type.$dirty }"><label for="field_type" class="col-sm-2 control-label" translate="document.dialog.type.label">type</label><div class="col-sm-9"><select ng-disabled="\'type\' == mappedBy" class="form-control input-sm" id="field_type" name="type" ng-model="document.type" ng-change="changeDocumentType(document.type)" required ng-options="type as type.functionalType for type in typeList track by type.id"><option value=""></option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new type" ng-disabled="\'type\' == mappedBy" ng-click="createType()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.file.$invalid, \'has-success\' : editForm.file.$valid && editForm.file.$dirty }"><label for="field_file" id="label_file" class="col-sm-2 control-label" translate="document.dialog.file.label">File</label><div class="col-sm-9"><div class="input-group"><span class="input-group-btn"><label ng-class="(isDisableFileInput())?\'btn btn-default btn-file\':\'btn btn-primary btn-file\'" ng-disabled="isDisableFileInput()"><span translate="global.form.browse">Browse</span><input type="file" id="field_file" nv-file-select uploader="file" style="display: none"></label></span><input type="text" class="form-control input-sm" ng-disabled="isDisableFileInput()" readonly="readonly" placeholder="{{file.queue[0].file.name}}"> <span class="input-group-addon" ng-show="file.queue.length > 0">{{file.queue[0].file.size/1024/1024|number:2}}MB</span></div></div><div class="col-sm-9 col-sm-offset-2" ng-show="!isDisableFileInput()"><div ng-show="file.isHTML5"><div class="progress" style="margin-top: 10px"><div class="progress-bar progress-bar-striped" role="progressbar" ng-style="{ \'width\': file.queue[0].progress + \'%\' }">{{file.queue[0].progress}}%</div></div></div><p class="help-block" ng-show="editForm.file.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.car.$invalid, \'has-success\' : editForm.car.$valid && editForm.car.$dirty }"><label for="field_car" class="col-sm-2 control-label" translate="document.dialog.car.label">car</label><div class="col-sm-9"><input ng-disabled="\'car\' == mappedBy" type="text" id="field_car" name="car" ng-model="document.car" ng-model-options="$root.modelOptions" uib-typeahead="car as car.displayValue for car in autocompleteCars($viewValue)" typeahead-loading="loadingCar" typeahead-no-results="noResultsForCar" placeholder="{{\'document.dialog.car.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off"> <i ng-show="loadingCar" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForCar"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new car" ng-disabled="\'car\' == mappedBy" ng-click="createCar()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.location.$invalid, \'has-success\' : editForm.location.$valid && editForm.location.$dirty }"><label for="field_location" class="col-sm-2 control-label" translate="document.dialog.location.label">location</label><div class="col-sm-9"><select ng-disabled="\'location\' == mappedBy" class="form-control input-sm" id="field_location" name="location" ng-model="document.location" ng-options="location as location.name for location in locationList track by location.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new location" ng-disabled="\'location\' == mappedBy" ng-click="createLocation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relation.$invalid, \'has-success\' : editForm.relation.$valid && editForm.relation.$dirty }"><label for="field_relation" class="col-sm-2 control-label" translate="document.dialog.relation.label">relation</label><div class="col-sm-9"><input ng-disabled="\'relation\' == mappedBy" type="text" id="field_relation" name="relation" ng-model="document.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsForRelation" placeholder="{{\'document.dialog.relation.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new relation" ng-disabled="\'relation\' == mappedBy" ng-click="createRelation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.event.$invalid, \'has-success\' : editForm.event.$valid && editForm.event.$dirty }"><label for="field_event" class="col-sm-2 control-label" translate="document.dialog.event.label">event</label><div class="col-sm-9"><input ng-disabled="\'event\' == mappedBy" type="text" id="field_event" name="event" ng-model="document.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsForEvent" placeholder="{{\'document.dialog.event.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off"> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new event" ng-disabled="\'event\' == mappedBy" ng-click="createEvent()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="document.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="document.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/document/document-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createDocumentButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="document.overview.button.new">Create a new Document</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.createdOn.label">createdOn</label><div class="col-md-6"><p class="input-group"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="fromcreatedOn" ng-model="DocumentSearchTab.createdOnFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="tocreatedOn" ng-model="DocumentSearchTab.createdOnTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></p></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'document.overview.search.name.placeholder\' | translate}}" name="name" ng-model="DocumentSearchTab.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm" ng-hide="mappedBy == \'type\'"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.type.label">type</label><div class="col-md-6"><select id="type_select" class="form-control input-sm" ng-options="type as type.functionalType for type in typeReferenceFilterList track by type.id" ng-model="DocumentSearchTab.type" tabindex="0" ng-change="search()"><option value="" translate="document.overview.search.type.defaultOption">All DocumentTypes</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="document.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isDocumentSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="document.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteDocumentConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="document.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="document.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Document</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="document.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteDocument" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="document.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="DocumentSearchTab.predicate" ascending="DocumentSearchTab.ascending" callback="search()"><th jh-sort-by="createdOn" class="sortable"><span class="pull-left" translate="document.overview.results.header.createdOn.label">createdOn</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'createdOn\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="document.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="document.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'type\'" jh-sort-by="type.functionalType" class="sortable"><span class="pull-left" translate="document.overview.results.header.type.label">type</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'type.functionalType\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="document.overview.results.header.file.label">file</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="document in documentList"><td nowrap="nowrap"><a ui-sref="document.detail({documentId:document.id})"><span ng-show="document.createdOn != null" class="hidden-xs">{{document.createdOn | nullableDateTimeNoZone}}</span> <span ng-show="document.createdOn != null" class="visible-xs">{{document.createdOn | nullableDateTimeNoZone}}</span> <span ng-show="document.createdOn == null">-</span></a></td><td id="document.nameId{{$index}}">{{document.name}}</td><td id="document.descriptionId{{$index}}">{{document.description}}</td><td ng-hide="mappedBy == \'type\'"><a ui-sref="documenttype.detail({documentTypeId:document.type.id})"><span>{{document.type.functionalType}}</span></a></td><td id="document.fileId{{$index}}"><a ng-click="downloadDocument(document.id)" target="_blank" style="cursor: hand;cursor: pointer"><span class="glyphicon glyphicon-download-alt"></span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Document{{$index}}" type="submit" ui-sref="document.detail({documentId:document.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="deleteDocument{{$index}}" type="submit" ng-click="singleDelete(document.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="DocumentSearchTab.page" ng-change="search()"></ul></div></div></div></div>');
$templateCache.put('app/entities/document/documents.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="document.overview.title">Documents</h3></div><div class="panel-buttons"><button id="createDocumentButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="document.overview.button.new">Create a new Document</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.createdOn.label">createdOn</label><div class="col-md-6"><p class="input-group"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="fromcreatedOn" ng-model="DocumentSearchOverview.createdOnFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" name="tocreatedOn" ng-model="DocumentSearchOverview.createdOnTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></p></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'document.overview.search.name.placeholder\' | translate}}" name="name" ng-model="DocumentSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.car.label">car</label><div class="col-md-6"><input type="text" id="field_car" name="car" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="DocumentSearchOverview.car" ng-model-options="$root.modelOptions" uib-typeahead="car as car.displayValue for car in autocompleteCars($viewValue)" typeahead-loading="loadingCar" typeahead-no-results="noResultsCar" placeholder="{{\'document.overview.search.car.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingCar" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsCar"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.location.label">location</label><div class="col-md-6"><select id="location_select" class="form-control input-sm" ng-options="location as location.name for location in locationReferenceFilterList track by location.id" ng-model="DocumentSearchOverview.location" tabindex="0" ng-change="search()"><option value="" translate="document.overview.search.location.defaultOption">All Locations</option></select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="DocumentSearchOverview.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'document.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.event.label">event</label><div class="col-md-6"><input type="text" id="field_event" name="event" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="DocumentSearchOverview.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsEvent" placeholder="{{\'document.overview.search.event.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="document.overview.search.type.label">type</label><div class="col-md-6"><select id="type_select" class="form-control input-sm" ng-options="type as type.functionalType for type in typeReferenceFilterList track by type.id" ng-model="DocumentSearchOverview.type" tabindex="0" ng-change="search()"><option value="" translate="document.overview.search.type.defaultOption">All DocumentTypes</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="document.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isDocumentSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="document.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteDocumentConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="document.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="document.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Document</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="document.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteDocument" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="document.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="DocumentSearchOverview.predicate" ascending="DocumentSearchOverview.ascending" callback="search()"><th jh-sort-by="createdOn" class="sortable"><span class="pull-left" translate="document.overview.results.header.createdOn.label">createdOn</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'createdOn\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="document.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="type.functionalType" class="sortable"><span class="pull-left" translate="document.overview.results.header.type.label">type</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'type.functionalType\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="car.name" class="sortable"><span class="pull-left" translate="document.overview.results.header.car.label">car</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'car.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="location.name" class="sortable"><span class="pull-left" translate="document.overview.results.header.location.label">location</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'location.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="document.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="event.name" class="sortable"><span class="pull-left" translate="document.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="document.overview.results.header.file.label">file</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="document in documentList"><td nowrap="nowrap"><a ui-sref="document.detail({documentId:document.id})"><span ng-show="document.createdOn != null" class="hidden-xs">{{document.createdOn | nullableDateTimeNoZone}}</span> <span ng-show="document.createdOn != null" class="visible-xs">{{document.createdOn | nullableDateTimeNoZone}}</span> <span ng-show="document.createdOn == null">-</span></a></td><td id="document.nameId{{$index}}">{{document.name}}</td><td><a ui-sref="documenttype.detail({documentTypeId:document.type.id})"><span>{{document.type.functionalType}}</span></a></td><td><a ui-sref="car.detail({carId:document.car.id})"><span>{{$root.displayFields([document.car.name, document.car.rental])}}</span></a></td><td><a ui-sref="location.detail({locationId:document.location.id})"><span>{{document.location.name}}</span></a></td><td><a ui-sref="user-relation.detail({relationId:document.relation.id})"><span>{{$root.displayFields([document.relation.externalId, document.relation.firstName, document.relation.lastName, document.relation.companyName])}}</span></a></td><td><a ui-sref="event.detail.subscriptions({eventId:document.event.id})"><span>{{document.event.name}}</span></a></td><td id="document.fileId{{$index}}"><a ng-click="downloadDocument(document.id)" target="_blank" style="cursor: hand;cursor: pointer"><span class="glyphicon glyphicon-download-alt"></span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Document{{$index}}" type="submit" ui-sref="document.detail({documentId:document.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="deleteDocument{{$index}}" type="submit" ng-click="singleDelete(document.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="DocumentSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/event/booking-subscription-details.html','<div has-any-authority="ROLE_USER"><div class="panel-body"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12 col-sm-8"><!-- Booking panel --><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-xs-8"><h4><span translate="booking.detail.title">Booking</span> {{title()}}</h4><p class="small text-lowercase"><span translate="booking.detail.creator.label">Creator:</span> <span ng-show="booking.creator != null">{{booking.creator}}</span> <span ng-show="booking.creator == null">-&nbsp;</span> <span class="form-control-static" ng-show="booking.createdOn != null">{{booking.createdOn | nullableDateTimeNoZone}}</span> ,&nbsp;<span translate="booking.detail.updater.label">Updater: </span><span ng-show="booking.updater != null">{{booking.updater}}</span> <span ng-show="booking.updater == null">-&nbsp;</span> <span class="form-control-static" ng-show="event.updatedOn != null">{{booking.updatedOn | nullableDateTimeNoZone}}</span></p></div><div class="col-xs-4"><button type="button" ng-click="backToEvent()" class="btn btn-sm"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="booking.detail.action.event">Event details</span></button> <button type="button" ng-click="backToSalesDashboard()" class="btn btn-sm"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="booking.detail.action.sales">Sales dashboard</span></button></div></div><div class="row animate-show animate-hide" id="editBookingForm" ng-show="showBookingForm"><div class="\u201Ccol-xs-12\u201D"><form class="form-horizontal" name="editBookingForm" role="form" ng-submit="saveBooking()" novalidate show-validation><div class="form-group form-group-sm"><div class="col-xs-12 col-sm-4"><label for="id" class="col-sm-4 control-label">ID</label><div class="col-sm-8"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="booking.id" readonly="readonly"></div></div><div class="col-xs-12 col-sm-8"><label for="field_description" id="label_description" class="col-sm-3 control-label" translate="booking.dialog.description.label">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="booking.description" ng-maxlength="-1" placeholder="{{\'booking.dialog.description.placeholder\'|translate}}"></div></div></div><div class="form-group form-group-sm"><div class="col-xs-12 col-sm-4"><label for="field_ConfirmationEmailStatus" id="label_ConfirmationEmailStatus" translate="booking.dialog.confirmationEmailStatus.label" class="col-sm-4 control-label"></label><div class="col-sm-8"><select class="form-control" id="field_ConfirmationEmailStatus" name="confirmationEmailStatus" ng-model="booking.confirmationEmailStatus"><option selected="selected" value="NOT_SENT" translate="ConfirmationEmailStatus.NOT_SENT"></option><option value="SENT" translate="ConfirmationEmailStatus.SENT"></option><option value="ERROR" translate="ConfirmationEmailStatus.ERROR"></option><option value="CONFIRMED" translate="ConfirmationEmailStatus.CONFIRMED"></option><option value="REJECTED" translate="ConfirmationEmailStatus.REJECTED"></option><option value="QUEUED" translate="ConfirmationEmailStatus.QUEUED"></option><option value="INVALID" translate="ConfirmationEmailStatus.INVALID"></option></select></div></div><div class="col-xs-12 col-sm-8"><label for="field_description" id="label_confirmationEmailDescription" class="col-sm-3 control-label" translate="booking.dialog.confirmationEmailDescription.label"></label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="confirmationEmailDescription" id="field_confirmationEmailDescription" ng-model="booking.confirmationEmailDescription" ng-maxlength="-1" placeholder="{{\'booking.dialog.confirmationEmailDescription.placeholder\'|translate}}"></div></div></div><div class="form-group form-group-sm"><div class="col-xs-12 col-sm-4" ng-class="{ \'has-error\': editBookingForm.bookingDate.$invalid, \'has-success\' : editBookingForm.bookingDate.$valid && editBookingForm.bookingDate.$dirty }"><label for="field_bookingDate" id="label_bookingDate" class="col-sm-4 control-label" translate="booking.dialog.bookingDate.label">BookingDate</label><div class="col-sm-8"><input datepicker-localdate type="date" class="form-control input-sm" name="bookingDate" id="field_bookingDate" ng-readonly="booking.status!=\'NEW\'" ng-model="booking.bookingDate" required><p class="help-block" ng-show="editBookingForm.bookingDate.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="col-xs-12 col-sm-8" ng-class="{ \'has-error\': editBookingForm.client.$invalid, \'has-success\' : editBookingForm.client.$valid && editBookingForm.client.$dirty }"><label for="field_client" class="col-sm-3 control-label" translate="booking.dialog.client.label">client</label><div class="col-sm-9"><div class="input-group input-group-sm"><input type="text" id="field_client" name="client" ng-model="booking.client" ng-readonly="booking.status!=\'NEW\'" ng-model-options="modelOptions" uib-typeahead="client as client.displayValue for client in autocompleteRelations($viewValue)" typeahead-loading="loadingClient" typeahead-no-results="noResultsForClient" placeholder="{{\'booking.dialog.client.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" ng-hide="booking.status!=\'NEW\'" uib-tooltip="Create a new client for this booking" ng-click="createBookingClient()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div><i ng-show="loadingClient" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForClient"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editBookingForm.client.$invalid"><p class="help-block" ng-show="editBookingForm.client.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="form-group form-group-sm"><div class="col-xs-12 col-sm-4"><label for="field_totalCost" id="label_totalCost" class="col-sm-4 control-label" translate="booking.dialog.totalCost.label">TotalCost</label><div class="col-sm-8"><input type="text" class="form-control input-sm" name="totalCost" id="field_totalCost" readonly="true" ng-model="booking.totalCost" ng-currency currency-symbol="\u20AC" fraction="2" ng-disabled="true" placeholder="{{\'booking.dialog.totalCost.placeholder\'|translate}}"></div></div><div class="col-xs-12 col-sm-8" ng-class="{ \'has-error\': editBookingForm.event.$invalid, \'has-success\' : editBookingForm.event.$valid && editBookingForm.event.$dirty }"><label for="field_event" class="col-sm-3 control-label" translate="booking.dialog.event.label">event</label><div class="col-sm-9"><input ng-disabled="true" type="text" id="field_event" name="event.name" ng-model="booking.event.name" class="form-control input-sm" autocomplete="off" required></div></div></div><div class="form-group form-group-sm"><div class="col-xs-12"><div class="pull-right"><button id="cancelBookingButton" ng-click="hideEditBookingForm()" type="button" class="btn"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="booking.dialog.cancel.button">cancel</span></button> <button id="saveBookingButton" type="submit" ng-disabled="editBookingForm.$invalid" class="btn btn-primary" style="margin-right: 15px"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="booking.dialog.update.button">Save</span></button></div></div></div></form></div></div><div class="row"><div class="col-xs-12 col-sm-6"><div ng-if="booking.status"><label id="label_bookingStatus" class="col-sm-3 control-label" translate="booking.dialog.status.label">status</label><div class="col-sm-9"><span class="label" ng-class="{\'label-success\': booking.status==\'BILLED\',\'label-danger\': booking.status!=\'BILLED\'}">{{booking.status}}</span></div></div></div><div class="col-xs-12 col-sm-6"><div class="pull-right"><button id="booking.details{$index}}" ui-sref="booking.detail({bookingId:booking.id})" ng-disabled="!isDefinedAndNotNull(booking.id)" class="btn btn-success btn-sm" title="Go to Booking details"><span class="glyphicon glyphicon-euro"></span></button> <button id="editBookingButton" ng-click="toggleBookingForm()" ng-disabled="!isDefinedAndNotNull(booking.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button id="billBookingButton" type="button" ng-click="billBooking(booking)" ng-disabled="!booking.id || !booking.status || (booking.status != \'NEW\' && booking.status != \'CHANGED_AFTER_BILLING\')" class="btn btn-info btn-sm"><span id="billButtonIcon" class="glyphicon glyphicon-euro"></span>&nbsp;<span translate="booking.dialog.bill.button">Bill</span></button></div></div></div></div></div></div><div class="col-xs-12 col-sm-4"><span ng-show="!hasDriver()">Please add a driver first</span><!-- Car panel --><div class="panel panel-default" ng-show="hasCarData() || showCarForm"><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-7"><h4>{{ currentSubscription.driverDto.car }}</h4></div><div class="col-xs-6 col-sm-3"><h4><span class="label label-warning label-license">{{ currentSubscription.driverDto.carLicense }}</span></h4></div><div class="col-xs-6 col-sm-2"><button id="editCarButton" ng-click="editCar()" class="btn btn-primary btn-sm pull-right"><span class="glyphicon glyphicon-pencil"></span></button></div></div><div class="row"><div class="col-xs-10" ng-class="{\'text-success\' : isDefinedAndNotNull(currentSubscription.driverDto.insurance), \'text-danger\': !isDefinedAndNotNull(currentSubscription.driverDto.insurance)}"><span class="glyphicon glyphicon-folder-open" aria-hidden="true"></span> &nbsp;<span>{{ currentSubscription.driverDto.insurance }}</span></div><div class="col-xs-2"><span class="label label-success label-additional pull-right" tooltip-placement="left" uib-tooltip="Rental car">{{(currentSubscription.driverDto.carIsRental) ? \'R\' : \'\'}}</span></div></div><div class="row"><div class="col-xs-10" ng-class="{\'text-success\' : isDefinedAndNotNull(currentSubscription.driverDto.fuel), \'text-danger\': !isDefinedAndNotNull(currentSubscription.driverDto.fuel)}"><span class="glyphicon glyphicon-tint" aria-hidden="true"></span> &nbsp;<span>{{ currentSubscription.driverDto.fuel }}</span></div><div class="col-xs-2"><span class="label label-info label-additional pull-right" tooltip-placement="left" uib-tooltip="Service car">{{(currentSubscription.driverDto.carIsServiced) ? \'M\' : \'\'}}</span></div></div><div class="row"><div class="col-xs-12 animate-show animate-hide" id="editCarForm" ng-show="showCarForm"><form class="form-horizontal" name="editCarForm" role="form" novalidate show-validation><div class="form-group form-group-sm" ng-class="{ \'has-error\': editCarForm.insurance.$invalid, \'has-success\' : editCarForm.insurance.$valid && editCarForm.insurance.$dirty }"><label for="field_insurance" class="col-xs-3 control-label" translate="subscription.dialog.insurance.label">insurance</label><div class="col-xs-9"><select class="form-control" id="field_insurance" name="insurance" ng-model="subscriptionToEdit.insurance" ng-options="insurance as $root.displayFields([insurance.name, insurance.price]) for insurance in insuranceList track by insurance.id"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editCarForm.fuel.$invalid, \'has-success\' : editCarForm.fuel.$valid && editCarForm.fuel.$dirty }"><label for="field_fuel" class="col-xs-3 control-label" translate="subscription.dialog.fuel.label">fuel</label><div class="col-xs-9"><select class="form-control" id="field_fuel" name="fuel" ng-model="subscriptionToEdit.fuel" ng-options="fuel as $root.displayFields([fuel.name, fuel.price]) for fuel in fuelList track by fuel.id" ng-disabled="subscriptionToEdit.car.rental!==true"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editCarForm.car.$invalid, \'has-success\' : editCarForm.car.$valid && editCarForm.car.$dirty }"><label for="field_car" class="col-xs-3 control-label" translate="subscription.dialog.car.label">car</label><div class="col-xs-9"><div class="input-group input-group-sm"><input type="text" id="field_car" ng-model="subscriptionToEdit.car" ng-model-options="modelOptions" name="car" uib-typeahead="car as car.displayValue for car in autocompleteCars($viewValue)" typeahead-loading="loadingCar" typeahead-no-results="noResultsForCar" typeahead-on-select="onCarSelect($item, $model, $label, $event)" placeholder="{{\'subscription.dialog.car.placeholder\'|translate}}" class="form-control" autocomplete="off"><div class="input-group-btn"><button ng-disabled="!isDefinedAndNotNull(subscriptionToEdit)" class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new car" ng-click="createCar()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div><i ng-show="loadingCar" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForCar"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="row"><span class="col-xs-12"><span class="pull-right voffset1"><button id="cancelCarButton" ng-click="hideEditCarForm()" class="btn"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="booking.dialog.cancel.button">cancel</span></button> <button id="saveCarButton" ng-disabled="!isDefinedAndNotNull(subscriptionToEdit)" ng-click="saveCar()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="booking.dialog.update.button">Save</span></button></span></span></div></form></div></div></div></div><div ng-show="!hasCarData() && !showCarForm && hasDriver()" style="position:relative; top: 100px"><a ng-click="editCar()">Please choose a car</a></div></div></div><div class="row"><div class="col-xs-12"><div class="btn-group btn-group-justified" role="group" aria-label="Driver navigation"><div class="btn-group" role="group"><button id="previousDriverButton" ng-click="previousSubscription()" ng-disabled="!hasPreviousSubscription()" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-chevron-left"></span>&nbsp;Previous driver</button></div><div class="btn-group" role="group"><button id="nextDriverButton" ng-click="nextSubscription()" ng-disabled="!hasNextSubscription()" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-chevron-right"></span>&nbsp;Next driver</button></div><div class="btn-group" role="group"><button id="addDriverButton" ng-click="addDriver()" ng-class="{\'btn-primary\' : !isDefinedAndNotNull(currentSubscription.driverDto)}" ng-disabled="!isDefinedAndNotNull(booking.id)" class="btn btn-sm" autocomplete="off"><span class="glyphicon glyphicon-plus"></span>&nbsp;Add driver</button></div></div></div></div><div class="panel panel-default"><!-- Default panel contents --><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-6"><button id="addSecondDriverButton" ng-click="addSubscription(\'Second_driver\')" ng-disabled="!isValidDriverSubscription()" class="btn btn-sm" autocomplete="off"><span class="glyphicon glyphicon-plus"></span>&nbsp;Add second driver</button>&nbsp; <button id="addSpectatorButton" ng-click="addSubscription(\'Spectator\')" ng-disabled="!isValidDriverSubscription()" class="btn btn-sm" autocomplete="off"><span class="glyphicon glyphicon-plus"></span>&nbsp;Add spectator</button>&nbsp;</div><div class="col-xs-12 col-sm-6"><div class="pull-right"><button id="showBookingData" ng-click="toggleBookingData()" class="btn btn-sm active" data-toggle="button" aria-pressed="true" autocomplete="off"><span class="glyphicon glyphicon-ok-circle" id="showBookingDataIcon"></span>&nbsp;Show booking data</button>&nbsp; <button id="showInstructionData" ng-click="toggleInstructionData()" class="btn btn-sm" data-toggle="button" aria-pressed="false" autocomplete="off"><span class="glyphicon glyphicon-remove-circle" id="showInstructionDataIcon"></span>&nbsp;Show instruction data</button></div></div></div></div><!-- Table --><div class="table-responsive"><table class="table"><thead><tr><th></th><th>Name</th><th ng-show="showBookingData">Booking product</th><th ng-show="showBookingData">Info / after mail</th><th ng-show="showBookingData">Hotel</th><th ng-show="showBookingData">Description</th><th ng-show="showBookingData">Instruction type</th><th ng-show="showBookingData">Instruction hours</th><th ng-show="showInstructionData">Instructor</th><th ng-show="showInstructionData">Group</th><th ng-show="showInstructionData">Driving results / progress</th><th ng-show="showInstructionData">Progress</th><th ng-show="showInstructionData">Driving directions</th><th></th></tr></thead><tbody><tr class="info animate-show-tr animate-hide-tr" id="editSubscriptionForm" ng-show="showEditSubscriptionForm"><td><select class="form-control input-sm" id="field_subscriptionType" name="subscriptionType" ng-disabled="true" ng-model="subscriptionToEdit.subscriptionType" required ng-options="\'SubscriptionType.\' + subscriptionType | translate for subscriptionType in subscriptionTypeList"><option value=""></option></select></td><td><div ng-class="{ \'has-error\': editSubscriptionForm.relation.$invalid, \'has-success\' : editSubscriptionForm.relation.$valid && editSubscriptionForm.relation.$dirty }"><div class="input-group input-group-sm"><input type="text" id="field_relation" ng-model="subscriptionToEdit.relation" name="relation" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsForRelation" typeahead-wait-ms="50" typeahead-select-on-blur="true" placeholder="{{\'subscription.dialog.relation.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off"><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new relation for this subscription" ng-click="createRelation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div><i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editSubscriptionForm.relation.$invalid"><p class="help-block" ng-show="editSubscriptionForm.relation.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div ng-class="{ \'has-error\': editSubscriptionForm.status.$invalid, \'has-success\' : editSubscriptionForm.status.$valid && editSubscriptionForm.status.$dirty }"><select class="form-control input-sm" id="field_status" name="status" ng-model="subscriptionToEdit.status" required ng-options="\'SubscriptionStatus.\' + status | translate for status in statusList"><option value=""></option></select><div ng-show="editSubscriptionForm.status.$invalid"><p class="help-block" ng-show="editSubscriptionForm.status.$error.required" translate="entity.validation.required">This field is required.</p></div></div></td><td ng-show="showBookingData"><select class="form-control input-sm" id="field_driver" name="driver" ng-model="subscriptionToEdit.driver" ng-options="driver as $root.displayFields([driver.name, driver.price]) for driver in driverList track by driver.id" ng-show="subscriptionToEdit.subscriptionType==\'Driver\'" ng-change="updateInstructionHours()"><option value=""></option></select><select class="form-control input-sm" id="field_secondDriver" name="secondDriver" ng-model="subscriptionToEdit.secondDriver" ng-options="secondDriver as $root.displayFields([secondDriver.name, secondDriver.price]) for secondDriver in secondDriverList track by secondDriver.id" ng-show="subscriptionToEdit.subscriptionType==\'Second_driver\'" ng-change="updateInstructionHours()"><option value=""></option></select><select class="form-control input-sm" id="field_spectator" name="spectator" ng-model="subscriptionToEdit.spectator" ng-options="spectator as $root.displayFields([spectator.name, spectator.price]) for spectator in spectatorList track by spectator.id" ng-show="subscriptionToEdit.subscriptionType==\'Spectator\'" ng-change="updateInstructionHours()"><option value=""></option></select></td><td ng-show="showBookingData"><span><nz-toggle vertical ng-model="subscriptionToEdit.infoMail" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle><nz-toggle vertical ng-model="subscriptionToEdit.afterMail" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></span></td><td ng-show="showBookingData" ng-class="{ \'has-error\': editSubscriptionForm.hotel.$invalid, \'has-success\' : editSubscriptionForm.hotel.$valid && editSubscriptionForm.hotel.$dirty }"><select class="form-control input-sm" id="field_hotel" name="hotel" ng-model="subscriptionToEdit.hotel" ng-options="hotel as $root.displayFields([hotel.name, hotel.price]) for hotel in hotelList track by hotel.id"><option value=""></option></select></td><td ng-show="showBookingData"><textarea rows="3" class="form-control input-sm" name="instructionDirections" id="field_drivingDescription" ng-model="subscriptionToEdit.description" placeholder="{{\'subscription.dialog.description.placeholder\'|translate}}"></textarea></td><td ng-show="showBookingData" ng-class="{ \'has-error\': editSubscriptionForm.trainingType.$invalid, \'has-success\' : editSubscriptionForm.trainingType.$valid && editSubscriptionForm.trainingType.$dirty }"><select class="form-control input-sm" id="field_trainingType" name="trainingType" ng-model="subscriptionToEdit.trainingType" ng-options="trainingType as trainingType.name for trainingType in trainingTypeList track by trainingType.id"><option value=""></option></select></td><td ng-show="showBookingData" ng-class="{ \'has-error\': editSubscriptionForm.instructionHours.$invalid, \'has-success\' : editSubscriptionForm.instructionHours.$valid && editSubscriptionForm.instructionHours.$dirty }"><input type="number" step="0.5" class="form-control input-sm" name="instructionHours" id="field_instructionHours" ng-model="subscriptionToEdit.instructionHours" ng-maxlength="-1" placeholder="{{\'subscription.dialog.instructionHours.placeholder\'|translate}}"></td><td ng-show="showInstructionData" ng-class="{ \'has-error\': editSubscriptionForm.instructor.$invalid, \'has-success\' : editSubscriptionForm.instructor.$valid && editSubscriptionForm.instructor.$dirty }"><div class="input-group input-group-sm"><select class="form-control input-sm" id="field_instructor" name="instructor" ng-model="subscriptionToEdit.instructor" ng-options="instructor as $root.displayFields([instructor.description, instructor.relation.externalId, instructor.relation.firstName, instructor.relation.lastName, instructor.relation.companyName]) for instructor in instructorList track by instructor.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new instructor for this subscription" ng-click="createInstructor()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></td><td ng-show="showInstructionData" ng-class="{ \'has-error\': editSubscriptionForm.drivingGroup.$invalid, \'has-success\' : editSubscriptionForm.drivingGroup.$valid && editSubscriptionForm.drivingGroup.$dirty }"><input type="text" class="form-control input-sm" name="drivingGroup" id="field_drivingGroup" ng-model="subscriptionToEdit.drivingGroup" ng-maxlength="-1" placeholder="{{\'subscription.dialog.drivingGroup.placeholder\'|translate}}"></td><td ng-show="showInstructionData"><div ng-class="{ \'has-error\': editSubscriptionForm.drivingResult.$invalid, \'has-success\' : editSubscriptionForm.drivingResult.$valid && editSubscriptionForm.drivingResult.$dirty }"><input type="number" step="0.5" class="form-control input-sm" name="drivingResult" id="field_drivingResult" ng-model="subscriptionToEdit.drivingResult" ng-min="1" ng-max="10" ng-maxlength="-1" placeholder="{{\'subscription.dialog.drivingResult.placeholder\'|translate}}"><p class="help-block" ng-show="editSubscriptionForm.drivingResult.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="10">Maximum value validation error</p><p class="help-block" ng-show="editSubscriptionForm.drivingResult.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="1">Minimal value validation error</p></div><div ng-class="{ \'has-error\': editSubscriptionForm.progress.$invalid, \'has-success\' : editSubscriptionForm.progress.$valid && editSubscriptionForm.progress.$dirty }"><input type="number" step="0.5" class="form-control input-sm" name="progress" id="field_progress" ng-model="subscriptionToEdit.progress" ng-min="1" ng-max="10" ng-maxlength="-1" placeholder="{{\'subscription.dialog.progress.placeholder\'|translate}}"><p class="help-block" ng-show="editSubscriptionForm.progress.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="10">Maximum value validation error</p><p class="help-block" ng-show="editSubscriptionForm.progress.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="1">Minimal value validation error</p></div></td><td ng-show="showInstructionData" ng-class="{ \'has-error\': editSubscriptionForm.instructionProgress.$invalid, \'has-success\' : editSubscriptionForm.instructionProgress.$valid && editSubscriptionForm.instructionProgress.$dirty }"><textarea rows="3" class="form-control input-sm" name="instructionProgress" id="field_instructionProgress" ng-model="subscriptionToEdit.instructionProgress" ng-maxlength="-1" placeholder="{{\'subscription.dialog.instructionProgress.placeholder\'|translate}}"></textarea></td><td ng-show="showInstructionData" ng-class="{ \'has-error\': editSubscriptionForm.instructionDirections.$invalid, \'has-success\' : editSubscriptionForm.instructionDirections.$valid && editSubscriptionForm.instructionDirections.$dirty }"><textarea rows="3" class="form-control input-sm" name="instructionDirections" id="field_instructionDirections" ng-model="subscriptionToEdit.instructionDirections" ng-maxlength="-1" placeholder="{{\'subscription.dialog.instructionDirections.placeholder\'|translate}}"></textarea></td><td><div class="clearfix"><button id="saveSubscriptionButton" type="button" ng-click="saveSubscription()" ng-show="isDefinedAndNotNull(subscriptionToEdit)" class="btn btn-primary btn-xs pull-right" autocomplete="off"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span></button></div><div class="clearfix voffset1"><button id="cancelSubscriptionButton" type="button" ng-show="isDefinedAndNotNull(subscriptionToEdit)" ng-click="cancelSubscription()" class="btn btn-xs pull-right" autocomplete="off"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></button></div></td></tr><!--empty row with message that there are no drivers yet for this booking--><tr ng-hide="!hideAddingNewDriver && isValidDriverSubscription()"><td colspan="13"><span class="text-center center-block"><em>There are no driver subscriptions for this booking yet. Go ahead and add a new driver.</em></span></td></tr><!--the data--><tr ng-class="{\'success\' : currentSubscription.driverDto.status==\'CONFIRMED\', \'warning\': currentSubscription.driverDto.status==\'RESERVED\'}" ng-show="!hideAddingNewDriver && isValidDriverSubscription()"><td><strong>Driver</strong></td><td><a ui-sref="user-relation.detail({relationId:currentSubscription.driverDto.relationIdPk})"><span>{{currentSubscription.driverDto.subscriptionPersonName}}</span> </a><span class="badge">{{currentSubscription.driverDto.instructionGroup}}</span> <span class="glyphicon pull-right" tooltip-placement="bottom" uib-tooltip="{{translateStatus(currentSubscription.driverDto.status)}}" style="font-size:1.5em" aria-hidden="true" ng-class="{\'glyphicon-ok-sign text-success\': currentSubscription.driverDto.status==\'CONFIRMED\',\r\n                                            \'glyphicon-question-sign text-warning\': currentSubscription.driverDto.status==\'RESERVED\',\r\n                                            \'glyphicon-remove-sign text-warning\': currentSubscription.driverDto.status==\'CANCELLED\'}"></span></td><td ng-show="showBookingData">{{getBookingArticle(currentSubscription.driverDto)}}</td><td ng-show="showBookingData"><span ng-show="currentSubscription.driverDto.infoMail" class="glyphicon glyphicon-envelope text-warning" style="font-size:1.5em" aria-hidden="true"></span> <span ng-show="currentSubscription.driverDto.afterMail" class="glyphicon glyphicon-envelope text-success" style="font-size:1.5em" aria-hidden="true"></span></td><td ng-show="showBookingData">{{currentSubscription.driverDto.hotel}}</td><td ng-show="showBookingData">{{currentSubscription.driverDto.description}}</td><td ng-show="showBookingData">{{currentSubscription.driverDto.instructionType}}</td><td ng-show="showBookingData">{{currentSubscription.driverDto.instructionHours}}</td><td ng-show="showInstructionData">{{currentSubscription.driverDto.instructor}}</td><td ng-show="showInstructionData">{{currentSubscription.driverDto.instructionGroup}}</td><td ng-show="showInstructionData"><span class="badge">{{isDefinedAndNotNull(currentSubscription.driverDto.drivingResults) ? currentSubscription.driverDto.drivingResults : 0}}</span> <span>/</span> <span class="badge">{{isDefinedAndNotNull(currentSubscription.driverDto.progress) ? currentSubscription.driverDto.progress : 0}}</span></td><td ng-show="showInstructionData">{{currentSubscription.driverDto.drivingProgress}}</td><td ng-show="showInstructionData">{{currentSubscription.driverDto.drivingDirections}}</td><td><div class="pull-right"><button id="subscription.driver.email{$index}}" ng-click="showEmailDialog(booking.id, currentSubscription.driverDto.subscriptionIdPk)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-envelope"></span></button> <button id="subscription.driver.edit{$index}}" ng-click="editSubscription(currentSubscription.driverDto)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="subscription.driver.deleteButton{$index}}" ng-click="deleteDriverSubscription(currentSubscription.driverDto)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr><tr ng-class="{\'success\' : secondDriver.status==\'CONFIRMED\', \'warning\': secondDriver.status==\'RESERVED\'}" ng-repeat="secondDriver in currentSubscription.secondDriverDtoList" ng-hide="hideAddingNewDriver"><td><strong>Second driver</strong></td><td><a ui-sref="user-relation.detail({relationId:secondDriver.relationIdPk})"><span>{{secondDriver.subscriptionPersonName}}</span> </a><span class="badge">{{secondDriver.instructionGroup}}</span> <span class="glyphicon pull-right" tooltip-placement="bottom" uib-tooltip="{{translateStatus(secondDriver.status)}}" style="font-size:1.5em" aria-hidden="true" ng-class="{\'glyphicon-ok-sign text-success\': secondDriver.status==\'CONFIRMED\',\r\n                                             \'glyphicon-question-sign text-warning\': secondDriver.status==\'RESERVED\',\r\n                                             \'glyphicon-remove-sign text-warning\': secondDriver.status==\'CANCELLED\'}"></span></td><td ng-show="showBookingData">{{getBookingArticle(secondDriver)}}</td><td ng-show="showBookingData"><span ng-show="secondDriver.infoMail" class="glyphicon glyphicon-envelope text-warning" style="font-size:1.5em" aria-hidden="true"></span> <span ng-show="secondDriver.afterMail" class="glyphicon glyphicon-envelope text-success" style="font-size:1.5em" aria-hidden="true"></span></td><td ng-show="showBookingData">{{secondDriver.hotel}}</td><td ng-show="showBookingData">{{secondDriver.description}}</td><td ng-show="showBookingData">{{secondDriver.instructionType}}</td><td ng-show="showBookingData">{{secondDriver.instructionHours}}</td><td ng-show="showInstructionData">{{secondDriver.instructor}}</td><td ng-show="showInstructionData">{{secondDriver.instructionGroup}}</td><td ng-show="showInstructionData"><span class="badge">{{isDefinedAndNotNull(secondDriver.drivingResults) ? secondDriver.drivingResults : 0}}</span> <span>/</span> <span class="badge">{{isDefinedAndNotNull(secondDriver.progress) ? secondDriver.progress : 0}}</span></td><td ng-show="showInstructionData">{{secondDriver.drivingProgress}}</td><td ng-show="showInstructionData">{{secondDriver.drivingDirections}}</td><td><div class="pull-right"><button id="subscription.secondDriver.email{$index}}" ng-click="showEmailDialog(booking.id, secondDriver.subscriptionIdPk)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-envelope"></span></button> <button id="subscription.secondDriver.editButton{$index}}" ng-click="editSubscription(secondDriver)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button id="subscription.secondDriver.deleteButton{$index}}" ng-click="deleteSubscription(secondDriver)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr><tr ng-class="{\'success\' : spectator.status==\'CONFIRMED\', \'warning\': spectator.status==\'RESERVED\'}" ng-repeat="spectator in currentSubscription.spectatorDtoList" ng-hide="hideAddingNewDriver"><td><strong>Spectator</strong></td><td>{{spectator.subscriptionPersonName}} <span class="glyphicon pull-right" tooltip-placement="bottom" uib-tooltip="{{translateStatus(spectator.status)}}" style="font-size:1.5em" aria-hidden="true" ng-class="{\'glyphicon-ok-sign text-success\': spectator.status==\'CONFIRMED\',\r\n                                             \'glyphicon-question-sign text-warning\': spectator.status==\'RESERVED\',\r\n                                             \'glyphicon-remove-sign text-warning\': spectator.status==\'CANCELLED\'}"></span></td><td ng-show="showBookingData">{{getBookingArticle(spectator)}}</td><td ng-show="showBookingData"><span ng-show="spectator.infoMail" class="glyphicon glyphicon-envelope text-warning" style="font-size:1.5em" aria-hidden="true"></span> <span ng-show="spectator.afterMail" class="glyphicon glyphicon-envelope text-success" style="font-size:1.5em" aria-hidden="true"></span></td><td ng-show="showBookingData">{{spectator.hotel}}</td><td ng-show="showBookingData">{{spectator.description}}</td><td ng-show="showBookingData" colspan="2"></td><td ng-show="showInstructionData" colspan="5"></td><td><div class="pull-right"><button id="spectator.email{$index}}" ng-click="showEmailDialog(booking.id, spectator.subscriptionIdPk)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-envelope"></span></button> <button id="subscription.spectator.editButton{$index}}" ng-click="editSubscription(spectator)" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button id="subscription.spectator.deleteButton{$index}}" ng-click="deleteSubscription(spectator)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="backToEvent()" class="btn btn-sm"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="booking.detail.action.event">Event details</span></button> <button type="button" ng-click="backToSalesDashboard()" class="btn btn-sm"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="booking.detail.action.sales">Sales dashboard</span></button></div></div></div><div class="modal fade" id="deleteSubscriptionConfirmation"><div class="modal-dialog"><jhi-alert></jhi-alert><div class="modal-content"><form name="deleteForm" ng-submit="confirmDeleteDriverSubscription(subscriptionToDelete.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="subscription.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p>NOTE Deleting driver {{subscriptionToDelete.relation.personName}} also results in deleting all second drivers and spectators on this page. Are you sure you want to proceed?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteSubscription" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/event/event-detail-with-subscriptions.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="EventDetailTitle" translate="event.detail.title">Event</span> {{event.name}}</h3><p class="small text-lowercase panel-sub-title"><span translate="event.detail.creator.label">Creator:</span> <span ng-show="event.creator != null">{{event.creator}}</span> <span ng-show="event.creator == null">-&nbsp;</span> <span class="form-control-static" ng-show="event.createdOn != null">{{event.createdOn | nullableDateTimeNoZone}}</span> ,&nbsp;<span translate="event.detail.updater.label">Updater: </span><span ng-show="event.updater != null">{{event.updater}}</span> <span ng-show="event.updater == null">-&nbsp;</span> <span class="form-control-static" ng-show="event.updatedOn != null">{{event.updatedOn | nullableDateTimeNoZone}}</span></p></div><div class="panel-buttons"><button ui-sref="event.detail.subscriptions.edit({eventId:event.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button ui-sref="event.detail.booking({eventId:event.id})" class="btn btn-primary"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span>&nbsp;Create new booking</button> <button ng-click="updateInfoMail()" class="btn"><span class="glyphicon glyphicon-envelope text-warning" aria-hidden="true"></span> <span>Info mail</span></button> <button ng-click="updateAfterMail()" class="btn"><span class="glyphicon glyphicon-envelope text-success" aria-hidden="true"></span> <span>After mail</span></button> <button ng-click="syncAudiences()" class="btn" tooltip-placement="top" uib-tooltip="Sync audience with mailchimp"><span class="glyphicon glyphicon-indent-left text-success" aria-hidden="true"></span> <span>Sync audience</span></button> <a ng-if="event.mailChimpAudienceWebId" href="{{\'https://us9.admin.mailchimp.com/lists/members?id=\' + this.event.mailChimpAudienceWebId}}" target="_blank" ng-click="syncAudiences()" class="btn btn-a" tooltip-placement="top" uib-tooltip="Open audience in the MailChimp"><span class="glyphicon glyphicon-link text-success" aria-hidden="true"></span> <span>View audience</span> </a><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="row"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed layout-container"><tbody><tr><td style="width: 100%"><!-- start panel container --><div class="panel panel-default"><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr ng-class="{\r\n                                                    \'success\':event.workdaysRemaining >= 14,\r\n                                                    \'warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14,\r\n                                                    \'danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}"><td style="width: 25%"><span>{{event.description}}</span></td><td style="width: 25%"><span>{{event.startDate | nullableDate}}&nbsp;({{event.workdaysRemaining}} days remaining)</span></td><td style="width: 25%"><label translate="event.detail.location.label">Location</label></td><td style="width: 25%"><a ui-sref="location.detail({locationId:event.location.id})"><span>{{event.location.name}}</span></a></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><td style="width: 100%"><!-- start panel container --><div class="panel panel-default"><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td style="width: 50%"><label translate="event.detail.costCenter.label">costcenter</label></td><td style="width: 50%"><strong>{{event.costCenter}}</strong></td></tr><tr><td style="width: 50%"><label translate="event.detail.additionalInfo.label"></label></td><td style="width: 50%; white-space: pre-line">{{event.additionalInfo}}</td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><td style="width: 100%"><!-- start panel container --><div class="panel panel-default"><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td style="width: 25%"><label translate="event.detail.availableSpots.label">AvailableSpots</label></td><td style="width: 25%"><em class="text-muted">{{event.target}} - ({{event.totalConfirmed}} + {{event.totalReserved}})</em> = <strong>{{event.availableSpots}}</strong></td><td colspan="2" style="width: 50%"><em class="text-muted" translate="event.detail.subscriptions.explanation"></td></tr><tr><td style="width: 25%"><label translate="event.detail.totalInstructionHours.label">TotalInstructionHours</label></td><td style="width: 25%"><em class="text-muted">({{event.confirmedInstructionHours}} + {{event.reservedInstructionHours}})</em> = <strong>{{event.totalInstructionHours}}</strong></td><td colspan="2" style="width: 50%"><em class="text-muted" translate="event.detail.subscriptions.instructionHoursCalculation.explanation"></td></tr><tr><td style="width: 25%"><label translate="event.detail.instructorsAvailable.label">InstructorsAvailable</label></td><td style="width: 25%"><em class="text-muted">({{event.instructorsAvailable}} x {{event.templateEvent.instructionRatio}})</em> = <strong>{{event.instructorsAvailable * event.templateEvent.instructionRatio}}</strong></td><td colspan="2" style="width: 50%"><em class="text-muted" translate="event.detail.subscriptions.instructorsAvailableCalculation.explanation"></td></tr><tr><td style="width: 25%"><label translate="event.detail.totalHotelPositions.label">TotalHotelPositions</label></td><td style="width: 25%"><em class="text-muted">({{event.confirmedHotelPositions}} + {{event.reservedHotelPositions}})</em> = <strong>{{event.totalHotelPositions}}</strong></td><td colspan="2" style="width: 50%"><em class="text-muted" translate="event.detail.subscriptions.hotelPositionsCalculation.explanation"></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><!-- END row in rows --></tbody></table></div></div></div><div><uib-tabset active="$root.eventActiveTab"><uib-tab heading="Subscriptions" ng-click="loadData()" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><div class="table-responsive"><table class="table table-condensed table-striped table-bordered"><thead><tr><th><span>Booking</span></th><th><span>Driver</span></th><th><span>Second driver(s)</span></th><th><span>Spectator(s)</span></th><th><span>Car</span></th><th><span>Insurance</span></th><th><span>Hotel</span></th><th><span>Instructor</span></th><th><span>Instruction type</span></th><th><span>Instruction hours</span></th><th><span>Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="subscription in subscriptionList"><td id="subscription.bookingPersonName{$index}}" class="small" ng-class="{\'danger\' : !subscription.bookingIsBilled, \'success\' : subscription.bookingIsBilled}"><span class="pull-left label label-subscription"><span><a ui-sref="user-relation.detail({relationId:subscription.bookingClientId})"><span>{{ subscription.bookingPersonName }}</span> </a></span></span><span class="pull-right label label-subscription"><span class="label label-info label-additional" tooltip-placement="bottom" uib-tooltip="Season booking">{{(subscription.bookingIsSeason) ? \'S\' : \'\'}}</span> <span class="label label-success label-additional" tooltip-placement="bottom" uib-tooltip="Vip booking">{{(subscription.bookingIsVip) ? \'V\' : \'\'}}</span></span></td><td id="subscription.driverDto.subscriptionPersonName{$index}}" class="small success"><span class="pull-left label label-subscription"><span><a ui-sref="user-relation.detail({relationId:subscription.driverDto.relationIdPk})"><span>{{subscription.driverDto.subscriptionPersonName}}</span> </a></span><span class="badge">{{subscription.driverDto.instructionGroup}}</span> </span><span class="pull-right"><span class="glyphicon" tooltip-placement="bottom" uib-tooltip="{{translateStatus(subscription.driverDto.status)}}" style="font-size:1.5em" aria-hidden="true" ng-class="{\'glyphicon-ok-sign text-success\': subscription.driverDto.status==\'CONFIRMED\',\r\n                                                         \'glyphicon-question-sign text-warning\': subscription.driverDto.status==\'RESERVED\',\r\n                                                         \'glyphicon-remove-sign text-warning\': subscription.driverDto.status==\'CANCELLED\'}"></span> <span class="glyphicon glyphicon-envelope" ng-hide="!subscription.driverDto.infoMail" tooltip-placement="bottom" uib-tooltip="Only info mail indicates as blue, after mail as green" style="font-size:1.5em" aria-hidden="true" ng-class="{\'text-warning\': subscription.driverDto.infoMail}"></span> <span class="glyphicon glyphicon-envelope" ng-hide="!subscription.driverDto.afterMail" tooltip-placement="bottom" uib-tooltip="Only info mail indicates as blue, after mail as green" style="font-size:1.5em" aria-hidden="true" ng-class="{\'text-success\': subscription.driverDto.afterMail}"></span></span></td><td id="subscription.secondDriverDtoList{$index}}" class="small success"><span ng-repeat="secondDriver in subscription.secondDriverDtoList"><span class="pull-left label label-subscription"><span><a ui-sref="user-relation.detail({relationId:secondDriver.relationIdPk})"><span>{{secondDriver.subscriptionPersonName}}</span> </a></span><span class="badge">{{secondDriver.instructionGroup}}</span> </span><span class="pull-right"><span class="glyphicon" tooltip-placement="bottom" uib-tooltip="{{translateStatus(secondDriver.status)}}" style="font-size:1.5em" aria-hidden="true" ng-class="{\'glyphicon-ok-sign text-success\': secondDriver.status==\'CONFIRMED\',\r\n                                                             \'glyphicon-question-sign text-warning\': secondDriver.status==\'RESERVED\',\r\n                                                             \'glyphicon-remove-sign text-warning\': secondDriver.status==\'CANCELLED\'}"></span> <span class="glyphicon glyphicon-envelope pull-right" ng-hide="!secondDriver.infoMail" tooltip-placement="bottom" uib-tooltip="Only info mail indicates as blue, after mail as green" style="font-size:1.5em" aria-hidden="true" ng-class="{\'text-warning\': secondDriver.infoMail}"></span> <span class="glyphicon glyphicon-envelope pull-right" ng-hide="!secondDriver.afterMail" tooltip-placement="bottom" uib-tooltip="Only info mail indicates as blue, after mail as green" style="font-size:1.5em" aria-hidden="true" ng-class="{\'text-success\': secondDriver.afterMail}"></span> {{$last ? \'\' : \', \'}}</span></span></td><td id="subscription.spectatorDtoList{$index}}" class="small success"><span ng-repeat="spectator in subscription.spectatorDtoList"><span class="label label-subscription"><span>{{spectator.subscriptionPersonName}}</span> <span class="glyphicon" tooltip-placement="bottom" uib-tooltip="{{translateStatus(spectator.status)}}" style="font-size:1.5em" aria-hidden="true" ng-class="{\'glyphicon-ok-sign text-success\': spectator.status==\'CONFIRMED\',\r\n                                                             \'glyphicon-question-sign text-warning\': spectator.status==\'RESERVED\',\r\n                                                             \'glyphicon-remove-sign text-warning\': spectator.status==\'CANCELLED\'}"></span> <span class="glyphicon glyphicon-envelope" ng-hide="!spectator.infoMail" tooltip-placement="bottom" uib-tooltip="Only info mail indicates as blue, after mail as green" style="font-size:1.5em" aria-hidden="true" ng-class="{\'text-warning\': spectator.infoMail}"></span> <span class="glyphicon glyphicon-envelope" ng-hide="!spectator.afterMail" tooltip-placement="bottom" uib-tooltip="Only info mail indicates as blue, after mail as green" style="font-size:1.5em" aria-hidden="true" ng-class="{\'text-success\': spectator.afterMail}"></span> {{$last ? \'\' : \', \'}}</span></span></td><td id="subscription.driverDto.car{$index}}" class="small info"><span>{{ subscription.driverDto.car }}</span> <span class="pull-right label label-subscription"><span class="label label-success label-additional" tooltip-placement="bottom" uib-tooltip="Rental car">{{(subscription.driverDto.carIsRental) ? \'R\' : \'\'}}</span> <span class="label label-info label-additional" tooltip-placement="bottom" uib-tooltip="Service car">{{(subscription.driverDto.carIsServiced) ? \'M\' : \'\'}}</span> <span class="label label-warning label-license">{{ subscription.driverDto.carLicense }}</span></span></td><td id="subscription.driverDto.insurance{$index}}" class="small info">{{ subscription.driverDto.insurance }}</td><td id="subscription.hotel{$index}}" class="small"><span>{{getHotels(subscription)}}</span></td><td id="subscription.instructor{$index}}" class="small warning"><span>{{getInstructors(subscription)}}</span></td><td id="subscription.driverDto.instructionType{$index}}" class="small warning"><span>{{getInstructionTypes(subscription)}}</span></td><td id="subscription.driverDto.instructionHours{$index}}" class="small warning">{{getInstructionHours(subscription)}}</td><td id="subscription.driverDto.description{$index}}" class="small warning">{{ subscription.driverDto.description }}</td><td><span class="pull-right text-nowrap"><button id="subscription.delete{$index}}" ng-click="deleteDriver(subscription)" ng-disabled="!isDefinedAndNotNull(subscription.driverDto)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove"></span></button> <button id="subscription.details{$index}}" ui-sref="event.detail.booking({eventId:event.id,bookingId:subscription.bookingIdPk,driverId:subscription.driverDto.subscriptionIdPk})" class="btn btn-info btn-xs" title="Go to Booking and Subscriptions"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="booking.details{$index}}" ui-sref="booking.detail({bookingId:subscription.bookingIdPk})" ng-disabled="!isDefinedAndNotNull(subscription.bookingIdPk)" class="btn btn-success btn-xs" title="Go to Booking details"><span class="glyphicon glyphicon-euro"></span></button></span></td></tr></tbody></table></div></uib-tab><uib-tab heading="{{\'event.detail.tab.booking.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><bookings-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></bookings-overview-mapped-by-event></uib-tab><uib-tab heading="{{\'event.detail.tab.document.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></documents-overview-mapped-by-event></uib-tab><uib-tab heading="{{\'event.detail.tab.instructor.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><instructors-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></instructors-overview-mapped-by-event></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/event/event-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="EventDetailTitle" translate="event.detail.title">Event</span> {{event.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="event.detail.creator.label">Creator:</span>&nbsp; <span>{{event.creator}} {{event.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="event.updater">,&nbsp; <span translate="event.detail.updater.label">Updater: </span>&nbsp; <span>{{event.updater}} {{event.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="event.detail.edit({eventId:event.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(event.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="event.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="event.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Event?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="event.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="event.detail.name.label">name</span></td><td><span class="form-control-static">{{event.name}}</span></td></tr><tr><td><span translate="event.detail.startDate.label">startDate</span></td><td><span class="form-control-static">{{event.startDate | nullableDate}}</span></td></tr><tr><td><span translate="event.detail.duration.label">duration</span></td><td><span class="form-control-static">{{event.duration}}</span></td></tr><tr><td><span translate="event.detail.target.label">target</span></td><td><span class="form-control-static">{{event.target}}</span></td></tr><tr><td><span translate="event.detail.status.label">status</span></td><td><span class="form-control-static">{{event.status === null ? "" : \'EventStatus.\' + event.status | translate}}</span></td></tr><tr><td><span translate="event.detail.templateEvent.label">templateEvent</span></td><td><a ui-sref="templateevent.detail({templateEventId:event.templateEvent.id})"><span>{{event.templateEvent.name}}</span></a></td></tr><tr><td><span translate="event.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{event.description}}</span></td></tr><tr><td><span translate="event.detail.additionalInfo.label">additionalInfo</span></td><td><span class="form-control-static white-space-pre">{{event.additionalInfo}}</span></td></tr><tr><td><span translate="event.detail.costCenter.label">costCenter</span></td><td><span class="form-control-static">{{event.costCenter}}</span></td></tr><tr><td><span translate="event.detail.location.label">location</span></td><td><a ui-sref="location.detail({locationId:event.location.id})"><span>{{event.location.name}}</span></a></td></tr><tr><td><span translate="event.detail.totalConfirmed.label">totalConfirmed</span></td><td><span class="form-control-static">{{event.totalConfirmed}}</span></td></tr><tr><td><span translate="event.detail.totalReserved.label">totalReserved</span></td><td><span class="form-control-static">{{event.totalReserved}}</span></td></tr><tr><td><span translate="event.detail.availableSpots.label">availableSpots</span></td><td><span class="form-control-static">{{event.availableSpots}}</span></td></tr><tr ng-class="{\'available-instructor-mismatch\': event.instructorsNeeded > event.instructorsAvailable}"><td><span translate="event.detail.instructorsAvailable.label">instructorsAvailable</span></td><td><span class="form-control-static">{{event.instructorsAvailable}}</span></td></tr><tr><td><span translate="event.detail.exclusive.label">exclusive</span></td><td><span class="form-control-static">{{event.exclusive}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.eventActiveTab"><uib-tab id="tab-bookings-overview-mapped-by-event" heading="{{\'event.detail.tab.booking.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><bookings-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></bookings-overview-mapped-by-event></uib-tab><uib-tab id="tab-documents-overview-mapped-by-event" heading="{{\'event.detail.tab.document.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></documents-overview-mapped-by-event></uib-tab><uib-tab id="tab-instructors-overview-mapped-by-event" heading="{{\'event.detail.tab.instructor.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><instructors-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></instructors-overview-mapped-by-event></uib-tab><uib-tab id="tab-eventrelationcontacts-overview-mapped-by-event" heading="{{\'event.detail.tab.eventRelationContact.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><eventrelationcontacts-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></eventrelationcontacts-overview-mapped-by-event></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/event/event-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="EventDialogTitleCreate" translate="event.dialog.title.create">Create a Event</h4><h4 class="modal-title" ng-show="isEdit()" id="EventDialogTitleEdit" translate="event.dialog.title.edit" translate-value-id="{{event.id}}">Edit a Event</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="event.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="event.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="event.name" required ng-maxlength="50" placeholder="{{\'event.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.startDate.$invalid, \'has-success\' : editForm.startDate.$valid && editForm.startDate.$dirty }"><label for="field_startDate" id="label_startDate" class="col-sm-2 control-label" translate="event.dialog.startDate.label">StartDate</label><div class="col-sm-9"><input datepicker-localdate type="date" class="form-control input-sm" name="startDate" id="field_startDate" ng-model="event.startDate" required><p class="help-block" ng-show="editForm.startDate.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.duration.$invalid, \'has-success\' : editForm.duration.$valid && editForm.duration.$dirty }"><label for="field_duration" id="label_duration" class="col-sm-2 control-label" translate="event.dialog.duration.label">Duration</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="duration" id="field_duration" ng-model="event.duration" required ng-maxlength="-1" placeholder="{{\'event.dialog.duration.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.duration.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.target.$invalid, \'has-success\' : editForm.target.$valid && editForm.target.$dirty }"><label for="field_target" id="label_target" class="col-sm-2 control-label" translate="event.dialog.target.label">Target</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="target" id="field_target" ng-model="event.target" ng-maxlength="-1" placeholder="{{\'event.dialog.target.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.status.$invalid, \'has-success\' : editForm.status.$valid && editForm.status.$dirty }"><label for="field_status" class="col-sm-2 control-label" translate="event.dialog.status.label">status</label><div class="col-sm-9"><select ng-disabled="\'status\' == mappedBy" class="form-control input-sm" id="field_status" name="status" ng-model="event.status" ng-options="\'EventStatus.\' + status | translate for status in statusList"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.templateEvent.$invalid, \'has-success\' : editForm.templateEvent.$valid && editForm.templateEvent.$dirty }"><label for="field_templateEvent" class="col-sm-2 control-label" translate="event.dialog.templateEvent.label">templateEvent</label><div class="col-sm-9"><select ng-disabled="\'templateEvent\' == mappedBy" class="form-control input-sm" id="field_templateEvent" name="templateEvent" ng-model="event.templateEvent" ng-change="changeTemplateEvent(event.templateEvent)" required ng-options="templateEvent as templateEvent.name for templateEvent in templateEventList track by templateEvent.id"><option value=""></option></select><div ng-show="editForm.templateEvent.$invalid"><p class="help-block" ng-show="editForm.templateEvent.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new templateevent" ng-disabled="\'templateEvent\' == mappedBy" ng-click="createTemplateEvent()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="event.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="event.description" required ng-maxlength="-1" placeholder="{{\'event.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.additionalInfo.$invalid, \'has-success\' : editForm.additionalInfo.$valid && editForm.additionalInfo.$dirty }"><label for="field_additionalInfo" id="label_additionalInfo" class="col-sm-2 control-label" translate="event.dialog.additionalInfo.label">AdditionalInfo</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="additionalInfo" id="field_additionalInfo" ng-model="event.additionalInfo" ng-maxlength="-1" placeholder="{{\'event.dialog.additionalInfo.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.costCenter.$invalid, \'has-success\' : editForm.costCenter.$valid && editForm.costCenter.$dirty }"><label for="field_costCenter" id="label_costCenter" class="col-sm-2 control-label" translate="event.dialog.costCenter.label">CostCenter</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="costCenter" id="field_costCenter" ng-model="event.costCenter" required ng-maxlength="-1" placeholder="{{\'event.dialog.costCenter.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.costCenter.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.location.$invalid, \'has-success\' : editForm.location.$valid && editForm.location.$dirty }"><label for="field_location" class="col-sm-2 control-label" translate="event.dialog.location.label">location</label><div class="col-sm-9"><select ng-disabled="\'location\' == mappedBy" class="form-control input-sm" id="field_location" name="location" ng-model="event.location" required ng-options="location as location.name for location in locationList track by location.id"><option value=""></option></select><div ng-show="editForm.location.$invalid"><p class="help-block" ng-show="editForm.location.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new location" ng-disabled="\'location\' == mappedBy" ng-click="createLocation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.totalConfirmed.$invalid, \'has-success\' : editForm.totalConfirmed.$valid && editForm.totalConfirmed.$dirty }"><label for="field_totalConfirmed" id="label_totalConfirmed" class="col-sm-2 control-label" translate="event.dialog.totalConfirmed.label">TotalConfirmed</label><div class="col-sm-9"><input readonly="true" type="number" class="form-control input-sm" name="totalConfirmed" id="field_totalConfirmed" ng-model="event.totalConfirmed" ng-maxlength="-1" placeholder="{{\'event.dialog.totalConfirmed.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.totalReserved.$invalid, \'has-success\' : editForm.totalReserved.$valid && editForm.totalReserved.$dirty }"><label for="field_totalReserved" id="label_totalReserved" class="col-sm-2 control-label" translate="event.dialog.totalReserved.label">TotalReserved</label><div class="col-sm-9"><input readonly="true" type="number" class="form-control input-sm" name="totalReserved" id="field_totalReserved" ng-model="event.totalReserved" ng-maxlength="-1" placeholder="{{\'event.dialog.totalReserved.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.availableSpots.$invalid, \'has-success\' : editForm.availableSpots.$valid && editForm.availableSpots.$dirty }"><label for="field_availableSpots" id="label_availableSpots" class="col-sm-2 control-label" translate="event.dialog.availableSpots.label">AvailableSpots</label><div class="col-sm-9"><input readonly="true" type="number" class="form-control input-sm" name="availableSpots" id="field_availableSpots" ng-model="event.availableSpots" ng-maxlength="-1" placeholder="{{\'event.dialog.availableSpots.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.instructorsAvailable.$invalid, \'has-success\' : editForm.instructorsAvailable.$valid && editForm.instructorsAvailable.$dirty }"><label for="field_instructorsAvailable" id="label_instructorsAvailable" class="col-sm-2 control-label" translate="event.dialog.instructorsAvailable.label">InstructorsAvailable</label><div class="col-sm-9"><input readonly="true" type="number" class="form-control input-sm" name="instructorsAvailable" id="field_instructorsAvailable" ng-model="event.instructorsAvailable" ng-maxlength="-1" placeholder="{{\'event.dialog.instructorsAvailable.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.exclusive.$invalid, \'has-success\' : editForm.exclusive.$valid && editForm.exclusive.$dirty }"><label for="field_exclusive" id="label_exclusive" class="col-sm-2 control-label" translate="event.dialog.exclusive.label">Exclusive</label><div class="col-sm-9"><nz-toggle ng-disabled="isInEditState()" id="field_exclusive" name="exclusive" ng-model="event.exclusive" val-true="true" val-false="false" val-null="null" val-default="false" class="square"></nz-toggle><p class="help-block" ng-show="editForm.exclusive.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="event.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="event.dialog.saveAndNew.button">Save</span></button></div></form>');
$templateCache.put('app/entities/event/event-edit-user.html','<!--// Created by html/angular/entity/dto-edit.ftl--><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="!isEdit()" id="EventDialogTitleCreate" translate="event.dialog.title.create">Create a Event</h3><h3 class="voffset" ng-show="isEdit()" id="EventDialogTitleEdit" translate="event.dialog.title.edit" translate-value-id="{{event.id}}">Edit a Event</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.name.label" for="field_name">Name</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="event.name" required ng-maxlength="50" ng-minlength="2" autofocus placeholder="{{\'event.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.startDate.label" for="field_startDate">StartDate</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input datepicker-localdate type="date" class="form-control input-sm" name="startDate" id="field_startDate" ng-model="event.startDate" required><p class="help-block" ng-show="editForm.startDate.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.duration.label" for="field_duration">Duration</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="duration" id="field_duration" ng-model="event.duration" required placeholder="{{\'event.dialog.duration.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.duration.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.target.label" for="field_target">Target</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="target" id="field_target" ng-model="event.target" placeholder="{{\'event.dialog.target.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.status.label" for="field_status">Status</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><select ng-disabled="\'status\' == mappedBy" class="form-control input-sm" id="field_status" name="status" ng-model="event.status" ng-options="\'EventStatus.\' + status | translate for status in event.statusList"><option value=""></option></select></div><!-- close column--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.templateEvent.label" for="field_templateEvent">TemplateEvent</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'templateEvent\' == mappedBy" class="form-control input-sm" id="field_templateEvent" name="templateEvent" ng-model="event.selectedTemplateEvent" ng-change="changeTemplateEvent(event.templateEvent)" required ng-options="templateEvent as templateEvent.displayValue for templateEvent in event.templateEventList track by templateEvent.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new templateevent" ng-click="createTemplateEvent()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div><p class="help-block" ng-show="editForm.templateEvent.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.description.label" for="field_description">Description</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="event.description" required placeholder="{{\'event.dialog.description.placeholder\'|translate}}">\r\n\t\t\t\t\t</textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.costCenter.label" for="field_costCenter">CostCenter</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="costCenter" id="field_costCenter" ng-model="event.costCenter" required placeholder="{{\'event.dialog.costCenter.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.costCenter.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #9--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.location.label" for="field_location">Location</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'location\' == mappedBy" class="form-control input-sm" id="field_location" name="location" ng-model="event.selectedLocation" required ng-options="location as location.displayValue for location in event.locationList track by location.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new location" ng-click="createLocation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div><p class="help-block" ng-show="editForm.location.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #10--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.totalConfirmed.label" for="field_totalConfirmed">TotalConfirmed</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input readonly="true" type="number" class="form-control input-sm" name="totalConfirmed" id="field_totalConfirmed" ng-model="event.totalConfirmed" placeholder="{{\'event.dialog.totalConfirmed.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #11--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.totalReserved.label" for="field_totalReserved">TotalReserved</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input readonly="true" type="number" class="form-control input-sm" name="totalReserved" id="field_totalReserved" ng-model="event.totalReserved" placeholder="{{\'event.dialog.totalReserved.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #12--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.availableSpots.label" for="field_availableSpots">AvailableSpots</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input readonly="true" type="number" class="form-control input-sm" name="availableSpots" id="field_availableSpots" ng-model="event.availableSpots" placeholder="{{\'event.dialog.availableSpots.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.instructorsAvailable.label" for="field_instructorsAvailable">InstructorsAvailable</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input readonly="true" type="number" class="form-control input-sm" name="instructorsAvailable" id="field_instructorsAvailable" ng-model="event.instructorsAvailable" placeholder="{{\'event.dialog.instructorsAvailable.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #14--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.exclusive.label" for="field_exclusive">Exclusive</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><nz-toggle ng-disabled="isInEditState()" id="field_exclusive" ng-model="event.exclusive" val-true="true" val-false="false" val-null="null" val-default="false" class="square"></nz-toggle><p class="help-block" ng-show="editForm.exclusive.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #15--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="event.dialog.additionalInfo.label" for="field_additionalInfo">AdditionalInfo</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><textarea rows="3" class="form-control input-sm" name="additionalInfo" id="field_additionalInfo" ng-model="event.additionalInfo" placeholder="{{\'event.dialog.additionalInfo.placeholder\'|translate}}">\r\n\t\t\t\t\t</textarea></div><!-- close column--></div><div class="row voffset2"><!--row #16--></div><div class="row voffset2"><!--row #17--></div><div class="row voffset2"><!--row #18--></div><div class="row voffset2"><!--row #19--></div><div class="row voffset2"><!--row #20--></div><div class="row voffset2"><!--row #21--></div><div class="row voffset2"><!--row #22--></div><div class="row voffset2"><!--row #23--></div><div class="row voffset2"><!--row #24--></div><div class="row voffset2"><!--row #25--></div><div class="row voffset2"><!--row #26--></div><div class="row voffset2"><!--row #27--></div><div class="row voffset2"><!--row #28--></div><div class="row voffset2"><!--row #29--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="event.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="event.dialog.saveAndNew.button">Save</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/event/event-eventdetail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="EventDetailTitle" translate="event.detail.title">Event</span> {{event.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="event.detail.creator.label">Creator:</span>&nbsp; <span>{{event.creator}} {{event.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="event.updater">,&nbsp; <span translate="event.detail.updater.label">Updater: </span>&nbsp; <span>{{event.updater}} {{event.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="event.detail.edit({eventId:event.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="modal fade" id="deleteEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(event.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="event.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="event.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Event?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="event.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="panel-body"><div class="row"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed layout-container"><tbody><tr><!--row #1--><td style="width: 100%"><!--column #1--><!-- start panel container --><div class="panel panel-default"><div class="panel-heading" translate="event.detail.panel.main">event.detail.panel.main</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td colspan="2" style="width: 50%"><!--column #1--><textarea ng-model="event.description" disabled="disabled" class="form-control" rows="5"></textarea></td><td style="width: 25%"><!--column #2--> <span>{{event.startDate | nullableDate}}</span>&nbsp;</td><td style="width: 25%"><!--column #3--><label translate="event.detail.location.label">Location</label></td><td style="width: 25%"><!--column #4--> <a ui-sref="location.detail({locationId:event.location.id})"><span>{{event.location.name}}</span></a></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="event.detail.workdaysRemaining.label">WorkdaysRemaining</label></td><td style="width: 25%"><!--column #2--> <span>{{event.workdaysRemaining}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><!--row #2--><td style="width: 100%"><!--column #1--><!-- start panel container --><div class="panel panel-default"><div class="panel-heading" translate="event.detail.panel.calculations">event.detail.panel.calculations</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td colspan="2" style="width: 50%"><!--column #1--><label translate="event.detail.availableSpots.label">AvailableSpots</label></td><td style="width: 25%"><!--column #2--> <em class="text-muted">{{event.target}} - ({{event.totalConfirmed}} + {{event.totalReserved}})</em> = <strong>{{event.availableSpots}}</strong></td><td colspan="2" style="width: 50%"><!--column #3--> <em class="text-muted" translate="event.detail.subscriptions.explanation"></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="event.detail.totalInstructionHours.label">TotalInstructionHours</label></td><td style="width: 25%"><!--column #2--> <em class="text-muted">({{event.confirmedInstructionHours}} + {{event.reservedInstructionHours}})</em> = <strong>{{event.totalInstructionHours}}</strong></td><td colspan="2" style="width: 50%"><!--column #3--> <em class="text-muted" translate="event.detail.subscriptions.instructionHoursCalculation.explanation"></td></tr><tr><!--row #3--><td style="width: 25%"><!--column #1--><label translate="event.detail.instructorsAvailable.label">InstructorsAvailable</label></td><td style="width: 25%"><!--column #2--> <em class="text-muted">({{event.instructorsAvailable}} x {{event.templateEvent.instructionRatio}})</em> = <strong>{{event.instructorsAvailable * event.templateEvent.instructionRatio}}</strong></td><td colspan="2" style="width: 50%"><!--column #3--> <em class="text-muted" translate="event.detail.subscriptions.instructorsAvailableCalculation.explanation"></td></tr><tr><!--row #4--><td style="width: 25%"><!--column #1--><label translate="event.detail.totalHotelPositions.label">TotalHotelPositions</label></td><td style="width: 25%"><!--column #2--> <em class="text-muted">({{event.confirmedHotelPositions}} + {{event.reservedHotelPositions}})</em> = <strong>{{event.totalHotelPositions}}</strong></td><td colspan="2" style="width: 50%"><!--column #3--> <em class="text-muted" translate="event.detail.subscriptions.hotelPositionsCalculation.explanation"></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><!-- END row in rows --></tbody></table></div></div></div><div><uib-tabset active="$root.eventActiveTab"><uib-tab id="tab-bookings-overview-mapped-by-event" heading="{{\'event.detail.tab.booking.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><bookings-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></bookings-overview-mapped-by-event></uib-tab><uib-tab id="tab-documents-overview-mapped-by-event" heading="{{\'event.detail.tab.document.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></documents-overview-mapped-by-event></uib-tab><uib-tab id="tab-instructors-overview-mapped-by-event" heading="{{\'event.detail.tab.instructor.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><instructors-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></instructors-overview-mapped-by-event></uib-tab><uib-tab id="tab-eventrelationcontacts-overview-mapped-by-event" heading="{{\'event.detail.tab.eventRelationContact.by.event\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><eventrelationcontacts-overview-mapped-by-event read-only="true" mapped-by-id="eventId" mapped-by="\'event\'" mapped-by-type="\'event\'"></eventrelationcontacts-overview-mapped-by-event></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/event/event-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="event.overview.title">Events</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createEventButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="event.overview.button.new">Create a new Event</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="event.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="event.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Event</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEvent" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="event.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="EventSearchOverview.predicate" ascending="EventSearchOverview.ascending" callback="search()"><th jh-sort-by="startDate" class="sortable"><span class="pull-left" translate="event.overview.results.header.startDate.label">startDate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'startDate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th class="hidden-xs"><span class="pull-left" translate="event.overview.results.header.workdaysRemaining.label">workdaysRemaining</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="event.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="templateEvent.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="location.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.location.label">location</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'location.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="target" class="sortable"><span class="pull-left" translate="event.overview.results.header.target.label">target</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'target\')}}" aria-hidden="true"></span>&nbsp;</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.totalConfirmed.label">totalConfirmed</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.totalReserved.label">totalReserved</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.availableSpots.label">availableSpots</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.instructorsAvailable.label">instructorsAvailable</span></th><th jh-sort-by="exclusive" class="sortable"><span class="pull-left" translate="event.overview.results.header.exclusive.label">exclusive</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'exclusive\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td><!-- column #0--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.from.label">from</span> <input tabindex="0" class="form-control" name="fromstartDate" ng-model="EventSearchOverview.startDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.to.label">to</span> <input tabindex="0" class="form-control" name="tostartDate" ng-model="EventSearchOverview.startDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #1--></td><td><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'event.overview.search.name.placeholder\' | translate}}" name="name" ng-model="EventSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #3--><ui-select multiple="multiple" ng-model="EventSearchOverview.templateEventIdList" spinner-enabled="true" on-select="updateTemplateEventUISelect($item, $model)" on-remove="updateTemplateEventUISelect($item, $model)"><ui-select-match placeholder="{{\'event.overview.search.templateEvent.defaultOption\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent.id as templateEvent in templateEventReferenceFilterList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></td><td><!-- column #4--><select id="location_select" class="form-control input-sm" ng-options="location as location.displayValue for location in locationReferenceFilterList track by location.id" ng-model="EventSearchOverview.location" tabindex="0" ng-change="search()"><option value="" translate="event.overview.search.location.defaultOption">All Locations</option></select></td><td><!-- column #5--></td><td><!-- column #6--></td><td><!-- column #7--></td><td><!-- column #8--></td><td><!-- column #9--></td><td><!-- column #10--><nz-toggle tri-toggle on-toggle="search()" ng-model="EventSearchOverview.exclusiveGroup" val-true="true" val-false="false" class="square"></nz-toggle></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isEventSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="event in eventList" ng-class="{\r\n\t\t\t\t\t\t\'success\':event.workdaysRemaining>= 14,\r\n\t\t\t\t\t\t\'warning\':event.workdaysRemaining>= 7 && event.workdaysRemaining <14,\r\n\t\t\t\t\t\t\'danger\':event.workdaysRemaining> 0 && event.workdaysRemaining <7}"><td id="event.startDateId{{$index}}"><span ng-hide="event.startDate == null">{{event.startDate | date:\'mediumDate\'}}</span></td><td class="hidden-xs" ng-class="{\'text-success\': event.workdaysRemaining >= 14, \'text-warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14, \'text-danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}" id="event.workdaysRemainingId{{$index}}"><strong>{{event.workdaysRemaining}}</strong></td><td id="event.nameId{{$index}}"><strong>{{event.name}}</strong></td><td><span>{{event.templateEventDisplayValue}}</span></td><td><span>{{event.locationDisplayValue}}</span></td><td id="event.targetId{{$index}}">{{event.target}}</td><td id="event.totalConfirmedId{{$index}}">{{event.totalConfirmed}}</td><td id="event.totalReservedId{{$index}}">{{event.totalReserved}}</td><td id="event.availableSpotsId{{$index}}">{{event.availableSpots}}</td><td ng-class="{\'available-instructor-mismatch\': event.instructorsNeeded > event.instructorsAvailable}" id="event.instructorsAvailableId{{$index}}">{{event.instructorsAvailable}}</td><td id="event.exclusiveId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(event.exclusive)"><span ng-show="event.exclusive" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!event.exclusive" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="customDetailEvent{{$index}}" type="submit" ui-sref="event.detail.subscriptions({eventId:event.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Event{{$index}}" type="submit" ui-sref="user-event.edit({eventId:event.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEvent{{$index}}" type="submit" ng-click="singleDelete(event.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="EventSearchOverview.page" ng-change="search()"></ul></div><div class="col-xs-12 col-md-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/event/event-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createEventButton" class="btn btn-primary" ng-click="goToNewState()" ng-if="showCreateButtonTab"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="event.overview.button.new">Create a new Event</span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteEventConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="event.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="event.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Event</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEvent" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="event.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="EventSearchTab.predicate" ascending="EventSearchTab.ascending" callback="search()"><th jh-sort-by="startDate" class="sortable"><span class="pull-left" translate="event.overview.results.header.startDate.label">startDate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'startDate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th class="hidden-xs"><span class="pull-left" translate="event.overview.results.header.workdaysRemaining.label">workdaysRemaining</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="event.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'templateEvent\'" jh-sort-by="templateEvent.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'location\'" jh-sort-by="location.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.location.label">location</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'location.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="target" class="sortable"><span class="pull-left" translate="event.overview.results.header.target.label">target</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'target\')}}" aria-hidden="true"></span>&nbsp;</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.totalConfirmed.label">totalConfirmed</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.totalReserved.label">totalReserved</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.availableSpots.label">availableSpots</span></th><th class=""><span class="pull-left" translate="event.overview.results.header.instructorsAvailable.label">instructorsAvailable</span></th><th jh-sort-by="exclusive" class="sortable"><span class="pull-left" translate="event.overview.results.header.exclusive.label">exclusive</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'exclusive\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td><!-- column #0--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.from.label">from</span> <input tabindex="0" class="form-control" name="fromstartDate" ng-model="EventSearchTab.startDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.to.label">to</span> <input tabindex="0" class="form-control" name="tostartDate" ng-model="EventSearchTab.startDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #1--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'event.overview.search.workdaysRemaining.placeholder.from\' | translate}}" class="form-control" name="workdaysRemainingFrom" ng-model="EventSearchTab.workdaysRemainingFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'event.overview.search.workdaysRemaining.placeholder.to\' | translate}}" class="form-control" name="toworkdaysRemaining" ng-model="EventSearchTab.workdaysRemainingTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td><!-- column #2--></td><td ng-hide="mappedBy == \'templateEvent\'"><!-- column #3--><ui-select multiple="multiple" ng-model="EventSearchTab.templateEventIdList" spinner-enabled="true" on-select="updateTemplateEventUISelect($item, $model)" on-remove="updateTemplateEventUISelect($item, $model)"><ui-select-match placeholder="{{\'event.overview.search.templateEvent.defaultOption\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent.id as templateEvent in templateEventReferenceFilterList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></td><td ng-hide="mappedBy == \'location\'"><!-- column #4--><select id="location_select" class="form-control input-sm" ng-options="location as location.displayValue for location in locationReferenceFilterList track by location.id" ng-model="EventSearchTab.location" tabindex="0" ng-change="search()"><option value="" translate="event.overview.search.location.defaultOption">All Locations</option></select></td><td><!-- column #5--></td><td><!-- column #6--></td><td><!-- column #7--></td><td><!-- column #8--></td><td><!-- column #9--></td><td><!-- column #10--><nz-toggle tri-toggle on-toggle="search()" ng-model="EventSearchTab.exclusiveGroup" val-true="true" val-false="false" class="square"></nz-toggle></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isEventSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="event in eventList" ng-class="{\r\n\t\t\t\t\t\t\'success\':event.workdaysRemaining>= 14,\r\n\t\t\t\t\t\t\'warning\':event.workdaysRemaining>= 7 && event.workdaysRemaining <14,\r\n\t\t\t\t\t\t\'danger\':event.workdaysRemaining> 0 && event.workdaysRemaining <7}"><td id="event.startDateId{{$index}}"><span ng-hide="event.startDate == null">{{event.startDate | date:\'mediumDate\'}}</span></td><td class="hidden-xs" ng-class="{\'text-success\': event.workdaysRemaining >= 14, \'text-warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14, \'text-danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}" id="event.workdaysRemainingId{{$index}}"><strong>{{event.workdaysRemaining}}</strong></td><td id="event.nameId{{$index}}"><strong>{{event.name}}</strong></td><td ng-hide="mappedBy == \'templateEvent\'"><span>{{event.templateEventDisplayValue}}</span></td><td ng-hide="mappedBy == \'location\'"><span>{{event.locationDisplayValue}}</span></td><td id="event.targetId{{$index}}">{{event.target}}</td><td id="event.totalConfirmedId{{$index}}">{{event.totalConfirmed}}</td><td id="event.totalReservedId{{$index}}">{{event.totalReserved}}</td><td id="event.availableSpotsId{{$index}}">{{event.availableSpots}}</td><td ng-class="{\'available-instructor-mismatch\': event.instructorsNeeded > event.instructorsAvailable}" id="event.instructorsAvailableId{{$index}}">{{event.instructorsAvailable}}</td><td id="event.exclusiveId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(event.exclusive)"><span ng-show="event.exclusive" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!event.exclusive" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="customDetailEvent{{$index}}" type="submit" ui-sref="event.detail.subscriptions({eventId:event.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Event{{$index}}" type="submit" ui-sref="user-event.edit({eventId:event.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEvent{{$index}}" type="submit" ng-click="singleDelete(event.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="EventSearchTab.page" ng-change="search()"></ul></div><div class="col-xs-12 col-md-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></div></div></div></div></div>');
$templateCache.put('app/entities/event/event-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createEventButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="event.overview.button.new">Create a new Event</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="event.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="event.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Event</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEvent" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="event.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="EventSearchTab.predicate" ascending="EventSearchTab.ascending" callback="search()"><th jh-sort-by="startDate" class="sortable"><span class="pull-left" translate="event.overview.results.header.startDate.label">startDate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'startDate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span class="pull-left" translate="event.overview.results.header.workdaysRemaining.label">workdaysRemaining</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="event.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'templateEvent\'" jh-sort-by="templateEvent.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'location\'" jh-sort-by="location.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.location.label">location</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'location.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="target" class="sortable"><span class="pull-left" translate="event.overview.results.header.target.label">target</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'target\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span class="pull-left" translate="event.overview.results.header.totalConfirmed.label">totalConfirmed</span></th><th><span class="pull-left" translate="event.overview.results.header.totalReserved.label">totalReserved</span></th><th><span class="pull-left" translate="event.overview.results.header.availableSpots.label">availableSpots</span></th><th><span class="pull-left" translate="event.overview.results.header.instructorsAvailable.label">instructorsAvailable</span></th><th jh-sort-by="exclusive" class="sortable"><span class="pull-left" translate="event.overview.results.header.exclusive.label">exclusive</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'exclusive\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td><!-- column #0--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.from.label">from</span> <input tabindex="0" class="form-control" name="fromstartDate" ng-model="EventSearchTab.startDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.to.label">to</span> <input tabindex="0" class="form-control" name="tostartDate" ng-model="EventSearchTab.startDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #1--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'event.overview.search.workdaysRemaining.placeholder.from\' | translate}}" class="form-control" name="workdaysRemainingFrom" ng-model="EventSearchTab.workdaysRemainingFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'event.overview.search.workdaysRemaining.placeholder.to\' | translate}}" class="form-control" name="toworkdaysRemaining" ng-model="EventSearchTab.workdaysRemainingTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td><!-- column #2--></td><td ng-hide="mappedBy == \'templateEvent\'"><!-- column #3--><ui-select multiple="multiple" ng-model="EventSearchTab.templateEventIdList" spinner-enabled="true" on-select="updateTemplateEventUISelect($item, $model)" on-remove="updateTemplateEventUISelect($item, $model)"><ui-select-match placeholder="{{\'event.overview.search.templateEvent.defaultOption\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent in templateEventReferenceFilterList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></td><td ng-hide="mappedBy == \'location\'"><!-- column #4--><select id="location_select" class="form-control input-sm" ng-options="location as location.name for location in locationReferenceFilterList track by location.id" ng-model="EventSearchTab.location" tabindex="0" ng-change="search()"><option value="" translate="event.overview.search.location.defaultOption">All Locations</option></select></td><td><!-- column #5--></td><td><!-- column #6--></td><td><!-- column #7--></td><td><!-- column #8--></td><td><!-- column #9--></td><td><!-- column #10--><nz-toggle tri-toggle on-toggle="search()" ng-model="EventSearchTab.exclusiveGroup" val-true="true" val-false="false" class="square"></nz-toggle></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isEventSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="event in eventList" ng-class="{\r\n\'success\':event.workdaysRemaining >= 14,\r\n\'warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14,\r\n\'danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}"><td id="event.startDateId{{$index}}"><span ng-hide="event.startDate == null">{{event.startDate | date:\'mediumDate\'}}</span></td><td class="hidden-xs" ng-class="{\'text-success\': event.workdaysRemaining >= 14, \'text-warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14, \'text-danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}" id="event.workdaysRemainingId{{$index}}"><strong>{{event.workdaysRemaining}}</strong></td><td id="event.nameId{{$index}}"><strong>{{event.name}}</strong></td><td ng-hide="mappedBy == \'templateEvent\'"><a ui-sref="templateevent.detail({templateEventId:event.templateEvent.id})"><span>{{event.templateEvent.name}}</span></a></td><td ng-hide="mappedBy == \'location\'"><a ui-sref="location.detail({locationId:event.location.id})"><span>{{event.location.name}}</span></a></td><td id="event.targetId{{$index}}">{{event.target}}</td><td id="event.totalConfirmedId{{$index}}">{{event.totalConfirmed}}</td><td id="event.totalReservedId{{$index}}">{{event.totalReserved}}</td><td id="event.availableSpotsId{{$index}}">{{event.availableSpots}}</td><td ng-class="{\'available-instructor-mismatch\': event.instructorsNeeded > event.instructorsAvailable}" id="event.instructorsAvailableId{{$index}}">{{event.instructorsAvailable}}</td><td id="event.exclusiveId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(event.exclusive)"><span ng-show="event.exclusive" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!event.exclusive" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="customDetailEvent{{$index}}" type="submit" ui-sref="event.detail.subscriptions({eventId:event.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Event{{$index}}" type="submit" ng-click="goToEditState(event)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEvent{{$index}}" type="submit" ng-click="singleDelete(event.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="EventSearchTab.page" ng-change="search()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></select></div></div></div></div></div>');
$templateCache.put('app/entities/event/events.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="event.overview.title">Events</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createEventButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="event.overview.button.new">Create a new Event</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="event.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="event.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Event</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="event.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEvent" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="event.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="EventSearchOverview.predicate" ascending="EventSearchOverview.ascending" callback="search()"><th jh-sort-by="startDate" class="sortable"><span class="pull-left" translate="event.overview.results.header.startDate.label">startDate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'startDate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span class="pull-left" translate="event.overview.results.header.workdaysRemaining.label">workdaysRemaining</span></th><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="event.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="templateEvent.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="location.name" class="sortable"><span class="pull-left" translate="event.overview.results.header.location.label">location</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'location.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="target" class="sortable"><span class="pull-left" translate="event.overview.results.header.target.label">target</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'target\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span class="pull-left" translate="event.overview.results.header.totalConfirmed.label">totalConfirmed</span></th><th><span class="pull-left" translate="event.overview.results.header.totalReserved.label">totalReserved</span></th><th><span class="pull-left" translate="event.overview.results.header.availableSpots.label">availableSpots</span></th><th><span class="pull-left" translate="event.overview.results.header.instructorsAvailable.label">instructorsAvailable</span></th><th jh-sort-by="exclusive" class="sortable"><span class="pull-left" translate="event.overview.results.header.exclusive.label">exclusive</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'exclusive\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td><!-- column #0--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.from.label">from</span> <input tabindex="0" class="form-control" name="fromstartDate" ng-model="EventSearchOverview.startDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.to.label">to</span> <input tabindex="0" class="form-control" name="tostartDate" ng-model="EventSearchOverview.startDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #1--></td><td><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'event.overview.search.name.placeholder\' | translate}}" name="name" ng-model="EventSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #3--><ui-select multiple="multiple" ng-model="EventSearchOverview.templateEventIdList" spinner-enabled="true" on-select="updateTemplateEventUISelect($item, $model)" on-remove="updateTemplateEventUISelect($item, $model)"><ui-select-match placeholder="{{\'event.overview.search.templateEvent.defaultOption\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent in templateEventReferenceFilterList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></td><td><!-- column #4--><select id="location_select" class="form-control input-sm" ng-options="location as location.name for location in locationReferenceFilterList track by location.id" ng-model="EventSearchOverview.location" tabindex="0" ng-change="search()"><option value="" translate="event.overview.search.location.defaultOption">All Locations</option></select></td><td><!-- column #5--></td><td><!-- column #6--></td><td><!-- column #7--></td><td><!-- column #8--></td><td><!-- column #9--></td><td><!-- column #10--><nz-toggle tri-toggle on-toggle="search()" ng-model="EventSearchOverview.exclusiveGroup" val-true="true" val-false="false" class="square"></nz-toggle></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isEventSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="event in eventList" ng-class="{\r\n\'success\':event.workdaysRemaining >= 14,\r\n\'warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14,\r\n\'danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}"><td id="event.startDateId{{$index}}"><span ng-hide="event.startDate == null">{{event.startDate | date:\'mediumDate\'}}</span></td><td class="hidden-xs" ng-class="{\'text-success\': event.workdaysRemaining >= 14, \'text-warning\':event.workdaysRemaining >= 7 && event.workdaysRemaining < 14, \'text-danger\':event.workdaysRemaining > 0 && event.workdaysRemaining < 7}" id="event.workdaysRemainingId{{$index}}"><strong>{{event.workdaysRemaining}}</strong></td><td id="event.nameId{{$index}}"><strong>{{event.name}}</strong></td><td><a ui-sref="templateevent.detail({templateEventId:event.templateEvent.id})"><span>{{event.templateEvent.name}}</span></a></td><td><a ui-sref="location.detail({locationId:event.location.id})"><span>{{event.location.name}}</span></a></td><td id="event.targetId{{$index}}">{{event.target}}</td><td id="event.totalConfirmedId{{$index}}">{{event.totalConfirmed}}</td><td id="event.totalReservedId{{$index}}">{{event.totalReserved}}</td><td id="event.availableSpotsId{{$index}}">{{event.availableSpots}}</td><td ng-class="{\'available-instructor-mismatch\': event.instructorsNeeded > event.instructorsAvailable}" id="event.instructorsAvailableId{{$index}}">{{event.instructorsAvailable}}</td><td id="event.exclusiveId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(event.exclusive)"><span ng-show="event.exclusive" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!event.exclusive" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="customDetailEvent{{$index}}" type="submit" ui-sref="event.detail.subscriptions({eventId:event.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Event{{$index}}" type="submit" ng-click="goToEditState(event)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEvent{{$index}}" type="submit" ng-click="singleDelete(event.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="EventSearchOverview.page" ng-change="search()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></select></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/event/overview-of-one-to-many-events.html','<div><h2 ng-show="{{!readOnly}}">Events</h2><jhi-alert></jhi-alert><div class="container" ng-show="{{!readOnly}}"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="event.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new Event</span></button></div></div></div><div class="modal fade" id="deleteEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(event.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><p>Are you sure you want to delete this Event?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form></div></div></div><div class="table-responsive voffset3"><table class="table table-condensed table-striped table-bordered"><thead><tr><th nowrap="nowrap" ng-show="false">Created on</th><th nowrap="nowrap">startDate</th><th nowrap="nowrap">name</th><th nowrap="nowrap" ng-hide="parentObject == \'TemplateEvent\'">templateEvent</th><th nowrap="nowrap" ng-hide="parentObject == \'Location\'">location</th><th nowrap="nowrap">target</th><th nowrap="nowrap">totalConfirmed</th><th nowrap="nowrap">totalReserved</th><th nowrap="nowrap">availableSpots</th><th nowrap="nowrap">status</th><th ng-show="{{!readOnly}}"></th></tr></thead><tbody><tr ng-repeat="event in events"><td nowrap="nowrap" ng-show="false"><a ui-sref="event.detail({id:event.id})"><span ng-show="event.createdOn != null">{{event.createdOn * 1000 | date:\'yyyy-MM-dd HH:mm:ss Z\'}}</span> <span ng-show="event.createdOn == null">-</span></a></td><td>{{event.startDate | date:\'mediumDate\'}}</td><td>{{event.name}}</td><td ng-hide="parentObject == \'TemplateEvent\'">{{event.templateEvent.name}}</td><td ng-hide="parentObject == \'Location\'">{{event.location.name}}</td><td>{{event.target}}</td><td>{{event.totalConfirmed}}</td><td>{{event.totalReserved}}</td><td>{{event.availableSpots}}</td><td ng-hide="parentObject == \'EventStatus\'">{{event.status}}</td><td nowrap="nowrap" class="text-right" ng-show="{{!readOnly}}"><button type="submit" ui-sref="event.detail({id:event.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span> View</span></button> <button type="submit" ui-sref="event.edit({id:event.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span> Edit</span></button> <button type="submit" ng-click="delete(event.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span> Delete</span></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/eventtype/eventtype-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="EventTypeDetailTitle" translate="eventType.detail.title">EventType</span> {{eventType.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="eventType.detail.creator.label">Creator:</span>&nbsp; <span>{{eventType.creator}} {{eventType.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="eventType.updater">,&nbsp; <span translate="eventType.detail.updater.label">Updater: </span>&nbsp; <span>{{eventType.updater}} {{eventType.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="eventtype.detail.edit({eventTypeId:eventType.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(eventType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="eventType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="eventType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this EventType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="eventType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="eventType.detail.name.label">name</span></td><td><span class="form-control-static">{{eventType.name}}</span></td></tr><tr><td><span translate="eventType.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{eventType.description}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.eventTypeActiveTab"><uib-tab id="tab-templateevents-overview-mapped-by-eventType" heading="{{\'eventType.detail.tab.templateEvent.by.eventType\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><templateevents-overview-mapped-by-eventtype read-only="true" mapped-by-id="eventTypeId" mapped-by="\'eventType\'" mapped-by-type="\'eventtype\'"></templateevents-overview-mapped-by-eventtype></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/eventtype/eventtype-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="EventTypeDialogTitleCreate" translate="eventType.dialog.title.create">Create a EventType</h4><h4 class="modal-title" ng-show="isEdit()" id="EventTypeDialogTitleEdit" translate="eventType.dialog.title.edit" translate-value-id="{{eventType.id}}">Edit a EventType</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="eventType.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="eventType.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="eventType.name" required ng-maxlength="50" placeholder="{{\'eventType.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="eventType.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="eventType.description" required ng-maxlength="-1" placeholder="{{\'eventType.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventType.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="eventType.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/eventtype/eventtype-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createEventTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="eventType.overview.button.new">Create a new EventType</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventTypeConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="eventType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="eventType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this EventType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEventType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="eventType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="eventType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="eventType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="eventType in eventTypeList"><td id="eventType.nameId{{$index}}">{{eventType.name}}</td><td id="eventType.descriptionId{{$index}}">{{eventType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_EventType{{$index}}" type="submit" ui-sref="eventtype.detail({eventTypeId:eventType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_EventType{{$index}}" type="submit" ng-click="goToEditState(eventType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEventType{{$index}}" type="submit" ng-click="singleDelete(eventType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/eventtype/eventtypes.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="eventType.overview.title">EventTypes</h3></div><div class="panel-buttons"><button id="createEventTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="eventType.overview.button.new">Create a new EventType</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="eventType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="eventType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this EventType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEventType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="eventType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="eventType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="eventType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="eventType in eventTypeList"><td id="eventType.nameId{{$index}}">{{eventType.name}}</td><td id="eventType.descriptionId{{$index}}">{{eventType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_EventType{{$index}}" type="submit" ui-sref="eventtype.detail({eventTypeId:eventType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_EventType{{$index}}" type="submit" ng-click="goToEditState(eventType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEventType{{$index}}" type="submit" ng-click="singleDelete(eventType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/location/location-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="LocationDetailTitle" translate="location.detail.title">Location</span> {{location.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="location.detail.creator.label">Creator:</span>&nbsp; <span>{{location.creator}} {{location.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="location.updater">,&nbsp; <span translate="location.detail.updater.label">Updater: </span>&nbsp; <span>{{location.updater}} {{location.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="location.detail.edit({locationId:location.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteLocationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(location.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="location.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="location.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Location?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="location.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="location.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="location.detail.name.label">name</span></td><td><span class="form-control-static">{{location.name}}</span></td></tr><tr><td><span translate="location.detail.description.label">description</span></td><td><span class="form-control-static">{{location.description}}</span></td></tr><tr><td><span translate="location.detail.rentalCost.label">rentalCost</span></td><td><span class="form-control-static">{{location.rentalCost | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="location.detail.deliveryContactPerson.label">deliveryContactPerson</span></td><td><span class="form-control-static">{{location.deliveryContactPerson}}</span></td></tr><tr><td><span translate="location.detail.deliveryAddressStreet.label">deliveryAddressStreet</span></td><td><span class="form-control-static">{{location.deliveryAddressStreet}}</span></td></tr><tr><td><span translate="location.detail.deliveryAddressZip.label">deliveryAddressZip</span></td><td><span class="form-control-static">{{location.deliveryAddressZip}}</span></td></tr><tr><td><span translate="location.detail.deliveryAddressCity.label">deliveryAddressCity</span></td><td><span class="form-control-static">{{location.deliveryAddressCity}}</span></td></tr><tr><td><span translate="location.detail.deliveryAddressCountry.label">deliveryAddressCountry</span></td><td><a ui-sref="country.detail({countryId:location.deliveryAddressCountry.id})"><span>{{location.deliveryAddressCountry.name}}</span></a></td></tr></tbody></table></div><div><uib-tabset active="$root.locationActiveTab"><uib-tab id="tab-events-overview-mapped-by-location" heading="{{\'location.detail.tab.event.by.location\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><events-overview-mapped-by-location read-only="true" mapped-by-id="locationId" mapped-by="\'location\'" mapped-by-type="\'location\'"></events-overview-mapped-by-location></uib-tab><uib-tab id="tab-documents-overview-mapped-by-location" heading="{{\'location.detail.tab.document.by.location\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-location read-only="true" mapped-by-id="locationId" mapped-by="\'location\'" mapped-by-type="\'location\'"></documents-overview-mapped-by-location></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/location/location-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="LocationDialogTitleCreate" translate="location.dialog.title.create">Create a Location</h4><h4 class="modal-title" ng-show="isEdit()" id="LocationDialogTitleEdit" translate="location.dialog.title.edit" translate-value-id="{{location.id}}">Edit a Location</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="location.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="location.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="location.name" required ng-maxlength="-1" placeholder="{{\'location.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="location.dialog.description.label">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="location.description" ng-maxlength="-1" placeholder="{{\'location.dialog.description.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.rentalCost.$invalid, \'has-success\' : editForm.rentalCost.$valid && editForm.rentalCost.$dirty }"><label for="field_rentalCost" id="label_rentalCost" class="col-sm-2 control-label" translate="location.dialog.rentalCost.label">RentalCost</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="rentalCost" id="field_rentalCost" ng-model="location.rentalCost" ng-currency currency-symbol="\u20AC" 2 fraction="2" min="0" placeholder="{{\'location.dialog.rentalCost.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.rentalCost.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.rentalCost.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.deliveryContactPerson.$invalid, \'has-success\' : editForm.deliveryContactPerson.$valid && editForm.deliveryContactPerson.$dirty }"><label for="field_deliveryContactPerson" id="label_deliveryContactPerson" class="col-sm-2 control-label" translate="location.dialog.deliveryContactPerson.label">DeliveryContactPerson</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="deliveryContactPerson" id="field_deliveryContactPerson" ng-model="location.deliveryContactPerson" ng-maxlength="-1" placeholder="{{\'location.dialog.deliveryContactPerson.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.deliveryContactPerson.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.deliveryContactPerson.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.deliveryAddressStreet.$invalid, \'has-success\' : editForm.deliveryAddressStreet.$valid && editForm.deliveryAddressStreet.$dirty }"><label for="field_deliveryAddressStreet" id="label_deliveryAddressStreet" class="col-sm-2 control-label" translate="location.dialog.deliveryAddressStreet.label">DeliveryAddressStreet</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="deliveryAddressStreet" id="field_deliveryAddressStreet" ng-model="location.deliveryAddressStreet" ng-maxlength="-1" placeholder="{{\'location.dialog.deliveryAddressStreet.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.deliveryAddressStreet.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.deliveryAddressStreet.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.deliveryAddressZip.$invalid, \'has-success\' : editForm.deliveryAddressZip.$valid && editForm.deliveryAddressZip.$dirty }"><label for="field_deliveryAddressZip" id="label_deliveryAddressZip" class="col-sm-2 control-label" translate="location.dialog.deliveryAddressZip.label">DeliveryAddressZip</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="deliveryAddressZip" id="field_deliveryAddressZip" ng-model="location.deliveryAddressZip" ng-maxlength="-1" placeholder="{{\'location.dialog.deliveryAddressZip.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.deliveryAddressZip.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.deliveryAddressZip.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.deliveryAddressCity.$invalid, \'has-success\' : editForm.deliveryAddressCity.$valid && editForm.deliveryAddressCity.$dirty }"><label for="field_deliveryAddressCity" id="label_deliveryAddressCity" class="col-sm-2 control-label" translate="location.dialog.deliveryAddressCity.label">DeliveryAddressCity</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="deliveryAddressCity" id="field_deliveryAddressCity" ng-model="location.deliveryAddressCity" ng-maxlength="-1" placeholder="{{\'location.dialog.deliveryAddressCity.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.deliveryAddressCity.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.deliveryAddressCity.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.deliveryAddressCountry.$invalid, \'has-success\' : editForm.deliveryAddressCountry.$valid && editForm.deliveryAddressCountry.$dirty }"><label for="field_deliveryAddressCountry" class="col-sm-2 control-label" translate="location.dialog.deliveryAddressCountry.label">deliveryAddressCountry</label><div class="col-sm-9"><select ng-disabled="\'deliveryAddressCountry\' == mappedBy" class="form-control input-sm" id="field_deliveryAddressCountry" name="deliveryAddressCountry" ng-model="location.deliveryAddressCountry" ng-options="deliveryAddressCountry as deliveryAddressCountry.name for deliveryAddressCountry in deliveryAddressCountryList track by deliveryAddressCountry.id"><option value=""></option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="location.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="location.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/location/location-edit-user.html','<!--// Created by html/angular/entity/dto-edit.ftl--><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="!isEdit()" id="LocationDialogTitleCreate" translate="location.dialog.title.create">Create a Location</h3><h3 class="voffset" ng-show="isEdit()" id="LocationDialogTitleEdit" translate="location.dialog.title.edit" translate-value-id="{{location.id}}">Edit a Location</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.name.label" for="field_name">Name</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="location.name" required autofocus placeholder="{{\'location.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.description.label" for="field_description">Description</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="location.description" placeholder="{{\'location.dialog.description.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.rentalCost.label" for="field_rentalCost">RentalCost</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" step="0.1" class="form-control input-sm" name="rentalCost" id="field_rentalCost" ng-model="location.rentalCost" placeholder="{{\'location.dialog.rentalCost.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.rentalCost.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.deliveryContactPerson.label" for="field_deliveryContactPerson">DeliveryContactPerson</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="deliveryContactPerson" id="field_deliveryContactPerson" ng-model="location.deliveryContactPerson" placeholder="{{\'location.dialog.deliveryContactPerson.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.deliveryAddressStreet.label" for="field_deliveryAddressStreet">DeliveryAddressStreet</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="deliveryAddressStreet" id="field_deliveryAddressStreet" ng-model="location.deliveryAddressStreet" placeholder="{{\'location.dialog.deliveryAddressStreet.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.deliveryAddressZip.label" for="field_deliveryAddressZip">DeliveryAddressZip</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="deliveryAddressZip" id="field_deliveryAddressZip" ng-model="location.deliveryAddressZip" placeholder="{{\'location.dialog.deliveryAddressZip.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.deliveryAddressCity.label" for="field_deliveryAddressCity">DeliveryAddressCity</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="deliveryAddressCity" id="field_deliveryAddressCity" ng-model="location.deliveryAddressCity" placeholder="{{\'location.dialog.deliveryAddressCity.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.deliveryAddressCountry.label" for="field_deliveryAddressCountry">DeliveryAddressCountry</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><select ng-disabled="\'deliveryAddressCountry\' == mappedBy" class="form-control input-sm" id="field_deliveryAddressCountry" name="deliveryAddressCountry" ng-model="location.selectedDeliveryAddressCountry" ng-options="deliveryAddressCountry as deliveryAddressCountry.displayValue for deliveryAddressCountry in location.deliveryAddressCountryList track by deliveryAddressCountry.id"><option value=""></option></select></div><!-- close column--></div><div class="row voffset2"><!--row #9--></div><div class="row voffset2"><!--row #10--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="location.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="location.dialog.update.button">Save</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/location/location-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createLocationButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="location.overview.button.new">Create a new Location</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="location.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'location.overview.search.name.placeholder\' | translate}}" name="name" ng-model="LocationSearchTab.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="location.overview.search.description.label">description</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'location.overview.search.description.placeholder\' | translate}}" name="description" ng-model="LocationSearchTab.description" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="location.overview.search.deliveryContactPerson.label">deliveryContactPerson</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'location.overview.search.deliveryContactPerson.placeholder\' | translate}}" name="deliveryContactPerson" ng-model="LocationSearchTab.deliveryContactPerson" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="location.overview.search.deliveryAddressStreet.label">deliveryAddressStreet</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'location.overview.search.deliveryAddressStreet.placeholder\' | translate}}" name="deliveryAddressStreet" ng-model="LocationSearchTab.deliveryAddressStreet" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="location.overview.search.deliveryAddressZip.label">deliveryAddressZip</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'location.overview.search.deliveryAddressZip.placeholder\' | translate}}" name="deliveryAddressZip" ng-model="LocationSearchTab.deliveryAddressZip" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="location.overview.search.deliveryAddressCity.label">deliveryAddressCity</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'location.overview.search.deliveryAddressCity.placeholder\' | translate}}" name="deliveryAddressCity" ng-model="LocationSearchTab.deliveryAddressCity" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm" ng-hide="mappedBy == \'deliveryAddressCountry\'"><label class="col-md-2 col-md-offset-2 control-label" translate="location.overview.search.deliveryAddressCountry.label">deliveryAddressCountry</label><div class="col-md-6"><select id="deliveryAddressCountry_select" class="form-control input-sm" ng-options="deliveryAddressCountry as deliveryAddressCountry.name for deliveryAddressCountry in deliveryAddressCountryReferenceFilterList track by deliveryAddressCountry.id" ng-model="LocationSearchTab.deliveryAddressCountry" tabindex="0" ng-change="search()"><option value="" translate="location.overview.search.deliveryAddressCountry.defaultOption">All Countries</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="location.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isLocationSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="location.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteLocationConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="location.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="location.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Location</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="location.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteLocation" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="location.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="location.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="location.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="location.overview.results.header.rentalCost.label">rentalCost</span></th><th jh-sort-by="deliveryContactPerson" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryContactPerson.label">deliveryContactPerson</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryContactPerson\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="deliveryAddressStreet" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryAddressStreet.label">deliveryAddressStreet</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryAddressStreet\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="deliveryAddressZip" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryAddressZip.label">deliveryAddressZip</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryAddressZip\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="deliveryAddressCity" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryAddressCity.label">deliveryAddressCity</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryAddressCity\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'deliveryAddressCountry\'" jh-sort-by="deliveryAddressCountry.name" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryAddressCountry.label">deliveryAddressCountry</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryAddressCountry.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="location in locationList"><td id="location.nameId{{$index}}">{{location.name}}</td><td id="location.descriptionId{{$index}}">{{location.description}}</td><td id="location.rentalCostId{{$index}}">{{location.rentalCost | currency:"\u20AC":2}}</td><td id="location.deliveryContactPersonId{{$index}}">{{location.deliveryContactPerson}}</td><td id="location.deliveryAddressStreetId{{$index}}">{{location.deliveryAddressStreet}}</td><td id="location.deliveryAddressZipId{{$index}}">{{location.deliveryAddressZip}}</td><td id="location.deliveryAddressCityId{{$index}}">{{location.deliveryAddressCity}}</td><td ng-hide="mappedBy == \'deliveryAddressCountry\'"><a ui-sref="country.detail({countryId:location.deliveryAddressCountry.id})"><span>{{location.deliveryAddressCountry.name}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Location{{$index}}" type="submit" ui-sref="location.detail({locationId:location.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Location{{$index}}" type="submit" ng-click="goToEditState(location)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteLocation{{$index}}" type="submit" ng-click="singleDelete(location.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/location/location-user.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="LocationDialogTitleCreate" translate="location.dialog.title.create">Create a Location</h4><h4 class="modal-title" ng-show="isEdit()" id="LocationDialogTitleEdit" translate="location.dialog.title.edit" translate-value-id="{{location.id}}">Edit a Location</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="row"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.name.label" for="field_name">Name</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="location.name" required autofocus placeholder="{{\'location.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.description.label" for="field_description">Description</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="location.description" placeholder="{{\'location.dialog.description.placeholder\'|translate}}"></div><!-- close column--></div><div class="row"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.rentalCost.label" for="field_rentalCost">RentalCost</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" step="0.1" class="form-control input-sm" name="rentalCost" id="field_rentalCost" ng-model="location.rentalCost" placeholder="{{\'location.dialog.rentalCost.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.rentalCost.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div><!-- close column--></div><div class="row"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.event.label" for="field_event">Event</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><ui-select multiple="multiple" ng-model="location.selectedEventList" id="field_event" ng-disabled="disabled" title="Choose a event"><ui-select-match placeholder="{{ \'location.dialog.event.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="event in location.eventList | propsFilter: {displayValue: $select.search}"><small>{{event.displayValue}}</small></ui-select-choices></ui-select></div><!-- close column--></div><div class="row"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="location.dialog.document.label" for="field_document">Document</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><ui-select multiple="multiple" ng-model="location.selectedDocumentList" id="field_document" ng-disabled="disabled" title="Choose a document"><ui-select-match placeholder="{{ \'location.dialog.document.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="document in location.documentList | propsFilter: {displayValue: $select.search}"><small>{{document.displayValue}}</small></ui-select-choices></ui-select></div><!-- close column--></div><!-- END row in rows --></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span> &nbsp; <span translate="location.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> &nbsp; <span translate="location.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/location/locations.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="location.overview.title">Locations</h3></div><div class="panel-buttons"><button id="createLocationButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="location.overview.button.new">Create a new Location</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteLocationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="location.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="location.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Location</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="location.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteLocation" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="location.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="location.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="location.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="location.overview.results.header.rentalCost.label">rentalCost</span></th><th jh-sort-by="deliveryContactPerson" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryContactPerson.label">deliveryContactPerson</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryContactPerson\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="deliveryAddressStreet" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryAddressStreet.label">deliveryAddressStreet</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryAddressStreet\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="deliveryAddressZip" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryAddressZip.label">deliveryAddressZip</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryAddressZip\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="deliveryAddressCity" class="sortable"><span class="pull-left" translate="location.overview.results.header.deliveryAddressCity.label">deliveryAddressCity</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'deliveryAddressCity\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="location in locationList"><td id="location.nameId{{$index}}">{{location.name}}</td><td id="location.descriptionId{{$index}}">{{location.description}}</td><td id="location.rentalCostId{{$index}}">{{location.rentalCost | currency:"\u20AC":2}}</td><td id="location.deliveryContactPersonId{{$index}}">{{location.deliveryContactPerson}}</td><td id="location.deliveryAddressStreetId{{$index}}">{{location.deliveryAddressStreet}}</td><td id="location.deliveryAddressZipId{{$index}}">{{location.deliveryAddressZip}}</td><td id="location.deliveryAddressCityId{{$index}}">{{location.deliveryAddressCity}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Location{{$index}}" type="submit" ui-sref="location.detail({locationId:location.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Location{{$index}}" type="submit" ng-click="goToEditState(location)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteLocation{{$index}}" type="submit" ng-click="singleDelete(location.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/instructor/instructor-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="InstructorDetailTitle" translate="instructor.detail.title">Instructor</span> {{instructor.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="instructor.detail.creator.label">Creator:</span>&nbsp; <span>{{instructor.creator}} {{instructor.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="instructor.updater">,&nbsp; <span translate="instructor.detail.updater.label">Updater: </span>&nbsp; <span>{{instructor.updater}} {{instructor.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="instructor.detail.edit({instructorId:instructor.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteInstructorConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(instructor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="instructor.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="instructor.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Instructor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="instructor.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="instructor.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="instructor.detail.description.label">description</span></td><td><span class="form-control-static">{{instructor.description}}</span></td></tr><tr><td><span translate="instructor.detail.relation.label">relation</span></td><td><a ui-sref="user-relation.detail({relationId:instructor.relation.id})"><span>{{$root.displayFields([instructor.relation.externalId, instructor.relation.firstName, instructor.relation.lastName, instructor.relation.companyName])}}</span></a></td></tr><tr><td><span translate="instructor.detail.event.label">event</span></td><td><a ui-sref="event.detail.subscriptions({eventId:instructor.event.id})"><span>{{instructor.event.name}}</span></a></td></tr><tr><td><span translate="instructor.detail.hotel.label">hotel</span></td><td><a ui-sref="article.detail({articleId:instructor.hotel.id})"><span>{{$root.displayFields([instructor.hotel.name, instructor.hotel.price])}}</span></a></td></tr><tr><td><span translate="instructor.detail.status.label">status</span></td><td><span class="form-control-static">{{instructor.status === null ? "" : \'SubscriptionStatus.\' + instructor.status | translate}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.instructorActiveTab"><uib-tab id="tab-subscriptions-overview-mapped-by-instructor" heading="{{\'instructor.detail.tab.subscription.by.instructor\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><subscriptions-overview-mapped-by-instructor read-only="true" mapped-by-id="instructorId" mapped-by="\'instructor\'" mapped-by-type="\'instructor\'"></subscriptions-overview-mapped-by-instructor></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/instructor/instructor-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="InstructorDialogTitleCreate" translate="instructor.dialog.title.create">Create a Instructor</h4><h4 class="modal-title" ng-show="isEdit()" id="InstructorDialogTitleEdit" translate="instructor.dialog.title.edit" translate-value-id="{{instructor.id}}">Edit a Instructor</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="instructor.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="instructor.dialog.description.label">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="instructor.description" ng-maxlength="-1" placeholder="{{\'instructor.dialog.description.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relation.$invalid, \'has-success\' : editForm.relation.$valid && editForm.relation.$dirty }"><label for="field_relation" class="col-sm-2 control-label" translate="instructor.dialog.relation.label">relation</label><div class="col-sm-9"><input ng-disabled="\'relation\' == mappedBy" type="text" id="field_relation" name="relation" ng-model="instructor.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsForRelation" placeholder="{{\'instructor.dialog.relation.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.relation.$invalid"><p class="help-block" ng-show="editForm.relation.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new relation" ng-disabled="\'relation\' == mappedBy" ng-click="createRelation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.event.$invalid, \'has-success\' : editForm.event.$valid && editForm.event.$dirty }"><label for="field_event" class="col-sm-2 control-label" translate="instructor.dialog.event.label">event</label><div class="col-sm-9"><input ng-disabled="\'event\' == mappedBy" type="text" id="field_event" name="event" ng-model="instructor.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsForEvent" placeholder="{{\'instructor.dialog.event.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.event.$invalid"><p class="help-block" ng-show="editForm.event.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.hotel.$invalid, \'has-success\' : editForm.hotel.$valid && editForm.hotel.$dirty }"><label for="field_hotel" class="col-sm-2 control-label" translate="instructor.dialog.hotel.label">hotel</label><div class="col-sm-9"><select ng-disabled="\'hotel\' == mappedBy" class="form-control input-sm" id="field_hotel" name="hotel" ng-model="instructor.hotel" ng-options="hotel as $root.displayFields([hotel.name, hotel.price]) for hotel in hotelList track by hotel.id"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.status.$invalid, \'has-success\' : editForm.status.$valid && editForm.status.$dirty }"><label for="field_status" class="col-sm-2 control-label" translate="instructor.dialog.status.label">status</label><div class="col-sm-9"><select ng-disabled="\'status\' == mappedBy" class="form-control input-sm" id="field_status" name="status" ng-model="instructor.status" required ng-options="\'SubscriptionStatus.\' + status | translate for status in statusList"><option value=""></option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="instructor.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="instructor.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/instructor/instructor-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createInstructorButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="instructor.overview.button.new">Create a new Instructor</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteInstructorConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="instructor.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="instructor.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Instructor</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="instructor.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteInstructor" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="instructor.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'relation\'" jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'event\'" jh-sort-by="event.name" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'hotel\'" jh-sort-by="hotel.name" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.hotel.label">hotel</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'hotel.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="status" class="sortable"><span translate="instructor.overview.results.header.status.label">status</span> <span class="glyphicon {{getSortIcon(\'status\')}}"></span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="instructor in instructorList"><td id="instructor.descriptionId{{$index}}">{{instructor.description}}</td><td ng-hide="mappedBy == \'relation\'"><a ui-sref="user-relation.detail({relationId:instructor.relation.id})"><span>{{$root.displayFields([instructor.relation.externalId, instructor.relation.firstName, instructor.relation.lastName, instructor.relation.companyName])}}</span></a></td><td ng-hide="mappedBy == \'event\'"><a ui-sref="event.detail.subscriptions({eventId:instructor.event.id})"><span>{{instructor.event.name}}</span></a></td><td ng-hide="mappedBy == \'hotel\'"><a ui-sref="article.detail({articleId:instructor.hotel.id})"><span>{{$root.displayFields([instructor.hotel.name, instructor.hotel.price])}}</span></a></td><td>{{instructor.status === null ? "" : \'SubscriptionStatus.\' + instructor.status | translate}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Instructor{{$index}}" type="submit" ui-sref="instructor.detail({instructorId:instructor.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Instructor{{$index}}" type="submit" ng-click="goToEditState(instructor)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteInstructor{{$index}}" type="submit" ng-click="singleDelete(instructor.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/instructor/instructors.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="instructor.overview.title">Instructors</h3></div><div class="panel-buttons"><button id="createInstructorButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="instructor.overview.button.new">Create a new Instructor</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="instructor.overview.search.description.label">description</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'instructor.overview.search.description.placeholder\' | translate}}" name="description" ng-model="InstructorSearchOverview.description" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="instructor.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="InstructorSearchOverview.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'instructor.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="instructor.overview.search.event.label">event</label><div class="col-md-6"><input type="text" id="field_event" name="event" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="InstructorSearchOverview.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsEvent" placeholder="{{\'instructor.overview.search.event.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="instructor.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isInstructorSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="instructor.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteInstructorConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="instructor.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="instructor.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Instructor</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="instructor.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteInstructor" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="instructor.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="InstructorSearchOverview.predicate" ascending="InstructorSearchOverview.ascending" callback="search()"><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="event.name" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="hotel.name" class="sortable"><span class="pull-left" translate="instructor.overview.results.header.hotel.label">hotel</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'hotel.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="status" class="sortable"><span translate="instructor.overview.results.header.status.label">status</span> <span class="glyphicon {{getSortIcon(\'status\')}}"></span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="instructor in instructorList"><td id="instructor.descriptionId{{$index}}">{{instructor.description}}</td><td><a ui-sref="user-relation.detail({relationId:instructor.relation.id})"><span>{{$root.displayFields([instructor.relation.externalId, instructor.relation.firstName, instructor.relation.lastName, instructor.relation.companyName])}}</span></a></td><td><a ui-sref="event.detail.subscriptions({eventId:instructor.event.id})"><span>{{instructor.event.name}}</span></a></td><td><a ui-sref="article.detail({articleId:instructor.hotel.id})"><span>{{$root.displayFields([instructor.hotel.name, instructor.hotel.price])}}</span></a></td><td>{{instructor.status === null ? "" : \'SubscriptionStatus.\' + instructor.status | translate}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Instructor{{$index}}" type="submit" ui-sref="instructor.detail({instructorId:instructor.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Instructor{{$index}}" type="submit" ng-click="goToEditState(instructor)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteInstructor{{$index}}" type="submit" ng-click="singleDelete(instructor.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="InstructorSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/eventrelationcontact/eventrelationcontact-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="EventRelationContactDetailTitle" translate="eventRelationContact.detail.title">EventRelationContact</span> {{eventRelationContact.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="eventRelationContact.detail.creator.label">Creator:</span>&nbsp; <span>{{eventRelationContact.creator}} {{eventRelationContact.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="eventRelationContact.updater">,&nbsp; <span translate="eventRelationContact.detail.updater.label">Updater: </span>&nbsp; <span>{{eventRelationContact.updater}} {{eventRelationContact.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="eventrelationcontact.detail.edit({eventRelationContactId:eventRelationContact.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventRelationContactConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(eventRelationContact.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="eventRelationContact.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="eventRelationContact.overview.results.buttons.delete.confirmation">Are you sure you want to delete this EventRelationContact?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventRelationContact.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="eventRelationContact.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="eventRelationContact.detail.event.label">event</span></td><td><a ui-sref="event.detail.subscriptions({eventId:eventRelationContact.event.id})"><span>{{eventRelationContact.event.name}}</span></a></td></tr><tr><td><span translate="eventRelationContact.detail.relation.label">relation</span></td><td><a ui-sref="user-relation.detail({relationId:eventRelationContact.relation.id})"><span>{{$root.displayFields([eventRelationContact.relation.externalId, eventRelationContact.relation.firstName, eventRelationContact.relation.lastName, eventRelationContact.relation.companyName])}}</span></a></td></tr><tr><td><span translate="eventRelationContact.detail.salesStatus.label">salesStatus</span></td><td><span class="form-control-static">{{eventRelationContact.salesStatus === null ? "" : \'SalesStatus.\' + eventRelationContact.salesStatus | translate}}</span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/eventrelationcontact/eventrelationcontact-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="EventRelationContactDialogTitleCreate" translate="eventRelationContact.dialog.title.create">Create a EventRelationContact</h4><h4 class="modal-title" ng-show="isEdit()" id="EventRelationContactDialogTitleEdit" translate="eventRelationContact.dialog.title.edit" translate-value-id="{{eventRelationContact.id}}">Edit a EventRelationContact</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="eventRelationContact.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.event.$invalid, \'has-success\' : editForm.event.$valid && editForm.event.$dirty }"><label for="field_event" class="col-sm-2 control-label" translate="eventRelationContact.dialog.event.label">event</label><div class="col-sm-9"><input ng-disabled="\'event\' == mappedBy" type="text" id="field_event" name="event" ng-model="eventRelationContact.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsForEvent" placeholder="{{\'eventRelationContact.dialog.event.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.event.$invalid"><p class="help-block" ng-show="editForm.event.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relation.$invalid, \'has-success\' : editForm.relation.$valid && editForm.relation.$dirty }"><label for="field_relation" class="col-sm-2 control-label" translate="eventRelationContact.dialog.relation.label">relation</label><div class="col-sm-9"><input ng-disabled="\'relation\' == mappedBy" type="text" id="field_relation" name="relation" ng-model="eventRelationContact.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsForRelation" placeholder="{{\'eventRelationContact.dialog.relation.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.relation.$invalid"><p class="help-block" ng-show="editForm.relation.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.salesStatus.$invalid, \'has-success\' : editForm.salesStatus.$valid && editForm.salesStatus.$dirty }"><label for="field_salesStatus" class="col-sm-2 control-label" translate="eventRelationContact.dialog.salesStatus.label">salesStatus</label><div class="col-sm-9"><select ng-disabled="\'salesStatus\' == mappedBy" class="form-control input-sm" id="field_salesStatus" name="salesStatus" ng-model="eventRelationContact.salesStatus" required ng-options="\'SalesStatus.\' + salesStatus | translate for salesStatus in salesStatusList"><option value=""></option></select><div ng-show="editForm.salesStatus.$invalid"><p class="help-block" ng-show="editForm.salesStatus.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventRelationContact.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="eventRelationContact.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/eventrelationcontact/eventrelationcontact-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="eventRelationContact.overview.title">EventRelationContacts</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="eventRelationContact.overview.search.event.label">event</label><div class="col-md-6"><input type="text" id="field_event" name="event" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="EventRelationContactSearchOverview.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsEvent" placeholder="{{\'eventRelationContact.overview.search.event.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="eventRelationContact.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="EventRelationContactSearchOverview.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'eventRelationContact.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="eventRelationContact.overview.search.salesStatus.label">salesStatus</label><div class="col-md-6"><select id="salesStatus_select" class="form-control input-sm" ng-model="EventRelationContactSearchOverview.salesStatus" tabindex="0" ng-change="search()" ng-options="\'SalesStatus.\' + salesStatus | translate for salesStatus in salesStatusList"><option value="" translate="eventRelationContact.overview.search.salesStatus.defaultOption">All SalesStatuses</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="eventRelationContact.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isEventRelationContactSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="eventRelationContact.overview.search.reset.button">Reset</span></button></div></div></form><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="EventRelationContactSearchOverview.predicate" ascending="EventRelationContactSearchOverview.ascending" callback="search()"><th jh-sort-by="event.name" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="salesStatus" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.salesStatus.label">salesStatus</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesStatus\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="relation.externalId" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="eventRelationContact in eventRelationContactList"><td class="hidden-xs"><a ui-sref="event.detail.subscriptions({eventId:eventRelationContact.eventPkId})"><span>{{eventRelationContact.eventDisplayValue}}</span></a></td><td class="hidden-xs">{{eventRelationContact.salesStatusDisplayValue === null ? "" : eventRelationContact.salesStatusDisplayValue | translate}}</td><td class="hidden-xs"><a ui-sref="user-relation.detail({relationId:eventRelationContact.relationPkId})"><span>{{eventRelationContact.relationDisplayValue}}</span></a></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="EventRelationContactSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/eventrelationcontact/eventrelationcontact-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'event\'" jh-sort-by="event.name" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="salesStatus" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.salesStatus.label">salesStatus</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesStatus\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'relation\'" jh-sort-by="relation.externalId" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="eventRelationContact in eventRelationContactList"><td class="hidden-xs" ng-hide="mappedBy == \'event\'"><a ui-sref="event.detail.subscriptions({eventId:eventRelationContact.eventPkId})"><span>{{eventRelationContact.eventDisplayValue}}</span></a></td><td class="hidden-xs">{{eventRelationContact.salesStatusDisplayValue === null ? "" : eventRelationContact.salesStatusDisplayValue | translate}}</td><td class="hidden-xs" ng-hide="mappedBy == \'relation\'"><a ui-sref="user-relation.detail({relationId:eventRelationContact.relationPkId})"><span>{{eventRelationContact.relationDisplayValue}}</span></a></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/eventrelationcontact/eventrelationcontact-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createEventRelationContactButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="eventRelationContact.overview.button.new">Create a new EventRelationContact</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteEventRelationContactConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="eventRelationContact.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="eventRelationContact.overview.results.buttons.delete.confirmation">Are you sure you want to delete this EventRelationContact</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventRelationContact.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEventRelationContact" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="eventRelationContact.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'event\'" jh-sort-by="event.name" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'relation\'" jh-sort-by="relation.externalId" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="salesStatus" class="sortable hidden-xs"><span translate="eventRelationContact.overview.results.header.salesStatus.label">salesStatus</span> <span class="glyphicon {{getSortIcon(\'salesStatus\')}}"></span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="eventRelationContact in eventRelationContactList"><td class="hidden-xs" ng-hide="mappedBy == \'event\'"><a ui-sref="event.detail.subscriptions({eventId:eventRelationContact.event.id})"><span>{{eventRelationContact.event.name}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'relation\'"><a ui-sref="user-relation.detail({relationId:eventRelationContact.relation.id})"><span>{{$root.displayFields([eventRelationContact.relation.externalId, eventRelationContact.relation.firstName, eventRelationContact.relation.lastName, eventRelationContact.relation.companyName])}}</span></a></td><td class="hidden-xs">{{eventRelationContact.salesStatus === null ? "" : \'SalesStatus.\' + eventRelationContact.salesStatus | translate}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_EventRelationContact{{$index}}" type="submit" ui-sref="eventrelationcontact.detail({eventRelationContactId:eventRelationContact.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_EventRelationContact{{$index}}" type="submit" ng-click="goToEditState(eventRelationContact)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEventRelationContact{{$index}}" type="submit" ng-click="singleDelete(eventRelationContact.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/eventrelationcontact/eventrelationcontacts.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="eventRelationContact.overview.title">EventRelationContacts</h3></div><div class="panel-buttons"><button id="createEventRelationContactButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="eventRelationContact.overview.button.new">Create a new EventRelationContact</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="eventRelationContact.overview.search.event.label">event</label><div class="col-md-6"><input type="text" id="field_event" name="event" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="EventRelationContactSearchOverview.event" ng-model-options="$root.modelOptions" uib-typeahead="event as event.displayValue for event in autocompleteEvents($viewValue)" typeahead-loading="loadingEvent" typeahead-no-results="noResultsEvent" placeholder="{{\'eventRelationContact.overview.search.event.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingEvent" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsEvent"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="eventRelationContact.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="EventRelationContactSearchOverview.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'eventRelationContact.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="eventRelationContact.overview.search.salesStatus.label">salesStatus</label><div class="col-md-6"><select id="salesStatus_select" class="form-control input-sm" ng-model="EventRelationContactSearchOverview.salesStatus" tabindex="0" ng-change="search()" ng-options="\'SalesStatus.\' + salesStatus | translate for salesStatus in salesStatusList"><option value="" translate="eventRelationContact.overview.search.salesStatus.defaultOption">All SalesStatuses</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="eventRelationContact.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isEventRelationContactSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="eventRelationContact.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteEventRelationContactConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="eventRelationContact.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="eventRelationContact.overview.results.buttons.delete.confirmation">Are you sure you want to delete this EventRelationContact</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="eventRelationContact.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteEventRelationContact" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="eventRelationContact.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="EventRelationContactSearchOverview.predicate" ascending="EventRelationContactSearchOverview.ascending" callback="search()"><th jh-sort-by="event.name" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.event.label">event</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'event.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="relation.externalId" class="sortable hidden-xs"><span class="pull-left" translate="eventRelationContact.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="salesStatus" class="sortable hidden-xs"><span translate="eventRelationContact.overview.results.header.salesStatus.label">salesStatus</span> <span class="glyphicon {{getSortIcon(\'salesStatus\')}}"></span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="eventRelationContact in eventRelationContactList"><td class="hidden-xs"><a ui-sref="event.detail.subscriptions({eventId:eventRelationContact.event.id})"><span>{{eventRelationContact.event.name}}</span></a></td><td class="hidden-xs"><a ui-sref="user-relation.detail({relationId:eventRelationContact.relation.id})"><span>{{$root.displayFields([eventRelationContact.relation.externalId, eventRelationContact.relation.firstName, eventRelationContact.relation.lastName, eventRelationContact.relation.companyName])}}</span></a></td><td class="hidden-xs">{{eventRelationContact.salesStatus === null ? "" : \'SalesStatus.\' + eventRelationContact.salesStatus | translate}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_EventRelationContact{{$index}}" type="submit" ui-sref="eventrelationcontact.detail({eventRelationContactId:eventRelationContact.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_EventRelationContact{{$index}}" type="submit" ng-click="goToEditState(eventRelationContact)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteEventRelationContact{{$index}}" type="submit" ng-click="singleDelete(eventRelationContact.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="EventRelationContactSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/locationtemplateeventarticle/locationtemplateeventarticle-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="LocationTemplateEventArticleDetailTitle" translate="locationTemplateEventArticle.detail.title">LocationTemplateEventArticle</span> {{locationTemplateEventArticle.name}}</h3></div><div class="panel-buttons"><button ui-sref="locationtemplateeventarticle.detail.edit({locationTemplateEventArticleId:locationTemplateEventArticle.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteLocationTemplateEventArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(locationTemplateEventArticle.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="locationTemplateEventArticle.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="locationTemplateEventArticle.overview.results.buttons.delete.confirmation">Are you sure you want to delete this LocationTemplateEventArticle?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="locationTemplateEventArticle.detail.location.label">location</span></td><td><a ui-sref="location.detail({locationId:locationTemplateEventArticle.location.id})"><span>{{locationTemplateEventArticle.location.name}}</span></a></td></tr><tr><td><span translate="locationTemplateEventArticle.detail.templateEvent.label">templateEvent</span></td><td><a ui-sref="templateevent.detail({templateEventId:locationTemplateEventArticle.templateEvent.id})"><span>{{locationTemplateEventArticle.templateEvent.name}}</span></a></td></tr><tr><td><span translate="locationTemplateEventArticle.detail.article.label">article</span></td><td><a ui-sref="article.detail({articleId:locationTemplateEventArticle.article.id})"><span>{{$root.displayFields([locationTemplateEventArticle.article.name, locationTemplateEventArticle.article.price])}}</span></a></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/locationtemplateeventarticle/locationtemplateeventarticle-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="LocationTemplateEventArticleDialogTitleCreate" translate="locationTemplateEventArticle.dialog.title.create">Create a LocationTemplateEventArticle</h4><h4 class="modal-title" ng-show="isEdit()" id="LocationTemplateEventArticleDialogTitleEdit" translate="locationTemplateEventArticle.dialog.title.edit" translate-value-id="{{locationTemplateEventArticle.id}}">Edit a LocationTemplateEventArticle</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="locationTemplateEventArticle.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.location.$invalid, \'has-success\' : editForm.location.$valid && editForm.location.$dirty }"><label for="field_location" class="col-sm-2 control-label" translate="locationTemplateEventArticle.dialog.location.label">location</label><div class="col-sm-9"><select ng-disabled="\'location\' == mappedBy" class="form-control input-sm" id="field_location" name="location" ng-model="locationTemplateEventArticle.location" required ng-options="location as location.name for location in locationList track by location.id"><option value=""></option></select><div ng-show="editForm.location.$invalid"><p class="help-block" ng-show="editForm.location.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.templateEvent.$invalid, \'has-success\' : editForm.templateEvent.$valid && editForm.templateEvent.$dirty }"><label for="field_templateEvent" class="col-sm-2 control-label" translate="locationTemplateEventArticle.dialog.templateEvent.label">templateEvent</label><div class="col-sm-9"><select ng-disabled="\'templateEvent\' == mappedBy" class="form-control input-sm" id="field_templateEvent" name="templateEvent" ng-model="locationTemplateEventArticle.templateEvent" required ng-options="templateEvent as templateEvent.name for templateEvent in templateEventList track by templateEvent.id"><option value=""></option></select><div ng-show="editForm.templateEvent.$invalid"><p class="help-block" ng-show="editForm.templateEvent.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.article.$invalid, \'has-success\' : editForm.article.$valid && editForm.article.$dirty }"><label for="field_article" class="col-sm-2 control-label" translate="locationTemplateEventArticle.dialog.article.label">article</label><div class="col-sm-9"><select ng-disabled="\'article\' == mappedBy" class="form-control input-sm" id="field_article" name="article" ng-model="locationTemplateEventArticle.article" required ng-options="article as $root.displayFields([article.name, article.price]) for article in articleList track by article.id"><option value=""></option></select><div ng-show="editForm.article.$invalid"><p class="help-block" ng-show="editForm.article.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new article" ng-disabled="\'article\' == mappedBy" ng-click="createArticle()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="locationTemplateEventArticle.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="locationTemplateEventArticle.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/locationtemplateeventarticle/locationtemplateeventarticle-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createLocationTemplateEventArticleButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="locationTemplateEventArticle.overview.button.new">Create a new LocationTemplateEventArticle</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteLocationTemplateEventArticleConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="locationTemplateEventArticle.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="locationTemplateEventArticle.overview.results.buttons.delete.confirmation">Are you sure you want to delete this LocationTemplateEventArticle</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteLocationTemplateEventArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'location\'" jh-sort-by="location.name" class="sortable hidden-xs"><span class="pull-left" translate="locationTemplateEventArticle.overview.results.header.location.label">location</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'location.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'templateEvent\'" jh-sort-by="templateEvent.name" class="sortable hidden-xs"><span class="pull-left" translate="locationTemplateEventArticle.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'article\'" jh-sort-by="article.name" class="sortable hidden-xs"><span class="pull-left" translate="locationTemplateEventArticle.overview.results.header.article.label">article</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'article.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="locationTemplateEventArticle in locationTemplateEventArticleList"><td class="hidden-xs" ng-hide="mappedBy == \'location\'"><a ui-sref="location.detail({locationId:locationTemplateEventArticle.location.id})"><span>{{locationTemplateEventArticle.location.name}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'templateEvent\'"><a ui-sref="templateevent.detail({templateEventId:locationTemplateEventArticle.templateEvent.id})"><span>{{locationTemplateEventArticle.templateEvent.name}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'article\'"><a ui-sref="article.detail({articleId:locationTemplateEventArticle.article.id})"><span>{{$root.displayFields([locationTemplateEventArticle.article.name, locationTemplateEventArticle.article.price])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_LocationTemplateEventArticle{{$index}}" type="submit" ui-sref="locationtemplateeventarticle.detail({locationTemplateEventArticleId:locationTemplateEventArticle.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_LocationTemplateEventArticle{{$index}}" type="submit" ng-click="goToEditState(locationTemplateEventArticle)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteLocationTemplateEventArticle{{$index}}" type="submit" ng-click="singleDelete(locationTemplateEventArticle.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/locationtemplateeventarticle/locationtemplateeventarticles.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="locationTemplateEventArticle.overview.title">LocationTemplateEventArticles</h3></div><div class="panel-buttons"><button id="createLocationTemplateEventArticleButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="locationTemplateEventArticle.overview.button.new">Create a new LocationTemplateEventArticle</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="locationTemplateEventArticle.overview.search.location.label">location</label><div class="col-md-6"><select id="location_select" class="form-control input-sm" ng-options="location as location.name for location in locationReferenceFilterList track by location.id" ng-model="LocationTemplateEventArticleSearchOverview.location" tabindex="0" ng-change="search()"><option value="" translate="locationTemplateEventArticle.overview.search.location.defaultOption">All Locations</option></select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="locationTemplateEventArticle.overview.search.templateEvent.label">templateEvent</label><div class="col-md-6"><select id="templateEvent_select" class="form-control input-sm" ng-options="templateEvent as templateEvent.name for templateEvent in templateEventReferenceFilterList track by templateEvent.id" ng-model="LocationTemplateEventArticleSearchOverview.templateEvent" tabindex="0" ng-change="search()"><option value="" translate="locationTemplateEventArticle.overview.search.templateEvent.defaultOption">All TemplateEvents</option></select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="locationTemplateEventArticle.overview.search.article.label">article</label><div class="col-md-6"><select id="article_select" class="form-control input-sm" ng-options="article as $root.displayFields([article.name, article.price]) for article in articleReferenceFilterList track by article.id" ng-model="LocationTemplateEventArticleSearchOverview.article" tabindex="0" ng-change="search()"><option value="" translate="locationTemplateEventArticle.overview.search.article.defaultOption">All Articles</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isLocationTemplateEventArticleSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteLocationTemplateEventArticleConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="locationTemplateEventArticle.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="locationTemplateEventArticle.overview.results.buttons.delete.confirmation">Are you sure you want to delete this LocationTemplateEventArticle</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteLocationTemplateEventArticle" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="locationTemplateEventArticle.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="LocationTemplateEventArticleSearchOverview.predicate" ascending="LocationTemplateEventArticleSearchOverview.ascending" callback="search()"><th jh-sort-by="location.name" class="sortable hidden-xs"><span class="pull-left" translate="locationTemplateEventArticle.overview.results.header.location.label">location</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'location.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="templateEvent.name" class="sortable hidden-xs"><span class="pull-left" translate="locationTemplateEventArticle.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="article.name" class="sortable hidden-xs"><span class="pull-left" translate="locationTemplateEventArticle.overview.results.header.article.label">article</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'article.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="locationTemplateEventArticle in locationTemplateEventArticleList"><td class="hidden-xs"><a ui-sref="location.detail({locationId:locationTemplateEventArticle.location.id})"><span>{{locationTemplateEventArticle.location.name}}</span></a></td><td class="hidden-xs"><a ui-sref="templateevent.detail({templateEventId:locationTemplateEventArticle.templateEvent.id})"><span>{{locationTemplateEventArticle.templateEvent.name}}</span></a></td><td class="hidden-xs"><a ui-sref="article.detail({articleId:locationTemplateEventArticle.article.id})"><span>{{$root.displayFields([locationTemplateEventArticle.article.name, locationTemplateEventArticle.article.price])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_LocationTemplateEventArticle{{$index}}" type="submit" ui-sref="locationtemplateeventarticle.detail({locationTemplateEventArticleId:locationTemplateEventArticle.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_LocationTemplateEventArticle{{$index}}" type="submit" ng-click="goToEditState(locationTemplateEventArticle)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteLocationTemplateEventArticle{{$index}}" type="submit" ng-click="singleDelete(locationTemplateEventArticle.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="LocationTemplateEventArticleSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/mailgroup/mailgroup-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="MailGroupDetailTitle" translate="mailGroup.detail.title">MailGroup</span> {{mailGroup.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="mailGroup.detail.creator.label">Creator:</span>&nbsp; <span>{{mailGroup.creator}} {{mailGroup.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="mailGroup.updater">,&nbsp; <span translate="mailGroup.detail.updater.label">Updater: </span>&nbsp; <span>{{mailGroup.updater}} {{mailGroup.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="mailgroup.detail.edit({mailGroupId:mailGroup.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteMailGroupConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(mailGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="mailGroup.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="mailGroup.overview.results.buttons.delete.confirmation">Are you sure you want to delete this MailGroup?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="mailGroup.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="mailGroup.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="mailGroup.detail.name.label">name</span></td><td><span class="form-control-static">{{mailGroup.name}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.mailGroupActiveTab"><uib-tab id="tab-relationmailgroups-overview-mapped-by-mailGroup" heading="{{\'mailGroup.detail.tab.relationMailGroup.by.mailGroup\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><relationmailgroups-overview-mapped-by-mailgroup read-only="true" mapped-by-id="mailGroupId" mapped-by="\'mailGroup\'" mapped-by-type="\'mailgroup\'"></relationmailgroups-overview-mapped-by-mailgroup></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/mailgroup/mailgroup-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="MailGroupDialogTitleCreate" translate="mailGroup.dialog.title.create">Create a MailGroup</h4><h4 class="modal-title" ng-show="isEdit()" id="MailGroupDialogTitleEdit" translate="mailGroup.dialog.title.edit" translate-value-id="{{mailGroup.id}}">Edit a MailGroup</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="mailGroup.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="mailGroup.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="mailGroup.name" required ng-maxlength="-1" placeholder="{{\'mailGroup.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="mailGroup.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="mailGroup.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/mailgroup/mailgroup-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createMailGroupButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="mailGroup.overview.button.new">Create a new MailGroup</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="mailGroup.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'mailGroup.overview.search.name.placeholder\' | translate}}" name="name" ng-model="MailGroupSearchTab.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="mailGroup.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isMailGroupSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="mailGroup.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteMailGroupConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="mailGroup.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="mailGroup.overview.results.buttons.delete.confirmation">Are you sure you want to delete this MailGroup</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="mailGroup.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteMailGroup" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="mailGroup.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="mailGroup.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="mailGroup in mailGroupList"><td id="mailGroup.nameId{{$index}}">{{mailGroup.name}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_MailGroup{{$index}}" type="submit" ui-sref="mailgroup.detail({mailGroupId:mailGroup.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_MailGroup{{$index}}" type="submit" ng-click="goToEditState(mailGroup)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteMailGroup{{$index}}" type="submit" ng-click="singleDelete(mailGroup.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/mailgroup/mailgroups.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="mailGroup.overview.title">MailGroups</h3></div><div class="panel-buttons"><button id="createMailGroupButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="mailGroup.overview.button.new">Create a new MailGroup</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteMailGroupConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="mailGroup.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="mailGroup.overview.results.buttons.delete.confirmation">Are you sure you want to delete this MailGroup</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="mailGroup.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteMailGroup" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="mailGroup.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="mailGroup.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="mailGroup in mailGroupList"><td id="mailGroup.nameId{{$index}}">{{mailGroup.name}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_MailGroup{{$index}}" type="submit" ui-sref="mailgroup.detail({mailGroupId:mailGroup.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_MailGroup{{$index}}" type="submit" ng-click="goToEditState(mailGroup)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteMailGroup{{$index}}" type="submit" ng-click="singleDelete(mailGroup.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/orderline/orderline-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="OrderLineDetailTitle" translate="orderLine.detail.title">OrderLine</span> {{orderLine.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="orderLine.detail.creator.label">Creator:</span>&nbsp; <span>{{orderLine.creator}} {{orderLine.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="orderLine.updater">,&nbsp; <span translate="orderLine.detail.updater.label">Updater: </span>&nbsp; <span>{{orderLine.updater}} {{orderLine.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="orderline.detail.edit({orderLineId:orderLine.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteOrderLineConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(orderLine.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="orderLine.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="orderLine.overview.results.buttons.delete.confirmation">Are you sure you want to delete this OrderLine?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="orderLine.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="orderLine.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="orderLine.detail.article.label">article</span></td><td><a ui-sref="user-article.detail({articleId:orderLine.article.id})"><span>{{$root.displayFields([orderLine.article.name, orderLine.article.price])}}</span></a></td></tr><tr><td><span translate="orderLine.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{orderLine.description}}</span></td></tr><tr><td><span translate="orderLine.detail.pricePerPiece.label">pricePerPiece</span></td><td><span class="form-control-static">{{orderLine.pricePerPiece | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="orderLine.detail.numberOfArticles.label">numberOfArticles</span></td><td><span class="form-control-static">{{orderLine.numberOfArticles | number: 1}}</span></td></tr><tr><td><span translate="orderLine.detail.price.label">price</span></td><td><span class="form-control-static">{{orderLine.price | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="orderLine.detail.discount.label">discount</span></td><td><span class="form-control-static">{{orderLine.discount | currency:"\u20AC":2}}</span></td></tr><tr><td><span translate="orderLine.detail.discountComment.label">discountComment</span></td><td><span class="form-control-static">{{orderLine.discountComment}}</span></td></tr><tr><td><span translate="orderLine.detail.booking.label">booking</span></td><td><a ui-sref="booking.detail({bookingId:orderLine.booking.id})"><span>{{$root.displayFields([orderLine.booking.description, orderLine.booking.event.name, orderLine.booking.client.externalId, orderLine.booking.client.firstName, orderLine.booking.client.lastName, orderLine.booking.client.companyName])}}</span></a></td></tr><tr><td><span translate="orderLine.detail.subscription.label">subscription</span></td><td><a ui-sref="subscription.detail({subscriptionId:orderLine.subscription.id})"><span>{{$root.displayFields([orderLine.subscription.description, orderLine.subscription.relation.externalId, orderLine.subscription.relation.firstName, orderLine.subscription.relation.lastName, orderLine.subscription.relation.companyName])}}</span></a></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/orderline/orderline-dialog.html','<!--CodeComposer:preserve:file => Don\'t override manual changes--><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="OrderLineDialogTitleCreate" translate="orderLine.dialog.title.create">Create a OrderLine</h4><h4 class="modal-title" ng-show="isEdit()" id="OrderLineDialogTitleEdit" translate="orderLine.dialog.title.edit" translate-value-id="{{orderLine.id}}">Edit a OrderLine</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="orderLine.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.article.$invalid, \'has-success\' : editForm.article.$valid && editForm.article.$dirty }"><label for="field_article" class="col-sm-2 control-label" translate="orderLine.dialog.article.label">article</label><div class="col-sm-9"><select ng-disabled="\'article\' == mappedBy" class="form-control input-sm" id="field_article" name="article" ng-model="orderLine.article" ng-change="changeArticle(orderLine.article)" required ng-options="article as $root.displayFields([article.name, article.price]) for article in articleList track by article.id"><option value=""></option></select><div ng-show="editForm.article.$invalid"><p class="help-block" ng-show="editForm.article.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new article" ng-disabled="\'article\' == mappedBy" ng-click="createArticle()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="orderLine.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="orderLine.description" ng-maxlength="-1" placeholder="{{\'orderLine.dialog.description.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.pricePerPiece.$invalid, \'has-success\' : editForm.pricePerPiece.$valid && editForm.pricePerPiece.$dirty }"><label for="field_pricePerPiece" id="label_pricePerPiece" class="col-sm-2 control-label" translate="orderLine.dialog.pricePerPiece.label">PricePerPiece</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="pricePerPiece" id="field_pricePerPiece" ng-model="orderLine.pricePerPiece" ng-currency currency-symbol="\u20AC" 2 fraction="2" ng-disabled="orderLine.pricePerPiece === undefined && orderLine.numberOfArticles === undefined" ng-change="changePrice()" placeholder="{{\'orderLine.dialog.pricePerPiece.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.pricePerPiece.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.pricePerPiece.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.numberOfArticles.$invalid, \'has-success\' : editForm.numberOfArticles.$valid && editForm.numberOfArticles.$dirty }"><label for="field_numberOfArticles" id="label_numberOfArticles" class="col-sm-2 control-label" translate="orderLine.dialog.numberOfArticles.label">NumberOfArticles</label><div class="col-sm-9"><input type="number" step="0.01" class="form-control input-sm" name="numberOfArticles" id="field_numberOfArticles" ng-model="orderLine.numberOfArticles" ng-maxlength="-1" ng-disabled="orderLine.pricePerPiece === undefined && orderLine.numberOfArticles === undefined" ng-change="changePrice()" placeholder="{{\'orderLine.dialog.numberOfArticles.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.numberOfArticles.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.numberOfArticles.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.price.$invalid, \'has-success\' : editForm.price.$valid && editForm.price.$dirty }"><label for="field_price" id="label_price" class="col-sm-2 control-label" translate="orderLine.dialog.price.label">Price</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="price" id="field_price" readonly="true" ng-model="orderLine.price" ng-currency currency-symbol="\u20AC" 2 fraction="2" ng-disabled="orderLine.article === undefined" placeholder="{{\'orderLine.dialog.price.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.price.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.price.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.discount.$invalid, \'has-success\' : editForm.discount.$valid && editForm.discount.$dirty }"><label for="field_discount" id="label_discount" class="col-sm-2 control-label" translate="orderLine.dialog.discount.label">Discount</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="discount" id="field_discount" ng-model="orderLine.discount" ng-currency currency-symbol="\u20AC" 2 fraction="2" placeholder="{{\'orderLine.dialog.discount.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.discount.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.discount.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.discountComment.$invalid, \'has-success\' : editForm.discountComment.$valid && editForm.discountComment.$dirty }"><label for="field_discountComment" id="label_discountComment" class="col-sm-2 control-label" translate="orderLine.dialog.discountComment.label">DiscountComment</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="discountComment" id="field_discountComment" ng-model="orderLine.discountComment" ng-maxlength="255" placeholder="{{\'orderLine.dialog.discountComment.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.discountComment.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="255">Maxlength validation error</p><p class="help-block" ng-show="editForm.discountComment.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="">Maximum value validation error</p><p class="help-block" ng-show="editForm.discountComment.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.booking.$invalid, \'has-success\' : editForm.booking.$valid && editForm.booking.$dirty }"><label for="field_booking" class="col-sm-2 control-label" translate="orderLine.dialog.booking.label">booking</label><div class="col-sm-9"><input ng-disabled="\'booking\' == mappedBy" type="text" id="field_booking" name="booking" ng-model="orderLine.booking" ng-model-options="$root.modelOptions" uib-typeahead="booking as booking.displayValue for booking in autocompleteBookings($viewValue)" typeahead-loading="loadingBooking" typeahead-no-results="noResultsForBooking" placeholder="{{\'orderLine.dialog.booking.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingBooking" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForBooking"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.booking.$invalid"><p class="help-block" ng-show="editForm.booking.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new booking" ng-disabled="\'booking\' == mappedBy" ng-click="createBooking()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.subscription.$invalid, \'has-success\' : editForm.subscription.$valid && editForm.subscription.$dirty }"><label for="field_subscription" class="col-sm-2 control-label" translate="orderLine.dialog.subscription.label">subscription</label><div class="col-sm-9"><select ng-disabled="\'subscription\' == mappedBy" class="form-control input-sm" id="field_subscription" name="subscription" ng-model="orderLine.subscription" ng-options="subscription as $root.displayFields([subscription.description, subscription.relation.externalId, subscription.relation.firstName, subscription.relation.lastName, subscription.relation.companyName]) for subscription in subscriptionList track by subscription.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new subscription" ng-disabled="\'subscription\' == mappedBy" ng-click="createSubscription()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="orderLine.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="orderLine.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/orderline/orderline-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createOrderLineButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="orderLine.overview.button.new">Create a new OrderLine</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteOrderLineConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="orderLine.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="orderLine.overview.results.buttons.delete.confirmation">Are you sure you want to delete this OrderLine</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="orderLine.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteOrderLine" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="orderLine.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><!-- Generated by custom/jhipster/html/overview/table.ftl --><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'booking\'" jh-sort-by="booking.description" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.booking.label">booking</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'booking.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'subscription\'" jh-sort-by="subscription.relation.personName" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.subscription.label">subscription</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'subscription.relation.personName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'subscription\'" jh-sort-by="subscription.status" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.subscription.status.label">status</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'subscription.status\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.description.label">description</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="numberOfArticles" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.numberOfArticles.label">numberOfArticles</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'numberOfArticles\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="orderLine.overview.results.header.pricePerPiece.label">pricePerPiece</span></th><th><span translate="orderLine.overview.results.header.price.label">price</span></th><th class="hidden-xs"><span translate="orderLine.overview.results.header.discount.label">discount</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="orderLine in orderLineList"><td ng-hide="mappedBy == \'booking\'"><a ui-sref="booking.detail({bookingId:orderLine.booking.id})"><span>{{$root.displayFields([orderLine.booking.description, orderLine.booking.event.name, orderLine.booking.client.externalId, orderLine.booking.client.personName, orderLine.booking.client.companyName])}}</span></a></td><td ng-hide="mappedBy == \'subscription\'"><a ui-sref="subscription.detail({subscriptionId:orderLine.subscription.id})"><span>{{$root.displayFields([orderLine.subscription.description, orderLine.subscription.relation.externalId, orderLine.subscription.relation.personName, orderLine.subscription.relation.companyName])}}</span></a></td><td ng-hide="mappedBy == \'subscription\'"><a ui-sref="subscription.detail({subscriptionId:orderLine.subscription.id})"><span>{{$root.displayFields([orderLine.subscription.status])}}</span></a></td><td id="orderLine.description{{$index}}">{{orderLine.description}}</td><td id="orderLine.numberOfArticlesId{{$index}}" ng-class="{\r\n\'price-equal\': orderLine.pricePerPiece === orderLine.currentPrice,\r\n\'price-not-equal\': orderLine.pricePerPiece !== orderLine.currentPrice\r\n}">{{orderLine.numberOfArticles | number: 3}}</td><td id="orderLine.pricePerPieceId{{$index}}">{{orderLine.pricePerPiece | currency:"\u20AC":2}}</td><td id="orderLine.priceId{{$index}}">{{orderLine.price | currency:"\u20AC":2}}</td><td class="hidden-xs" id="orderLine.discountId{{$index}}">{{orderLine.discount | currency:"\u20AC":2}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_OrderLine{{$index}}" type="submit" ui-sref="orderline.detail({orderLineId:orderLine.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button><button id="btn_edit_OrderLine{{$index}}" type="submit" ng-click="goToEditState(orderLine)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button><button id="deleteOrderLine{{$index}}" type="submit" ng-click="singleDelete(orderLine.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/orderline/orderlines.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="orderLine.overview.title">OrderLines</h3></div><div class="panel-buttons"><button id="createOrderLineButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="orderLine.overview.button.new">Create a new OrderLine</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="orderLine.overview.search.booking.label">booking</label><div class="col-md-6"><input type="text" id="field_booking" name="booking" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="OrderLineSearchOverview.booking" ng-model-options="$root.modelOptions" uib-typeahead="booking as booking.displayValue for booking in autocompleteBookings($viewValue)" typeahead-loading="loadingBooking" typeahead-no-results="noResultsBooking" placeholder="{{\'orderLine.overview.search.booking.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingBooking" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsBooking"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="orderLine.overview.search.subscription.label">subscription</label><div class="col-md-6"><select id="subscription_select" class="form-control input-sm" ng-options="subscription as $root.displayFields([subscription.description, subscription.relation.externalId, subscription.relation.firstName, subscription.relation.lastName, subscription.relation.companyName]) for subscription in subscriptionReferenceFilterList track by subscription.id" ng-model="OrderLineSearchOverview.subscription" tabindex="0" ng-change="search()"><option value="" translate="orderLine.overview.search.subscription.defaultOption">All Subscriptions</option></select></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="orderLine.overview.search.article.label">article</label><div class="col-md-6"><select id="article_select" class="form-control input-sm" ng-options="article as $root.displayFields([article.name, article.price]) for article in articleReferenceFilterList track by article.id" ng-model="OrderLineSearchOverview.article" tabindex="0" ng-change="search()"><option value="" translate="orderLine.overview.search.article.defaultOption">All Articles</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="orderLine.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isOrderLineSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="orderLine.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteOrderLineConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="orderLine.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="orderLine.overview.results.buttons.delete.confirmation">Are you sure you want to delete this OrderLine</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="orderLine.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteOrderLine" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="orderLine.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="OrderLineSearchOverview.predicate" ascending="OrderLineSearchOverview.ascending" callback="search()"><th jh-sort-by="article.name" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.article.label">article</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'article.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="numberOfArticles" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.numberOfArticles.label">numberOfArticles</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'numberOfArticles\')}}" aria-hidden="true"></span>&nbsp;</span></th><th><span translate="orderLine.overview.results.header.price.label">price</span></th><th jh-sort-by="booking.description" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.booking.label">booking</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'booking.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="subscription.relation.personName" class="sortable"><span class="pull-left" translate="orderLine.overview.results.header.subscription.label">subscription</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'subscription.relation.personName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="orderLine in orderLineList"><td><a ui-sref="user-article.detail({articleId:orderLine.article.id})"><span>{{$root.displayFields([orderLine.article.name, orderLine.article.price])}}</span></a></td><td id="orderLine.numberOfArticlesId{{$index}}">{{orderLine.numberOfArticles | number: 3}}</td><td id="orderLine.priceId{{$index}}">{{orderLine.price | currency:"\u20AC":2}}</td><td><a ui-sref="booking.detail({bookingId:orderLine.booking.id})"><span>{{$root.displayFields([orderLine.booking.description, orderLine.booking.event.name, orderLine.booking.client.externalId, orderLine.booking.client.firstName, orderLine.booking.client.lastName, orderLine.booking.client.companyName])}}</span></a></td><td><a ui-sref="subscription.detail({subscriptionId:orderLine.subscription.id})"><span>{{$root.displayFields([orderLine.subscription.description, orderLine.subscription.relation.externalId, orderLine.subscription.relation.firstName, orderLine.subscription.relation.lastName, orderLine.subscription.relation.companyName])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_OrderLine{{$index}}" type="submit" ui-sref="orderline.detail({orderLineId:orderLine.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_OrderLine{{$index}}" type="submit" ng-click="goToEditState(orderLine)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteOrderLine{{$index}}" type="submit" ng-click="singleDelete(orderLine.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="OrderLineSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/relation/relation-bulkedit-user.html','<!--CodeComposer:preserve:file => Don\'t override manual changes--><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" id="RelationDialogTitleCreate" translate="relation.dialog.title.bulkedit" translate-value-amount="{{selectedItemsAmount}}">Bulk update 7 Relations</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" ng-disabled="updatingItemsInProgress" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.snelstart.label">relation.dialog.snelstart.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.externalId.$invalid, \'has-success\' : editForm.externalId.$valid && editForm.externalId.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.externalId.label" for="field_externalId">ExternalId</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="externalId" id="field_externalId" ng-model="relation.externalId" autofocus placeholder="{{\'relation.dialog.externalId.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartSync.$invalid, \'has-success\' : editForm.snelstartSync.$valid && editForm.snelstartSync.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartSync.label" for="field_snelstartSync">SnelstartSync</label><div class="col-xs-12 col-sm-8"><nz-toggle tri-toggle id="field_snelstartSync" ng-model="relation.snelstartSyncBoolean" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartId.$invalid, \'has-success\' : editForm.snelstartId.$valid && editForm.snelstartId.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartId.label" for="field_snelstartId">SnelstartId</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="snelstartId" id="field_snelstartId" ng-model="relation.snelstartId" placeholder="{{\'relation.dialog.snelstartId.placeholder\'|translate}}"></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.companyName.$invalid, \'has-success\' : editForm.companyName.$valid && editForm.companyName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.companyName.label" for="field_companyName">CompanyName</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="companyName" id="field_companyName" ng-model="relation.companyName" placeholder="{{\'relation.dialog.companyName.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.season.$invalid, \'has-success\' : editForm.season.$valid && editForm.season.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.season.label" for="field_season">Season</label><div class="col-xs-12 col-sm-8"><nz-toggle tri-toggle id="field_season" ng-model="relation.season" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group" ng-class="{ \'has-error\': editForm.vip.$invalid, \'has-success\' : editForm.vip.$valid && editForm.vip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.vip.label" for="field_vip">Vip</label><div class="col-xs-12 col-sm-8"><nz-toggle tri-toggle id="field_vip" ng-model="relation.vip" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.firstName.$invalid, \'has-success\' : editForm.firstName.$valid && editForm.firstName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.firstName.label" for="field_firstName">FirstName</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="firstName" id="field_firstName" ng-model="relation.firstName" placeholder="{{\'relation.dialog.firstName.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.firstName.$error.firstAndLastNameLengthSumm" , translate="user.edit.firstName.validation.lengthSum" , translate-value-length="{{_validationSumOfLengths}}"></p></div></div><div class="form-group" ng-class="{ \'has-error\': editForm.lastName.$invalid, \'has-success\' : editForm.lastName.$valid && editForm.lastName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.lastName.label" for="field_lastName">LastName</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="lastName" id="field_lastName" ng-model="relation.lastName" placeholder="{{\'relation.dialog.lastName.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.firstName.$error.firstAndLastNameLengthSumm" , translate="user.edit.firstName.validation.lengthSum" , translate-value-length="{{_validationSumOfLengths}}"></p></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.potential.$invalid, \'has-success\' : editForm.potential.$valid && editForm.potential.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.potential.label" for="field_potential">Potential</label><div class="col-xs-12 col-sm-8"><input type="number" class="form-control input-sm" name="potential" id="field_potential" ng-model="relation.potential" ng-min="1" ng-max="6" placeholder="{{\'relation.dialog.potential.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.accountManager.$invalid, \'has-success\' : editForm.accountManager.$valid && editForm.accountManager.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.accountManager.label" for="field_accountManager">AccountManager</label><div class="col-xs-12 col-sm-8"><select class="form-control input-sm" id="field_accountManager" name="accountManager" ng-model="relation.selectedAccountManager" ng-options="accountManager as accountManager.displayValue for accountManager in relation.accountManagerList track by accountManager.id"><option value=""></option></select></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.clientOf.$invalid, \'has-success\' : editForm.clientOf.$valid && editForm.clientOf.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.clientOf.label" for="field_clientOf">ClientOf</label><div class="col-xs-12 col-sm-8"><select class="form-control input-sm" id="field_clientOf" name="clientOf" ng-model="relation.clientOf" ng-options="\'ClientOf.\' + clientOf | translate for clientOf in relation.clientOfList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.sortOrder.$invalid, \'has-success\' : editForm.sortOrder.$valid && editForm.sortOrder.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.sortOrder.label" for="field_sortOrder">SortOrder</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="number" class="form-control input-sm" name="sortOrder" id="field_sortOrder" ng-model="relation.sortOrder" ng-min="0" placeholder="{{\'relation.dialog.sortOrder.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.relationSource.$invalid, \'has-success\' : editForm.relationSource.$valid && editForm.relationSource.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.relationSource.label" for="field_relationSource">RelationSource</label><div class="col-xs-12 col-sm-8"><select class="form-control input-sm" id="field_relationSource" name="relationSource" ng-model="relation.relationSource" ng-options="\'RelationSource.\' + relationSource | translate for relationSource in relation.relationSourceList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><!-- start panel container --><div class="panel bold"><div class="panel-heading" translate="relation.dialog.drivingPurpose.label">relation.dialog.drivingPurpose.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><textarea ng-disabled="true" rows="3" class="form-control input-sm" name="drivingPurpose" id="field_drivingPurpose" ng-model="relation.drivingPurpose" autofocus placeholder="{{\'relation.dialog.drivingPurpose.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t\t\t</textarea></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.extraInformation.label">relation.dialog.extraInformation.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><textarea ng-disabled="true" rows="3" class="form-control input-sm" name="extraInformation" id="field_extraInformation" ng-model="relation.extraInformation" autofocus placeholder="{{\'relation.dialog.extraInformation.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t\t\t</textarea></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row voffset2"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.email.$invalid, \'has-success\' : editForm.email.$valid && editForm.email.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.email.label" for="field_email">Email</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="email" class="form-control input-sm" name="email" id="field_email" ng-model="relation.email" placeholder="{{\'relation.dialog.email.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.gender.$invalid, \'has-success\' : editForm.gender.$valid && editForm.gender.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.gender.label" for="field_gender">Gender</label><div class="col-xs-12 col-sm-8"><select class="form-control input-sm" id="field_gender" name="gender" ng-model="relation.gender" ng-options="\'Gender.\' + gender | translate for gender in relation.genderList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.telephone.$invalid, \'has-success\' : editForm.telephone.$valid && editForm.telephone.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.telephone.label" for="field_telephone">Telephone</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="telephone" id="field_telephone" ng-model="relation.telephone" placeholder="{{\'relation.dialog.telephone.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.birthDate.$invalid, \'has-success\' : editForm.birthDate.$valid && editForm.birthDate.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.birthDate.label" for="field_birthDate">BirthDate</label><div class="col-xs-12 col-sm-8"><input datepicker-localdate type="date" class="form-control input-sm" name="birthDate" id="field_birthDate" ng-model="relation.birthDate" ng-disabled="true"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #9--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.mobile.$invalid, \'has-success\' : editForm.mobile.$valid && editForm.mobile.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.mobile.label" for="field_mobile">Mobile</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="mobile" id="field_mobile" ng-model="relation.mobile" placeholder="{{\'relation.dialog.mobile.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.knafLicenseNumber.$invalid, \'has-success\' : editForm.knafLicenseNumber.$valid && editForm.knafLicenseNumber.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.knafLicenseNumber.label" for="field_knafLicenseNumber">KnafLicenseNumber</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="knafLicenseNumber" id="field_knafLicenseNumber" ng-model="relation.knafLicenseNumber" placeholder="{{\'relation.dialog.knafLicenseNumber.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #10--><div class="col-xs-12 col-sm-6"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.businessAddress.label">relation.dialog.businessAddress.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessStreet.$invalid, \'has-success\' : editForm.businessStreet.$valid && editForm.businessStreet.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessStreet.label" for="field_businessStreet">BusinessStreet</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="businessStreet" id="field_businessStreet" ng-model="relation.businessStreet" placeholder="{{\'relation.dialog.businessStreet.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessZip.$invalid, \'has-success\' : editForm.businessZip.$valid && editForm.businessZip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessZip.label" for="field_businessZip">BusinessZip</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="businessZip" id="field_businessZip" ng-model="relation.businessZip" placeholder="{{\'relation.dialog.businessZip.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessCity.$invalid, \'has-success\' : editForm.businessCity.$valid && editForm.businessCity.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessCity.label" for="field_businessCity">BusinessCity</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="businessCity" id="field_businessCity" ng-model="relation.businessCity" placeholder="{{\'relation.dialog.businessCity.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessCountry.$invalid, \'has-success\' : editForm.businessCountry.$valid && editForm.businessCountry.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessCountry.label" for="field_businessCountry">BusinessCountry</label><div class="col-xs-12 col-sm-8"><select ng-disabled="true" class="form-control input-sm" id="field_businessCountry" name="businessCountry" ng-model="relation.selectedBusinessCountry" ng-options="businessCountry as businessCountry.displayValue for businessCountry in relation.businessCountryList track by businessCountry.id"><option value=""></option></select></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.privateAddress.label">relation.dialog.privateAddress.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateStreet.$invalid, \'has-success\' : editForm.privateStreet.$valid && editForm.privateStreet.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateStreet.label" for="field_privateStreet">PrivateStreet</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="privateStreet" id="field_privateStreet" ng-model="relation.privateStreet" placeholder="{{\'relation.dialog.privateStreet.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateZip.$invalid, \'has-success\' : editForm.privateZip.$valid && editForm.privateZip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateZip.label" for="field_privateZip">PrivateZip</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="privateZip" id="field_privateZip" ng-model="relation.privateZip" placeholder="{{\'relation.dialog.privateZip.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateCity.$invalid, \'has-success\' : editForm.privateCity.$valid && editForm.privateCity.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateCity.label" for="field_privateCity">PrivateCity</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="privateCity" id="field_privateCity" ng-model="relation.privateCity" placeholder="{{\'relation.dialog.privateCity.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateCountry.$invalid, \'has-success\' : editForm.privateCountry.$valid && editForm.privateCountry.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateCountry.label" for="field_privateCountry">PrivateCountry</label><div class="col-xs-12 col-sm-8"><select ng-disabled="true" class="form-control input-sm" id="field_privateCountry" name="privateCountry" ng-model="relation.selectedPrivateCountry" ng-options="privateCountry as privateCountry.displayValue for privateCountry in relation.privateCountryList track by privateCountry.id"><option value=""></option></select></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row voffset2"><!--row #11--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.vatNumber.$invalid, \'has-success\' : editForm.vatNumber.$valid && editForm.vatNumber.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.vatNumber.label" for="field_vatNumber">VatNumber</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="vatNumber" id="field_vatNumber" ng-model="relation.vatNumber" ng-maxlength="14" placeholder="{{\'relation.dialog.vatNumber.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.vatNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="14">Maxlength validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #12--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.relationMailGroup.$invalid, \'has-success\' : editForm.relationMailGroup.$valid && editForm.relationMailGroup.$dirty }"><label class="col-xs-12 col-sm-2 control-label" translate="relation.dialog.relationMailGroup.label" for="field_relationMailGroup">RelationMailGroup</label><div class="col-xs-12 col-sm-10"><ui-select multiple="multiple" ng-model="relation.selectedMailGroupList" id="field_relationMailGroup" title="Choose a mailGroup"><ui-select-match placeholder="{{ \'relation.dialog.relationMailGroup.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="mailGroup in relation.mailGroupList | propsFilter: {displayValue: $select.search}"><small>{{mailGroup.displayValue}}</small></ui-select-choices></ui-select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.sponsor.$invalid, \'has-success\' : editForm.sponsor.$valid && editForm.sponsor.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.sponsor.label" for="field_sponsor">Sponsor</label><div class="col-xs-12 col-sm-8"><nz-toggle tri-toggle id="field_sponsor" ng-model="relation.sponsor" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #14--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartCostCenter.$invalid, \'has-success\' : editForm.snelstartCostCenter.$valid && editForm.snelstartCostCenter.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartCostCenter.label" for="field_snelstartCostCenter">SnelstartCostCenter</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="number" class="form-control input-sm" name="snelstartCostCenter" id="field_snelstartCostCenter" ng-model="relation.snelstartCostCenter" ng-min="0" placeholder="{{\'relation.dialog.snelstartCostCenter.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #15--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.langKey.$invalid, \'has-success\' : editForm.langKey.$valid && editForm.langKey.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.langKey.label" for="field_langKey">LangKey</label><div class="col-xs-12 col-sm-8"><select class="form-control input-sm" id="field_langKey" name="langKey" ng-model="relation.langKey" ng-options="\'LangKey.\' + langKey | translate for langKey in relation.langKeyList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.carRentalAgreementSigned.$invalid, \'has-success\' : editForm.carRentalAgreementSigned.$valid && editForm.carRentalAgreementSigned.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.carRentalAgreementSigned.label" for="field_carRentalAgreementSigned">Car Rental Agreement Signed</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_carRentalAgreementSigned" ng-model="relation.carRentalAgreementSigned" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.indemnificationSigned.$invalid, \'has-success\' : editForm.indemnificationSigned.$valid && editForm.indemnificationSigned.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.indemnificationSigned.label" for="field_indemnificationSigned">indemnificationSigned</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_indemnificationSigned" ng-model="relation.indemnificationSigned" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #16--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><i ng-show="updatingItemsInProgress" class="glyphicon glyphicon-refresh">&nbsp;</i> <button type="button" class="btn btn-default" ng-click="clear()" ng-disabled="updatingItemsInProgress"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || updatingItemsInProgress" class="btn btn-primary" title="{{\'relation.dialog.bulkupdate.button.hint\'|translate}}"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="relation.dialog.bulkupdate.button">Bulk update</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/relation/relation-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="RelationDetailTitle" translate="relation.detail.title">Relation</span> {{relation.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="relation.detail.creator.label">Creator:</span>&nbsp; <span>{{relation.creator}} {{relation.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="relation.updater">,&nbsp; <span translate="relation.detail.updater.label">Updater: </span>&nbsp; <span>{{relation.updater}} {{relation.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="relation.detail.edit({relationId:relation.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteRelationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(relation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="relation.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relation.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Relation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="relation.detail.externalId.label">externalId</span></td><td><span class="form-control-static">{{relation.externalId}}</span></td></tr><tr><td><span translate="relation.detail.snelstartId.label">snelstartId</span></td><td><span class="form-control-static">{{relation.snelstartId}}</span></td></tr><tr><td><span translate="relation.detail.companyName.label">companyName</span></td><td><span class="form-control-static">{{relation.companyName}}</span></td></tr><tr><td><span translate="relation.detail.firstName.label">firstName</span></td><td><span class="form-control-static">{{relation.firstName}}</span></td></tr><tr><td><span translate="relation.detail.lastName.label">lastName</span></td><td><span class="form-control-static">{{relation.lastName}}</span></td></tr><tr><td><span translate="relation.detail.email.label">email</span></td><td><span class="form-control-static">{{relation.email}}</span></td></tr><tr><td><span translate="relation.detail.telephone.label">telephone</span></td><td><span class="form-control-static">{{relation.telephone}}</span></td></tr><tr><td><span translate="relation.detail.mobile.label">mobile</span></td><td><span class="form-control-static">{{relation.mobile}}</span></td></tr><tr><td><span translate="relation.detail.birthDate.label">birthDate</span></td><td><span class="form-control-static">{{relation.birthDate | nullableDate}}</span></td></tr><tr><td><span translate="relation.detail.knafLicenseNumber.label">knafLicenseNumber</span></td><td><span class="form-control-static">{{relation.knafLicenseNumber}}</span></td></tr><tr><td><span translate="relation.detail.season.label">season</span></td><td><span class="form-control-static">{{relation.season}}</span></td></tr><tr><td><span translate="relation.detail.snelstartSync.label">snelstartSync</span></td><td><span class="form-control-static">{{relation.snelstartSync}}</span></td></tr><tr><td><span translate="relation.detail.sponsor.label">sponsor</span></td><td><span class="form-control-static">{{relation.sponsor}}</span></td></tr><tr><td><span translate="relation.detail.vip.label">vip</span></td><td><span class="form-control-static">{{relation.vip}}</span></td></tr><tr><td><span translate="relation.detail.businessStreet.label">businessStreet</span></td><td><span class="form-control-static">{{relation.businessStreet}}</span></td></tr><tr><td><span translate="relation.detail.businessZip.label">businessZip</span></td><td><span class="form-control-static">{{relation.businessZip}}</span></td></tr><tr><td><span translate="relation.detail.businessCity.label">businessCity</span></td><td><span class="form-control-static">{{relation.businessCity}}</span></td></tr><tr><td><span translate="relation.detail.businessCountry.label">businessCountry</span></td><td><a ui-sref="country.detail({countryId:relation.businessCountry.id})"><span>{{relation.businessCountry.name}}</span></a></td></tr><tr><td><span translate="relation.detail.privateStreet.label">privateStreet</span></td><td><span class="form-control-static">{{relation.privateStreet}}</span></td></tr><tr><td><span translate="relation.detail.privateZip.label">privateZip</span></td><td><span class="form-control-static">{{relation.privateZip}}</span></td></tr><tr><td><span translate="relation.detail.privateCity.label">privateCity</span></td><td><span class="form-control-static">{{relation.privateCity}}</span></td></tr><tr><td><span translate="relation.detail.privateCountry.label">privateCountry</span></td><td><a ui-sref="country.detail({countryId:relation.privateCountry.id})"><span>{{relation.privateCountry.name}}</span></a></td></tr><tr><td><span translate="relation.detail.sortOrder.label">sortOrder</span></td><td><span class="form-control-static">{{relation.sortOrder}}</span></td></tr><tr><td><span translate="relation.detail.snelstartCostCenter.label">snelstartCostCenter</span></td><td><span class="form-control-static">{{relation.snelstartCostCenter}}</span></td></tr><tr><td><span translate="relation.detail.type.label">type</span></td><td><span class="form-control-static">{{relation.type === null ? "" : \'RelationType.\' + relation.type | translate}}</span></td></tr><tr><td><span translate="relation.detail.companyType.label">companyType</span></td><td><a ui-sref="companytype.detail({companyTypeId:relation.companyType.id})"><span>{{relation.companyType.name}}</span></a></td></tr><tr><td><span translate="relation.detail.relationSource.label">relationSource</span></td><td><span class="form-control-static">{{relation.relationSource === null ? "" : \'RelationSource.\' + relation.relationSource | translate}}</span></td></tr><tr><td><span translate="relation.detail.gender.label">gender</span></td><td><span class="form-control-static">{{relation.gender === null ? "" : \'Gender.\' + relation.gender | translate}}</span></td></tr><tr><td><span translate="relation.detail.drivingPurpose.label">drivingPurpose</span></td><td><span class="form-control-static white-space-pre">{{relation.drivingPurpose}}</span></td></tr><tr><td><span translate="relation.detail.clientOf.label">clientOf</span></td><td><span class="form-control-static">{{relation.clientOf === null ? "" : \'ClientOf.\' + relation.clientOf | translate}}</span></td></tr><tr><td><span translate="relation.detail.langKey.label">langKey</span></td><td><span class="form-control-static">{{relation.langKey === null ? "" : \'LangKey.\' + relation.langKey | translate}}</span></td></tr><tr><td><span translate="relation.detail.potential.label">potential</span></td><td><span class="form-control-static">{{relation.potential}}</span></td></tr><tr><td><span translate="relation.detail.carRentalAgreementSigned.label">carRentalAgreementSigned</span></td><td><span class="form-control-static">{{relation.carRentalAgreementSigned}}</span></td></tr><tr><td><span translate="relation.detail.extraInformation.label">extraInformation</span></td><td><span class="form-control-static white-space-pre">{{relation.extraInformation}}</span></td></tr><tr><td><span translate="relation.detail.indemnificationSigned.label">indemnificationSigned</span></td><td><span class="form-control-static">{{relation.indemnificationSigned}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.relationActiveTab"><uib-tab id="tab-relationmailgroups-overview-mapped-by-relation" heading="{{\'relation.detail.tab.relationMailGroup.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><relationmailgroups-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></relationmailgroups-overview-mapped-by-relation></uib-tab><uib-tab id="tab-bookings-overview-mapped-by-client" heading="{{\'relation.detail.tab.booking.by.client\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><bookings-overview-mapped-by-client read-only="true" mapped-by-id="relationId" mapped-by="\'client\'" mapped-by-type="\'relation\'"></bookings-overview-mapped-by-client></uib-tab><uib-tab id="tab-cars-overview-mapped-by-owner" heading="{{\'relation.detail.tab.car.by.owner\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><cars-overview-mapped-by-owner read-only="true" mapped-by-id="relationId" mapped-by="\'owner\'" mapped-by-type="\'relation\'"></cars-overview-mapped-by-owner></uib-tab><uib-tab id="tab-subscriptions-overview-mapped-by-relation" heading="{{\'relation.detail.tab.subscription.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><subscriptions-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></subscriptions-overview-mapped-by-relation></uib-tab><uib-tab id="tab-documents-overview-mapped-by-relation" heading="{{\'relation.detail.tab.document.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></documents-overview-mapped-by-relation></uib-tab><uib-tab id="tab-instructors-overview-mapped-by-relation" heading="{{\'relation.detail.tab.instructor.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><instructors-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></instructors-overview-mapped-by-relation></uib-tab><uib-tab id="tab-eventrelationcontacts-overview-mapped-by-relation" heading="{{\'relation.detail.tab.eventRelationContact.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><eventrelationcontacts-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></eventrelationcontacts-overview-mapped-by-relation></uib-tab><uib-tab id="tab-articlerelationprices-overview-mapped-by-relation" heading="{{\'relation.detail.tab.articleRelationPrice.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><articlerelationprices-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></articlerelationprices-overview-mapped-by-relation></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/relation/relation-detaillayout.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="RelationDetailTitle" translate="relation.detail.title">Relation</span> {{relation.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="relation.detail.creator.label">Creator:</span>&nbsp; <span>{{relation.creator}} {{relation.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="relation.updater">,&nbsp; <span translate="relation.detail.updater.label">Updater: </span>&nbsp; <span>{{relation.updater}} {{relation.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="relation.detail.edit({relationId:relation.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="modal fade" id="deleteRelationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(relation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="relation.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relation.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Relation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="panel-body"><div class="row"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed layout-container"><tbody><tr><!--row #1--><td colspan="4" style="width: 100%"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.snelstart.label">relation.dialog.snelstart.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 25%"><!--column #1--><label translate="relation.detail.externalId.label">ExternalId</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.externalId}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.snelstartSync.label">SnelstartSync</label></td><td style="width: 25%"><!--column #4--> <span ng-class="$root.getActiveClassForBoolean(relation.snelstartSync)"><span ng-show="relation.snelstartSync" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.snelstartSync" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="relation.detail.snelstartId.label">SnelstartId</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.snelstartId}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="relation.detail.companyName.label">CompanyName</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.companyName}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.season.label">Season</label><label translate="relation.detail.vip.label">Vip</label></td><td style="width: 25%"><!--column #4--> <span ng-class="$root.getActiveClassForBoolean(relation.season)"><span ng-show="relation.season" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.season" class="glyphicon glyphicon-remove" aria-hidden="true"></span> </span><span ng-class="$root.getActiveClassForBoolean(relation.vip)"><span ng-show="relation.vip" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.vip" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td></tr><tr><!--row #3--><td style="width: 25%"><!--column #1--><label translate="relation.detail.firstName.label">FirstName</label><label translate="relation.detail.lastName.label">LastName</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.firstName}}</span> <span>{{relation.lastName}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.potential.label">Potential</label></td><td style="width: 25%"><!--column #4--> <span uib-rating max="6" read-only="true" ng-model="relation.potential" titles="[\'1\',\'2\',\'3\',\'4\',\'5\',\'6\',\'7\',\'8\',\'9\',\'10\']" aria-labelledby="default-rating"></span></td></tr><tr><!--row #4--><td style="width: 25%"><!--column #1--><label translate="relation.detail.accountManager.label">AccountManager</label></td><td style="width: 25%"><!--column #2--> <a ui-sref="user.detail({userId:relation.accountManager.id})"><span>{{$root.displayFields([relation.accountManager.lastName, relation.accountManager.firstName])}}</span></a></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.clientOf.label">ClientOf</label></td><td style="width: 25%"><!--column #4--> <span class="form-control-static">{{relation.clientOf === null ? "" : \'ClientOf.\' + relation.clientOf | translate}}</span></td></tr><tr><!--row #5--><td style="width: 25%"><!--column #1--><label translate="relation.detail.sortOrder.label">SortOrder</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.sortOrder}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.relationSource.label">RelationSource</label></td><td style="width: 25%"><!--column #4--> <span class="form-control-static">{{relation.relationSource === null ? "" : \'RelationSource.\' + relation.relationSource | translate}}</span></td></tr><tr><!--row #6--><td style="width: 25%"><!--column #1--><label translate="relation.detail.drivingPurpose.label">DrivingPurpose</label></td><td style="width: 25%"><!--column #2--><textarea ng-model="relation.drivingPurpose" disabled="disabled" class="form-control" rows="5"></textarea></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.extraInformation.label">ExtraInformation</label></td><td style="width: 25%"><!--column #4--><textarea ng-model="relation.extraInformation" disabled="disabled" class="form-control" rows="5"></textarea></td></tr><tr><!--row #7--><td colspan="4" style="width: 100%"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.personalData.label">relation.dialog.personalData.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 25%"><!--column #1--><label translate="relation.detail.email.label">Email</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.email}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.gender.label">Gender</label></td><td style="width: 25%"><!--column #4--> <span class="form-control-static">{{relation.gender === null ? "" : \'Gender.\' + relation.gender | translate}}</span></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="relation.detail.telephone.label">Telephone</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.telephone}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.birthDate.label">BirthDate</label></td><td style="width: 25%"><!--column #4--> <span>{{relation.birthDate | nullableDate}}</span>&nbsp;</td></tr><tr><!--row #3--><td style="width: 25%"><!--column #1--><label translate="relation.detail.mobile.label">Mobile</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.mobile}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.knafLicenseNumber.label">KnafLicenseNumber</label></td><td style="width: 25%"><!--column #4--> <span>{{relation.knafLicenseNumber}}</span></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><!--row #8--><td colspan="2" style="width: 50%"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.businessAddress.label">relation.dialog.businessAddress.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessStreet.label">BusinessStreet</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.businessStreet}}</span></td></tr><tr><!--row #2--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessZip.label">BusinessZip</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.businessZip}}</span></td></tr><tr><!--row #3--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessCity.label">BusinessCity</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.businessCity}}</span></td></tr><tr><!--row #4--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessCountry.label">BusinessCountry</label></td><td style="width: 50%"><!--column #2--> <a ui-sref="country.detail({countryId:relation.businessCountry.id})"><span>{{relation.businessCountry.name}}</span></a></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td><td colspan="2" style="width: 50%"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.privateAddress.label">relation.dialog.privateAddress.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateStreet.label">PrivateStreet</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.privateStreet}}</span></td></tr><tr><!--row #2--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateZip.label">PrivateZip</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.privateZip}}</span></td></tr><tr><!--row #3--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateCity.label">PrivateCity</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.privateCity}}</span></td></tr><tr><!--row #4--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateCountry.label">PrivateCountry</label></td><td style="width: 50%"><!--column #2--> <a ui-sref="country.detail({countryId:relation.privateCountry.id})"><span>{{relation.privateCountry.name}}</span></a></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><!--row #9--><td style="width: 25%"><!--column #1--><label translate="relation.detail.sponsor.label">Sponsor</label></td><td style="width: 25%"><!--column #2--> <span ng-class="$root.getActiveClassForBoolean(relation.sponsor)"><span ng-show="relation.sponsor" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.sponsor" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #10--><td style="width: 25%"><!--column #1--><label translate="relation.detail.snelstartCostCenter.label">SnelstartCostCenter</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.snelstartCostCenter}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #11--><td style="width: 25%"><!--column #1--><label translate="relation.detail.langKey.label">LangKey</label></td><td style="width: 25%"><!--column #2--> <span class="form-control-static">{{relation.langKey === null ? "" : \'LangKey.\' + relation.langKey | translate}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #12--><td style="width: 25%"><!--column #1--><label translate="relation.detail.vatNumber.label">VatNumber</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.vatNumber}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #13--><td style="width: 25%"><!--column #1--><label translate="relation.detail.carRentalAgreementSigned.label">CarRentalAgreementSigned</label></td><td style="width: 25%"><!--column #2--> <span ng-class="$root.getActiveClassForBoolean(relation.carRentalAgreementSigned)"><span ng-show="relation.carRentalAgreementSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.carRentalAgreementSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #14--><td style="width: 25%"><!--column #1--><label translate="relation.detail.indemnificationSigned.label">IndemnificationSigned</label></td><td style="width: 25%"><!--column #2--> <span ng-class="$root.getActiveClassForBoolean(relation.indemnificationSigned)"><span ng-show="relation.indemnificationSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.indemnificationSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #15--><td style="width: 25%"></td><td style="width: 25%"></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><!-- END row in rows --></tbody></table></div></div></div><div><uib-tabset active="$root.relationActiveTab"><uib-tab id="tab-relationmailgroups-overview-mapped-by-relation" heading="{{\'relation.detail.tab.relationMailGroup.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><relationmailgroups-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></relationmailgroups-overview-mapped-by-relation></uib-tab><uib-tab id="tab-bookings-overview-mapped-by-client" heading="{{\'relation.detail.tab.booking.by.client\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><bookings-overview-mapped-by-client read-only="true" mapped-by-id="relationId" mapped-by="\'client\'" mapped-by-type="\'relation\'"></bookings-overview-mapped-by-client></uib-tab><uib-tab id="tab-cars-overview-mapped-by-owner" heading="{{\'relation.detail.tab.car.by.owner\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><cars-overview-mapped-by-owner read-only="true" mapped-by-id="relationId" mapped-by="\'owner\'" mapped-by-type="\'relation\'"></cars-overview-mapped-by-owner></uib-tab><uib-tab id="tab-subscriptions-overview-mapped-by-relation" heading="{{\'relation.detail.tab.subscription.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><subscriptions-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></subscriptions-overview-mapped-by-relation></uib-tab><uib-tab id="tab-documents-overview-mapped-by-relation" heading="{{\'relation.detail.tab.document.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></documents-overview-mapped-by-relation></uib-tab><uib-tab id="tab-instructors-overview-mapped-by-relation" heading="{{\'relation.detail.tab.instructor.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><instructors-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></instructors-overview-mapped-by-relation></uib-tab><uib-tab id="tab-eventrelationcontacts-overview-mapped-by-relation" heading="{{\'relation.detail.tab.eventRelationContact.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><eventrelationcontacts-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></eventrelationcontacts-overview-mapped-by-relation></uib-tab><uib-tab id="tab-articlerelationprices-overview-mapped-by-relation" heading="{{\'relation.detail.tab.articleRelationPrice.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><articlerelationprices-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></articlerelationprices-overview-mapped-by-relation></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/relation/relation-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="RelationDialogTitleCreate" translate="relation.dialog.title.create">Create a Relation</h4><h4 class="modal-title" ng-show="isEdit()" id="RelationDialogTitleEdit" translate="relation.dialog.title.edit" translate-value-id="{{relation.id}}">Edit a Relation</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="relation.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.externalId.$invalid, \'has-success\' : editForm.externalId.$valid && editForm.externalId.$dirty }"><label for="field_externalId" id="label_externalId" class="col-sm-2 control-label" translate="relation.dialog.externalId.label">ExternalId</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="externalId" id="field_externalId" ng-model="relation.externalId" ng-maxlength="-1" placeholder="{{\'relation.dialog.externalId.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.snelstartId.$invalid, \'has-success\' : editForm.snelstartId.$valid && editForm.snelstartId.$dirty }"><label for="field_snelstartId" id="label_snelstartId" class="col-sm-2 control-label" translate="relation.dialog.snelstartId.label">SnelstartId</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="snelstartId" id="field_snelstartId" ng-model="relation.snelstartId" ng-maxlength="-1" placeholder="{{\'relation.dialog.snelstartId.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.companyName.$invalid, \'has-success\' : editForm.companyName.$valid && editForm.companyName.$dirty }"><label for="field_companyName" id="label_companyName" class="col-sm-2 control-label" translate="relation.dialog.companyName.label">CompanyName</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="companyName" id="field_companyName" ng-model="relation.companyName" ng-maxlength="49" placeholder="{{\'relation.dialog.companyName.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.companyName.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="49">Maxlength validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.firstName.$invalid, \'has-success\' : editForm.firstName.$valid && editForm.firstName.$dirty }"><label for="field_firstName" id="label_firstName" class="col-sm-2 control-label" translate="relation.dialog.firstName.label">FirstName</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="firstName" id="field_firstName" ng-model="relation.firstName" ng-maxlength="-1" placeholder="{{\'relation.dialog.firstName.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.lastName.$invalid, \'has-success\' : editForm.lastName.$valid && editForm.lastName.$dirty }"><label for="field_lastName" id="label_lastName" class="col-sm-2 control-label" translate="relation.dialog.lastName.label">LastName</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="lastName" id="field_lastName" ng-model="relation.lastName" ng-maxlength="-1" placeholder="{{\'relation.dialog.lastName.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.email.$invalid, \'has-success\' : editForm.email.$valid && editForm.email.$dirty }"><label for="field_email" id="label_email" class="col-sm-2 control-label" translate="relation.dialog.email.label">Email</label><div class="col-sm-9"><input type="email" class="form-control input-sm" name="email" id="field_email" ng-model="relation.email" ng-maxlength="-1" placeholder="{{\'relation.dialog.email.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.telephone.$invalid, \'has-success\' : editForm.telephone.$valid && editForm.telephone.$dirty }"><label for="field_telephone" id="label_telephone" class="col-sm-2 control-label" translate="relation.dialog.telephone.label">Telephone</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="telephone" id="field_telephone" ng-model="relation.telephone" ng-maxlength="-1" placeholder="{{\'relation.dialog.telephone.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.mobile.$invalid, \'has-success\' : editForm.mobile.$valid && editForm.mobile.$dirty }"><label for="field_mobile" id="label_mobile" class="col-sm-2 control-label" translate="relation.dialog.mobile.label">Mobile</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="mobile" id="field_mobile" ng-model="relation.mobile" ng-maxlength="-1" placeholder="{{\'relation.dialog.mobile.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.birthDate.$invalid, \'has-success\' : editForm.birthDate.$valid && editForm.birthDate.$dirty }"><label for="field_birthDate" id="label_birthDate" class="col-sm-2 control-label" translate="relation.dialog.birthDate.label">BirthDate</label><div class="col-sm-9"><input datepicker-localdate type="date" class="form-control input-sm" name="birthDate" id="field_birthDate" ng-model="relation.birthDate"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.knafLicenseNumber.$invalid, \'has-success\' : editForm.knafLicenseNumber.$valid && editForm.knafLicenseNumber.$dirty }"><label for="field_knafLicenseNumber" id="label_knafLicenseNumber" class="col-sm-2 control-label" translate="relation.dialog.knafLicenseNumber.label">KnafLicenseNumber</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="knafLicenseNumber" id="field_knafLicenseNumber" ng-model="relation.knafLicenseNumber" ng-maxlength="-1" placeholder="{{\'relation.dialog.knafLicenseNumber.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.season.$invalid, \'has-success\' : editForm.season.$valid && editForm.season.$dirty }"><label for="field_season" id="label_season" class="col-sm-2 control-label" translate="relation.dialog.season.label">Season</label><div class="col-sm-9"><nz-toggle id="field_season" name="season" ng-model="relation.season" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.snelstartSync.$invalid, \'has-success\' : editForm.snelstartSync.$valid && editForm.snelstartSync.$dirty }"><label for="field_snelstartSync" id="label_snelstartSync" class="col-sm-2 control-label" translate="relation.dialog.snelstartSync.label">SnelstartSync</label><div class="col-sm-9"><nz-toggle id="field_snelstartSync" name="snelstartSync" ng-model="relation.snelstartSync" val-true="true" val-false="false" val-null="null" val-default="true" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.sponsor.$invalid, \'has-success\' : editForm.sponsor.$valid && editForm.sponsor.$dirty }"><label for="field_sponsor" id="label_sponsor" class="col-sm-2 control-label" translate="relation.dialog.sponsor.label">Sponsor</label><div class="col-sm-9"><nz-toggle id="field_sponsor" name="sponsor" ng-model="relation.sponsor" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.vip.$invalid, \'has-success\' : editForm.vip.$valid && editForm.vip.$dirty }"><label for="field_vip" id="label_vip" class="col-sm-2 control-label" translate="relation.dialog.vip.label">Vip</label><div class="col-sm-9"><nz-toggle id="field_vip" name="vip" ng-model="relation.vip" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.businessStreet.$invalid, \'has-success\' : editForm.businessStreet.$valid && editForm.businessStreet.$dirty }"><label for="field_businessStreet" id="label_businessStreet" class="col-sm-2 control-label" translate="relation.dialog.businessStreet.label">BusinessStreet</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="businessStreet" id="field_businessStreet" ng-model="relation.businessStreet" ng-maxlength="-1" placeholder="{{\'relation.dialog.businessStreet.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.businessZip.$invalid, \'has-success\' : editForm.businessZip.$valid && editForm.businessZip.$dirty }"><label for="field_businessZip" id="label_businessZip" class="col-sm-2 control-label" translate="relation.dialog.businessZip.label">BusinessZip</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="businessZip" id="field_businessZip" ng-model="relation.businessZip" ng-maxlength="-1" placeholder="{{\'relation.dialog.businessZip.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.businessCity.$invalid, \'has-success\' : editForm.businessCity.$valid && editForm.businessCity.$dirty }"><label for="field_businessCity" id="label_businessCity" class="col-sm-2 control-label" translate="relation.dialog.businessCity.label">BusinessCity</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="businessCity" id="field_businessCity" ng-model="relation.businessCity" ng-maxlength="-1" placeholder="{{\'relation.dialog.businessCity.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.businessCountry.$invalid, \'has-success\' : editForm.businessCountry.$valid && editForm.businessCountry.$dirty }"><label for="field_businessCountry" class="col-sm-2 control-label" translate="relation.dialog.businessCountry.label">businessCountry</label><div class="col-sm-9"><select ng-disabled="\'businessCountry\' == mappedBy" class="form-control input-sm" id="field_businessCountry" name="businessCountry" ng-model="relation.businessCountry" ng-options="businessCountry as businessCountry.name for businessCountry in businessCountryList track by businessCountry.id"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.privateStreet.$invalid, \'has-success\' : editForm.privateStreet.$valid && editForm.privateStreet.$dirty }"><label for="field_privateStreet" id="label_privateStreet" class="col-sm-2 control-label" translate="relation.dialog.privateStreet.label">PrivateStreet</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="privateStreet" id="field_privateStreet" ng-model="relation.privateStreet" ng-maxlength="-1" placeholder="{{\'relation.dialog.privateStreet.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.privateZip.$invalid, \'has-success\' : editForm.privateZip.$valid && editForm.privateZip.$dirty }"><label for="field_privateZip" id="label_privateZip" class="col-sm-2 control-label" translate="relation.dialog.privateZip.label">PrivateZip</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="privateZip" id="field_privateZip" ng-model="relation.privateZip" ng-maxlength="-1" placeholder="{{\'relation.dialog.privateZip.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.privateCity.$invalid, \'has-success\' : editForm.privateCity.$valid && editForm.privateCity.$dirty }"><label for="field_privateCity" id="label_privateCity" class="col-sm-2 control-label" translate="relation.dialog.privateCity.label">PrivateCity</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="privateCity" id="field_privateCity" ng-model="relation.privateCity" ng-maxlength="-1" placeholder="{{\'relation.dialog.privateCity.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.privateCountry.$invalid, \'has-success\' : editForm.privateCountry.$valid && editForm.privateCountry.$dirty }"><label for="field_privateCountry" class="col-sm-2 control-label" translate="relation.dialog.privateCountry.label">privateCountry</label><div class="col-sm-9"><select ng-disabled="\'privateCountry\' == mappedBy" class="form-control input-sm" id="field_privateCountry" name="privateCountry" ng-model="relation.privateCountry" ng-options="privateCountry as privateCountry.name for privateCountry in privateCountryList track by privateCountry.id"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.sortOrder.$invalid, \'has-success\' : editForm.sortOrder.$valid && editForm.sortOrder.$dirty }"><label for="field_sortOrder" id="label_sortOrder" class="col-sm-2 control-label" translate="relation.dialog.sortOrder.label">SortOrder</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="sortOrder" id="field_sortOrder" ng-model="relation.sortOrder" ng-min="0" ng-maxlength="-1" placeholder="{{\'relation.dialog.sortOrder.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.sortOrder.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.snelstartCostCenter.$invalid, \'has-success\' : editForm.snelstartCostCenter.$valid && editForm.snelstartCostCenter.$dirty }"><label for="field_snelstartCostCenter" id="label_snelstartCostCenter" class="col-sm-2 control-label" translate="relation.dialog.snelstartCostCenter.label">SnelstartCostCenter</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="snelstartCostCenter" id="field_snelstartCostCenter" ng-model="relation.snelstartCostCenter" ng-min="0" ng-maxlength="-1" placeholder="{{\'relation.dialog.snelstartCostCenter.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.snelstartCostCenter.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.type.$invalid, \'has-success\' : editForm.type.$valid && editForm.type.$dirty }"><label for="field_type" class="col-sm-2 control-label" translate="relation.dialog.type.label">type</label><div class="col-sm-9"><select ng-disabled="\'type\' == mappedBy" class="form-control input-sm" id="field_type" name="type" ng-model="relation.type" ng-options="\'RelationType.\' + type | translate for type in typeList"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.companyType.$invalid, \'has-success\' : editForm.companyType.$valid && editForm.companyType.$dirty }"><label for="field_companyType" class="col-sm-2 control-label" translate="relation.dialog.companyType.label">companyType</label><div class="col-sm-9"><select ng-disabled="\'companyType\' == mappedBy" class="form-control input-sm" id="field_companyType" name="companyType" ng-model="relation.companyType" ng-options="companyType as companyType.name for companyType in companyTypeList track by companyType.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new companytype" ng-disabled="\'companyType\' == mappedBy" ng-click="createCompanyType()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relationSource.$invalid, \'has-success\' : editForm.relationSource.$valid && editForm.relationSource.$dirty }"><label for="field_relationSource" class="col-sm-2 control-label" translate="relation.dialog.relationSource.label">relationSource</label><div class="col-sm-9"><select ng-disabled="\'relationSource\' == mappedBy" class="form-control input-sm" id="field_relationSource" name="relationSource" ng-model="relation.relationSource" ng-options="\'RelationSource.\' + relationSource | translate for relationSource in relationSourceList"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.gender.$invalid, \'has-success\' : editForm.gender.$valid && editForm.gender.$dirty }"><label for="field_gender" class="col-sm-2 control-label" translate="relation.dialog.gender.label">gender</label><div class="col-sm-9"><select ng-disabled="\'gender\' == mappedBy" class="form-control input-sm" id="field_gender" name="gender" ng-model="relation.gender" ng-options="\'Gender.\' + gender | translate for gender in genderList"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.drivingPurpose.$invalid, \'has-success\' : editForm.drivingPurpose.$valid && editForm.drivingPurpose.$dirty }"><label for="field_drivingPurpose" id="label_drivingPurpose" class="col-sm-2 control-label" translate="relation.dialog.drivingPurpose.label">DrivingPurpose</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="drivingPurpose" id="field_drivingPurpose" ng-model="relation.drivingPurpose" ng-maxlength="-1" placeholder="{{\'relation.dialog.drivingPurpose.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.clientOf.$invalid, \'has-success\' : editForm.clientOf.$valid && editForm.clientOf.$dirty }"><label for="field_clientOf" class="col-sm-2 control-label" translate="relation.dialog.clientOf.label">clientOf</label><div class="col-sm-9"><select ng-disabled="\'clientOf\' == mappedBy" class="form-control input-sm" id="field_clientOf" name="clientOf" ng-model="relation.clientOf" ng-options="\'ClientOf.\' + clientOf | translate for clientOf in clientOfList"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.langKey.$invalid, \'has-success\' : editForm.langKey.$valid && editForm.langKey.$dirty }"><label for="field_langKey" class="col-sm-2 control-label" translate="relation.dialog.langKey.label">langKey</label><div class="col-sm-9"><select ng-disabled="\'langKey\' == mappedBy" class="form-control input-sm" id="field_langKey" name="langKey" ng-model="relation.langKey" required ng-options="\'LangKey.\' + langKey | translate for langKey in langKeyList"><option value=""></option></select><div ng-show="editForm.langKey.$invalid"><p class="help-block" ng-show="editForm.langKey.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.potential.$invalid, \'has-success\' : editForm.potential.$valid && editForm.potential.$dirty }"><label for="field_potential" id="label_potential" class="col-sm-2 control-label" translate="relation.dialog.potential.label">Potential</label><div class="col-sm-9"><span uib-rating ng-model="relation.potential" ng-max="6" titles="[\'1\',\'2\',\'3\',\'4\',\'5\',\'6\',\'7\',\'8\',\'9\',\'10\']" aria-labelledby="default-rating"></span><p class="help-block" ng-show="editForm.potential.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="6">Maximum value validation error</p><p class="help-block" ng-show="editForm.potential.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="1">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.carRentalAgreementSigned.$invalid, \'has-success\' : editForm.carRentalAgreementSigned.$valid && editForm.carRentalAgreementSigned.$dirty }"><label for="field_carRentalAgreementSigned" id="label_carRentalAgreementSigned" class="col-sm-2 control-label" translate="relation.dialog.carRentalAgreementSigned.label">CarRentalAgreementSigned</label><div class="col-sm-9"><nz-toggle id="field_carRentalAgreementSigned" name="carRentalAgreementSigned" ng-model="relation.carRentalAgreementSigned" val-true="true" val-false="false" val-null="null" val-default="FALSE" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.extraInformation.$invalid, \'has-success\' : editForm.extraInformation.$valid && editForm.extraInformation.$dirty }"><label for="field_extraInformation" id="label_extraInformation" class="col-sm-2 control-label" translate="relation.dialog.extraInformation.label">ExtraInformation</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="extraInformation" id="field_extraInformation" ng-model="relation.extraInformation" ng-maxlength="-1" placeholder="{{\'relation.dialog.extraInformation.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.indemnificationSigned.$invalid, \'has-success\' : editForm.indemnificationSigned.$valid && editForm.indemnificationSigned.$dirty }"><label for="field_indemnificationSigned" id="label_indemnificationSigned" class="col-sm-2 control-label" translate="relation.dialog.indemnificationSigned.label">IndemnificationSigned</label><div class="col-sm-9"><nz-toggle id="field_indemnificationSigned" name="indemnificationSigned" ng-model="relation.indemnificationSigned" val-true="true" val-false="false" val-null="null" val-default="FALSE" class="square"></nz-toggle></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="relation.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="relation.dialog.saveAndNew.button">Save</span></button></div></form>');
$templateCache.put('app/entities/relation/relation-dialoglayout.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="RelationDialogTitleCreate" translate="relation.dialog.title.create">Create a Relation</h4><h4 class="modal-title" ng-show="isEdit()" id="RelationDialogTitleEdit" translate="relation.dialog.title.edit" translate-value-id="{{relation.id}}">Edit a Relation</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="row"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.snelstart.label">relation.dialog.snelstart.label</div><div class="panel-body"><div class="row"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.externalId.$invalid, \'has-success\' : editForm.externalId.$valid && editForm.externalId.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.externalId.label" for="field_externalId">ExternalId</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="externalId" id="field_externalId" ng-model="relation.externalId" autofocus placeholder="{{\'relation.dialog.externalId.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartSync.$invalid, \'has-success\' : editForm.snelstartSync.$valid && editForm.snelstartSync.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartSync.label" for="field_snelstartSync">SnelstartSync</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_snelstartSync" ng-model="relation.snelstartSync" val-true="true" val-false="false" val-null="null" val-default="true" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartId.$invalid, \'has-success\' : editForm.snelstartId.$valid && editForm.snelstartId.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartId.label" for="field_snelstartId">SnelstartId</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="snelstartId" id="field_snelstartId" ng-model="relation.snelstartId" placeholder="{{\'relation.dialog.snelstartId.placeholder\'|translate}}"></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.companyName.$invalid, \'has-success\' : editForm.companyName.$valid && editForm.companyName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.companyName.label" for="field_companyName">CompanyName</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="companyName" id="field_companyName" ng-model="relation.companyName" ng-maxlength="49" placeholder="{{\'relation.dialog.companyName.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.companyName.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="49">Maxlength validation error</p></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.season.$invalid, \'has-success\' : editForm.season.$valid && editForm.season.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.season.label" for="field_season">Season</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_season" ng-model="relation.season" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group" ng-class="{ \'has-error\': editForm.vip.$invalid, \'has-success\' : editForm.vip.$valid && editForm.vip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.vip.label" for="field_vip">Vip</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_vip" ng-model="relation.vip" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.firstName.$invalid, \'has-success\' : editForm.firstName.$valid && editForm.firstName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.firstName.label" for="field_firstName">FirstName</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="firstName" id="field_firstName" ng-model="relation.firstName" placeholder="{{\'relation.dialog.firstName.placeholder\'|translate}}"></div></div><div class="form-group" ng-class="{ \'has-error\': editForm.lastName.$invalid, \'has-success\' : editForm.lastName.$valid && editForm.lastName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.lastName.label" for="field_lastName">LastName</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="lastName" id="field_lastName" ng-model="relation.lastName" placeholder="{{\'relation.dialog.lastName.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.potential.$invalid, \'has-success\' : editForm.potential.$valid && editForm.potential.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.potential.label" for="field_potential">Potential</label><div class="col-xs-12 col-sm-8"><span uib-rating id="field_potential" ng-model="relation.potential" max="6" titles="[\'1\',\'2\',\'3\',\'4\',\'5\',\'6\',\'7\',\'8\',\'9\',\'10\']" aria-labelledby="default-rating"></span><p class="help-block" ng-show="editForm.potential.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="6">Maximum value validation error</p><p class="help-block" ng-show="editForm.potential.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="1">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.accountManager.$invalid, \'has-success\' : editForm.accountManager.$valid && editForm.accountManager.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.accountManager.label" for="field_accountManager">AccountManager</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'accountManager\' == mappedBy" class="form-control input-sm" id="field_accountManager" name="accountManager" ng-model="relation.accountManager" ng-options="accountManager as $root.displayFields([accountManager.lastName, accountManager.firstName]) for accountManager in accountManagerList track by accountManager.id"><option value=""></option></select></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.clientOf.$invalid, \'has-success\' : editForm.clientOf.$valid && editForm.clientOf.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.clientOf.label" for="field_clientOf">ClientOf</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'clientOf\' == mappedBy" class="form-control input-sm" id="field_clientOf" name="clientOf" ng-model="relation.clientOf" ng-options="\'ClientOf.\' + clientOf | translate for clientOf in clientOfList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.sortOrder.$invalid, \'has-success\' : editForm.sortOrder.$valid && editForm.sortOrder.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.sortOrder.label" for="field_sortOrder">SortOrder</label><div class="col-xs-12 col-sm-8"><input type="number" class="form-control input-sm" name="sortOrder" id="field_sortOrder" ng-model="relation.sortOrder" ng-min="0" placeholder="{{\'relation.dialog.sortOrder.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.sortOrder.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.relationSource.$invalid, \'has-success\' : editForm.relationSource.$valid && editForm.relationSource.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.relationSource.label" for="field_relationSource">RelationSource</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'relationSource\' == mappedBy" class="form-control input-sm" id="field_relationSource" name="relationSource" ng-model="relation.relationSource" ng-options="\'RelationSource.\' + relationSource | translate for relationSource in relationSourceList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><!-- start panel container --><div class="panel bold"><div class="panel-heading" translate="relation.dialog.drivingPurpose.label">relation.dialog.drivingPurpose.label</div><div class="panel-body"><div class="row"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><textarea rows="3" class="form-control input-sm" name="drivingPurpose" id="field_drivingPurpose" ng-model="relation.drivingPurpose" autofocus placeholder="{{\'relation.dialog.drivingPurpose.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t\t</textarea></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.extraInformation.label">relation.dialog.extraInformation.label</div><div class="panel-body"><div class="row"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><textarea rows="3" class="form-control input-sm" name="extraInformation" id="field_extraInformation" ng-model="relation.extraInformation" autofocus placeholder="{{\'relation.dialog.extraInformation.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t\t</textarea></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.email.$invalid, \'has-success\' : editForm.email.$valid && editForm.email.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.email.label" for="field_email">Email</label><div class="col-xs-12 col-sm-8"><input type="email" class="form-control input-sm" name="email" id="field_email" ng-model="relation.email" placeholder="{{\'relation.dialog.email.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.gender.$invalid, \'has-success\' : editForm.gender.$valid && editForm.gender.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.gender.label" for="field_gender">Gender</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'gender\' == mappedBy" class="form-control input-sm" id="field_gender" name="gender" ng-model="relation.gender" ng-options="\'Gender.\' + gender | translate for gender in genderList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.telephone.$invalid, \'has-success\' : editForm.telephone.$valid && editForm.telephone.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.telephone.label" for="field_telephone">Telephone</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="telephone" id="field_telephone" ng-model="relation.telephone" placeholder="{{\'relation.dialog.telephone.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.birthDate.$invalid, \'has-success\' : editForm.birthDate.$valid && editForm.birthDate.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.birthDate.label" for="field_birthDate">BirthDate</label><div class="col-xs-12 col-sm-8"><input datepicker-localdate type="date" class="form-control input-sm" name="birthDate" id="field_birthDate" ng-model="relation.birthDate"></div></div></div><!-- close column--></div><div class="row"><!--row #9--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.mobile.$invalid, \'has-success\' : editForm.mobile.$valid && editForm.mobile.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.mobile.label" for="field_mobile">Mobile</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="mobile" id="field_mobile" ng-model="relation.mobile" placeholder="{{\'relation.dialog.mobile.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.knafLicenseNumber.$invalid, \'has-success\' : editForm.knafLicenseNumber.$valid && editForm.knafLicenseNumber.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.knafLicenseNumber.label" for="field_knafLicenseNumber">KnafLicenseNumber</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="knafLicenseNumber" id="field_knafLicenseNumber" ng-model="relation.knafLicenseNumber" placeholder="{{\'relation.dialog.knafLicenseNumber.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row"><!--row #10--><div class="col-xs-12 col-sm-6"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.businessAddress.label">relation.dialog.businessAddress.label</div><div class="panel-body"><div class="row"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessStreet.$invalid, \'has-success\' : editForm.businessStreet.$valid && editForm.businessStreet.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessStreet.label" for="field_businessStreet">BusinessStreet</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="businessStreet" id="field_businessStreet" ng-model="relation.businessStreet" placeholder="{{\'relation.dialog.businessStreet.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessZip.$invalid, \'has-success\' : editForm.businessZip.$valid && editForm.businessZip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessZip.label" for="field_businessZip">BusinessZip</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="businessZip" id="field_businessZip" ng-model="relation.businessZip" placeholder="{{\'relation.dialog.businessZip.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessCity.$invalid, \'has-success\' : editForm.businessCity.$valid && editForm.businessCity.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessCity.label" for="field_businessCity">BusinessCity</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="businessCity" id="field_businessCity" ng-model="relation.businessCity" placeholder="{{\'relation.dialog.businessCity.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessCountry.$invalid, \'has-success\' : editForm.businessCountry.$valid && editForm.businessCountry.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessCountry.label" for="field_businessCountry">BusinessCountry</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'businessCountry\' == mappedBy" class="form-control input-sm" id="field_businessCountry" name="businessCountry" ng-model="relation.businessCountry" ng-options="businessCountry as businessCountry.name for businessCountry in businessCountryList track by businessCountry.id"><option value=""></option></select></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.privateAddress.label">relation.dialog.privateAddress.label</div><div class="panel-body"><div class="row"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateStreet.$invalid, \'has-success\' : editForm.privateStreet.$valid && editForm.privateStreet.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateStreet.label" for="field_privateStreet">PrivateStreet</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="privateStreet" id="field_privateStreet" ng-model="relation.privateStreet" placeholder="{{\'relation.dialog.privateStreet.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateZip.$invalid, \'has-success\' : editForm.privateZip.$valid && editForm.privateZip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateZip.label" for="field_privateZip">PrivateZip</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="privateZip" id="field_privateZip" ng-model="relation.privateZip" placeholder="{{\'relation.dialog.privateZip.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateCity.$invalid, \'has-success\' : editForm.privateCity.$valid && editForm.privateCity.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateCity.label" for="field_privateCity">PrivateCity</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="privateCity" id="field_privateCity" ng-model="relation.privateCity" placeholder="{{\'relation.dialog.privateCity.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateCountry.$invalid, \'has-success\' : editForm.privateCountry.$valid && editForm.privateCountry.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateCountry.label" for="field_privateCountry">PrivateCountry</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'privateCountry\' == mappedBy" class="form-control input-sm" id="field_privateCountry" name="privateCountry" ng-model="relation.privateCountry" ng-options="privateCountry as privateCountry.name for privateCountry in privateCountryList track by privateCountry.id"><option value=""></option></select></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row"><!--row #11--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.vatNumber.$invalid, \'has-success\' : editForm.vatNumber.$valid && editForm.vatNumber.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.vatNumber.label" for="field_vatNumber">VatNumber</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="vatNumber" id="field_vatNumber" ng-model="relation.vatNumber" ng-maxlength="14" placeholder="{{\'relation.dialog.vatNumber.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.vatNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="14">Maxlength validation error</p></div></div></div><!-- close column--></div><div class="row"><!--row #12--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.relationMailGroup.$invalid, \'has-success\' : editForm.relationMailGroup.$valid && editForm.relationMailGroup.$dirty }"><label class="col-xs-12 col-sm-2 control-label" translate="relation.dialog.relationMailGroup.label" for="field_relationMailGroup">RelationMailGroup</label><div class="col-xs-12 col-sm-10"><select ng-options="item as item.name for item in mailGroupPickListOptions" multiple="multiple" name="relationMailGroup" id="field_relationMailGroup" ng-model="selectedMailGroupList" bs-duallistbox filter="false" move-on-select="false" info-all="{0} items"></select></div></div></div><!-- close column--></div><div class="row"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.sponsor.$invalid, \'has-success\' : editForm.sponsor.$valid && editForm.sponsor.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.sponsor.label" for="field_sponsor">Sponsor</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_sponsor" ng-model="relation.sponsor" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row"><!--row #14--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartCostCenter.$invalid, \'has-success\' : editForm.snelstartCostCenter.$valid && editForm.snelstartCostCenter.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartCostCenter.label" for="field_snelstartCostCenter">SnelstartCostCenter</label><div class="col-xs-12 col-sm-8"><input type="number" class="form-control input-sm" name="snelstartCostCenter" id="field_snelstartCostCenter" ng-model="relation.snelstartCostCenter" ng-min="0" placeholder="{{\'relation.dialog.snelstartCostCenter.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.snelstartCostCenter.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row"><!--row #15--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.langKey.$invalid, \'has-success\' : editForm.langKey.$valid && editForm.langKey.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.langKey.label" for="field_langKey">LangKey</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'langKey\' == mappedBy" class="form-control input-sm" id="field_langKey" name="langKey" ng-model="relation.langKey" required ng-options="\'LangKey.\' + langKey | translate for langKey in langKeyList"><option value=""></option></select><p class="help-block" ng-show="editForm.langKey.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><!-- close column--></div><div class="row"><!--row #16--><div class="col-xs-12 col-sm-6 col-xs-offset-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.carRentalAgreementSigned.$invalid, \'has-success\' : editForm.carRentalAgreementSigned.$valid && editForm.carRentalAgreementSigned.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.carRentalAgreementSigned.label" for="field_carRentalAgreementSigned">CarRentalAgreementSigned</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_carRentalAgreementSigned" ng-model="relation.carRentalAgreementSigned" val-true="true" val-false="false" val-null="null" val-default="FALSE" class="square"></nz-toggle></div></div></div><!-- close column--></div><!-- END row in rows --></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="relation.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="relation.dialog.saveAndNew.button">Save</span></button></div></form>');
$templateCache.put('app/entities/relation/relation-edit-user.html','<!--CodeComposer:preserve:file => Don\'t override manual changes--><!--// Created by html/angular/entity/dto-edit.ftl--><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="!isEdit()" id="RelationDialogTitleCreate" translate="relation.dialog.title.create">Create a Relation</h3><h3 class="voffset" ng-show="isEdit()" id="RelationDialogTitleEdit" translate="relation.dialog.title.edit" translate-value-id="{{relation.id}}">Edit a Relation</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.snelstart.label">relation.dialog.snelstart.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.externalId.$invalid, \'has-success\' : editForm.externalId.$valid && editForm.externalId.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.externalId.label" for="field_externalId">ExternalId</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="externalId" id="field_externalId" ng-model="relation.externalId" autofocus placeholder="{{\'relation.dialog.externalId.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartSync.$invalid, \'has-success\' : editForm.snelstartSync.$valid && editForm.snelstartSync.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartSync.label" for="field_snelstartSync">SnelstartSync</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_snelstartSync" ng-model="relation.snelstartSync" val-true="true" val-false="false" val-null="null" val-default="true" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartId.$invalid, \'has-success\' : editForm.snelstartId.$valid && editForm.snelstartId.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartId.label" for="field_snelstartId">SnelstartId</label><div class="col-xs-12 col-sm-8"><input ng-disabled="true" type="text" class="form-control input-sm" name="snelstartId" id="field_snelstartId" ng-model="relation.snelstartId" placeholder="{{\'relation.dialog.snelstartId.placeholder\'|translate}}"></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.companyName.$invalid, \'has-success\' : editForm.companyName.$valid && editForm.companyName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.companyName.label" for="field_companyName">CompanyName</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="companyName" id="field_companyName" ng-model="relation.companyName" ng-maxlength="49" placeholder="{{\'relation.dialog.companyName.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.companyName.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="49">Maxlength validation error</p></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.season.$invalid, \'has-success\' : editForm.season.$valid && editForm.season.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.season.label" for="field_season">Season</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_season" ng-model="relation.season" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group" ng-class="{ \'has-error\': editForm.vip.$invalid, \'has-success\' : editForm.vip.$valid && editForm.vip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.vip.label" for="field_vip">Vip</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_vip" ng-model="relation.vip" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.firstName.$invalid, \'has-success\' : editForm.firstName.$valid && editForm.firstName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.firstName.label" for="field_firstName">FirstName</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="firstName" id="field_firstName" ng-model="relation.firstName" placeholder="{{\'relation.dialog.firstName.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.firstName.$error.firstAndLastNameLengthSumm" , translate="user.edit.firstName.validation.lengthSum" , translate-value-length="{{_validationSumOfLengths}}"></p></div></div><div class="form-group" ng-class="{ \'has-error\': editForm.lastName.$invalid, \'has-success\' : editForm.lastName.$valid && editForm.lastName.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.lastName.label" for="field_lastName">LastName</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="lastName" id="field_lastName" ng-model="relation.lastName" placeholder="{{\'relation.dialog.lastName.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.firstName.$error.firstAndLastNameLengthSumm" , translate="user.edit.firstName.validation.lengthSum" , translate-value-length="{{_validationSumOfLengths}}"></p></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.potential.$invalid, \'has-success\' : editForm.potential.$valid && editForm.potential.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.potential.label" for="field_potential">Potential</label><div class="col-xs-12 col-sm-8"><span uib-rating id="field_potential" ng-model="relation.potential" max="6" titles="[\'1\',\'2\',\'3\',\'4\',\'5\',\'6\',\'7\',\'8\',\'9\',\'10\']" aria-labelledby="default-rating"></span><p class="help-block" ng-show="editForm.potential.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="6">Maximum value validation error</p><p class="help-block" ng-show="editForm.potential.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="1">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.accountManager.$invalid, \'has-success\' : editForm.accountManager.$valid && editForm.accountManager.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.accountManager.label" for="field_accountManager">AccountManager</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'accountManager\' == mappedBy" class="form-control input-sm" id="field_accountManager" name="accountManager" ng-model="relation.selectedAccountManager" ng-options="accountManager as accountManager.displayValue for accountManager in relation.accountManagerList track by accountManager.id"><option value=""></option></select></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.clientOf.$invalid, \'has-success\' : editForm.clientOf.$valid && editForm.clientOf.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.clientOf.label" for="field_clientOf">ClientOf</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'clientOf\' == mappedBy" class="form-control input-sm" id="field_clientOf" name="clientOf" ng-model="relation.clientOf" ng-options="\'ClientOf.\' + clientOf | translate for clientOf in relation.clientOfList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.sortOrder.$invalid, \'has-success\' : editForm.sortOrder.$valid && editForm.sortOrder.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.sortOrder.label" for="field_sortOrder">SortOrder</label><div class="col-xs-12 col-sm-8"><input type="number" class="form-control input-sm" name="sortOrder" id="field_sortOrder" ng-model="relation.sortOrder" ng-min="0" placeholder="{{\'relation.dialog.sortOrder.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.sortOrder.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.relationSource.$invalid, \'has-success\' : editForm.relationSource.$valid && editForm.relationSource.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.relationSource.label" for="field_relationSource">RelationSource</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'relationSource\' == mappedBy" class="form-control input-sm" id="field_relationSource" name="relationSource" ng-model="relation.relationSource" ng-options="\'RelationSource.\' + relationSource | translate for relationSource in relation.relationSourceList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><!-- start panel container --><div class="panel bold"><div class="panel-heading" translate="relation.dialog.drivingPurpose.label">relation.dialog.drivingPurpose.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><textarea rows="3" class="form-control input-sm" name="drivingPurpose" id="field_drivingPurpose" ng-model="relation.drivingPurpose" autofocus placeholder="{{\'relation.dialog.drivingPurpose.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t\t\t</textarea></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.extraInformation.label">relation.dialog.extraInformation.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><textarea rows="3" class="form-control input-sm" name="extraInformation" id="field_extraInformation" ng-model="relation.extraInformation" autofocus placeholder="{{\'relation.dialog.extraInformation.placeholder\'|translate}}">\r\n\t\t\t\t\t\t\t\t\t</textarea></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row voffset2"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.email.$invalid, \'has-success\' : editForm.email.$valid && editForm.email.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.email.label" for="field_email">Email</label><div class="col-xs-12 col-sm-8"><input type="email" class="form-control input-sm" name="email" id="field_email" ng-model="relation.email" placeholder="{{\'relation.dialog.email.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.gender.$invalid, \'has-success\' : editForm.gender.$valid && editForm.gender.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.gender.label" for="field_gender">Gender</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'gender\' == mappedBy" class="form-control input-sm" id="field_gender" name="gender" ng-model="relation.gender" ng-options="\'Gender.\' + gender | translate for gender in relation.genderList"><option value=""></option></select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.telephone.$invalid, \'has-success\' : editForm.telephone.$valid && editForm.telephone.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.telephone.label" for="field_telephone">Telephone</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="telephone" id="field_telephone" ng-model="relation.telephone" placeholder="{{\'relation.dialog.telephone.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.birthDate.$invalid, \'has-success\' : editForm.birthDate.$valid && editForm.birthDate.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.birthDate.label" for="field_birthDate">BirthDate</label><div class="col-xs-12 col-sm-8"><input datepicker-localdate type="date" class="form-control input-sm" name="birthDate" id="field_birthDate" ng-model="relation.birthDate"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #9--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.mobile.$invalid, \'has-success\' : editForm.mobile.$valid && editForm.mobile.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.mobile.label" for="field_mobile">Mobile</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="mobile" id="field_mobile" ng-model="relation.mobile" placeholder="{{\'relation.dialog.mobile.placeholder\'|translate}}"></div></div></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><div class="form-group" ng-class="{ \'has-error\': editForm.knafLicenseNumber.$invalid, \'has-success\' : editForm.knafLicenseNumber.$valid && editForm.knafLicenseNumber.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.knafLicenseNumber.label" for="field_knafLicenseNumber">KnafLicenseNumber</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="knafLicenseNumber" id="field_knafLicenseNumber" ng-model="relation.knafLicenseNumber" placeholder="{{\'relation.dialog.knafLicenseNumber.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #10--><div class="col-xs-12 col-sm-6"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.businessAddress.label">relation.dialog.businessAddress.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessStreet.$invalid, \'has-success\' : editForm.businessStreet.$valid && editForm.businessStreet.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessStreet.label" for="field_businessStreet">BusinessStreet</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="businessStreet" id="field_businessStreet" ng-model="relation.businessStreet" placeholder="{{\'relation.dialog.businessStreet.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessZip.$invalid, \'has-success\' : editForm.businessZip.$valid && editForm.businessZip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessZip.label" for="field_businessZip">BusinessZip</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="businessZip" id="field_businessZip" ng-model="relation.businessZip" placeholder="{{\'relation.dialog.businessZip.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessCity.$invalid, \'has-success\' : editForm.businessCity.$valid && editForm.businessCity.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessCity.label" for="field_businessCity">BusinessCity</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="businessCity" id="field_businessCity" ng-model="relation.businessCity" placeholder="{{\'relation.dialog.businessCity.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.businessCountry.$invalid, \'has-success\' : editForm.businessCountry.$valid && editForm.businessCountry.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.businessCountry.label" for="field_businessCountry">BusinessCountry</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'businessCountry\' == mappedBy" class="form-control input-sm" id="field_businessCountry" name="businessCountry" ng-model="relation.selectedBusinessCountry" ng-options="businessCountry as businessCountry.displayValue for businessCountry in relation.businessCountryList track by businessCountry.id"><option value=""></option></select></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.privateAddress.label">relation.dialog.privateAddress.label</div><div class="panel-body"><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateStreet.$invalid, \'has-success\' : editForm.privateStreet.$valid && editForm.privateStreet.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateStreet.label" for="field_privateStreet">PrivateStreet</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="privateStreet" id="field_privateStreet" ng-model="relation.privateStreet" placeholder="{{\'relation.dialog.privateStreet.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateZip.$invalid, \'has-success\' : editForm.privateZip.$valid && editForm.privateZip.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateZip.label" for="field_privateZip">PrivateZip</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="privateZip" id="field_privateZip" ng-model="relation.privateZip" placeholder="{{\'relation.dialog.privateZip.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateCity.$invalid, \'has-success\' : editForm.privateCity.$valid && editForm.privateCity.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateCity.label" for="field_privateCity">PrivateCity</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="privateCity" id="field_privateCity" ng-model="relation.privateCity" placeholder="{{\'relation.dialog.privateCity.placeholder\'|translate}}"></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.privateCountry.$invalid, \'has-success\' : editForm.privateCountry.$valid && editForm.privateCountry.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.privateCountry.label" for="field_privateCountry">PrivateCountry</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'privateCountry\' == mappedBy" class="form-control input-sm" id="field_privateCountry" name="privateCountry" ng-model="relation.selectedPrivateCountry" ng-options="privateCountry as privateCountry.displayValue for privateCountry in relation.privateCountryList track by privateCountry.id"><option value=""></option></select></div></div></div><!-- close column--></div><!-- END row in rows --></div></div><!-- close panel container --></div><!-- close column--></div><div class="row voffset2"><!--row #11--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.vatNumber.$invalid, \'has-success\' : editForm.vatNumber.$valid && editForm.vatNumber.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.vatNumber.label" for="field_vatNumber">VatNumber</label><div class="col-xs-12 col-sm-8"><input type="text" class="form-control input-sm" name="vatNumber" id="field_vatNumber" ng-model="relation.vatNumber" ng-maxlength="14" placeholder="{{\'relation.dialog.vatNumber.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.vatNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="14">Maxlength validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #12--><div class="col-xs-12 col-sm-12"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.relationMailGroup.$invalid, \'has-success\' : editForm.relationMailGroup.$valid && editForm.relationMailGroup.$dirty }"><label class="col-xs-12 col-sm-2 control-label" translate="relation.dialog.relationMailGroup.label" for="field_relationMailGroup">RelationMailGroup</label><div class="col-xs-12 col-sm-10"><ui-select multiple="multiple" ng-model="relation.selectedMailGroupList" id="field_relationMailGroup" ng-disabled="disabled" title="Choose a mailGroup"><ui-select-match placeholder="{{ \'relation.dialog.relationMailGroup.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="mailGroup in relation.mailGroupList | propsFilter: {displayValue: $select.search}"><small>{{mailGroup.displayValue}}</small></ui-select-choices></ui-select></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.sponsor.$invalid, \'has-success\' : editForm.sponsor.$valid && editForm.sponsor.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.sponsor.label" for="field_sponsor">Sponsor</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_sponsor" ng-model="relation.sponsor" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #14--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.snelstartCostCenter.$invalid, \'has-success\' : editForm.snelstartCostCenter.$valid && editForm.snelstartCostCenter.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.snelstartCostCenter.label" for="field_snelstartCostCenter">SnelstartCostCenter</label><div class="col-xs-12 col-sm-8"><input type="number" class="form-control input-sm" name="snelstartCostCenter" id="field_snelstartCostCenter" ng-model="relation.snelstartCostCenter" ng-min="0" placeholder="{{\'relation.dialog.snelstartCostCenter.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.snelstartCostCenter.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #15--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.langKey.$invalid, \'has-success\' : editForm.langKey.$valid && editForm.langKey.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.langKey.label" for="field_langKey">LangKey</label><div class="col-xs-12 col-sm-8"><select ng-disabled="\'langKey\' == mappedBy" class="form-control input-sm" id="field_langKey" name="langKey" ng-model="relation.langKey" required ng-options="\'LangKey.\' + langKey | translate for langKey in relation.langKeyList"><option value=""></option></select><p class="help-block" ng-show="editForm.langKey.$error.required" translate="entity.validation.required">This field is required</p></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.carRentalAgreementSigned.$invalid, \'has-success\' : editForm.carRentalAgreementSigned.$valid && editForm.carRentalAgreementSigned.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.carRentalAgreementSigned.label" for="field_carRentalAgreementSigned">CarRentalAgreementSigned</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_carRentalAgreementSigned" ng-model="relation.carRentalAgreementSigned" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><div class="form-group" ng-class="{ \'has-error\': editForm.indemnificationSigned.$invalid, \'has-success\' : editForm.indemnificationSigned.$valid && editForm.indemnificationSigned.$dirty }"><label class="col-xs-12 col-sm-4 control-label" translate="relation.dialog.indemnificationSigned.label" for="field_indemnificationSigned">indemnificationSigned</label><div class="col-xs-12 col-sm-8"><nz-toggle id="field_indemnificationSigned" ng-model="relation.indemnificationSigned" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div></div><!-- close column--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="relation.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="relation.dialog.saveAndNew.button">Save</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/relation/relation-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="relation.overview.title">Relations</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createRelationButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="relation.overview.button.new">Create a new Relation</span></button> <button type="button" id="updateSelectedRelationButton" class="btn btn-success" ng-disabled="selectedRelationList.length == 0" ng-click="multipleUpdate()"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteRelationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="relation.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relation.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Relation</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteRelation" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="RelationSearchOverview.predicate" ascending="RelationSearchOverview.ascending" callback="search()"><th style="width:20px"><tri-state-checkbox class="toggle-all" items="relationList" top-level-click="toggleSelection" child-click="childClick"></tri-state-checkbox></th><th jh-sort-by="externalId" class="sortable"><span class="pull-left" translate="relation.overview.results.header.externalId.label">externalId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="companyName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.companyName.label">companyName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'companyName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="firstName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.firstName.label">firstName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'firstName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.lastName.label">lastName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="email" class="sortable"><span class="pull-left" translate="relation.overview.results.header.email.label">email</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'email\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="telephone" class="sortable"><span class="pull-left" translate="relation.overview.results.header.telephone.label">telephone</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'telephone\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="mobile" class="sortable"><span class="pull-left" translate="relation.overview.results.header.mobile.label">mobile</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'mobile\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="accountManager.lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.accountManager.label">accountManager</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'accountManager.lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="carRentalAgreementSigned" class="sortable"><span class="pull-left" translate="relation.overview.results.header.carRentalAgreementSigned.label">carRentalAgreementSigned</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'carRentalAgreementSigned\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="indemnificationSigned" class="sortable"><span class="pull-left" translate="relation.overview.results.header.indemnificationSigned.label">indemnificationSigned</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'indemnificationSigned\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="sortOrder" class="sortable hidden-xs"><span class="pull-left" translate="relation.overview.results.header.sortOrder.label">sortOrder</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'sortOrder\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartCostCenter" class="sortable hidden-xs"><span class="pull-left" translate="relation.overview.results.header.snelstartCostCenter.label">snelstartCostCenter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartCostCenter\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td></td><td><!-- column #0--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.externalId.placeholder\' | translate}}" name="externalId" ng-model="RelationSearchOverview.externalId" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #1--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.companyName.placeholder\' | translate}}" name="companyName" ng-model="RelationSearchOverview.companyName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.firstName.placeholder\' | translate}}" name="firstName" ng-model="RelationSearchOverview.firstName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #3--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.lastName.placeholder\' | translate}}" name="lastName" ng-model="RelationSearchOverview.lastName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #4--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.email.placeholder\' | translate}}" name="email" ng-model="RelationSearchOverview.email" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #5--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.telephone.placeholder\' | translate}}" name="telephone" ng-model="RelationSearchOverview.telephone" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #6--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.mobile.placeholder\' | translate}}" name="mobile" ng-model="RelationSearchOverview.mobile" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #7--><select id="accountManager_select" class="form-control input-sm" ng-options="accountManager as accountManager.displayValue for accountManager in accountManagerReferenceFilterList track by accountManager.id" ng-model="RelationSearchOverview.accountManager" tabindex="0" ng-change="search()"><option value="" translate="relation.overview.search.accountManager.defaultOption">All Users</option></select></td><td><!-- column #8--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchOverview.carRentalAgreementSignedGroup" class="square"></nz-toggle></td><td><!-- column #9--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchOverview.indemnificationSignedGroup" class="square"></nz-toggle></td><td class="hidden-xs"><!-- column #10--></td><td class="hidden-xs"><!-- column #11--></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isRelationSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="relation in relationList"><td class="td-checkbox"><input type="checkbox" ng-model="relation.isSelected" ng-click="selectionChanged(relation)"></td><td id="relation.externalIdId{{$index}}">{{relation.externalId}}</td><td id="relation.companyNameId{{$index}}">{{relation.companyName}}</td><td id="relation.firstNameId{{$index}}">{{relation.firstName}}</td><td id="relation.lastNameId{{$index}}">{{relation.lastName}}</td><td id="relation.emailId{{$index}}">{{relation.email}}</td><td id="relation.telephoneId{{$index}}">{{relation.telephone}}</td><td id="relation.mobileId{{$index}}">{{relation.mobile}}</td><td><span>{{relation.accountManagerDisplayValue}}</span></td><td id="relation.carRentalAgreementSignedId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.carRentalAgreementSigned)"><span ng-show="relation.carRentalAgreementSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.carRentalAgreementSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="relation.indemnificationSignedId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.indemnificationSigned)"><span ng-show="relation.indemnificationSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.indemnificationSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td class="hidden-xs" id="relation.sortOrderId{{$index}}">{{relation.sortOrder}}</td><td class="hidden-xs" id="relation.snelstartCostCenterId{{$index}}">{{relation.snelstartCostCenter}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Relation{{$index}}" type="submit" ui-sref="user-relation.detail({relationId:relation.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Relation{{$index}}" type="submit" ui-sref="user-relation.edit({relationId:relation.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteRelation{{$index}}" type="submit" ng-click="singleDelete(relation.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="RelationSearchOverview.page" ng-change="search()"></ul></div><div class="col-xs-12 col-md-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/relation/relation-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createRelationButton" class="btn btn-primary" ng-click="goToNewState()" ng-if="showCreateButtonTab"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="relation.overview.button.new">Create a new Relation</span></button> <button type="button" id="updateSelectedRelationButton" class="btn btn-success" ng-disabled="selectedRelationList.length == 0" ng-click="multipleUpdate()"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteRelationConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="relation.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relation.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Relation</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteRelation" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="RelationSearchTab.predicate" ascending="RelationSearchTab.ascending" callback="search()"><th style="width:20px" ng-if="showCreateButtonTab"><tri-state-checkbox class="toggle-all" items="relationList" top-level-click="toggleSelection" child-click="childClick"></tri-state-checkbox></th><th jh-sort-by="externalId" class="sortable"><span class="pull-left" translate="relation.overview.results.header.externalId.label">externalId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="companyName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.companyName.label">companyName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'companyName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="firstName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.firstName.label">firstName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'firstName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.lastName.label">lastName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="email" class="sortable"><span class="pull-left" translate="relation.overview.results.header.email.label">email</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'email\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="telephone" class="sortable"><span class="pull-left" translate="relation.overview.results.header.telephone.label">telephone</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'telephone\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="mobile" class="sortable"><span class="pull-left" translate="relation.overview.results.header.mobile.label">mobile</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'mobile\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'accountManager\'" jh-sort-by="accountManager.lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.accountManager.label">accountManager</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'accountManager.lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="carRentalAgreementSigned" class="sortable"><span class="pull-left" translate="relation.overview.results.header.carRentalAgreementSigned.label">carRentalAgreementSigned</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'carRentalAgreementSigned\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="indemnificationSigned" class="sortable"><span class="pull-left" translate="relation.overview.results.header.indemnificationSigned.label">indemnificationSigned</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'indemnificationSigned\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="sortOrder" class="sortable hidden-xs"><span class="pull-left" translate="relation.overview.results.header.sortOrder.label">sortOrder</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'sortOrder\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartCostCenter" class="sortable hidden-xs"><span class="pull-left" translate="relation.overview.results.header.snelstartCostCenter.label">snelstartCostCenter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartCostCenter\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td ng-if="showCreateButtonTab"></td><td><!-- column #0--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.externalId.placeholder\' | translate}}" name="externalId" ng-model="RelationSearchTab.externalId" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #1--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.companyName.placeholder\' | translate}}" name="companyName" ng-model="RelationSearchTab.companyName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.firstName.placeholder\' | translate}}" name="firstName" ng-model="RelationSearchTab.firstName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #3--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.lastName.placeholder\' | translate}}" name="lastName" ng-model="RelationSearchTab.lastName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #4--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.email.placeholder\' | translate}}" name="email" ng-model="RelationSearchTab.email" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #5--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.telephone.placeholder\' | translate}}" name="telephone" ng-model="RelationSearchTab.telephone" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #6--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.mobile.placeholder\' | translate}}" name="mobile" ng-model="RelationSearchTab.mobile" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td ng-hide="mappedBy == \'accountManager\'"><!-- column #7--><select id="accountManager_select" class="form-control input-sm" ng-options="accountManager as accountManager.displayValue for accountManager in accountManagerReferenceFilterList track by accountManager.id" ng-model="RelationSearchTab.accountManager" tabindex="0" ng-change="search()"><option value="" translate="relation.overview.search.accountManager.defaultOption">All Users</option></select></td><td><!-- column #8--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchTab.carRentalAgreementSignedGroup" class="square"></nz-toggle></td><td><!-- column #9--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchTab.indemnificationSignedGroup" class="square"></nz-toggle></td><td class="hidden-xs"><!-- column #10--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'relation.overview.search.sortOrder.placeholder.from\' | translate}}" class="form-control" name="sortOrderFrom" ng-model="RelationSearchTab.sortOrderFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'relation.overview.search.sortOrder.placeholder.to\' | translate}}" class="form-control" name="tosortOrder" ng-model="RelationSearchTab.sortOrderTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #11--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'relation.overview.search.snelstartCostCenter.placeholder.from\' | translate}}" class="form-control" name="snelstartCostCenterFrom" ng-model="RelationSearchTab.snelstartCostCenterFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'relation.overview.search.snelstartCostCenter.placeholder.to\' | translate}}" class="form-control" name="tosnelstartCostCenter" ng-model="RelationSearchTab.snelstartCostCenterTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isRelationSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="relation in relationList"><td class="td-checkbox" ng-if="showCreateButtonTab"><input type="checkbox" ng-model="relation.isSelected" ng-click="selectionChanged(relation)"></td><td id="relation.externalIdId{{$index}}">{{relation.externalId}}</td><td id="relation.companyNameId{{$index}}">{{relation.companyName}}</td><td id="relation.firstNameId{{$index}}">{{relation.firstName}}</td><td id="relation.lastNameId{{$index}}">{{relation.lastName}}</td><td id="relation.emailId{{$index}}">{{relation.email}}</td><td id="relation.telephoneId{{$index}}">{{relation.telephone}}</td><td id="relation.mobileId{{$index}}">{{relation.mobile}}</td><td ng-hide="mappedBy == \'accountManager\'"><span>{{relation.accountManagerDisplayValue}}</span></td><td id="relation.carRentalAgreementSignedId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.carRentalAgreementSigned)"><span ng-show="relation.carRentalAgreementSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.carRentalAgreementSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="relation.indemnificationSignedId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.indemnificationSigned)"><span ng-show="relation.indemnificationSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.indemnificationSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td class="hidden-xs" id="relation.sortOrderId{{$index}}">{{relation.sortOrder}}</td><td class="hidden-xs" id="relation.snelstartCostCenterId{{$index}}">{{relation.snelstartCostCenter}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Relation{{$index}}" type="submit" ui-sref="user-relation.detail({relationId:relation.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Relation{{$index}}" type="submit" ui-sref="user-relation.edit({relationId:relation.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteRelation{{$index}}" type="submit" ng-click="singleDelete(relation.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="RelationSearchTab.page" ng-change="search()"></ul></div><div class="col-xs-12 col-md-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></div></div></div></div></div>');
$templateCache.put('app/entities/relation/relation-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createRelationButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="relation.overview.button.new">Create a new Relation</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteRelationConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="relation.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relation.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Relation</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteRelation" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="RelationSearchTab.predicate" ascending="RelationSearchTab.ascending" callback="search()"><th jh-sort-by="externalId" class="sortable"><span class="pull-left" translate="relation.overview.results.header.externalId.label">externalId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="companyName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.companyName.label">companyName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'companyName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="firstName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.firstName.label">firstName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'firstName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.lastName.label">lastName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="email" class="sortable"><span class="pull-left" translate="relation.overview.results.header.email.label">email</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'email\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="telephone" class="sortable"><span class="pull-left" translate="relation.overview.results.header.telephone.label">telephone</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'telephone\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="mobile" class="sortable"><span class="pull-left" translate="relation.overview.results.header.mobile.label">mobile</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'mobile\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'accountManager\'" jh-sort-by="accountManager.lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.accountManager.label">accountManager</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'accountManager.lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="birthDate" class="sortable"><span class="pull-left" translate="relation.overview.results.header.birthDate.label">birthDate</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'birthDate\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="knafLicenseNumber" class="sortable"><span class="pull-left" translate="relation.overview.results.header.knafLicenseNumber.label">knafLicenseNumber</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'knafLicenseNumber\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="season" class="sortable"><span class="pull-left" translate="relation.overview.results.header.season.label">season</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'season\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="sponsor" class="sortable"><span class="pull-left" translate="relation.overview.results.header.sponsor.label">sponsor</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'sponsor\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="vip" class="sortable"><span class="pull-left" translate="relation.overview.results.header.vip.label">vip</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'vip\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="businessStreet" class="sortable"><span class="pull-left" translate="relation.overview.results.header.businessStreet.label">businessStreet</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'businessStreet\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="businessZip" class="sortable"><span class="pull-left" translate="relation.overview.results.header.businessZip.label">businessZip</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'businessZip\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="businessCity" class="sortable"><span class="pull-left" translate="relation.overview.results.header.businessCity.label">businessCity</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'businessCity\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'businessCountry\'" jh-sort-by="businessCountry.name" class="sortable"><span class="pull-left" translate="relation.overview.results.header.businessCountry.label">businessCountry</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'businessCountry.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="privateStreet" class="sortable"><span class="pull-left" translate="relation.overview.results.header.privateStreet.label">privateStreet</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'privateStreet\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="privateZip" class="sortable"><span class="pull-left" translate="relation.overview.results.header.privateZip.label">privateZip</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'privateZip\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="privateCity" class="sortable"><span class="pull-left" translate="relation.overview.results.header.privateCity.label">privateCity</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'privateCity\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'privateCountry\'" jh-sort-by="privateCountry.name" class="sortable"><span class="pull-left" translate="relation.overview.results.header.privateCountry.label">privateCountry</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'privateCountry.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="drivingPurpose" class="sortable"><span class="pull-left" translate="relation.overview.results.header.drivingPurpose.label">drivingPurpose</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'drivingPurpose\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="extraInformation" class="sortable"><span class="pull-left" translate="relation.overview.results.header.extraInformation.label">extraInformation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'extraInformation\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="type" class="sortable"><span translate="relation.overview.results.header.type.label">type</span> <span class="glyphicon {{getSortIcon(\'type\')}}"></span></th><th ng-hide="mappedBy == \'companyType\'" jh-sort-by="companyType.name" class="sortable"><span class="pull-left" translate="relation.overview.results.header.companyType.label">companyType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'companyType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="relationSource" class="sortable"><span translate="relation.overview.results.header.relationSource.label">relationSource</span> <span class="glyphicon {{getSortIcon(\'relationSource\')}}"></span></th><th jh-sort-by="gender" class="sortable"><span translate="relation.overview.results.header.gender.label">gender</span> <span class="glyphicon {{getSortIcon(\'gender\')}}"></span></th><th jh-sort-by="potential" class="sortable"><span class="pull-left" translate="relation.overview.results.header.potential.label">potential</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'potential\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="clientOf" class="sortable"><span translate="relation.overview.results.header.clientOf.label">clientOf</span> <span class="glyphicon {{getSortIcon(\'clientOf\')}}"></span></th><th jh-sort-by="langKey" class="sortable"><span translate="relation.overview.results.header.langKey.label">langKey</span> <span class="glyphicon {{getSortIcon(\'langKey\')}}"></span></th><th jh-sort-by="carRentalAgreementSigned" class="sortable"><span class="pull-left" translate="relation.overview.results.header.carRentalAgreementSigned.label">carRentalAgreementSigned</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'carRentalAgreementSigned\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="indemnificationSigned" class="sortable"><span class="pull-left" translate="relation.overview.results.header.indemnificationSigned.label">indemnificationSigned</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'indemnificationSigned\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td><!-- column #0--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.externalId.placeholder\' | translate}}" name="externalId" ng-model="RelationSearchTab.externalId" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #1--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.companyName.placeholder\' | translate}}" name="companyName" ng-model="RelationSearchTab.companyName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.firstName.placeholder\' | translate}}" name="firstName" ng-model="RelationSearchTab.firstName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #3--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.lastName.placeholder\' | translate}}" name="lastName" ng-model="RelationSearchTab.lastName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #4--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.email.placeholder\' | translate}}" name="email" ng-model="RelationSearchTab.email" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #5--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.telephone.placeholder\' | translate}}" name="telephone" ng-model="RelationSearchTab.telephone" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #6--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.mobile.placeholder\' | translate}}" name="mobile" ng-model="RelationSearchTab.mobile" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td ng-hide="mappedBy == \'accountManager\'"><!-- column #7--><select id="accountManager_select" class="form-control input-sm" ng-options="accountManager as $root.displayFields([accountManager.lastName, accountManager.firstName]) for accountManager in accountManagerReferenceFilterList track by accountManager.id" ng-model="RelationSearchTab.accountManager" tabindex="0" ng-change="search()"><option value="" translate="relation.overview.search.accountManager.defaultOption">All Users</option></select></td><td><!-- column #8--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.from.label">from</span> <input tabindex="0" class="form-control" name="frombirthDate" ng-model="RelationSearchTab.birthDateFrom" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon input-group-addon-date" translate="entity.search.to.label">to</span> <input tabindex="0" class="form-control" name="tobirthDate" ng-model="RelationSearchTab.birthDateTo" type="date" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td><!-- column #9--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.knafLicenseNumber.placeholder\' | translate}}" name="knafLicenseNumber" ng-model="RelationSearchTab.knafLicenseNumber" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #10--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchTab.seasonGroup" class="square"></nz-toggle></td><td><!-- column #11--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchTab.sponsorGroup" class="square"></nz-toggle></td><td><!-- column #12--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchTab.vipGroup" class="square"></nz-toggle></td><td><!-- column #13--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.businessStreet.placeholder\' | translate}}" name="businessStreet" ng-model="RelationSearchTab.businessStreet" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #14--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.businessZip.placeholder\' | translate}}" name="businessZip" ng-model="RelationSearchTab.businessZip" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #15--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.businessCity.placeholder\' | translate}}" name="businessCity" ng-model="RelationSearchTab.businessCity" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td ng-hide="mappedBy == \'businessCountry\'"><!-- column #16--><ui-select multiple="multiple" ng-model="RelationSearchTab.businessCountryIdList" spinner-enabled="true" on-select="updateBusinessCountryUISelect($item, $model)" on-remove="updateBusinessCountryUISelect($item, $model)"><ui-select-match placeholder="{{\'relation.overview.search.businessCountry.defaultOption\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="businessCountry in businessCountryReferenceFilterList | propsFilter: {displayValue: $select.search}"><small>{{businessCountry.displayValue}}</small></ui-select-choices></ui-select></td><td><!-- column #17--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.privateStreet.placeholder\' | translate}}" name="privateStreet" ng-model="RelationSearchTab.privateStreet" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #18--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.privateZip.placeholder\' | translate}}" name="privateZip" ng-model="RelationSearchTab.privateZip" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #19--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.privateCity.placeholder\' | translate}}" name="privateCity" ng-model="RelationSearchTab.privateCity" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td ng-hide="mappedBy == \'privateCountry\'"><!-- column #20--><ui-select multiple="multiple" ng-model="RelationSearchTab.privateCountryIdList" spinner-enabled="true" on-select="updatePrivateCountryUISelect($item, $model)" on-remove="updatePrivateCountryUISelect($item, $model)"><ui-select-match placeholder="{{\'relation.overview.search.privateCountry.defaultOption\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="privateCountry in privateCountryReferenceFilterList | propsFilter: {displayValue: $select.search}"><small>{{privateCountry.displayValue}}</small></ui-select-choices></ui-select></td><td><!-- column #21--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.drivingPurpose.placeholder\' | translate}}" name="drivingPurpose" ng-model="RelationSearchTab.drivingPurpose" type="text" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #22--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.extraInformation.placeholder\' | translate}}" name="extraInformation" ng-model="RelationSearchTab.extraInformation" type="text" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td ng-hide="mappedBy == \'type\'"><!-- column #23--><select id="type_select" class="form-control input-sm" ng-model="RelationSearchTab.type" tabindex="0" ng-change="search()" ng-options="\'RelationType.\' + type | translate for type in relationTypeList"><option value="" translate="relation.overview.search.type.defaultOption">All RelationTypes</option></select></td><td ng-hide="mappedBy == \'companyType\'"><!-- column #24--><select id="companyType_select" class="form-control input-sm" ng-options="companyType as companyType.name for companyType in companyTypeReferenceFilterList track by companyType.id" ng-model="RelationSearchTab.companyType" tabindex="0" ng-change="search()"><option value="" translate="relation.overview.search.companyType.defaultOption">All CompanyTypes</option></select></td><td ng-hide="mappedBy == \'relationSource\'"><!-- column #25--><select id="relationSource_select" class="form-control input-sm" ng-model="RelationSearchTab.relationSource" tabindex="0" ng-change="search()" ng-options="\'RelationSource.\' + relationSource | translate for relationSource in relationSourceList"><option value="" translate="relation.overview.search.relationSource.defaultOption">All RelationSources</option></select></td><td ng-hide="mappedBy == \'gender\'"><!-- column #26--><select id="gender_select" class="form-control input-sm" ng-model="RelationSearchTab.gender" tabindex="0" ng-change="search()" ng-options="\'Gender.\' + gender | translate for gender in genderList"><option value="" translate="relation.overview.search.gender.defaultOption">All Genders</option></select></td><td><!-- column #27--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'relation.overview.search.potential.placeholder.from\' | translate}}" class="form-control" name="potentialFrom" ng-model="RelationSearchTab.potentialFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'relation.overview.search.potential.placeholder.to\' | translate}}" class="form-control" name="topotential" ng-model="RelationSearchTab.potentialTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td ng-hide="mappedBy == \'clientOf\'"><!-- column #28--><ui-select multiple="multiple" ng-model="RelationSearchTab.clientOfList" spinner-enabled="true" on-select="updateClientOfUISelect($item, $model)" on-remove="updateClientOfUISelect($item, $model)"><ui-select-match placeholder="{{\'relation.overview.search.clientOf.defaultOption\' | translate}}">{{\'ClientOf.\' + $item | translate}}</ui-select-match><ui-select-choices repeat="clientOf in clientOfList"><small>{{\'ClientOf.\' + clientOf | translate}}</small></ui-select-choices></ui-select></td><td ng-hide="mappedBy == \'langKey\'"><!-- column #29--><ui-select multiple="multiple" ng-model="RelationSearchTab.langKeyList" spinner-enabled="true" on-select="updateLangKeyUISelect($item, $model)" on-remove="updateLangKeyUISelect($item, $model)"><ui-select-match placeholder="{{\'relation.overview.search.langKey.defaultOption\' | translate}}">{{\'LangKey.\' + $item | translate}}</ui-select-match><ui-select-choices repeat="langKey in langKeyList"><small>{{\'LangKey.\' + langKey | translate}}</small></ui-select-choices></ui-select></td><td><!-- column #30--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchTab.carRentalAgreementSignedGroup" class="square"></nz-toggle></td><td><!-- column #31--><nz-toggle tri-toggle on-toggle="search()" ng-model="RelationSearchTab.indemnificationSignedGroup" class="square"></nz-toggle></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isRelationSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="relation in relationList"><td id="relation.externalIdId{{$index}}">{{relation.externalId}}</td><td id="relation.companyNameId{{$index}}">{{relation.companyName}}</td><td id="relation.firstNameId{{$index}}">{{relation.firstName}}</td><td id="relation.lastNameId{{$index}}">{{relation.lastName}}</td><td id="relation.emailId{{$index}}">{{relation.email}}</td><td id="relation.telephoneId{{$index}}">{{relation.telephone}}</td><td id="relation.mobileId{{$index}}">{{relation.mobile}}</td><td ng-hide="mappedBy == \'accountManager\'"><a ui-sref="user.detail({userId:relation.accountManager.id})"><span>{{$root.displayFields([relation.accountManager.lastName, relation.accountManager.firstName])}}</span></a></td><td id="relation.birthDateId{{$index}}"><span ng-hide="relation.birthDate == null">{{relation.birthDate | date:\'mediumDate\'}}</span></td><td id="relation.knafLicenseNumberId{{$index}}">{{relation.knafLicenseNumber}}</td><td id="relation.seasonId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.season)"><span ng-show="relation.season" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.season" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="relation.sponsorId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.sponsor)"><span ng-show="relation.sponsor" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.sponsor" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="relation.vipId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.vip)"><span ng-show="relation.vip" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.vip" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="relation.businessStreetId{{$index}}">{{relation.businessStreet}}</td><td id="relation.businessZipId{{$index}}">{{relation.businessZip}}</td><td id="relation.businessCityId{{$index}}">{{relation.businessCity}}</td><td ng-hide="mappedBy == \'businessCountry\'"><a ui-sref="country.detail({countryId:relation.businessCountry.id})"><span>{{relation.businessCountry.name}}</span></a></td><td id="relation.privateStreetId{{$index}}">{{relation.privateStreet}}</td><td id="relation.privateZipId{{$index}}">{{relation.privateZip}}</td><td id="relation.privateCityId{{$index}}">{{relation.privateCity}}</td><td ng-hide="mappedBy == \'privateCountry\'"><a ui-sref="country.detail({countryId:relation.privateCountry.id})"><span>{{relation.privateCountry.name}}</span></a></td><td id="relation.drivingPurposeId{{$index}}">{{relation.drivingPurpose | visibleLimitTo:250 }}</td><td id="relation.extraInformationId{{$index}}">{{relation.extraInformation | visibleLimitTo:250 }}</td><td>{{relation.type === null ? "" : \'RelationType.\' + relation.type | translate}}</td><td ng-hide="mappedBy == \'companyType\'"><a ui-sref="companytype.detail({companyTypeId:relation.companyType.id})"><span>{{relation.companyType.name}}</span></a></td><td>{{relation.relationSource === null ? "" : \'RelationSource.\' + relation.relationSource | translate}}</td><td>{{relation.gender === null ? "" : \'Gender.\' + relation.gender | translate}}</td><td id="relation.potentialId{{$index}}">{{relation.potential}}</td><td>{{relation.clientOf === null ? "" : \'ClientOf.\' + relation.clientOf | translate}}</td><td>{{relation.langKey === null ? "" : \'LangKey.\' + relation.langKey | translate}}</td><td id="relation.carRentalAgreementSignedId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.carRentalAgreementSigned)"><span ng-show="relation.carRentalAgreementSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.carRentalAgreementSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="relation.indemnificationSignedId{{$index}}"><span ng-class="$root.getActiveClassForBoolean(relation.indemnificationSigned)"><span ng-show="relation.indemnificationSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.indemnificationSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Relation{{$index}}" type="submit" ui-sref="relation.detail({relationId:relation.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Relation{{$index}}" type="submit" ng-click="goToEditState(relation)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteRelation{{$index}}" type="submit" ng-click="singleDelete(relation.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="RelationSearchTab.page" ng-change="search()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></select></div></div></div></div></div>');
$templateCache.put('app/entities/relation/relation-view-user.html','<!-- Created by html/angular/entity/dto-view.ftl --><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="RelationDetailTitle" translate="relation.detail.title">Relation</span> {{relation.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="relation.detail.creator.label">Creator:</span>&nbsp; <span>{{relation.creator}} {{relation.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="relation.updater">,&nbsp; <span translate="relation.detail.updater.label">Updater: </span>&nbsp; <span>{{relation.updater}} {{relation.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button id="btn_edit_Relation{{$index}}" type="submit" ui-sref="user-relation.edit({relationId:relation.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button><p>&nbsp;</p></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteRelationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(relation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="relation.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relation.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Relation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="row"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed layout-container"><tbody><tr><!--row #1--><td colspan="4" style="width: 100%"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.snelstart.label">relation.dialog.snelstart.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 25%"><!--column #1--><label translate="relation.detail.externalId.label">ExternalId</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.externalId}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.snelstartSync.label">SnelstartSync</label></td><td style="width: 25%"><!--column #4--> <span ng-class="$root.getActiveClassForBoolean(relation.snelstartSync)"><span ng-show="relation.snelstartSync" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.snelstartSync" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="relation.detail.snelstartId.label">SnelstartId</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.snelstartId}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="relation.detail.companyName.label">CompanyName</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.companyName}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.season.label">Season</label><label translate="relation.detail.vip.label">Vip</label></td><td style="width: 25%"><!--column #4--> <span ng-class="$root.getActiveClassForBoolean(relation.season)"><span ng-show="relation.season" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.season" class="glyphicon glyphicon-remove" aria-hidden="true"></span> </span><span ng-class="$root.getActiveClassForBoolean(relation.vip)"><span ng-show="relation.vip" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.vip" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td></tr><tr><!--row #3--><td style="width: 25%"><!--column #1--><label translate="relation.detail.firstName.label">FirstName</label><label translate="relation.detail.lastName.label">LastName</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.firstName}}</span> <span>{{relation.lastName}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.potential.label">Potential</label></td><td style="width: 25%"><!--column #4--> <span uib-rating max="6" read-only="true" ng-model="relation.potential" titles="[\'1\',\'2\',\'3\',\'4\',\'5\',\'6\',\'7\',\'8\',\'9\',\'10\']" aria-labelledby="default-rating"></span></td></tr><tr><!--row #4--><td style="width: 25%"><!--column #1--><label translate="relation.detail.accountManager.label">AccountManager</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.accountManagerDisplayValue}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.clientOf.label">ClientOf</label></td><td style="width: 25%"><!--column #4--> <span class="form-control-static">{{relation.clientOfDisplayValue === null ? "" : relation.clientOfDisplayValue | translate}}</span></td></tr><tr><!--row #5--><td style="width: 25%"><!--column #1--><label translate="relation.detail.sortOrder.label">SortOrder</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.sortOrder}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.relationSource.label">RelationSource</label></td><td style="width: 25%"><!--column #4--> <span class="form-control-static">{{relation.relationSourceDisplayValue === null ? "" : relation.relationSourceDisplayValue | translate}}</span></td></tr><tr><!--row #6--><td style="width: 25%"><!--column #1--><label translate="relation.detail.drivingPurpose.label">DrivingPurpose</label></td><td style="width: 25%"><!--column #2--><textarea ng-model="relation.drivingPurpose" disabled="disabled" class="form-control" rows="5"></textarea></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.extraInformation.label">ExtraInformation</label></td><td style="width: 25%"><!--column #4--><textarea ng-model="relation.extraInformation" disabled="disabled" class="form-control" rows="5"></textarea></td></tr><tr><!--row #7--><td colspan="4" style="width: 100%"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.personalData.label">relation.dialog.personalData.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 25%"><!--column #1--><label translate="relation.detail.email.label">Email</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.email}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.gender.label">Gender</label></td><td style="width: 25%"><!--column #4--> <span class="form-control-static">{{relation.genderDisplayValue === null ? "" : relation.genderDisplayValue | translate}}</span></td></tr><tr><!--row #2--><td style="width: 25%"><!--column #1--><label translate="relation.detail.telephone.label">Telephone</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.telephone}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.birthDate.label">BirthDate</label></td><td style="width: 25%"><!--column #4--> <span>{{relation.birthDate | nullableDate}}</span>&nbsp;</td></tr><tr><!--row #3--><td style="width: 25%"><!--column #1--><label translate="relation.detail.mobile.label">Mobile</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.mobile}}</span></td><td style="width: 25%"><!--column #3--><label translate="relation.detail.knafLicenseNumber.label">KnafLicenseNumber</label></td><td style="width: 25%"><!--column #4--> <span>{{relation.knafLicenseNumber}}</span></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><!--row #8--><td colspan="2" style="width: 50%"><!--column #1--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.businessAddress.label">relation.dialog.businessAddress.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessStreet.label">BusinessStreet</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.businessStreet}}</span></td></tr><tr><!--row #2--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessZip.label">BusinessZip</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.businessZip}}</span></td></tr><tr><!--row #3--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessCity.label">BusinessCity</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.businessCity}}</span></td></tr><tr><!--row #4--><td style="width: 50%"><!--column #1--><label translate="relation.detail.businessCountry.label">BusinessCountry</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.businessCountryDisplayValue}}</span></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td><td colspan="2" style="width: 50%"><!--column #3--><!-- start panel container --><div class="panel"><div class="panel-heading" translate="relation.dialog.privateAddress.label">relation.dialog.privateAddress.label</div><div class="panel-body"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><!--row #1--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateStreet.label">PrivateStreet</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.privateStreet}}</span></td></tr><tr><!--row #2--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateZip.label">PrivateZip</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.privateZip}}</span></td></tr><tr><!--row #3--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateCity.label">PrivateCity</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.privateCity}}</span></td></tr><tr><!--row #4--><td style="width: 50%"><!--column #1--><label translate="relation.detail.privateCountry.label">PrivateCountry</label></td><td style="width: 50%"><!--column #2--> <span>{{relation.privateCountryDisplayValue}}</span></td></tr><!-- END row in rows --></tbody></table></div></div></div><!-- close panel container --></td></tr><tr><!--row #9--><td style="width: 25%"><!--column #1--><label translate="relation.detail.sponsor.label">Sponsor</label></td><td style="width: 25%"><!--column #2--> <span ng-class="$root.getActiveClassForBoolean(relation.sponsor)"><span ng-show="relation.sponsor" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.sponsor" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #10--><td style="width: 25%"><!--column #1--><label translate="relation.detail.snelstartCostCenter.label">SnelstartCostCenter</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.snelstartCostCenter}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #11--><td style="width: 25%"><!--column #1--><label translate="relation.detail.langKey.label">LangKey</label></td><td style="width: 25%"><!--column #2--> <span class="form-control-static">{{relation.langKeyDisplayValue === null ? "" : relation.langKeyDisplayValue | translate}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #12--><td style="width: 25%"><!--column #1--><label translate="relation.detail.vatNumber.label">VatNumber</label></td><td style="width: 25%"><!--column #2--> <span>{{relation.vatNumber}}</span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #13--><td style="width: 25%"><!--column #1--><label translate="relation.detail.carRentalAgreementSigned.label">CarRentalAgreementSigned</label></td><td style="width: 25%"><!--column #2--> <span ng-class="$root.getActiveClassForBoolean(relation.carRentalAgreementSigned)"><span ng-show="relation.carRentalAgreementSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.carRentalAgreementSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #14--><td style="width: 25%"><!--column #1--><label translate="relation.detail.indemnificationSigned.label">IndemnificationSigned</label></td><td style="width: 25%"><!--column #2--> <span ng-class="$root.getActiveClassForBoolean(relation.indemnificationSigned)"><span ng-show="relation.indemnificationSigned" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-show="!relation.indemnificationSigned" class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><tr><!--row #15--><td style="width: 25%"></td><td style="width: 25%"></td><td style="width: 25%"></td><td style="width: 25%"></td></tr><!-- END row in rows --></tbody></table></div></div></div><div class="row"><div class="col-xs-12"><div><uib-tabset active="$root.relationActiveTab"><uib-tab id="tab-relationmailgroups-overview-mapped-by-relation" heading="{{\'relation.detail.tab.relationMailGroup.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><relationmailgroups-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></relationmailgroups-overview-mapped-by-relation></uib-tab><uib-tab id="tab-bookings-overview-mapped-by-client" heading="{{\'relation.detail.tab.booking.by.client\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><bookings-overview-mapped-by-client read-only="true" mapped-by-id="relationId" mapped-by="\'client\'" mapped-by-type="\'relation\'"></bookings-overview-mapped-by-client></uib-tab><uib-tab id="tab-cars-overview-mapped-by-owner" heading="{{\'relation.detail.tab.car.by.owner\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><cars-overview-mapped-by-owner read-only="true" mapped-by-id="relationId" mapped-by="\'owner\'" mapped-by-type="\'relation\'"></cars-overview-mapped-by-owner></uib-tab><uib-tab id="tab-subscriptions-overview-mapped-by-relation" heading="{{\'relation.detail.tab.subscription.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><subscriptions-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></subscriptions-overview-mapped-by-relation></uib-tab><uib-tab id="tab-documents-overview-mapped-by-relation" heading="{{\'relation.detail.tab.document.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><documents-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></documents-overview-mapped-by-relation></uib-tab><uib-tab id="tab-instructors-overview-mapped-by-relation" heading="{{\'relation.detail.tab.instructor.by.relation\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><instructors-overview-mapped-by-relation read-only="true" mapped-by-id="relationId" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></instructors-overview-mapped-by-relation></uib-tab><uib-tab id="tab-user-event-relation-contact-mapped-by-relation" heading="{{\'relation.detail.tab.eventRelationContact.by.relation\' | translate}}"><user-event-relation-contact-mapped-by-relation read-only="true" show-create-button-tab="false" mapped-by-id="relationId" mapped-by-display-value="relation.displayValue" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></user-event-relation-contact-mapped-by-relation></uib-tab><uib-tab id="tab-articlerelationprices-overview-mapped-by-relation" heading="{{\'relation.detail.tab.articleRelationPrice.by.relation\' | translate}}"><articlerelationprices-overview-mapped-by-relation read-only="true" show-create-button-tab="false" mapped-by-id="relationId" mapped-by-display-value="relation.displayValue" mapped-by="\'relation\'" mapped-by-type="\'relation\'"></articlerelationprices-overview-mapped-by-relation></uib-tab></uib-tabset></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/relation/relations.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="relation.overview.title">Relations</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createRelationButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="relation.overview.button.new">Create a new Relation</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteRelationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="relation.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relation.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Relation</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteRelation" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relation.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="RelationSearchOverview.predicate" ascending="RelationSearchOverview.ascending" callback="search()"><th jh-sort-by="externalId" class="sortable"><span class="pull-left" translate="relation.overview.results.header.externalId.label">externalId</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="companyName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.companyName.label">companyName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'companyName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="firstName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.firstName.label">firstName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'firstName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.lastName.label">lastName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="email" class="sortable"><span class="pull-left" translate="relation.overview.results.header.email.label">email</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'email\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="telephone" class="sortable"><span class="pull-left" translate="relation.overview.results.header.telephone.label">telephone</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'telephone\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="accountManager.lastName" class="sortable"><span class="pull-left" translate="relation.overview.results.header.accountManager.label">accountManager</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'accountManager.lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="sortOrder" class="sortable hidden-xs"><span class="pull-left" translate="relation.overview.results.header.sortOrder.label">sortOrder</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'sortOrder\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartCostCenter" class="sortable hidden-xs"><span class="pull-left" translate="relation.overview.results.header.snelstartCostCenter.label">snelstartCostCenter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartCostCenter\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td><!-- column #0--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.externalId.placeholder\' | translate}}" name="externalId" ng-model="RelationSearchOverview.externalId" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #1--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.companyName.placeholder\' | translate}}" name="companyName" ng-model="RelationSearchOverview.companyName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.firstName.placeholder\' | translate}}" name="firstName" ng-model="RelationSearchOverview.firstName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #3--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.lastName.placeholder\' | translate}}" name="lastName" ng-model="RelationSearchOverview.lastName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #4--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.email.placeholder\' | translate}}" name="email" ng-model="RelationSearchOverview.email" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #5--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'relation.overview.search.telephone.placeholder\' | translate}}" name="telephone" ng-model="RelationSearchOverview.telephone" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td><!-- column #6--><select id="accountManager_select" class="form-control input-sm" ng-options="accountManager as $root.displayFields([accountManager.lastName, accountManager.firstName]) for accountManager in accountManagerReferenceFilterList track by accountManager.id" ng-model="RelationSearchOverview.accountManager" tabindex="0" ng-change="search()"><option value="" translate="relation.overview.search.accountManager.defaultOption">All Users</option></select></td><td class="hidden-xs"><!-- column #7--></td><td class="hidden-xs"><!-- column #8--></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isRelationSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="relation in relationList"><td id="relation.externalIdId{{$index}}">{{relation.externalId}}</td><td id="relation.companyNameId{{$index}}">{{relation.companyName}}</td><td id="relation.firstNameId{{$index}}">{{relation.firstName}}</td><td id="relation.lastNameId{{$index}}">{{relation.lastName}}</td><td id="relation.emailId{{$index}}">{{relation.email}}</td><td id="relation.telephoneId{{$index}}">{{relation.telephone}}</td><td><a ui-sref="user.detail({userId:relation.accountManager.id})"><span>{{$root.displayFields([relation.accountManager.lastName, relation.accountManager.firstName])}}</span></a></td><td class="hidden-xs" id="relation.sortOrderId{{$index}}">{{relation.sortOrder}}</td><td class="hidden-xs" id="relation.snelstartCostCenterId{{$index}}">{{relation.snelstartCostCenter}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Relation{{$index}}" type="submit" ui-sref="relation.detail({relationId:relation.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Relation{{$index}}" type="submit" ng-click="goToEditState(relation)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteRelation{{$index}}" type="submit" ng-click="singleDelete(relation.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="RelationSearchOverview.page" ng-change="search()"></ul></div><div class="col-xs-3"><div class="pull-right text-nowrap"><span translate="entity.search.pagesize">Page size</span><select id="pageSize_select" class="form-control input-sm pagination-sm" ng-options="pageSize as pageSize for pageSize in $root.pageSizeList" ng-model="pageSize" tabindex="0" ng-change="search()"></select></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/relationmailgroup/relationmailgroup-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="RelationMailGroupDetailTitle" translate="relationMailGroup.detail.title">RelationMailGroup</span> {{relationMailGroup.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="relationMailGroup.detail.creator.label">Creator:</span>&nbsp; <span>{{relationMailGroup.creator}} {{relationMailGroup.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="relationMailGroup.updater">,&nbsp; <span translate="relationMailGroup.detail.updater.label">Updater: </span>&nbsp; <span>{{relationMailGroup.updater}} {{relationMailGroup.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="relationmailgroup.detail.edit({relationMailGroupId:relationMailGroup.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteRelationMailGroupConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(relationMailGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="relationMailGroup.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relationMailGroup.overview.results.buttons.delete.confirmation">Are you sure you want to delete this RelationMailGroup?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relationMailGroup.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relationMailGroup.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="relationMailGroup.detail.relation.label">relation</span></td><td><a ui-sref="user-relation.detail({relationId:relationMailGroup.relation.id})"><span>{{$root.displayFields([relationMailGroup.relation.externalId, relationMailGroup.relation.firstName, relationMailGroup.relation.lastName, relationMailGroup.relation.companyName])}}</span></a></td></tr><tr><td><span translate="relationMailGroup.detail.mailGroup.label">mailGroup</span></td><td><a ui-sref="mailgroup.detail({mailGroupId:relationMailGroup.mailGroup.id})"><span>{{relationMailGroup.mailGroup.name}}</span></a></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/relationmailgroup/relationmailgroup-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="RelationMailGroupDialogTitleCreate" translate="relationMailGroup.dialog.title.create">Create a RelationMailGroup</h4><h4 class="modal-title" ng-show="isEdit()" id="RelationMailGroupDialogTitleEdit" translate="relationMailGroup.dialog.title.edit" translate-value-id="{{relationMailGroup.id}}">Edit a RelationMailGroup</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="relationMailGroup.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relation.$invalid, \'has-success\' : editForm.relation.$valid && editForm.relation.$dirty }"><label for="field_relation" class="col-sm-2 control-label" translate="relationMailGroup.dialog.relation.label">relation</label><div class="col-sm-9"><input ng-disabled="\'relation\' == mappedBy" type="text" id="field_relation" name="relation" ng-model="relationMailGroup.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsForRelation" placeholder="{{\'relationMailGroup.dialog.relation.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.relation.$invalid"><p class="help-block" ng-show="editForm.relation.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new relation" ng-disabled="\'relation\' == mappedBy" ng-click="createRelation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.mailGroup.$invalid, \'has-success\' : editForm.mailGroup.$valid && editForm.mailGroup.$dirty }"><label for="field_mailGroup" class="col-sm-2 control-label" translate="relationMailGroup.dialog.mailGroup.label">mailGroup</label><div class="col-sm-9"><select ng-disabled="\'mailGroup\' == mappedBy" class="form-control input-sm" id="field_mailGroup" name="mailGroup" ng-model="relationMailGroup.mailGroup" required ng-options="mailGroup as mailGroup.name for mailGroup in mailGroupList track by mailGroup.id"><option value=""></option></select><div ng-show="editForm.mailGroup.$invalid"><p class="help-block" ng-show="editForm.mailGroup.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new mailgroup" ng-disabled="\'mailGroup\' == mappedBy" ng-click="createMailGroup()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relationMailGroup.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="relationMailGroup.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/relationmailgroup/relationmailgroup-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteRelationMailGroupConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="relationMailGroup.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relationMailGroup.overview.results.buttons.delete.confirmation">Are you sure you want to delete this RelationMailGroup</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relationMailGroup.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteRelationMailGroup" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relationMailGroup.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'relation\'" jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="relationMailGroup.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'mailGroup\'" jh-sort-by="mailGroup.name" class="sortable"><span class="pull-left" translate="relationMailGroup.overview.results.header.mailGroup.label">mailGroup</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'mailGroup.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="relationMailGroup in relationMailGroupList"><td ng-hide="mappedBy == \'relation\'"><a ui-sref="user-relation.detail({relationId:relationMailGroup.relation.id})"><span>{{$root.displayFields([relationMailGroup.relation.externalId, relationMailGroup.relation.firstName, relationMailGroup.relation.lastName, relationMailGroup.relation.companyName])}}</span></a></td><td ng-hide="mappedBy == \'mailGroup\'"><a ui-sref="mailgroup.detail({mailGroupId:relationMailGroup.mailGroup.id})"><span>{{relationMailGroup.mailGroup.name}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_RelationMailGroup{{$index}}" type="submit" ui-sref="relationmailgroup.detail({relationMailGroupId:relationMailGroup.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/relationmailgroup/relationmailgroups.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="relationMailGroup.overview.title">RelationMailGroups</h3></div><div class="panel-buttons"><button id="createRelationMailGroupButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="relationMailGroup.overview.button.new">Create a new RelationMailGroup</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteRelationMailGroupConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="relationMailGroup.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="relationMailGroup.overview.results.buttons.delete.confirmation">Are you sure you want to delete this RelationMailGroup</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="relationMailGroup.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteRelationMailGroup" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="relationMailGroup.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="relationMailGroup.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="mailGroup.name" class="sortable"><span class="pull-left" translate="relationMailGroup.overview.results.header.mailGroup.label">mailGroup</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'mailGroup.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="relationMailGroup in relationMailGroupList"><td><a ui-sref="user-relation.detail({relationId:relationMailGroup.relation.id})"><span>{{$root.displayFields([relationMailGroup.relation.externalId, relationMailGroup.relation.firstName, relationMailGroup.relation.lastName, relationMailGroup.relation.companyName])}}</span></a></td><td><a ui-sref="mailgroup.detail({mailGroupId:relationMailGroup.mailGroup.id})"><span>{{relationMailGroup.mailGroup.name}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_RelationMailGroup{{$index}}" type="submit" ui-sref="relationmailgroup.detail({relationMailGroupId:relationMailGroup.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_RelationMailGroup{{$index}}" type="submit" ng-click="goToEditState(relationMailGroup)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteRelationMailGroup{{$index}}" type="submit" ng-click="singleDelete(relationMailGroup.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfiltereventtype/salesfiltereventtype-detail.html','<div has-any-authority=""><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="SalesFilterEventTypeDetailTitle" translate="salesFilterEventType.detail.title">SalesFilterEventType</span> {{salesFilterEventType.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="salesFilterEventType.detail.creator.label">Creator:</span>&nbsp; <span>{{salesFilterEventType.creator}} {{salesFilterEventType.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="salesFilterEventType.updater">,&nbsp; <span translate="salesFilterEventType.detail.updater.label">Updater: </span>&nbsp; <span>{{salesFilterEventType.updater}} {{salesFilterEventType.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="salesfiltereventtype.detail.edit({salesFilterEventTypeId:salesFilterEventType.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteSalesFilterEventTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(salesFilterEventType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="salesFilterEventType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilterEventType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilterEventType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilterEventType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilterEventType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfiltereventtype/salesfiltereventtype-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="salesFilterEventType.overview.title">SalesFilterEventTypes</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SalesFilterEventTypeSearchOverview.predicate" ascending="SalesFilterEventTypeSearchOverview.ascending" callback="search()"><th jh-sort-by="salesFilter.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterEventType.overview.results.header.salesFilter.label">salesFilter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesFilter.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="eventType.name" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterEventType.overview.results.header.eventType.label">eventType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'eventType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td class="hidden-xs"><!-- column #0--><select id="salesFilter_select" class="form-control input-sm" ng-options="salesFilter as salesFilter.displayValue for salesFilter in salesFilterReferenceFilterList track by salesFilter.id" ng-model="SalesFilterEventTypeSearchOverview.salesFilter" tabindex="0" ng-change="search()"><option value="" translate="salesFilterEventType.overview.search.salesFilter.defaultOption">All SalesFilters</option></select></td><td class="hidden-xs"><!-- column #1--><select id="eventType_select" class="form-control input-sm" ng-options="eventType as eventType.displayValue for eventType in eventTypeReferenceFilterList track by eventType.id" ng-model="SalesFilterEventTypeSearchOverview.eventType" tabindex="0" ng-change="search()"><option value="" translate="salesFilterEventType.overview.search.eventType.defaultOption">All EventTypes</option></select></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isSalesFilterEventTypeSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="salesFilterEventType in salesFilterEventTypeList"><td class="hidden-xs"><a ui-sref="user-salesfilter.detail({salesFilterId:salesFilterEventType.salesFilterPkId})"><span>{{salesFilterEventType.salesFilterDisplayValue}}</span></a></td><td class="hidden-xs"><span>{{salesFilterEventType.eventTypeDisplayValue}}</span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="deleteSalesFilterEventType{{$index}}" type="submit" ng-click="singleDelete(salesFilterEventType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SalesFilterEventTypeSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfiltereventtype/salesfiltereventtype-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'salesFilter\'" jh-sort-by="salesFilter.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterEventType.overview.results.header.salesFilter.label">salesFilter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesFilter.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'eventType\'" jh-sort-by="eventType.name" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterEventType.overview.results.header.eventType.label">eventType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'eventType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="salesFilterEventType in salesFilterEventTypeList"><td class="hidden-xs" ng-hide="mappedBy == \'salesFilter\'"><a ui-sref="user-salesfilter.detail({salesFilterId:salesFilterEventType.salesFilterPkId})"><span>{{salesFilterEventType.salesFilterDisplayValue}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'eventType\'"><span>{{salesFilterEventType.eventTypeDisplayValue}}</span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="deleteSalesFilterEventType{{$index}}" type="submit" ng-click="singleDelete(salesFilterEventType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/salesfiltereventtype/salesfiltereventtype-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="salesFilterEventType in salesFilterEventTypeList"><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilterEventType{{$index}}" type="submit" ui-sref="salesfiltereventtype.detail({salesFilterEventTypeId:salesFilterEventType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/salesfiltereventtype/salesfiltereventtypes.html','<div id="content"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="salesFilterEventType.overview.title">SalesFilterEventTypes</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SalesFilterEventTypeSearchOverview.predicate" ascending="SalesFilterEventTypeSearchOverview.ascending" callback="search()"><th jh-sort-by="salesFilter.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterEventType.overview.results.header.salesFilter.label">salesFilter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesFilter.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="eventType.name" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterEventType.overview.results.header.eventType.label">eventType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'eventType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td class="hidden-xs"><!-- column #0--><select id="salesFilter_select" class="form-control input-sm" ng-options="salesFilter as $root.displayFields([salesFilter.firstName, salesFilter.lastName]) for salesFilter in salesFilterReferenceFilterList track by salesFilter.id" ng-model="SalesFilterEventTypeSearchOverview.salesFilter" tabindex="0" ng-change="search()"><option value="" translate="salesFilterEventType.overview.search.salesFilter.defaultOption">All SalesFilters</option></select></td><td class="hidden-xs"><!-- column #1--><select id="eventType_select" class="form-control input-sm" ng-options="eventType as eventType.name for eventType in eventTypeReferenceFilterList track by eventType.id" ng-model="SalesFilterEventTypeSearchOverview.eventType" tabindex="0" ng-change="search()"><option value="" translate="salesFilterEventType.overview.search.eventType.defaultOption">All EventTypes</option></select></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isSalesFilterEventTypeSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="salesFilterEventType in salesFilterEventTypeList"><td class="hidden-xs"><a ui-sref="salesfilter.detail({salesFilterId:salesFilterEventType.salesFilter.id})"><span>{{$root.displayFields([salesFilterEventType.salesFilter.firstName, salesFilterEventType.salesFilter.lastName])}}</span></a></td><td class="hidden-xs"><a ui-sref="eventtype.detail({eventTypeId:salesFilterEventType.eventType.id})"><span>{{salesFilterEventType.eventType.name}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilterEventType{{$index}}" type="submit" ui-sref="salesfiltereventtype.detail({salesFilterEventTypeId:salesFilterEventType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SalesFilterEventTypeSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfilter/salesfilter-detail.html','<div has-any-authority=""><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="SalesFilterDetailTitle" translate="salesFilter.detail.title">SalesFilter</span> {{salesFilter.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="salesFilter.detail.creator.label">Creator:</span>&nbsp; <span>{{salesFilter.creator}} {{salesFilter.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="salesFilter.updater">,&nbsp; <span translate="salesFilter.detail.updater.label">Updater: </span>&nbsp; <span>{{salesFilter.updater}} {{salesFilter.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="salesfilter.detail.edit({salesFilterId:salesFilter.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteSalesFilterConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(salesFilter.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="salesFilter.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilter.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilter?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="salesFilter.detail.description.label">description</span></td><td><span class="form-control-static">{{salesFilter.description}}</span></td></tr><tr><td><span translate="salesFilter.detail.firstName.label">firstName</span></td><td><span class="form-control-static">{{salesFilter.firstName}}</span></td></tr><tr><td><span translate="salesFilter.detail.lastName.label">lastName</span></td><td><span class="form-control-static">{{salesFilter.lastName}}</span></td></tr><tr><td><span translate="salesFilter.detail.potentialFrom.label">potentialFrom</span></td><td><span class="form-control-static">{{salesFilter.potentialFrom}}</span></td></tr><tr><td><span translate="salesFilter.detail.potentialTo.label">potentialTo</span></td><td><span class="form-control-static">{{salesFilter.potentialTo}}</span></td></tr><tr><td><span translate="salesFilter.detail.offsetStartDateFrom.label">offsetStartDateFrom</span></td><td><span class="form-control-static">{{salesFilter.offsetStartDateFrom}}</span></td></tr><tr><td><span translate="salesFilter.detail.offsetStartDateTo.label">offsetStartDateTo</span></td><td><span class="form-control-static">{{salesFilter.offsetStartDateTo}}</span></td></tr><tr><td><span translate="salesFilter.detail.salesStatus.label">salesStatus</span></td><td><span class="form-control-static">{{salesFilter.salesStatus === null ? "" : \'SalesStatus.\' + salesFilter.salesStatus | translate}}</span></td></tr><tr><td><span translate="salesFilter.detail.user.label">user</span></td><td><a ui-sref="user.detail({userId:salesFilter.user.id})"><span>{{$root.displayFields([salesFilter.user.lastName, salesFilter.user.firstName])}}</span></a></td></tr></tbody></table></div><div><uib-tabset active="$root.salesFilterActiveTab"></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfilter/salesfilter-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="SalesFilterDialogTitleCreate" translate="salesFilter.dialog.title.create">Create a SalesFilter</h4><h4 class="modal-title" ng-show="isEdit()" id="SalesFilterDialogTitleEdit" translate="salesFilter.dialog.title.edit" translate-value-id="{{salesFilter.id}}">Edit a SalesFilter</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="salesFilter.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="salesFilter.dialog.description.label">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="salesFilter.description" required ng-maxlength="-1" placeholder="{{\'salesFilter.dialog.description.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.firstName.$invalid, \'has-success\' : editForm.firstName.$valid && editForm.firstName.$dirty }"><label for="field_firstName" id="label_firstName" class="col-sm-2 control-label" translate="salesFilter.dialog.firstName.label">FirstName</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="firstName" id="field_firstName" ng-model="salesFilter.firstName" ng-maxlength="-1" placeholder="{{\'salesFilter.dialog.firstName.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.lastName.$invalid, \'has-success\' : editForm.lastName.$valid && editForm.lastName.$dirty }"><label for="field_lastName" id="label_lastName" class="col-sm-2 control-label" translate="salesFilter.dialog.lastName.label">LastName</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="lastName" id="field_lastName" ng-model="salesFilter.lastName" ng-maxlength="-1" placeholder="{{\'salesFilter.dialog.lastName.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.potentialFrom.$invalid, \'has-success\' : editForm.potentialFrom.$valid && editForm.potentialFrom.$dirty }"><label for="field_potentialFrom" id="label_potentialFrom" class="col-sm-2 control-label" translate="salesFilter.dialog.potentialFrom.label">PotentialFrom</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="potentialFrom" id="field_potentialFrom" ng-model="salesFilter.potentialFrom" ng-maxlength="-1" placeholder="{{\'salesFilter.dialog.potentialFrom.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.potentialTo.$invalid, \'has-success\' : editForm.potentialTo.$valid && editForm.potentialTo.$dirty }"><label for="field_potentialTo" id="label_potentialTo" class="col-sm-2 control-label" translate="salesFilter.dialog.potentialTo.label">PotentialTo</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="potentialTo" id="field_potentialTo" ng-model="salesFilter.potentialTo" ng-maxlength="-1" placeholder="{{\'salesFilter.dialog.potentialTo.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.offsetStartDateFrom.$invalid, \'has-success\' : editForm.offsetStartDateFrom.$valid && editForm.offsetStartDateFrom.$dirty }"><label for="field_offsetStartDateFrom" id="label_offsetStartDateFrom" class="col-sm-2 control-label" translate="salesFilter.dialog.offsetStartDateFrom.label">OffsetStartDateFrom</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="offsetStartDateFrom" id="field_offsetStartDateFrom" ng-model="salesFilter.offsetStartDateFrom" ng-maxlength="-1" placeholder="{{\'salesFilter.dialog.offsetStartDateFrom.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.offsetStartDateTo.$invalid, \'has-success\' : editForm.offsetStartDateTo.$valid && editForm.offsetStartDateTo.$dirty }"><label for="field_offsetStartDateTo" id="label_offsetStartDateTo" class="col-sm-2 control-label" translate="salesFilter.dialog.offsetStartDateTo.label">OffsetStartDateTo</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="offsetStartDateTo" id="field_offsetStartDateTo" ng-model="salesFilter.offsetStartDateTo" ng-maxlength="-1" placeholder="{{\'salesFilter.dialog.offsetStartDateTo.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.salesStatus.$invalid, \'has-success\' : editForm.salesStatus.$valid && editForm.salesStatus.$dirty }"><label for="field_salesStatus" class="col-sm-2 control-label" translate="salesFilter.dialog.salesStatus.label">salesStatus</label><div class="col-sm-9"><select ng-disabled="\'salesStatus\' == mappedBy" class="form-control input-sm" id="field_salesStatus" name="salesStatus" ng-model="salesFilter.salesStatus" ng-options="\'SalesStatus.\' + salesStatus | translate for salesStatus in salesStatusList"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.user.$invalid, \'has-success\' : editForm.user.$valid && editForm.user.$dirty }"><label for="field_user" class="col-sm-2 control-label" translate="salesFilter.dialog.user.label">user</label><div class="col-sm-9"><select ng-disabled="\'user\' == mappedBy" class="form-control input-sm" id="field_user" name="user" ng-model="salesFilter.user" ng-options="user as $root.displayFields([user.lastName, user.firstName]) for user in userList track by user.id"><option value=""></option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="salesFilter.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/salesfilter/salesfilter-edit-user.html','<!--// Created by html/angular/entity/dto-edit.ftl--><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="!isEdit()" id="SalesFilterDialogTitleCreate" translate="salesFilter.dialog.title.create">Create a SalesFilter</h3><h3 class="voffset" ng-show="isEdit()" id="SalesFilterDialogTitleEdit" translate="salesFilter.dialog.title.edit" translate-value-id="{{salesFilter.id}}">Edit a SalesFilter</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.description.label" for="field_description">Description</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="salesFilter.description" required autofocus placeholder="{{\'salesFilter.dialog.description.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.firstName.label" for="field_firstName">FirstName</label><label class="control-label" translate="salesFilter.dialog.lastName.label" for="field_lastName">LastName</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="firstName" id="field_firstName" ng-model="salesFilter.firstName" placeholder="{{\'salesFilter.dialog.firstName.placeholder\'|translate}}"> <input type="text" class="form-control input-sm" name="lastName" id="field_lastName" ng-model="salesFilter.lastName" placeholder="{{\'salesFilter.dialog.lastName.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.potentialFrom.label" for="field_potentialFrom">PotentialFrom</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="potentialFrom" id="field_potentialFrom" ng-model="salesFilter.potentialFrom" placeholder="{{\'salesFilter.dialog.potentialFrom.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.potentialTo.label" for="field_potentialTo">PotentialTo</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="potentialTo" id="field_potentialTo" ng-model="salesFilter.potentialTo" placeholder="{{\'salesFilter.dialog.potentialTo.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.offsetStartDateFrom.label" for="field_offsetStartDateFrom">OffsetStartDateFrom</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="offsetStartDateFrom" id="field_offsetStartDateFrom" ng-model="salesFilter.offsetStartDateFrom" placeholder="{{\'salesFilter.dialog.offsetStartDateFrom.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.offsetStartDateTo.label" for="field_offsetStartDateTo">OffsetStartDateTo</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="offsetStartDateTo" id="field_offsetStartDateTo" ng-model="salesFilter.offsetStartDateTo" placeholder="{{\'salesFilter.dialog.offsetStartDateTo.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.salesFilterEventType.label" for="field_salesFilterEventType">SalesFilterEventType</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><ui-select multiple="multiple" ng-model="salesFilter.selectedEventTypeList" id="field_salesFilterEventType" ng-disabled="disabled" title="Choose a eventType"><ui-select-match placeholder="{{ \'salesFilter.dialog.salesFilterEventType.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="eventType in salesFilter.eventTypeList | propsFilter: {displayValue: $select.search}"><small>{{eventType.displayValue}}</small></ui-select-choices></ui-select></div><!-- close column--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.salesFilterTemplateEvent.label" for="field_salesFilterTemplateEvent">SalesFilterTemplateEvent</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><ui-select multiple="multiple" ng-model="salesFilter.selectedTemplateEventList" id="field_salesFilterTemplateEvent" ng-disabled="disabled" title="Choose a templateEvent"><ui-select-match placeholder="{{ \'salesFilter.dialog.salesFilterTemplateEvent.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent in salesFilter.templateEventList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></div><!-- close column--></div><div class="row voffset2"><!--row #9--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.salesStatus.label" for="field_salesStatus">SalesStatus</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><select ng-disabled="\'salesStatus\' == mappedBy" class="form-control input-sm" id="field_salesStatus" name="salesStatus" ng-model="salesFilter.salesStatus" ng-options="\'SalesStatus.\' + salesStatus | translate for salesStatus in salesFilter.salesStatusList"><option value=""></option></select></div><!-- close column--></div><div class="row voffset2"><!--row #10--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.user.label" for="field_user">User</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><select ng-disabled="\'user\' == mappedBy" class="form-control input-sm" id="field_user" name="user" ng-model="salesFilter.selectedUser" ng-options="user as user.displayValue for user in salesFilter.userList track by user.id"><option value=""></option></select></div><!-- close column--></div><div class="row voffset2"><!--row #11--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.pagingPage.label" for="field_pagingPage">PagingPage</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="pagingPage" id="field_pagingPage" ng-model="salesFilter.pagingPage" placeholder="{{\'salesFilter.dialog.pagingPage.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #12--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="salesFilter.dialog.pagingSize.label" for="field_pagingSize">PagingSize</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" class="form-control input-sm" name="pagingSize" id="field_pagingSize" ng-model="salesFilter.pagingSize" placeholder="{{\'salesFilter.dialog.pagingSize.placeholder\'|translate}}"></div><!-- close column--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="salesFilter.dialog.update.button">Save</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/salesfilter/salesfilter-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="salesFilter.overview.title">SalesFilters</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createSalesFilterButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="salesFilter.overview.button.new">Create a new SalesFilter</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteSalesFilterConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="salesFilter.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilter.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilter</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteSalesFilter" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SalesFilterSearchOverview.predicate" ascending="SalesFilterSearchOverview.ascending" callback="search()"><th jh-sort-by="description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="firstName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.firstName.label">firstName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'firstName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="lastName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.lastName.label">lastName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="potentialFrom" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.potentialFrom.label">potentialFrom</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'potentialFrom\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="potentialTo" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.potentialTo.label">potentialTo</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'potentialTo\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="offsetStartDateFrom" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.offsetStartDateFrom.label">offsetStartDateFrom</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'offsetStartDateFrom\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="offsetStartDateTo" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.offsetStartDateTo.label">offsetStartDateTo</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'offsetStartDateTo\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="salesStatus" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.salesStatus.label">salesStatus</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesStatus\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="user.lastName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.user.label">user</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'user.lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td class="hidden-xs"><!-- column #0--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'salesFilter.overview.search.description.placeholder\' | translate}}" name="description" ng-model="SalesFilterSearchOverview.description" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td class="hidden-xs"><!-- column #1--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'salesFilter.overview.search.firstName.placeholder\' | translate}}" name="firstName" ng-model="SalesFilterSearchOverview.firstName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td class="hidden-xs"><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'salesFilter.overview.search.lastName.placeholder\' | translate}}" name="lastName" ng-model="SalesFilterSearchOverview.lastName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td class="hidden-xs"><!-- column #3--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialFrom.placeholder.from\' | translate}}" class="form-control" name="potentialFromFrom" ng-model="SalesFilterSearchOverview.potentialFromFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialFrom.placeholder.to\' | translate}}" class="form-control" name="topotentialFrom" ng-model="SalesFilterSearchOverview.potentialFromTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #4--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialTo.placeholder.from\' | translate}}" class="form-control" name="potentialToFrom" ng-model="SalesFilterSearchOverview.potentialToFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialTo.placeholder.to\' | translate}}" class="form-control" name="topotentialTo" ng-model="SalesFilterSearchOverview.potentialToTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #5--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateFrom.placeholder.from\' | translate}}" class="form-control" name="offsetStartDateFromFrom" ng-model="SalesFilterSearchOverview.offsetStartDateFromFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateFrom.placeholder.to\' | translate}}" class="form-control" name="tooffsetStartDateFrom" ng-model="SalesFilterSearchOverview.offsetStartDateFromTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #6--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateTo.placeholder.from\' | translate}}" class="form-control" name="offsetStartDateToFrom" ng-model="SalesFilterSearchOverview.offsetStartDateToFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateTo.placeholder.to\' | translate}}" class="form-control" name="tooffsetStartDateTo" ng-model="SalesFilterSearchOverview.offsetStartDateToTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #7--><select id="salesStatus_select" class="form-control input-sm" ng-model="SalesFilterSearchOverview.salesStatus" tabindex="0" ng-change="search()" ng-options="\'SalesStatus.\' + salesStatus | translate for salesStatus in salesStatusList"><option value="" translate="salesFilter.overview.search.salesStatus.defaultOption">All SalesStatuses</option></select></td><td class="hidden-xs"><!-- column #8--><select id="user_select" class="form-control input-sm" ng-options="user as user.displayValue for user in userReferenceFilterList track by user.id" ng-model="SalesFilterSearchOverview.user" tabindex="0" ng-change="search()"><option value="" translate="salesFilter.overview.search.user.defaultOption">All Users</option></select></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isSalesFilterSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="salesFilter in salesFilterList"><td class="hidden-xs" id="salesFilter.descriptionId{{$index}}">{{salesFilter.description}}</td><td class="hidden-xs" id="salesFilter.firstNameId{{$index}}">{{salesFilter.firstName}}</td><td class="hidden-xs" id="salesFilter.lastNameId{{$index}}">{{salesFilter.lastName}}</td><td class="hidden-xs" id="salesFilter.potentialFromId{{$index}}">{{salesFilter.potentialFrom}}</td><td class="hidden-xs" id="salesFilter.potentialToId{{$index}}">{{salesFilter.potentialTo}}</td><td class="hidden-xs" id="salesFilter.offsetStartDateFromId{{$index}}">{{salesFilter.offsetStartDateFrom}}</td><td class="hidden-xs" id="salesFilter.offsetStartDateToId{{$index}}">{{salesFilter.offsetStartDateTo}}</td><td class="hidden-xs">{{salesFilter.salesStatusDisplayValue === null ? "" : salesFilter.salesStatusDisplayValue | translate}}</td><td class="hidden-xs"><span>{{salesFilter.userDisplayValue}}</span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilter{{$index}}" type="submit" ui-sref="user-salesfilter.detail({salesFilterId:salesFilter.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_SalesFilter{{$index}}" type="submit" ui-sref="user-salesfilter.edit({salesFilterId:salesFilter.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteSalesFilter{{$index}}" type="submit" ng-click="singleDelete(salesFilter.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SalesFilterSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfilter/salesfilter-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"><button id="createSalesFilterButton" class="btn btn-primary" ng-click="goToNewState()" ng-if="showCreateButtonTab"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span><span class="hidden-xs" translate="salesFilter.overview.button.new">Create a new SalesFilter</span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteSalesFilterConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="salesFilter.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilter.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilter</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteSalesFilter" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="firstName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.firstName.label">firstName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'firstName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="lastName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.lastName.label">lastName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="potentialFrom" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.potentialFrom.label">potentialFrom</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'potentialFrom\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="potentialTo" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.potentialTo.label">potentialTo</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'potentialTo\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="offsetStartDateFrom" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.offsetStartDateFrom.label">offsetStartDateFrom</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'offsetStartDateFrom\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="offsetStartDateTo" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.offsetStartDateTo.label">offsetStartDateTo</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'offsetStartDateTo\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="salesStatus" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.salesStatus.label">salesStatus</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesStatus\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'user\'" jh-sort-by="user.lastName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.user.label">user</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'user.lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="salesFilter in salesFilterList"><td class="hidden-xs" id="salesFilter.descriptionId{{$index}}">{{salesFilter.description}}</td><td class="hidden-xs" id="salesFilter.firstNameId{{$index}}">{{salesFilter.firstName}}</td><td class="hidden-xs" id="salesFilter.lastNameId{{$index}}">{{salesFilter.lastName}}</td><td class="hidden-xs" id="salesFilter.potentialFromId{{$index}}">{{salesFilter.potentialFrom}}</td><td class="hidden-xs" id="salesFilter.potentialToId{{$index}}">{{salesFilter.potentialTo}}</td><td class="hidden-xs" id="salesFilter.offsetStartDateFromId{{$index}}">{{salesFilter.offsetStartDateFrom}}</td><td class="hidden-xs" id="salesFilter.offsetStartDateToId{{$index}}">{{salesFilter.offsetStartDateTo}}</td><td class="hidden-xs">{{salesFilter.salesStatusDisplayValue === null ? "" : salesFilter.salesStatusDisplayValue | translate}}</td><td class="hidden-xs" ng-hide="mappedBy == \'user\'"><span>{{salesFilter.userDisplayValue}}</span></td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilter{{$index}}" type="submit" ui-sref="user-salesfilter.detail({salesFilterId:salesFilter.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_SalesFilter{{$index}}" type="submit" ui-sref="user-salesfilter.edit({salesFilterId:salesFilter.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteSalesFilter{{$index}}" type="submit" ng-click="singleDelete(salesFilter.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/salesfilter/salesfilter-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createSalesFilterButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="salesFilter.overview.button.new">Create a new SalesFilter</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteSalesFilterConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="salesFilter.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilter.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilter</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteSalesFilter" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="salesFilter in salesFilterList"><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilter{{$index}}" type="submit" ui-sref="salesfilter.detail({salesFilterId:salesFilter.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_SalesFilter{{$index}}" type="submit" ng-click="goToEditState(salesFilter)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteSalesFilter{{$index}}" type="submit" ng-click="singleDelete(salesFilter.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/salesfilter/salesfilter-view-user.html','<!-- Created by html/angular/entity/dto-view.ftl --><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="SalesFilterDetailTitle" translate="salesFilter.detail.title">SalesFilter</span> {{salesFilter.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="salesFilter.detail.creator.label">Creator:</span>&nbsp; <span>{{salesFilter.creator}} {{salesFilter.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="salesFilter.updater">,&nbsp; <span translate="salesFilter.detail.updater.label">Updater: </span>&nbsp; <span>{{salesFilter.updater}} {{salesFilter.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button id="btn_edit_SalesFilter{{$index}}" type="submit" ui-sref="user-salesfilter.edit({salesFilterId:salesFilter.id, mappedBy:mappedBy, mappedById:mappedById, mappedByDisplayValue:mappedByDisplayValue})" class="btn btn-success"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button><p>&nbsp;</p></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="modal fade" id="deleteSalesFilterConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(salesFilter.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="salesFilter.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilter.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilter?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="row"><div class="col-xs-12"><div class="table-responsive"><table class="table table-condensed layout-container"><tbody><tr><!--row #1--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.description.label">Description</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.description}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #2--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.firstName.label">FirstName</label><label translate="salesFilter.detail.lastName.label">LastName</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.firstName}}</span> <span>{{salesFilter.lastName}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #3--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.potentialFrom.label">PotentialFrom</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.potentialFrom}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #4--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.potentialTo.label">PotentialTo</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.potentialTo}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #5--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.offsetStartDateFrom.label">OffsetStartDateFrom</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.offsetStartDateFrom}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #6--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.offsetStartDateTo.label">OffsetStartDateTo</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.offsetStartDateTo}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #7--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.salesFilterEventType.label">SalesFilterEventType</label></td><td colspan="3" style="width: 50%"><!--column #2--><ui-select multiple="multiple" ng-model="salesFilter.selectedEventTypeList" ng-disabled="true" title="Choose a eventType"><ui-select-match>{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="eventType in salesFilter.eventTypeList | propsFilter: {displayValue: $select.search}"><small>{{eventType.displayValue}}</small></ui-select-choices></ui-select></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #8--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.salesFilterTemplateEvent.label">SalesFilterTemplateEvent</label></td><td colspan="3" style="width: 50%"><!--column #2--><ui-select multiple="multiple" ng-model="salesFilter.selectedTemplateEventList" ng-disabled="true" title="Choose a templateEvent"><ui-select-match>{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="templateEvent in salesFilter.templateEventList | propsFilter: {displayValue: $select.search}"><small>{{templateEvent.displayValue}}</small></ui-select-choices></ui-select></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #9--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.salesStatus.label">SalesStatus</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span class="form-control-static">{{salesFilter.salesStatusDisplayValue === null ? "" : salesFilter.salesStatusDisplayValue | translate}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #10--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.user.label">User</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.userDisplayValue}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #11--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.pagingPage.label">PagingPage</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.pagingPage}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><tr><!--row #12--><td colspan="3" style="width: 50%"><!--column #1--><label translate="salesFilter.detail.pagingSize.label">PagingSize</label></td><td colspan="3" style="width: 50%"><!--column #2--> <span>{{salesFilter.pagingSize}}</span></td><td style="width: 17%"></td><td style="width: 17%"></td></tr><!-- END row in rows --></tbody></table></div></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfilter/salesfilters.html','<div id="content"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="salesFilter.overview.title">SalesFilters</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button id="createSalesFilterButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="salesFilter.overview.button.new">Create a new SalesFilter</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteSalesFilterConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="salesFilter.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilter.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilter</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteSalesFilter" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilter.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SalesFilterSearchOverview.predicate" ascending="SalesFilterSearchOverview.ascending" callback="search()"><th jh-sort-by="description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="firstName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.firstName.label">firstName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'firstName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="lastName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.lastName.label">lastName</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="potentialFrom" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.potentialFrom.label">potentialFrom</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'potentialFrom\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="potentialTo" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.potentialTo.label">potentialTo</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'potentialTo\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="offsetStartDateFrom" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.offsetStartDateFrom.label">offsetStartDateFrom</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'offsetStartDateFrom\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="offsetStartDateTo" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.offsetStartDateTo.label">offsetStartDateTo</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'offsetStartDateTo\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="salesStatus" class="sortable hidden-xs"><span translate="salesFilter.overview.results.header.salesStatus.label">salesStatus</span> <span class="glyphicon {{getSortIcon(\'salesStatus\')}}"></span></th><th jh-sort-by="user.lastName" class="sortable hidden-xs"><span class="pull-left" translate="salesFilter.overview.results.header.user.label">user</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'user.lastName\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td class="hidden-xs"><!-- column #0--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'salesFilter.overview.search.description.placeholder\' | translate}}" name="description" ng-model="SalesFilterSearchOverview.description" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td class="hidden-xs"><!-- column #1--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'salesFilter.overview.search.firstName.placeholder\' | translate}}" name="firstName" ng-model="SalesFilterSearchOverview.firstName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td class="hidden-xs"><!-- column #2--> <input tabindex="0" class="input-sm form-control" placeholder="{{\'salesFilter.overview.search.lastName.placeholder\' | translate}}" name="lastName" ng-model="SalesFilterSearchOverview.lastName" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></td><td class="hidden-xs"><!-- column #3--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialFrom.placeholder.from\' | translate}}" class="form-control" name="potentialFromFrom" ng-model="SalesFilterSearchOverview.potentialFromFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialFrom.placeholder.to\' | translate}}" class="form-control" name="topotentialFrom" ng-model="SalesFilterSearchOverview.potentialFromTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #4--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialTo.placeholder.from\' | translate}}" class="form-control" name="potentialToFrom" ng-model="SalesFilterSearchOverview.potentialToFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.potentialTo.placeholder.to\' | translate}}" class="form-control" name="topotentialTo" ng-model="SalesFilterSearchOverview.potentialToTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #5--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateFrom.placeholder.from\' | translate}}" class="form-control" name="offsetStartDateFromFrom" ng-model="SalesFilterSearchOverview.offsetStartDateFromFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateFrom.placeholder.to\' | translate}}" class="form-control" name="tooffsetStartDateFrom" ng-model="SalesFilterSearchOverview.offsetStartDateFromTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #6--><div class="input-group input-group-sm hidden-xs"><span class="input-group-addon" translate="entity.search.from.label">from</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateTo.placeholder.from\' | translate}}" class="form-control" name="offsetStartDateToFrom" ng-model="SalesFilterSearchOverview.offsetStartDateToFrom" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-addon" translate="entity.search.to.label">to</span> <input tabindex="0" placeholder="{{\'salesFilter.overview.search.offsetStartDateTo.placeholder.to\' | translate}}" class="form-control" name="tooffsetStartDateTo" ng-model="SalesFilterSearchOverview.offsetStartDateToTo" type="number" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></td><td class="hidden-xs"><!-- column #7--><select id="salesStatus_select" class="form-control input-sm" ng-model="SalesFilterSearchOverview.salesStatus" tabindex="0" ng-change="search()" ng-options="\'SalesStatus.\' + salesStatus | translate for salesStatus in salesStatusList"><option value="" translate="salesFilter.overview.search.salesStatus.defaultOption">All SalesStatuses</option></select></td><td class="hidden-xs"><!-- column #8--><select id="user_select" class="form-control input-sm" ng-options="user as $root.displayFields([user.lastName, user.firstName]) for user in userReferenceFilterList track by user.id" ng-model="SalesFilterSearchOverview.user" tabindex="0" ng-change="search()"><option value="" translate="salesFilter.overview.search.user.defaultOption">All Users</option></select></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isSalesFilterSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="salesFilter in salesFilterList"><td class="hidden-xs" id="salesFilter.descriptionId{{$index}}">{{salesFilter.description}}</td><td class="hidden-xs" id="salesFilter.firstNameId{{$index}}">{{salesFilter.firstName}}</td><td class="hidden-xs" id="salesFilter.lastNameId{{$index}}">{{salesFilter.lastName}}</td><td class="hidden-xs" id="salesFilter.potentialFromId{{$index}}">{{salesFilter.potentialFrom}}</td><td class="hidden-xs" id="salesFilter.potentialToId{{$index}}">{{salesFilter.potentialTo}}</td><td class="hidden-xs" id="salesFilter.offsetStartDateFromId{{$index}}">{{salesFilter.offsetStartDateFrom}}</td><td class="hidden-xs" id="salesFilter.offsetStartDateToId{{$index}}">{{salesFilter.offsetStartDateTo}}</td><td class="hidden-xs">{{salesFilter.salesStatus === null ? "" : \'SalesStatus.\' + salesFilter.salesStatus | translate}}</td><td class="hidden-xs"><a ui-sref="user.detail({userId:salesFilter.user.id})"><span>{{$root.displayFields([salesFilter.user.lastName, salesFilter.user.firstName])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilter{{$index}}" type="submit" ui-sref="salesfilter.detail({salesFilterId:salesFilter.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_SalesFilter{{$index}}" type="submit" ng-click="goToEditState(salesFilter)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteSalesFilter{{$index}}" type="submit" ng-click="singleDelete(salesFilter.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SalesFilterSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/subscription/subscription-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="SubscriptionDetailTitle" translate="subscription.detail.title">Subscription</span> {{subscription.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="subscription.detail.creator.label">Creator:</span>&nbsp; <span>{{subscription.creator}} {{subscription.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="subscription.updater">,&nbsp; <span translate="subscription.detail.updater.label">Updater: </span>&nbsp; <span>{{subscription.updater}} {{subscription.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="subscription.detail.edit({subscriptionId:subscription.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteSubscriptionConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(subscription.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="subscription.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="subscription.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Subscription?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="subscription.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{subscription.description}}</span></td></tr><tr><td><span translate="subscription.detail.drivingGroup.label">drivingGroup</span></td><td><span class="form-control-static">{{subscription.drivingGroup}}</span></td></tr><tr><td><span translate="subscription.detail.instructionHours.label">instructionHours</span></td><td><span class="form-control-static">{{subscription.instructionHours | number: 0}}</span></td></tr><tr><td><span translate="subscription.detail.instructionDirections.label">instructionDirections</span></td><td><span class="form-control-static white-space-pre">{{subscription.instructionDirections}}</span></td></tr><tr><td><span translate="subscription.detail.instructionProgress.label">instructionProgress</span></td><td><span class="form-control-static white-space-pre">{{subscription.instructionProgress}}</span></td></tr><tr><td><span translate="subscription.detail.drivingResult.label">drivingResult</span></td><td><span class="form-control-static">{{subscription.drivingResult | number: 1}}</span></td></tr><tr><td><span translate="subscription.detail.progress.label">progress</span></td><td><span class="form-control-static">{{subscription.progress | number: 1}}</span></td></tr><tr><td><span translate="subscription.detail.car.label">car</span></td><td><a ui-sref="car.detail({carId:subscription.car.id})"><span>{{$root.displayFields([subscription.car.name, subscription.car.rental])}}</span></a></td></tr><tr><td><span translate="subscription.detail.present.label">present</span></td><td><span class="form-control-static">{{subscription.present}}</span></td></tr><tr><td><span translate="subscription.detail.infoMail.label">infoMail</span></td><td><span class="form-control-static">{{subscription.infoMail}}</span></td></tr><tr><td><span translate="subscription.detail.afterMail.label">afterMail</span></td><td><span class="form-control-static">{{subscription.afterMail}}</span></td></tr><tr><td><span translate="subscription.detail.driver.label">driver</span></td><td><a ui-sref="article.detail({articleId:subscription.driver.id})"><span>{{$root.displayFields([subscription.driver.name, subscription.driver.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.secondDriver.label">secondDriver</span></td><td><a ui-sref="article.detail({articleId:subscription.secondDriver.id})"><span>{{$root.displayFields([subscription.secondDriver.name, subscription.secondDriver.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.spectator.label">spectator</span></td><td><a ui-sref="article.detail({articleId:subscription.spectator.id})"><span>{{$root.displayFields([subscription.spectator.name, subscription.spectator.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.insurance.label">insurance</span></td><td><a ui-sref="article.detail({articleId:subscription.insurance.id})"><span>{{$root.displayFields([subscription.insurance.name, subscription.insurance.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.hotel.label">hotel</span></td><td><a ui-sref="article.detail({articleId:subscription.hotel.id})"><span>{{$root.displayFields([subscription.hotel.name, subscription.hotel.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.fuel.label">fuel</span></td><td><a ui-sref="article.detail({articleId:subscription.fuel.id})"><span>{{$root.displayFields([subscription.fuel.name, subscription.fuel.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.relationOf.label">relationOf</span></td><td><a ui-sref="subscription.detail({subscriptionId:subscription.relationOf.id})"><span>{{$root.displayFields([subscription.relationOf.description, subscription.relationOf.relation.externalId, subscription.relationOf.relation.firstName, subscription.relationOf.relation.lastName, subscription.relationOf.relation.companyName])}}</span></a></td></tr><tr><td><span translate="subscription.detail.instructor.label">instructor</span></td><td><a ui-sref="instructor.detail({instructorId:subscription.instructor.id})"><span>{{$root.displayFields([subscription.instructor.description, subscription.instructor.relation.externalId, subscription.instructor.relation.firstName, subscription.instructor.relation.lastName, subscription.instructor.relation.companyName])}}</span></a></td></tr><tr><td><span translate="subscription.detail.trainingType.label">trainingType</span></td><td><a ui-sref="templateevent.detail({templateEventId:subscription.trainingType.id})"><span>{{subscription.trainingType.name}}</span></a></td></tr><tr><td><span translate="subscription.detail.subscriptionType.label">subscriptionType</span></td><td><span class="form-control-static">{{subscription.subscriptionType === null ? "" : \'SubscriptionType.\' + subscription.subscriptionType | translate}}</span></td></tr><tr><td><span translate="subscription.detail.rentalCar.label">rentalCar</span></td><td><a ui-sref="article.detail({articleId:subscription.rentalCar.id})"><span>{{$root.displayFields([subscription.rentalCar.name, subscription.rentalCar.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.relation.label">relation</span></td><td><a ui-sref="user-relation.detail({relationId:subscription.relation.id})"><span>{{$root.displayFields([subscription.relation.externalId, subscription.relation.firstName, subscription.relation.lastName, subscription.relation.companyName])}}</span></a></td></tr><tr><td><span translate="subscription.detail.instruction.label">instruction</span></td><td><a ui-sref="article.detail({articleId:subscription.instruction.id})"><span>{{$root.displayFields([subscription.instruction.name, subscription.instruction.price])}}</span></a></td></tr><tr><td><span translate="subscription.detail.booking.label">booking</span></td><td><a ui-sref="booking.detail({bookingId:subscription.booking.id})"><span>{{$root.displayFields([subscription.booking.description, subscription.booking.event.name, subscription.booking.client.externalId, subscription.booking.client.firstName, subscription.booking.client.lastName, subscription.booking.client.companyName])}}</span></a></td></tr><tr><td><span translate="subscription.detail.status.label">status</span></td><td><span class="form-control-static">{{subscription.status === null ? "" : \'SubscriptionStatus.\' + subscription.status | translate}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.subscriptionActiveTab"></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/subscription/subscription-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="SubscriptionDialogTitleCreate" translate="subscription.dialog.title.create">Create a Subscription</h4><h4 class="modal-title" ng-show="isEdit()" id="SubscriptionDialogTitleEdit" translate="subscription.dialog.title.edit" translate-value-id="{{subscription.id}}">Edit a Subscription</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="subscription.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="subscription.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="subscription.description" ng-maxlength="-1" placeholder="{{\'subscription.dialog.description.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.drivingGroup.$invalid, \'has-success\' : editForm.drivingGroup.$valid && editForm.drivingGroup.$dirty }"><label for="field_drivingGroup" id="label_drivingGroup" class="col-sm-2 control-label" translate="subscription.dialog.drivingGroup.label">DrivingGroup</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="drivingGroup" id="field_drivingGroup" ng-model="subscription.drivingGroup" ng-maxlength="-1" placeholder="{{\'subscription.dialog.drivingGroup.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.instructionHours.$invalid, \'has-success\' : editForm.instructionHours.$valid && editForm.instructionHours.$dirty }"><label for="field_instructionHours" id="label_instructionHours" class="col-sm-2 control-label" translate="subscription.dialog.instructionHours.label">InstructionHours</label><div class="col-sm-9"><input type="number" step="0.01" class="form-control input-sm" name="instructionHours" id="field_instructionHours" ng-model="subscription.instructionHours" ng-maxlength="-1" placeholder="{{\'subscription.dialog.instructionHours.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.instructionDirections.$invalid, \'has-success\' : editForm.instructionDirections.$valid && editForm.instructionDirections.$dirty }"><label for="field_instructionDirections" id="label_instructionDirections" class="col-sm-2 control-label" translate="subscription.dialog.instructionDirections.label">InstructionDirections</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="instructionDirections" id="field_instructionDirections" ng-model="subscription.instructionDirections" ng-maxlength="-1" placeholder="{{\'subscription.dialog.instructionDirections.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.instructionProgress.$invalid, \'has-success\' : editForm.instructionProgress.$valid && editForm.instructionProgress.$dirty }"><label for="field_instructionProgress" id="label_instructionProgress" class="col-sm-2 control-label" translate="subscription.dialog.instructionProgress.label">InstructionProgress</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="instructionProgress" id="field_instructionProgress" ng-model="subscription.instructionProgress" ng-maxlength="-1" placeholder="{{\'subscription.dialog.instructionProgress.placeholder\'|translate}}"></textarea></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.drivingResult.$invalid, \'has-success\' : editForm.drivingResult.$valid && editForm.drivingResult.$dirty }"><label for="field_drivingResult" id="label_drivingResult" class="col-sm-2 control-label" translate="subscription.dialog.drivingResult.label">DrivingResult</label><div class="col-sm-9"><input type="number" step="0.01" class="form-control input-sm" name="drivingResult" id="field_drivingResult" ng-model="subscription.drivingResult" ng-min="1" ng-max="10" ng-maxlength="-1" placeholder="{{\'subscription.dialog.drivingResult.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.drivingResult.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="10">Maximum value validation error</p><p class="help-block" ng-show="editForm.drivingResult.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="1">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.progress.$invalid, \'has-success\' : editForm.progress.$valid && editForm.progress.$dirty }"><label for="field_progress" id="label_progress" class="col-sm-2 control-label" translate="subscription.dialog.progress.label">Progress</label><div class="col-sm-9"><input type="number" step="0.01" class="form-control input-sm" name="progress" id="field_progress" ng-model="subscription.progress" ng-min="1" ng-max="10" ng-maxlength="-1" placeholder="{{\'subscription.dialog.progress.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.progress.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="10">Maximum value validation error</p><p class="help-block" ng-show="editForm.progress.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="1">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.car.$invalid, \'has-success\' : editForm.car.$valid && editForm.car.$dirty }"><label for="field_car" class="col-sm-2 control-label" translate="subscription.dialog.car.label">car</label><div class="col-sm-9"><input ng-disabled="\'car\' == mappedBy" type="text" id="field_car" name="car" ng-model="subscription.car" ng-model-options="$root.modelOptions" uib-typeahead="car as car.displayValue for car in autocompleteCars($viewValue)" typeahead-loading="loadingCar" typeahead-no-results="noResultsForCar" placeholder="{{\'subscription.dialog.car.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off"> <i ng-show="loadingCar" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForCar"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new car" ng-disabled="\'car\' == mappedBy" ng-click="createCar()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.present.$invalid, \'has-success\' : editForm.present.$valid && editForm.present.$dirty }"><label for="field_present" id="label_present" class="col-sm-2 control-label" translate="subscription.dialog.present.label">Present</label><div class="col-sm-9"><nz-toggle id="field_present" name="present" ng-model="subscription.present" val-true="true" val-false="false" val-null="null" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.infoMail.$invalid, \'has-success\' : editForm.infoMail.$valid && editForm.infoMail.$dirty }"><label for="field_infoMail" id="label_infoMail" class="col-sm-2 control-label" translate="subscription.dialog.infoMail.label">InfoMail</label><div class="col-sm-9"><nz-toggle id="field_infoMail" name="infoMail" ng-model="subscription.infoMail" val-true="true" val-false="false" val-null="null" val-default="false" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.afterMail.$invalid, \'has-success\' : editForm.afterMail.$valid && editForm.afterMail.$dirty }"><label for="field_afterMail" id="label_afterMail" class="col-sm-2 control-label" translate="subscription.dialog.afterMail.label">AfterMail</label><div class="col-sm-9"><nz-toggle id="field_afterMail" name="afterMail" ng-model="subscription.afterMail" val-true="true" val-false="false" val-null="null" val-default="false" class="square"></nz-toggle></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.driver.$invalid, \'has-success\' : editForm.driver.$valid && editForm.driver.$dirty }"><label for="field_driver" class="col-sm-2 control-label" translate="subscription.dialog.driver.label">driver</label><div class="col-sm-9"><select ng-disabled="\'driver\' == mappedBy" class="form-control input-sm" id="field_driver" name="driver" ng-model="subscription.driver" ng-options="driver as $root.displayFields([driver.name, driver.price]) for driver in driverList track by driver.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new driver" ng-disabled="\'driver\' == mappedBy" ng-click="createDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.secondDriver.$invalid, \'has-success\' : editForm.secondDriver.$valid && editForm.secondDriver.$dirty }"><label for="field_secondDriver" class="col-sm-2 control-label" translate="subscription.dialog.secondDriver.label">secondDriver</label><div class="col-sm-9"><select ng-disabled="\'secondDriver\' == mappedBy" class="form-control input-sm" id="field_secondDriver" name="secondDriver" ng-model="subscription.secondDriver" ng-options="secondDriver as $root.displayFields([secondDriver.name, secondDriver.price]) for secondDriver in secondDriverList track by secondDriver.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new seconddriver" ng-disabled="\'secondDriver\' == mappedBy" ng-click="createSecondDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.spectator.$invalid, \'has-success\' : editForm.spectator.$valid && editForm.spectator.$dirty }"><label for="field_spectator" class="col-sm-2 control-label" translate="subscription.dialog.spectator.label">spectator</label><div class="col-sm-9"><select ng-disabled="\'spectator\' == mappedBy" class="form-control input-sm" id="field_spectator" name="spectator" ng-model="subscription.spectator" ng-options="spectator as $root.displayFields([spectator.name, spectator.price]) for spectator in spectatorList track by spectator.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new spectator" ng-disabled="\'spectator\' == mappedBy" ng-click="createSpectator()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.insurance.$invalid, \'has-success\' : editForm.insurance.$valid && editForm.insurance.$dirty }"><label for="field_insurance" class="col-sm-2 control-label" translate="subscription.dialog.insurance.label">insurance</label><div class="col-sm-9"><select ng-disabled="\'insurance\' == mappedBy" class="form-control input-sm" id="field_insurance" name="insurance" ng-model="subscription.insurance" ng-options="insurance as $root.displayFields([insurance.name, insurance.price]) for insurance in insuranceList track by insurance.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new insurance" ng-disabled="\'insurance\' == mappedBy" ng-click="createInsurance()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.hotel.$invalid, \'has-success\' : editForm.hotel.$valid && editForm.hotel.$dirty }"><label for="field_hotel" class="col-sm-2 control-label" translate="subscription.dialog.hotel.label">hotel</label><div class="col-sm-9"><select ng-disabled="\'hotel\' == mappedBy" class="form-control input-sm" id="field_hotel" name="hotel" ng-model="subscription.hotel" ng-options="hotel as $root.displayFields([hotel.name, hotel.price]) for hotel in hotelList track by hotel.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new hotel" ng-disabled="\'hotel\' == mappedBy" ng-click="createHotel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.fuel.$invalid, \'has-success\' : editForm.fuel.$valid && editForm.fuel.$dirty }"><label for="field_fuel" class="col-sm-2 control-label" translate="subscription.dialog.fuel.label">fuel</label><div class="col-sm-9"><select ng-disabled="\'fuel\' == mappedBy" class="form-control input-sm" id="field_fuel" name="fuel" ng-model="subscription.fuel" ng-options="fuel as $root.displayFields([fuel.name, fuel.price]) for fuel in fuelList track by fuel.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new fuel" ng-disabled="\'fuel\' == mappedBy" ng-click="createFuel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relationOf.$invalid, \'has-success\' : editForm.relationOf.$valid && editForm.relationOf.$dirty }"><label for="field_relationOf" class="col-sm-2 control-label" translate="subscription.dialog.relationOf.label">relationOf</label><div class="col-sm-9"><select ng-disabled="\'relationOf\' == mappedBy" class="form-control input-sm" id="field_relationOf" name="relationOf" ng-model="subscription.relationOf" ng-options="relationOf as $root.displayFields([relationOf.description, relationOf.relation.externalId, relationOf.relation.firstName, relationOf.relation.lastName, relationOf.relation.companyName]) for relationOf in relationOfList track by relationOf.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new relationof" ng-disabled="\'relationOf\' == mappedBy" ng-click="createRelationOf()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.instructor.$invalid, \'has-success\' : editForm.instructor.$valid && editForm.instructor.$dirty }"><label for="field_instructor" class="col-sm-2 control-label" translate="subscription.dialog.instructor.label">instructor</label><div class="col-sm-9"><select ng-disabled="\'instructor\' == mappedBy" class="form-control input-sm" id="field_instructor" name="instructor" ng-model="subscription.instructor" ng-options="instructor as $root.displayFields([instructor.description, instructor.relation.externalId, instructor.relation.firstName, instructor.relation.lastName, instructor.relation.companyName]) for instructor in instructorList track by instructor.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new instructor" ng-disabled="\'instructor\' == mappedBy" ng-click="createInstructor()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.trainingType.$invalid, \'has-success\' : editForm.trainingType.$valid && editForm.trainingType.$dirty }"><label for="field_trainingType" class="col-sm-2 control-label" translate="subscription.dialog.trainingType.label">trainingType</label><div class="col-sm-9"><select ng-disabled="\'trainingType\' == mappedBy" class="form-control input-sm" id="field_trainingType" name="trainingType" ng-model="subscription.trainingType" ng-options="trainingType as trainingType.name for trainingType in trainingTypeList track by trainingType.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new trainingtype" ng-disabled="\'trainingType\' == mappedBy" ng-click="createTrainingType()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.subscriptionType.$invalid, \'has-success\' : editForm.subscriptionType.$valid && editForm.subscriptionType.$dirty }"><label for="field_subscriptionType" class="col-sm-2 control-label" translate="subscription.dialog.subscriptionType.label">subscriptionType</label><div class="col-sm-9"><select ng-disabled="\'subscriptionType\' == mappedBy" class="form-control input-sm" id="field_subscriptionType" name="subscriptionType" ng-model="subscription.subscriptionType" required ng-options="\'SubscriptionType.\' + subscriptionType | translate for subscriptionType in subscriptionTypeList"><option value=""></option></select><div ng-show="editForm.subscriptionType.$invalid"><p class="help-block" ng-show="editForm.subscriptionType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.rentalCar.$invalid, \'has-success\' : editForm.rentalCar.$valid && editForm.rentalCar.$dirty }"><label for="field_rentalCar" class="col-sm-2 control-label" translate="subscription.dialog.rentalCar.label">rentalCar</label><div class="col-sm-9"><select ng-disabled="\'rentalCar\' == mappedBy" class="form-control input-sm" id="field_rentalCar" name="rentalCar" ng-model="subscription.rentalCar" ng-options="rentalCar as $root.displayFields([rentalCar.name, rentalCar.price]) for rentalCar in rentalCarList track by rentalCar.id"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.relation.$invalid, \'has-success\' : editForm.relation.$valid && editForm.relation.$dirty }"><label for="field_relation" class="col-sm-2 control-label" translate="subscription.dialog.relation.label">relation</label><div class="col-sm-9"><input ng-disabled="\'relation\' == mappedBy" type="text" id="field_relation" name="relation" ng-model="subscription.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsForRelation" placeholder="{{\'subscription.dialog.relation.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off" required> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div><div ng-show="editForm.relation.$invalid"><p class="help-block" ng-show="editForm.relation.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new relation" ng-disabled="\'relation\' == mappedBy" ng-click="createRelation()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.instruction.$invalid, \'has-success\' : editForm.instruction.$valid && editForm.instruction.$dirty }"><label for="field_instruction" class="col-sm-2 control-label" translate="subscription.dialog.instruction.label">instruction</label><div class="col-sm-9"><select ng-disabled="\'instruction\' == mappedBy" class="form-control input-sm" id="field_instruction" name="instruction" ng-model="subscription.instruction" ng-options="instruction as $root.displayFields([instruction.name, instruction.price]) for instruction in instructionList track by instruction.id"><option value=""></option></select></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.booking.$invalid, \'has-success\' : editForm.booking.$valid && editForm.booking.$dirty }"><label for="field_booking" class="col-sm-2 control-label" translate="subscription.dialog.booking.label">booking</label><div class="col-sm-9"><input ng-disabled="\'booking\' == mappedBy" type="text" id="field_booking" name="booking" ng-model="subscription.booking" ng-model-options="$root.modelOptions" uib-typeahead="booking as booking.displayValue for booking in autocompleteBookings($viewValue)" typeahead-loading="loadingBooking" typeahead-no-results="noResultsForBooking" typeahead-on-select="updateRelationOf(); updateInstructor();" placeholder="{{\'subscription.dialog.booking.placeholder\'|translate}}" class="form-control input-sm" autocomplete="off"> <i ng-show="loadingBooking" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsForBooking"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new booking" ng-disabled="\'booking\' == mappedBy" ng-click="createBooking()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.status.$invalid, \'has-success\' : editForm.status.$valid && editForm.status.$dirty }"><label for="field_status" class="col-sm-2 control-label" translate="subscription.dialog.status.label">status</label><div class="col-sm-9"><select ng-disabled="\'status\' == mappedBy" class="form-control input-sm" id="field_status" name="status" ng-model="subscription.status" required ng-options="\'SubscriptionStatus.\' + status | translate for status in statusList"><option value=""></option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="subscription.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="subscription.dialog.update.button">Save</span></button> <button type="button" id="saveAndNewButton" ng-click="saveAndNew()" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span translate="subscription.dialog.saveAndNew.button">Save</span></button></div></form>');
$templateCache.put('app/entities/subscription/subscription-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm" ng-hide="mappedBy == \'booking\'"><label class="col-md-2 col-md-offset-2 control-label" translate="subscription.overview.search.booking.label">booking</label><div class="col-md-6"><input type="text" id="field_booking" name="booking" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="SubscriptionSearchTab.booking" ng-model-options="$root.modelOptions" uib-typeahead="booking as booking.displayValue for booking in autocompleteBookings($viewValue)" typeahead-loading="loadingBooking" typeahead-no-results="noResultsBooking" placeholder="{{\'subscription.overview.search.booking.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingBooking" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsBooking"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm" ng-hide="mappedBy == \'relation\'"><label class="col-md-2 col-md-offset-2 control-label" translate="subscription.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="SubscriptionSearchTab.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'subscription.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="subscription.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isSubscriptionSearchTabDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="subscription.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteSubscriptionConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="subscription.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="subscription.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Subscription</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteSubscription" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SubscriptionSearchTab.predicate" ascending="SubscriptionSearchTab.ascending" callback="search()"><th ng-hide="mappedBy == \'relation\'" jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="subscriptionType" class="sortable"><span translate="subscription.overview.results.header.subscriptionType.label">subscriptionType</span> <span class="glyphicon {{getSortIcon(\'subscriptionType\')}}"></span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="status" class="sortable"><span translate="subscription.overview.results.header.status.label">status</span> <span class="glyphicon {{getSortIcon(\'status\')}}"></span></th><th jh-sort-by="drivingGroup" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.drivingGroup.label">drivingGroup</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'drivingGroup\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'instructor\'" jh-sort-by="instructor.description" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructor.label">instructor</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructor.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'trainingType\'" jh-sort-by="trainingType.name" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.trainingType.label">trainingType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'trainingType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionHours" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructionHours.label">instructionHours</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionHours\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="drivingResult" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.drivingResult.label">drivingResult</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'drivingResult\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="progress" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.progress.label">progress</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'progress\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionProgress" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructionProgress.label">instructionProgress</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionProgress\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionDirections" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructionDirections.label">instructionDirections</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionDirections\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="subscription in subscriptionList"><td ng-hide="mappedBy == \'relation\'"><a ui-sref="user-relation.detail({relationId:subscription.relation.id})"><span>{{$root.displayFields([subscription.relation.externalId, subscription.relation.firstName, subscription.relation.lastName, subscription.relation.companyName])}}</span></a></td><td>{{subscription.subscriptionType === null ? "" : \'SubscriptionType.\' + subscription.subscriptionType | translate}}</td><td id="subscription.descriptionId{{$index}}">{{subscription.description | visibleLimitTo:250 }}</td><td>{{subscription.status === null ? "" : \'SubscriptionStatus.\' + subscription.status | translate}}</td><td id="subscription.drivingGroupId{{$index}}">{{subscription.drivingGroup}}</td><td ng-hide="mappedBy == \'instructor\'"><a ui-sref="instructor.detail({instructorId:subscription.instructor.id})"><span>{{$root.displayFields([subscription.instructor.description, subscription.instructor.relation.externalId, subscription.instructor.relation.firstName, subscription.instructor.relation.lastName, subscription.instructor.relation.companyName])}}</span></a></td><td ng-hide="mappedBy == \'trainingType\'"><a ui-sref="templateevent.detail({templateEventId:subscription.trainingType.id})"><span>{{subscription.trainingType.name}}</span></a></td><td id="subscription.instructionHoursId{{$index}}">{{subscription.instructionHours | number: 3}}</td><td id="subscription.drivingResultId{{$index}}">{{subscription.drivingResult | number: 3}}</td><td id="subscription.progressId{{$index}}">{{subscription.progress | number: 3}}</td><td id="subscription.instructionProgressId{{$index}}">{{subscription.instructionProgress | visibleLimitTo:250 }}</td><td id="subscription.instructionDirectionsId{{$index}}">{{subscription.instructionDirections | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Subscription{{$index}}" type="submit" ui-sref="subscription.detail({subscriptionId:subscription.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="deleteSubscription{{$index}}" type="submit" ng-click="singleDelete(subscription.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SubscriptionSearchTab.page" ng-change="search()"></ul></div></div></div></div>');
$templateCache.put('app/entities/subscription/subscriptions.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="subscription.overview.title">Subscriptions</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="subscription.overview.search.booking.label">booking</label><div class="col-md-6"><input type="text" id="field_booking" name="booking" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="SubscriptionSearchOverview.booking" ng-model-options="$root.modelOptions" uib-typeahead="booking as booking.displayValue for booking in autocompleteBookings($viewValue)" typeahead-loading="loadingBooking" typeahead-no-results="noResultsBooking" placeholder="{{\'subscription.overview.search.booking.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingBooking" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsBooking"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="subscription.overview.search.relation.label">relation</label><div class="col-md-6"><input type="text" id="field_relation" name="relation" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" ng-model="SubscriptionSearchOverview.relation" ng-model-options="$root.modelOptions" uib-typeahead="relation as relation.displayValue for relation in autocompleteRelations($viewValue)" typeahead-loading="loadingRelation" typeahead-no-results="noResultsRelation" placeholder="{{\'subscription.overview.search.relation.placeholder\'|translate}}" autocomplete="off"> <i ng-show="loadingRelation" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsRelation"><i class="glyphicon glyphicon-remove"></i>No Results Found</div></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="subscription.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isSubscriptionSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="subscription.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteSubscriptionConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="subscription.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="subscription.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Subscription</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteSubscription" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="subscription.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SubscriptionSearchOverview.predicate" ascending="SubscriptionSearchOverview.ascending" callback="search()"><th jh-sort-by="relation.externalId" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.relation.label">relation</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'relation.externalId\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="subscriptionType" class="sortable"><span translate="subscription.overview.results.header.subscriptionType.label">subscriptionType</span> <span class="glyphicon {{getSortIcon(\'subscriptionType\')}}"></span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="status" class="sortable"><span translate="subscription.overview.results.header.status.label">status</span> <span class="glyphicon {{getSortIcon(\'status\')}}"></span></th><th jh-sort-by="drivingGroup" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.drivingGroup.label">drivingGroup</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'drivingGroup\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructor.description" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructor.label">instructor</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructor.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="trainingType.name" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.trainingType.label">trainingType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'trainingType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionHours" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructionHours.label">instructionHours</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionHours\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="drivingResult" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.drivingResult.label">drivingResult</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'drivingResult\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="progress" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.progress.label">progress</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'progress\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionProgress" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructionProgress.label">instructionProgress</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionProgress\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionDirections" class="sortable"><span class="pull-left" translate="subscription.overview.results.header.instructionDirections.label">instructionDirections</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionDirections\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="subscription in subscriptionList"><td><a ui-sref="user-relation.detail({relationId:subscription.relation.id})"><span>{{$root.displayFields([subscription.relation.externalId, subscription.relation.firstName, subscription.relation.lastName, subscription.relation.companyName])}}</span></a></td><td>{{subscription.subscriptionType === null ? "" : \'SubscriptionType.\' + subscription.subscriptionType | translate}}</td><td id="subscription.descriptionId{{$index}}">{{subscription.description | visibleLimitTo:250 }}</td><td>{{subscription.status === null ? "" : \'SubscriptionStatus.\' + subscription.status | translate}}</td><td id="subscription.drivingGroupId{{$index}}">{{subscription.drivingGroup}}</td><td><a ui-sref="instructor.detail({instructorId:subscription.instructor.id})"><span>{{$root.displayFields([subscription.instructor.description, subscription.instructor.relation.externalId, subscription.instructor.relation.firstName, subscription.instructor.relation.lastName, subscription.instructor.relation.companyName])}}</span></a></td><td><a ui-sref="templateevent.detail({templateEventId:subscription.trainingType.id})"><span>{{subscription.trainingType.name}}</span></a></td><td id="subscription.instructionHoursId{{$index}}">{{subscription.instructionHours | number: 3}}</td><td id="subscription.drivingResultId{{$index}}">{{subscription.drivingResult | number: 3}}</td><td id="subscription.progressId{{$index}}">{{subscription.progress | number: 3}}</td><td id="subscription.instructionProgressId{{$index}}">{{subscription.instructionProgress | visibleLimitTo:250 }}</td><td id="subscription.instructionDirectionsId{{$index}}">{{subscription.instructionDirections | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Subscription{{$index}}" type="submit" ui-sref="subscription.detail({subscriptionId:subscription.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="deleteSubscription{{$index}}" type="submit" ng-click="singleDelete(subscription.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SubscriptionSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfiltertemplateevent/salesfiltertemplateevent-detail.html','<div has-any-authority=""><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="SalesFilterTemplateEventDetailTitle" translate="salesFilterTemplateEvent.detail.title">SalesFilterTemplateEvent</span> {{salesFilterTemplateEvent.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="salesFilterTemplateEvent.detail.creator.label">Creator:</span>&nbsp; <span>{{salesFilterTemplateEvent.creator}} {{salesFilterTemplateEvent.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="salesFilterTemplateEvent.updater">,&nbsp; <span translate="salesFilterTemplateEvent.detail.updater.label">Updater: </span>&nbsp; <span>{{salesFilterTemplateEvent.updater}} {{salesFilterTemplateEvent.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="salesfiltertemplateevent.detail.edit({salesFilterTemplateEventId:salesFilterTemplateEvent.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteSalesFilterTemplateEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(salesFilterTemplateEvent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="salesFilterTemplateEvent.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="salesFilterTemplateEvent.overview.results.buttons.delete.confirmation">Are you sure you want to delete this SalesFilterTemplateEvent?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="salesFilterTemplateEvent.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="salesFilterTemplateEvent.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfiltertemplateevent/salesfiltertemplateevent-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="salesFilterTemplateEvent.overview.title">SalesFilterTemplateEvents</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SalesFilterTemplateEventSearchOverview.predicate" ascending="SalesFilterTemplateEventSearchOverview.ascending" callback="search()"><th jh-sort-by="salesFilter.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterTemplateEvent.overview.results.header.salesFilter.label">salesFilter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesFilter.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="templateEvent.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterTemplateEvent.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th class="hidden-xs" translate="templateEvent.overview.results.header.description.label">description</th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td class="hidden-xs"><!-- column #0--><select id="salesFilter_select" class="form-control input-sm" ng-options="salesFilter as salesFilter.displayValue for salesFilter in salesFilterReferenceFilterList track by salesFilter.id" ng-model="SalesFilterTemplateEventSearchOverview.salesFilter" tabindex="0" ng-change="search()"><option value="" translate="salesFilterTemplateEvent.overview.search.salesFilter.defaultOption">All SalesFilters</option></select></td><td class="hidden-xs"><!-- column #1--><select id="templateEvent_select" class="form-control input-sm" ng-options="templateEvent as templateEvent.displayValue for templateEvent in templateEventReferenceFilterList track by templateEvent.id" ng-model="SalesFilterTemplateEventSearchOverview.templateEvent" tabindex="0" ng-change="search()"><option value="" translate="salesFilterTemplateEvent.overview.search.templateEvent.defaultOption">All TemplateEvents</option></select></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isSalesFilterTemplateEventSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="salesFilterTemplateEvent in salesFilterTemplateEventList"><td class="hidden-xs"><a ui-sref="user-salesfilter.detail({salesFilterId:salesFilterTemplateEvent.salesFilterPkId})"><span>{{salesFilterTemplateEvent.salesFilterDisplayValue}}</span></a></td><td class="hidden-xs"><span>{{salesFilterTemplateEvent.templateEventDisplayValue}}</span></td><td class="hidden-xs">{{salesFilterTemplateEvent.templateEvent.description}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="deleteSalesFilterTemplateEvent{{$index}}" type="submit" ng-click="singleDelete(salesFilterTemplateEvent.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SalesFilterTemplateEventSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/salesfiltertemplateevent/salesfiltertemplateevent-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-hide="mappedBy == \'salesFilter\'" jh-sort-by="salesFilter.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterTemplateEvent.overview.results.header.salesFilter.label">salesFilter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesFilter.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'templateEvent\'" jh-sort-by="templateEvent.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterTemplateEvent.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'templateEvent\'" class="hidden-xs" translate="templateEvent.overview.results.header.description.label">description</th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="salesFilterTemplateEvent in salesFilterTemplateEventList"><td class="hidden-xs" ng-hide="mappedBy == \'salesFilter\'"><a ui-sref="user-salesfilter.detail({salesFilterId:salesFilterTemplateEvent.salesFilterPkId})"><span>{{salesFilterTemplateEvent.salesFilterDisplayValue}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'templateEvent\'"><span>{{salesFilterTemplateEvent.templateEventDisplayValue}}</span></td><td class="hidden-xs" ng-hide="mappedBy == \'templateEvent\'">{{salesFilterTemplateEvent.templateEvent.description}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="deleteSalesFilterTemplateEvent{{$index}}" type="submit" ng-click="singleDelete(salesFilterTemplateEvent.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/salesfiltertemplateevent/salesfiltertemplateevent-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="salesFilterTemplateEvent in salesFilterTemplateEventList"><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilterTemplateEvent{{$index}}" type="submit" ui-sref="salesfiltertemplateevent.detail({salesFilterTemplateEventId:salesFilterTemplateEvent.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/salesfiltertemplateevent/salesfiltertemplateevents.html','<div id="content"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="salesFilterTemplateEvent.overview.title">SalesFilterTemplateEvents</h3></div><div class="panel-buttons"><button type="button" class="btn" id="toggle-search-button" ng-click="showSearchForm = !showSearchForm"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="SalesFilterTemplateEventSearchOverview.predicate" ascending="SalesFilterTemplateEventSearchOverview.ascending" callback="search()"><th jh-sort-by="salesFilter.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterTemplateEvent.overview.results.header.salesFilter.label">salesFilter</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'salesFilter.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="templateEvent.description" class="sortable hidden-xs"><span class="pull-left" translate="salesFilterTemplateEvent.overview.results.header.templateEvent.label">templateEvent</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'templateEvent.description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th class="hidden-xs" translate="templateEvent.overview.results.header.description.label">description</th><th class="hidden-xs" translate="templateEvent.overview.results.header.eventType.label">eventType</th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr><tr class="animate-show-tr animate-hide-tr" ng-show="showSearchForm" id="searchRecord"><td class="hidden-xs"><!-- column #0--><select id="salesFilter_select" class="form-control input-sm" ng-options="salesFilter as $root.displayFields([salesFilter.firstName, salesFilter.lastName]) for salesFilter in salesFilterReferenceFilterList track by salesFilter.id" ng-model="SalesFilterTemplateEventSearchOverview.salesFilter" tabindex="0" ng-change="search()"><option value="" translate="salesFilterTemplateEvent.overview.search.salesFilter.defaultOption">All SalesFilters</option></select></td><td class="hidden-xs"><!-- column #1--><select id="templateEvent_select" class="form-control input-sm" ng-options="templateEvent as templateEvent.name for templateEvent in templateEventReferenceFilterList track by templateEvent.id" ng-model="SalesFilterTemplateEventSearchOverview.templateEvent" tabindex="0" ng-change="search()"><option value="" translate="salesFilterTemplateEvent.overview.search.templateEvent.defaultOption">All TemplateEvents</option></select></td><td><span class="pull-right text-nowrap"><button type="reset" class="btn btn-sm" ng-click="reset()" ng-disabled="!isSalesFilterTemplateEventSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" class="btn btn-sm btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span></button></span></td></tr></thead><tbody><tr ng-repeat="salesFilterTemplateEvent in salesFilterTemplateEventList"><td class="hidden-xs"><a ui-sref="salesfilter.detail({salesFilterId:salesFilterTemplateEvent.salesFilter.id})"><span>{{$root.displayFields([salesFilterTemplateEvent.salesFilter.firstName, salesFilterTemplateEvent.salesFilter.lastName])}}</span></a></td><td class="hidden-xs"><a ui-sref="templateevent.detail({templateEventId:salesFilterTemplateEvent.templateEvent.id})"><span>{{salesFilterTemplateEvent.templateEvent.name}}</span></a></td><td class="hidden-xs">{{salesFilterTemplateEvent.templateEvent.description}}</td><td class="hidden-xs">{{salesFilterTemplateEvent.templateEvent.eventType.name}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_SalesFilterTemplateEvent{{$index}}" type="submit" ui-sref="salesfiltertemplateevent.detail({salesFilterTemplateEventId:salesFilterTemplateEvent.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="SalesFilterTemplateEventSearchOverview.page" ng-change="search()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/templateevent/templateevent-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="TemplateEventDetailTitle" translate="templateEvent.detail.title">TemplateEvent</span> {{templateEvent.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="templateEvent.detail.creator.label">Creator:</span>&nbsp; <span>{{templateEvent.creator}} {{templateEvent.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="templateEvent.updater">,&nbsp; <span translate="templateEvent.detail.updater.label">Updater: </span>&nbsp; <span>{{templateEvent.updater}} {{templateEvent.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="templateevent.detail.edit({templateEventId:templateEvent.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteTemplateEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(templateEvent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="templateEvent.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="templateEvent.overview.results.buttons.delete.confirmation">Are you sure you want to delete this TemplateEvent?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="templateEvent.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="templateEvent.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="templateEvent.detail.name.label">name</span></td><td><span class="form-control-static">{{templateEvent.name}}</span></td></tr><tr><td><span translate="templateEvent.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{templateEvent.description}}</span></td></tr><tr><td><span translate="templateEvent.detail.instructionRatio.label">instructionRatio</span></td><td><span class="form-control-static">{{templateEvent.instructionRatio | number: 1}}</span></td></tr><tr><td><span translate="templateEvent.detail.eventType.label">eventType</span></td><td><a ui-sref="eventtype.detail({eventTypeId:templateEvent.eventType.id})"><span>{{templateEvent.eventType.name}}</span></a></td></tr><tr><td><span translate="templateEvent.detail.defaultDriver.label">defaultDriver</span></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultDriver.id})"><span>{{$root.displayFields([templateEvent.defaultDriver.name, templateEvent.defaultDriver.price])}}</span></a></td></tr><tr><td><span translate="templateEvent.detail.defaultSecondDriver.label">defaultSecondDriver</span></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultSecondDriver.id})"><span>{{$root.displayFields([templateEvent.defaultSecondDriver.name, templateEvent.defaultSecondDriver.price])}}</span></a></td></tr><tr><td><span translate="templateEvent.detail.defaultSpectator.label">defaultSpectator</span></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultSpectator.id})"><span>{{$root.displayFields([templateEvent.defaultSpectator.name, templateEvent.defaultSpectator.price])}}</span></a></td></tr><tr><td><span translate="templateEvent.detail.defaultInsurance.label">defaultInsurance</span></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultInsurance.id})"><span>{{$root.displayFields([templateEvent.defaultInsurance.name, templateEvent.defaultInsurance.price])}}</span></a></td></tr><tr><td><span translate="templateEvent.detail.defaultHotel.label">defaultHotel</span></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultHotel.id})"><span>{{$root.displayFields([templateEvent.defaultHotel.name, templateEvent.defaultHotel.price])}}</span></a></td></tr><tr><td><span translate="templateEvent.detail.defaultFuel.label">defaultFuel</span></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultFuel.id})"><span>{{$root.displayFields([templateEvent.defaultFuel.name, templateEvent.defaultFuel.price])}}</span></a></td></tr><tr><td><span translate="templateEvent.detail.defaultInstruction.label">defaultInstruction</span></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultInstruction.id})"><span>{{$root.displayFields([templateEvent.defaultInstruction.name, templateEvent.defaultInstruction.price])}}</span></a></td></tr></tbody></table></div><div><uib-tabset active="$root.templateEventActiveTab"><uib-tab id="tab-events-overview-mapped-by-templateEvent" heading="{{\'templateEvent.detail.tab.event.by.templateEvent\' | translate}}" ng-if="$root.userHasAnyAuthority([\'ROLE_USER\'])"><events-overview-mapped-by-templateevent read-only="true" mapped-by-id="templateEventId" mapped-by="\'templateEvent\'" mapped-by-type="\'templateevent\'"></events-overview-mapped-by-templateevent></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/templateevent/templateevent-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="TemplateEventDialogTitleCreate" translate="templateEvent.dialog.title.create">Create a TemplateEvent</h4><h4 class="modal-title" ng-show="isEdit()" id="TemplateEventDialogTitleEdit" translate="templateEvent.dialog.title.edit" translate-value-id="{{templateEvent.id}}">Edit a TemplateEvent</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="templateEvent.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="templateEvent.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="templateEvent.name" required ng-maxlength="50" placeholder="{{\'templateEvent.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="templateEvent.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="templateEvent.description" required ng-maxlength="-1" placeholder="{{\'templateEvent.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.instructionRatio.$invalid, \'has-success\' : editForm.instructionRatio.$valid && editForm.instructionRatio.$dirty }"><label for="field_instructionRatio" id="label_instructionRatio" class="col-sm-2 control-label" translate="templateEvent.dialog.instructionRatio.label">InstructionRatio</label><div class="col-sm-9"><input type="number" step="0.01" class="form-control input-sm" name="instructionRatio" id="field_instructionRatio" ng-model="templateEvent.instructionRatio" ng-maxlength="-1" placeholder="{{\'templateEvent.dialog.instructionRatio.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.eventType.$invalid, \'has-success\' : editForm.eventType.$valid && editForm.eventType.$dirty }"><label for="field_eventType" class="col-sm-2 control-label" translate="templateEvent.dialog.eventType.label">eventType</label><div class="col-sm-9"><select ng-disabled="\'eventType\' == mappedBy" class="form-control input-sm" id="field_eventType" name="eventType" ng-model="templateEvent.eventType" required ng-options="eventType as eventType.name for eventType in eventTypeList track by eventType.id"><option value=""></option></select><div ng-show="editForm.eventType.$invalid"><p class="help-block" ng-show="editForm.eventType.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new eventtype" ng-disabled="\'eventType\' == mappedBy" ng-click="createEventType()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.defaultDriver.$invalid, \'has-success\' : editForm.defaultDriver.$valid && editForm.defaultDriver.$dirty }"><label for="field_defaultDriver" class="col-sm-2 control-label" translate="templateEvent.dialog.defaultDriver.label">defaultDriver</label><div class="col-sm-9"><select ng-disabled="\'defaultDriver\' == mappedBy" class="form-control input-sm" id="field_defaultDriver" name="defaultDriver" ng-model="templateEvent.defaultDriver" ng-options="defaultDriver as $root.displayFields([defaultDriver.name, defaultDriver.price]) for defaultDriver in defaultDriverList track by defaultDriver.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultdriver" ng-disabled="\'defaultDriver\' == mappedBy" ng-click="createDefaultDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.defaultSecondDriver.$invalid, \'has-success\' : editForm.defaultSecondDriver.$valid && editForm.defaultSecondDriver.$dirty }"><label for="field_defaultSecondDriver" class="col-sm-2 control-label" translate="templateEvent.dialog.defaultSecondDriver.label">defaultSecondDriver</label><div class="col-sm-9"><select ng-disabled="\'defaultSecondDriver\' == mappedBy" class="form-control input-sm" id="field_defaultSecondDriver" name="defaultSecondDriver" ng-model="templateEvent.defaultSecondDriver" ng-options="defaultSecondDriver as $root.displayFields([defaultSecondDriver.name, defaultSecondDriver.price]) for defaultSecondDriver in defaultSecondDriverList track by defaultSecondDriver.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultseconddriver" ng-disabled="\'defaultSecondDriver\' == mappedBy" ng-click="createDefaultSecondDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.defaultSpectator.$invalid, \'has-success\' : editForm.defaultSpectator.$valid && editForm.defaultSpectator.$dirty }"><label for="field_defaultSpectator" class="col-sm-2 control-label" translate="templateEvent.dialog.defaultSpectator.label">defaultSpectator</label><div class="col-sm-9"><select ng-disabled="\'defaultSpectator\' == mappedBy" class="form-control input-sm" id="field_defaultSpectator" name="defaultSpectator" ng-model="templateEvent.defaultSpectator" ng-options="defaultSpectator as $root.displayFields([defaultSpectator.name, defaultSpectator.price]) for defaultSpectator in defaultSpectatorList track by defaultSpectator.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultspectator" ng-disabled="\'defaultSpectator\' == mappedBy" ng-click="createDefaultSpectator()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.defaultInsurance.$invalid, \'has-success\' : editForm.defaultInsurance.$valid && editForm.defaultInsurance.$dirty }"><label for="field_defaultInsurance" class="col-sm-2 control-label" translate="templateEvent.dialog.defaultInsurance.label">defaultInsurance</label><div class="col-sm-9"><select ng-disabled="\'defaultInsurance\' == mappedBy" class="form-control input-sm" id="field_defaultInsurance" name="defaultInsurance" ng-model="templateEvent.defaultInsurance" ng-options="defaultInsurance as $root.displayFields([defaultInsurance.name, defaultInsurance.price]) for defaultInsurance in defaultInsuranceList track by defaultInsurance.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultinsurance" ng-disabled="\'defaultInsurance\' == mappedBy" ng-click="createDefaultInsurance()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.defaultHotel.$invalid, \'has-success\' : editForm.defaultHotel.$valid && editForm.defaultHotel.$dirty }"><label for="field_defaultHotel" class="col-sm-2 control-label" translate="templateEvent.dialog.defaultHotel.label">defaultHotel</label><div class="col-sm-9"><select ng-disabled="\'defaultHotel\' == mappedBy" class="form-control input-sm" id="field_defaultHotel" name="defaultHotel" ng-model="templateEvent.defaultHotel" ng-options="defaultHotel as $root.displayFields([defaultHotel.name, defaultHotel.price]) for defaultHotel in defaultHotelList track by defaultHotel.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaulthotel" ng-disabled="\'defaultHotel\' == mappedBy" ng-click="createDefaultHotel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.defaultFuel.$invalid, \'has-success\' : editForm.defaultFuel.$valid && editForm.defaultFuel.$dirty }"><label for="field_defaultFuel" class="col-sm-2 control-label" translate="templateEvent.dialog.defaultFuel.label">defaultFuel</label><div class="col-sm-9"><select ng-disabled="\'defaultFuel\' == mappedBy" class="form-control input-sm" id="field_defaultFuel" name="defaultFuel" ng-model="templateEvent.defaultFuel" ng-options="defaultFuel as $root.displayFields([defaultFuel.name, defaultFuel.price]) for defaultFuel in defaultFuelList track by defaultFuel.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultfuel" ng-disabled="\'defaultFuel\' == mappedBy" ng-click="createDefaultFuel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.defaultInstruction.$invalid, \'has-success\' : editForm.defaultInstruction.$valid && editForm.defaultInstruction.$dirty }"><label for="field_defaultInstruction" class="col-sm-2 control-label" translate="templateEvent.dialog.defaultInstruction.label">defaultInstruction</label><div class="col-sm-9"><select ng-disabled="\'defaultInstruction\' == mappedBy" class="form-control input-sm" id="field_defaultInstruction" name="defaultInstruction" ng-model="templateEvent.defaultInstruction" ng-options="defaultInstruction as $root.displayFields([defaultInstruction.name, defaultInstruction.price]) for defaultInstruction in defaultInstructionList track by defaultInstruction.id"><option value=""></option></select></div><div class="col-sm-1"><span class="pull-right"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultinstruction" ng-disabled="\'defaultInstruction\' == mappedBy" ng-click="createDefaultInstruction()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="templateEvent.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="templateEvent.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/templateevent/templateevent-edit-user.html','<!--// Created by html/angular/entity/dto-edit.ftl--><div has-any-authority="ROLE_USER, ROLE_ADMIN"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="!isEdit()" id="TemplateEventDialogTitleCreate" translate="templateEvent.dialog.title.create">Create a TemplateEvent</h3><h3 class="voffset" ng-show="isEdit()" id="TemplateEventDialogTitleEdit" translate="templateEvent.dialog.title.edit" translate-value-id="{{templateEvent.id}}">Edit a TemplateEvent</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="row voffset2"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.name.label" for="field_name">Name</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="templateEvent.name" required ng-maxlength="50" ng-minlength="2" autofocus placeholder="{{\'templateEvent.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div><!-- close column--></div><div class="row voffset2"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.description.label" for="field_description">Description</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="templateEvent.description" required placeholder="{{\'templateEvent.dialog.description.placeholder\'|translate}}">\r\n\t\t\t\t\t</textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.instructionRatio.label" for="field_instructionRatio">InstructionRatio</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" step="0.1" class="form-control input-sm" name="instructionRatio" id="field_instructionRatio" ng-model="templateEvent.instructionRatio" placeholder="{{\'templateEvent.dialog.instructionRatio.placeholder\'|translate}}"></div><!-- close column--></div><div class="row voffset2"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.eventType.label" for="field_eventType">EventType</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><select ng-disabled="\'eventType\' == mappedBy" class="form-control input-sm" id="field_eventType" name="eventType" ng-model="templateEvent.selectedEventType" required ng-options="eventType as eventType.displayValue for eventType in templateEvent.eventTypeList track by eventType.id"><option value=""></option></select><p class="help-block" ng-show="editForm.eventType.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row voffset2"><!--row #5--></div><div class="row voffset2"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultDriver.label" for="field_defaultDriver">DefaultDriver</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultDriver\' == mappedBy" class="form-control input-sm" id="field_defaultDriver" name="defaultDriver" ng-model="templateEvent.selectedDefaultDriver" ng-options="defaultDriver as defaultDriver.displayValue for defaultDriver in templateEvent.defaultDriverList track by defaultDriver.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultdriver" ng-click="createDefaultDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultSecondDriver.label" for="field_defaultSecondDriver">DefaultSecondDriver</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultSecondDriver\' == mappedBy" class="form-control input-sm" id="field_defaultSecondDriver" name="defaultSecondDriver" ng-model="templateEvent.selectedDefaultSecondDriver" ng-options="defaultSecondDriver as defaultSecondDriver.displayValue for defaultSecondDriver in templateEvent.defaultSecondDriverList track by defaultSecondDriver.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultseconddriver" ng-click="createDefaultSecondDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultSpectator.label" for="field_defaultSpectator">DefaultSpectator</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultSpectator\' == mappedBy" class="form-control input-sm" id="field_defaultSpectator" name="defaultSpectator" ng-model="templateEvent.selectedDefaultSpectator" ng-options="defaultSpectator as defaultSpectator.displayValue for defaultSpectator in templateEvent.defaultSpectatorList track by defaultSpectator.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultspectator" ng-click="createDefaultSpectator()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #9--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultInsurance.label" for="field_defaultInsurance">DefaultInsurance</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultInsurance\' == mappedBy" class="form-control input-sm" id="field_defaultInsurance" name="defaultInsurance" ng-model="templateEvent.selectedDefaultInsurance" ng-options="defaultInsurance as defaultInsurance.displayValue for defaultInsurance in templateEvent.defaultInsuranceList track by defaultInsurance.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultinsurance" ng-click="createDefaultInsurance()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #10--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultHotel.label" for="field_defaultHotel">DefaultHotel</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultHotel\' == mappedBy" class="form-control input-sm" id="field_defaultHotel" name="defaultHotel" ng-model="templateEvent.selectedDefaultHotel" ng-options="defaultHotel as defaultHotel.displayValue for defaultHotel in templateEvent.defaultHotelList track by defaultHotel.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaulthotel" ng-click="createDefaultHotel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #11--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultFuel.label" for="field_defaultFuel">DefaultFuel</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultFuel\' == mappedBy" class="form-control input-sm" id="field_defaultFuel" name="defaultFuel" ng-model="templateEvent.selectedDefaultFuel" ng-options="defaultFuel as defaultFuel.displayValue for defaultFuel in templateEvent.defaultFuelList track by defaultFuel.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultfuel" ng-click="createDefaultFuel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row voffset2"><!--row #12--></div><div class="row voffset2"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultInstruction.label" for="field_defaultInstruction">DefaultInstruction</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultInstruction\' == mappedBy" class="form-control input-sm" id="field_defaultInstruction" name="defaultInstruction" ng-model="templateEvent.selectedDefaultInstruction" ng-options="defaultInstruction as defaultInstruction.displayValue for defaultInstruction in templateEvent.defaultInstructionList track by defaultInstruction.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultinstruction" ng-click="createDefaultInstruction()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><!-- END row in rows --><div class="row voffset2"><div class="col-xs-12"><span class="pull-right"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="templateEvent.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="templateEvent.dialog.update.button">Save</span></button></span></div></div></form></div></div>');
$templateCache.put('app/entities/templateevent/templateevent-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createTemplateEventButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="templateEvent.overview.button.new">Create a new TemplateEvent</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteTemplateEventConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="templateEvent.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="templateEvent.overview.results.buttons.delete.confirmation">Are you sure you want to delete this TemplateEvent</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="templateEvent.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteTemplateEvent" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="templateEvent.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionRatio" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.instructionRatio.label">instructionRatio</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionRatio\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'eventType\'" jh-sort-by="eventType.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.eventType.label">eventType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'eventType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'defaultDriver\'" jh-sort-by="defaultDriver.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultDriver.label">defaultDriver</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultDriver.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'defaultSecondDriver\'" jh-sort-by="defaultSecondDriver.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultSecondDriver.label">defaultSecondDriver</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultSecondDriver.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'defaultSpectator\'" jh-sort-by="defaultSpectator.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultSpectator.label">defaultSpectator</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultSpectator.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'defaultInsurance\'" jh-sort-by="defaultInsurance.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultInsurance.label">defaultInsurance</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultInsurance.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'defaultHotel\'" jh-sort-by="defaultHotel.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultHotel.label">defaultHotel</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultHotel.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'defaultFuel\'" jh-sort-by="defaultFuel.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultFuel.label">defaultFuel</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultFuel.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-hide="mappedBy == \'defaultInstruction\'" jh-sort-by="defaultInstruction.name" class="sortable hidden-xs"><span class="pull-left" translate="templateEvent.overview.results.header.defaultInstruction.label">defaultInstruction</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultInstruction.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="templateEvent in templateEventList"><td id="templateEvent.nameId{{$index}}">{{templateEvent.name}}</td><td id="templateEvent.descriptionId{{$index}}">{{templateEvent.description | visibleLimitTo:250 }}</td><td id="templateEvent.instructionRatioId{{$index}}">{{templateEvent.instructionRatio | number: 3}}</td><td ng-hide="mappedBy == \'eventType\'"><a ui-sref="eventtype.detail({eventTypeId:templateEvent.eventType.id})"><span>{{templateEvent.eventType.name}}</span></a></td><td ng-hide="mappedBy == \'defaultDriver\'"><a ui-sref="article.detail({articleId:templateEvent.defaultDriver.id})"><span>{{$root.displayFields([templateEvent.defaultDriver.name, templateEvent.defaultDriver.price])}}</span></a></td><td ng-hide="mappedBy == \'defaultSecondDriver\'"><a ui-sref="article.detail({articleId:templateEvent.defaultSecondDriver.id})"><span>{{$root.displayFields([templateEvent.defaultSecondDriver.name, templateEvent.defaultSecondDriver.price])}}</span></a></td><td ng-hide="mappedBy == \'defaultSpectator\'"><a ui-sref="article.detail({articleId:templateEvent.defaultSpectator.id})"><span>{{$root.displayFields([templateEvent.defaultSpectator.name, templateEvent.defaultSpectator.price])}}</span></a></td><td ng-hide="mappedBy == \'defaultInsurance\'"><a ui-sref="article.detail({articleId:templateEvent.defaultInsurance.id})"><span>{{$root.displayFields([templateEvent.defaultInsurance.name, templateEvent.defaultInsurance.price])}}</span></a></td><td ng-hide="mappedBy == \'defaultHotel\'"><a ui-sref="article.detail({articleId:templateEvent.defaultHotel.id})"><span>{{$root.displayFields([templateEvent.defaultHotel.name, templateEvent.defaultHotel.price])}}</span></a></td><td ng-hide="mappedBy == \'defaultFuel\'"><a ui-sref="article.detail({articleId:templateEvent.defaultFuel.id})"><span>{{$root.displayFields([templateEvent.defaultFuel.name, templateEvent.defaultFuel.price])}}</span></a></td><td class="hidden-xs" ng-hide="mappedBy == \'defaultInstruction\'"><a ui-sref="article.detail({articleId:templateEvent.defaultInstruction.id})"><span>{{$root.displayFields([templateEvent.defaultInstruction.name, templateEvent.defaultInstruction.price])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_TemplateEvent{{$index}}" type="submit" ui-sref="templateevent.detail({templateEventId:templateEvent.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_TemplateEvent{{$index}}" type="submit" ng-click="goToEditState(templateEvent)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteTemplateEvent{{$index}}" type="submit" ng-click="singleDelete(templateEvent.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/templateevent/templateevent-user.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="TemplateEventDialogTitleCreate" translate="templateEvent.dialog.title.create">Create a TemplateEvent</h4><h4 class="modal-title" ng-show="isEdit()" id="TemplateEventDialogTitleEdit" translate="templateEvent.dialog.title.edit" translate-value-id="{{templateEvent.id}}">Edit a TemplateEvent</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="row"><!--row #1--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.name.label" for="field_name">Name</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="templateEvent.name" required ng-maxlength="50" ng-minlength="2" autofocus placeholder="{{\'templateEvent.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div><!-- close column--></div><div class="row"><!--row #2--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.description.label" for="field_description">Description</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="templateEvent.description" ng-required="required" placeholder="{{\'templateEvent.dialog.description.placeholder\'|translate}}">\r\n\t\t\t\t</textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row"><!--row #3--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.instructionRatio.label" for="field_instructionRatio">InstructionRatio</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--> <input type="number" step="0.1" class="form-control input-sm" name="instructionRatio" id="field_instructionRatio" ng-model="templateEvent.instructionRatio" placeholder="{{\'templateEvent.dialog.instructionRatio.placeholder\'|translate}}"></div><!-- close column--></div><div class="row"><!--row #4--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.eventType.label" for="field_eventType">EventType</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'eventType\' == mappedBy" class="form-control input-sm" id="field_eventType" name="eventType" ng-model="templateEvent.eventType" required ng-options="eventType as eventType.name for eventType in eventTypeList track by eventType.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new eventtype" ng-click="createEventType()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div><p class="help-block" ng-show="editForm.eventType.$error.required" translate="entity.validation.required">This field is required</p></div><!-- close column--></div><div class="row"><!--row #5--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.event.label" for="field_event">Event</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><ui-select multiple="multiple" ng-model="templateEvent.selectedEventList" id="field_event" ng-disabled="disabled" title="Choose a event"><ui-select-match placeholder="{{ \'templateEvent.dialog.event.placeholder\' | translate}}">{{$item.displayValue}}</ui-select-match><ui-select-choices repeat="event in templateEvent.eventList | propsFilter: {displayValue: $select.search}"><small>{{event.displayValue}}</small></ui-select-choices></ui-select></div><!-- close column--></div><div class="row"><!--row #6--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultDriver.label" for="field_defaultDriver">DefaultDriver</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultDriver\' == mappedBy" class="form-control input-sm" id="field_defaultDriver" name="defaultDriver" ng-model="templateEvent.defaultDriver" ng-options="defaultDriver as $root.displayFields([defaultDriver.name, defaultDriver.price]) for defaultDriver in defaultDriverList track by defaultDriver.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultdriver" ng-click="createDefaultDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row"><!--row #7--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultSecondDriver.label" for="field_defaultSecondDriver">DefaultSecondDriver</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultSecondDriver\' == mappedBy" class="form-control input-sm" id="field_defaultSecondDriver" name="defaultSecondDriver" ng-model="templateEvent.defaultSecondDriver" ng-options="defaultSecondDriver as $root.displayFields([defaultSecondDriver.name, defaultSecondDriver.price]) for defaultSecondDriver in defaultSecondDriverList track by defaultSecondDriver.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultseconddriver" ng-click="createDefaultSecondDriver()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row"><!--row #8--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultSpectator.label" for="field_defaultSpectator">DefaultSpectator</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultSpectator\' == mappedBy" class="form-control input-sm" id="field_defaultSpectator" name="defaultSpectator" ng-model="templateEvent.defaultSpectator" ng-options="defaultSpectator as $root.displayFields([defaultSpectator.name, defaultSpectator.price]) for defaultSpectator in defaultSpectatorList track by defaultSpectator.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultspectator" ng-click="createDefaultSpectator()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row"><!--row #9--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultInsurance.label" for="field_defaultInsurance">DefaultInsurance</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultInsurance\' == mappedBy" class="form-control input-sm" id="field_defaultInsurance" name="defaultInsurance" ng-model="templateEvent.defaultInsurance" ng-options="defaultInsurance as $root.displayFields([defaultInsurance.name, defaultInsurance.price]) for defaultInsurance in defaultInsuranceList track by defaultInsurance.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultinsurance" ng-click="createDefaultInsurance()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row"><!--row #10--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultHotel.label" for="field_defaultHotel">DefaultHotel</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultHotel\' == mappedBy" class="form-control input-sm" id="field_defaultHotel" name="defaultHotel" ng-model="templateEvent.defaultHotel" ng-options="defaultHotel as $root.displayFields([defaultHotel.name, defaultHotel.price]) for defaultHotel in defaultHotelList track by defaultHotel.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaulthotel" ng-click="createDefaultHotel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row"><!--row #11--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultFuel.label" for="field_defaultFuel">DefaultFuel</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultFuel\' == mappedBy" class="form-control input-sm" id="field_defaultFuel" name="defaultFuel" ng-model="templateEvent.defaultFuel" ng-options="defaultFuel as $root.displayFields([defaultFuel.name, defaultFuel.price]) for defaultFuel in defaultFuelList track by defaultFuel.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultfuel" ng-click="createDefaultFuel()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><div class="row"><!--row #12--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.salesFilterTemplateEvent.label" for="field_salesFilterTemplateEvent">SalesFilterTemplateEvent</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><select ng-options="item as item.personName for item in salesFilterPickListOptions" multiple="multiple" name="salesFilterTemplateEvent" id="field_salesFilterTemplateEvent" ng-model="selectedSalesFilterList" bs-duallistbox filter="false" move-on-select="false" info-all="{0} items"></select></div><!-- close column--></div><div class="row"><!--row #13--><div class="col-xs-12 col-sm-6"><!--column #1--><label class="control-label" translate="templateEvent.dialog.defaultInstruction.label" for="field_defaultInstruction">DefaultInstruction</label></div><!-- close column--><div class="col-xs-12 col-sm-6"><!--column #2--><div class="input-group input-group-sm"><select ng-disabled="\'defaultInstruction\' == mappedBy" class="form-control input-sm" id="field_defaultInstruction" name="defaultInstruction" ng-model="templateEvent.defaultInstruction" ng-options="defaultInstruction as $root.displayFields([defaultInstruction.name, defaultInstruction.price]) for defaultInstruction in defaultInstructionList track by defaultInstruction.id"><option value=""></option></select><div class="input-group-btn"><button class="btn btn-sm" type="button" tooltip-placement="bottom" uib-tooltip="Create a new defaultinstruction" ng-click="createDefaultInstruction()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button></div></div></div><!-- close column--></div><!-- END row in rows --></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span> &nbsp; <span translate="templateEvent.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> &nbsp; <span translate="templateEvent.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/templateevent/templateevents.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="templateEvent.overview.title">TemplateEvents</h3></div><div class="panel-buttons"><button id="createTemplateEventButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="templateEvent.overview.button.new">Create a new TemplateEvent</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><form name="searchForm" class="form-horizontal voffset3" novalidate id="searchForm"><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="templateEvent.overview.search.name.label">name</label><div class="col-md-6"><input aria-invalid="false" aria-required="false" tabindex="0" class="input-sm form-control ng-pristine ng-untouched ng-valid ng-valid-required" placeholder="{{\'templateEvent.overview.search.name.placeholder\' | translate}}" name="name" ng-model="TemplateEventSearchOverview.name" type="String" ng-change="search()" ng-model-options="{ debounce: 500 }"></div></div><div class="form-group form-group-sm"><label class="col-md-2 col-md-offset-2 control-label" translate="templateEvent.overview.search.eventType.label">eventType</label><div class="col-md-6"><select id="eventType_select" class="form-control input-sm" ng-options="eventType as eventType.name for eventType in eventTypeReferenceFilterList track by eventType.id" ng-model="TemplateEventSearchOverview.eventType" tabindex="0" ng-change="search()"><option value="" translate="templateEvent.overview.search.eventType.defaultOption">All EventTypes</option></select></div></div><div class="form-group form-group-sm"><div class="col-md-offset-4 col-md-6 no-padding-right"><button type="submit" class="btn btn-primary" ng-click="search()"><span id="search-button" class="glyphicon glyphicon-search"></span>&nbsp;<span translate="templateEvent.overview.search.button">Search</span></button> <button type="reset" class="btn" ng-click="reset()" ng-disabled="!isTemplateEventSearchOverviewDirty()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="templateEvent.overview.search.reset.button">Reset</span></button></div></div></form><div class="modal fade" id="deleteTemplateEventConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="templateEvent.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="templateEvent.overview.results.buttons.delete.confirmation">Are you sure you want to delete this TemplateEvent</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="templateEvent.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteTemplateEvent" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="templateEvent.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="TemplateEventSearchOverview.predicate" ascending="TemplateEventSearchOverview.ascending" callback="search()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="instructionRatio" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.instructionRatio.label">instructionRatio</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'instructionRatio\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="eventType.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.eventType.label">eventType</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'eventType.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="defaultDriver.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultDriver.label">defaultDriver</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultDriver.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="defaultSecondDriver.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultSecondDriver.label">defaultSecondDriver</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultSecondDriver.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="defaultSpectator.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultSpectator.label">defaultSpectator</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultSpectator.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="defaultInsurance.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultInsurance.label">defaultInsurance</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultInsurance.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="defaultHotel.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultHotel.label">defaultHotel</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultHotel.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="defaultFuel.name" class="sortable"><span class="pull-left" translate="templateEvent.overview.results.header.defaultFuel.label">defaultFuel</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultFuel.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="defaultInstruction.name" class="sortable hidden-xs"><span class="pull-left" translate="templateEvent.overview.results.header.defaultInstruction.label">defaultInstruction</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'defaultInstruction.name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="templateEvent in templateEventList"><td id="templateEvent.nameId{{$index}}">{{templateEvent.name}}</td><td id="templateEvent.descriptionId{{$index}}">{{templateEvent.description | visibleLimitTo:250 }}</td><td id="templateEvent.instructionRatioId{{$index}}">{{templateEvent.instructionRatio | number: 3}}</td><td><a ui-sref="eventtype.detail({eventTypeId:templateEvent.eventType.id})"><span>{{templateEvent.eventType.name}}</span></a></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultDriver.id})"><span>{{$root.displayFields([templateEvent.defaultDriver.name, templateEvent.defaultDriver.price])}}</span></a></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultSecondDriver.id})"><span>{{$root.displayFields([templateEvent.defaultSecondDriver.name, templateEvent.defaultSecondDriver.price])}}</span></a></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultSpectator.id})"><span>{{$root.displayFields([templateEvent.defaultSpectator.name, templateEvent.defaultSpectator.price])}}</span></a></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultInsurance.id})"><span>{{$root.displayFields([templateEvent.defaultInsurance.name, templateEvent.defaultInsurance.price])}}</span></a></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultHotel.id})"><span>{{$root.displayFields([templateEvent.defaultHotel.name, templateEvent.defaultHotel.price])}}</span></a></td><td><a ui-sref="article.detail({articleId:templateEvent.defaultFuel.id})"><span>{{$root.displayFields([templateEvent.defaultFuel.name, templateEvent.defaultFuel.price])}}</span></a></td><td class="hidden-xs"><a ui-sref="article.detail({articleId:templateEvent.defaultInstruction.id})"><span>{{$root.displayFields([templateEvent.defaultInstruction.name, templateEvent.defaultInstruction.price])}}</span></a></td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_TemplateEvent{{$index}}" type="submit" ui-sref="templateevent.detail({templateEventId:templateEvent.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_TemplateEvent{{$index}}" type="submit" ng-click="goToEditState(templateEvent)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteTemplateEvent{{$index}}" type="submit" ng-click="singleDelete(templateEvent.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/vat/vat-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="VatDetailTitle" translate="vat.detail.title">Vat</span> {{vat.name}}</h3></div><div class="panel-buttons"><button ui-sref="vat.detail.edit({vatId:vat.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteVatConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(vat.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="vat.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="vat.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Vat?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="vat.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="vat.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="vat.detail.vatType.label">vatType</span></td><td><span class="form-control-static">{{vat.vatType === null ? "" : \'VatType.\' + vat.vatType | translate}}</span></td></tr><tr><td><span translate="vat.detail.percentage.label">percentage</span></td><td><span class="form-control-static">{{vat.percentage | number: 3}}</span></td></tr><tr><td><span translate="vat.detail.snelstartGeneralLedgerNumber.label">snelstartGeneralLedgerNumber</span></td><td><span class="form-control-static">{{vat.snelstartGeneralLedgerNumber}}</span></td></tr><tr><td><span translate="vat.detail.snelstartGeneralLedgerNumberUuid.label">snelstartGeneralLedgerNumberUuid</span></td><td><span class="form-control-static">{{vat.snelstartGeneralLedgerNumberUuid}}</span></td></tr><tr><td><span translate="vat.detail.snelstartArticleUuid.label">snelstartArticleUuid</span></td><td><span class="form-control-static">{{vat.snelstartArticleUuid}}</span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/vat/vat-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="VatDialogTitleCreate" translate="vat.dialog.title.create">Create a Vat</h4><h4 class="modal-title" ng-show="isEdit()" id="VatDialogTitleEdit" translate="vat.dialog.title.edit" translate-value-id="{{vat.id}}">Edit a Vat</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="vat.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.vatType.$invalid, \'has-success\' : editForm.vatType.$valid && editForm.vatType.$dirty }"><label for="field_vatType" class="col-sm-2 control-label" translate="vat.dialog.vatType.label">vatType</label><div class="col-sm-9"><select ng-disabled="\'vatType\' == mappedBy" class="form-control input-sm" id="field_vatType" name="vatType" ng-model="vat.vatType" required ng-options="\'VatType.\' + vatType | translate for vatType in vatTypeList"><option value=""></option></select><div ng-show="editForm.vatType.$invalid"><p class="help-block" ng-show="editForm.vatType.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.percentage.$invalid, \'has-success\' : editForm.percentage.$valid && editForm.percentage.$dirty }"><label for="field_percentage" id="label_percentage" class="col-sm-2 control-label" translate="vat.dialog.percentage.label">Percentage</label><div class="col-sm-9"><div class="input-group input-group-sm"><input type="number" step="0.01" class="form-control input-sm" name="percentage" id="field_percentage" ng-model="vat.percentage" ng-min="0" ng-max="100" required ng-maxlength="-1" placeholder="{{\'vat.dialog.percentage.placeholder\'|translate}}"> <span class="input-group-addon" translate="%">%</span></div><p class="help-block" ng-show="editForm.percentage.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.percentage.$error.max" translate="entity.validation.maxvalue" translate-value-maxvalue="100">Maximum value validation error</p><p class="help-block" ng-show="editForm.percentage.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="0">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.snelstartGeneralLedgerNumber.$invalid, \'has-success\' : editForm.snelstartGeneralLedgerNumber.$valid && editForm.snelstartGeneralLedgerNumber.$dirty }"><label for="field_snelstartGeneralLedgerNumber" id="label_snelstartGeneralLedgerNumber" class="col-sm-2 control-label" translate="vat.dialog.snelstartGeneralLedgerNumber.label">SnelstartGeneralLedgerNumber</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="snelstartGeneralLedgerNumber" id="field_snelstartGeneralLedgerNumber" ng-model="vat.snelstartGeneralLedgerNumber" required ng-maxlength="-1" placeholder="{{\'vat.dialog.snelstartGeneralLedgerNumber.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.snelstartGeneralLedgerNumber.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.snelstartGeneralLedgerNumberUuid.$invalid, \'has-success\' : editForm.snelstartGeneralLedgerNumberUuid.$valid && editForm.snelstartGeneralLedgerNumberUuid.$dirty }"><label for="field_snelstartGeneralLedgerNumberUuid" id="label_snelstartGeneralLedgerNumberUuid" class="col-sm-2 control-label" translate="vat.dialog.snelstartGeneralLedgerNumberUuid.label">SnelstartGeneralLedgerNumberUuid</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="snelstartGeneralLedgerNumberUuid" id="field_snelstartGeneralLedgerNumberUuid" ng-model="vat.snelstartGeneralLedgerNumberUuid" ng-maxlength="-1" placeholder="{{\'vat.dialog.snelstartGeneralLedgerNumberUuid.placeholder\'|translate}}"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.snelstartArticleUuid.$invalid, \'has-success\' : editForm.snelstartArticleUuid.$valid && editForm.snelstartArticleUuid.$dirty }"><label for="field_snelstartArticleUuid" id="label_snelstartArticleUuid" class="col-sm-2 control-label" translate="vat.dialog.snelstartArticleUuid.label">SnelstartArticleUuid</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="snelstartArticleUuid" id="field_snelstartArticleUuid" ng-model="vat.snelstartArticleUuid" ng-maxlength="-1" placeholder="{{\'vat.dialog.snelstartArticleUuid.placeholder\'|translate}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="vat.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="vat.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/vat/vat-list-user.html','<div id="content" has-any-authority="ROLE_USER, ROLE_ADMIN"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="vat.overview.title">Vats</h3></div><div class="panel-buttons"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="vatType" class="sortable hidden-xs"><span class="pull-left" translate="vat.overview.results.header.vatType.label">vatType</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'vatType\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="percentage" class="sortable hidden-xs"><span class="pull-left" translate="vat.overview.results.header.percentage.label">percentage</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'percentage\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartGeneralLedgerNumber" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumber.label">snelstartGeneralLedgerNumber</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumber\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartGeneralLedgerNumberUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumberUuid.label">snelstartGeneralLedgerNumberUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumberUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartArticleUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartArticleUuid.label">snelstartArticleUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartArticleUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="vat in vatList"><td class="hidden-xs">{{vat.vatTypeDisplayValue === null ? "" : vat.vatTypeDisplayValue | translate}}</td><td class="hidden-xs" id="vat.percentageId{{$index}}">{{vat.percentage | number: 3}} <span ng-show="isDefinedAndNotNull(vat.percentage)" translate="%">%</span></td><td id="vat.snelstartGeneralLedgerNumberId{{$index}}">{{vat.snelstartGeneralLedgerNumber}}</td><td id="vat.snelstartGeneralLedgerNumberUuidId{{$index}}">{{vat.snelstartGeneralLedgerNumberUuid}}</td><td id="vat.snelstartArticleUuidId{{$index}}">{{vat.snelstartArticleUuid}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/vat/vat-list-user.tab.html','<div id="contentTab" class="voffset2"><!-- Created by html/angular/entity/dto-list.ftl--><div class="panel-heading"><div class="panel-title"></div><div class="panel-buttons"></div></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="vatType" class="sortable hidden-xs"><span class="pull-left" translate="vat.overview.results.header.vatType.label">vatType</span> <span class="pull-right"><span class="glyphicon {{getSortIcon(\'vatType\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="percentage" class="sortable hidden-xs"><span class="pull-left" translate="vat.overview.results.header.percentage.label">percentage</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'percentage\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartGeneralLedgerNumber" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumber.label">snelstartGeneralLedgerNumber</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumber\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartGeneralLedgerNumberUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumberUuid.label">snelstartGeneralLedgerNumberUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumberUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartArticleUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartArticleUuid.label">snelstartArticleUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartArticleUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="vat in vatList"><td class="hidden-xs">{{vat.vatTypeDisplayValue === null ? "" : vat.vatTypeDisplayValue | translate}}</td><td class="hidden-xs" id="vat.percentageId{{$index}}">{{vat.percentage | number: 3}} <span ng-show="isDefinedAndNotNull(vat.percentage)" translate="%">%</span></td><td id="vat.snelstartGeneralLedgerNumberId{{$index}}">{{vat.snelstartGeneralLedgerNumber}}</td><td id="vat.snelstartGeneralLedgerNumberUuidId{{$index}}">{{vat.snelstartGeneralLedgerNumberUuid}}</td><td id="vat.snelstartArticleUuidId{{$index}}">{{vat.snelstartArticleUuid}}</td><!-- A custom hook can be implemented here custom/html/angular/entity/dto-list/action_column_body.ftl --><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 col-md-offset-3 col-md-6 text-center"><ul ng-if="totalCountIsKnownAtTheMoment" uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="paging.page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/vat/vat-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createVatButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="vat.overview.button.new">Create a new Vat</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteVatConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="vat.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="vat.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Vat</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="vat.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteVat" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="vat.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="snelstartGeneralLedgerNumber" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumber.label">snelstartGeneralLedgerNumber</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumber\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartGeneralLedgerNumberUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumberUuid.label">snelstartGeneralLedgerNumberUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumberUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartArticleUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartArticleUuid.label">snelstartArticleUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartArticleUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="vat in vatList"><td id="vat.snelstartGeneralLedgerNumberId{{$index}}">{{vat.snelstartGeneralLedgerNumber}}</td><td id="vat.snelstartGeneralLedgerNumberUuidId{{$index}}">{{vat.snelstartGeneralLedgerNumberUuid}}</td><td id="vat.snelstartArticleUuidId{{$index}}">{{vat.snelstartArticleUuid}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Vat{{$index}}" type="submit" ui-sref="vat.detail({vatId:vat.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Vat{{$index}}" type="submit" ng-click="goToEditState(vat)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteVat{{$index}}" type="submit" ng-click="singleDelete(vat.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div></div></div>');
$templateCache.put('app/entities/vat/vats.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="vat.overview.title">Vats</h3></div><div class="panel-buttons"><button id="createVatButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="vat.overview.button.new">Create a new Vat</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteVatConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="vat.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="vat.overview.results.buttons.delete.confirmation">Are you sure you want to delete this Vat</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="vat.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteVat" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="vat.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="vatType" class="sortable hidden-xs"><span translate="vat.overview.results.header.vatType.label">vatType</span> <span class="glyphicon {{getSortIcon(\'vatType\')}}"></span></th><th jh-sort-by="percentage" class="sortable hidden-xs"><span class="pull-left" translate="vat.overview.results.header.percentage.label">percentage</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'percentage\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartGeneralLedgerNumber" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumber.label">snelstartGeneralLedgerNumber</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumber\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartGeneralLedgerNumberUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartGeneralLedgerNumberUuid.label">snelstartGeneralLedgerNumberUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartGeneralLedgerNumberUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="snelstartArticleUuid" class="sortable"><span class="pull-left" translate="vat.overview.results.header.snelstartArticleUuid.label">snelstartArticleUuid</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'snelstartArticleUuid\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="vat in vatList"><td class="hidden-xs">{{vat.vatType === null ? "" : \'VatType.\' + vat.vatType | translate}}</td><td class="hidden-xs" id="vat.percentageId{{$index}}">{{vat.percentage | number: 3}}</td><td id="vat.snelstartGeneralLedgerNumberId{{$index}}">{{vat.snelstartGeneralLedgerNumber}}</td><td id="vat.snelstartGeneralLedgerNumberUuidId{{$index}}">{{vat.snelstartGeneralLedgerNumberUuid}}</td><td id="vat.snelstartArticleUuidId{{$index}}">{{vat.snelstartArticleUuid}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_Vat{{$index}}" type="submit" ui-sref="vat.detail({vatId:vat.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_Vat{{$index}}" type="submit" ng-click="goToEditState(vat)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteVat{{$index}}" type="submit" ng-click="singleDelete(vat.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6 text-center"><ul uib-pagination class="pagination-sm" total-items="totalItems" items-per-page="pageSize" ng-model="page" ng-change="loadAll()"></ul></div></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/usertype/usertype-detail.html','<div has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset"><span id="UserTypeDetailTitle" translate="userType.detail.title">UserType</span> {{userType.name}}</h3><p class="small text-lowercase panel-sub-title"><span><span translate="userType.detail.creator.label">Creator:</span>&nbsp; <span>{{userType.creator}} {{userType.createdOn | nullableDateTimeNoZone}}</span> </span><span ng-if="userType.updater">,&nbsp; <span translate="userType.detail.updater.label">Updater: </span>&nbsp; <span>{{userType.updater}} {{userType.updatedOn | nullableDateTimeNoZone}}</span></span></p></div><div class="panel-buttons"><button ui-sref="usertype.detail.edit({userTypeId:userType.id, mappedBy:mappedBy, mappedById:mappedById})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteUserTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(userType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="userType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="userType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this UserType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="userType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDelete" type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="userType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table"><tbody><tr><td><span translate="userType.detail.name.label">name</span></td><td><span class="form-control-static">{{userType.name}}</span></td></tr><tr><td><span translate="userType.detail.description.label">description</span></td><td><span class="form-control-static white-space-pre">{{userType.description}}</span></td></tr><tr><td><span translate="userType.detail.predefinedUserType.label">predefinedUserType</span></td><td><span class="form-control-static">{{userType.predefinedUserType === null ? "" : \'PredefinedUserType.\' + userType.predefinedUserType | translate}}</span></td></tr></tbody></table></div><div><uib-tabset active="$root.userTypeActiveTab"><uib-tab id="tab-users-overview-mapped-by-userType" heading="{{\'userType.detail.tab.user.by.userType\' | translate}}" ng-if="$root.userHasAnyAuthority([])"><users-overview-mapped-by-usertype read-only="true" mapped-by-id="userTypeId" mapped-by="\'userType\'" mapped-by-type="\'usertype\'"></users-overview-mapped-by-usertype></uib-tab></uib-tabset></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/entities/usertype/usertype-dialog.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" ng-show="!isEdit()" id="UserTypeDialogTitleCreate" translate="userType.dialog.title.create">Create a UserType</h4><h4 class="modal-title" ng-show="isEdit()" id="UserTypeDialogTitleEdit" translate="userType.dialog.title.edit" translate-value-id="{{userType.id}}">Edit a UserType</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group form-group-sm" style="margin-top: 30px"><label for="id" class="col-sm-2 control-label">ID</label><div class="col-sm-9"><input type="text" class="form-control input-sm" id="id" name="id" ng-model="userType.id" readonly="readonly"></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.name.$invalid, \'has-success\' : editForm.name.$valid && editForm.name.$dirty }"><label for="field_name" id="label_name" class="col-sm-2 control-label" translate="userType.dialog.name.label">Name</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="userType.name" required ng-maxlength="50" placeholder="{{\'userType.dialog.name.placeholder\'|translate}}"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-maxlength="50">Maxlength validation error</p><p class="help-block" ng-show="editForm.name.$error.min" translate="entity.validation.minvalue" translate-value-minvalue="2">Minimal value validation error</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.description.$invalid, \'has-success\' : editForm.description.$valid && editForm.description.$dirty }"><label for="field_description" id="label_description" class="col-sm-2 control-label" translate="userType.dialog.description.label">Description</label><div class="col-sm-9"><textarea rows="3" class="form-control input-sm" name="description" id="field_description" ng-model="userType.description" required ng-maxlength="-1" placeholder="{{\'userType.dialog.description.placeholder\'|translate}}"></textarea><p class="help-block" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required</p></div></div><div class="form-group form-group-sm" ng-class="{ \'has-error\': editForm.predefinedUserType.$invalid, \'has-success\' : editForm.predefinedUserType.$valid && editForm.predefinedUserType.$dirty }"><label for="field_predefinedUserType" class="col-sm-2 control-label" translate="userType.dialog.predefinedUserType.label">predefinedUserType</label><div class="col-sm-9"><select ng-disabled="\'predefinedUserType\' == mappedBy" class="form-control input-sm" id="field_predefinedUserType" name="predefinedUserType" ng-model="userType.predefinedUserType" ng-options="\'PredefinedUserType.\' + predefinedUserType | translate for predefinedUserType in predefinedUserTypeList"><option value=""></option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="userType.dialog.cancel.button">Cancel</span></button> <button id="saveButton" type="submit" ng-disabled="editForm.$invalid || !submitButtonIsActive" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="userType.dialog.update.button">Save</span></button></div></form>');
$templateCache.put('app/entities/usertype/usertype-tab.html','<div id="contentTab" class="voffset2"><div class="panel-heading"><div class="panel-buttons"><button id="createUserTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="userType.overview.button.new">Create a new UserType</span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteUserTypeConfirmationInTab"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="userType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="userType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this UserType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="userType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteUserType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="userType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="userType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="userType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="userType in userTypeList"><td id="userType.nameId{{$index}}">{{userType.name}}</td><td id="userType.descriptionId{{$index}}">{{userType.description | visibleLimitTo:250 }}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_UserType{{$index}}" type="submit" ui-sref="usertype.detail({userTypeId:userType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_UserType{{$index}}" type="submit" ng-click="goToEditState(userType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteUserType{{$index}}" type="submit" ng-click="singleDelete(userType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/usertype/usertypes.html','<div id="content" has-any-authority="ROLE_USER"><div class="panel-heading"><div class="panel-title"><h3 class="voffset" ng-show="{{!readOnly}}" translate="userType.overview.title">UserTypes</h3></div><div class="panel-buttons"><button id="createUserTypeButton" class="btn btn-primary" ng-click="goToNewState()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> <span class="hidden-xs" translate="userType.overview.button.new">Create a new UserType</span></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div><jhi-alert></jhi-alert><div class="panel-body"><div class="modal fade" id="deleteUserTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteSingleForm" ng-submit="confirmSingleDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="userType.overview.results.buttons.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="userType.overview.results.buttons.delete.confirmation">Are you sure you want to delete this UserType</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="userType.overview.results.buttons.cancel">Cancel</span></button> <button id="confirmDeleteUserType" type="submit" ng-disabled="deleteSingleForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="userType.overview.results.buttons.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive voffset1"><table class="table table-condensed table-striped table-bordered"><thead><tr jh-sort="predicate" ascending="ascending" callback="loadAll()"><th jh-sort-by="name" class="sortable"><span class="pull-left" translate="userType.overview.results.header.name.label">name</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'name\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="description" class="sortable"><span class="pull-left" translate="userType.overview.results.header.description.label">description</span><span class="pull-right"><span class="glyphicon {{getSortIcon(\'description\')}}" aria-hidden="true"></span>&nbsp;</span></th><th jh-sort-by="predefinedUserType" class="sortable"><span translate="userType.overview.results.header.predefinedUserType.label">predefinedUserType</span> <span class="glyphicon {{getSortIcon(\'predefinedUserType\')}}"></span></th><th ng-show="{{!readOnly}}" class="actionButtons"></th></tr></thead><tbody><tr ng-repeat="userType in userTypeList"><td id="userType.nameId{{$index}}">{{userType.name}}</td><td id="userType.descriptionId{{$index}}">{{userType.description | visibleLimitTo:250 }}</td><td>{{userType.predefinedUserType === null ? "" : \'PredefinedUserType.\' + userType.predefinedUserType | translate}}</td><td id="crudButtons" ng-show="{{!readOnly}}" class="actionButtons"><span class="pull-right oneline"><button id="btn_detail_UserType{{$index}}" type="submit" ui-sref="usertype.detail({userTypeId:userType.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button id="btn_edit_UserType{{$index}}" type="submit" ng-click="goToEditState(userType)" class="btn btn-success btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button id="deleteUserType{{$index}}" type="submit" ng-click="singleDelete(userType.id)" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></span></td></tr></tbody></table></div><div class="row"><div class="col-xs-12 text-right"><button type="button" ng-click="scrollTo(\'content\')" class="btn"><span class="glyphicon glyphicon-triangle-top" aria-hidden="true"></button> <button type="button" ng-click="back()" class="btn"><span class="glyphicon glyphicon-triangle-left" aria-hidden="true"></span> <span class="hidden-xs" translate="entity.action.back"></span></button></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default navbar-fixed-top" role="navigation"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" href="#/" ng-click="vm.collapseNavbar()"><span>GP-Elite EMS version</span> <span class="navbar-version">{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span translate="global.navbar.category.home.title">Home</span></a></li><li ui-sref-active="active" ng-switch-when="true" class="dropdown pointer"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-tablet" translate="global.navbar.category.sales.title">Sales</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="event.dashboard"><span translate="global.navbar.category.sales.item.dashboard">events dashboard</span></a></li><li ui-sref-active="active"><a ui-sref="sales.relation"><span translate="global.navbar.category.sales.item.relation.dashboard">relation sales dashboard</span></a></li></ul></li><li ui-sref-active="active" ng-switch-when="true" class="dropdown pointer"><a ui-sref="user-event.list"><span class="hidden-tablet" translate="global.navbar.category.event.item.event">Events</span></a></li><li ui-sref-active="active" ng-switch-when="true" class="dropdown pointer"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-tablet" translate="global.navbar.category.booking.title">Booking</span> <b class="caret"></b></span></a><ul class="dropdown-menu"><li ui-sref-active="active"><a ui-sref="booking.list"><span translate="global.navbar.category.booking.item.booking">Booking</span></a></li><li ui-sref-active="active"><a ui-sref="subscription.list" translate="global.navbar.category.booking.item.subscription"><span>Subscriptions</span></a></li></ul></li><!--li ui-sref-active="active" ng-switch-when="true" class="dropdown pointer">\r\n                    <a ui-sref="relation.list">\r\n                        <span class="hidden-tablet" translate="global.navbar.category.relation.title">Relations</span>\r\n                    </a>\r\n                </li--><li ui-sref-active="active" ng-switch-when="true" class="dropdown pointer"><a ui-sref="user-relation.list"><span class="hidden-tablet" translate="global.navbar.category.relation.title">Relations</span></a></li><li ui-sref-active="active" ng-switch-when="true" class="dropdown pointer"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-tablet" translate="global.navbar.category.crm.title">CRM</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="mailgroup.list"><span translate="global.navbar.category.crm.item.mailgroup">Mailgroups</span></a></li><li ui-sref-active="active"><a ui-sref="document.list"><span translate="global.navbar.category.event.item.document">Documents</span></a></li><li ui-sref-active="active"><a ui-sref="eventrelationcontact.list"><span translate="global.navbar.category.crm.item.eventrelationcontact">eventrelationcontact</span></a></li></ul></li><li ui-sref-active="active" ng-switch-when="true" class="dropdown pointer"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-tablet" translate="global.navbar.category.event.title">Event settings</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="eventtype.list" translate="global.navbar.category.event.item.eventtype"><span>Event categories</span></a></li><li ui-sref-active="active"><a ui-sref="templateevent.list" translate="global.navbar.category.event.item.templateevent"><span>Event sub categories</span></a></li><li ui-sref-active="active"><a ui-sref="instructor.list" translate="global.navbar.category.event.item.instructor"><span>Instructors</span></a></li><li role="separator" class="divider"></li><li ui-sref-active="active"><a ui-sref="articletype.list"><span translate="global.navbar.category.event.item.articletype">Article categories</span></a></li><!--                        <li ui-sref-active="active">--><!--                            <a ui-sref="article.list"><span translate="global.navbar.category.event.item.article">Article products</span></a>--><!--                        </li>--><li ui-sref-active="active"><a ui-sref="user-article.list"><span translate="global.navbar.category.event.item.article">Article products</span></a></li><li ui-sref-active="active"><a ui-sref="locationtemplateeventarticle.list"><span translate="global.navbar.category.event.item.locationTemplateEventArticle">Location Subcategory Articles</span></a></li><li ui-sref-active="active"><a ui-sref="articlerelationprice.list"><span translate="global.navbar.category.event.item.articlerelationprice">Relation prices</span></a></li><li role="separator" class="divider"></li><li ui-sref-active="active"><a ui-sref="location.list"><span translate="global.navbar.category.event.item.location">Locations</span></a></li><li role="separator" class="divider"></li><li ui-sref-active="active"><a ui-sref="vat.list"><span translate="global.navbar.category.event.item.vat">Vats</span></a></li><li role="separator" class="divider"></li><li ui-sref-active="active"><a ui-sref="car.list"><span translate="global.navbar.category.event.item.car">Cars</span></a></li><li ui-sref-active="active"><a ui-sref="carrentaltype.list"><span translate="global.navbar.category.event.item.carRentalType">Car rental types</span></a></li><li ui-sref-active="active"><a ui-sref="carrentaltypetemplateeventarticle.list"><span translate="global.navbar.category.event.item.carRentalTypeTemplateEventArticle">CarRentalType Subcategory Articles</span></a></li><li ui-sref-active="active"><a ui-sref="companytype.list"><span translate="global.navbar.category.event.item.companytype">Supplier type</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.navbar.category.account.title">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.navbar.category.account.item.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.navbar.category.account.item.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.navbar.category.account.item.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.navbar.category.account.item.authenticate">Sign in</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.navbar.category.administration.title">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.navbar.category.administration.item.usermanagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.navbar.category.administration.item.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.navbar.category.administration.item.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.navbar.category.administration.item.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.navbar.category.administration.item.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.navbar.category.administration.item.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.navbar.category.administration.item.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul><!--// end new menu--></div></div></nav>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="reset.finish.title">Reset password</h3></div></div><div class="panel-body"><div class="row"><div class="col-md-4 col-md-offset-4"><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="panel-heading"><div class="panel-title"><h3 class="voffset" data-translate="reset.request.title">Reset your password</h3></div></div><div class="panel-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div></div>');}]);})();